(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["TwitterNBAEmoji"] = factory();
	else
		root["TwitterNBAEmoji"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!*******************************!*\
  !*** ./assets/js/src/main.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(/*! react-dom */ 120);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _mobileDetect = __webpack_require__(/*! mobile-detect */ 172);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _EmojiIsLife = __webpack_require__(/*! ./components/EmojiIsLife.jsx */ 246);
	
	var _EmojiIsLife2 = _interopRequireDefault(_EmojiIsLife);
	
	var _system = __webpack_require__(/*! ./helpers/system */ 125);
	
	var _system2 = _interopRequireDefault(_system);
	
	var _data = __webpack_require__(/*! ./data/data */ 124);
	
	var _data2 = _interopRequireDefault(_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Calls a function when the DOM is ready
	 * @param {Function} callback - The function to call
	 * @returns {undefined} undefined
	 */
	function domReady(callback) {
	  var doc = document;
	  var attach = 'addEventListener';
	
	  if (doc[attach]) {
	    doc[attach]('DOMContentLoaded', callback);
	  } else {
	    window.attachEvent('onload', callback);
	  }
	}
	
	/**
	 * Loads the app
	 * @param {Function} callback - The function to call
	 * @returns {undefined} undefined
	 */
	domReady(function () {
	  var md = new _mobileDetect2.default(window.navigator.userAgent);
	  var htmlEl = document.getElementsByTagName('html')[0];
	  var touch = md.mobile() ? true : false;
	  var cssTransforms3d = htmlEl.className.indexOf('no-csstransforms3d') === -1;
	  var appContainer = document.getElementsByClassName('app-container')[0];
	  var iOSVersion = _system2.default.iOSVersion();
	  var androidVersion = _system2.default.androidVersion();
	  var isFirefox = _system2.default.isFirefox();
	  var isIEOrEdge = _system2.default.isIEOrEdge();
	
	  if (iOSVersion === 8 || iOSVersion === 9) {
	    var originalClass = htmlEl.className;
	    var newClass = originalClass + ' iOS-' + iOSVersion.toString();
	
	    htmlEl.className = newClass;
	  }
	
	  if (androidVersion) {
	    var _originalClass = htmlEl.className;
	    var _newClass = _originalClass + ' android android-v-' + androidVersion.toString();
	
	    htmlEl.className = _newClass;
	  }
	
	  if (isFirefox) {
	    var _originalClass2 = htmlEl.className;
	    var _newClass2 = _originalClass2 + ' firefox';
	
	    htmlEl.className = _newClass2;
	  }
	
	  if (isIEOrEdge) {
	    var _originalClass3 = htmlEl.className;
	    var _newClass3 = _originalClass3 + ' ie-edge';
	
	    htmlEl.className = _newClass3;
	  }
	
	  _reactDom2.default.render(_react2.default.createElement(_EmojiIsLife2.default, {
	    minDesktopWidth: 768,
	    cssTransforms3d: cssTransforms3d,
	    touch: touch,
	    data: _data2.default
	  }), appContainer);
	});
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "main.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 1 */
/*!*************************************!*\
  !*** ./~/pixi.js/src/core/index.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @file        Main export of the PIXI core library
	 * @author      Mat Groves <mat@goodboydigital.com>
	 * @copyright   2013-2015 GoodBoyDigital
	 * @license     {@link https://github.com/pixijs/pixi.js/blob/master/LICENSE|MIT License}
	 */
	
	/**
	 * @namespace PIXI
	 */
	// export core and const. We assign core to const so that the non-reference types in const remain in-tact
	var core = module.exports = Object.assign(__webpack_require__(/*! ./const */ 6), __webpack_require__(/*! ./math */ 9), {
	    // utils
	    utils: __webpack_require__(/*! ./utils */ 7),
	    ticker: __webpack_require__(/*! ./ticker */ 197),
	
	    // display
	    DisplayObject:          __webpack_require__(/*! ./display/DisplayObject */ 94),
	    Container:              __webpack_require__(/*! ./display/Container */ 36),
	
	    // sprites
	    Sprite:                 __webpack_require__(/*! ./sprites/Sprite */ 106),
	    ParticleContainer:      __webpack_require__(/*! ./particles/ParticleContainer */ 183),
	    SpriteRenderer:         __webpack_require__(/*! ./sprites/webgl/SpriteRenderer */ 194),
	    ParticleRenderer:       __webpack_require__(/*! ./particles/webgl/ParticleRenderer */ 185),
	
	    // text
	    Text:                   __webpack_require__(/*! ./text/Text */ 195),
	
	    // primitives
	    Graphics:               __webpack_require__(/*! ./graphics/Graphics */ 176),
	    GraphicsData:           __webpack_require__(/*! ./graphics/GraphicsData */ 95),
	    GraphicsRenderer:       __webpack_require__(/*! ./graphics/webgl/GraphicsRenderer */ 177),
	
	    // textures
	    Texture:                __webpack_require__(/*! ./textures/Texture */ 30),
	    BaseTexture:            __webpack_require__(/*! ./textures/BaseTexture */ 41),
	    RenderTexture:          __webpack_require__(/*! ./textures/RenderTexture */ 61),
	    VideoBaseTexture:       __webpack_require__(/*! ./textures/VideoBaseTexture */ 108),
	    TextureUvs:             __webpack_require__(/*! ./textures/TextureUvs */ 107),
	
	    // renderers - canvas
	    CanvasRenderer:         __webpack_require__(/*! ./renderers/canvas/CanvasRenderer */ 187),
	    CanvasGraphics:         __webpack_require__(/*! ./renderers/canvas/utils/CanvasGraphics */ 59),
	    CanvasBuffer:           __webpack_require__(/*! ./renderers/canvas/utils/CanvasBuffer */ 58),
	
	    // renderers - webgl
	    WebGLRenderer:          __webpack_require__(/*! ./renderers/webgl/WebGLRenderer */ 37),
	    WebGLManager:           __webpack_require__(/*! ./renderers/webgl/managers/WebGLManager */ 23),
	    ShaderManager:          __webpack_require__(/*! ./renderers/webgl/managers/ShaderManager */ 103),
	    Shader:                 __webpack_require__(/*! ./renderers/webgl/shaders/Shader */ 38),
	    TextureShader:          __webpack_require__(/*! ./renderers/webgl/shaders/TextureShader */ 39),
	    PrimitiveShader:        __webpack_require__(/*! ./renderers/webgl/shaders/PrimitiveShader */ 105),
	    ComplexPrimitiveShader: __webpack_require__(/*! ./renderers/webgl/shaders/ComplexPrimitiveShader */ 104),
	    ObjectRenderer:         __webpack_require__(/*! ./renderers/webgl/utils/ObjectRenderer */ 29),
	    RenderTarget:           __webpack_require__(/*! ./renderers/webgl/utils/RenderTarget */ 40),
	
	    // filters - webgl
	    AbstractFilter:         __webpack_require__(/*! ./renderers/webgl/filters/AbstractFilter */ 60),
	    FXAAFilter:             __webpack_require__(/*! ./renderers/webgl/filters/FXAAFilter */ 100),
	    SpriteMaskFilter:       __webpack_require__(/*! ./renderers/webgl/filters/SpriteMaskFilter */ 101),
	
	    /**
	     * This helper function will automatically detect which renderer you should be using.
	     * WebGL is the preferred renderer as it is a lot faster. If webGL is not supported by
	     * the browser then this function will return a canvas renderer
	     *
	     * @memberof PIXI
	     * @param width=800 {number} the width of the renderers view
	     * @param height=600 {number} the height of the renderers view
	     * @param [options] {object} The optional renderer parameters
	     * @param [options.view] {HTMLCanvasElement} the canvas to use as a view, optional
	     * @param [options.transparent=false] {boolean} If the render view is transparent, default false
	     * @param [options.antialias=false] {boolean} sets antialias (only applicable in chrome at the moment)
	     * @param [options.preserveDrawingBuffer=false] {boolean} enables drawing buffer preservation, enable this if you
	     *      need to call toDataUrl on the webgl context
	     * @param [options.resolution=1] {number} the resolution of the renderer, retina would be 2
	     * @param [noWebGL=false] {boolean} prevents selection of WebGL renderer, even if such is present
	     *
	     * @return {WebGLRenderer|CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
	     */
	    autoDetectRenderer: function (width, height, options, noWebGL)
	    {
	        width = width || 800;
	        height = height || 600;
	
	        if (!noWebGL && core.utils.isWebGLSupported())
	        {
	            return new core.WebGLRenderer(width, height, options);
	        }
	
	        return new core.CanvasRenderer(width, height, options);
	    }
	});


/***/ },
/* 2 */
/*!*********************************!*\
  !*** ./~/fbjs/lib/invariant.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/*!*******************************!*\
  !*** ./~/fbjs/lib/warning.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(/*! ./emptyFunction */ 15);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 4 */
/*!**************************************!*\
  !*** ./~/react/lib/Object.assign.js ***!
  \**************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ },
/* 5 */
/*!*******************************************!*\
  !*** ./~/node-libs-browser/mock/empty.js ***!
  \*******************************************/
/***/ function(module, exports) {



/***/ },
/* 6 */
/*!*************************************!*\
  !*** ./~/pixi.js/src/core/const.js ***!
  \*************************************/
/***/ function(module, exports) {

	/**
	 * Constant values used in pixi
	 *
	 * @lends PIXI
	 */
	var CONST = {
	    /**
	     * String of the current PIXI version
	     *
	     * @static
	     * @constant
	     * @property {string} VERSION
	     */
	    VERSION: '__VERSION__',
	
	    /**
	     * @property {number} PI_2 - Two Pi
	     * @constant
	     * @static
	     */
	    PI_2: Math.PI * 2,
	
	    /**
	     * @property {number} RAD_TO_DEG - Constant conversion factor for converting radians to degrees
	     * @constant
	     * @static
	     */
	    RAD_TO_DEG: 180 / Math.PI,
	
	    /**
	     * @property {Number} DEG_TO_RAD - Constant conversion factor for converting degrees to radians
	     * @constant
	     * @static
	     */
	    DEG_TO_RAD: Math.PI / 180,
	
	    /**
	     * Target frames per millisecond.
	     *
	     * @static
	     * @constant
	     * @property {number} TARGET_FPMS=0.06
	     */
	    TARGET_FPMS: 0.06,
	
	    /**
	     * Constant to identify the Renderer Type.
	     *
	     * @static
	     * @constant
	     * @property {object} RENDERER_TYPE
	     * @property {number} RENDERER_TYPE.UNKNOWN
	     * @property {number} RENDERER_TYPE.WEBGL
	     * @property {number} RENDERER_TYPE.CANVAS
	     */
	    RENDERER_TYPE: {
	        UNKNOWN:    0,
	        WEBGL:      1,
	        CANVAS:     2
	    },
	
	    /**
	     * Various blend modes supported by PIXI. IMPORTANT - The WebGL renderer only supports
	     * the NORMAL, ADD, MULTIPLY and SCREEN blend modes. Anything else will silently act like
	     * NORMAL.
	     *
	     * @static
	     * @constant
	     * @property {object} BLEND_MODES
	     * @property {number} BLEND_MODES.NORMAL
	     * @property {number} BLEND_MODES.ADD
	     * @property {number} BLEND_MODES.MULTIPLY
	     * @property {number} BLEND_MODES.SCREEN
	     * @property {number} BLEND_MODES.OVERLAY
	     * @property {number} BLEND_MODES.DARKEN
	     * @property {number} BLEND_MODES.LIGHTEN
	     * @property {number} BLEND_MODES.COLOR_DODGE
	     * @property {number} BLEND_MODES.COLOR_BURN
	     * @property {number} BLEND_MODES.HARD_LIGHT
	     * @property {number} BLEND_MODES.SOFT_LIGHT
	     * @property {number} BLEND_MODES.DIFFERENCE
	     * @property {number} BLEND_MODES.EXCLUSION
	     * @property {number} BLEND_MODES.HUE
	     * @property {number} BLEND_MODES.SATURATION
	     * @property {number} BLEND_MODES.COLOR
	     * @property {number} BLEND_MODES.LUMINOSITY
	     */
	    BLEND_MODES: {
	        NORMAL:         0,
	        ADD:            1,
	        MULTIPLY:       2,
	        SCREEN:         3,
	        OVERLAY:        4,
	        DARKEN:         5,
	        LIGHTEN:        6,
	        COLOR_DODGE:    7,
	        COLOR_BURN:     8,
	        HARD_LIGHT:     9,
	        SOFT_LIGHT:     10,
	        DIFFERENCE:     11,
	        EXCLUSION:      12,
	        HUE:            13,
	        SATURATION:     14,
	        COLOR:          15,
	        LUMINOSITY:     16
	    },
	
	    /**
	     * Various webgl draw modes. These can be used to specify which GL drawMode to use
	     * under certain situations and renderers.
	     *
	     * @static
	     * @constant
	     * @property {object} DRAW_MODES
	     * @property {number} DRAW_MODES.POINTS
	     * @property {number} DRAW_MODES.LINES
	     * @property {number} DRAW_MODES.LINE_LOOP
	     * @property {number} DRAW_MODES.LINE_STRIP
	     * @property {number} DRAW_MODES.TRIANGLES
	     * @property {number} DRAW_MODES.TRIANGLE_STRIP
	     * @property {number} DRAW_MODES.TRIANGLE_FAN
	     */
	    DRAW_MODES: {
	        POINTS:         0,
	        LINES:          1,
	        LINE_LOOP:      2,
	        LINE_STRIP:     3,
	        TRIANGLES:      4,
	        TRIANGLE_STRIP: 5,
	        TRIANGLE_FAN:   6
	    },
	
	    /**
	     * The scale modes that are supported by pixi.
	     *
	     * The DEFAULT scale mode affects the default scaling mode of future operations.
	     * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
	     *
	     * @static
	     * @constant
	     * @property {object} SCALE_MODES
	     * @property {number} SCALE_MODES.DEFAULT=LINEAR
	     * @property {number} SCALE_MODES.LINEAR Smooth scaling
	     * @property {number} SCALE_MODES.NEAREST Pixelating scaling
	     */
	    SCALE_MODES: {
	        DEFAULT:    0,
	        LINEAR:     0,
	        NEAREST:    1
	    },
	
	    /**
	     * The prefix that denotes a URL is for a retina asset
	     *
	     * @static
	     * @constant
	     * @property {string} RETINA_PREFIX
	     */
	    //example: '@2x',
	    RETINA_PREFIX: /@(.+)x/,
	
	    RESOLUTION:1,
	
	    FILTER_RESOLUTION:1,
	
	    /**
	     * The default render options if none are supplied to {@link PIXI.WebGLRenderer}
	     * or {@link PIXI.CanvasRenderer}.
	     *
	     * @static
	     * @constant
	     * @property {object} DEFAULT_RENDER_OPTIONS
	     * @property {HTMLCanvasElement} DEFAULT_RENDER_OPTIONS.view=null
	     * @property {boolean} DEFAULT_RENDER_OPTIONS.transparent=false
	     * @property {boolean} DEFAULT_RENDER_OPTIONS.antialias=false
	     * @property {boolean} DEFAULT_RENDER_OPTIONS.forceFXAA=false
	     * @property {boolean} DEFAULT_RENDER_OPTIONS.preserveDrawingBuffer=false
	     * @property {number} DEFAULT_RENDER_OPTIONS.resolution=1
	     * @property {number} DEFAULT_RENDER_OPTIONS.backgroundColor=0x000000
	     * @property {boolean} DEFAULT_RENDER_OPTIONS.clearBeforeRender=true
	     * @property {boolean} DEFAULT_RENDER_OPTIONS.autoResize=false
	     */
	    DEFAULT_RENDER_OPTIONS: {
	        view: null,
	        resolution: 1,
	        antialias: false,
	        forceFXAA: false,
	        autoResize: false,
	        transparent: false,
	        backgroundColor: 0x000000,
	        clearBeforeRender: true,
	        preserveDrawingBuffer: false,
	        roundPixels: false
	    },
	
	    /**
	     * Constants that identify shapes, mainly to prevent `instanceof` calls.
	     *
	     * @static
	     * @constant
	     * @property {object} SHAPES
	     * @property {object} SHAPES.POLY=0
	     * @property {object} SHAPES.RECT=1
	     * @property {object} SHAPES.CIRC=2
	     * @property {object} SHAPES.ELIP=3
	     * @property {object} SHAPES.RREC=4
	     */
	    SHAPES: {
	        POLY: 0,
	        RECT: 1,
	        CIRC: 2,
	        ELIP: 3,
	        RREC: 4
	    },
	
	    // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
	    // TODO: maybe add PARTICLE.BATCH_SIZE: 15000
	    SPRITE_BATCH_SIZE: 2000 //nice balance between mobile and desktop machines
	};
	
	module.exports = CONST;


/***/ },
/* 7 */
/*!*******************************************!*\
  !*** ./~/pixi.js/src/core/utils/index.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var CONST = __webpack_require__(/*! ../const */ 6);
	
	/**
	 * @namespace PIXI.utils
	 */
	var utils = module.exports = {
	    _uid: 0,
	    _saidHello: false,
	
	    EventEmitter:   __webpack_require__(/*! eventemitter3 */ 18),
	    pluginTarget:   __webpack_require__(/*! ./pluginTarget */ 198),
	    async:          __webpack_require__(/*! async */ 85),
	
	    /**
	     * Gets the next unique identifier
	     *
	     * @return {number} The next unique identifier to use.
	     */
	    uid: function ()
	    {
	        return ++utils._uid;
	    },
	
	    /**
	     * Converts a hex color number to an [R, G, B] array
	     *
	     * @param hex {number}
	     * @param  {number[]} [out=[]]
	     * @return {number[]} An array representing the [R, G, B] of the color.
	     */
	    hex2rgb: function (hex, out)
	    {
	        out = out || [];
	
	        out[0] = (hex >> 16 & 0xFF) / 255;
	        out[1] = (hex >> 8 & 0xFF) / 255;
	        out[2] = (hex & 0xFF) / 255;
	
	        return out;
	    },
	
	    /**
	     * Converts a hex color number to a string.
	     *
	     * @param hex {number}
	     * @return {string} The string color.
	     */
	    hex2string: function (hex)
	    {
	        hex = hex.toString(16);
	        hex = '000000'.substr(0, 6 - hex.length) + hex;
	
	        return '#' + hex;
	    },
	
	    /**
	     * Converts a color as an [R, G, B] array to a hex number
	     *
	     * @param rgb {number[]}
	     * @return {number} The color number
	     */
	    rgb2hex: function (rgb)
	    {
	        return ((rgb[0]*255 << 16) + (rgb[1]*255 << 8) + rgb[2]*255);
	    },
	
	    /**
	     * Checks whether the Canvas BlendModes are supported by the current browser
	     *
	     * @return {boolean} whether they are supported
	     */
	    canUseNewCanvasBlendModes: function ()
	    {
	        if (typeof document === 'undefined')
	        {
	            return false;
	        }
	
	        var pngHead = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABAQMAAADD8p2OAAAAA1BMVEX/';
	        var pngEnd = 'AAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==';
	
	        var magenta = new Image();
	        magenta.src = pngHead + 'AP804Oa6' + pngEnd;
	
	        var yellow = new Image();
	        yellow.src = pngHead + '/wCKxvRF' + pngEnd;
	
	        var canvas = document.createElement('canvas');
	        canvas.width = 6;
	        canvas.height = 1;
	
	        var context = canvas.getContext('2d');
	        context.globalCompositeOperation = 'multiply';
	        context.drawImage(magenta, 0, 0);
	        context.drawImage(yellow, 2, 0);
	
	        var data = context.getImageData(2,0,1,1).data;
	
	        return (data[0] === 255 && data[1] === 0 && data[2] === 0);
	    },
	
	    /**
	     * Given a number, this function returns the closest number that is a power of two
	     * this function is taken from Starling Framework as its pretty neat ;)
	     *
	     * @param number {number}
	     * @return {number} the closest number that is a power of two
	     */
	    getNextPowerOfTwo: function (number)
	    {
	        // see: http://en.wikipedia.org/wiki/Power_of_two#Fast_algorithm_to_check_if_a_positive_number_is_a_power_of_two
	        if (number > 0 && (number & (number - 1)) === 0)
	        {
	            return number;
	        }
	        else
	        {
	            var result = 1;
	
	            while (result < number)
	            {
	                result <<= 1;
	            }
	
	            return result;
	        }
	    },
	
	    /**
	     * checks if the given width and height make a power of two rectangle
	     *
	     * @param width {number}
	     * @param height {number}
	     * @return {boolean}
	     */
	    isPowerOfTwo: function (width, height)
	    {
	        return (width > 0 && (width & (width - 1)) === 0 && height > 0 && (height & (height - 1)) === 0);
	    },
	
	    /**
	     * get the resolution of an asset by looking for the prefix
	     * used by spritesheets and image urls
	     *
	     * @param url {string} the image path
	     * @return {number}
	     */
	    getResolutionOfUrl: function (url)
	    {
	        var resolution = CONST.RETINA_PREFIX.exec(url);
	
	        if (resolution)
	        {
	           return parseFloat(resolution[1]);
	        }
	
	        return 1;
	    },
	
	    /**
	     * Logs out the version and renderer information for this running instance of PIXI.
	     * If you don't want to see this message you can set `PIXI.utils._saidHello = true;`
	     * so the library thinks it already said it. Keep in mind that doing that will forever
	     * makes you a jerk face.
	     *
	     * @param {string} type - The string renderer type to log.
	     * @constant
	     * @static
	     */
	    sayHello: function (type)
	    {
	        if (utils._saidHello)
	        {
	            return;
	        }
	
	        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1)
	        {
	            var args = [
	                '\n %c %c %c Pixi.js ' + CONST.VERSION + ' - ✰ ' + type + ' ✰  %c ' + ' %c ' + ' http://www.pixijs.com/  %c %c ♥%c♥%c♥ \n\n',
	                'background: #ff66a5; padding:5px 0;',
	                'background: #ff66a5; padding:5px 0;',
	                'color: #ff66a5; background: #030307; padding:5px 0;',
	                'background: #ff66a5; padding:5px 0;',
	                'background: #ffc3dc; padding:5px 0;',
	                'background: #ff66a5; padding:5px 0;',
	                'color: #ff2424; background: #fff; padding:5px 0;',
	                'color: #ff2424; background: #fff; padding:5px 0;',
	                'color: #ff2424; background: #fff; padding:5px 0;'
	            ];
	
	            window.console.log.apply(console, args); //jshint ignore:line
	        }
	        else if (window.console)
	        {
	            window.console.log('Pixi.js ' + CONST.VERSION + ' - ' + type + ' - http://www.pixijs.com/'); //jshint ignore:line
	        }
	
	        utils._saidHello = true;
	    },
	
	    /**
	     * Helper for checking for webgl support
	     *
	     * @return {boolean}
	     */
	    isWebGLSupported: function ()
	    {
	        var contextOptions = { stencil: true };
	        try
	        {
	            if (!window.WebGLRenderingContext)
	            {
	                return false;
	            }
	
	            var canvas = document.createElement('canvas'),
	                gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);
	
	            return !!(gl && gl.getContextAttributes().stencil);
	        }
	        catch (e)
	        {
	            return false;
	        }
	    },
	
	    /**
	     * Returns sign of number
	     *
	     * @param n {number}
	     * @returns {number} 0 if n is 0, -1 if n is negative, 1 if n i positive
	     */
	    sign: function (n)
	    {
	        return n ? (n < 0 ? -1 : 1) : 0;
	    },
	
	    /**
	     * removeItems
	     *
	     * @param {array} arr The target array
	     * @param {number} startIdx The index to begin removing from (inclusive)
	     * @param {number} removeCount How many items to remove
	     */
	    removeItems: function (arr, startIdx, removeCount)
	    {
	        var length = arr.length;
	
	        if (startIdx >= length || removeCount === 0)
	        {
	            return;
	        }
	
	        removeCount = (startIdx+removeCount > length ? length-startIdx : removeCount);
	        for (var i = startIdx, len = length-removeCount; i < len; ++i)
	        {
	            arr[i] = arr[i + removeCount];
	        }
	
	        arr.length = len;
	    },
	
	    /**
	     * @todo Describe property usage
	     * @private
	     */
	    TextureCache: {},
	
	    /**
	     * @todo Describe property usage
	     * @private
	     */
	    BaseTextureCache: {}
	};


/***/ },
/* 8 */
/*!********************************************!*\
  !*** ./~/fbjs/lib/ExecutionEnvironment.js ***!
  \********************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 9 */
/*!******************************************!*\
  !*** ./~/pixi.js/src/core/math/index.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Math classes and utilities mixed into PIXI namespace.
	 *
	 * @lends PIXI
	 */
	module.exports = {
	    // These will be mixed to be made publicly available,
	    // while this module is used internally in core
	    // to avoid circular dependencies and cut down on
	    // internal module requires.
	
	    Point:      __webpack_require__(/*! ./Point */ 56),
	    Matrix:     __webpack_require__(/*! ./Matrix */ 97),
	    GroupD8:    __webpack_require__(/*! ./GroupD8 */ 96),
	
	    Circle:     __webpack_require__(/*! ./shapes/Circle */ 179),
	    Ellipse:    __webpack_require__(/*! ./shapes/Ellipse */ 180),
	    Polygon:    __webpack_require__(/*! ./shapes/Polygon */ 181),
	    Rectangle:  __webpack_require__(/*! ./shapes/Rectangle */ 57),
	    RoundedRectangle: __webpack_require__(/*! ./shapes/RoundedRectangle */ 182)
	};


/***/ },
/* 10 */
/*!***********************************!*\
  !*** ./~/react/lib/ReactMount.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(/*! ./DOMProperty */ 26);
	var ReactBrowserEventEmitter = __webpack_require__(/*! ./ReactBrowserEventEmitter */ 45);
	var ReactCurrentOwner = __webpack_require__(/*! ./ReactCurrentOwner */ 17);
	var ReactDOMFeatureFlags = __webpack_require__(/*! ./ReactDOMFeatureFlags */ 134);
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactEmptyComponentRegistry = __webpack_require__(/*! ./ReactEmptyComponentRegistry */ 141);
	var ReactInstanceHandles = __webpack_require__(/*! ./ReactInstanceHandles */ 27);
	var ReactInstanceMap = __webpack_require__(/*! ./ReactInstanceMap */ 33);
	var ReactMarkupChecksum = __webpack_require__(/*! ./ReactMarkupChecksum */ 144);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	var ReactReconciler = __webpack_require__(/*! ./ReactReconciler */ 24);
	var ReactUpdateQueue = __webpack_require__(/*! ./ReactUpdateQueue */ 71);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var emptyObject = __webpack_require__(/*! fbjs/lib/emptyObject */ 28);
	var containsNode = __webpack_require__(/*! fbjs/lib/containsNode */ 87);
	var instantiateReactComponent = __webpack_require__(/*! ./instantiateReactComponent */ 78);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var setInnerHTML = __webpack_require__(/*! ./setInnerHTML */ 52);
	var shouldUpdateReactComponent = __webpack_require__(/*! ./shouldUpdateReactComponent */ 81);
	var validateDOMNesting = __webpack_require__(/*! ./validateDOMNesting */ 83);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ },
/* 11 */
/*!*************************************!*\
  !*** ./~/react/lib/ReactElement.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(/*! ./ReactCurrentOwner */ 17);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var canDefineProperty = __webpack_require__(/*! ./canDefineProperty */ 50);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 12 */
/*!**************************!*\
  !*** ./~/react/react.js ***!
  \**************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(/*! ./lib/React */ 268);


/***/ },
/* 13 */
/*!**********************************!*\
  !*** ./~/react/lib/ReactPerf.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ },
/* 14 */
/*!*************************************!*\
  !*** ./~/react/lib/ReactUpdates.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(/*! ./CallbackQueue */ 65);
	var PooledClass = __webpack_require__(/*! ./PooledClass */ 22);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	var ReactReconciler = __webpack_require__(/*! ./ReactReconciler */ 24);
	var Transaction = __webpack_require__(/*! ./Transaction */ 49);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 15 */
/*!*************************************!*\
  !*** ./~/fbjs/lib/emptyFunction.js ***!
  \*************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 16 */
/*!***************************************!*\
  !*** ./~/react/lib/EventConstants.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(/*! fbjs/lib/keyMirror */ 35);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 17 */
/*!******************************************!*\
  !*** ./~/react/lib/ReactCurrentOwner.js ***!
  \******************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 18 */
/*!**********************************!*\
  !*** ./~/eventemitter3/index.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 19 */
/*!*****************************!*\
  !*** ./~/fbjs/lib/keyOf.js ***!
  \*****************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 20 */
/*!*************************************************!*\
  !*** ./assets/js/src/constants/AppConstants.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Constants
	 * @object
	 */
	
	var config = {};
	
	var actions = {
	  WINDOW_RESIZE: 'WINDOW_RESIZE',
	  OPEN_MAIN_MENU: 'OPEN_MAIN_MENU',
	  CLOSE_MAIN_MENU: 'CLOSE_MAIN_MENU',
	  GO_TO_SLIDE: 'GO_TO_SLIDE',
	  SLIDE_CHANGED: 'SLIDE_CHANGED',
	  GO_TO_LANDING_CONTENT: 'GO_TO_LANDING_CONTENT',
	  GO_TO_MAIN_CONTENT: 'GO_TO_MAIN_CONTENT',
	  SHOW_LARGE_LANDING: 'SHOW_LARGE_LANDING',
	  REMOVE_LARGE_LANDING: 'REMOVE_LARGE_LANDING',
	  ADVANCE_SLIDE: 'ADVANCE_SLIDE',
	  REVERSE_SLIDE: 'REVERSE_SLIDE',
	  SECTION_TRANSITION_COMPLETE: 'SECTION_TRANSITION_COMPLETE',
	  SECTION_TRANSITION_IN_PROGRESS: 'SECTION_TRANSITION_IN_PROGRESS'
	};
	
	var constants = Object.assign(config, actions);
	
	exports.default = constants;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "AppConstants.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 21 */
/*!***************************************************!*\
  !*** ./assets/js/src/dispatcher/AppDispatcher.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dispatcher = __webpack_require__(/*! ./Dispatcher */ 251);
	
	var _Dispatcher2 = _interopRequireDefault(_Dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * App Dispatcher
	 * @class
	 */
	var AppDispatcher = Object.assign({}, _Dispatcher2.default.prototype, {
	  /**
	   * A bridge function between the views and the dispatcher, marking the action
	   * as a view action.  Another variant here could be handleServerAction
	   * @param {object} action The data coming from the view
	   * @returns {undefined} undefined
	   */
	
	  handleViewAction: function handleViewAction(action) {
	    this.dispatch({
	      source: 'VIEW_ACTION',
	      action: action
	    });
	  }
	});
	
	exports.default = AppDispatcher;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "AppDispatcher.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 22 */
/*!************************************!*\
  !*** ./~/react/lib/PooledClass.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 23 */
/*!*********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/managers/WebGLManager.js ***!
  \*********************************************************************/
/***/ function(module, exports) {

	/**
	 * @class
	 * @memberof PIXI
	 * @param renderer {PIXI.WebGLRenderer} The renderer this manager works for.
	 */
	function WebGLManager(renderer)
	{
	    /**
	     * The renderer this manager works for.
	     *
	     * @member {PIXI.WebGLRenderer}
	     */
	    this.renderer = renderer;
	
	    this.renderer.on('context', this.onContextChange, this);
	}
	
	WebGLManager.prototype.constructor = WebGLManager;
	module.exports = WebGLManager;
	
	/**
	 * Generic method called when there is a WebGL context change.
	 *
	 */
	WebGLManager.prototype.onContextChange = function ()
	{
		// do some codes init!
	};
	
	/**
	 * Generic destroy methods to be overridden by the subclass
	 *
	 */
	WebGLManager.prototype.destroy = function ()
	{
	    this.renderer.off('context', this.onContextChange, this);
	
	    this.renderer = null;
	};


/***/ },
/* 24 */
/*!****************************************!*\
  !*** ./~/react/lib/ReactReconciler.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(/*! ./ReactRef */ 287);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 25 */
/*!***************************************!*\
  !*** ./~/react/lib/SyntheticEvent.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(/*! ./PooledClass */ 22);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var emptyFunction = __webpack_require__(/*! fbjs/lib/emptyFunction */ 15);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ },
/* 26 */
/*!************************************!*\
  !*** ./~/react/lib/DOMProperty.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 27 */
/*!*********************************************!*\
  !*** ./~/react/lib/ReactInstanceHandles.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(/*! ./ReactRootIndex */ 149);
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ },
/* 28 */
/*!***********************************!*\
  !*** ./~/fbjs/lib/emptyObject.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 29 */
/*!********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/utils/ObjectRenderer.js ***!
  \********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var WebGLManager = __webpack_require__(/*! ../managers/WebGLManager */ 23);
	
	/**
	 * Base for a common object renderer that can be used as a system renderer plugin.
	 *
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 * @param renderer {PIXI.WebGLRenderer} The renderer this object renderer works for.
	 */
	function ObjectRenderer(renderer)
	{
	    WebGLManager.call(this, renderer);
	}
	
	
	ObjectRenderer.prototype = Object.create(WebGLManager.prototype);
	ObjectRenderer.prototype.constructor = ObjectRenderer;
	module.exports = ObjectRenderer;
	
	/**
	 * Starts the renderer and sets the shader
	 *
	 */
	ObjectRenderer.prototype.start = function ()
	{
	    // set the shader..
	};
	
	/**
	 * Stops the renderer
	 *
	 */
	ObjectRenderer.prototype.stop = function ()
	{
	    this.flush();
	};
	
	/**
	 * flushes
	 *
	 */
	ObjectRenderer.prototype.flush = function ()
	{
	    // flush!
	};
	
	/**
	 * Renders an object
	 *
	 * @param object {PIXI.DisplayObject} The object to render.
	 */
	ObjectRenderer.prototype.render = function (object) // jshint unused:false
	{
	    // render the object
	};


/***/ },
/* 30 */
/*!************************************************!*\
  !*** ./~/pixi.js/src/core/textures/Texture.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	var BaseTexture = __webpack_require__(/*! ./BaseTexture */ 41),
	    VideoBaseTexture = __webpack_require__(/*! ./VideoBaseTexture */ 108),
	    TextureUvs = __webpack_require__(/*! ./TextureUvs */ 107),
	    EventEmitter = __webpack_require__(/*! eventemitter3 */ 18),
	    math = __webpack_require__(/*! ../math */ 9),
	    utils = __webpack_require__(/*! ../utils */ 7);
	
	/**
	 * A texture stores the information that represents an image or part of an image. It cannot be added
	 * to the display list directly. Instead use it as the texture for a Sprite. If no frame is provided then the whole image is used.
	 *
	 * You can directly create a texture from an image and then reuse it multiple times like this :
	 *
	 * ```js
	 * var texture = PIXI.Texture.fromImage('assets/image.png');
	 * var sprite1 = new PIXI.Sprite(texture);
	 * var sprite2 = new PIXI.Sprite(texture);
	 * ```
	 *
	 * @class
	 * @memberof PIXI
	 * @param baseTexture {PIXI.BaseTexture} The base texture source to create the texture from
	 * @param [frame] {PIXI.Rectangle} The rectangle frame of the texture to show
	 * @param [crop] {PIXI.Rectangle} The area of original texture
	 * @param [trim] {PIXI.Rectangle} Trimmed texture rectangle
	 * @param [rotate] {number} indicates how the texture was rotated by texture packer. See {@link PIXI.GroupD8}
	 */
	function Texture(baseTexture, frame, crop, trim, rotate)
	{
	    EventEmitter.call(this);
	
	    /**
	     * Does this Texture have any frame data assigned to it?
	     *
	     * @member {boolean}
	     */
	    this.noFrame = false;
	
	    if (!frame)
	    {
	        this.noFrame = true;
	        frame = new math.Rectangle(0, 0, 1, 1);
	    }
	
	    if (baseTexture instanceof Texture)
	    {
	        baseTexture = baseTexture.baseTexture;
	    }
	
	    /**
	     * The base texture that this texture uses.
	     *
	     * @member {PIXI.BaseTexture}
	     */
	    this.baseTexture = baseTexture;
	
	    /**
	     * The frame specifies the region of the base texture that this texture uses
	     *
	     * @member {PIXI.Rectangle}
	     * @private
	     */
	    this._frame = frame;
	
	    /**
	     * The texture trim data.
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.trim = trim;
	
	    /**
	     * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	     *
	     * @member {boolean}
	     */
	    this.valid = false;
	
	    /**
	     * This will let a renderer know that a texture has been updated (used mainly for webGL uv updates)
	     *
	     * @member {boolean}
	     */
	    this.requiresUpdate = false;
	
	    /**
	     * The WebGL UV data cache.
	     *
	     * @member {PIXI.TextureUvs}
	     * @private
	     */
	    this._uvs = null;
	
	    /**
	     * The width of the Texture in pixels.
	     *
	     * @member {number}
	     */
	    this.width = 0;
	
	    /**
	     * The height of the Texture in pixels.
	     *
	     * @member {number}
	     */
	    this.height = 0;
	
	    /**
	     * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
	     * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.crop = crop || frame;//new math.Rectangle(0, 0, 1, 1);
	
	    this._rotate = +(rotate || 0);
	
	    if (rotate === true) {
	        // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
	        this._rotate = 2;
	    } else {
	        if (this._rotate % 2 !== 0) {
	            throw 'attempt to use diamond-shaped UVs. If you are sure, set rotation manually';
	        }
	    }
	
	    if (baseTexture.hasLoaded)
	    {
	        if (this.noFrame)
	        {
	            frame = new math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
	
	            // if there is no frame we should monitor for any base texture changes..
	            baseTexture.on('update', this.onBaseTextureUpdated, this);
	        }
	        this.frame = frame;
	    }
	    else
	    {
	        baseTexture.once('loaded', this.onBaseTextureLoaded, this);
	    }
	
	    /**
	     * Fired when the texture is updated. This happens if the frame or the baseTexture is updated.
	     *
	     * @event update
	     * @memberof PIXI.Texture#
	     * @protected
	     */
	}
	
	Texture.prototype = Object.create(EventEmitter.prototype);
	Texture.prototype.constructor = Texture;
	module.exports = Texture;
	
	Object.defineProperties(Texture.prototype, {
	    /**
	     * The frame specifies the region of the base texture that this texture uses.
	     *
	     * @member {PIXI.Rectangle}
	     * @memberof PIXI.Texture#
	     */
	    frame: {
	        get: function ()
	        {
	            return this._frame;
	        },
	        set: function (frame)
	        {
	            this._frame = frame;
	
	            this.noFrame = false;
	
	            this.width = frame.width;
	            this.height = frame.height;
	
	            if (!this.trim && !this.rotate && (frame.x + frame.width > this.baseTexture.width || frame.y + frame.height > this.baseTexture.height))
	            {
	                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions ' + this);
	            }
	
	            //this.valid = frame && frame.width && frame.height && this.baseTexture.source && this.baseTexture.hasLoaded;
	            this.valid = frame && frame.width && frame.height && this.baseTexture.hasLoaded;
	
	            if (this.trim)
	            {
	                this.width = this.trim.width;
	                this.height = this.trim.height;
	                this._frame.width = this.trim.width;
	                this._frame.height = this.trim.height;
	            }
	            else
	            {
	                this.crop = frame;
	            }
	
	            if (this.valid)
	            {
	                this._updateUvs();
	            }
	        }
	    },
	    /**
	     * Indicates whether the texture is rotated inside the atlas
	     * set to 2 to compensate for texture packer rotation
	     * set to 6 to compensate for spine packer rotation
	     * can be used to rotate or mirror sprites
	     * See {@link PIXI.GroupD8} for explanation
	     *
	     * @member {number}
	     */
	    rotate: {
	        get: function ()
	        {
	            return this._rotate;
	        },
	        set: function (rotate)
	        {
	            this._rotate = rotate;
	            if (this.valid)
	            {
	                this._updateUvs();
	            }
	        }
	    }
	});
	
	/**
	 * Updates this texture on the gpu.
	 *
	 */
	Texture.prototype.update = function ()
	{
	    this.baseTexture.update();
	};
	
	/**
	 * Called when the base texture is loaded
	 *
	 * @private
	 */
	Texture.prototype.onBaseTextureLoaded = function (baseTexture)
	{
	    // TODO this code looks confusing.. boo to abusing getters and setterss!
	    if (this.noFrame)
	    {
	        this.frame = new math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
	    }
	    else
	    {
	        this.frame = this._frame;
	    }
	
	    this.emit('update', this);
	};
	
	/**
	 * Called when the base texture is updated
	 *
	 * @private
	 */
	Texture.prototype.onBaseTextureUpdated = function (baseTexture)
	{
	    this._frame.width = baseTexture.width;
	    this._frame.height = baseTexture.height;
	
	    this.emit('update', this);
	};
	
	/**
	 * Destroys this texture
	 *
	 * @param [destroyBase=false] {boolean} Whether to destroy the base texture as well
	 */
	Texture.prototype.destroy = function (destroyBase)
	{
	    if (this.baseTexture)
	    {
	        if (destroyBase)
	        {
	            this.baseTexture.destroy();
	        }
	
	        this.baseTexture.off('update', this.onBaseTextureUpdated, this);
	        this.baseTexture.off('loaded', this.onBaseTextureLoaded, this);
	
	        this.baseTexture = null;
	    }
	
	    this._frame = null;
	    this._uvs = null;
	    this.trim = null;
	    this.crop = null;
	
	    this.valid = false;
	
	    this.off('dispose', this.dispose, this);
	    this.off('update', this.update, this);
	};
	
	/**
	 * Creates a new texture object that acts the same as this one.
	 *
	 * @return {PIXI.Texture}
	 */
	Texture.prototype.clone = function ()
	{
	    return new Texture(this.baseTexture, this.frame, this.crop, this.trim, this.rotate);
	};
	
	/**
	 * Updates the internal WebGL UV cache.
	 *
	 * @private
	 */
	Texture.prototype._updateUvs = function ()
	{
	    if (!this._uvs)
	    {
	        this._uvs = new TextureUvs();
	    }
	
	    this._uvs.set(this.crop, this.baseTexture, this.rotate);
	};
	
	/**
	 * Helper function that creates a Texture object from the given image url.
	 * If the image is not in the texture cache it will be  created and loaded.
	 *
	 * @static
	 * @param imageUrl {string} The image url of the texture
	 * @param crossorigin {boolean} Whether requests should be treated as crossorigin
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @return {PIXI.Texture} The newly created texture
	 */
	Texture.fromImage = function (imageUrl, crossorigin, scaleMode)
	{
	    var texture = utils.TextureCache[imageUrl];
	
	    if (!texture)
	    {
	        texture = new Texture(BaseTexture.fromImage(imageUrl, crossorigin, scaleMode));
	        utils.TextureCache[imageUrl] = texture;
	    }
	
	    return texture;
	};
	
	/**
	 * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
	 * The frame ids are created when a Texture packer file has been loaded
	 *
	 * @static
	 * @param frameId {string} The frame Id of the texture in the cache
	 * @return {PIXI.Texture} The newly created texture
	 */
	Texture.fromFrame = function (frameId)
	{
	    var texture = utils.TextureCache[frameId];
	
	    if (!texture)
	    {
	        throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
	    }
	
	    return texture;
	};
	
	/**
	 * Helper function that creates a new Texture based on the given canvas element.
	 *
	 * @static
	 * @param canvas {Canvas} The canvas element source of the texture
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @return {PIXI.Texture}
	 */
	Texture.fromCanvas = function (canvas, scaleMode)
	{
	    return new Texture(BaseTexture.fromCanvas(canvas, scaleMode));
	};
	
	/**
	 * Helper function that creates a new Texture based on the given video element.
	 *
	 * @static
	 * @param video {HTMLVideoElement}
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @return {PIXI.Texture} A Texture
	 */
	Texture.fromVideo = function (video, scaleMode)
	{
	    if (typeof video === 'string')
	    {
	        return Texture.fromVideoUrl(video, scaleMode);
	    }
	    else
	    {
	        return new Texture(VideoBaseTexture.fromVideo(video, scaleMode));
	    }
	};
	
	/**
	 * Helper function that creates a new Texture based on the video url.
	 *
	 * @static
	 * @param videoUrl {string}
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @return {PIXI.Texture} A Texture
	 */
	Texture.fromVideoUrl = function (videoUrl, scaleMode)
	{
	    return new Texture(VideoBaseTexture.fromUrl(videoUrl, scaleMode));
	};
	
	/**
	 * Adds a texture to the global utils.TextureCache. This cache is shared across the whole PIXI object.
	 *
	 * @static
	 * @param texture {PIXI.Texture} The Texture to add to the cache.
	 * @param id {string} The id that the texture will be stored against.
	 */
	Texture.addTextureToCache = function (texture, id)
	{
	    utils.TextureCache[id] = texture;
	};
	
	/**
	 * Remove a texture from the global utils.TextureCache.
	 *
	 * @static
	 * @param id {string} The id of the texture to be removed
	 * @return {PIXI.Texture} The texture that was removed
	 */
	Texture.removeTextureFromCache = function (id)
	{
	    var texture = utils.TextureCache[id];
	
	    delete utils.TextureCache[id];
	    delete utils.BaseTextureCache[id];
	
	    return texture;
	};
	
	/**
	 * An empty texture, used often to not have to create multiple empty textures.
	 *
	 * @static
	 * @constant
	 */
	Texture.EMPTY = new Texture(new BaseTexture());


/***/ },
/* 31 */
/*!***************************************!*\
  !*** ./~/react/lib/EventPluginHub.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(/*! ./EventPluginRegistry */ 129);
	var EventPluginUtils = __webpack_require__(/*! ./EventPluginUtils */ 265);
	var ReactErrorUtils = __webpack_require__(/*! ./ReactErrorUtils */ 142);
	
	var accumulateInto = __webpack_require__(/*! ./accumulateInto */ 151);
	var forEachAccumulated = __webpack_require__(/*! ./forEachAccumulated */ 152);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 32 */
/*!*****************************************!*\
  !*** ./~/react/lib/EventPropagators.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(/*! ./EventConstants */ 16);
	var EventPluginHub = __webpack_require__(/*! ./EventPluginHub */ 31);
	
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var accumulateInto = __webpack_require__(/*! ./accumulateInto */ 151);
	var forEachAccumulated = __webpack_require__(/*! ./forEachAccumulated */ 152);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 33 */
/*!*****************************************!*\
  !*** ./~/react/lib/ReactInstanceMap.js ***!
  \*****************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 34 */
/*!*****************************************!*\
  !*** ./~/react/lib/SyntheticUIEvent.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(/*! ./SyntheticEvent */ 25);
	
	var getEventTarget = __webpack_require__(/*! ./getEventTarget */ 76);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 35 */
/*!*********************************!*\
  !*** ./~/fbjs/lib/keyMirror.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(/*! ./invariant */ 2);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 36 */
/*!*************************************************!*\
  !*** ./~/pixi.js/src/core/display/Container.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	var math = __webpack_require__(/*! ../math */ 9),
	    utils = __webpack_require__(/*! ../utils */ 7),
	    DisplayObject = __webpack_require__(/*! ./DisplayObject */ 94),
	    RenderTexture = __webpack_require__(/*! ../textures/RenderTexture */ 61),
	    _tempMatrix = new math.Matrix();
	
	/**
	 * A Container represents a collection of display objects.
	 * It is the base class of all display objects that act as a container for other objects.
	 *
	 *```js
	 * var container = new PIXI.Container();
	 * container.addChild(sprite);
	 * ```
	 * @class
	 * @extends PIXI.DisplayObject
	 * @memberof PIXI
	 */
	function Container()
	{
	    DisplayObject.call(this);
	
	    /**
	     * The array of children of this container.
	     *
	     * @member {PIXI.DisplayObject[]}
	     * @readonly
	     */
	    this.children = [];
	}
	
	// constructor
	Container.prototype = Object.create(DisplayObject.prototype);
	Container.prototype.constructor = Container;
	module.exports = Container;
	
	Object.defineProperties(Container.prototype, {
	    /**
	     * The width of the Container, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     * @memberof PIXI.Container#
	     */
	    width: {
	        get: function ()
	        {
	            return this.scale.x * this.getLocalBounds().width;
	        },
	        set: function (value)
	        {
	
	            var width = this.getLocalBounds().width;
	
	            if (width !== 0)
	            {
	                this.scale.x = value / width;
	            }
	            else
	            {
	                this.scale.x = 1;
	            }
	
	
	            this._width = value;
	        }
	    },
	
	    /**
	     * The height of the Container, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     * @memberof PIXI.Container#
	     */
	    height: {
	        get: function ()
	        {
	            return  this.scale.y * this.getLocalBounds().height;
	        },
	        set: function (value)
	        {
	
	            var height = this.getLocalBounds().height;
	
	            if (height !== 0)
	            {
	                this.scale.y = value / height ;
	            }
	            else
	            {
	                this.scale.y = 1;
	            }
	
	            this._height = value;
	        }
	    }
	});
	
	/**
	 * Overridable method that can be used by Container subclasses whenever the children array is modified
	 *
	 * @private
	 */
	Container.prototype.onChildrenChange = function () {};
	
	/**
	 * Adds a child to the container.
	 * 
	 * You can also add multple items like so: myContainer.addChild(thinkOne, thingTwo, thingThree)
	 * @param child {PIXI.DisplayObject} The DisplayObject to add to the container
	 * @return {PIXI.DisplayObject} The child that was added.
	 */
	Container.prototype.addChild = function (child)
	{ 
	    var argumentsLength = arguments.length;
	
	    // if there is only one argument we can bypass looping through the them
	    if(argumentsLength > 1)
	    {
	        // loop through the arguments property and add all children
	        // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
	        for (var i = 0; i < argumentsLength; i++)
	        {
	            this.addChild( arguments[i] );
	        }
	    }     
	    else
	    {
	        // if the child has a parent then lets remove it as Pixi objects can only exist in one place
	        if (child.parent)
	        {
	            child.parent.removeChild(child);
	        }
	
	        child.parent = this;
	        
	        this.children.push(child);
	
	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(this.children.length-1);
	        child.emit('added', this);
	    }
	
	    return child;
	};
	
	/**
	 * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
	 *
	 * @param child {PIXI.DisplayObject} The child to add
	 * @param index {number} The index to place the child in
	 * @return {PIXI.DisplayObject} The child that was added.
	 */
	Container.prototype.addChildAt = function (child, index)
	{
	    if (index >= 0 && index <= this.children.length)
	    {
	        if (child.parent)
	        {
	            child.parent.removeChild(child);
	        }
	
	        child.parent = this;
	
	        this.children.splice(index, 0, child);
	
	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('added', this);
	
	        return child;
	    }
	    else
	    {
	        throw new Error(child + 'addChildAt: The index '+ index +' supplied is out of bounds ' + this.children.length);
	    }
	};
	
	/**
	 * Swaps the position of 2 Display Objects within this container.
	 *
	 * @param child {PIXI.DisplayObject}
	 * @param child2 {PIXI.DisplayObject}
	 */
	Container.prototype.swapChildren = function (child, child2)
	{
	    if (child === child2)
	    {
	        return;
	    }
	
	    var index1 = this.getChildIndex(child);
	    var index2 = this.getChildIndex(child2);
	
	    if (index1 < 0 || index2 < 0)
	    {
	        throw new Error('swapChildren: Both the supplied DisplayObjects must be children of the caller.');
	    }
	
	    this.children[index1] = child2;
	    this.children[index2] = child;
	    this.onChildrenChange(index1 < index2 ? index1 : index2);
	};
	
	/**
	 * Returns the index position of a child DisplayObject instance
	 *
	 * @param child {PIXI.DisplayObject} The DisplayObject instance to identify
	 * @return {number} The index position of the child display object to identify
	 */
	Container.prototype.getChildIndex = function (child)
	{
	    var index = this.children.indexOf(child);
	
	    if (index === -1)
	    {
	        throw new Error('The supplied DisplayObject must be a child of the caller');
	    }
	
	    return index;
	};
	
	/**
	 * Changes the position of an existing child in the display object container
	 *
	 * @param child {PIXI.DisplayObject} The child DisplayObject instance for which you want to change the index number
	 * @param index {number} The resulting index number for the child display object
	 */
	Container.prototype.setChildIndex = function (child, index)
	{
	    if (index < 0 || index >= this.children.length)
	    {
	        throw new Error('The supplied index is out of bounds');
	    }
	
	    var currentIndex = this.getChildIndex(child);
	
	    utils.removeItems(this.children, currentIndex, 1); // remove from old position
	    this.children.splice(index, 0, child); //add at new position
	    this.onChildrenChange(index);
	};
	
	/**
	 * Returns the child at the specified index
	 *
	 * @param index {number} The index to get the child at
	 * @return {PIXI.DisplayObject} The child at the given index, if any.
	 */
	Container.prototype.getChildAt = function (index)
	{
	    if (index < 0 || index >= this.children.length)
	    {
	        throw new Error('getChildAt: Supplied index ' + index + ' does not exist in the child list, or the supplied DisplayObject is not a child of the caller');
	    }
	
	    return this.children[index];
	};
	
	/**
	 * Removes a child from the container.
	 *
	 * @param child {PIXI.DisplayObject} The DisplayObject to remove
	 * @return {PIXI.DisplayObject} The child that was removed.
	 */
	Container.prototype.removeChild = function (child)
	{
	    var argumentsLength = arguments.length;
	
	    // if there is only one argument we can bypass looping through the them
	    if(argumentsLength > 1)
	    {
	        // loop through the arguments property and add all children
	        // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
	        for (var i = 0; i < argumentsLength; i++)
	        {
	            this.removeChild( arguments[i] );
	        }
	    }     
	    else
	    {   
	        var index = this.children.indexOf(child);
	
	        if (index === -1)
	        {
	            return;
	        }
	
	        child.parent = null;
	        utils.removeItems(this.children, index, 1);
	
	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('removed', this);
	    }
	
	    return child;
	};
	
	/**
	 * Removes a child from the specified index position.
	 *
	 * @param index {number} The index to get the child from
	 * @return {PIXI.DisplayObject} The child that was removed.
	 */
	Container.prototype.removeChildAt = function (index)
	{
	    var child = this.getChildAt(index);
	
	    child.parent = null;
	    utils.removeItems(this.children, index, 1);
	
	    // TODO - lets either do all callbacks or all events.. not both!
	    this.onChildrenChange(index);
	    child.emit('removed', this);
	
	    return child;
	};
	
	/**
	 * Removes all children from this container that are within the begin and end indexes.
	 *
	 * @param beginIndex {number} The beginning position. Default value is 0.
	 * @param endIndex {number} The ending position. Default value is size of the container.
	 */
	Container.prototype.removeChildren = function (beginIndex, endIndex)
	{
	    var begin = beginIndex || 0;
	    var end = typeof endIndex === 'number' ? endIndex : this.children.length;
	    var range = end - begin;
	    var removed, i;
	
	    if (range > 0 && range <= end)
	    {
	        removed = this.children.splice(begin, range);
	
	        for (i = 0; i < removed.length; ++i)
	        {
	            removed[i].parent = null;
	        }
	
	        this.onChildrenChange(beginIndex);
	
	        for (i = 0; i < removed.length; ++i)
	        {
	            removed[i].emit('removed', this);
	        }
	
	        return removed;
	    }
	    else if (range === 0 && this.children.length === 0)
	    {
	        return [];
	    }
	    else
	    {
	        throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
	    }
	};
	
	/**
	 * Useful function that returns a texture of the display object that can then be used to create sprites
	 * This can be quite useful if your displayObject is static / complicated and needs to be reused multiple times.
	 *
	 * @param renderer {PIXI.CanvasRenderer|PIXI.WebGLRenderer} The renderer used to generate the texture.
	 * @param resolution {number} The resolution of the texture being generated
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @return {PIXI.Texture} a texture of the display object
	 */
	Container.prototype.generateTexture = function (renderer, resolution, scaleMode)
	{
	    var bounds = this.getLocalBounds();
	
	    var renderTexture = new RenderTexture(renderer, bounds.width | 0, bounds.height | 0, scaleMode, resolution);
	
	    _tempMatrix.tx = -bounds.x;
	    _tempMatrix.ty = -bounds.y;
	
	    renderTexture.render(this, _tempMatrix);
	
	    return renderTexture;
	};
	
	/*
	 * Updates the transform on all children of this container for rendering
	 *
	 * @private
	 */
	Container.prototype.updateTransform = function ()
	{
	    if (!this.visible)
	    {
	        return;
	    }
	
	    this.displayObjectUpdateTransform();
	
	    for (var i = 0, j = this.children.length; i < j; ++i)
	    {
	        this.children[i].updateTransform();
	    }
	};
	
	// performance increase to avoid using call.. (10x faster)
	Container.prototype.containerUpdateTransform = Container.prototype.updateTransform;
	
	/**
	 * Retrieves the bounds of the Container as a rectangle. The bounds calculation takes all visible children into consideration.
	 *
	 * @return {PIXI.Rectangle} The rectangular bounding area
	 */
	Container.prototype.getBounds = function ()
	{
	    if(!this._currentBounds)
	    {
	
	        if (this.children.length === 0)
	        {
	            return math.Rectangle.EMPTY;
	        }
	
	        // TODO the bounds have already been calculated this render session so return what we have
	
	        var minX = Infinity;
	        var minY = Infinity;
	
	        var maxX = -Infinity;
	        var maxY = -Infinity;
	
	        var childBounds;
	        var childMaxX;
	        var childMaxY;
	
	        var childVisible = false;
	
	        for (var i = 0, j = this.children.length; i < j; ++i)
	        {
	            var child = this.children[i];
	
	            if (!child.visible)
	            {
	                continue;
	            }
	
	            childVisible = true;
	
	            childBounds = this.children[i].getBounds();
	
	            minX = minX < childBounds.x ? minX : childBounds.x;
	            minY = minY < childBounds.y ? minY : childBounds.y;
	
	            childMaxX = childBounds.width + childBounds.x;
	            childMaxY = childBounds.height + childBounds.y;
	
	            maxX = maxX > childMaxX ? maxX : childMaxX;
	            maxY = maxY > childMaxY ? maxY : childMaxY;
	        }
	
	        if (!childVisible)
	        {
	            return math.Rectangle.EMPTY;
	        }
	
	        var bounds = this._bounds;
	
	        bounds.x = minX;
	        bounds.y = minY;
	        bounds.width = maxX - minX;
	        bounds.height = maxY - minY;
	
	        this._currentBounds = bounds;
	    }
	
	    return this._currentBounds;
	};
	
	Container.prototype.containerGetBounds = Container.prototype.getBounds;
	
	/**
	 * Retrieves the non-global local bounds of the Container as a rectangle.
	 * The calculation takes all visible children into consideration.
	 *
	 * @return {PIXI.Rectangle} The rectangular bounding area
	 */
	Container.prototype.getLocalBounds = function ()
	{
	    var matrixCache = this.worldTransform;
	
	    this.worldTransform = math.Matrix.IDENTITY;
	
	    for (var i = 0, j = this.children.length; i < j; ++i)
	    {
	        this.children[i].updateTransform();
	    }
	
	    this.worldTransform = matrixCache;
	
	    this._currentBounds = null;
	
	    return this.getBounds( math.Matrix.IDENTITY );
	};
	
	/**
	 * Renders the object using the WebGL renderer
	 *
	 * @param renderer {PIXI.WebGLRenderer} The renderer
	 */
	Container.prototype.renderWebGL = function (renderer)
	{
	
	    // if the object is not visible or the alpha is 0 then no need to render this element
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable)
	    {
	        return;
	    }
	
	    var i, j;
	
	    // do a quick check to see if this element has a mask or a filter.
	    if (this._mask || this._filters)
	    {
	        renderer.currentRenderer.flush();
	
	        // push filter first as we need to ensure the stencil buffer is correct for any masking
	        if (this._filters && this._filters.length)
	        {
	            renderer.filterManager.pushFilter(this, this._filters);
	        }
	
	        if (this._mask)
	        {
	            renderer.maskManager.pushMask(this, this._mask);
	        }
	
	        renderer.currentRenderer.start();
	
	        // add this object to the batch, only rendered if it has a texture.
	        this._renderWebGL(renderer);
	
	        // now loop through the children and make sure they get rendered
	        for (i = 0, j = this.children.length; i < j; i++)
	        {
	            this.children[i].renderWebGL(renderer);
	        }
	
	        renderer.currentRenderer.flush();
	
	        if (this._mask)
	        {
	            renderer.maskManager.popMask(this, this._mask);
	        }
	
	        if (this._filters)
	        {
	            renderer.filterManager.popFilter();
	
	        }
	        renderer.currentRenderer.start();
	    }
	    else
	    {
	        this._renderWebGL(renderer);
	
	        // simple render children!
	        for (i = 0, j = this.children.length; i < j; ++i)
	        {
	            this.children[i].renderWebGL(renderer);
	        }
	    }
	};
	
	/**
	 * To be overridden by the subclass
	 *
	 * @param renderer {PIXI.WebGLRenderer} The renderer
	 * @private
	 */
	Container.prototype._renderWebGL = function (renderer) // jshint unused:false
	{
	    // this is where content itself gets rendered...
	};
	
	/**
	 * To be overridden by the subclass
	 *
	 * @param renderer {PIXI.CanvasRenderer} The renderer
	 * @private
	 */
	Container.prototype._renderCanvas = function (renderer) // jshint unused:false
	{
	    // this is where content itself gets rendered...
	};
	
	
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @param renderer {PIXI.CanvasRenderer} The renderer
	 */
	Container.prototype.renderCanvas = function (renderer)
	{
	    // if not visible or the alpha is 0 then no need to render this
	    if (!this.visible || this.alpha <= 0 || !this.renderable)
	    {
	        return;
	    }
	
	    if (this._mask)
	    {
	        renderer.maskManager.pushMask(this._mask, renderer);
	    }
	
	    this._renderCanvas(renderer);
	    for (var i = 0, j = this.children.length; i < j; ++i)
	    {
	        this.children[i].renderCanvas(renderer);
	    }
	
	    if (this._mask)
	    {
	        renderer.maskManager.popMask(renderer);
	    }
	};
	
	/**
	 * Destroys the container
	 * @param [destroyChildren=false] {boolean} if set to true, all the children will have their destroy method called as well
	 */
	Container.prototype.destroy = function (destroyChildren)
	{
	    DisplayObject.prototype.destroy.call(this);
	
	    if (destroyChildren)
	    {
	        for (var i = 0, j = this.children.length; i < j; ++i)
	        {
	            this.children[i].destroy(destroyChildren);
	        }
	    }
	
	    this.removeChildren();
	
	    this.children = null;
	};


/***/ },
/* 37 */
/*!*************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/WebGLRenderer.js ***!
  \*************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var SystemRenderer = __webpack_require__(/*! ../SystemRenderer */ 98),
	    ShaderManager = __webpack_require__(/*! ./managers/ShaderManager */ 103),
	    MaskManager = __webpack_require__(/*! ./managers/MaskManager */ 190),
	    StencilManager = __webpack_require__(/*! ./managers/StencilManager */ 191),
	    FilterManager = __webpack_require__(/*! ./managers/FilterManager */ 102),
	    BlendModeManager = __webpack_require__(/*! ./managers/BlendModeManager */ 189),
	    RenderTarget = __webpack_require__(/*! ./utils/RenderTarget */ 40),
	    ObjectRenderer = __webpack_require__(/*! ./utils/ObjectRenderer */ 29),
	    FXAAFilter = __webpack_require__(/*! ./filters/FXAAFilter */ 100),
	    utils = __webpack_require__(/*! ../../utils */ 7),
	    CONST = __webpack_require__(/*! ../../const */ 6);
	
	/**
	 * The WebGLRenderer draws the scene and all its content onto a webGL enabled canvas. This renderer
	 * should be used for browsers that support webGL. This Render works by automatically managing webGLBatchs.
	 * So no need for Sprite Batches or Sprite Clouds.
	 * Don't forget to add the view to your DOM or you will not see anything :)
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.SystemRenderer
	 * @param [width=0] {number} the width of the canvas view
	 * @param [height=0] {number} the height of the canvas view
	 * @param [options] {object} The optional renderer parameters
	 * @param [options.view] {HTMLCanvasElement} the canvas to use as a view, optional
	 * @param [options.transparent=false] {boolean} If the render view is transparent, default false
	 * @param [options.autoResize=false] {boolean} If the render view is automatically resized, default false
	 * @param [options.antialias=false] {boolean} sets antialias. If not available natively then FXAA antialiasing is used
	 * @param [options.forceFXAA=false] {boolean} forces FXAA antialiasing to be used over native. FXAA is faster, but may not always look as great
	 * @param [options.resolution=1] {number} the resolution of the renderer retina would be 2
	 * @param [options.clearBeforeRender=true] {boolean} This sets if the CanvasRenderer will clear the canvas or
	 *      not before the new render pass. If you wish to set this to false, you *must* set preserveDrawingBuffer to `true`.
	 * @param [options.preserveDrawingBuffer=false] {boolean} enables drawing buffer preservation, enable this if
	 *      you need to call toDataUrl on the webgl context.
	 * @param [options.roundPixels=false] {boolean} If true Pixi will Math.floor() x/y values when rendering, stopping pixel interpolation.
	 */
	function WebGLRenderer(width, height, options)
	{
	    options = options || {};
	
	    SystemRenderer.call(this, 'WebGL', width, height, options);
	
	    /**
	     * The type of this renderer as a standardised const
	     *
	     * @member {number}
	     *
	     */
	    this.type = CONST.RENDERER_TYPE.WEBGL;
	
	    this.handleContextLost = this.handleContextLost.bind(this);
	    this.handleContextRestored = this.handleContextRestored.bind(this);
	
	    this.view.addEventListener('webglcontextlost', this.handleContextLost, false);
	    this.view.addEventListener('webglcontextrestored', this.handleContextRestored, false);
	
	    //TODO possibility to force FXAA as it may offer better performance?
	    /**
	     * Does it use FXAA ?
	     *
	     * @member {boolean}
	     * @private
	     */
	    this._useFXAA = !!options.forceFXAA && options.antialias;
	
	    /**
	     * The fxaa filter
	     *
	     * @member {PIXI.FXAAFilter}
	     * @private
	     */
	    this._FXAAFilter = null;
	
	    /**
	     * The options passed in to create a new webgl context.
	     *
	     * @member {object}
	     * @private
	     */
	    this._contextOptions = {
	        alpha: this.transparent,
	        antialias: options.antialias,
	        premultipliedAlpha: this.transparent && this.transparent !== 'notMultiplied',
	        stencil: true,
	        preserveDrawingBuffer: options.preserveDrawingBuffer
	    };
	
	    /**
	     * Counter for the number of draws made each frame
	     *
	     * @member {number}
	     */
	    this.drawCount = 0;
	
	    /**
	     * Deals with managing the shader programs and their attribs.
	     *
	     * @member {PIXI.ShaderManager}
	     */
	    this.shaderManager = new ShaderManager(this);
	
	    /**
	     * Manages the masks using the stencil buffer.
	     *
	     * @member {PIXI.MaskManager}
	     */
	    this.maskManager = new MaskManager(this);
	
	    /**
	     * Manages the stencil buffer.
	     *
	     * @member {PIXI.StencilManager}
	     */
	    this.stencilManager = new StencilManager(this);
	
	    /**
	     * Manages the filters.
	     *
	     * @member {PIXI.FilterManager}
	     */
	    this.filterManager = new FilterManager(this);
	
	
	    /**
	     * Manages the blendModes
	     *
	     * @member {PIXI.BlendModeManager}
	     */
	    this.blendModeManager = new BlendModeManager(this);
	
	    /**
	     * Holds the current render target
	     *
	     * @member {PIXI.RenderTarget}
	     */
	    this.currentRenderTarget = null;
	
	    /**
	     * The currently active ObjectRenderer.
	     *
	     * @member {PIXI.ObjectRenderer}
	     */
	    this.currentRenderer = new ObjectRenderer(this);
	
	    this.initPlugins();
	
	    // initialize the context so it is ready for the managers.
	    this._createContext();
	    this._initContext();
	
	    // map some webGL blend modes..
	    this._mapGlModes();
	
	    // track textures in the renderer so we can no longer listen to them on destruction.
	    this._managedTextures = [];
	
	    /**
	     * An array of render targets
	     * @member {PIXI.RenderTarget[]}
	     * @private
	     */
	    this._renderTargetStack = [];
	}
	
	// constructor
	WebGLRenderer.prototype = Object.create(SystemRenderer.prototype);
	WebGLRenderer.prototype.constructor = WebGLRenderer;
	module.exports = WebGLRenderer;
	utils.pluginTarget.mixin(WebGLRenderer);
	
	WebGLRenderer.glContextId = 0;
	
	/**
	 * Creates the gl context.
	 *
	 * @private
	 */
	WebGLRenderer.prototype._createContext = function () {
	    var gl = this.view.getContext('webgl', this._contextOptions) || this.view.getContext('experimental-webgl', this._contextOptions);
	    this.gl = gl;
	
	    if (!gl)
	    {
	        // fail, not able to get a context
	        throw new Error('This browser does not support webGL. Try using the canvas renderer');
	    }
	
	    this.glContextId = WebGLRenderer.glContextId++;
	    gl.id = this.glContextId;
	    gl.renderer = this;
	};
	
	/**
	 * Creates the WebGL context
	 *
	 * @private
	 */
	WebGLRenderer.prototype._initContext = function ()
	{
	    var gl = this.gl;
	
	    // set up the default pixi settings..
	    gl.disable(gl.DEPTH_TEST);
	    gl.disable(gl.CULL_FACE);
	    gl.enable(gl.BLEND);
	
	    this.renderTarget = new RenderTarget(gl, this.width, this.height, null, this.resolution, true);
	
	    this.setRenderTarget(this.renderTarget);
	
	    this.emit('context', gl);
	
	    // setup the width/height properties and gl viewport
	    this.resize(this.width, this.height);
	
	    if(!this._useFXAA)
	    {
	        this._useFXAA = (this._contextOptions.antialias && ! gl.getContextAttributes().antialias);
	    }
	
	
	    if(this._useFXAA)
	    {
	        window.console.warn('FXAA antialiasing being used instead of native antialiasing');
	        this._FXAAFilter = [new FXAAFilter()];
	    }
	};
	
	/**
	 * Renders the object to its webGL view
	 *
	 * @param object {PIXI.DisplayObject} the object to be rendered
	 */
	WebGLRenderer.prototype.render = function (object)
	{
	
	    this.emit('prerender');
	
	    // no point rendering if our context has been blown up!
	    if (this.gl.isContextLost())
	    {
	        return;
	    }
	
	    this.drawCount = 0;
	
	    this._lastObjectRendered = object;
	
	    if(this._useFXAA)
	    {
	        this._FXAAFilter[0].uniforms.resolution.value.x = this.width;
	        this._FXAAFilter[0].uniforms.resolution.value.y = this.height;
	        object.filterArea = this.renderTarget.size;
	        object.filters = this._FXAAFilter;
	    }
	
	    var cacheParent = object.parent;
	    object.parent = this._tempDisplayObjectParent;
	
	    // update the scene graph
	    object.updateTransform();
	
	    object.parent = cacheParent;
	
	    var gl = this.gl;
	
	    // make sure we are bound to the main frame buffer
	    this.setRenderTarget(this.renderTarget);
	
	    if (this.clearBeforeRender)
	    {
	        if (this.transparent)
	        {
	            gl.clearColor(0, 0, 0, 0);
	        }
	        else
	        {
	            gl.clearColor(this._backgroundColorRgb[0], this._backgroundColorRgb[1], this._backgroundColorRgb[2], 1);
	        }
	
	        gl.clear(gl.COLOR_BUFFER_BIT);
	    }
	
	    this.renderDisplayObject(object, this.renderTarget);//this.projection);
	
	    this.emit('postrender');
	};
	
	/**
	 * Renders a Display Object.
	 *
	 * @param displayObject {PIXI.DisplayObject} The DisplayObject to render
	 * @param renderTarget {PIXI.RenderTarget} The render target to use to render this display object
	 *
	 */
	WebGLRenderer.prototype.renderDisplayObject = function (displayObject, renderTarget, clear)//projection, buffer)
	{
	    // TODO is this needed...
	    //this.blendModeManager.setBlendMode(CONST.BLEND_MODES.NORMAL);
	    this.setRenderTarget(renderTarget);
	
	    if(clear)
	    {
	        renderTarget.clear();
	    }
	
	    // start the filter manager
	    this.filterManager.setFilterStack( renderTarget.filterStack );
	
	    // render the scene!
	    displayObject.renderWebGL(this);
	
	    // finish the current renderer..
	    this.currentRenderer.flush();
	};
	
	/**
	 * Changes the current renderer to the one given in parameter
	 *
	 * @param objectRenderer {PIXI.ObjectRenderer} The object renderer to use.
	 */
	WebGLRenderer.prototype.setObjectRenderer = function (objectRenderer)
	{
	    if (this.currentRenderer === objectRenderer)
	    {
	        return;
	    }
	
	    this.currentRenderer.stop();
	    this.currentRenderer = objectRenderer;
	    this.currentRenderer.start();
	};
	
	/**
	 * Changes the current render target to the one given in parameter
	 *
	 * @param renderTarget {PIXI.RenderTarget} the new render target
	 */
	WebGLRenderer.prototype.setRenderTarget = function (renderTarget)
	{
	    if( this.currentRenderTarget === renderTarget)
	    {
	        return;
	    }
	    // TODO - maybe down the line this should be a push pos thing? Leaving for now though.
	    this.currentRenderTarget = renderTarget;
	    this.currentRenderTarget.activate();
	    this.stencilManager.setMaskStack( renderTarget.stencilMaskStack );
	};
	
	
	/**
	 * Resizes the webGL view to the specified width and height.
	 *
	 * @param width {number} the new width of the webGL view
	 * @param height {number} the new height of the webGL view
	 */
	WebGLRenderer.prototype.resize = function (width, height)
	{
	    SystemRenderer.prototype.resize.call(this, width, height);
	
	    this.filterManager.resize(width, height);
	    this.renderTarget.resize(width, height);
	
	    if(this.currentRenderTarget === this.renderTarget)
	    {
	        this.renderTarget.activate();
	        this.gl.viewport(0, 0, this.width, this.height);
	    }
	};
	
	/**
	 * Updates and/or Creates a WebGL texture for the renderer's context.
	 *
	 * @param texture {PIXI.BaseTexture|PIXI.Texture} the texture to update
	 */
	WebGLRenderer.prototype.updateTexture = function (texture)
	{
	    texture = texture.baseTexture || texture;
	
	    if (!texture.hasLoaded)
	    {
	        return;
	    }
	
	    var gl = this.gl;
	
	    if (!texture._glTextures[gl.id])
	    {
	        texture._glTextures[gl.id] = gl.createTexture();
	        texture.on('update', this.updateTexture, this);
	        texture.on('dispose', this.destroyTexture, this);
	        this._managedTextures.push(texture);
	    }
	
	
	    gl.bindTexture(gl.TEXTURE_2D, texture._glTextures[gl.id]);
	
	    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultipliedAlpha);
	    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, texture.source);
	
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, texture.scaleMode === CONST.SCALE_MODES.LINEAR ? gl.LINEAR : gl.NEAREST);
	
	
	    if (texture.mipmap && texture.isPowerOfTwo)
	    {
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, texture.scaleMode === CONST.SCALE_MODES.LINEAR ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
	        gl.generateMipmap(gl.TEXTURE_2D);
	    }
	    else
	    {
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, texture.scaleMode === CONST.SCALE_MODES.LINEAR ? gl.LINEAR : gl.NEAREST);
	    }
	
	    if (!texture.isPowerOfTwo)
	    {
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	    }
	    else
	    {
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
	    }
	
	    return  texture._glTextures[gl.id];
	};
	
	/**
	 * Deletes the texture from WebGL
	 *
	 * @param texture {PIXI.BaseTexture|PIXI.Texture} the texture to destroy
	 */
	WebGLRenderer.prototype.destroyTexture = function (texture, _skipRemove)
	{
	    texture = texture.baseTexture || texture;
	
	    if (!texture.hasLoaded)
	    {
	        return;
	    }
	
	    if (texture._glTextures[this.gl.id])
	    {
	        this.gl.deleteTexture(texture._glTextures[this.gl.id]);
	        delete texture._glTextures[this.gl.id];
	
	        if (!_skipRemove)
	        {
	            var i = this._managedTextures.indexOf(texture);
	            if (i !== -1) {
	                utils.removeItems(this._managedTextures, i, 1);
	            }
	        }
	    }
	};
	
	/**
	 * Handles a lost webgl context
	 *
	 * @private
	 */
	WebGLRenderer.prototype.handleContextLost = function (event)
	{
	    event.preventDefault();
	};
	
	/**
	 * Handles a restored webgl context
	 *
	 * @private
	 */
	WebGLRenderer.prototype.handleContextRestored = function ()
	{
	    this._initContext();
	
	    // empty all the old gl textures as they are useless now
	    for (var i = 0; i < this._managedTextures.length; ++i)
	    {
	        var texture = this._managedTextures[i];
	        if (texture._glTextures[this.gl.id])
	        {
	            delete texture._glTextures[this.gl.id];
	        }
	    }
	};
	
	/**
	 * Removes everything from the renderer (event listeners, spritebatch, etc...)
	 *
	 * @param [removeView=false] {boolean} Removes the Canvas element from the DOM.
	 */
	WebGLRenderer.prototype.destroy = function (removeView)
	{
	    this.destroyPlugins();
	
	    // remove listeners
	    this.view.removeEventListener('webglcontextlost', this.handleContextLost);
	    this.view.removeEventListener('webglcontextrestored', this.handleContextRestored);
	
	    // destroy managed textures
	    for (var i = 0; i < this._managedTextures.length; ++i)
	    {
	        var texture = this._managedTextures[i];
	        this.destroyTexture(texture, true);
	        texture.off('update', this.updateTexture, this);
	        texture.off('dispose', this.destroyTexture, this);
	    }
	
	    // call base destroy
	    SystemRenderer.prototype.destroy.call(this, removeView);
	
	    this.uid = 0;
	
	    // destroy the managers
	    this.shaderManager.destroy();
	    this.maskManager.destroy();
	    this.stencilManager.destroy();
	    this.filterManager.destroy();
	    this.blendModeManager.destroy();
	
	    this.shaderManager = null;
	    this.maskManager = null;
	    this.filterManager = null;
	    this.blendModeManager = null;
	    this.currentRenderer = null;
	
	    this.handleContextLost = null;
	    this.handleContextRestored = null;
	
	    this._contextOptions = null;
	
	    this._managedTextures = null;
	
	    this.drawCount = 0;
	
	    this.gl.useProgram(null);
	
	    this.gl.flush();
	
	    this.gl = null;
	};
	
	/**
	 * Maps Pixi blend modes to WebGL blend modes. It works only for pre-multiplied textures.
	 *
	 * @private
	 */
	WebGLRenderer.prototype._mapGlModes = function ()
	{
	    var gl = this.gl;
	
	    if (!this.blendModes)
	    {
	        this.blendModes = {};
	
	        this.blendModes[CONST.BLEND_MODES.NORMAL]        = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.ADD]           = [gl.ONE,       gl.DST_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.MULTIPLY]      = [gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.SCREEN]        = [gl.ONE,       gl.ONE_MINUS_SRC_COLOR];
	        this.blendModes[CONST.BLEND_MODES.OVERLAY]       = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.DARKEN]        = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.LIGHTEN]       = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.COLOR_DODGE]   = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.COLOR_BURN]    = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.HARD_LIGHT]    = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.SOFT_LIGHT]    = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.DIFFERENCE]    = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.EXCLUSION]     = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.HUE]           = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.SATURATION]    = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.COLOR]         = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	        this.blendModes[CONST.BLEND_MODES.LUMINOSITY]    = [gl.ONE,       gl.ONE_MINUS_SRC_ALPHA];
	    }
	
	    if (!this.drawModes)
	    {
	        this.drawModes = {};
	
	        this.drawModes[CONST.DRAW_MODES.POINTS]         = gl.POINTS;
	        this.drawModes[CONST.DRAW_MODES.LINES]          = gl.LINES;
	        this.drawModes[CONST.DRAW_MODES.LINE_LOOP]      = gl.LINE_LOOP;
	        this.drawModes[CONST.DRAW_MODES.LINE_STRIP]     = gl.LINE_STRIP;
	        this.drawModes[CONST.DRAW_MODES.TRIANGLES]      = gl.TRIANGLES;
	        this.drawModes[CONST.DRAW_MODES.TRIANGLE_STRIP] = gl.TRIANGLE_STRIP;
	        this.drawModes[CONST.DRAW_MODES.TRIANGLE_FAN]   = gl.TRIANGLE_FAN;
	    }
	};


/***/ },
/* 38 */
/*!**************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/shaders/Shader.js ***!
  \**************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/*global console */
	var utils = __webpack_require__(/*! ../../../utils */ 7);
	
	/**
	 * Base shader class for PIXI managed shaders.
	 *
	 * @class
	 * @memberof PIXI
	 * @param shaderManager {PIXI.ShaderManager} The webgl shader manager this shader works for.
	 * @param [vertexSrc] {string} The source of the vertex shader.
	 * @param [fragmentSrc] {string} The source of the fragment shader.
	 * @param [uniforms] {object} Uniforms for this shader.
	 * @param [attributes] {object} Attributes for this shader.
	 */
	function Shader(shaderManager, vertexSrc, fragmentSrc, uniforms, attributes)
	{
	    if (!vertexSrc || !fragmentSrc)
	    {
	         throw new Error('Pixi.js Error. Shader requires vertexSrc and fragmentSrc');
	    }
	
	    /**
	     * A unique id
	     * @member {number}
	     * @readonly
	     */
	    this.uid = utils.uid();
	
	    /**
	     * The current WebGL drawing context
	     * @member {WebGLRenderingContext}
	     * @readonly
	     */
	    this.gl = shaderManager.renderer.gl;
	
	    //TODO maybe we should pass renderer rather than shader manger?? food for thought..
	    this.shaderManager = shaderManager;
	
	    /**
	     * The WebGL program.
	     *
	     * @member {WebGLProgram}
	     * @readonly
	     */
	    this.program = null;
	
	    /**
	     * The uniforms as an object
	     * @member {object}
	     * @private
	     */
	    this.uniforms = uniforms || {};
	
	    /**
	     * The attributes as an object
	     * @member {object}
	     * @private
	     */
	    this.attributes = attributes || {};
	
	    /**
	     * Internal texture counter
	     * @member {number}
	     * @private
	     */
	    this.textureCount = 1;
	
	    /**
	     * The vertex shader as an array of strings
	     *
	     * @member {string}
	     */
	    this.vertexSrc = vertexSrc;
	
	    /**
	     * The fragment shader as an array of strings
	     *
	     * @member {string}
	     */
	    this.fragmentSrc = fragmentSrc;
	
	    this.init();
	}
	
	Shader.prototype.constructor = Shader;
	module.exports = Shader;
	
	/**
	 * Creates the shader and uses it
	 *
	 */
	Shader.prototype.init = function ()
	{
	    this.compile();
	
	    this.gl.useProgram(this.program);
	
	    this.cacheUniformLocations(Object.keys(this.uniforms));
	    this.cacheAttributeLocations(Object.keys(this.attributes));
	};
	
	/**
	 * Caches the locations of the uniform for reuse.
	 *
	 * @param keys {string} the uniforms to cache
	 */
	Shader.prototype.cacheUniformLocations = function (keys)
	{
	    for (var i = 0; i < keys.length; ++i)
	    {
	        this.uniforms[keys[i]]._location = this.gl.getUniformLocation(this.program, keys[i]);
	    }
	};
	
	/**
	 * Caches the locations of the attribute for reuse.
	 *
	 * @param keys {string} the attributes to cache
	 */
	Shader.prototype.cacheAttributeLocations = function (keys)
	{
	    for (var i = 0; i < keys.length; ++i)
	    {
	        this.attributes[keys[i]] = this.gl.getAttribLocation(this.program, keys[i]);
	    }
	
	    // TODO: Check if this is needed anymore...
	
	    // Begin worst hack eva //
	
	    // WHY??? ONLY on my chrome pixel the line above returns -1 when using filters?
	    // maybe its something to do with the current state of the gl context.
	    // I'm convinced this is a bug in the chrome browser as there is NO reason why this should be returning -1 especially as it only manifests on my chrome pixel
	    // If theres any webGL people that know why could happen please help :)
	    // if (this.attributes.aColor === -1){
	    //     this.attributes.aColor = 2;
	    // }
	
	    // End worst hack eva //
	};
	
	/**
	 * Attaches the shaders and creates the program.
	 *
	 * @return {WebGLProgram}
	 */
	Shader.prototype.compile = function ()
	{
	    var gl = this.gl;
	
	    var glVertShader = this._glCompile(gl.VERTEX_SHADER, this.vertexSrc);
	    var glFragShader = this._glCompile(gl.FRAGMENT_SHADER, this.fragmentSrc);
	
	    var program = gl.createProgram();
	
	    gl.attachShader(program, glVertShader);
	    gl.attachShader(program, glFragShader);
	    gl.linkProgram(program);
	
	    // if linking fails, then log and cleanup
	    if (!gl.getProgramParameter(program, gl.LINK_STATUS))
	    {
	        console.error('Pixi.js Error: Could not initialize shader.');
	        console.error('gl.VALIDATE_STATUS', gl.getProgramParameter(program, gl.VALIDATE_STATUS));
	        console.error('gl.getError()', gl.getError());
	
	        // if there is a program info log, log it
	        if (gl.getProgramInfoLog(program) !== '')
	        {
	            console.warn('Pixi.js Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
	        }
	
	        gl.deleteProgram(program);
	        program = null;
	    }
	
	    // clean up some shaders
	    gl.deleteShader(glVertShader);
	    gl.deleteShader(glFragShader);
	
	    return (this.program = program);
	};
	
	/*
	Shader.prototype.buildSync = function ()
	{
	   // var str = ""
	
	   // str =  "Shader.prototype.syncUniforms = function()";
	   // str += "{\n";
	
	    for (var key in this.uniforms)
	    {
	        var uniform = this.uniforms[key];
	
	        Object.defineProperty(this, key, {
	
	            get: function ()
	            {
	                return uniform.value
	            },
	            set: function (value)
	            {
	                this.setUniform(uniform, value);
	            }
	        });
	
	        console.log( makePropSetter( key, " bloop", uniform.type )  )
	  //      Object.def
	        //    location = uniform._location,
	          //  value = uniform.value,
	            //i, il;
	
	    //    str += "gl.uniform1i(this.uniforms."+ key +"._location, this.uniforms." + key + ".value );\n"
	
	    }
	
	}*/
	
	/**
	* Adds a new uniform
	*
	* @param uniform {object} the new uniform to attach
	*/
	Shader.prototype.syncUniform = function (uniform)
	{
	    var location = uniform._location,
	        value = uniform.value,
	        gl = this.gl,
	        i, il;
	
	    switch (uniform.type)
	    {
	        case 'b':
	        case 'bool':
	        case 'boolean':
	            gl.uniform1i(location, value ? 1 : 0);
	            break;
	
	        // single int value
	        case 'i':
	        case '1i':
	            gl.uniform1i(location, value);
	            break;
	
	        // single float value
	        case 'f':
	        case '1f':
	            gl.uniform1f(location, value);
	            break;
	
	        // Float32Array(2) or JS Arrray
	        case '2f':
	            gl.uniform2f(location, value[0], value[1]);
	            break;
	
	        // Float32Array(3) or JS Arrray
	        case '3f':
	            gl.uniform3f(location, value[0], value[1], value[2]);
	            break;
	
	        // Float32Array(4) or JS Arrray
	        case '4f':
	            gl.uniform4f(location, value[0], value[1], value[2], value[3]);
	            break;
	
	        // a 2D Point object
	        case 'v2':
	            gl.uniform2f(location, value.x, value.y);
	            break;
	
	        // a 3D Point object
	        case 'v3':
	            gl.uniform3f(location, value.x, value.y, value.z);
	            break;
	
	        // a 4D Point object
	        case 'v4':
	            gl.uniform4f(location, value.x, value.y, value.z, value.w);
	            break;
	
	        // Int32Array or JS Array
	        case '1iv':
	            gl.uniform1iv(location, value);
	            break;
	
	        // Int32Array or JS Array
	        case '2iv':
	            gl.uniform2iv(location, value);
	            break;
	
	        // Int32Array or JS Array
	        case '3iv':
	            gl.uniform3iv(location, value);
	            break;
	
	        // Int32Array or JS Array
	        case '4iv':
	            gl.uniform4iv(location, value);
	            break;
	
	        // Float32Array or JS Array
	        case '1fv':
	            gl.uniform1fv(location, value);
	            break;
	
	        // Float32Array or JS Array
	        case '2fv':
	            gl.uniform2fv(location, value);
	            break;
	
	        // Float32Array or JS Array
	        case '3fv':
	            gl.uniform3fv(location, value);
	            break;
	
	        // Float32Array or JS Array
	        case '4fv':
	            gl.uniform4fv(location, value);
	            break;
	
	        // Float32Array or JS Array
	        case 'm2':
	        case 'mat2':
	        case 'Matrix2fv':
	            gl.uniformMatrix2fv(location, uniform.transpose, value);
	            break;
	
	        // Float32Array or JS Array
	        case 'm3':
	        case 'mat3':
	        case 'Matrix3fv':
	
	            gl.uniformMatrix3fv(location, uniform.transpose, value);
	            break;
	
	        // Float32Array or JS Array
	        case 'm4':
	        case 'mat4':
	        case 'Matrix4fv':
	            gl.uniformMatrix4fv(location, uniform.transpose, value);
	            break;
	
	        // a Color Value
	        case 'c':
	            if (typeof value === 'number')
	            {
	                value = utils.hex2rgb(value);
	            }
	
	            gl.uniform3f(location, value[0], value[1], value[2]);
	            break;
	
	        // flat array of integers (JS or typed array)
	        case 'iv1':
	            gl.uniform1iv(location, value);
	            break;
	
	        // flat array of integers with 3 x N size (JS or typed array)
	        case 'iv':
	            gl.uniform3iv(location, value);
	            break;
	
	        // flat array of floats (JS or typed array)
	        case 'fv1':
	            gl.uniform1fv(location, value);
	            break;
	
	        // flat array of floats with 3 x N size (JS or typed array)
	        case 'fv':
	            gl.uniform3fv(location, value);
	            break;
	
	        // array of 2D Point objects
	        case 'v2v':
	            if (!uniform._array)
	            {
	                uniform._array = new Float32Array(2 * value.length);
	            }
	
	            for (i = 0, il = value.length; i < il; ++i)
	            {
	                uniform._array[i * 2]       = value[i].x;
	                uniform._array[i * 2 + 1]   = value[i].y;
	            }
	
	            gl.uniform2fv(location, uniform._array);
	            break;
	
	        // array of 3D Point objects
	        case 'v3v':
	            if (!uniform._array)
	            {
	                uniform._array = new Float32Array(3 * value.length);
	            }
	
	            for (i = 0, il = value.length; i < il; ++i)
	            {
	                uniform._array[i * 3]       = value[i].x;
	                uniform._array[i * 3 + 1]   = value[i].y;
	                uniform._array[i * 3 + 2]   = value[i].z;
	
	            }
	
	            gl.uniform3fv(location, uniform._array);
	            break;
	
	        // array of 4D Point objects
	        case 'v4v':
	            if (!uniform._array)
	            {
	                uniform._array = new Float32Array(4 * value.length);
	            }
	
	            for (i = 0, il = value.length; i < il; ++i)
	            {
	                uniform._array[i * 4]       = value[i].x;
	                uniform._array[i * 4 + 1]   = value[i].y;
	                uniform._array[i * 4 + 2]   = value[i].z;
	                uniform._array[i * 4 + 3]   = value[i].w;
	
	            }
	
	            gl.uniform4fv(location, uniform._array);
	            break;
	
	        // PIXI.Texture
	        case 't':
	        case 'sampler2D':
	
	            if (!uniform.value || !uniform.value.baseTexture.hasLoaded)
	            {
	                break;
	            }
	
	            // activate this texture
	            gl.activeTexture(gl['TEXTURE' + this.textureCount]);
	
	            var texture = uniform.value.baseTexture._glTextures[gl.id];
	
	            if (!texture)
	            {
	                this.initSampler2D(uniform);
	
	                // set the textur to the newly created one..
	                texture = uniform.value.baseTexture._glTextures[gl.id];
	            }
	
	            // bind the texture
	            gl.bindTexture(gl.TEXTURE_2D, texture);
	
	            // set uniform to texture index
	            gl.uniform1i(uniform._location, this.textureCount);
	
	            // increment next texture id
	            this.textureCount++;
	
	            break;
	
	        default:
	            console.warn('Pixi.js Shader Warning: Unknown uniform type: ' + uniform.type);
	    }
	};
	
	/**
	 * Updates the shader uniform values.
	 *
	 */
	Shader.prototype.syncUniforms = function ()
	{
	    this.textureCount = 1;
	
	    for (var key in this.uniforms)
	    {
	        this.syncUniform(this.uniforms[key]);
	    }
	};
	
	
	/**
	 * Initialises a Sampler2D uniform (which may only be available later on after initUniforms once the texture has loaded)
	 *
	 */
	Shader.prototype.initSampler2D = function (uniform)
	{
	    var gl = this.gl;
	
	    var texture = uniform.value.baseTexture;
	
	    if(!texture.hasLoaded)
	    {
	        return;
	    }
	
	
	
	    if (uniform.textureData)
	    {
	
	        //TODO move this...
	        var data = uniform.textureData;
	
	        texture._glTextures[gl.id] = gl.createTexture();
	
	        gl.bindTexture(gl.TEXTURE_2D, texture._glTextures[gl.id]);
	
	        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultipliedAlpha);
	        // GLTexture = mag linear, min linear_mipmap_linear, wrap repeat + gl.generateMipmap(gl.TEXTURE_2D);
	        // GLTextureLinear = mag/min linear, wrap clamp
	        // GLTextureNearestRepeat = mag/min NEAREST, wrap repeat
	        // GLTextureNearest = mag/min nearest, wrap clamp
	        // AudioTexture = whatever + luminance + width 512, height 2, border 0
	        // KeyTexture = whatever + luminance + width 256, height 2, border 0
	
	        //  magFilter can be: gl.LINEAR, gl.LINEAR_MIPMAP_LINEAR or gl.NEAREST
	        //  wrapS/T can be: gl.CLAMP_TO_EDGE or gl.REPEAT
	
	        gl.texImage2D(gl.TEXTURE_2D, 0, data.luminance ? gl.LUMINANCE : gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, texture.source);
	
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, data.magFilter ? data.magFilter : gl.LINEAR );
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, data.wrapS ? data.wrapS : gl.CLAMP_TO_EDGE );
	
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, data.wrapS ? data.wrapS : gl.CLAMP_TO_EDGE);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, data.wrapT ? data.wrapT : gl.CLAMP_TO_EDGE);
	    }
	    else
	    {
	        this.shaderManager.renderer.updateTexture(texture);
	    }
	};
	
	/**
	 * Destroys the shader.
	 *
	 */
	Shader.prototype.destroy = function ()
	{
	    this.gl.deleteProgram(this.program);
	
	    this.gl = null;
	    this.uniforms = null;
	    this.attributes = null;
	
	    this.vertexSrc = null;
	    this.fragmentSrc = null;
	};
	
	Shader.prototype._glCompile = function (type, src)
	{
	    var shader = this.gl.createShader(type);
	
	    this.gl.shaderSource(shader, src);
	    this.gl.compileShader(shader);
	
	    if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS))
	    {
	        console.log(this.gl.getShaderInfoLog(shader));
	        return null;
	    }
	
	    return shader;
	};


/***/ },
/* 39 */
/*!*********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/shaders/TextureShader.js ***!
  \*********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Shader = __webpack_require__(/*! ./Shader */ 38);
	
	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 * @param shaderManager {PIXI.ShaderManager} The webgl shader manager this shader works for.
	 * @param [vertexSrc] {string} The source of the vertex shader.
	 * @param [fragmentSrc] {string} The source of the fragment shader.
	 * @param [customUniforms] {object} Custom uniforms to use to augment the built-in ones.
	 * @param [fragmentSrc] {string} The source of the fragment shader.
	 */
	function TextureShader(shaderManager, vertexSrc, fragmentSrc, customUniforms, customAttributes)
	{
	    var uniforms = {
	
	        uSampler:           { type: 'sampler2D', value: 0 },
	        projectionMatrix:   { type: 'mat3', value: new Float32Array([1, 0, 0,
	                                                                     0, 1, 0,
	                                                                     0, 0, 1]) }
	    };
	
	    if (customUniforms)
	    {
	        for (var u in customUniforms)
	        {
	            uniforms[u] = customUniforms[u];
	        }
	    }
	
	
	    var attributes = {
	        aVertexPosition:    0,
	        aTextureCoord:      0,
	        aColor:             0
	    };
	
	    if (customAttributes)
	    {
	        for (var a in customAttributes)
	        {
	            attributes[a] = customAttributes[a];
	        }
	    }
	
	    /**
	     * The vertex shader.
	     *
	     * @member {string}
	     */
	    vertexSrc = vertexSrc || TextureShader.defaultVertexSrc;
	
	    /**
	     * The fragment shader.
	     *
	     * @member {string}
	     */
	    fragmentSrc = fragmentSrc || TextureShader.defaultFragmentSrc;
	
	    Shader.call(this, shaderManager, vertexSrc, fragmentSrc, uniforms, attributes);
	}
	
	// constructor
	TextureShader.prototype = Object.create(Shader.prototype);
	TextureShader.prototype.constructor = TextureShader;
	module.exports = TextureShader;
	
	/**
	 * The default vertex shader source
	 *
	 * @static
	 * @constant
	 */
	TextureShader.defaultVertexSrc = [
	    'precision lowp float;',
	    'attribute vec2 aVertexPosition;',
	    'attribute vec2 aTextureCoord;',
	    'attribute vec4 aColor;',
	
	    'uniform mat3 projectionMatrix;',
	
	    'varying vec2 vTextureCoord;',
	    'varying vec4 vColor;',
	
	    'void main(void){',
	    '   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);',
	    '   vTextureCoord = aTextureCoord;',
	    '   vColor = vec4(aColor.rgb * aColor.a, aColor.a);',
	    '}'
	].join('\n');
	
	/**
	 * The default fragment shader source
	 *
	 * @static
	 * @constant
	 */
	TextureShader.defaultFragmentSrc = [
	    'precision lowp float;',
	
	    'varying vec2 vTextureCoord;',
	    'varying vec4 vColor;',
	
	    'uniform sampler2D uSampler;',
	
	    'void main(void){',
	    '   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor ;',
	    '}'
	].join('\n');


/***/ },
/* 40 */
/*!******************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/utils/RenderTarget.js ***!
  \******************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var math = __webpack_require__(/*! ../../../math */ 9),
	    utils = __webpack_require__(/*! ../../../utils */ 7),
	    CONST = __webpack_require__(/*! ../../../const */ 6),
	    //StencilManager = require('../managers/StencilManager'),
	    StencilMaskStack = __webpack_require__(/*! ./StencilMaskStack */ 193);
	
	/**
	 * @author Mat Groves http://matgroves.com/ @Doormat23
	 */
	
	/**
	 * @class
	 * @memberof PIXI
	 * @param gl {WebGLRenderingContext} the current WebGL drawing context
	 * @param width {number} the horizontal range of the filter
	 * @param height {number} the vertical range of the filter
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @param resolution {number} the current resolution
	 * @param root {boolean} Whether this object is the root element or not
	 */
	var RenderTarget = function(gl, width, height, scaleMode, resolution, root)
	{
	    //TODO Resolution could go here ( eg low res blurs )
	
	    /**
	     * The current WebGL drawing context.
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    // next time to create a frame buffer and texture
	
	    /**
	     * A frame buffer
	     *
	     * @member {WebGLFrameBuffer}
	     */
	    this.frameBuffer = null;
	
	    /**
	     * The texture
	     *
	     * @member {PIXI.Texture}
	     */
	    this.texture = null;
	
	    /**
	     * The size of the object as a rectangle
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.size = new math.Rectangle(0, 0, 1, 1);
	
	    /**
	     * The current resolution
	     *
	     * @member {number}
	     */
	    this.resolution = resolution || CONST.RESOLUTION;
	
	    /**
	     * The projection matrix
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.projectionMatrix = new math.Matrix();
	
	    /**
	     * The object's transform
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.transform = null;
	
	    /**
	     * The frame.
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.frame = null;
	
	    /**
	     * The stencil buffer stores masking data for the render target
	     *
	     * @member {WebGLRenderBuffer}
	     */
	    this.stencilBuffer = null;
	
	    /**
	     * The data structure for the stencil masks
	     *
	     * @member {PIXI.StencilMaskStack}
	     */
	    this.stencilMaskStack = new StencilMaskStack();
	
	    /**
	     * Stores filter data for the render target
	     *
	     * @member {object[]}
	     */
	    this.filterStack = [
	        {
	            renderTarget:this,
	            filter:[],
	            bounds:this.size
	        }
	    ];
	
	
	    /**
	     * The scale mode.
	     *
	     * @member {number}
	     * @default PIXI.SCALE_MODES.DEFAULT
	     * @see PIXI.SCALE_MODES
	     */
	    this.scaleMode = scaleMode || CONST.SCALE_MODES.DEFAULT;
	
	    /**
	     * Whether this object is the root element or not
	     *
	     * @member {boolean}
	     */
	    this.root = root;
	
	    if (!this.root)
	    {
	       // this.flipY = true;
	        this.frameBuffer = gl.createFramebuffer();
	
	        /*
	            A frame buffer needs a target to render to..
	            create a texture and bind it attach it to the framebuffer..
	         */
	
	        this.texture = gl.createTexture();
	
	        gl.bindTexture(gl.TEXTURE_2D,  this.texture);
	
	        // set the scale properties of the texture..
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, scaleMode === CONST.SCALE_MODES.LINEAR ? gl.LINEAR : gl.NEAREST);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, scaleMode === CONST.SCALE_MODES.LINEAR ? gl.LINEAR : gl.NEAREST);
	
	        // check to see if the texture is a power of two!
	        var isPowerOfTwo = utils.isPowerOfTwo(width, height);
	
	        //TODO for 99% of use cases if a texture is power of two we should tile the texture...
	         if (!isPowerOfTwo)
	        {
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	        }
	        else
	        {
	
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
	        }
	
	        gl.bindFramebuffer(gl.FRAMEBUFFER, this.frameBuffer );
	        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture, 0);
	    }
	
	    this.resize(width, height);
	};
	
	RenderTarget.prototype.constructor = RenderTarget;
	module.exports = RenderTarget;
	
	/**
	 * Clears the filter texture.
	 *
	 * @param [bind=false] {boolean} Should we bind our framebuffer before clearing?
	 */
	RenderTarget.prototype.clear = function(bind)
	{
	    var gl = this.gl;
	    if(bind)
	    {
	        gl.bindFramebuffer(gl.FRAMEBUFFER, this.frameBuffer);
	    }
	
	    gl.clearColor(0,0,0,0);
	    gl.clear(gl.COLOR_BUFFER_BIT);
	};
	
	/**
	 * Binds the stencil buffer.
	 *
	 */
	RenderTarget.prototype.attachStencilBuffer = function()
	{
	
	    if (this.stencilBuffer)
	    {
	        return;
	    }
	
	    /**
	     * The stencil buffer is used for masking in pixi
	     * lets create one and then add attach it to the framebuffer..
	     */
	    if (!this.root)
	    {
	        var gl = this.gl;
	
	        this.stencilBuffer = gl.createRenderbuffer();
	        gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencilBuffer);
	        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, this.stencilBuffer);
	        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL,  this.size.width * this.resolution  , this.size.height * this.resolution );
	    }
	};
	
	/**
	 * Binds the buffers and initialises the viewport.
	 *
	 */
	RenderTarget.prototype.activate = function()
	{
	    //TOOD refactor usage of frame..
	    var gl = this.gl;
	
	    gl.bindFramebuffer(gl.FRAMEBUFFER, this.frameBuffer);
	
	    var projectionFrame = this.frame || this.size;
	
	    // TODO add a dirty flag to this of a setter for the frame?
	    this.calculateProjection( projectionFrame );
	
	    if(this.transform)
	    {
	        this.projectionMatrix.append(this.transform);
	    }
	
	    gl.viewport(0,0, projectionFrame.width * this.resolution, projectionFrame.height * this.resolution);
	};
	
	/**
	 * Updates the projection matrix based on a projection frame (which is a rectangle)
	 *
	 */
	RenderTarget.prototype.calculateProjection = function (projectionFrame)
	{
	    var pm = this.projectionMatrix;
	
	    pm.identity();
	
	    if (!this.root)
	    {
	        pm.a = 1 / projectionFrame.width*2;
	        pm.d = 1 / projectionFrame.height*2;
	
	        pm.tx = -1 - projectionFrame.x * pm.a;
	        pm.ty = -1 - projectionFrame.y * pm.d;
	    }
	    else
	    {
	        pm.a = 1 / projectionFrame.width*2;
	        pm.d = -1 / projectionFrame.height*2;
	
	        pm.tx = -1 - projectionFrame.x * pm.a;
	        pm.ty = 1 - projectionFrame.y * pm.d;
	    }
	};
	
	
	/**
	 * Resizes the texture to the specified width and height
	 *
	 * @param width {Number} the new width of the texture
	 * @param height {Number} the new height of the texture
	 */
	RenderTarget.prototype.resize = function (width, height)
	{
	    width = width | 0;
	    height = height | 0;
	
	    if (this.size.width === width && this.size.height === height) {
	        return;
	    }
	
	    this.size.width = width;
	    this.size.height = height;
	
	    if (!this.root)
	    {
	        var gl = this.gl;
	
	        gl.bindTexture(gl.TEXTURE_2D,  this.texture);
	
	        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,  width * this.resolution, height * this.resolution , 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	
	        if (this.stencilBuffer )
	        {
	            // update the stencil buffer width and height
	            gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencilBuffer);
	            gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL,  width * this.resolution, height * this.resolution );
	        }
	    }
	
	    var projectionFrame = this.frame || this.size;
	
	    this.calculateProjection( projectionFrame );
	};
	
	/**
	 * Destroys the render target.
	 *
	 */
	RenderTarget.prototype.destroy = function ()
	{
	    var gl = this.gl;
	    gl.deleteRenderbuffer( this.stencilBuffer );
	    gl.deleteFramebuffer( this.frameBuffer );
	    gl.deleteTexture( this.texture );
	
	    this.frameBuffer = null;
	    this.texture = null;
	};


/***/ },
/* 41 */
/*!****************************************************!*\
  !*** ./~/pixi.js/src/core/textures/BaseTexture.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(/*! ../utils */ 7),
	    CONST = __webpack_require__(/*! ../const */ 6),
	    EventEmitter = __webpack_require__(/*! eventemitter3 */ 18);
	
	/**
	 * A texture stores the information that represents an image. All textures have a base texture.
	 *
	 * @class
	 * @memberof PIXI
	 * @param source {Image|Canvas} the source object of the texture.
	 * @param [scaleMode=PIXI.SCALE_MODES.DEFAULT] {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @param resolution {number} the resolution of the texture for devices with different pixel ratios
	 */
	function BaseTexture(source, scaleMode, resolution)
	{
	    EventEmitter.call(this);
	
	    this.uid = utils.uid();
	
	    /**
	     * The Resolution of the texture.
	     *
	     * @member {number}
	     */
	    this.resolution = resolution || 1;
	
	    /**
	     * The width of the base texture set when the image has loaded
	     *
	     * @member {number}
	     * @readOnly
	     */
	    this.width = 100;
	
	    /**
	     * The height of the base texture set when the image has loaded
	     *
	     * @member {number}
	     * @readOnly
	     */
	    this.height = 100;
	
	    // TODO docs
	    // used to store the actual dimensions of the source
	    /**
	     * Used to store the actual width of the source of this texture
	     *
	     * @member {number}
	     * @readOnly
	     */
	    this.realWidth = 100;
	    /**
	     * Used to store the actual height of the source of this texture
	     *
	     * @member {number}
	     * @readOnly
	     */
	    this.realHeight = 100;
	
	    /**
	     * The scale mode to apply when scaling this texture
	     *
	     * @member {number}
	     * @default PIXI.SCALE_MODES.LINEAR
	     * @see PIXI.SCALE_MODES
	     */
	    this.scaleMode = scaleMode || CONST.SCALE_MODES.DEFAULT;
	
	    /**
	     * Set to true once the base texture has successfully loaded.
	     *
	     * This is never true if the underlying source fails to load or has no texture data.
	     *
	     * @member {boolean}
	     * @readOnly
	     */
	    this.hasLoaded = false;
	
	    /**
	     * Set to true if the source is currently loading.
	     *
	     * If an Image source is loading the 'loaded' or 'error' event will be
	     * dispatched when the operation ends. An underyling source that is
	     * immediately-available bypasses loading entirely.
	     *
	     * @member {boolean}
	     * @readonly
	     */
	    this.isLoading = false;
	
	    /**
	     * The image source that is used to create the texture.
	     *
	     * TODO: Make this a setter that calls loadSource();
	     *
	     * @member {Image|Canvas}
	     * @readonly
	     */
	    this.source = null; // set in loadSource, if at all
	
	    /**
	     * Controls if RGB channels should be pre-multiplied by Alpha  (WebGL only)
	     * All blend modes, and shaders written for default value. Change it on your own risk.
	     *
	     * @member {boolean}
	     * @default true
	     */
	    this.premultipliedAlpha = true;
	
	    /**
	     * @member {string}
	     */
	    this.imageUrl = null;
	
	    /**
	     * Wether or not the texture is a power of two, try to use power of two textures as much as you can
	     * @member {boolean}
	     * @private
	     */
	    this.isPowerOfTwo = false;
	
	    // used for webGL
	
	    /**
	     *
	     * Set this to true if a mipmap of this texture needs to be generated. This value needs to be set before the texture is used
	     * Also the texture must be a power of two size to work
	     *
	     * @member {boolean}
	     */
	    this.mipmap = false;
	
	    /**
	     * A map of renderer IDs to webgl textures
	     *
	     * @member {object<number, WebGLTexture>}
	     * @private
	     */
	    this._glTextures = {};
	
	    // if no source passed don't try to load
	    if (source)
	    {
	        this.loadSource(source);
	    }
	
	    /**
	     * Fired when a not-immediately-available source finishes loading.
	     *
	     * @event loaded
	     * @memberof PIXI.BaseTexture#
	     * @protected
	     */
	
	    /**
	     * Fired when a not-immediately-available source fails to load.
	     *
	     * @event error
	     * @memberof PIXI.BaseTexture#
	     * @protected
	     */
	}
	
	BaseTexture.prototype = Object.create(EventEmitter.prototype);
	BaseTexture.prototype.constructor = BaseTexture;
	module.exports = BaseTexture;
	
	/**
	 * Updates the texture on all the webgl renderers, this also assumes the src has changed.
	 *
	 * @fires update
	 */
	BaseTexture.prototype.update = function ()
	{
	    this.realWidth = this.source.naturalWidth || this.source.width;
	    this.realHeight = this.source.naturalHeight || this.source.height;
	
	    this.width = this.realWidth / this.resolution;
	    this.height = this.realHeight / this.resolution;
	
	    this.isPowerOfTwo = utils.isPowerOfTwo(this.realWidth, this.realHeight);
	
	    this.emit('update', this);
	};
	
	/**
	 * Load a source.
	 *
	 * If the source is not-immediately-available, such as an image that needs to be
	 * downloaded, then the 'loaded' or 'error' event will be dispatched in the future
	 * and `hasLoaded` will remain false after this call.
	 *
	 * The logic state after calling `loadSource` directly or indirectly (eg. `fromImage`, `new BaseTexture`) is:
	 *
	 *     if (texture.hasLoaded)
	 {
	 *        // texture ready for use
	 *     } else if (texture.isLoading)
	 {
	 *        // listen to 'loaded' and/or 'error' events on texture
	 *     } else {
	 *        // not loading, not going to load UNLESS the source is reloaded
	 *        // (it may still make sense to listen to the events)
	 *     }
	 *
	 * @protected
	 * @param source {Image|Canvas} the source object of the texture.
	 */
	BaseTexture.prototype.loadSource = function (source)
	{
	    var wasLoading = this.isLoading;
	    this.hasLoaded = false;
	    this.isLoading = false;
	
	    if (wasLoading && this.source)
	    {
	        this.source.onload = null;
	        this.source.onerror = null;
	    }
	
	    this.source = source;
	
	    // Apply source if loaded. Otherwise setup appropriate loading monitors.
	    if ((this.source.complete || this.source.getContext) && this.source.width && this.source.height)
	    {
	        this._sourceLoaded();
	    }
	    else if (!source.getContext)
	    {
	
	        // Image fail / not ready
	        this.isLoading = true;
	
	        var scope = this;
	
	        source.onload = function ()
	        {
	            source.onload = null;
	            source.onerror = null;
	
	            if (!scope.isLoading)
	            {
	                return;
	            }
	
	            scope.isLoading = false;
	            scope._sourceLoaded();
	
	            scope.emit('loaded', scope);
	        };
	
	        source.onerror = function ()
	        {
	            source.onload = null;
	            source.onerror = null;
	
	            if (!scope.isLoading)
	            {
	                return;
	            }
	
	            scope.isLoading = false;
	            scope.emit('error', scope);
	        };
	
	        // Per http://www.w3.org/TR/html5/embedded-content-0.html#the-img-element
	        //   "The value of `complete` can thus change while a script is executing."
	        // So complete needs to be re-checked after the callbacks have been added..
	        // NOTE: complete will be true if the image has no src so best to check if the src is set.
	        if (source.complete && source.src)
	        {
	            this.isLoading = false;
	
	            // ..and if we're complete now, no need for callbacks
	            source.onload = null;
	            source.onerror = null;
	
	            if (source.width && source.height)
	            {
	                this._sourceLoaded();
	
	                // If any previous subscribers possible
	                if (wasLoading)
	                {
	                    this.emit('loaded', this);
	                }
	            }
	            else
	            {
	                // If any previous subscribers possible
	                if (wasLoading)
	                {
	                    this.emit('error', this);
	                }
	            }
	        }
	    }
	};
	
	/**
	 * Used internally to update the width, height, and some other tracking vars once
	 * a source has successfully loaded.
	 *
	 * @private
	 */
	BaseTexture.prototype._sourceLoaded = function ()
	{
	    this.hasLoaded = true;
	    this.update();
	};
	
	/**
	 * Destroys this base texture
	 *
	 */
	BaseTexture.prototype.destroy = function ()
	{
	    if (this.imageUrl)
	    {
	        delete utils.BaseTextureCache[this.imageUrl];
	        delete utils.TextureCache[this.imageUrl];
	
	        this.imageUrl = null;
	
	        if (!navigator.isCocoonJS)
	        {
	            this.source.src = '';
	        }
	    }
	    else if (this.source && this.source._pixiId)
	    {
	        delete utils.BaseTextureCache[this.source._pixiId];
	    }
	
	    this.source = null;
	
	    this.dispose();
	};
	
	/**
	 * Frees the texture from WebGL memory without destroying this texture object.
	 * This means you can still use the texture later which will upload it to GPU
	 * memory again.
	 *
	 */
	BaseTexture.prototype.dispose = function ()
	{
	    this.emit('dispose', this);
	
	    // this should no longer be needed, the renderers should cleanup all the gl textures.
	    // this._glTextures = {};
	};
	
	/**
	 * Changes the source image of the texture.
	 * The original source must be an Image element.
	 *
	 * @param newSrc {string} the path of the image
	 */
	BaseTexture.prototype.updateSourceImage = function (newSrc)
	{
	    this.source.src = newSrc;
	
	    this.loadSource(this.source);
	};
	
	/**
	 * Helper function that creates a base texture from the given image url.
	 * If the image is not in the base texture cache it will be created and loaded.
	 *
	 * @static
	 * @param imageUrl {string} The image url of the texture
	 * @param [crossorigin=(auto)] {boolean} Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
	 * @param [scaleMode=PIXI.SCALE_MODES.DEFAULT] {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @return PIXI.BaseTexture
	 */
	BaseTexture.fromImage = function (imageUrl, crossorigin, scaleMode)
	{
	    var baseTexture = utils.BaseTextureCache[imageUrl];
	
	    if (crossorigin === undefined && imageUrl.indexOf('data:') !== 0)
	    {
	        crossorigin = true;
	    }
	
	    if (!baseTexture)
	    {
	        // new Image() breaks tex loading in some versions of Chrome.
	        // See https://code.google.com/p/chromium/issues/detail?id=238071
	        var image = new Image();//document.createElement('img');
	        if (crossorigin)
	        {
	            image.crossOrigin = '';
	        }
	
	        baseTexture = new BaseTexture(image, scaleMode);
	        baseTexture.imageUrl = imageUrl;
	
	        image.src = imageUrl;
	
	        utils.BaseTextureCache[imageUrl] = baseTexture;
	
	        // if there is an @2x at the end of the url we are going to assume its a highres image
	        baseTexture.resolution = utils.getResolutionOfUrl(imageUrl);
	    }
	
	    return baseTexture;
	};
	
	/**
	 * Helper function that creates a base texture from the given canvas element.
	 *
	 * @static
	 * @param canvas {Canvas} The canvas element source of the texture
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @return PIXI.BaseTexture
	 */
	BaseTexture.fromCanvas = function (canvas, scaleMode)
	{
	    if (!canvas._pixiId)
	    {
	        canvas._pixiId = 'canvas_' + utils.uid();
	    }
	
	    var baseTexture = utils.BaseTextureCache[canvas._pixiId];
	
	    if (!baseTexture)
	    {
	        baseTexture = new BaseTexture(canvas, scaleMode);
	        utils.BaseTextureCache[canvas._pixiId] = baseTexture;
	    }
	
	    return baseTexture;
	};


/***/ },
/* 42 */
/*!***************************************************!*\
  !*** ./~/pixi.js/src/filters/blur/BlurXFilter.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * The BlurXFilter applies a horizontal Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function BlurXFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        fs.readFileSync(__dirname + '/blurX.vert', 'utf8'),
	        // fragment shader
	        fs.readFileSync(__dirname + '/blur.frag', 'utf8'),
	        // set the uniforms
	        {
	            strength: { type: '1f', value: 1 }
	        }
	    );
	
	    /**
	     * Sets the number of passes for blur. More passes means higher quaility bluring.
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.passes = 1;
	
	    this.strength = 4;
	}
	
	BlurXFilter.prototype = Object.create(core.AbstractFilter.prototype);
	BlurXFilter.prototype.constructor = BlurXFilter;
	module.exports = BlurXFilter;
	
	BlurXFilter.prototype.applyFilter = function (renderer, input, output, clear)
	{
	    var shader = this.getShader(renderer);
	
	    this.uniforms.strength.value = this.strength / 4 / this.passes * (input.frame.width / input.size.width);
	
	    if(this.passes === 1)
	    {
	        renderer.filterManager.applyFilter(shader, input, output, clear);
	    }
	    else
	    {
	        var renderTarget = renderer.filterManager.getRenderTarget(true);
	        var flip = input;
	        var flop = renderTarget;
	
	        for(var i = 0; i < this.passes-1; i++)
	        {
	            renderer.filterManager.applyFilter(shader, flip, flop, true);
	
	           var temp = flop;
	           flop = flip;
	           flip = temp;
	        }
	
	        renderer.filterManager.applyFilter(shader, flip, output, clear);
	
	        renderer.filterManager.returnRenderTarget(renderTarget);
	    }
	};
	
	
	Object.defineProperties(BlurXFilter.prototype, {
	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.BlurXFilter#
	     * @default 2
	     */
	    blur: {
	        get: function ()
	        {
	            return  this.strength;
	        },
	        set: function (value)
	        {
	            this.padding =  Math.abs(value) * 0.5;
	            this.strength = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 43 */
/*!************************************!*\
  !*** ./~/pixi.js/src/mesh/Mesh.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1),
	    tempPoint = new core.Point(),
	    tempPolygon = new core.Polygon();
	
	/**
	 * Base mesh class
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.mesh
	 * @param texture {PIXI.Texture} The texture to use
	 * @param [vertices] {Float32Array} if you want to specify the vertices
	 * @param [uvs] {Float32Array} if you want to specify the uvs
	 * @param [indices] {Uint16Array} if you want to specify the indices
	 * @param [drawMode] {number} the drawMode, can be any of the Mesh.DRAW_MODES consts
	 */
	function Mesh(texture, vertices, uvs, indices, drawMode)
	{
	    core.Container.call(this);
	
	    /**
	     * The texture of the Mesh
	     *
	     * @member {PIXI.Texture}
	     * @private
	     */
	    this._texture = null;
	
	    /**
	     * The Uvs of the Mesh
	     *
	     * @member {Float32Array}
	     */
	    this.uvs = uvs || new Float32Array([0, 0,
	        1, 0,
	        1, 1,
	        0, 1]);
	
	    /**
	     * An array of vertices
	     *
	     * @member {Float32Array}
	     */
	    this.vertices = vertices || new Float32Array([0, 0,
	        100, 0,
	        100, 100,
	        0, 100]);
	
	    /*
	     * @member {Uint16Array} An array containing the indices of the vertices
	     */
	    //  TODO auto generate this based on draw mode!
	    this.indices = indices || new Uint16Array([0, 1, 3, 2]);
	
	    /**
	     * Whether the Mesh is dirty or not
	     *
	     * @member {boolean}
	     */
	    this.dirty = true;
	
	    /**
	     * The blend mode to be applied to the sprite. Set to `PIXI.BLEND_MODES.NORMAL` to remove any blend mode.
	     *
	     * @member {number}
	     * @default PIXI.BLEND_MODES.NORMAL
	     * @see PIXI.BLEND_MODES
	     */
	    this.blendMode = core.BLEND_MODES.NORMAL;
	
	    /**
	     * Triangles in canvas mode are automatically antialiased, use this value to force triangles to overlap a bit with each other.
	     *
	     * @member {number}
	     */
	    this.canvasPadding = 0;
	
	    /**
	     * The way the Mesh should be drawn, can be any of the {@link PIXI.mesh.Mesh.DRAW_MODES} consts
	     *
	     * @member {number}
	     * @see PIXI.mesh.Mesh.DRAW_MODES
	     */
	    this.drawMode = drawMode || Mesh.DRAW_MODES.TRIANGLE_MESH;
	
	    // run texture setter;
	    this.texture = texture;
	
	     /**
	     * The default shader that is used if a mesh doesn't have a more specific one.
	     *
	     * @member {PIXI.Shader}
	     */
	    this.shader = null;
	}
	
	// constructor
	Mesh.prototype = Object.create(core.Container.prototype);
	Mesh.prototype.constructor = Mesh;
	module.exports = Mesh;
	
	Object.defineProperties(Mesh.prototype, {
	    /**
	     * The texture that the sprite is using
	     *
	     * @member {PIXI.Texture}
	     * @memberof PIXI.mesh.Mesh#
	     */
	    texture: {
	        get: function ()
	        {
	            return  this._texture;
	        },
	        set: function (value)
	        {
	            if (this._texture === value)
	            {
	                return;
	            }
	
	            this._texture = value;
	
	            if (value)
	            {
	                // wait for the texture to load
	                if (value.baseTexture.hasLoaded)
	                {
	                    this._onTextureUpdate();
	                }
	                else
	                {
	                    value.once('update', this._onTextureUpdate, this);
	                }
	            }
	        }
	    }
	});
	
	/**
	 * Renders the object using the WebGL renderer
	 *
	 * @param renderer {PIXI.WebGLRenderer} a reference to the WebGL renderer
	 * @private
	 */
	Mesh.prototype._renderWebGL = function (renderer)
	{
	    renderer.setObjectRenderer(renderer.plugins.mesh);
	    renderer.plugins.mesh.render(this);
	};
	
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @param renderer {PIXI.CanvasRenderer}
	 * @private
	 */
	Mesh.prototype._renderCanvas = function (renderer)
	{
	    var context = renderer.context;
	
	    var transform = this.worldTransform;
	    var res = renderer.resolution;
	
	    if (renderer.roundPixels)
	    {
	        context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, (transform.tx * res) | 0, (transform.ty * res) | 0);
	    }
	    else
	    {
	        context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
	    }
	
	    if (this.drawMode === Mesh.DRAW_MODES.TRIANGLE_MESH)
	    {
	        this._renderCanvasTriangleMesh(context);
	    }
	    else
	    {
	        this._renderCanvasTriangles(context);
	    }
	};
	
	/**
	 * Draws the object in Triangle Mesh mode using canvas
	 *
	 * @param context {CanvasRenderingContext2D} the current drawing context
	 * @private
	 */
	Mesh.prototype._renderCanvasTriangleMesh = function (context)
	{
	    // draw triangles!!
	    var vertices = this.vertices;
	    var uvs = this.uvs;
	
	    var length = vertices.length / 2;
	    // this.count++;
	
	    for (var i = 0; i < length - 2; i++)
	    {
	        // draw some triangles!
	        var index = i * 2;
	        this._renderCanvasDrawTriangle(context, vertices, uvs, index, (index + 2), (index + 4));
	    }
	};
	
	/**
	 * Draws the object in triangle mode using canvas
	 *
	 * @param context {CanvasRenderingContext2D} the current drawing context
	 * @private
	 */
	Mesh.prototype._renderCanvasTriangles = function (context)
	{
	    // draw triangles!!
	    var vertices = this.vertices;
	    var uvs = this.uvs;
	    var indices = this.indices;
	
	    var length = indices.length;
	    // this.count++;
	
	    for (var i = 0; i < length; i += 3)
	    {
	        // draw some triangles!
	        var index0 = indices[i] * 2, index1 = indices[i + 1] * 2, index2 = indices[i + 2] * 2;
	        this._renderCanvasDrawTriangle(context, vertices, uvs, index0, index1, index2);
	    }
	};
	
	/**
	 * Draws one of the triangles that form this Mesh
	 *
	 * @param context {CanvasRenderingContext2D} the current drawing context
	 * @param vertices {Float32Array} a reference to the vertices of the Mesh
	 * @param uvs {Float32Array} a reference to the uvs of the Mesh
	 * @param index0 {number} the index of the first vertex
	 * @param index1 {number} the index of the second vertex
	 * @param index2 {number} the index of the third vertex
	 * @private
	 */
	Mesh.prototype._renderCanvasDrawTriangle = function (context, vertices, uvs, index0, index1, index2)
	{
	    var base = this._texture.baseTexture;
	    var textureSource = base.source;
	    var textureWidth = base.width;
	    var textureHeight = base.height;
	
	    var x0 = vertices[index0], x1 = vertices[index1], x2 = vertices[index2];
	    var y0 = vertices[index0 + 1], y1 = vertices[index1 + 1], y2 = vertices[index2 + 1];
	
	    var u0 = uvs[index0] * base.width, u1 = uvs[index1] * base.width, u2 = uvs[index2] * base.width;
	    var v0 = uvs[index0 + 1] * base.height, v1 = uvs[index1 + 1] * base.height, v2 = uvs[index2 + 1] * base.height;
	
	    if (this.canvasPadding > 0)
	    {
	        var paddingX = this.canvasPadding / this.worldTransform.a;
	        var paddingY = this.canvasPadding / this.worldTransform.d;
	        var centerX = (x0 + x1 + x2) / 3;
	        var centerY = (y0 + y1 + y2) / 3;
	
	        var normX = x0 - centerX;
	        var normY = y0 - centerY;
	
	        var dist = Math.sqrt(normX * normX + normY * normY);
	        x0 = centerX + (normX / dist) * (dist + paddingX);
	        y0 = centerY + (normY / dist) * (dist + paddingY);
	
	        //
	
	        normX = x1 - centerX;
	        normY = y1 - centerY;
	
	        dist = Math.sqrt(normX * normX + normY * normY);
	        x1 = centerX + (normX / dist) * (dist + paddingX);
	        y1 = centerY + (normY / dist) * (dist + paddingY);
	
	        normX = x2 - centerX;
	        normY = y2 - centerY;
	
	        dist = Math.sqrt(normX * normX + normY * normY);
	        x2 = centerX + (normX / dist) * (dist + paddingX);
	        y2 = centerY + (normY / dist) * (dist + paddingY);
	    }
	
	    context.save();
	    context.beginPath();
	
	
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	
	    context.closePath();
	
	    context.clip();
	
	    // Compute matrix transform
	    var delta =  (u0 * v1)      + (v0 * u2)      + (u1 * v2)      - (v1 * u2)      - (v0 * u1)      - (u0 * v2);
	    var deltaA = (x0 * v1)      + (v0 * x2)      + (x1 * v2)      - (v1 * x2)      - (v0 * x1)      - (x0 * v2);
	    var deltaB = (u0 * x1)      + (x0 * u2)      + (u1 * x2)      - (x1 * u2)      - (x0 * u1)      - (u0 * x2);
	    var deltaC = (u0 * v1 * x2) + (v0 * x1 * u2) + (x0 * u1 * v2) - (x0 * v1 * u2) - (v0 * u1 * x2) - (u0 * x1 * v2);
	    var deltaD = (y0 * v1)      + (v0 * y2)      + (y1 * v2)      - (v1 * y2)      - (v0 * y1)      - (y0 * v2);
	    var deltaE = (u0 * y1)      + (y0 * u2)      + (u1 * y2)      - (y1 * u2)      - (y0 * u1)      - (u0 * y2);
	    var deltaF = (u0 * v1 * y2) + (v0 * y1 * u2) + (y0 * u1 * v2) - (y0 * v1 * u2) - (v0 * u1 * y2) - (u0 * y1 * v2);
	
	    context.transform(deltaA / delta, deltaD / delta,
	        deltaB / delta, deltaE / delta,
	        deltaC / delta, deltaF / delta);
	
	    context.drawImage(textureSource, 0, 0, textureWidth * base.resolution, textureHeight * base.resolution, 0, 0, textureWidth, textureHeight);
	    context.restore();
	};
	
	
	
	/**
	 * Renders a flat Mesh
	 *
	 * @param Mesh {PIXI.mesh.Mesh} The Mesh to render
	 * @private
	 */
	Mesh.prototype.renderMeshFlat = function (Mesh)
	{
	    var context = this.context;
	    var vertices = Mesh.vertices;
	
	    var length = vertices.length/2;
	    // this.count++;
	
	    context.beginPath();
	    for (var i=1; i < length-2; i++)
	    {
	        // draw some triangles!
	        var index = i*2;
	
	        var x0 = vertices[index],   x1 = vertices[index+2], x2 = vertices[index+4];
	        var y0 = vertices[index+1], y1 = vertices[index+3], y2 = vertices[index+5];
	
	        context.moveTo(x0, y0);
	        context.lineTo(x1, y1);
	        context.lineTo(x2, y2);
	    }
	
	    context.fillStyle = '#FF0000';
	    context.fill();
	    context.closePath();
	};
	
	/**
	 * When the texture is updated, this event will fire to update the scale and frame
	 *
	 * @param event
	 * @private
	 */
	Mesh.prototype._onTextureUpdate = function ()
	{
	    this.updateFrame = true;
	};
	
	/**
	 * Returns the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
	 *
	 * @param matrix {PIXI.Matrix} the transformation matrix of the sprite
	 * @return {PIXI.Rectangle} the framing rectangle
	 */
	Mesh.prototype.getBounds = function (matrix)
	{
	    if (!this._currentBounds) {
	        var worldTransform = matrix || this.worldTransform;
	
	        var a = worldTransform.a;
	        var b = worldTransform.b;
	        var c = worldTransform.c;
	        var d = worldTransform.d;
	        var tx = worldTransform.tx;
	        var ty = worldTransform.ty;
	
	        var maxX = -Infinity;
	        var maxY = -Infinity;
	
	        var minX = Infinity;
	        var minY = Infinity;
	
	        var vertices = this.vertices;
	        for (var i = 0, n = vertices.length; i < n; i += 2) {
	            var rawX = vertices[i], rawY = vertices[i + 1];
	            var x = (a * rawX) + (c * rawY) + tx;
	            var y = (d * rawY) + (b * rawX) + ty;
	
	            minX = x < minX ? x : minX;
	            minY = y < minY ? y : minY;
	
	            maxX = x > maxX ? x : maxX;
	            maxY = y > maxY ? y : maxY;
	        }
	
	        if (minX === -Infinity || maxY === Infinity) {
	            return core.Rectangle.EMPTY;
	        }
	
	        var bounds = this._bounds;
	
	        bounds.x = minX;
	        bounds.width = maxX - minX;
	
	        bounds.y = minY;
	        bounds.height = maxY - minY;
	
	        // store a reference so that if this function gets called again in the render cycle we do not have to recalculate
	        this._currentBounds = bounds;
	    }
	
	    return this._currentBounds;
	};
	
	/**
	 * Tests if a point is inside this mesh. Works only for TRIANGLE_MESH
	 *
	 * @param point {PIXI.Point} the point to test
	 * @return {boolean} the result of the test
	 */
	Mesh.prototype.containsPoint = function( point ) {
	    if (!this.getBounds().contains(point.x, point.y)) {
	        return false;
	    }
	    this.worldTransform.applyInverse(point,  tempPoint);
	
	    var vertices = this.vertices;
	    var points = tempPolygon.points;
	    var i, len;
	
	    if (this.drawMode === Mesh.DRAW_MODES.TRIANGLES) {
	        var indices = this.indices;
	        len = this.indices.length;
	        //TODO: inline this.
	        for (i=0;i<len;i+=3) {
	            var ind0 = indices[i]*2, ind1 = indices[i+1]*2, ind2 = indices[i+2]*2;
	            points[0] = vertices[ind0];
	            points[1] = vertices[ind0+1];
	            points[2] = vertices[ind1];
	            points[3] = vertices[ind1+1];
	            points[4] = vertices[ind2];
	            points[5] = vertices[ind2+1];
	            if (tempPolygon.contains(tempPoint.x, tempPoint.y)) {
	                return true;
	            }
	        }
	    } else {
	        len = vertices.length;
	        for (i=0;i<len;i+=6) {
	            points[0] = vertices[i];
	            points[1] = vertices[i+1];
	            points[2] = vertices[i+2];
	            points[3] = vertices[i+3];
	            points[4] = vertices[i+4];
	            points[5] = vertices[i+5];
	            if (tempPolygon.contains(tempPoint.x, tempPoint.y)) {
	                return true;
	            }
	        }
	    }
	    return false;
	};
	
	/**
	 * Different drawing buffer modes supported
	 *
	 * @static
	 * @constant
	 * @property {object} DRAW_MODES
	 * @property {number} DRAW_MODES.TRIANGLE_MESH
	 * @property {number} DRAW_MODES.TRIANGLES
	 */
	Mesh.DRAW_MODES = {
	    TRIANGLE_MESH: 0,
	    TRIANGLES: 1
	};


/***/ },
/* 44 */
/*!******************************!*\
  !*** ./~/process/browser.js ***!
  \******************************/
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 45 */
/*!*************************************************!*\
  !*** ./~/react/lib/ReactBrowserEventEmitter.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(/*! ./EventConstants */ 16);
	var EventPluginHub = __webpack_require__(/*! ./EventPluginHub */ 31);
	var EventPluginRegistry = __webpack_require__(/*! ./EventPluginRegistry */ 129);
	var ReactEventEmitterMixin = __webpack_require__(/*! ./ReactEventEmitterMixin */ 280);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	var ViewportMetrics = __webpack_require__(/*! ./ViewportMetrics */ 150);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var isEventSupported = __webpack_require__(/*! ./isEventSupported */ 79);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 46 */
/*!***************************************************!*\
  !*** ./~/react/lib/ReactPropTypeLocationNames.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 47 */
/*!***********************************************!*\
  !*** ./~/react/lib/ReactPropTypeLocations.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(/*! fbjs/lib/keyMirror */ 35);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 48 */
/*!********************************************!*\
  !*** ./~/react/lib/SyntheticMouseEvent.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(/*! ./SyntheticUIEvent */ 34);
	var ViewportMetrics = __webpack_require__(/*! ./ViewportMetrics */ 150);
	
	var getEventModifierState = __webpack_require__(/*! ./getEventModifierState */ 75);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 49 */
/*!************************************!*\
  !*** ./~/react/lib/Transaction.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 50 */
/*!******************************************!*\
  !*** ./~/react/lib/canDefineProperty.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 51 */
/*!****************************************************!*\
  !*** ./~/react/lib/escapeTextContentForBrowser.js ***!
  \****************************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 52 */
/*!*************************************!*\
  !*** ./~/react/lib/setInnerHTML.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 53 */
/*!****************************************!*\
  !*** ./~/resource-loader/src/index.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./Loader */ 313);
	
	module.exports.Resource = __webpack_require__(/*! ./Resource */ 84);
	
	module.exports.middleware = {
	    caching: {
	        memory: __webpack_require__(/*! ./middlewares/caching/memory */ 315)
	    },
	    parsing: {
	        blob: __webpack_require__(/*! ./middlewares/parsing/blob */ 316)
	    }
	};


/***/ },
/* 54 */
/*!*************************************!*\
  !*** ./~/timers-browserify/main.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(/*! process/browser.js */ 44).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./~/timers-browserify/main.js */ 54).setImmediate, __webpack_require__(/*! ./~/timers-browserify/main.js */ 54).clearImmediate))

/***/ },
/* 55 */
/*!****************************!*\
  !*** ./~/events/events.js ***!
  \****************************/
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 56 */
/*!******************************************!*\
  !*** ./~/pixi.js/src/core/math/Point.js ***!
  \******************************************/
/***/ function(module, exports) {

	/**
	 * The Point object represents a location in a two-dimensional coordinate system, where x represents
	 * the horizontal axis and y represents the vertical axis.
	 *
	 * @class
	 * @memberof PIXI
	 * @param [x=0] {number} position of the point on the x axis
	 * @param [y=0] {number} position of the point on the y axis
	 */
	function Point(x, y)
	{
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y || 0;
	}
	
	Point.prototype.constructor = Point;
	module.exports = Point;
	
	/**
	 * Creates a clone of this point
	 *
	 * @return {PIXI.Point} a copy of the point
	 */
	Point.prototype.clone = function ()
	{
	    return new Point(this.x, this.y);
	};
	
	/**
	 * Copies x and y from the given point
	 *
	 * @param p {PIXI.Point}
	 */
	Point.prototype.copy = function (p) {
	    this.set(p.x, p.y);
	};
	
	/**
	 * Returns true if the given point is equal to this point
	 *
	 * @param p {PIXI.Point}
	 * @returns {boolean}
	 */
	Point.prototype.equals = function (p) {
	    return (p.x === this.x) && (p.y === this.y);
	};
	
	/**
	 * Sets the point to a new x and y position.
	 * If y is omitted, both x and y will be set to x.
	 *
	 * @param [x=0] {number} position of the point on the x axis
	 * @param [y=0] {number} position of the point on the y axis
	 */
	Point.prototype.set = function (x, y)
	{
	    this.x = x || 0;
	    this.y = y || ( (y !== 0) ? this.x : 0 ) ;
	};


/***/ },
/* 57 */
/*!*****************************************************!*\
  !*** ./~/pixi.js/src/core/math/shapes/Rectangle.js ***!
  \*****************************************************/
/***/ function(module, exports, __webpack_require__) {

	var CONST = __webpack_require__(/*! ../../const */ 6);
	
	/**
	 * the Rectangle object is an area defined by its position, as indicated by its top-left corner point (x, y) and by its width and its height.
	 *
	 * @class
	 * @memberof PIXI
	 * @param x {number} The X coordinate of the upper-left corner of the rectangle
	 * @param y {number} The Y coordinate of the upper-left corner of the rectangle
	 * @param width {number} The overall width of this rectangle
	 * @param height {number} The overall height of this rectangle
	 */
	function Rectangle(x, y, width, height)
	{
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.width = width || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.height = height || 0;
	
	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     */
	    this.type = CONST.SHAPES.RECT;
	}
	
	Rectangle.prototype.constructor = Rectangle;
	module.exports = Rectangle;
	
	/**
	 * A constant empty rectangle.
	 *
	 * @static
	 * @constant
	 */
	Rectangle.EMPTY = new Rectangle(0, 0, 0, 0);
	
	
	/**
	 * Creates a clone of this Rectangle
	 *
	 * @return {PIXI.Rectangle} a copy of the rectangle
	 */
	Rectangle.prototype.clone = function ()
	{
	    return new Rectangle(this.x, this.y, this.width, this.height);
	};
	
	/**
	 * Checks whether the x and y coordinates given are contained within this Rectangle
	 *
	 * @param x {number} The X coordinate of the point to test
	 * @param y {number} The Y coordinate of the point to test
	 * @return {boolean} Whether the x/y coordinates are within this Rectangle
	 */
	Rectangle.prototype.contains = function (x, y)
	{
	    if (this.width <= 0 || this.height <= 0)
	    {
	        return false;
	    }
	
	    if (x >= this.x && x < this.x + this.width)
	    {
	        if (y >= this.y && y < this.y + this.height)
	        {
	            return true;
	        }
	    }
	
	    return false;
	};


/***/ },
/* 58 */
/*!*******************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/canvas/utils/CanvasBuffer.js ***!
  \*******************************************************************/
/***/ function(module, exports) {

	/**
	 * Creates a Canvas element of the given size.
	 *
	 * @class
	 * @memberof PIXI
	 * @param width {number} the width for the newly created canvas
	 * @param height {number} the height for the newly created canvas
	 */
	function CanvasBuffer(width, height)
	{
	    /**
	     * The Canvas object that belongs to this CanvasBuffer.
	     *
	     * @member {HTMLCanvasElement}
	     */
	    this.canvas = document.createElement('canvas');
	
	    /**
	     * A CanvasRenderingContext2D object representing a two-dimensional rendering context.
	     *
	     * @member {CanvasRenderingContext2D}
	     */
	    this.context = this.canvas.getContext('2d');
	
	    this.canvas.width = width;
	    this.canvas.height = height;
	}
	
	CanvasBuffer.prototype.constructor = CanvasBuffer;
	module.exports = CanvasBuffer;
	
	Object.defineProperties(CanvasBuffer.prototype, {
	    /**
	     * The width of the canvas buffer in pixels.
	     *
	     * @member {number}
	     * @memberof PIXI.CanvasBuffer#
	     */
	    width: {
	        get: function ()
	        {
	            return this.canvas.width;
	        },
	        set: function (val)
	        {
	            this.canvas.width = val;
	        }
	    },
	    /**
	     * The height of the canvas buffer in pixels.
	     *
	     * @member {number}
	     * @memberof PIXI.CanvasBuffer#
	     */
	    height: {
	        get: function ()
	        {
	            return this.canvas.height;
	        },
	        set: function (val)
	        {
	            this.canvas.height = val;
	        }
	    }
	});
	
	/**
	 * Clears the canvas that was created by the CanvasBuffer class.
	 *
	 * @private
	 */
	CanvasBuffer.prototype.clear = function ()
	{
	    this.context.setTransform(1, 0, 0, 1, 0, 0);
	    this.context.clearRect(0,0, this.canvas.width, this.canvas.height);
	};
	
	/**
	 * Resizes the canvas to the specified width and height.
	 *
	 * @param width {number} the new width of the canvas
	 * @param height {number} the new height of the canvas
	 */
	CanvasBuffer.prototype.resize = function (width, height)
	{
	    this.canvas.width = width;
	    this.canvas.height = height;
	};
	
	/**
	 * Destroys this canvas.
	 *
	 */
	CanvasBuffer.prototype.destroy = function ()
	{
	    this.context = null;
	    this.canvas = null;
	};


/***/ },
/* 59 */
/*!*********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/canvas/utils/CanvasGraphics.js ***!
  \*********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var CONST = __webpack_require__(/*! ../../../const */ 6);
	
	/**
	 * A set of functions used by the canvas renderer to draw the primitive graphics data.
	 * @static
	 * @class
	 * @memberof PIXI
	 */
	var CanvasGraphics = {};
	module.exports = CanvasGraphics;
	
	/*
	 * Renders a Graphics object to a canvas.
	 *
	 * @param graphics {PIXI.Graphics} the actual graphics object to render
	 * @param context {CanvasRenderingContext2D} the 2d drawing method of the canvas
	 */
	CanvasGraphics.renderGraphics = function (graphics, context)
	{
	    var worldAlpha = graphics.worldAlpha;
	
	    if (graphics.dirty)
	    {
	        this.updateGraphicsTint(graphics);
	        graphics.dirty = false;
	    }
	
	    for (var i = 0; i < graphics.graphicsData.length; i++)
	    {
	        var data = graphics.graphicsData[i];
	        var shape = data.shape;
	
	        var fillColor = data._fillTint;
	        var lineColor = data._lineTint;
	
	        context.lineWidth = data.lineWidth;
	
	        if (data.type === CONST.SHAPES.POLY)
	        {
	            context.beginPath();
	
	            var points = shape.points;
	
	            context.moveTo(points[0], points[1]);
	
	            for (var j=1; j < points.length/2; j++)
	            {
	                context.lineTo(points[j * 2], points[j * 2 + 1]);
	            }
	
	            if (shape.closed)
	            {
	                context.lineTo(points[0], points[1]);
	            }
	
	            // if the first and last point are the same close the path - much neater :)
	            if (points[0] === points[points.length-2] && points[1] === points[points.length-1])
	            {
	                context.closePath();
	            }
	
	            if (data.fill)
	            {
	                context.globalAlpha = data.fillAlpha * worldAlpha;
	                context.fillStyle = '#' + ('00000' + ( fillColor | 0).toString(16)).substr(-6);
	                context.fill();
	            }
	            if (data.lineWidth)
	            {
	                context.globalAlpha = data.lineAlpha * worldAlpha;
	                context.strokeStyle = '#' + ('00000' + ( lineColor | 0).toString(16)).substr(-6);
	                context.stroke();
	            }
	        }
	        else if (data.type === CONST.SHAPES.RECT)
	        {
	
	            if (data.fillColor || data.fillColor === 0)
	            {
	                context.globalAlpha = data.fillAlpha * worldAlpha;
	                context.fillStyle = '#' + ('00000' + ( fillColor | 0).toString(16)).substr(-6);
	                context.fillRect(shape.x, shape.y, shape.width, shape.height);
	
	            }
	            if (data.lineWidth)
	            {
	                context.globalAlpha = data.lineAlpha * worldAlpha;
	                context.strokeStyle = '#' + ('00000' + ( lineColor | 0).toString(16)).substr(-6);
	                context.strokeRect(shape.x, shape.y, shape.width, shape.height);
	            }
	        }
	        else if (data.type === CONST.SHAPES.CIRC)
	        {
	            // TODO - need to be Undefined!
	            context.beginPath();
	            context.arc(shape.x, shape.y, shape.radius,0,2*Math.PI);
	            context.closePath();
	
	            if (data.fill)
	            {
	                context.globalAlpha = data.fillAlpha * worldAlpha;
	                context.fillStyle = '#' + ('00000' + ( fillColor | 0).toString(16)).substr(-6);
	                context.fill();
	            }
	            if (data.lineWidth)
	            {
	                context.globalAlpha = data.lineAlpha * worldAlpha;
	                context.strokeStyle = '#' + ('00000' + ( lineColor | 0).toString(16)).substr(-6);
	                context.stroke();
	            }
	        }
	        else if (data.type === CONST.SHAPES.ELIP)
	        {
	            // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	
	            var w = shape.width * 2;
	            var h = shape.height * 2;
	
	            var x = shape.x - w/2;
	            var y = shape.y - h/2;
	
	            context.beginPath();
	
	            var kappa = 0.5522848,
	                ox = (w / 2) * kappa, // control point offset horizontal
	                oy = (h / 2) * kappa, // control point offset vertical
	                xe = x + w,           // x-end
	                ye = y + h,           // y-end
	                xm = x + w / 2,       // x-middle
	                ym = y + h / 2;       // y-middle
	
	            context.moveTo(x, ym);
	            context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	            context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	            context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	            context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	
	            context.closePath();
	
	            if (data.fill)
	            {
	                context.globalAlpha = data.fillAlpha * worldAlpha;
	                context.fillStyle = '#' + ('00000' + ( fillColor | 0).toString(16)).substr(-6);
	                context.fill();
	            }
	            if (data.lineWidth)
	            {
	                context.globalAlpha = data.lineAlpha * worldAlpha;
	                context.strokeStyle = '#' + ('00000' + ( lineColor | 0).toString(16)).substr(-6);
	                context.stroke();
	            }
	        }
	        else if (data.type === CONST.SHAPES.RREC)
	        {
	            var rx = shape.x;
	            var ry = shape.y;
	            var width = shape.width;
	            var height = shape.height;
	            var radius = shape.radius;
	
	            var maxRadius = Math.min(width, height) / 2 | 0;
	            radius = radius > maxRadius ? maxRadius : radius;
	
	            context.beginPath();
	            context.moveTo(rx, ry + radius);
	            context.lineTo(rx, ry + height - radius);
	            context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	            context.lineTo(rx + width - radius, ry + height);
	            context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	            context.lineTo(rx + width, ry + radius);
	            context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	            context.lineTo(rx + radius, ry);
	            context.quadraticCurveTo(rx, ry, rx, ry + radius);
	            context.closePath();
	
	            if (data.fillColor || data.fillColor === 0)
	            {
	                context.globalAlpha = data.fillAlpha * worldAlpha;
	                context.fillStyle = '#' + ('00000' + ( fillColor | 0).toString(16)).substr(-6);
	                context.fill();
	
	            }
	            if (data.lineWidth)
	            {
	                context.globalAlpha = data.lineAlpha * worldAlpha;
	                context.strokeStyle = '#' + ('00000' + ( lineColor | 0).toString(16)).substr(-6);
	                context.stroke();
	            }
	        }
	    }
	};
	
	/*
	 * Renders a graphics mask
	 *
	 * @private
	 * @param graphics {PIXI.Graphics} the graphics which will be used as a mask
	 * @param context {CanvasRenderingContext2D} the context 2d method of the canvas
	 */
	CanvasGraphics.renderGraphicsMask = function (graphics, context)
	{
	    var len = graphics.graphicsData.length;
	
	    if (len === 0)
	    {
	        return;
	    }
	
	    context.beginPath();
	
	    for (var i = 0; i < len; i++)
	    {
	        var data = graphics.graphicsData[i];
	        var shape = data.shape;
	
	        if (data.type === CONST.SHAPES.POLY)
	        {
	
	            var points = shape.points;
	
	            context.moveTo(points[0], points[1]);
	
	            for (var j=1; j < points.length/2; j++)
	            {
	                context.lineTo(points[j * 2], points[j * 2 + 1]);
	            }
	
	            // if the first and last point are the same close the path - much neater :)
	            if (points[0] === points[points.length-2] && points[1] === points[points.length-1])
	            {
	                context.closePath();
	            }
	
	        }
	        else if (data.type === CONST.SHAPES.RECT)
	        {
	            context.rect(shape.x, shape.y, shape.width, shape.height);
	            context.closePath();
	        }
	        else if (data.type === CONST.SHAPES.CIRC)
	        {
	            // TODO - need to be Undefined!
	            context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
	            context.closePath();
	        }
	        else if (data.type === CONST.SHAPES.ELIP)
	        {
	
	            // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	
	            var w = shape.width * 2;
	            var h = shape.height * 2;
	
	            var x = shape.x - w/2;
	            var y = shape.y - h/2;
	
	            var kappa = 0.5522848,
	                ox = (w / 2) * kappa, // control point offset horizontal
	                oy = (h / 2) * kappa, // control point offset vertical
	                xe = x + w,           // x-end
	                ye = y + h,           // y-end
	                xm = x + w / 2,       // x-middle
	                ym = y + h / 2;       // y-middle
	
	            context.moveTo(x, ym);
	            context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	            context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	            context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	            context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	            context.closePath();
	        }
	        else if (data.type === CONST.SHAPES.RREC)
	        {
	
	            var rx = shape.x;
	            var ry = shape.y;
	            var width = shape.width;
	            var height = shape.height;
	            var radius = shape.radius;
	
	            var maxRadius = Math.min(width, height) / 2 | 0;
	            radius = radius > maxRadius ? maxRadius : radius;
	
	            context.moveTo(rx, ry + radius);
	            context.lineTo(rx, ry + height - radius);
	            context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	            context.lineTo(rx + width - radius, ry + height);
	            context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	            context.lineTo(rx + width, ry + radius);
	            context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	            context.lineTo(rx + radius, ry);
	            context.quadraticCurveTo(rx, ry, rx, ry + radius);
	            context.closePath();
	        }
	    }
	};
	
	/*
	 * Updates the tint of a graphics object
	 *
	 * @private
	 * @param graphics {PIXI.Graphics} the graphics that will have its tint updated
	 *
	 */
	CanvasGraphics.updateGraphicsTint = function (graphics)
	{
	    if (graphics.tint === 0xFFFFFF && graphics._prevTint === graphics.tint)
	    {
	        return;
	    }
	    graphics._prevTint = graphics.tint;
	
	    var tintR = (graphics.tint >> 16 & 0xFF) / 255;
	    var tintG = (graphics.tint >> 8 & 0xFF) / 255;
	    var tintB = (graphics.tint & 0xFF)/ 255;
	
	    for (var i = 0; i < graphics.graphicsData.length; i++)
	    {
	        var data = graphics.graphicsData[i];
	
	        var fillColor = data.fillColor | 0;
	        var lineColor = data.lineColor | 0;
	
	        /*
	        var colorR = (fillColor >> 16 & 0xFF) / 255;
	        var colorG = (fillColor >> 8 & 0xFF) / 255;
	        var colorB = (fillColor & 0xFF) / 255;
	
	        colorR *= tintR;
	        colorG *= tintG;
	        colorB *= tintB;
	
	        fillColor = ((colorR*255 << 16) + (colorG*255 << 8) + colorB*255);
	
	        colorR = (lineColor >> 16 & 0xFF) / 255;
	        colorG = (lineColor >> 8 & 0xFF) / 255;
	        colorB = (lineColor & 0xFF) / 255;
	
	        colorR *= tintR;
	        colorG *= tintG;
	        colorB *= tintB;
	
	        lineColor = ((colorR*255 << 16) + (colorG*255 << 8) + colorB*255);
	        */
	
	        // super inline cos im an optimization NAZI :)
	        data._fillTint = (((fillColor >> 16 & 0xFF) / 255 * tintR*255 << 16) + ((fillColor >> 8 & 0xFF) / 255 * tintG*255 << 8) +  (fillColor & 0xFF) / 255 * tintB*255);
	        data._lineTint = (((lineColor >> 16 & 0xFF) / 255 * tintR*255 << 16) + ((lineColor >> 8 & 0xFF) / 255 * tintG*255 << 8) +  (lineColor & 0xFF) / 255 * tintB*255);
	
	    }
	};
	


/***/ },
/* 60 */
/*!**********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/filters/AbstractFilter.js ***!
  \**********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var DefaultShader = __webpack_require__(/*! ../shaders/TextureShader */ 39);
	
	/**
	 * This is the base class for creating a PIXI filter. Currently only WebGL supports filters.
	 * If you want to make a custom filter this should be your base class.
	 *
	 * @class
	 * @memberof PIXI
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
	 * @param uniforms {object} An object containing the uniforms for this filter.
	 */
	function AbstractFilter(vertexSrc, fragmentSrc, uniforms)
	{
	
	    /**
	     * An array of shaders
	     * @member {PIXI.Shader[]}
	     * @private
	     */
	    this.shaders = [];
	
	    /**
	     * The extra padding that the filter might need
	     * @member {number}
	     */
	    this.padding = 0;
	
	    /**
	     * The uniforms as an object
	     * @member {object}
	     */
	    this.uniforms = uniforms || {};
	
	
	    /**
	     * The code of the vertex shader
	     * @member {string[]}
	     * @private
	     */
	    this.vertexSrc = vertexSrc || DefaultShader.defaultVertexSrc;
	
	    /**
	     * The code of the frament shader
	     * @member {string[]}
	     * @private
	     */
	    this.fragmentSrc = fragmentSrc || DefaultShader.defaultFragmentSrc;
	
	    //TODO a reminder - would be cool to have lower res filters as this would give better performance.
	
	    //typeof fragmentSrc === 'string' ? fragmentSrc.split('') : (fragmentSrc || []);
	
	}
	
	AbstractFilter.prototype.constructor = AbstractFilter;
	module.exports = AbstractFilter;
	
	/**
	 * Grabs a shader from the current renderer
	 *
	 * @param renderer {PIXI.WebGLRenderer} The renderer to retrieve the shader from
	 */
	AbstractFilter.prototype.getShader = function (renderer)
	{
	    var gl = renderer.gl;
	
	    var shader = this.shaders[gl.id];
	
	    if (!shader)
	    {
	        shader = new DefaultShader(renderer.shaderManager,
	            this.vertexSrc,
	            this.fragmentSrc,
	            this.uniforms,
	            this.attributes
	        );
	
	        this.shaders[gl.id] = shader;
	    }
	
	    return shader;
	};
	
	/**
	 * Applies the filter
	 *
	 * @param renderer {PIXI.WebGLRenderer} The renderer to retrieve the filter from
	 * @param input {PIXI.RenderTarget}
	 * @param output {PIXI.RenderTarget}
	 * @param clear {boolean} Whether or not we want to clear the outputTarget
	 */
	AbstractFilter.prototype.applyFilter = function (renderer, input, output, clear)
	{
	    var shader = this.getShader(renderer);
	
	    renderer.filterManager.applyFilter(shader, input, output, clear);
	};
	
	/**
	 * Syncs a uniform between the class object and the shaders.
	 *
	 */
	AbstractFilter.prototype.syncUniform = function (uniform)
	{
	    for (var i = 0, j = this.shaders.length; i < j; ++i)
	    {
	        this.shaders[i].syncUniform(uniform);
	    }
	};


/***/ },
/* 61 */
/*!******************************************************!*\
  !*** ./~/pixi.js/src/core/textures/RenderTexture.js ***!
  \******************************************************/
/***/ function(module, exports, __webpack_require__) {

	var BaseTexture = __webpack_require__(/*! ./BaseTexture */ 41),
	    Texture = __webpack_require__(/*! ./Texture */ 30),
	    RenderTarget = __webpack_require__(/*! ../renderers/webgl/utils/RenderTarget */ 40),
	    FilterManager = __webpack_require__(/*! ../renderers/webgl/managers/FilterManager */ 102),
	    CanvasBuffer = __webpack_require__(/*! ../renderers/canvas/utils/CanvasBuffer */ 58),
	    math = __webpack_require__(/*! ../math */ 9),
	    CONST = __webpack_require__(/*! ../const */ 6),
	    tempMatrix = new math.Matrix();
	
	/**
	 * A RenderTexture is a special texture that allows any Pixi display object to be rendered to it.
	 *
	 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
	 * otherwise black rectangles will be drawn instead.
	 *
	 * A RenderTexture takes a snapshot of any Display Object given to its render method. The position
	 * and rotation of the given Display Objects is ignored. For example:
	 *
	 * ```js
	 * var renderer = PIXI.autoDetectRenderer(1024, 1024, { view: canvas, ratio: 1 });
	 * var renderTexture = new PIXI.RenderTexture(renderer, 800, 600);
	 * var sprite = PIXI.Sprite.fromImage("spinObj_01.png");
	 *
	 * sprite.position.x = 800/2;
	 * sprite.position.y = 600/2;
	 * sprite.anchor.x = 0.5;
	 * sprite.anchor.y = 0.5;
	 *
	 * renderTexture.render(sprite);
	 * ```
	 *
	 * The Sprite in this case will be rendered to a position of 0,0. To render this sprite at its actual
	 * position a Container should be used:
	 *
	 * ```js
	 * var doc = new PIXI.Container();
	 *
	 * doc.addChild(sprite);
	 *
	 * renderTexture.render(doc);  // Renders to center of renderTexture
	 * ```
	 *
	 * @class
	 * @extends PIXI.Texture
	 * @memberof PIXI
	 * @param renderer {PIXI.CanvasRenderer|PIXI.WebGLRenderer} The renderer used for this RenderTexture
	 * @param [width=100] {number} The width of the render texture
	 * @param [height=100] {number} The height of the render texture
	 * @param [scaleMode] {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @param [resolution=1] {number} The resolution of the texture being generated
	 */
	function RenderTexture(renderer, width, height, scaleMode, resolution)
	{
	    if (!renderer)
	    {
	        throw new Error('Unable to create RenderTexture, you must pass a renderer into the constructor.');
	    }
	
	    width = width || 100;
	    height = height || 100;
	    resolution = resolution || CONST.RESOLUTION;
	
	    /**
	     * The base texture object that this texture uses
	     *
	     * @member {BaseTexture}
	     */
	    var baseTexture = new BaseTexture();
	    baseTexture.width = width;
	    baseTexture.height = height;
	    baseTexture.resolution = resolution;
	    baseTexture.scaleMode = scaleMode || CONST.SCALE_MODES.DEFAULT;
	    baseTexture.hasLoaded = true;
	
	
	    Texture.call(this,
	        baseTexture,
	        new math.Rectangle(0, 0, width, height)
	    );
	
	
	    /**
	     * The with of the render texture
	     *
	     * @member {number}
	     */
	    this.width = width;
	
	    /**
	     * The height of the render texture
	     *
	     * @member {number}
	     */
	    this.height = height;
	
	    /**
	     * The Resolution of the texture.
	     *
	     * @member {number}
	     */
	    this.resolution = resolution;
	
	    /**
	     * Draw/render the given DisplayObject onto the texture.
	     *
	     * The displayObject and descendents are transformed during this operation.
	     * If `updateTransform` is true then the transformations will be restored before the
	     * method returns. Otherwise it is up to the calling code to correctly use or reset
	     * the transformed display objects.
	     *
	     * The display object is always rendered with a worldAlpha value of 1.
	     *
	     * @method
	     * @param displayObject {PIXI.DisplayObject} The display object to render this texture on
	     * @param [matrix] {PIXI.Matrix} Optional matrix to apply to the display object before rendering.
	     * @param [clear=false] {boolean} If true the texture will be cleared before the displayObject is drawn
	     * @param [updateTransform=true] {boolean} If true the displayObject's worldTransform/worldAlpha and all children
	     *  transformations will be restored. Not restoring this information will be a little faster.
	     */
	    this.render = null;
	
	    /**
	     * The renderer this RenderTexture uses. A RenderTexture can only belong to one renderer at the moment if its webGL.
	     *
	     * @member {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
	     */
	    this.renderer = renderer;
	
	    if (this.renderer.type === CONST.RENDERER_TYPE.WEBGL)
	    {
	        var gl = this.renderer.gl;
	
	        this.textureBuffer = new RenderTarget(gl, this.width, this.height, baseTexture.scaleMode, this.resolution);//, this.baseTexture.scaleMode);
	        this.baseTexture._glTextures[gl.id] = this.textureBuffer.texture;
	
	        //TODO refactor filter manager.. as really its no longer a manager if we use it here..
	        this.filterManager = new FilterManager(this.renderer);
	        this.filterManager.onContextChange();
	        this.filterManager.resize(width, height);
	        this.render = this.renderWebGL;
	
	        // the creation of a filter manager unbinds the buffers..
	        this.renderer.currentRenderer.start();
	        this.renderer.currentRenderTarget.activate();
	    }
	    else
	    {
	
	        this.render = this.renderCanvas;
	        this.textureBuffer = new CanvasBuffer(this.width* this.resolution, this.height* this.resolution);
	        this.baseTexture.source = this.textureBuffer.canvas;
	    }
	
	    /**
	     * @member {boolean}
	     */
	    this.valid = true;
	
	    this._updateUvs();
	}
	
	RenderTexture.prototype = Object.create(Texture.prototype);
	RenderTexture.prototype.constructor = RenderTexture;
	module.exports = RenderTexture;
	
	/**
	 * Resizes the RenderTexture.
	 *
	 * @param width {number} The width to resize to.
	 * @param height {number} The height to resize to.
	 * @param updateBase {boolean} Should the baseTexture.width and height values be resized as well?
	 */
	RenderTexture.prototype.resize = function (width, height, updateBase)
	{
	    if (width === this.width && height === this.height)
	    {
	        return;
	    }
	
	    this.valid = (width > 0 && height > 0);
	
	    this.width = this._frame.width = this.crop.width = width;
	    this.height =  this._frame.height = this.crop.height = height;
	
	    if (updateBase)
	    {
	        this.baseTexture.width = this.width;
	        this.baseTexture.height = this.height;
	    }
	
	    if (!this.valid)
	    {
	        return;
	    }
	
	    this.textureBuffer.resize(this.width, this.height);
	
	    if(this.filterManager)
	    {
	        this.filterManager.resize(this.width, this.height);
	    }
	};
	
	/**
	 * Clears the RenderTexture.
	 *
	 */
	RenderTexture.prototype.clear = function ()
	{
	    if (!this.valid)
	    {
	        return;
	    }
	
	    if (this.renderer.type === CONST.RENDERER_TYPE.WEBGL)
	    {
	        this.renderer.gl.bindFramebuffer(this.renderer.gl.FRAMEBUFFER, this.textureBuffer.frameBuffer);
	    }
	
	    this.textureBuffer.clear();
	};
	
	/**
	 * Internal method assigned to the `render` property if using a CanvasRenderer.
	 *
	 * @private
	 * @param displayObject {PIXI.DisplayObject} The display object to render this texture on
	 * @param [matrix] {PIXI.Matrix} Optional matrix to apply to the display object before rendering.
	 * @param [clear=false] {boolean} If true the texture will be cleared before the displayObject is drawn
	 * @param [updateTransform=true] {boolean} If true the displayObject's worldTransform/worldAlpha and all children
	 *  transformations will be restored. Not restoring this information will be a little faster.
	 */
	RenderTexture.prototype.renderWebGL = function (displayObject, matrix, clear, updateTransform)
	{
	    if (!this.valid)
	    {
	        return;
	    }
	
	
	    updateTransform = (updateTransform !== undefined) ? updateTransform : true;//!updateTransform;
	
	    this.textureBuffer.transform = matrix;
	
	    //TODO not a fan that this is here... it will move!
	    this.textureBuffer.activate();
	
	    // setWorld Alpha to ensure that the object is renderer at full opacity
	    displayObject.worldAlpha = 1;
	
	    if (updateTransform)
	    {
	
	        // reset the matrix of the displatyObject..
	        displayObject.worldTransform.identity();
	
	        displayObject.currentBounds = null;
	
	        // Time to update all the children of the displayObject with the new matrix..
	        var children = displayObject.children;
	        var i, j;
	
	        for (i = 0, j = children.length; i < j; ++i)
	        {
	            children[i].updateTransform();
	        }
	    }
	
	    //TODO rename textureBuffer to renderTarget..
	    var temp =  this.renderer.filterManager;
	
	    this.renderer.filterManager = this.filterManager;
	    this.renderer.renderDisplayObject(displayObject, this.textureBuffer, clear);
	
	    this.renderer.filterManager = temp;
	};
	
	
	/**
	 * Internal method assigned to the `render` property if using a CanvasRenderer.
	 *
	 * @private
	 * @param displayObject {PIXI.DisplayObject} The display object to render this texture on
	 * @param [matrix] {PIXI.Matrix} Optional matrix to apply to the display object before rendering.
	 * @param [clear] {boolean} If true the texture will be cleared before the displayObject is drawn
	 */
	RenderTexture.prototype.renderCanvas = function (displayObject, matrix, clear, updateTransform)
	{
	    if (!this.valid)
	    {
	        return;
	    }
	
	    updateTransform = !!updateTransform;
	
	    var wt = tempMatrix;
	
	    wt.identity();
	
	    if (matrix)
	    {
	        wt.append(matrix);
	    }
	
	    var cachedWt = displayObject.worldTransform;
	    displayObject.worldTransform = wt;
	
	    // setWorld Alpha to ensure that the object is renderer at full opacity
	    displayObject.worldAlpha = 1;
	
	    // Time to update all the children of the displayObject with the new matrix..
	    var children = displayObject.children;
	    var i, j;
	
	    for (i = 0, j = children.length; i < j; ++i)
	    {
	        children[i].updateTransform();
	    }
	
	    if (clear)
	    {
	        this.textureBuffer.clear();
	    }
	
	
	//    this.textureBuffer.
	    var context = this.textureBuffer.context;
	
	    var realResolution = this.renderer.resolution;
	
	    this.renderer.resolution = this.resolution;
	
	    this.renderer.renderDisplayObject(displayObject, context);
	
	    this.renderer.resolution = realResolution;
	
	    if(displayObject.worldTransform === wt)
	    {
	        // fixes cacheAsBitmap Happening during the above..
	        displayObject.worldTransform = cachedWt;
	    }
	
	};
	
	/**
	 * Destroys this texture
	 *
	 * @param destroyBase {boolean} Whether to destroy the base texture as well
	 */
	RenderTexture.prototype.destroy = function ()
	{
	    Texture.prototype.destroy.call(this, true);
	
	    this.textureBuffer.destroy();
	
	    // destroy the filtermanager..
	    if(this.filterManager)
	    {
	        this.filterManager.destroy();
	    }
	
	    this.renderer = null;
	};
	
	/**
	 * Will return a HTML Image of the texture
	 *
	 * @return {Image}
	 */
	RenderTexture.prototype.getImage = function ()
	{
	    var image = new Image();
	    image.src = this.getBase64();
	    return image;
	};
	
	/**
	 * Will return a a base64 encoded string of this texture. It works by calling RenderTexture.getCanvas and then running toDataURL on that.
	 *
	 * @return {string} A base64 encoded string of the texture.
	 */
	RenderTexture.prototype.getBase64 = function ()
	{
	    return this.getCanvas().toDataURL();
	};
	
	/**
	 * Creates a Canvas element, renders this RenderTexture to it and then returns it.
	 *
	 * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	 */
	RenderTexture.prototype.getCanvas = function ()
	{
	    if (this.renderer.type === CONST.RENDERER_TYPE.WEBGL)
	    {
	        var gl = this.renderer.gl;
	        var width = this.textureBuffer.size.width;
	        var height = this.textureBuffer.size.height;
	
	        var webGLPixels = new Uint8Array(4 * width * height);
	
	        gl.bindFramebuffer(gl.FRAMEBUFFER, this.textureBuffer.frameBuffer);
	        gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webGLPixels);
	        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	
	        var tempCanvas = new CanvasBuffer(width, height);
	        var canvasData = tempCanvas.context.getImageData(0, 0, width, height);
	        canvasData.data.set(webGLPixels);
	
	        tempCanvas.context.putImageData(canvasData, 0, 0);
	
	        return tempCanvas.canvas;
	    }
	    else
	    {
	        return this.textureBuffer.canvas;
	    }
	};
	
	/**
	 * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA order, with integer values between 0 and 255 (included).
	 *
	 * @return {Uint8ClampedArray}
	 */
	RenderTexture.prototype.getPixels = function ()
	{
	    var width, height;
	
	    if (this.renderer.type === CONST.RENDERER_TYPE.WEBGL)
	    {
	        var gl = this.renderer.gl;
	        width = this.textureBuffer.size.width;
	        height = this.textureBuffer.size.height;
	
	        var webGLPixels = new Uint8Array(4 * width * height);
	
	        gl.bindFramebuffer(gl.FRAMEBUFFER, this.textureBuffer.frameBuffer);
	        gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webGLPixels);
	        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	
	        return webGLPixels;
	    }
	    else
	    {
	        width = this.textureBuffer.canvas.width;
	        height = this.textureBuffer.canvas.height;
	
	        return this.textureBuffer.canvas.getContext('2d').getImageData(0, 0, width, height).data;
	    }
	};
	
	/**
	 * Will return a one-dimensional array containing the pixel data of a pixel within the texture in RGBA order, with integer values between 0 and 255 (included).
	 *
	 * @param x {number} The x coordinate of the pixel to retrieve.
	 * @param y {number} The y coordinate of the pixel to retrieve.
	 * @return {Uint8ClampedArray}
	 */
	RenderTexture.prototype.getPixel = function (x, y)
	{
	    if (this.renderer.type === CONST.RENDERER_TYPE.WEBGL)
	    {
	        var gl = this.renderer.gl;
	
	        var webGLPixels = new Uint8Array(4);
	
	        gl.bindFramebuffer(gl.FRAMEBUFFER, this.textureBuffer.frameBuffer);
	        gl.readPixels(x, y, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, webGLPixels);
	        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	
	        return webGLPixels;
	    }
	    else
	    {
	        return this.textureBuffer.canvas.getContext('2d').getImageData(x, y, 1, 1).data;
	    }
	};


/***/ },
/* 62 */
/*!***************************************!*\
  !*** ./~/pixi.js/src/extras/index.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @file        Main export of the PIXI extras library
	 * @author      Mat Groves <mat@goodboydigital.com>
	 * @copyright   2013-2015 GoodBoyDigital
	 * @license     {@link https://github.com/pixijs/pixi.js/blob/master/LICENSE|MIT License}
	 */
	
	__webpack_require__(/*! ./cacheAsBitmap */ 203);
	__webpack_require__(/*! ./getChildByName */ 204);
	__webpack_require__(/*! ./getGlobalPosition */ 205);
	
	/**
	 * @namespace PIXI.extras
	 */
	module.exports = {
	    MovieClip:      __webpack_require__(/*! ./MovieClip */ 201),
	    TilingSprite:   __webpack_require__(/*! ./TilingSprite */ 202),
	    BitmapText:     __webpack_require__(/*! ./BitmapText */ 200)
	};


/***/ },
/* 63 */
/*!***************************************************!*\
  !*** ./~/pixi.js/src/filters/blur/BlurYFilter.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * The BlurYFilter applies a horizontal Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function BlurYFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        fs.readFileSync(__dirname + '/blurY.vert', 'utf8'),
	        // fragment shader
	        fs.readFileSync(__dirname + '/blur.frag', 'utf8'),
	        // set the uniforms
	        {
	            strength: { type: '1f', value: 1 }
	        }
	    );
	
	    this.passes = 1;
	    this.strength = 4;
	}
	
	BlurYFilter.prototype = Object.create(core.AbstractFilter.prototype);
	BlurYFilter.prototype.constructor = BlurYFilter;
	module.exports = BlurYFilter;
	
	BlurYFilter.prototype.applyFilter = function (renderer, input, output, clear)
	{
	    var shader = this.getShader(renderer);
	
	    this.uniforms.strength.value = Math.abs(this.strength) / 4 / this.passes * (input.frame.height / input.size.height);
	
	    if(this.passes === 1)
	    {
	        renderer.filterManager.applyFilter(shader, input, output, clear);
	    }
	    else
	    {
	        var renderTarget = renderer.filterManager.getRenderTarget(true);
	        var flip = input;
	        var flop = renderTarget;
	
	        for(var i = 0; i < this.passes-1; i++)
	        {
	            renderer.filterManager.applyFilter(shader, flip, flop, true);
	
	           var temp = flop;
	           flop = flip;
	           flip = temp;
	        }
	
	        renderer.filterManager.applyFilter(shader, flip, output, clear);
	
	        renderer.filterManager.returnRenderTarget(renderTarget);
	    }
	};
	
	
	Object.defineProperties(BlurYFilter.prototype, {
	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.BlurYFilter#
	     * @default 2
	     */
	    blur: {
	        get: function ()
	        {
	            return  this.strength;
	        },
	        set: function (value)
	        {
	            this.padding = Math.abs(value) * 0.5;
	            this.strength = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 64 */
/*!***********************************************!*\
  !*** ./assets/js/src/stores/MainMenuStore.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var _events = __webpack_require__(/*! events */ 55);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _AppDispatcher = __webpack_require__(/*! ./../dispatcher/AppDispatcher */ 21);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _AppConstants = __webpack_require__(/*! ./../constants/AppConstants */ 20);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHANGE_EVENT = 'change';
	var _menuOpen = false;
	
	var MainMenuStore = Object.assign({}, _events2.default.EventEmitter.prototype, {
	  /**
	   * Returns the current breakpoint
	   * @returns {String} the current breakpoint
	   */
	
	  getState: function getState() {
	    return {
	      menuOpen: _menuOpen
	    };
	  },
	
	
	  /**
	   * Emits change event
	   * @returns {undefined} undefined
	   */
	  emitChange: function emitChange() {
	    this.emit(CHANGE_EVENT);
	  },
	
	
	  /**
	   * Ads a listener function to the store
	   * @param {Function} callback A function to add as a callback
	   * @returns {undefined} undefined
	   */
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	
	
	  /**
	   * Removes a listener function from the store
	   * @param {Function} callback A function to remove from the callbacks
	   * @returns {undefined} undefined
	   */
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	
	
	  /**
	   * Listens for events and takes action accordingly
	   * @returns {Boolean} true
	   */
	  dispatcherIndex: _AppDispatcher2.default.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.actionType) {
	
	      case _AppConstants2.default.OPEN_MAIN_MENU:
	        _menuOpen = true;
	
	        MainMenuStore.emitChange();
	        break;
	
	      case _AppConstants2.default.CLOSE_MAIN_MENU:
	        _menuOpen = false;
	
	        MainMenuStore.emitChange();
	        break;
	
	      default:
	        break;
	    }
	
	    return true;
	  })
	});
	
	module.exports = MainMenuStore;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "MainMenuStore.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 65 */
/*!**************************************!*\
  !*** ./~/react/lib/CallbackQueue.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(/*! ./PooledClass */ 22);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 66 */
/*!**********************************************!*\
  !*** ./~/react/lib/DOMPropertyOperations.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(/*! ./DOMProperty */ 26);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	
	var quoteAttributeValueForBrowser = __webpack_require__(/*! ./quoteAttributeValueForBrowser */ 310);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 67 */
/*!*****************************************!*\
  !*** ./~/react/lib/LinkedValueUtils.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(/*! ./ReactPropTypes */ 148);
	var ReactPropTypeLocations = __webpack_require__(/*! ./ReactPropTypeLocations */ 47);
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 68 */
/*!*********************************************************!*\
  !*** ./~/react/lib/ReactComponentBrowserEnvironment.js ***!
  \*********************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(/*! ./ReactDOMIDOperations */ 70);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 69 */
/*!**************************************************!*\
  !*** ./~/react/lib/ReactComponentEnvironment.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 70 */
/*!*********************************************!*\
  !*** ./~/react/lib/ReactDOMIDOperations.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(/*! ./DOMChildrenOperations */ 128);
	var DOMPropertyOperations = __webpack_require__(/*! ./DOMPropertyOperations */ 66);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 71 */
/*!*****************************************!*\
  !*** ./~/react/lib/ReactUpdateQueue.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(/*! ./ReactCurrentOwner */ 17);
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactInstanceMap = __webpack_require__(/*! ./ReactInstanceMap */ 33);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 72 */
/*!*************************************!*\
  !*** ./~/react/lib/ReactVersion.js ***!
  \*************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.8';

/***/ },
/* 73 */
/*!************************************!*\
  !*** ./~/react/lib/findDOMNode.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(/*! ./ReactCurrentOwner */ 17);
	var ReactInstanceMap = __webpack_require__(/*! ./ReactInstanceMap */ 33);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ },
/* 74 */
/*!*****************************************!*\
  !*** ./~/react/lib/getEventCharCode.js ***!
  \*****************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 75 */
/*!**********************************************!*\
  !*** ./~/react/lib/getEventModifierState.js ***!
  \**********************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 76 */
/*!***************************************!*\
  !*** ./~/react/lib/getEventTarget.js ***!
  \***************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 77 */
/*!**************************************!*\
  !*** ./~/react/lib/getIteratorFn.js ***!
  \**************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 78 */
/*!**************************************************!*\
  !*** ./~/react/lib/instantiateReactComponent.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(/*! ./ReactCompositeComponent */ 271);
	var ReactEmptyComponent = __webpack_require__(/*! ./ReactEmptyComponent */ 140);
	var ReactNativeComponent = __webpack_require__(/*! ./ReactNativeComponent */ 146);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 79 */
/*!*****************************************!*\
  !*** ./~/react/lib/isEventSupported.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 80 */
/*!***************************************!*\
  !*** ./~/react/lib/setTextContent.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	var escapeTextContentForBrowser = __webpack_require__(/*! ./escapeTextContentForBrowser */ 51);
	var setInnerHTML = __webpack_require__(/*! ./setInnerHTML */ 52);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 81 */
/*!***************************************************!*\
  !*** ./~/react/lib/shouldUpdateReactComponent.js ***!
  \***************************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 82 */
/*!********************************************!*\
  !*** ./~/react/lib/traverseAllChildren.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(/*! ./ReactCurrentOwner */ 17);
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactInstanceHandles = __webpack_require__(/*! ./ReactInstanceHandles */ 27);
	
	var getIteratorFn = __webpack_require__(/*! ./getIteratorFn */ 77);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 83 */
/*!*******************************************!*\
  !*** ./~/react/lib/validateDOMNesting.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var emptyFunction = __webpack_require__(/*! fbjs/lib/emptyFunction */ 15);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 84 */
/*!*******************************************!*\
  !*** ./~/resource-loader/src/Resource.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var EventEmitter = __webpack_require__(/*! eventemitter3 */ 18),
	    _url = __webpack_require__(/*! url */ 156),
	    // tests is CORS is supported in XHR, if not we need to use XDR
	    useXdr = !!(window.XDomainRequest && !('withCredentials' in (new XMLHttpRequest()))),
	    tempAnchor = null;
	
	/**
	 * Manages the state and loading of a single resource represented by
	 * a single URL.
	 *
	 * @class
	 * @param name {string} The name of the resource to load.
	 * @param url {string|string[]} The url for this resource, for audio/video loads you can pass an array of sources.
	 * @param [options] {object} The options for the load.
	 * @param [options.crossOrigin] {string|boolean} Is this request cross-origin? Default is to determine automatically.
	 * @param [options.loadType=Resource.LOAD_TYPE.XHR] {Resource.LOAD_TYPE} How should this resource be loaded?
	 * @param [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] {Resource.XHR_RESPONSE_TYPE} How should the data being
	 *      loaded be interpreted when using XHR?
	 * @param [options.metadata] {object} Extra info for middleware.
	 */
	function Resource(name, url, options) {
	    EventEmitter.call(this);
	
	    options = options || {};
	
	    if (typeof name !== 'string' || typeof url !== 'string') {
	        throw new Error('Both name and url are required for constructing a resource.');
	    }
	
	    /**
	     * The name of this resource.
	     *
	     * @member {string}
	     * @readonly
	     */
	    this.name = name;
	
	    /**
	     * The url used to load this resource.
	     *
	     * @member {string}
	     * @readonly
	     */
	    this.url = url;
	
	    /**
	     * Stores whether or not this url is a data url.
	     *
	     * @member {boolean}
	     * @readonly
	     */
	    this.isDataUrl = this.url.indexOf('data:') === 0;
	
	    /**
	     * The data that was loaded by the resource.
	     *
	     * @member {any}
	     */
	    this.data = null;
	
	    /**
	     * Is this request cross-origin? If unset, determined automatically.
	     *
	     * @member {string}
	     */
	    this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;
	
	    /**
	     * The method of loading to use for this resource.
	     *
	     * @member {Resource.LOAD_TYPE}
	     */
	    this.loadType = options.loadType || this._determineLoadType();
	
	    /**
	     * The type used to load the resource via XHR. If unset, determined automatically.
	     *
	     * @member {string}
	     */
	    this.xhrType = options.xhrType;
	
	    /**
	     * Extra info for middleware
	     *
	     * @member {object}
	     */
	    this.metadata = options.metadata || {};
	
	    /**
	     * The error that occurred while loading (if any).
	     *
	     * @member {Error}
	     * @readonly
	     */
	    this.error = null;
	
	    /**
	     * The XHR object that was used to load this resource. This is only set
	     * when `loadType` is `Resource.LOAD_TYPE.XHR`.
	     *
	     * @member {XMLHttpRequest}
	     */
	    this.xhr = null;
	
	    /**
	     * Describes if this resource was loaded as json. Only valid after the resource
	     * has completely loaded.
	     *
	     * @member {boolean}
	     */
	    this.isJson = false;
	
	    /**
	     * Describes if this resource was loaded as xml. Only valid after the resource
	     * has completely loaded.
	     *
	     * @member {boolean}
	     */
	    this.isXml = false;
	
	    /**
	     * Describes if this resource was loaded as an image tag. Only valid after the resource
	     * has completely loaded.
	     *
	     * @member {boolean}
	     */
	    this.isImage = false;
	
	    /**
	     * Describes if this resource was loaded as an audio tag. Only valid after the resource
	     * has completely loaded.
	     *
	     * @member {boolean}
	     */
	    this.isAudio = false;
	
	    /**
	     * Describes if this resource was loaded as a video tag. Only valid after the resource
	     * has completely loaded.
	     *
	     * @member {boolean}
	     */
	    this.isVideo = false;
	
	    /**
	     * The `dequeue` method that will be used a storage place for the async queue dequeue method
	     * used privately by the loader.
	     *
	     * @member {function}
	     * @private
	     */
	    this._dequeue = null;
	
	    /**
	     * The `complete` function bound to this resource's context.
	     *
	     * @member {function}
	     * @private
	     */
	    this._boundComplete = this.complete.bind(this);
	
	    /**
	     * The `_onError` function bound to this resource's context.
	     *
	     * @member {function}
	     * @private
	     */
	    this._boundOnError = this._onError.bind(this);
	
	    /**
	     * The `_onProgress` function bound to this resource's context.
	     *
	     * @member {function}
	     * @private
	     */
	    this._boundOnProgress = this._onProgress.bind(this);
	
	    // xhr callbacks
	    this._boundXhrOnError = this._xhrOnError.bind(this);
	    this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
	    this._boundXhrOnLoad = this._xhrOnLoad.bind(this);
	    this._boundXdrOnTimeout = this._xdrOnTimeout.bind(this);
	
	    /**
	     * Emitted when the resource beings to load.
	     *
	     * @event start
	     * @memberof Resource#
	     */
	
	    /**
	     * Emitted each time progress of this resource load updates.
	     * Not all resources types and loader systems can support this event
	     * so sometimes it may not be available. If the resource
	     * is being loaded on a modern browser, using XHR, and the remote server
	     * properly sets Content-Length headers, then this will be available.
	     *
	     * @event progress
	     * @memberof Resource#
	     */
	
	    /**
	     * Emitted once this resource has loaded, if there was an error it will
	     * be in the `error` property.
	     *
	     * @event complete
	     * @memberof Resource#
	     */
	}
	
	Resource.prototype = Object.create(EventEmitter.prototype);
	Resource.prototype.constructor = Resource;
	module.exports = Resource;
	
	/**
	 * Marks the resource as complete.
	 *
	 * @fires complete
	 */
	Resource.prototype.complete = function () {
	    // TODO: Clean this up in a wrapper or something...gross....
	    if (this.data && this.data.removeEventListener) {
	        this.data.removeEventListener('error', this._boundOnError);
	        this.data.removeEventListener('load', this._boundComplete);
	        this.data.removeEventListener('progress', this._boundOnProgress);
	        this.data.removeEventListener('canplaythrough', this._boundComplete);
	    }
	
	    if (this.xhr) {
	        if (this.xhr.removeEventListener) {
	            this.xhr.removeEventListener('error', this._boundXhrOnError);
	            this.xhr.removeEventListener('abort', this._boundXhrOnAbort);
	            this.xhr.removeEventListener('progress', this._boundOnProgress);
	            this.xhr.removeEventListener('load', this._boundXhrOnLoad);
	        }
	        else {
	            this.xhr.onerror = null;
	            this.xhr.ontimeout = null;
	            this.xhr.onprogress = null;
	            this.xhr.onload = null;
	        }
	    }
	
	    this.emit('complete', this);
	};
	
	/**
	 * Kicks off loading of this resource.
	 *
	 * @fires start
	 * @param [callback] {function} Optional callback to call once the resource is loaded.
	 */
	Resource.prototype.load = function (cb) {
	    this.emit('start', this);
	
	    // if a callback is set, listen for complete event
	    if (cb) {
	        this.once('complete', cb);
	    }
	
	    // if unset, determine the value
	    if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') {
	        this.crossOrigin = this._determineCrossOrigin(this.url);
	    }
	
	    switch(this.loadType) {
	        case Resource.LOAD_TYPE.IMAGE:
	            this._loadImage();
	            break;
	
	        case Resource.LOAD_TYPE.AUDIO:
	            this._loadElement('audio');
	            break;
	
	        case Resource.LOAD_TYPE.VIDEO:
	            this._loadElement('video');
	            break;
	
	        case Resource.LOAD_TYPE.XHR:
	            /* falls through */
	        default:
	            if (useXdr && this.crossOrigin) {
	                this._loadXdr();
	            }
	            else {
	                this._loadXhr();
	            }
	            break;
	    }
	};
	
	/**
	 * Loads this resources using an Image object.
	 *
	 * @private
	 */
	Resource.prototype._loadImage = function () {
	    this.data = new Image();
	
	    if (this.crossOrigin) {
	        this.data.crossOrigin = this.crossOrigin;
	    }
	
	    this.data.src = this.url;
	
	    this.isImage = true;
	
	    this.data.addEventListener('error', this._boundOnError, false);
	    this.data.addEventListener('load', this._boundComplete, false);
	    this.data.addEventListener('progress', this._boundOnProgress, false);
	};
	
	/**
	 * Loads this resources using an HTMLAudioElement or HTMLVideoElement.
	 *
	 * @private
	 */
	Resource.prototype._loadElement = function (type) {
	    if (type === 'audio' && typeof Audio !== 'undefined') {
	        this.data = new Audio();
	    }
	    else {
	        this.data = document.createElement(type);
	    }
	
	    if (this.data === null) {
	        this.error = new Error('Unsupported element ' + type);
	        this.complete();
	        return;
	    }
	
	    // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
	    if (navigator.isCocoonJS) {
	        this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
	    }
	    else {
	        if (Array.isArray(this.url)) {
	            for (var i = 0; i < this.url.length; ++i) {
	                this.data.appendChild(this._createSource(type, this.url[i]));
	            }
	        }
	        else {
	            this.data.appendChild(this._createSource(type, this.url));
	        }
	    }
	
	    this['is' + type[0].toUpperCase() + type.substring(1)] = true;
	
	    this.data.addEventListener('error', this._boundOnError, false);
	    this.data.addEventListener('load', this._boundComplete, false);
	    this.data.addEventListener('progress', this._boundOnProgress, false);
	    this.data.addEventListener('canplaythrough', this._boundComplete, false);
	
	    this.data.load();
	};
	
	/**
	 * Loads this resources using an XMLHttpRequest.
	 *
	 * @private
	 */
	Resource.prototype._loadXhr = function () {
	    // if unset, determine the value
	    if (typeof this.xhrType !== 'string') {
	        this.xhrType = this._determineXhrType();
	    }
	
	    var xhr = this.xhr = new XMLHttpRequest();
	
	    // set the request type and url
	    xhr.open('GET', this.url, true);
	
	    // load json as text and parse it ourselves. We do this because some browsers
	    // *cough* safari *cough* can't deal with it.
	    if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON || this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	        xhr.responseType = Resource.XHR_RESPONSE_TYPE.TEXT;
	    }
	    else {
	        xhr.responseType = this.xhrType;
	    }
	
	    xhr.addEventListener('error', this._boundXhrOnError, false);
	    xhr.addEventListener('abort', this._boundXhrOnAbort, false);
	    xhr.addEventListener('progress', this._boundOnProgress, false);
	    xhr.addEventListener('load', this._boundXhrOnLoad, false);
	
	    xhr.send();
	};
	
	/**
	 * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
	 *
	 * @private
	 */
	Resource.prototype._loadXdr = function () {
	    // if unset, determine the value
	    if (typeof this.xhrType !== 'string') {
	        this.xhrType = this._determineXhrType();
	    }
	
	    var xdr = this.xhr = new XDomainRequest();
	
	    // XDomainRequest has a few quirks. Occasionally it will abort requests
	    // A way to avoid this is to make sure ALL callbacks are set even if not used
	    // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
	    xdr.timeout = 5000;
	
	    xdr.onerror = this._boundXhrOnError;
	    xdr.ontimeout = this._boundXdrOnTimeout;
	    xdr.onprogress = this._boundOnProgress;
	    xdr.onload = this._boundXhrOnLoad;
	
	    xdr.open('GET', this.url, true);
	
	    //  Note: The xdr.send() call is wrapped in a timeout to prevent an issue with the interface where some requests are lost
	    //  if multiple XDomainRequests are being sent at the same time.
	    // Some info here: https://github.com/photonstorm/phaser/issues/1248
	    setTimeout(function () {
	        xdr.send();
	    }, 0);
	};
	
	/**
	 * Creates a source used in loading via an element.
	 *
	 * @param type {string} The element type (video or audio).
	 * @param url {string} The source URL to load from.
	 * @param [mime] {string} The mime type of the video
	 * @private
	 */
	Resource.prototype._createSource = function (type, url, mime) {
	    if (!mime) {
	        mime = type + '/' + url.substr(url.lastIndexOf('.') + 1);
	    }
	
	    var source = document.createElement('source');
	
	    source.src = url;
	    source.type = mime;
	
	    return source;
	};
	
	/**
	 * Called if a load errors out.
	 *
	 * @param event {Event} The error event from the element that emits it.
	 * @private
	 */
	Resource.prototype._onError = function (event) {
	    this.error = new Error('Failed to load element using ' + event.target.nodeName);
	    this.complete();
	};
	
	/**
	 * Called if a load progress event fires for xhr/xdr.
	 *
	 * @fires progress
	 * @param event {XMLHttpRequestProgressEvent|Event}
	 * @private
	 */
	Resource.prototype._onProgress =  function (event) {
	    if (event && event.lengthComputable) {
	        this.emit('progress', this, event.loaded / event.total);
	    }
	};
	
	/**
	 * Called if an error event fires for xhr/xdr.
	 *
	 * @param event {XMLHttpRequestErrorEvent|Event}
	 * @private
	 */
	Resource.prototype._xhrOnError = function () {
	    this.error = new Error(
	        reqType(this.xhr) + ' Request failed. ' +
	        'Status: ' + this.xhr.status + ', text: "' + this.xhr.statusText + '"'
	    );
	
	    this.complete();
	};
	
	/**
	 * Called if an abort event fires for xhr.
	 *
	 * @param event {XMLHttpRequestAbortEvent}
	 * @private
	 */
	Resource.prototype._xhrOnAbort = function () {
	    this.error = new Error(reqType(this.xhr) + ' Request was aborted by the user.');
	    this.complete();
	};
	
	/**
	 * Called if a timeout event fires for xdr.
	 *
	 * @param event {Event}
	 * @private
	 */
	Resource.prototype._xdrOnTimeout = function () {
	    this.error = new Error(reqType(this.xhr) + ' Request timed out.');
	    this.complete();
	};
	
	/**
	 * Called when data successfully loads from an xhr/xdr request.
	 *
	 * @param event {XMLHttpRequestLoadEvent|Event}
	 * @private
	 */
	Resource.prototype._xhrOnLoad = function () {
	    var xhr = this.xhr,
	        status = xhr.status !== undefined ? xhr.status : 200; //XDR has no `.status`, assume 200.
	
	    // status can be 0 when using the file:// protocol, also check if a response was found
	    if (status === 200 || status === 204 || (status === 0 && xhr.responseText.length > 0)) {
	        // if text, just return it
	        if (this.xhrType === Resource.XHR_RESPONSE_TYPE.TEXT) {
	            this.data = xhr.responseText;
	        }
	        // if json, parse into json object
	        else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON) {
	            try {
	                this.data = JSON.parse(xhr.responseText);
	                this.isJson = true;
	            } catch(e) {
	                this.error = new Error('Error trying to parse loaded json:', e);
	            }
	        }
	        // if xml, parse into an xml document or div element
	        else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	            try {
	                if (window.DOMParser) {
	                    var domparser = new DOMParser();
	                    this.data = domparser.parseFromString(xhr.responseText, 'text/xml');
	                }
	                else {
	                    var div = document.createElement('div');
	                    div.innerHTML = xhr.responseText;
	                    this.data = div;
	                }
	                this.isXml = true;
	            } catch (e) {
	                this.error = new Error('Error trying to parse loaded xml:', e);
	            }
	        }
	        // other types just return the response
	        else {
	            this.data = xhr.response || xhr.responseText;
	        }
	    }
	    else {
	        this.error = new Error('[' + xhr.status + ']' + xhr.statusText + ':' + xhr.responseURL);
	    }
	
	    this.complete();
	};
	
	function reqType(xhr) {
	    return xhr.toString().replace('object ', '');
	}
	
	/**
	 * Sets the `crossOrigin` property for this resource based on if the url
	 * for this resource is cross-origin. If crossOrigin was manually set, this
	 * function does nothing.
	 *
	 * @private
	 * @param url {string} The url to test.
	 * @param [location=window.location] {object} The location object to test against.
	 * @return {string} The crossOrigin value to use (or empty string for none).
	 */
	Resource.prototype._determineCrossOrigin = function (url, loc) {
	    // data: and javascript: urls are considered same-origin
	    if (url.indexOf('data:') === 0) {
	        return '';
	    }
	
	    // default is window.location
	    loc = loc || window.location;
	
	    if (!tempAnchor) {
	        tempAnchor = document.createElement('a');
	    }
	
	    // let the browser determine the full href for the url of this resource and then
	    // parse with the node url lib, we can't use the properties of the anchor element
	    // because they don't work in IE9 :(
	    tempAnchor.href = url;
	    url = _url.parse(tempAnchor.href);
	
	    var samePort = (!url.port && loc.port === '') || (url.port === loc.port);
	
	    // if cross origin
	    if (url.hostname !== loc.hostname || !samePort || url.protocol !== loc.protocol) {
	        return 'anonymous';
	    }
	
	    return '';
	};
	
	/**
	 * Determines the responseType of an XHR request based on the extension of the
	 * resource being loaded.
	 *
	 * @private
	 * @return {Resource.XHR_RESPONSE_TYPE} The responseType to use.
	 */
	Resource.prototype._determineXhrType = function () {
	    return Resource._xhrTypeMap[this._getExtension()] || Resource.XHR_RESPONSE_TYPE.TEXT;
	};
	
	Resource.prototype._determineLoadType = function () {
	    return Resource._loadTypeMap[this._getExtension()] || Resource.LOAD_TYPE.XHR;
	};
	
	Resource.prototype._getExtension = function () {
	    var url = this.url,
	        ext;
	
	    if (this.isDataUrl) {
	        var slashIndex = url.indexOf('/');
	        ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
	    }
	    else {
	        var queryStart = url.indexOf('?');
	        if (queryStart !== -1) {
	            url = url.substring(0, queryStart);
	        }
	
	        ext = url.substring(url.lastIndexOf('.') + 1);
	    }
	
	    return ext.toLowerCase();
	};
	
	/**
	 * Determines the mime type of an XHR request based on the responseType of
	 * resource being loaded.
	 *
	 * @private
	 * @return {string} The mime type to use.
	 */
	Resource.prototype._getMimeFromXhrType = function (type) {
	    switch(type) {
	        case Resource.XHR_RESPONSE_TYPE.BUFFER:
	            return 'application/octet-binary';
	
	        case Resource.XHR_RESPONSE_TYPE.BLOB:
	            return 'application/blob';
	
	        case Resource.XHR_RESPONSE_TYPE.DOCUMENT:
	            return 'application/xml';
	
	        case Resource.XHR_RESPONSE_TYPE.JSON:
	            return 'application/json';
	
	        case Resource.XHR_RESPONSE_TYPE.DEFAULT:
	        case Resource.XHR_RESPONSE_TYPE.TEXT:
	            /* falls through */
	        default:
	            return 'text/plain';
	
	    }
	};
	
	/**
	 * The types of loading a resource can use.
	 *
	 * @static
	 * @constant
	 * @property {object} LOAD_TYPE
	 * @property {number} LOAD_TYPE.XHR - Uses XMLHttpRequest to load the resource.
	 * @property {number} LOAD_TYPE.IMAGE - Uses an `Image` object to load the resource.
	 * @property {number} LOAD_TYPE.AUDIO - Uses an `Audio` object to load the resource.
	 * @property {number} LOAD_TYPE.VIDEO - Uses a `Video` object to load the resource.
	 */
	Resource.LOAD_TYPE = {
	    XHR:    1,
	    IMAGE:  2,
	    AUDIO:  3,
	    VIDEO:  4
	};
	
	/**
	 * The XHR ready states, used internally.
	 *
	 * @static
	 * @constant
	 * @property {object} XHR_READY_STATE
	 * @property {number} XHR_READY_STATE.UNSENT - open()has not been called yet.
	 * @property {number} XHR_READY_STATE.OPENED - send()has not been called yet.
	 * @property {number} XHR_READY_STATE.HEADERS_RECEIVED - send() has been called, and headers and status are available.
	 * @property {number} XHR_READY_STATE.LOADING - Downloading; responseText holds partial data.
	 * @property {number} XHR_READY_STATE.DONE - The operation is complete.
	 */
	Resource.XHR_READY_STATE = {
	    UNSENT: 0,
	    OPENED: 1,
	    HEADERS_RECEIVED: 2,
	    LOADING: 3,
	    DONE: 4
	};
	
	/**
	 * The XHR ready states, used internally.
	 *
	 * @static
	 * @constant
	 * @property {object} XHR_RESPONSE_TYPE
	 * @property {string} XHR_RESPONSE_TYPE.DEFAULT - defaults to text
	 * @property {string} XHR_RESPONSE_TYPE.BUFFER - ArrayBuffer
	 * @property {string} XHR_RESPONSE_TYPE.BLOB - Blob
	 * @property {string} XHR_RESPONSE_TYPE.DOCUMENT - Document
	 * @property {string} XHR_RESPONSE_TYPE.JSON - Object
	 * @property {string} XHR_RESPONSE_TYPE.TEXT - String
	 */
	Resource.XHR_RESPONSE_TYPE = {
	    DEFAULT:    'text',
	    BUFFER:     'arraybuffer',
	    BLOB:       'blob',
	    DOCUMENT:   'document',
	    JSON:       'json',
	    TEXT:       'text'
	};
	
	Resource._loadTypeMap = {
	    'gif':      Resource.LOAD_TYPE.IMAGE,
	    'png':      Resource.LOAD_TYPE.IMAGE,
	    'bmp':      Resource.LOAD_TYPE.IMAGE,
	    'jpg':      Resource.LOAD_TYPE.IMAGE,
	    'jpeg':     Resource.LOAD_TYPE.IMAGE,
	    'tif':      Resource.LOAD_TYPE.IMAGE,
	    'tiff':     Resource.LOAD_TYPE.IMAGE,
	    'webp':     Resource.LOAD_TYPE.IMAGE,
	    'tga':      Resource.LOAD_TYPE.IMAGE,
	    'svg+xml':  Resource.LOAD_TYPE.IMAGE
	};
	
	Resource._xhrTypeMap = {
	    // xml
	    'xhtml':    Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    'html':     Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    'htm':      Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    'xml':      Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    'tmx':      Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    'tsx':      Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    'svg':      Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	
	    // images
	    'gif':      Resource.XHR_RESPONSE_TYPE.BLOB,
	    'png':      Resource.XHR_RESPONSE_TYPE.BLOB,
	    'bmp':      Resource.XHR_RESPONSE_TYPE.BLOB,
	    'jpg':      Resource.XHR_RESPONSE_TYPE.BLOB,
	    'jpeg':     Resource.XHR_RESPONSE_TYPE.BLOB,
	    'tif':      Resource.XHR_RESPONSE_TYPE.BLOB,
	    'tiff':     Resource.XHR_RESPONSE_TYPE.BLOB,
	    'webp':     Resource.XHR_RESPONSE_TYPE.BLOB,
	    'tga':      Resource.XHR_RESPONSE_TYPE.BLOB,
	
	    // json
	    'json':     Resource.XHR_RESPONSE_TYPE.JSON,
	
	    // text
	    'text':     Resource.XHR_RESPONSE_TYPE.TEXT,
	    'txt':      Resource.XHR_RESPONSE_TYPE.TEXT
	};
	
	/**
	 * Sets the load type to be used for a specific extension.
	 *
	 * @static
	 * @param extname {string} The extension to set the type for, e.g. "png" or "fnt"
	 * @param loadType {Resource.LOAD_TYPE} The load type to set it to.
	 */
	Resource.setExtensionLoadType = function (extname, loadType) {
	    setExtMap(Resource._loadTypeMap, extname, loadType);
	};
	
	/**
	 * Sets the load type to be used for a specific extension.
	 *
	 * @static
	 * @param extname {string} The extension to set the type for, e.g. "png" or "fnt"
	 * @param xhrType {Resource.XHR_RESPONSE_TYPE} The xhr type to set it to.
	 */
	Resource.setExtensionXhrType = function (extname, xhrType) {
	    setExtMap(Resource._xhrTypeMap, extname, xhrType);
	};
	
	function setExtMap(map, extname, val) {
	    if (extname && extname.indexOf('.') === 0) {
	        extname = extname.substring(1);
	    }
	
	    if (!extname) {
	        return;
	    }
	
	    map[extname] = val;
	}


/***/ },
/* 85 */
/*!******************************!*\
  !*** ./~/async/lib/async.js ***!
  \******************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, setImmediate, process) {/*!
	 * async
	 * https://github.com/caolan/async
	 *
	 * Copyright 2010-2014 Caolan McMahon
	 * Released under the MIT license
	 */
	(function () {
	
	    var async = {};
	    function noop() {}
	    function identity(v) {
	        return v;
	    }
	    function toBool(v) {
	        return !!v;
	    }
	    function notId(v) {
	        return !v;
	    }
	
	    // global on the server, window in the browser
	    var previous_async;
	
	    // Establish the root object, `window` (`self`) in the browser, `global`
	    // on the server, or `this` in some virtual machines. We use `self`
	    // instead of `window` for `WebWorker` support.
	    var root = typeof self === 'object' && self.self === self && self ||
	            typeof global === 'object' && global.global === global && global ||
	            this;
	
	    if (root != null) {
	        previous_async = root.async;
	    }
	
	    async.noConflict = function () {
	        root.async = previous_async;
	        return async;
	    };
	
	    function only_once(fn) {
	        return function() {
	            if (fn === null) throw new Error("Callback was already called.");
	            fn.apply(this, arguments);
	            fn = null;
	        };
	    }
	
	    function _once(fn) {
	        return function() {
	            if (fn === null) return;
	            fn.apply(this, arguments);
	            fn = null;
	        };
	    }
	
	    //// cross-browser compatiblity functions ////
	
	    var _toString = Object.prototype.toString;
	
	    var _isArray = Array.isArray || function (obj) {
	        return _toString.call(obj) === '[object Array]';
	    };
	
	    // Ported from underscore.js isObject
	    var _isObject = function(obj) {
	        var type = typeof obj;
	        return type === 'function' || type === 'object' && !!obj;
	    };
	
	    function _isArrayLike(arr) {
	        return _isArray(arr) || (
	            // has a positive integer length property
	            typeof arr.length === "number" &&
	            arr.length >= 0 &&
	            arr.length % 1 === 0
	        );
	    }
	
	    function _arrayEach(arr, iterator) {
	        var index = -1,
	            length = arr.length;
	
	        while (++index < length) {
	            iterator(arr[index], index, arr);
	        }
	    }
	
	    function _map(arr, iterator) {
	        var index = -1,
	            length = arr.length,
	            result = Array(length);
	
	        while (++index < length) {
	            result[index] = iterator(arr[index], index, arr);
	        }
	        return result;
	    }
	
	    function _range(count) {
	        return _map(Array(count), function (v, i) { return i; });
	    }
	
	    function _reduce(arr, iterator, memo) {
	        _arrayEach(arr, function (x, i, a) {
	            memo = iterator(memo, x, i, a);
	        });
	        return memo;
	    }
	
	    function _forEachOf(object, iterator) {
	        _arrayEach(_keys(object), function (key) {
	            iterator(object[key], key);
	        });
	    }
	
	    function _indexOf(arr, item) {
	        for (var i = 0; i < arr.length; i++) {
	            if (arr[i] === item) return i;
	        }
	        return -1;
	    }
	
	    var _keys = Object.keys || function (obj) {
	        var keys = [];
	        for (var k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                keys.push(k);
	            }
	        }
	        return keys;
	    };
	
	    function _keyIterator(coll) {
	        var i = -1;
	        var len;
	        var keys;
	        if (_isArrayLike(coll)) {
	            len = coll.length;
	            return function next() {
	                i++;
	                return i < len ? i : null;
	            };
	        } else {
	            keys = _keys(coll);
	            len = keys.length;
	            return function next() {
	                i++;
	                return i < len ? keys[i] : null;
	            };
	        }
	    }
	
	    // Similar to ES6's rest param (http://ariya.ofilabs.com/2013/03/es6-and-rest-parameter.html)
	    // This accumulates the arguments passed into an array, after a given index.
	    // From underscore.js (https://github.com/jashkenas/underscore/pull/2140).
	    function _restParam(func, startIndex) {
	        startIndex = startIndex == null ? func.length - 1 : +startIndex;
	        return function() {
	            var length = Math.max(arguments.length - startIndex, 0);
	            var rest = Array(length);
	            for (var index = 0; index < length; index++) {
	                rest[index] = arguments[index + startIndex];
	            }
	            switch (startIndex) {
	                case 0: return func.call(this, rest);
	                case 1: return func.call(this, arguments[0], rest);
	            }
	            // Currently unused but handle cases outside of the switch statement:
	            // var args = Array(startIndex + 1);
	            // for (index = 0; index < startIndex; index++) {
	            //     args[index] = arguments[index];
	            // }
	            // args[startIndex] = rest;
	            // return func.apply(this, args);
	        };
	    }
	
	    function _withoutIndex(iterator) {
	        return function (value, index, callback) {
	            return iterator(value, callback);
	        };
	    }
	
	    //// exported async module functions ////
	
	    //// nextTick implementation with browser-compatible fallback ////
	
	    // capture the global reference to guard against fakeTimer mocks
	    var _setImmediate = typeof setImmediate === 'function' && setImmediate;
	
	    var _delay = _setImmediate ? function(fn) {
	        // not a direct alias for IE10 compatibility
	        _setImmediate(fn);
	    } : function(fn) {
	        setTimeout(fn, 0);
	    };
	
	    if (typeof process === 'object' && typeof process.nextTick === 'function') {
	        async.nextTick = process.nextTick;
	    } else {
	        async.nextTick = _delay;
	    }
	    async.setImmediate = _setImmediate ? _delay : async.nextTick;
	
	
	    async.forEach =
	    async.each = function (arr, iterator, callback) {
	        return async.eachOf(arr, _withoutIndex(iterator), callback);
	    };
	
	    async.forEachSeries =
	    async.eachSeries = function (arr, iterator, callback) {
	        return async.eachOfSeries(arr, _withoutIndex(iterator), callback);
	    };
	
	
	    async.forEachLimit =
	    async.eachLimit = function (arr, limit, iterator, callback) {
	        return _eachOfLimit(limit)(arr, _withoutIndex(iterator), callback);
	    };
	
	    async.forEachOf =
	    async.eachOf = function (object, iterator, callback) {
	        callback = _once(callback || noop);
	        object = object || [];
	
	        var iter = _keyIterator(object);
	        var key, completed = 0;
	
	        while ((key = iter()) != null) {
	            completed += 1;
	            iterator(object[key], key, only_once(done));
	        }
	
	        if (completed === 0) callback(null);
	
	        function done(err) {
	            completed--;
	            if (err) {
	                callback(err);
	            }
	            // Check key is null in case iterator isn't exhausted
	            // and done resolved synchronously.
	            else if (key === null && completed <= 0) {
	                callback(null);
	            }
	        }
	    };
	
	    async.forEachOfSeries =
	    async.eachOfSeries = function (obj, iterator, callback) {
	        callback = _once(callback || noop);
	        obj = obj || [];
	        var nextKey = _keyIterator(obj);
	        var key = nextKey();
	        function iterate() {
	            var sync = true;
	            if (key === null) {
	                return callback(null);
	            }
	            iterator(obj[key], key, only_once(function (err) {
	                if (err) {
	                    callback(err);
	                }
	                else {
	                    key = nextKey();
	                    if (key === null) {
	                        return callback(null);
	                    } else {
	                        if (sync) {
	                            async.setImmediate(iterate);
	                        } else {
	                            iterate();
	                        }
	                    }
	                }
	            }));
	            sync = false;
	        }
	        iterate();
	    };
	
	
	
	    async.forEachOfLimit =
	    async.eachOfLimit = function (obj, limit, iterator, callback) {
	        _eachOfLimit(limit)(obj, iterator, callback);
	    };
	
	    function _eachOfLimit(limit) {
	
	        return function (obj, iterator, callback) {
	            callback = _once(callback || noop);
	            obj = obj || [];
	            var nextKey = _keyIterator(obj);
	            if (limit <= 0) {
	                return callback(null);
	            }
	            var done = false;
	            var running = 0;
	            var errored = false;
	
	            (function replenish () {
	                if (done && running <= 0) {
	                    return callback(null);
	                }
	
	                while (running < limit && !errored) {
	                    var key = nextKey();
	                    if (key === null) {
	                        done = true;
	                        if (running <= 0) {
	                            callback(null);
	                        }
	                        return;
	                    }
	                    running += 1;
	                    iterator(obj[key], key, only_once(function (err) {
	                        running -= 1;
	                        if (err) {
	                            callback(err);
	                            errored = true;
	                        }
	                        else {
	                            replenish();
	                        }
	                    }));
	                }
	            })();
	        };
	    }
	
	
	    function doParallel(fn) {
	        return function (obj, iterator, callback) {
	            return fn(async.eachOf, obj, iterator, callback);
	        };
	    }
	    function doParallelLimit(fn) {
	        return function (obj, limit, iterator, callback) {
	            return fn(_eachOfLimit(limit), obj, iterator, callback);
	        };
	    }
	    function doSeries(fn) {
	        return function (obj, iterator, callback) {
	            return fn(async.eachOfSeries, obj, iterator, callback);
	        };
	    }
	
	    function _asyncMap(eachfn, arr, iterator, callback) {
	        callback = _once(callback || noop);
	        arr = arr || [];
	        var results = _isArrayLike(arr) ? [] : {};
	        eachfn(arr, function (value, index, callback) {
	            iterator(value, function (err, v) {
	                results[index] = v;
	                callback(err);
	            });
	        }, function (err) {
	            callback(err, results);
	        });
	    }
	
	    async.map = doParallel(_asyncMap);
	    async.mapSeries = doSeries(_asyncMap);
	    async.mapLimit = doParallelLimit(_asyncMap);
	
	    // reduce only has a series version, as doing reduce in parallel won't
	    // work in many situations.
	    async.inject =
	    async.foldl =
	    async.reduce = function (arr, memo, iterator, callback) {
	        async.eachOfSeries(arr, function (x, i, callback) {
	            iterator(memo, x, function (err, v) {
	                memo = v;
	                callback(err);
	            });
	        }, function (err) {
	            callback(err, memo);
	        });
	    };
	
	    async.foldr =
	    async.reduceRight = function (arr, memo, iterator, callback) {
	        var reversed = _map(arr, identity).reverse();
	        async.reduce(reversed, memo, iterator, callback);
	    };
	
	    async.transform = function (arr, memo, iterator, callback) {
	        if (arguments.length === 3) {
	            callback = iterator;
	            iterator = memo;
	            memo = _isArray(arr) ? [] : {};
	        }
	
	        async.eachOf(arr, function(v, k, cb) {
	            iterator(memo, v, k, cb);
	        }, function(err) {
	            callback(err, memo);
	        });
	    };
	
	    function _filter(eachfn, arr, iterator, callback) {
	        var results = [];
	        eachfn(arr, function (x, index, callback) {
	            iterator(x, function (v) {
	                if (v) {
	                    results.push({index: index, value: x});
	                }
	                callback();
	            });
	        }, function () {
	            callback(_map(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), function (x) {
	                return x.value;
	            }));
	        });
	    }
	
	    async.select =
	    async.filter = doParallel(_filter);
	
	    async.selectLimit =
	    async.filterLimit = doParallelLimit(_filter);
	
	    async.selectSeries =
	    async.filterSeries = doSeries(_filter);
	
	    function _reject(eachfn, arr, iterator, callback) {
	        _filter(eachfn, arr, function(value, cb) {
	            iterator(value, function(v) {
	                cb(!v);
	            });
	        }, callback);
	    }
	    async.reject = doParallel(_reject);
	    async.rejectLimit = doParallelLimit(_reject);
	    async.rejectSeries = doSeries(_reject);
	
	    function _createTester(eachfn, check, getResult) {
	        return function(arr, limit, iterator, cb) {
	            function done() {
	                if (cb) cb(getResult(false, void 0));
	            }
	            function iteratee(x, _, callback) {
	                if (!cb) return callback();
	                iterator(x, function (v) {
	                    if (cb && check(v)) {
	                        cb(getResult(true, x));
	                        cb = iterator = false;
	                    }
	                    callback();
	                });
	            }
	            if (arguments.length > 3) {
	                eachfn(arr, limit, iteratee, done);
	            } else {
	                cb = iterator;
	                iterator = limit;
	                eachfn(arr, iteratee, done);
	            }
	        };
	    }
	
	    async.any =
	    async.some = _createTester(async.eachOf, toBool, identity);
	
	    async.someLimit = _createTester(async.eachOfLimit, toBool, identity);
	
	    async.all =
	    async.every = _createTester(async.eachOf, notId, notId);
	
	    async.everyLimit = _createTester(async.eachOfLimit, notId, notId);
	
	    function _findGetResult(v, x) {
	        return x;
	    }
	    async.detect = _createTester(async.eachOf, identity, _findGetResult);
	    async.detectSeries = _createTester(async.eachOfSeries, identity, _findGetResult);
	    async.detectLimit = _createTester(async.eachOfLimit, identity, _findGetResult);
	
	    async.sortBy = function (arr, iterator, callback) {
	        async.map(arr, function (x, callback) {
	            iterator(x, function (err, criteria) {
	                if (err) {
	                    callback(err);
	                }
	                else {
	                    callback(null, {value: x, criteria: criteria});
	                }
	            });
	        }, function (err, results) {
	            if (err) {
	                return callback(err);
	            }
	            else {
	                callback(null, _map(results.sort(comparator), function (x) {
	                    return x.value;
	                }));
	            }
	
	        });
	
	        function comparator(left, right) {
	            var a = left.criteria, b = right.criteria;
	            return a < b ? -1 : a > b ? 1 : 0;
	        }
	    };
	
	    async.auto = function (tasks, concurrency, callback) {
	        if (typeof arguments[1] === 'function') {
	            // concurrency is optional, shift the args.
	            callback = concurrency;
	            concurrency = null;
	        }
	        callback = _once(callback || noop);
	        var keys = _keys(tasks);
	        var remainingTasks = keys.length;
	        if (!remainingTasks) {
	            return callback(null);
	        }
	        if (!concurrency) {
	            concurrency = remainingTasks;
	        }
	
	        var results = {};
	        var runningTasks = 0;
	
	        var hasError = false;
	
	        var listeners = [];
	        function addListener(fn) {
	            listeners.unshift(fn);
	        }
	        function removeListener(fn) {
	            var idx = _indexOf(listeners, fn);
	            if (idx >= 0) listeners.splice(idx, 1);
	        }
	        function taskComplete() {
	            remainingTasks--;
	            _arrayEach(listeners.slice(0), function (fn) {
	                fn();
	            });
	        }
	
	        addListener(function () {
	            if (!remainingTasks) {
	                callback(null, results);
	            }
	        });
	
	        _arrayEach(keys, function (k) {
	            if (hasError) return;
	            var task = _isArray(tasks[k]) ? tasks[k]: [tasks[k]];
	            var taskCallback = _restParam(function(err, args) {
	                runningTasks--;
	                if (args.length <= 1) {
	                    args = args[0];
	                }
	                if (err) {
	                    var safeResults = {};
	                    _forEachOf(results, function(val, rkey) {
	                        safeResults[rkey] = val;
	                    });
	                    safeResults[k] = args;
	                    hasError = true;
	
	                    callback(err, safeResults);
	                }
	                else {
	                    results[k] = args;
	                    async.setImmediate(taskComplete);
	                }
	            });
	            var requires = task.slice(0, task.length - 1);
	            // prevent dead-locks
	            var len = requires.length;
	            var dep;
	            while (len--) {
	                if (!(dep = tasks[requires[len]])) {
	                    throw new Error('Has nonexistent dependency in ' + requires.join(', '));
	                }
	                if (_isArray(dep) && _indexOf(dep, k) >= 0) {
	                    throw new Error('Has cyclic dependencies');
	                }
	            }
	            function ready() {
	                return runningTasks < concurrency && _reduce(requires, function (a, x) {
	                    return (a && results.hasOwnProperty(x));
	                }, true) && !results.hasOwnProperty(k);
	            }
	            if (ready()) {
	                runningTasks++;
	                task[task.length - 1](taskCallback, results);
	            }
	            else {
	                addListener(listener);
	            }
	            function listener() {
	                if (ready()) {
	                    runningTasks++;
	                    removeListener(listener);
	                    task[task.length - 1](taskCallback, results);
	                }
	            }
	        });
	    };
	
	
	
	    async.retry = function(times, task, callback) {
	        var DEFAULT_TIMES = 5;
	        var DEFAULT_INTERVAL = 0;
	
	        var attempts = [];
	
	        var opts = {
	            times: DEFAULT_TIMES,
	            interval: DEFAULT_INTERVAL
	        };
	
	        function parseTimes(acc, t){
	            if(typeof t === 'number'){
	                acc.times = parseInt(t, 10) || DEFAULT_TIMES;
	            } else if(typeof t === 'object'){
	                acc.times = parseInt(t.times, 10) || DEFAULT_TIMES;
	                acc.interval = parseInt(t.interval, 10) || DEFAULT_INTERVAL;
	            } else {
	                throw new Error('Unsupported argument type for \'times\': ' + typeof t);
	            }
	        }
	
	        var length = arguments.length;
	        if (length < 1 || length > 3) {
	            throw new Error('Invalid arguments - must be either (task), (task, callback), (times, task) or (times, task, callback)');
	        } else if (length <= 2 && typeof times === 'function') {
	            callback = task;
	            task = times;
	        }
	        if (typeof times !== 'function') {
	            parseTimes(opts, times);
	        }
	        opts.callback = callback;
	        opts.task = task;
	
	        function wrappedTask(wrappedCallback, wrappedResults) {
	            function retryAttempt(task, finalAttempt) {
	                return function(seriesCallback) {
	                    task(function(err, result){
	                        seriesCallback(!err || finalAttempt, {err: err, result: result});
	                    }, wrappedResults);
	                };
	            }
	
	            function retryInterval(interval){
	                return function(seriesCallback){
	                    setTimeout(function(){
	                        seriesCallback(null);
	                    }, interval);
	                };
	            }
	
	            while (opts.times) {
	
	                var finalAttempt = !(opts.times-=1);
	                attempts.push(retryAttempt(opts.task, finalAttempt));
	                if(!finalAttempt && opts.interval > 0){
	                    attempts.push(retryInterval(opts.interval));
	                }
	            }
	
	            async.series(attempts, function(done, data){
	                data = data[data.length - 1];
	                (wrappedCallback || opts.callback)(data.err, data.result);
	            });
	        }
	
	        // If a callback is passed, run this as a controll flow
	        return opts.callback ? wrappedTask() : wrappedTask;
	    };
	
	    async.waterfall = function (tasks, callback) {
	        callback = _once(callback || noop);
	        if (!_isArray(tasks)) {
	            var err = new Error('First argument to waterfall must be an array of functions');
	            return callback(err);
	        }
	        if (!tasks.length) {
	            return callback();
	        }
	        function wrapIterator(iterator) {
	            return _restParam(function (err, args) {
	                if (err) {
	                    callback.apply(null, [err].concat(args));
	                }
	                else {
	                    var next = iterator.next();
	                    if (next) {
	                        args.push(wrapIterator(next));
	                    }
	                    else {
	                        args.push(callback);
	                    }
	                    ensureAsync(iterator).apply(null, args);
	                }
	            });
	        }
	        wrapIterator(async.iterator(tasks))();
	    };
	
	    function _parallel(eachfn, tasks, callback) {
	        callback = callback || noop;
	        var results = _isArrayLike(tasks) ? [] : {};
	
	        eachfn(tasks, function (task, key, callback) {
	            task(_restParam(function (err, args) {
	                if (args.length <= 1) {
	                    args = args[0];
	                }
	                results[key] = args;
	                callback(err);
	            }));
	        }, function (err) {
	            callback(err, results);
	        });
	    }
	
	    async.parallel = function (tasks, callback) {
	        _parallel(async.eachOf, tasks, callback);
	    };
	
	    async.parallelLimit = function(tasks, limit, callback) {
	        _parallel(_eachOfLimit(limit), tasks, callback);
	    };
	
	    async.series = function(tasks, callback) {
	        _parallel(async.eachOfSeries, tasks, callback);
	    };
	
	    async.iterator = function (tasks) {
	        function makeCallback(index) {
	            function fn() {
	                if (tasks.length) {
	                    tasks[index].apply(null, arguments);
	                }
	                return fn.next();
	            }
	            fn.next = function () {
	                return (index < tasks.length - 1) ? makeCallback(index + 1): null;
	            };
	            return fn;
	        }
	        return makeCallback(0);
	    };
	
	    async.apply = _restParam(function (fn, args) {
	        return _restParam(function (callArgs) {
	            return fn.apply(
	                null, args.concat(callArgs)
	            );
	        });
	    });
	
	    function _concat(eachfn, arr, fn, callback) {
	        var result = [];
	        eachfn(arr, function (x, index, cb) {
	            fn(x, function (err, y) {
	                result = result.concat(y || []);
	                cb(err);
	            });
	        }, function (err) {
	            callback(err, result);
	        });
	    }
	    async.concat = doParallel(_concat);
	    async.concatSeries = doSeries(_concat);
	
	    async.whilst = function (test, iterator, callback) {
	        callback = callback || noop;
	        if (test()) {
	            var next = _restParam(function(err, args) {
	                if (err) {
	                    callback(err);
	                } else if (test.apply(this, args)) {
	                    iterator(next);
	                } else {
	                    callback.apply(null, [null].concat(args));
	                }
	            });
	            iterator(next);
	        } else {
	            callback(null);
	        }
	    };
	
	    async.doWhilst = function (iterator, test, callback) {
	        var calls = 0;
	        return async.whilst(function() {
	            return ++calls <= 1 || test.apply(this, arguments);
	        }, iterator, callback);
	    };
	
	    async.until = function (test, iterator, callback) {
	        return async.whilst(function() {
	            return !test.apply(this, arguments);
	        }, iterator, callback);
	    };
	
	    async.doUntil = function (iterator, test, callback) {
	        return async.doWhilst(iterator, function() {
	            return !test.apply(this, arguments);
	        }, callback);
	    };
	
	    async.during = function (test, iterator, callback) {
	        callback = callback || noop;
	
	        var next = _restParam(function(err, args) {
	            if (err) {
	                callback(err);
	            } else {
	                args.push(check);
	                test.apply(this, args);
	            }
	        });
	
	        var check = function(err, truth) {
	            if (err) {
	                callback(err);
	            } else if (truth) {
	                iterator(next);
	            } else {
	                callback(null);
	            }
	        };
	
	        test(check);
	    };
	
	    async.doDuring = function (iterator, test, callback) {
	        var calls = 0;
	        async.during(function(next) {
	            if (calls++ < 1) {
	                next(null, true);
	            } else {
	                test.apply(this, arguments);
	            }
	        }, iterator, callback);
	    };
	
	    function _queue(worker, concurrency, payload) {
	        if (concurrency == null) {
	            concurrency = 1;
	        }
	        else if(concurrency === 0) {
	            throw new Error('Concurrency must not be zero');
	        }
	        function _insert(q, data, pos, callback) {
	            if (callback != null && typeof callback !== "function") {
	                throw new Error("task callback must be a function");
	            }
	            q.started = true;
	            if (!_isArray(data)) {
	                data = [data];
	            }
	            if(data.length === 0 && q.idle()) {
	                // call drain immediately if there are no tasks
	                return async.setImmediate(function() {
	                    q.drain();
	                });
	            }
	            _arrayEach(data, function(task) {
	                var item = {
	                    data: task,
	                    callback: callback || noop
	                };
	
	                if (pos) {
	                    q.tasks.unshift(item);
	                } else {
	                    q.tasks.push(item);
	                }
	
	                if (q.tasks.length === q.concurrency) {
	                    q.saturated();
	                }
	            });
	            async.setImmediate(q.process);
	        }
	        function _next(q, tasks) {
	            return function(){
	                workers -= 1;
	
	                var removed = false;
	                var args = arguments;
	                _arrayEach(tasks, function (task) {
	                    _arrayEach(workersList, function (worker, index) {
	                        if (worker === task && !removed) {
	                            workersList.splice(index, 1);
	                            removed = true;
	                        }
	                    });
	
	                    task.callback.apply(task, args);
	                });
	                if (q.tasks.length + workers === 0) {
	                    q.drain();
	                }
	                q.process();
	            };
	        }
	
	        var workers = 0;
	        var workersList = [];
	        var q = {
	            tasks: [],
	            concurrency: concurrency,
	            payload: payload,
	            saturated: noop,
	            empty: noop,
	            drain: noop,
	            started: false,
	            paused: false,
	            push: function (data, callback) {
	                _insert(q, data, false, callback);
	            },
	            kill: function () {
	                q.drain = noop;
	                q.tasks = [];
	            },
	            unshift: function (data, callback) {
	                _insert(q, data, true, callback);
	            },
	            process: function () {
	                while(!q.paused && workers < q.concurrency && q.tasks.length){
	
	                    var tasks = q.payload ?
	                        q.tasks.splice(0, q.payload) :
	                        q.tasks.splice(0, q.tasks.length);
	
	                    var data = _map(tasks, function (task) {
	                        return task.data;
	                    });
	
	                    if (q.tasks.length === 0) {
	                        q.empty();
	                    }
	                    workers += 1;
	                    workersList.push(tasks[0]);
	                    var cb = only_once(_next(q, tasks));
	                    worker(data, cb);
	                }
	            },
	            length: function () {
	                return q.tasks.length;
	            },
	            running: function () {
	                return workers;
	            },
	            workersList: function () {
	                return workersList;
	            },
	            idle: function() {
	                return q.tasks.length + workers === 0;
	            },
	            pause: function () {
	                q.paused = true;
	            },
	            resume: function () {
	                if (q.paused === false) { return; }
	                q.paused = false;
	                var resumeCount = Math.min(q.concurrency, q.tasks.length);
	                // Need to call q.process once per concurrent
	                // worker to preserve full concurrency after pause
	                for (var w = 1; w <= resumeCount; w++) {
	                    async.setImmediate(q.process);
	                }
	            }
	        };
	        return q;
	    }
	
	    async.queue = function (worker, concurrency) {
	        var q = _queue(function (items, cb) {
	            worker(items[0], cb);
	        }, concurrency, 1);
	
	        return q;
	    };
	
	    async.priorityQueue = function (worker, concurrency) {
	
	        function _compareTasks(a, b){
	            return a.priority - b.priority;
	        }
	
	        function _binarySearch(sequence, item, compare) {
	            var beg = -1,
	                end = sequence.length - 1;
	            while (beg < end) {
	                var mid = beg + ((end - beg + 1) >>> 1);
	                if (compare(item, sequence[mid]) >= 0) {
	                    beg = mid;
	                } else {
	                    end = mid - 1;
	                }
	            }
	            return beg;
	        }
	
	        function _insert(q, data, priority, callback) {
	            if (callback != null && typeof callback !== "function") {
	                throw new Error("task callback must be a function");
	            }
	            q.started = true;
	            if (!_isArray(data)) {
	                data = [data];
	            }
	            if(data.length === 0) {
	                // call drain immediately if there are no tasks
	                return async.setImmediate(function() {
	                    q.drain();
	                });
	            }
	            _arrayEach(data, function(task) {
	                var item = {
	                    data: task,
	                    priority: priority,
	                    callback: typeof callback === 'function' ? callback : noop
	                };
	
	                q.tasks.splice(_binarySearch(q.tasks, item, _compareTasks) + 1, 0, item);
	
	                if (q.tasks.length === q.concurrency) {
	                    q.saturated();
	                }
	                async.setImmediate(q.process);
	            });
	        }
	
	        // Start with a normal queue
	        var q = async.queue(worker, concurrency);
	
	        // Override push to accept second parameter representing priority
	        q.push = function (data, priority, callback) {
	            _insert(q, data, priority, callback);
	        };
	
	        // Remove unshift function
	        delete q.unshift;
	
	        return q;
	    };
	
	    async.cargo = function (worker, payload) {
	        return _queue(worker, 1, payload);
	    };
	
	    function _console_fn(name) {
	        return _restParam(function (fn, args) {
	            fn.apply(null, args.concat([_restParam(function (err, args) {
	                if (typeof console === 'object') {
	                    if (err) {
	                        if (console.error) {
	                            console.error(err);
	                        }
	                    }
	                    else if (console[name]) {
	                        _arrayEach(args, function (x) {
	                            console[name](x);
	                        });
	                    }
	                }
	            })]));
	        });
	    }
	    async.log = _console_fn('log');
	    async.dir = _console_fn('dir');
	    /*async.info = _console_fn('info');
	    async.warn = _console_fn('warn');
	    async.error = _console_fn('error');*/
	
	    async.memoize = function (fn, hasher) {
	        var memo = {};
	        var queues = {};
	        var has = Object.prototype.hasOwnProperty;
	        hasher = hasher || identity;
	        var memoized = _restParam(function memoized(args) {
	            var callback = args.pop();
	            var key = hasher.apply(null, args);
	            if (has.call(memo, key)) {   
	                async.setImmediate(function () {
	                    callback.apply(null, memo[key]);
	                });
	            }
	            else if (has.call(queues, key)) {
	                queues[key].push(callback);
	            }
	            else {
	                queues[key] = [callback];
	                fn.apply(null, args.concat([_restParam(function (args) {
	                    memo[key] = args;
	                    var q = queues[key];
	                    delete queues[key];
	                    for (var i = 0, l = q.length; i < l; i++) {
	                        q[i].apply(null, args);
	                    }
	                })]));
	            }
	        });
	        memoized.memo = memo;
	        memoized.unmemoized = fn;
	        return memoized;
	    };
	
	    async.unmemoize = function (fn) {
	        return function () {
	            return (fn.unmemoized || fn).apply(null, arguments);
	        };
	    };
	
	    function _times(mapper) {
	        return function (count, iterator, callback) {
	            mapper(_range(count), iterator, callback);
	        };
	    }
	
	    async.times = _times(async.map);
	    async.timesSeries = _times(async.mapSeries);
	    async.timesLimit = function (count, limit, iterator, callback) {
	        return async.mapLimit(_range(count), limit, iterator, callback);
	    };
	
	    async.seq = function (/* functions... */) {
	        var fns = arguments;
	        return _restParam(function (args) {
	            var that = this;
	
	            var callback = args[args.length - 1];
	            if (typeof callback == 'function') {
	                args.pop();
	            } else {
	                callback = noop;
	            }
	
	            async.reduce(fns, args, function (newargs, fn, cb) {
	                fn.apply(that, newargs.concat([_restParam(function (err, nextargs) {
	                    cb(err, nextargs);
	                })]));
	            },
	            function (err, results) {
	                callback.apply(that, [err].concat(results));
	            });
	        });
	    };
	
	    async.compose = function (/* functions... */) {
	        return async.seq.apply(null, Array.prototype.reverse.call(arguments));
	    };
	
	
	    function _applyEach(eachfn) {
	        return _restParam(function(fns, args) {
	            var go = _restParam(function(args) {
	                var that = this;
	                var callback = args.pop();
	                return eachfn(fns, function (fn, _, cb) {
	                    fn.apply(that, args.concat([cb]));
	                },
	                callback);
	            });
	            if (args.length) {
	                return go.apply(this, args);
	            }
	            else {
	                return go;
	            }
	        });
	    }
	
	    async.applyEach = _applyEach(async.eachOf);
	    async.applyEachSeries = _applyEach(async.eachOfSeries);
	
	
	    async.forever = function (fn, callback) {
	        var done = only_once(callback || noop);
	        var task = ensureAsync(fn);
	        function next(err) {
	            if (err) {
	                return done(err);
	            }
	            task(next);
	        }
	        next();
	    };
	
	    function ensureAsync(fn) {
	        return _restParam(function (args) {
	            var callback = args.pop();
	            args.push(function () {
	                var innerArgs = arguments;
	                if (sync) {
	                    async.setImmediate(function () {
	                        callback.apply(null, innerArgs);
	                    });
	                } else {
	                    callback.apply(null, innerArgs);
	                }
	            });
	            var sync = true;
	            fn.apply(this, args);
	            sync = false;
	        });
	    }
	
	    async.ensureAsync = ensureAsync;
	
	    async.constant = _restParam(function(values) {
	        var args = [null].concat(values);
	        return function (callback) {
	            return callback.apply(this, args);
	        };
	    });
	
	    async.wrapSync =
	    async.asyncify = function asyncify(func) {
	        return _restParam(function (args) {
	            var callback = args.pop();
	            var result;
	            try {
	                result = func.apply(this, args);
	            } catch (e) {
	                return callback(e);
	            }
	            // if result is Promise object
	            if (_isObject(result) && typeof result.then === "function") {
	                result.then(function(value) {
	                    callback(null, value);
	                })["catch"](function(err) {
	                    callback(err.message ? err : new Error(err));
	                });
	            } else {
	                callback(null, result);
	            }
	        });
	    };
	
	    // Node.js
	    if (typeof module === 'object' && module.exports) {
	        module.exports = async;
	    }
	    // AMD / RequireJS
	    else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return async;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    // included directly via <script> tag
	    else {
	        root.async = async;
	    }
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(/*! ./~/timers-browserify/main.js */ 54).setImmediate, __webpack_require__(/*! ./~/process/browser.js */ 44)))

/***/ },
/* 86 */
/*!*************************************!*\
  !*** ./~/fbjs/lib/EventListener.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(/*! ./emptyFunction */ 15);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ },
/* 87 */
/*!************************************!*\
  !*** ./~/fbjs/lib/containsNode.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(/*! ./isTextNode */ 168);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 88 */
/*!*********************************!*\
  !*** ./~/fbjs/lib/focusNode.js ***!
  \*********************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 89 */
/*!****************************************!*\
  !*** ./~/fbjs/lib/getActiveElement.js ***!
  \****************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 90 */
/*!*************************************!*\
  !*** ./~/fbjs/lib/getMarkupWrap.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(/*! ./ExecutionEnvironment */ 8);
	
	var invariant = __webpack_require__(/*! ./invariant */ 2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 91 */
/*!************************************!*\
  !*** ./~/fbjs/lib/shallowEqual.js ***!
  \************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 92 */
/*!************************************!*\
  !*** ./~/path-browserify/index.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./~/process/browser.js */ 44)))

/***/ },
/* 93 */
/*!*********************************************************!*\
  !*** ./~/pixi.js/src/accessibility/accessibleTarget.js ***!
  \*********************************************************/
/***/ function(module, exports) {

	/**
	 * Default property values of accessible objects
	 * used by {@link PIXI.accessibility.AccessibilityManager}.
	 *
	 * @mixin
	 * @memberof PIXI
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          MyObject.prototype,
	 *          PIXI.accessibility.accessibleTarget
	 *      );
	 */
	var accessibleTarget = {
	    
	    /**
	     * @todo Needs docs.
	     */
	    accessible:false,
	
	    /**
	     * @todo Needs docs.
	     */
	    accessibleTitle:null,
	
	    /**
	     * @todo Needs docs.
	     */
	    tabIndex:0,
	
	    /**
	     * @todo Needs docs.
	     */
	    _accessibleActive:false,
	
	    /**
	     * @todo Needs docs.
	     */
	    _accessibleDiv:false
	
	};
	
	module.exports = accessibleTarget;


/***/ },
/* 94 */
/*!*****************************************************!*\
  !*** ./~/pixi.js/src/core/display/DisplayObject.js ***!
  \*****************************************************/
/***/ function(module, exports, __webpack_require__) {

	var math = __webpack_require__(/*! ../math */ 9),
	    RenderTexture = __webpack_require__(/*! ../textures/RenderTexture */ 61),
	    EventEmitter = __webpack_require__(/*! eventemitter3 */ 18),
	    CONST = __webpack_require__(/*! ../const */ 6),
	    _tempMatrix = new math.Matrix(),
	    _tempDisplayObjectParent = {worldTransform:new math.Matrix(), worldAlpha:1, children:[]};
	
	
	/**
	 * The base class for all objects that are rendered on the screen.
	 * This is an abstract class and should not be used on its own rather it should be extended.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	function DisplayObject()
	{
	    EventEmitter.call(this);
	
	    /**
	     * The coordinate of the object relative to the local coordinates of the parent.
	     *
	     * @member {PIXI.Point}
	     */
	    this.position = new math.Point();
	
	    /**
	     * The scale factor of the object.
	     *
	     * @member {PIXI.Point}
	     */
	    this.scale = new math.Point(1, 1);
	
	    /**
	     * The pivot point of the displayObject that it rotates around
	     *
	     * @member {PIXI.Point}
	     */
	    this.pivot = new math.Point(0, 0);
	
	
	    /**
	     * The skew factor for the object in radians.
	     *
	     * @member {PIXI.Point}
	     */
	    this.skew = new math.Point(0, 0);
	
	    /**
	     * The rotation of the object in radians.
	     *
	     * @member {number}
	     */
	    this.rotation = 0;
	
	    /**
	     * The opacity of the object.
	     *
	     * @member {number}
	     */
	    this.alpha = 1;
	
	    /**
	     * The visibility of the object. If false the object will not be drawn, and
	     * the updateTransform function will not be called.
	     *
	     * @member {boolean}
	     */
	    this.visible = true;
	
	    /**
	     * Can this object be rendered, if false the object will not be drawn but the updateTransform
	     * methods will still be called.
	     *
	     * @member {boolean}
	     */
	    this.renderable = true;
	
	    /**
	     * The display object container that contains this display object.
	     *
	     * @member {PIXI.Container}
	     * @readOnly
	     */
	    this.parent = null;
	
	    /**
	     * The multiplied alpha of the displayObject
	     *
	     * @member {number}
	     * @readOnly
	     */
	    this.worldAlpha = 1;
	
	    /**
	     * Current transform of the object based on world (parent) factors
	     *
	     * @member {PIXI.Matrix}
	     * @readOnly
	     */
	    this.worldTransform = new math.Matrix();
	
	    /**
	     * The area the filter is applied to. This is used as more of an optimisation
	     * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.filterArea = null;
	
	    /**
	     * cached sin rotation
	     *
	     * @member {number}
	     * @private
	     */
	    this._sr = 0;
	
	    /**
	     * cached cos rotation
	     *
	     * @member {number}
	     * @private
	     */
	    this._cr = 1;
	
	    /**
	     * The original, cached bounds of the object
	     *
	     * @member {PIXI.Rectangle}
	     * @private
	     */
	    this._bounds = new math.Rectangle(0, 0, 1, 1);
	
	    /**
	     * The most up-to-date bounds of the object
	     *
	     * @member {PIXI.Rectangle}
	     * @private
	     */
	    this._currentBounds = null;
	
	    /**
	     * The original, cached mask of the object
	     *
	     * @member {PIXI.Rectangle}
	     * @private
	     */
	    this._mask = null;
	}
	
	// constructor
	DisplayObject.prototype = Object.create(EventEmitter.prototype);
	DisplayObject.prototype.constructor = DisplayObject;
	module.exports = DisplayObject;
	
	Object.defineProperties(DisplayObject.prototype, {
	    /**
	     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	     *
	     * @member {number}
	     * @memberof PIXI.DisplayObject#
	     */
	    x: {
	        get: function ()
	        {
	            return this.position.x;
	        },
	        set: function (value)
	        {
	            this.position.x = value;
	        }
	    },
	
	    /**
	     * The position of the displayObject on the y axis relative to the local coordinates of the parent.
	     *
	     * @member {number}
	     * @memberof PIXI.DisplayObject#
	     */
	    y: {
	        get: function ()
	        {
	            return this.position.y;
	        },
	        set: function (value)
	        {
	            this.position.y = value;
	        }
	    },
	
	    /**
	     * Indicates if the sprite is globally visible.
	     *
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     * @readonly
	     */
	    worldVisible: {
	        get: function ()
	        {
	            var item = this;
	
	            do {
	                if (!item.visible)
	                {
	                    return false;
	                }
	
	                item = item.parent;
	            } while (item);
	
	            return true;
	        }
	    },
	
	    /**
	     * Sets a mask for the displayObject. A mask is an object that limits the visibility of an object to the shape of the mask applied to it.
	     * In PIXI a regular mask must be a PIXI.Graphics or a PIXI.Sprite object. This allows for much faster masking in canvas as it utilises shape clipping.
	     * To remove a mask, set this property to null.
	     *
	     * @todo For the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
	     *
	     * @member {PIXI.Graphics|PIXI.Sprite}
	     * @memberof PIXI.DisplayObject#
	     */
	    mask: {
	        get: function ()
	        {
	            return this._mask;
	        },
	        set: function (value)
	        {
	            if (this._mask)
	            {
	                this._mask.renderable = true;
	            }
	
	            this._mask = value;
	
	            if (this._mask)
	            {
	                this._mask.renderable = false;
	            }
	        }
	    },
	
	    /**
	     * Sets the filters for the displayObject.
	     * * IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
	     * To remove filters simply set this property to 'null'
	     *
	     * @member {PIXI.AbstractFilter[]}
	     * @memberof PIXI.DisplayObject#
	     */
	    filters: {
	        get: function ()
	        {
	            return this._filters && this._filters.slice();
	        },
	        set: function (value)
	        {
	            this._filters = value && value.slice();
	        }
	    }
	
	});
	
	/*
	 * Updates the object transform for rendering
	 *
	 * TODO - Optimization pass!
	 */
	DisplayObject.prototype.updateTransform = function ()
	{
	    // create some matrix refs for easy access
	    var pt = this.parent.worldTransform;
	    var wt = this.worldTransform;
	
	    // temporary matrix variables
	    var a, b, c, d, tx, ty;
	
	    // looks like we are skewing
	    if(this.skew.x || this.skew.y)
	    {
	        // I'm assuming that skewing is not going to be very common
	        // With that in mind, we can do a full setTransform using the temp matrix
	        _tempMatrix.setTransform(
	            this.position.x,
	            this.position.y,
	            this.pivot.x,
	            this.pivot.y,
	            this.scale.x,
	            this.scale.y,
	            this.rotation,
	            this.skew.x,
	            this.skew.y
	        );
	
	        // now concat the matrix (inlined so that we can avoid using copy)
	        wt.a  = _tempMatrix.a  * pt.a + _tempMatrix.b  * pt.c;
	        wt.b  = _tempMatrix.a  * pt.b + _tempMatrix.b  * pt.d;
	        wt.c  = _tempMatrix.c  * pt.a + _tempMatrix.d  * pt.c;
	        wt.d  = _tempMatrix.c  * pt.b + _tempMatrix.d  * pt.d;
	        wt.tx = _tempMatrix.tx * pt.a + _tempMatrix.ty * pt.c + pt.tx;
	        wt.ty = _tempMatrix.tx * pt.b + _tempMatrix.ty * pt.d + pt.ty;
	    }
	    else
	    {
	        // so if rotation is between 0 then we can simplify the multiplication process...
	        if (this.rotation % CONST.PI_2)
	        {
	            // check to see if the rotation is the same as the previous render. This means we only need to use sin and cos when rotation actually changes
	            if (this.rotation !== this.rotationCache)
	            {
	                this.rotationCache = this.rotation;
	                this._sr = Math.sin(this.rotation);
	                this._cr = Math.cos(this.rotation);
	            }
	
	            // get the matrix values of the displayobject based on its transform properties..
	            a  =  this._cr * this.scale.x;
	            b  =  this._sr * this.scale.x;
	            c  = -this._sr * this.scale.y;
	            d  =  this._cr * this.scale.y;
	            tx =  this.position.x;
	            ty =  this.position.y;
	
	            // check for pivot.. not often used so geared towards that fact!
	            if (this.pivot.x || this.pivot.y)
	            {
	                tx -= this.pivot.x * a + this.pivot.y * c;
	                ty -= this.pivot.x * b + this.pivot.y * d;
	            }
	
	            // concat the parent matrix with the objects transform.
	            wt.a  = a  * pt.a + b  * pt.c;
	            wt.b  = a  * pt.b + b  * pt.d;
	            wt.c  = c  * pt.a + d  * pt.c;
	            wt.d  = c  * pt.b + d  * pt.d;
	            wt.tx = tx * pt.a + ty * pt.c + pt.tx;
	            wt.ty = tx * pt.b + ty * pt.d + pt.ty;
	        }
	        else
	        {
	            // lets do the fast version as we know there is no rotation..
	            a  = this.scale.x;
	            d  = this.scale.y;
	
	            tx = this.position.x - this.pivot.x * a;
	            ty = this.position.y - this.pivot.y * d;
	
	            wt.a  = a  * pt.a;
	            wt.b  = a  * pt.b;
	            wt.c  = d  * pt.c;
	            wt.d  = d  * pt.d;
	            wt.tx = tx * pt.a + ty * pt.c + pt.tx;
	            wt.ty = tx * pt.b + ty * pt.d + pt.ty;
	        }
	    }
	
	    // multiply the alphas..
	    this.worldAlpha = this.alpha * this.parent.worldAlpha;
	
	    // reset the bounds each time this is called!
	    this._currentBounds = null;
	};
	
	// performance increase to avoid using call.. (10x faster)
	DisplayObject.prototype.displayObjectUpdateTransform = DisplayObject.prototype.updateTransform;
	
	/**
	 *
	 *
	 * Retrieves the bounds of the displayObject as a rectangle object
	 *
	 * @param matrix {PIXI.Matrix}
	 * @return {PIXI.Rectangle} the rectangular bounding area
	 */
	DisplayObject.prototype.getBounds = function (matrix) // jshint unused:false
	{
	    return math.Rectangle.EMPTY;
	};
	
	/**
	 * Retrieves the local bounds of the displayObject as a rectangle object
	 *
	 * @return {PIXI.Rectangle} the rectangular bounding area
	 */
	DisplayObject.prototype.getLocalBounds = function ()
	{
	    return this.getBounds(math.Matrix.IDENTITY);
	};
	
	/**
	 * Calculates the global position of the display object
	 *
	 * @param position {PIXI.Point} The world origin to calculate from
	 * @return {PIXI.Point} A point object representing the position of this object
	 */
	DisplayObject.prototype.toGlobal = function (position)
	{
	    // this parent check is for just in case the item is a root object.
	    // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	    // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	    if(!this.parent)
	    {
	        this.parent = _tempDisplayObjectParent;
	        this.displayObjectUpdateTransform();
	        this.parent = null;
	    }
	    else
	    {
	        this.displayObjectUpdateTransform();
	    }
	
	    // don't need to update the lot
	    return this.worldTransform.apply(position);
	};
	
	/**
	 * Calculates the local position of the display object relative to another point
	 *
	 * @param position {PIXI.Point} The world origin to calculate from
	 * @param [from] {PIXI.DisplayObject} The DisplayObject to calculate the global position from
	 * @param [point] {PIXI.Point} A Point object in which to store the value, optional (otherwise will create a new Point)
	 * @return {PIXI.Point} A point object representing the position of this object
	 */
	DisplayObject.prototype.toLocal = function (position, from, point)
	{
	    if (from)
	    {
	        position = from.toGlobal(position);
	    }
	
	    // this parent check is for just in case the item is a root object.
	    // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	    // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	    if(!this.parent)
	    {
	        this.parent = _tempDisplayObjectParent;
	        this.displayObjectUpdateTransform();
	        this.parent = null;
	    }
	    else
	    {
	        this.displayObjectUpdateTransform();
	    }
	
	    // simply apply the matrix..
	    return this.worldTransform.applyInverse(position, point);
	};
	
	/**
	 * Renders the object using the WebGL renderer
	 *
	 * @param renderer {PIXI.WebGLRenderer} The renderer
	 * @private
	 */
	DisplayObject.prototype.renderWebGL = function (renderer) // jshint unused:false
	{
	    // OVERWRITE;
	};
	
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @param renderer {PIXI.CanvasRenderer} The renderer
	 * @private
	 */
	DisplayObject.prototype.renderCanvas = function (renderer) // jshint unused:false
	{
	    // OVERWRITE;
	};
	/**
	 * Useful function that returns a texture of the display object that can then be used to create sprites
	 * This can be quite useful if your displayObject is static / complicated and needs to be reused multiple times.
	 *
	 * @param renderer {PIXI.CanvasRenderer|PIXI.WebGLRenderer} The renderer used to generate the texture.
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @param resolution {number} The resolution of the texture being generated
	 * @return {PIXI.Texture} a texture of the display object
	 */
	DisplayObject.prototype.generateTexture = function (renderer, scaleMode, resolution)
	{
	    var bounds = this.getLocalBounds();
	
	    var renderTexture = new RenderTexture(renderer, bounds.width | 0, bounds.height | 0, scaleMode, resolution);
	
	    _tempMatrix.tx = -bounds.x;
	    _tempMatrix.ty = -bounds.y;
	
	    renderTexture.render(this, _tempMatrix);
	
	    return renderTexture;
	};
	
	/**
	 * Set the parent Container of this DisplayObject
	 *
	 * @param container {Container} The Container to add this DisplayObject to
	 * @return {Container} The Container that this DisplayObject was added to
	 */
	DisplayObject.prototype.setParent = function (container)
	{
	    if (!container || !container.addChild)
	    {
	        throw new Error('setParent: Argument must be a Container');
	    }
	
	    container.addChild(this);
	    return container;
	};
	
	/**
	 * Convenience function to set the postion, scale, skew and pivot at once.
	 *
	 * @param [x=0] {number} The X position
	 * @param [y=0] {number} The Y position
	 * @param [scaleX=1] {number} The X scale value
	 * @param [scaleY=1] {number} The Y scale value
	 * @param [rotation=0] {number} The rotation
	 * @param [skewX=0] {number} The X skew value
	 * @param [skewY=0] {number} The Y skew value
	 * @param [pivotX=0] {number} The X pivot value
	 * @param [pivotY=0] {number} The Y pivot value
	 * @return {PIXI.DisplayObject}
	 */
	DisplayObject.prototype.setTransform = function(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY) //jshint ignore:line
	{
	    this.position.x = x || 0;
	    this.position.y = y || 0;
	    this.scale.x = !scaleX ? 1 : scaleX;
	    this.scale.y = !scaleY ? 1 : scaleY;
	    this.rotation = rotation || 0;
	    this.skew.x = skewX || 0;
	    this.skew.y = skewY || 0;
	    this.pivot.x = pivotX || 0;
	    this.pivot.y = pivotY || 0;
	    return this;
	};
	
	/**
	 * Base destroy method for generic display objects
	 *
	 */
	DisplayObject.prototype.destroy = function ()
	{
	
	    this.position = null;
	    this.scale = null;
	    this.pivot = null;
	    this.skew = null;
	
	    this.parent = null;
	
	    this._bounds = null;
	    this._currentBounds = null;
	    this._mask = null;
	
	    this.worldTransform = null;
	    this.filterArea = null;
	};


/***/ },
/* 95 */
/*!*****************************************************!*\
  !*** ./~/pixi.js/src/core/graphics/GraphicsData.js ***!
  \*****************************************************/
/***/ function(module, exports) {

	/**
	 * A GraphicsData object.
	 *
	 * @class
	 * @memberof PIXI
	 * @param lineWidth {number} the width of the line to draw
	 * @param lineColor {number} the color of the line to draw
	 * @param lineAlpha {number} the alpha of the line to draw
	 * @param fillColor {number} the color of the fill
	 * @param fillAlpha {number} the alpha of the fill
	 * @param fill      {boolean} whether or not the shape is filled with a colour
	 * @param shape     {Circle|Rectangle|Ellipse|Line|Polygon} The shape object to draw.
	 */
	function GraphicsData(lineWidth, lineColor, lineAlpha, fillColor, fillAlpha, fill, shape)
	{
	    /*
	     * @member {number} the width of the line to draw
	     */
	    this.lineWidth = lineWidth;
	
	    /*
	     * @member {number} the color of the line to draw
	     */
	    this.lineColor = lineColor;
	    /*
	     * @member {number} the alpha of the line to draw
	     */
	    this.lineAlpha = lineAlpha;
	    /*
	     * @member {number} cached tint of the line to draw
	     */
	    this._lineTint = lineColor;
	
	    /*
	     * @member {number} the color of the fill
	     */
	    this.fillColor = fillColor;
	
	    /*
	     * @member {number} the alpha of the fill
	     */
	    this.fillAlpha = fillAlpha;
	
	    /*
	     * @member {number} cached tint of the fill
	     */
	    this._fillTint = fillColor;
	
	    /*
	     * @member {boolean} whether or not the shape is filled with a colour
	     */
	    this.fill = fill;
	
	    /*
	     * @member {PIXI.Circle|PIXI.Rectangle|PIXI.Ellipse|PIXI.Line|PIXI.Polygon} The shape object to draw.
	     */
	    this.shape = shape;
	
	    /*
	     * @member {number} The type of the shape, see the Const.Shapes file for all the existing types,
	     */
	    this.type = shape.type;
	}
	
	GraphicsData.prototype.constructor = GraphicsData;
	module.exports = GraphicsData;
	
	/**
	 * Creates a new GraphicsData object with the same values as this one.
	 *
	 * @return {PIXI.GraphicsData}
	 */
	GraphicsData.prototype.clone = function ()
	{
	    return new GraphicsData(
	        this.lineWidth,
	        this.lineColor,
	        this.lineAlpha,
	        this.fillColor,
	        this.fillAlpha,
	        this.fill,
	        this.shape
	    );
	};
	
	/**
	 * Destroys the Graphics data.
	 */
	GraphicsData.prototype.destroy = function () {
	    this.shape = null;
	};


/***/ },
/* 96 */
/*!********************************************!*\
  !*** ./~/pixi.js/src/core/math/GroupD8.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	// Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group of order 16
	
	var ux = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1];
	var uy = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vx = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vy = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1];
	var tempMatrices = [];
	var Matrix = __webpack_require__(/*! ./Matrix */ 97);
	
	var mul = [];
	
	function signum(x) {
	    if (x < 0) {
	        return -1;
	    }
	    if (x > 0) {
	        return 1;
	    }
	    return 0;
	}
	
	function init() {
	    for (var i = 0; i < 16; i++) {
	        var row = [];
	        mul.push(row);
	        for (var j = 0; j < 16; j++) {
	            var _ux = signum(ux[i] * ux[j] + vx[i] * uy[j]);
	            var _uy = signum(uy[i] * ux[j] + vy[i] * uy[j]);
	            var _vx = signum(ux[i] * vx[j] + vx[i] * vy[j]);
	            var _vy = signum(uy[i] * vx[j] + vy[i] * vy[j]);
	            for (var k = 0; k < 16; k++) {
	                if (ux[k] === _ux && uy[k] === _uy && vx[k] === _vx && vy[k] === _vy) {
	                    row.push(k);
	                    break;
	                }
	            }
	        }
	    }
	
	    for (i=0;i<16;i++) {
	        var mat = new Matrix();
	        mat.set(ux[i], uy[i], vx[i], vy[i], 0, 0);
	        tempMatrices.push(mat);
	    }
	}
	
	init();
	
	/**
	 * Implements Dihedral Group D_8, see [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html}, D8 is the same but with diagonals
	 * Used for texture rotations
	 * Vector xX(i), xY(i) is U-axis of sprite with rotation i
	 * Vector yY(i), yY(i) is V-axis of sprite with rotation i
	 * Rotations: 0 grad (0), 90 grad (2), 180 grad (4), 270 grad (6)
	 * Mirrors: vertical (8), main diagonal (10), horizontal (12), reverse diagonal (14)
	 * This is the small part of gameofbombs.com portal system. It works.
	 * @author Ivan @ivanpopelyshev
	 *
	 * @namespace PIXI.GroupD8
	 */
	var GroupD8 = {
	    E: 0,
	    SE: 1,
	    S: 2,
	    SW: 3,
	    W: 4,
	    NW: 5,
	    N: 6,
	    NE: 7,
	    MIRROR_VERTICAL: 8,
	    MIRROR_HORIZONTAL: 12,
	    uX: function (ind) {
	        return ux[ind];
	    },
	    uY: function (ind) {
	        return uy[ind];
	    },
	    vX: function (ind) {
	        return vx[ind];
	    },
	    vY: function (ind) {
	        return vy[ind];
	    },
	    inv: function (rotation) {
	        if (rotation & 8) {
	            return rotation & 15;
	        }
	        return (-rotation) & 7;
	    },
	    add: function (rotationSecond, rotationFirst) {
	        return mul[rotationSecond][rotationFirst];
	    },
	    sub: function (rotationSecond, rotationFirst) {
	        return mul[rotationSecond][GroupD8.inv(rotationFirst)];
	    },
	    /**
	     * Adds 180 degrees to rotation. Commutative operation
	     * @param rotation
	     * @returns {number}
	     */
	    rotate180: function (rotation) {
	        return rotation ^ 4;
	    },
	    /**
	     * I dont know why sometimes width and heights needs to be swapped. We'll fix it later.
	     * @param rotation
	     * @returns {boolean}
	     */
	    isSwapWidthHeight: function(rotation) {
	        return (rotation & 3) === 2;
	    },
	    byDirection: function (dx, dy) {
	        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
	            if (dy >= 0) {
	                return GroupD8.S;
	            }
	            else {
	                return GroupD8.N;
	            }
	        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
	            if (dx > 0) {
	                return GroupD8.E;
	            }
	            else {
	                return GroupD8.W;
	            }
	        } else {
	            if (dy > 0) {
	                if (dx > 0) {
	                    return GroupD8.SE;
	                }
	                else {
	                    return GroupD8.SW;
	                }
	            }
	            else if (dx > 0) {
	                return GroupD8.NE;
	            }
	            else {
	                return GroupD8.NW;
	            }
	        }
	    },
	    /**
	     * Helps sprite to compensate texture packer rotation.
	     * @param matrix {PIXI.Matrix} sprite world matrix
	     * @param rotation {number}
	     * @param tx {number|*} sprite anchoring
	     * @param ty {number|*} sprite anchoring
	     */
	    matrixAppendRotationInv: function (matrix, rotation, tx, ty) {
	        //Packer used "rotation", we use "inv(rotation)"
	        var mat = tempMatrices[GroupD8.inv(rotation)];
	        tx = tx || 0;
	        ty = ty || 0;
	        mat.tx = tx;
	        mat.ty = ty;
	        matrix.append(mat);
	    }
	};
	
	module.exports = GroupD8;


/***/ },
/* 97 */
/*!*******************************************!*\
  !*** ./~/pixi.js/src/core/math/Matrix.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	// @todo - ignore the too many parameters warning for now
	// should either fix it or change the jshint config
	// jshint -W072
	
	var Point = __webpack_require__(/*! ./Point */ 56);
	
	/**
	 * The pixi Matrix class as an object, which makes it a lot faster,
	 * here is a representation of it :
	 * | a | b | tx|
	 * | c | d | ty|
	 * | 0 | 0 | 1 |
	 *
	 * @class
	 * @memberof PIXI
	 */
	function Matrix()
	{
	    /**
	     * @member {number}
	     * @default 1
	     */
	    this.a = 1;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.b = 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.c = 0;
	
	    /**
	     * @member {number}
	     * @default 1
	     */
	    this.d = 1;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.tx = 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.ty = 0;
	}
	
	Matrix.prototype.constructor = Matrix;
	module.exports = Matrix;
	
	/**
	 * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
	 *
	 * a = array[0]
	 * b = array[1]
	 * c = array[3]
	 * d = array[4]
	 * tx = array[2]
	 * ty = array[5]
	 *
	 * @param array {number[]} The array that the matrix will be populated from.
	 */
	Matrix.prototype.fromArray = function (array)
	{
	    this.a = array[0];
	    this.b = array[1];
	    this.c = array[3];
	    this.d = array[4];
	    this.tx = array[2];
	    this.ty = array[5];
	};
	
	
	/**
	 * sets the matrix properties
	 *
	 * @param {number} a
	 * @param {number} b
	 * @param {number} c
	 * @param {number} d
	 * @param {number} tx
	 * @param {number} ty
	 *
	 * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	 */
	Matrix.prototype.set = function (a, b, c, d, tx, ty)
	{
	    this.a = a;
	    this.b = b;
	    this.c = c;
	    this.d = d;
	    this.tx = tx;
	    this.ty = ty;
	
	    return this;
	};
	
	
	/**
	 * Creates an array from the current Matrix object.
	 *
	 * @param transpose {boolean} Whether we need to transpose the matrix or not
	 * @param [out] {Array} If provided the array will be assigned to out
	 * @return {number[]} the newly created array which contains the matrix
	 */
	Matrix.prototype.toArray = function (transpose, out)
	{
	    if (!this.array)
	    {
	        this.array = new Float32Array(9);
	    }
	
	    var array = out || this.array;
	
	    if (transpose)
	    {
	        array[0] = this.a;
	        array[1] = this.b;
	        array[2] = 0;
	        array[3] = this.c;
	        array[4] = this.d;
	        array[5] = 0;
	        array[6] = this.tx;
	        array[7] = this.ty;
	        array[8] = 1;
	    }
	    else
	    {
	        array[0] = this.a;
	        array[1] = this.c;
	        array[2] = this.tx;
	        array[3] = this.b;
	        array[4] = this.d;
	        array[5] = this.ty;
	        array[6] = 0;
	        array[7] = 0;
	        array[8] = 1;
	    }
	
	    return array;
	};
	
	/**
	 * Get a new position with the current transformation applied.
	 * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
	 *
	 * @param pos {PIXI.Point} The origin
	 * @param [newPos] {PIXI.Point} The point that the new position is assigned to (allowed to be same as input)
	 * @return {PIXI.Point} The new point, transformed through this matrix
	 */
	Matrix.prototype.apply = function (pos, newPos)
	{
	    newPos = newPos || new Point();
	
	    var x = pos.x;
	    var y = pos.y;
	
	    newPos.x = this.a * x + this.c * y + this.tx;
	    newPos.y = this.b * x + this.d * y + this.ty;
	
	    return newPos;
	};
	
	/**
	 * Get a new position with the inverse of the current transformation applied.
	 * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
	 *
	 * @param pos {PIXI.Point} The origin
	 * @param [newPos] {PIXI.Point} The point that the new position is assigned to (allowed to be same as input)
	 * @return {PIXI.Point} The new point, inverse-transformed through this matrix
	 */
	Matrix.prototype.applyInverse = function (pos, newPos)
	{
	    newPos = newPos || new Point();
	
	    var id = 1 / (this.a * this.d + this.c * -this.b);
	
	    var x = pos.x;
	    var y = pos.y;
	
	    newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
	    newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;
	
	    return newPos;
	};
	
	/**
	 * Translates the matrix on the x and y.
	 *
	 * @param {number} x
	 * @param {number} y
	 * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	 */
	Matrix.prototype.translate = function (x, y)
	{
	    this.tx += x;
	    this.ty += y;
	
	    return this;
	};
	
	/**
	 * Applies a scale transformation to the matrix.
	 *
	 * @param {number} x The amount to scale horizontally
	 * @param {number} y The amount to scale vertically
	 * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	 */
	Matrix.prototype.scale = function (x, y)
	{
	    this.a *= x;
	    this.d *= y;
	    this.c *= x;
	    this.b *= y;
	    this.tx *= x;
	    this.ty *= y;
	
	    return this;
	};
	
	
	/**
	 * Applies a rotation transformation to the matrix.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	 */
	Matrix.prototype.rotate = function (angle)
	{
	    var cos = Math.cos( angle );
	    var sin = Math.sin( angle );
	
	    var a1 = this.a;
	    var c1 = this.c;
	    var tx1 = this.tx;
	
	    this.a = a1 * cos-this.b * sin;
	    this.b = a1 * sin+this.b * cos;
	    this.c = c1 * cos-this.d * sin;
	    this.d = c1 * sin+this.d * cos;
	    this.tx = tx1 * cos - this.ty * sin;
	    this.ty = tx1 * sin + this.ty * cos;
	
	    return this;
	};
	
	/**
	 * Appends the given Matrix to this Matrix.
	 *
	 * @param {PIXI.Matrix} matrix
	 * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	 */
	Matrix.prototype.append = function (matrix)
	{
	    var a1 = this.a;
	    var b1 = this.b;
	    var c1 = this.c;
	    var d1 = this.d;
	
	    this.a  = matrix.a * a1 + matrix.b * c1;
	    this.b  = matrix.a * b1 + matrix.b * d1;
	    this.c  = matrix.c * a1 + matrix.d * c1;
	    this.d  = matrix.c * b1 + matrix.d * d1;
	
	    this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
	    this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
	
	    return this;
	};
	
	/**
	 * Sets the matrix based on all the available properties
	 *
	 * @param {number} x
	 * @param {number} y
	 * @param {number} pivotX
	 * @param {number} pivotY
	 * @param {number} scaleX
	 * @param {number} scaleY
	 * @param {number} rotation
	 * @param {number} skewX
	 * @param {number} skewY
	 *
	 * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	 */
	Matrix.prototype.setTransform = function (x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY)
	{
	    var a, b, c, d, sr, cr, cy, sy, nsx, cx;
	
	    sr  = Math.sin(rotation);
	    cr  = Math.cos(rotation);
	    cy  = Math.cos(skewY);
	    sy  = Math.sin(skewY);
	    nsx = -Math.sin(skewX);
	    cx  =  Math.cos(skewX);
	
	    a  =  cr * scaleX;
	    b  =  sr * scaleX;
	    c  = -sr * scaleY;
	    d  =  cr * scaleY;
	
	    this.a  = cy * a + sy * c;
	    this.b  = cy * b + sy * d;
	    this.c  = nsx * a + cx * c;
	    this.d  = nsx * b + cx * d;
	
	    this.tx = x + ( pivotX * a + pivotY * c );
	    this.ty = y + ( pivotX * b + pivotY * d );
	
	    return this;
	};
	
	/**
	 * Prepends the given Matrix to this Matrix.
	 *
	 * @param {PIXI.Matrix} matrix
	 * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	 */
	Matrix.prototype.prepend = function(matrix)
	{
	    var tx1 = this.tx;
	
	    if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1)
	    {
	        var a1 = this.a;
	        var c1 = this.c;
	        this.a  = a1*matrix.a+this.b*matrix.c;
	        this.b  = a1*matrix.b+this.b*matrix.d;
	        this.c  = c1*matrix.a+this.d*matrix.c;
	        this.d  = c1*matrix.b+this.d*matrix.d;
	    }
	
	    this.tx = tx1*matrix.a+this.ty*matrix.c+matrix.tx;
	    this.ty = tx1*matrix.b+this.ty*matrix.d+matrix.ty;
	
	    return this;
	};
	
	/**
	 * Inverts this matrix
	 *
	 * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	 */
	Matrix.prototype.invert = function()
	{
	    var a1 = this.a;
	    var b1 = this.b;
	    var c1 = this.c;
	    var d1 = this.d;
	    var tx1 = this.tx;
	    var n = a1*d1-b1*c1;
	
	    this.a = d1/n;
	    this.b = -b1/n;
	    this.c = -c1/n;
	    this.d = a1/n;
	    this.tx = (c1*this.ty-d1*tx1)/n;
	    this.ty = -(a1*this.ty-b1*tx1)/n;
	
	    return this;
	};
	
	
	/**
	 * Resets this Matix to an identity (default) matrix.
	 *
	 * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	 */
	Matrix.prototype.identity = function ()
	{
	    this.a = 1;
	    this.b = 0;
	    this.c = 0;
	    this.d = 1;
	    this.tx = 0;
	    this.ty = 0;
	
	    return this;
	};
	
	/**
	 * Creates a new Matrix object with the same values as this one.
	 *
	 * @return {PIXI.Matrix} A copy of this matrix. Good for chaining method calls.
	 */
	Matrix.prototype.clone = function ()
	{
	    var matrix = new Matrix();
	    matrix.a = this.a;
	    matrix.b = this.b;
	    matrix.c = this.c;
	    matrix.d = this.d;
	    matrix.tx = this.tx;
	    matrix.ty = this.ty;
	
	    return matrix;
	};
	
	/**
	 * Changes the values of the given matrix to be the same as the ones in this matrix
	 *
	 * @return {PIXI.Matrix} The matrix given in parameter with its values updated.
	 */
	Matrix.prototype.copy = function (matrix)
	{
	    matrix.a = this.a;
	    matrix.b = this.b;
	    matrix.c = this.c;
	    matrix.d = this.d;
	    matrix.tx = this.tx;
	    matrix.ty = this.ty;
	
	    return matrix;
	};
	
	/**
	 * A default (identity) matrix
	 *
	 * @static
	 * @const
	 */
	Matrix.IDENTITY = new Matrix();
	
	/**
	 * A temp matrix
	 *
	 * @static
	 * @const
	 */
	Matrix.TEMP_MATRIX = new Matrix();


/***/ },
/* 98 */
/*!********************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/SystemRenderer.js ***!
  \********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(/*! ../utils */ 7),
	    math = __webpack_require__(/*! ../math */ 9),
	    CONST = __webpack_require__(/*! ../const */ 6),
	    EventEmitter = __webpack_require__(/*! eventemitter3 */ 18);
	
	/**
	 * The CanvasRenderer draws the scene and all its content onto a 2d canvas. This renderer should be used for browsers that do not support webGL.
	 * Don't forget to add the CanvasRenderer.view to your DOM or you will not see anything :)
	 *
	 * @class
	 * @memberof PIXI
	 * @param system {string} The name of the system this renderer is for.
	 * @param [width=800] {number} the width of the canvas view
	 * @param [height=600] {number} the height of the canvas view
	 * @param [options] {object} The optional renderer parameters
	 * @param [options.view] {HTMLCanvasElement} the canvas to use as a view, optional
	 * @param [options.transparent=false] {boolean} If the render view is transparent, default false
	 * @param [options.autoResize=false] {boolean} If the render view is automatically resized, default false
	 * @param [options.antialias=false] {boolean} sets antialias (only applicable in chrome at the moment)
	 * @param [options.resolution=1] {number} the resolution of the renderer retina would be 2
	 * @param [options.clearBeforeRender=true] {boolean} This sets if the CanvasRenderer will clear the canvas or
	 *      not before the new render pass.
	 * @param [options.backgroundColor=0x000000] {number} The background color of the rendered area (shown if not transparent).
	 * @param [options.roundPixels=false] {boolean} If true Pixi will Math.floor() x/y values when rendering, stopping pixel interpolation.
	 */
	function SystemRenderer(system, width, height, options)
	{
	    EventEmitter.call(this);
	
	    utils.sayHello(system);
	
	    // prepare options
	    if (options)
	    {
	        for (var i in CONST.DEFAULT_RENDER_OPTIONS)
	        {
	            if (typeof options[i] === 'undefined')
	            {
	                options[i] = CONST.DEFAULT_RENDER_OPTIONS[i];
	            }
	        }
	    }
	    else
	    {
	        options = CONST.DEFAULT_RENDER_OPTIONS;
	    }
	
	    /**
	     * The type of the renderer.
	     *
	     * @member {number}
	     * @default PIXI.RENDERER_TYPE.UNKNOWN
	     * @see PIXI.RENDERER_TYPE
	     */
	    this.type = CONST.RENDERER_TYPE.UNKNOWN;
	
	    /**
	     * The width of the canvas view
	     *
	     * @member {number}
	     * @default 800
	     */
	    this.width = width || 800;
	
	    /**
	     * The height of the canvas view
	     *
	     * @member {number}
	     * @default 600
	     */
	    this.height = height || 600;
	
	    /**
	     * The canvas element that everything is drawn to
	     *
	     * @member {HTMLCanvasElement}
	     */
	    this.view = options.view || document.createElement('canvas');
	
	    /**
	     * The resolution of the renderer
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.resolution = options.resolution;
	
	    /**
	     * Whether the render view is transparent
	     *
	     * @member {boolean}
	     */
	    this.transparent = options.transparent;
	
	    /**
	     * Whether the render view should be resized automatically
	     *
	     * @member {boolean}
	     */
	    this.autoResize = options.autoResize || false;
	
	    /**
	     * Tracks the blend modes useful for this renderer.
	     *
	     * @member {object<string, mixed>}
	     */
	    this.blendModes = null;
	
	    /**
	     * The value of the preserveDrawingBuffer flag affects whether or not the contents of the stencil buffer is retained after rendering.
	     *
	     * @member {boolean}
	     */
	    this.preserveDrawingBuffer = options.preserveDrawingBuffer;
	
	    /**
	     * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
	     * If the scene is NOT transparent Pixi will use a canvas sized fillRect operation every frame to set the canvas background color.
	     * If the scene is transparent Pixi will use clearRect to clear the canvas every frame.
	     * Disable this by setting this to false. For example if your game has a canvas filling background image you often don't need this set.
	     *
	     * @member {boolean}
	     * @default
	     */
	    this.clearBeforeRender = options.clearBeforeRender;
	
	    /**
	     * If true Pixi will Math.floor() x/y values when rendering, stopping pixel interpolation.
	     * Handy for crisp pixel art and speed on legacy devices.
	     *
	     * @member {boolean}
	     */
	    this.roundPixels = options.roundPixels;
	
	    /**
	     * The background color as a number.
	     *
	     * @member {number}
	     * @private
	     */
	    this._backgroundColor = 0x000000;
	
	    /**
	     * The background color as an [R, G, B] array.
	     *
	     * @member {number[]}
	     * @private
	     */
	    this._backgroundColorRgb = [0, 0, 0];
	
	    /**
	     * The background color as a string.
	     *
	     * @member {string}
	     * @private
	     */
	    this._backgroundColorString = '#000000';
	
	    this.backgroundColor = options.backgroundColor || this._backgroundColor; // run bg color setter
	
	    /**
	     * This temporary display object used as the parent of the currently being rendered item
	     *
	     * @member {PIXI.DisplayObject}
	     * @private
	     */
	    this._tempDisplayObjectParent = {worldTransform:new math.Matrix(), worldAlpha:1, children:[]};
	
	    /**
	     * The last root object that the renderer tried to render.
	     *
	     * @member {PIXI.DisplayObject}
	     * @private
	     */
	    this._lastObjectRendered = this._tempDisplayObjectParent;
	}
	
	// constructor
	SystemRenderer.prototype = Object.create(EventEmitter.prototype);
	SystemRenderer.prototype.constructor = SystemRenderer;
	module.exports = SystemRenderer;
	
	Object.defineProperties(SystemRenderer.prototype, {
	    /**
	     * The background color to fill if not transparent
	     *
	     * @member {number}
	     * @memberof PIXI.SystemRenderer#
	     */
	    backgroundColor:
	    {
	        get: function ()
	        {
	            return this._backgroundColor;
	        },
	        set: function (val)
	        {
	            this._backgroundColor = val;
	            this._backgroundColorString = utils.hex2string(val);
	            utils.hex2rgb(val, this._backgroundColorRgb);
	        }
	    }
	});
	
	/**
	 * Resizes the canvas view to the specified width and height
	 *
	 * @param width {number} the new width of the canvas view
	 * @param height {number} the new height of the canvas view
	 */
	SystemRenderer.prototype.resize = function (width, height) {
	    this.width = width * this.resolution;
	    this.height = height * this.resolution;
	
	    this.view.width = this.width;
	    this.view.height = this.height;
	
	    if (this.autoResize)
	    {
	        this.view.style.width = this.width / this.resolution + 'px';
	        this.view.style.height = this.height / this.resolution + 'px';
	    }
	};
	
	/**
	 * Removes everything from the renderer and optionally removes the Canvas DOM element.
	 *
	 * @param [removeView=false] {boolean} Removes the Canvas element from the DOM.
	 */
	SystemRenderer.prototype.destroy = function (removeView) {
	    if (removeView && this.view.parentNode)
	    {
	        this.view.parentNode.removeChild(this.view);
	    }
	
	    this.type = CONST.RENDERER_TYPE.UNKNOWN;
	
	    this.width = 0;
	    this.height = 0;
	
	    this.view = null;
	
	    this.resolution = 0;
	
	    this.transparent = false;
	
	    this.autoResize = false;
	
	    this.blendModes = null;
	
	    this.preserveDrawingBuffer = false;
	    this.clearBeforeRender = false;
	
	    this.roundPixels = false;
	
	    this._backgroundColor = 0;
	    this._backgroundColorRgb = null;
	    this._backgroundColorString = null;
	};


/***/ },
/* 99 */
/*!*******************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/canvas/utils/CanvasTinter.js ***!
  \*******************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(/*! ../../../utils */ 7);
	
	/**
	 * Utility methods for Sprite/Texture tinting.
	 * @static
	 * @class
	 * @memberof PIXI
	 */
	var CanvasTinter = {};
	module.exports = CanvasTinter;
	
	/**
	 * Basically this method just needs a sprite and a color and tints the sprite with the given color.
	 *
	 * @param sprite {PIXI.Sprite} the sprite to tint
	 * @param color {number} the color to use to tint the sprite with
	 * @return {HTMLCanvasElement} The tinted canvas
	 */
	CanvasTinter.getTintedTexture = function (sprite, color)
	{
	    var texture = sprite.texture;
	
	    color = CanvasTinter.roundColor(color);
	
	    var stringColor = '#' + ('00000' + ( color | 0).toString(16)).substr(-6);
	
	    texture.tintCache = texture.tintCache || {};
	
	    if (texture.tintCache[stringColor])
	    {
	        return texture.tintCache[stringColor];
	    }
	
	     // clone texture..
	    var canvas = CanvasTinter.canvas || document.createElement('canvas');
	
	    //CanvasTinter.tintWithPerPixel(texture, stringColor, canvas);
	    CanvasTinter.tintMethod(texture, color, canvas);
	
	    if (CanvasTinter.convertTintToImage)
	    {
	        // is this better?
	        var tintImage = new Image();
	        tintImage.src = canvas.toDataURL();
	
	        texture.tintCache[stringColor] = tintImage;
	    }
	    else
	    {
	        texture.tintCache[stringColor] = canvas;
	        // if we are not converting the texture to an image then we need to lose the reference to the canvas
	        CanvasTinter.canvas = null;
	    }
	
	    return canvas;
	};
	
	/**
	 * Tint a texture using the 'multiply' operation.
	 *
	 * @param texture {PIXI.Texture} the texture to tint
	 * @param color {number} the color to use to tint the sprite with
	 * @param canvas {HTMLCanvasElement} the current canvas
	 */
	CanvasTinter.tintWithMultiply = function (texture, color, canvas)
	{
	    var context = canvas.getContext( '2d' );
	
	    var resolution = texture.baseTexture.resolution;
	
	    var crop = texture.crop.clone();
	    crop.x *= resolution;
	    crop.y *= resolution;
	    crop.width *= resolution;
	    crop.height *= resolution;
	
	    canvas.width = crop.width;
	    canvas.height = crop.height;
	
	    context.fillStyle = '#' + ('00000' + ( color | 0).toString(16)).substr(-6);
	
	    context.fillRect(0, 0, crop.width, crop.height);
	
	    context.globalCompositeOperation = 'multiply';
	
	    context.drawImage(
	        texture.baseTexture.source,
	        crop.x,
	        crop.y,
	        crop.width,
	        crop.height,
	        0,
	        0,
	        crop.width,
	        crop.height
	    );
	
	    context.globalCompositeOperation = 'destination-atop';
	
	    context.drawImage(
	        texture.baseTexture.source,
	        crop.x,
	        crop.y,
	        crop.width,
	        crop.height,
	        0,
	        0,
	        crop.width,
	        crop.height
	    );
	};
	
	/**
	 * Tint a texture using the 'overlay' operation.
	 *
	 * @param texture {PIXI.Texture} the texture to tint
	 * @param color {number} the color to use to tint the sprite with
	 * @param canvas {HTMLCanvasElement} the current canvas
	 */
	CanvasTinter.tintWithOverlay = function (texture, color, canvas)
	{
	    var context = canvas.getContext( '2d' );
	
	    var resolution = texture.baseTexture.resolution;
	
	    var crop = texture.crop.clone();
	    crop.x *= resolution;
	    crop.y *= resolution;
	    crop.width *= resolution;
	    crop.height *= resolution;
	
	    canvas.width = crop.width;
	    canvas.height = crop.height;
	
	    context.globalCompositeOperation = 'copy';
	    context.fillStyle = '#' + ('00000' + ( color | 0).toString(16)).substr(-6);
	    context.fillRect(0, 0, crop.width, crop.height);
	
	    context.globalCompositeOperation = 'destination-atop';
	    context.drawImage(
	        texture.baseTexture.source,
	        crop.x,
	        crop.y,
	        crop.width,
	        crop.height,
	        0,
	        0,
	        crop.width,
	        crop.height
	    );
	
	    // context.globalCompositeOperation = 'copy';
	};
	
	/**
	 * Tint a texture pixel per pixel.
	 *
	 * @param texture {PIXI.Texture} the texture to tint
	 * @param color {number} the color to use to tint the sprite with
	 * @param canvas {HTMLCanvasElement} the current canvas
	 */
	CanvasTinter.tintWithPerPixel = function (texture, color, canvas)
	{
	    var context = canvas.getContext( '2d' );
	
	    var resolution = texture.baseTexture.resolution;
	
	    var crop = texture.crop.clone();
	    crop.x *= resolution;
	    crop.y *= resolution;
	    crop.width *= resolution;
	    crop.height *= resolution;
	
	    canvas.width = crop.width;
	    canvas.height = crop.height;
	
	    context.globalCompositeOperation = 'copy';
	    context.drawImage(
	        texture.baseTexture.source,
	        crop.x,
	        crop.y,
	        crop.width,
	        crop.height,
	        0,
	        0,
	        crop.width,
	        crop.height
	    );
	
	    var rgbValues = utils.hex2rgb(color);
	    var r = rgbValues[0], g = rgbValues[1], b = rgbValues[2];
	
	    var pixelData = context.getImageData(0, 0, crop.width, crop.height);
	
	    var pixels = pixelData.data;
	
	    for (var i = 0; i < pixels.length; i += 4)
	    {
	        pixels[i+0] *= r;
	        pixels[i+1] *= g;
	        pixels[i+2] *= b;
	    }
	
	    context.putImageData(pixelData, 0, 0);
	};
	
	/**
	 * Rounds the specified color according to the CanvasTinter.cacheStepsPerColorChannel.
	 *
	 * @param color {number} the color to round, should be a hex color
	 */
	CanvasTinter.roundColor = function (color)
	{
	    var step = CanvasTinter.cacheStepsPerColorChannel;
	
	    var rgbValues = utils.hex2rgb(color);
	
	    rgbValues[0] = Math.min(255, (rgbValues[0] / step) * step);
	    rgbValues[1] = Math.min(255, (rgbValues[1] / step) * step);
	    rgbValues[2] = Math.min(255, (rgbValues[2] / step) * step);
	
	    return utils.rgb2hex(rgbValues);
	};
	
	/**
	 * Number of steps which will be used as a cap when rounding colors.
	 *
	 * @member
	 */
	CanvasTinter.cacheStepsPerColorChannel = 8;
	
	/**
	 * Tint cache boolean flag.
	 *
	 * @member
	 */
	CanvasTinter.convertTintToImage = false;
	
	/**
	 * Whether or not the Canvas BlendModes are supported, consequently the ability to tint using the multiply method.
	 *
	 * @member
	 */
	CanvasTinter.canUseMultiply = utils.canUseNewCanvasBlendModes();
	
	/**
	 * The tinting method that will be used.
	 *
	 */
	CanvasTinter.tintMethod = CanvasTinter.canUseMultiply ? CanvasTinter.tintWithMultiply :  CanvasTinter.tintWithPerPixel;


/***/ },
/* 100 */
/*!******************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/filters/FXAAFilter.js ***!
  \******************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var AbstractFilter = __webpack_require__(/*! ./AbstractFilter */ 60);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 *
	 * Basic FXAA implementation based on the code on geeks3d.com with the
	 * modification that the texture2DLod stuff was removed since it's
	 * unsupported by WebGL.
	 *
	 * --
	 * From:
	 * https://github.com/mitsuhiko/webgl-meincraft
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI
	 *
	 */
	function FXAAFilter()
	{
	    AbstractFilter.call(this,
	        // vertex shader
	        fs.readFileSync(__dirname + '/FXAA.vert', 'utf8'),
	        // fragment shader
	        fs.readFileSync(__dirname + '/FXAA.frag', 'utf8'),
	        // uniforms
	        {
	            resolution: { type: 'v2', value: { x: 1, y: 1 } }
	        }
	    );
	
	}
	
	FXAAFilter.prototype = Object.create(AbstractFilter.prototype);
	FXAAFilter.prototype.constructor = FXAAFilter;
	module.exports = FXAAFilter;
	
	/**
	 * Applies the filter
	 *
	 * @param renderer {PIXI.WebGLRenderer} The renderer to retrieve the filter from
	 * @param input {PIXI.RenderTarget}
	 * @param output {PIXI.RenderTarget}
	 */
	FXAAFilter.prototype.applyFilter = function (renderer, input, output)
	{
	    var filterManager = renderer.filterManager;
	
	    var shader = this.getShader( renderer );
	     // draw the filter...
	    filterManager.applyFilter(shader, input, output);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 101 */
/*!************************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/filters/SpriteMaskFilter.js ***!
  \************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var AbstractFilter = __webpack_require__(/*! ./AbstractFilter */ 60),
	    math =  __webpack_require__(/*! ../../../math */ 9);
	
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * The SpriteMaskFilter class
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI
	 * @param sprite {PIXI.Sprite} the target sprite
	 */
	function SpriteMaskFilter(sprite)
	{
	    var maskMatrix = new math.Matrix();
	
	    AbstractFilter.call(this,
	        fs.readFileSync(__dirname + '/spriteMaskFilter.vert', 'utf8'),
	        fs.readFileSync(__dirname + '/spriteMaskFilter.frag', 'utf8'),
	        {
	            mask:           { type: 'sampler2D', value: sprite._texture },
	            alpha:          { type: 'f', value: 1},
	            otherMatrix:    { type: 'mat3', value: maskMatrix.toArray(true) }
	        }
	    );
	
	    this.maskSprite = sprite;
	    this.maskMatrix = maskMatrix;
	}
	
	SpriteMaskFilter.prototype = Object.create(AbstractFilter.prototype);
	SpriteMaskFilter.prototype.constructor = SpriteMaskFilter;
	module.exports = SpriteMaskFilter;
	
	/**
	 * Applies the filter
	 *
	 * @param renderer {PIXI.WebGLRenderer} The renderer to retrieve the filter from
	 * @param input {PIXI.RenderTarget}
	 * @param output {PIXI.RenderTarget}
	 */
	SpriteMaskFilter.prototype.applyFilter = function (renderer, input, output)
	{
	    var filterManager = renderer.filterManager;
	
	    this.uniforms.mask.value = this.maskSprite._texture;
	
	    filterManager.calculateMappedMatrix(input.frame, this.maskSprite, this.maskMatrix);
	
	    this.uniforms.otherMatrix.value = this.maskMatrix.toArray(true);
	    this.uniforms.alpha.value = this.maskSprite.worldAlpha;
	
	    var shader = this.getShader(renderer);
	     // draw the filter...
	    filterManager.applyFilter(shader, input, output);
	};
	
	
	Object.defineProperties(SpriteMaskFilter.prototype, {
	    /**
	     * The texture used for the displacement map. Must be power of 2 sized texture.
	     *
	     * @member {PIXI.Texture}
	     * @memberof PIXI.SpriteMaskFilter#
	     */
	    map: {
	        get: function ()
	        {
	            return this.uniforms.mask.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.mask.value = value;
	        }
	    },
	
	    /**
	     * The offset used to move the displacement map.
	     *
	     * @member {PIXI.Point}
	     * @memberof PIXI.SpriteMaskFilter#
	     */
	    offset: {
	        get: function()
	        {
	            return this.uniforms.offset.value;
	        },
	        set: function(value)
	        {
	            this.uniforms.offset.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 102 */
/*!**********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/managers/FilterManager.js ***!
  \**********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var WebGLManager = __webpack_require__(/*! ./WebGLManager */ 23),
	    RenderTarget = __webpack_require__(/*! ../utils/RenderTarget */ 40),
	    CONST = __webpack_require__(/*! ../../../const */ 6),
	    Quad = __webpack_require__(/*! ../utils/Quad */ 192),
	    math =  __webpack_require__(/*! ../../../math */ 9);
	
	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.WebGLManager
	 * @param renderer {PIXI.WebGLRenderer} The renderer this manager works for.
	 */
	function FilterManager(renderer)
	{
	    WebGLManager.call(this, renderer);
	
	    /**
	     * @member {object[]}
	     */
	    this.filterStack = [];
	
	    this.filterStack.push({
	        renderTarget:renderer.currentRenderTarget,
	        filter:[],
	        bounds:null
	    });
	
	    /**
	     * @member {PIXI.RenderTarget[]}
	     */
	    this.texturePool = [];
	
	    /**
	     * The size of the texture
	     *
	     * @member {PIXI.Rectangle}
	     */
	    // listen for context and update necessary buffers
	    //TODO make this dynamic!
	    //TODO test this out by forces power of two?
	    this.textureSize = new math.Rectangle(0, 0, renderer.width, renderer.height);
	
	    /**
	     * The current frame
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.currentFrame = null;
	}
	
	FilterManager.prototype = Object.create(WebGLManager.prototype);
	FilterManager.prototype.constructor = FilterManager;
	module.exports = FilterManager;
	
	
	/**
	 * Called when there is a WebGL context change.
	 *
	 */
	FilterManager.prototype.onContextChange = function ()
	{
	    this.texturePool.length = 0;
	
	    var gl = this.renderer.gl;
	    this.quad = new Quad(gl);
	};
	
	/**
	 * @param renderer {PIXI.WebGLRenderer}
	 * @param buffer {ArrayBuffer}
	 */
	FilterManager.prototype.setFilterStack = function ( filterStack )
	{
	    this.filterStack = filterStack;
	};
	
	/**
	 * Applies the filter and adds it to the current filter stack.
	 *
	 * @param target {PIXI.DisplayObject}
	 * @param filters {PIXI.AbstractFiler[]} the filters that will be pushed to the current filter stack
	 */
	FilterManager.prototype.pushFilter = function (target, filters)
	{
	    // get the bounds of the object..
	    // TODO replace clone with a copy to save object creation
	    var bounds = target.filterArea ? target.filterArea.clone() : target.getBounds();
	
	    //bounds = bounds.clone();
	
	    // round off the rectangle to get a nice smoooooooth filter :)
	    bounds.x = bounds.x | 0;
	    bounds.y = bounds.y | 0;
	    bounds.width = bounds.width | 0;
	    bounds.height = bounds.height | 0;
	
	
	    // padding!
	    var padding = filters[0].padding | 0;
	    bounds.x -= padding;
	    bounds.y -= padding;
	    bounds.width += padding * 2;
	    bounds.height += padding * 2;
	
	
	    if(this.renderer.currentRenderTarget.transform)
	    {
	        //TODO this will break if the renderTexture transform is anything other than a translation.
	        //Will need to take the full matrix transform into acount..
	        var transform = this.renderer.currentRenderTarget.transform;
	
	        bounds.x += transform.tx;
	        bounds.y += transform.ty;
	
	        this.capFilterArea( bounds );
	
	        bounds.x -= transform.tx;
	        bounds.y -= transform.ty;
	    }
	    else
	    {
	         this.capFilterArea( bounds );
	    }
	
	    if(bounds.width > 0 && bounds.height > 0)
	    {
	        this.currentFrame = bounds;
	
	        var texture = this.getRenderTarget();
	
	        this.renderer.setRenderTarget(texture);
	
	        // clear the texture..
	        texture.clear();
	
	        // TODO get rid of object creation!
	        this.filterStack.push({
	            renderTarget: texture,
	            filter: filters
	        });
	
	    }
	    else
	    {
	        // push somthing on to the stack that is empty
	        this.filterStack.push({
	            renderTarget: null,
	            filter: filters
	        });
	    }
	};
	
	
	/**
	 * Removes the last filter from the filter stack and returns it.
	 *
	 */
	FilterManager.prototype.popFilter = function ()
	{
	    var filterData = this.filterStack.pop();
	    var previousFilterData = this.filterStack[this.filterStack.length-1];
	
	    var input = filterData.renderTarget;
	
	    // if the renderTarget is null then we don't apply the filter as its offscreen
	    if(!filterData.renderTarget)
	    {
	        return;
	    }
	
	    var output = previousFilterData.renderTarget;
	
	    // use program
	    var gl = this.renderer.gl;
	
	
	    this.currentFrame = input.frame;
	
	    this.quad.map(this.textureSize, input.frame);
	
	
	    // TODO.. this probably only needs to be done once!
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.quad.vertexBuffer);
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.quad.indexBuffer);
	
	    var filters = filterData.filter;
	
	    // assuming all filters follow the correct format??
	    gl.vertexAttribPointer(this.renderer.shaderManager.defaultShader.attributes.aVertexPosition, 2, gl.FLOAT, false, 0, 0);
	    gl.vertexAttribPointer(this.renderer.shaderManager.defaultShader.attributes.aTextureCoord, 2, gl.FLOAT, false, 0, 2 * 4 * 4);
	    gl.vertexAttribPointer(this.renderer.shaderManager.defaultShader.attributes.aColor, 4, gl.FLOAT, false, 0, 4 * 4 * 4);
	
	    // restore the normal blendmode!
	    this.renderer.blendModeManager.setBlendMode(CONST.BLEND_MODES.NORMAL);
	
	    if (filters.length === 1)
	    {
	        // TODO (cengler) - There has to be a better way then setting this each time?
	        if (filters[0].uniforms.dimensions)
	        {
	            filters[0].uniforms.dimensions.value[0] = this.renderer.width;
	            filters[0].uniforms.dimensions.value[1] = this.renderer.height;
	            filters[0].uniforms.dimensions.value[2] = this.quad.vertices[0];
	            filters[0].uniforms.dimensions.value[3] = this.quad.vertices[5];
	        }
	
	        filters[0].applyFilter( this.renderer, input, output );
	        this.returnRenderTarget( input );
	
	    }
	    else
	    {
	        var flipTexture = input;
	        var flopTexture = this.getRenderTarget(true);
	
	        for (var i = 0; i < filters.length-1; i++)
	        {
	            var filter = filters[i];
	
	            // TODO (cengler) - There has to be a better way then setting this each time?
	            if (filter.uniforms.dimensions)
	            {
	                filter.uniforms.dimensions.value[0] = this.renderer.width;
	                filter.uniforms.dimensions.value[1] = this.renderer.height;
	                filter.uniforms.dimensions.value[2] = this.quad.vertices[0];
	                filter.uniforms.dimensions.value[3] = this.quad.vertices[5];
	            }
	
	            filter.applyFilter( this.renderer, flipTexture, flopTexture );
	
	            var temp = flipTexture;
	            flipTexture = flopTexture;
	            flopTexture = temp;
	        }
	
	        filters[filters.length-1].applyFilter( this.renderer, flipTexture, output );
	
	        this.returnRenderTarget( flipTexture );
	        this.returnRenderTarget( flopTexture );
	    }
	
	    return filterData.filter;
	};
	
	/**
	 * Grabs an render target from the internal pool
	 *
	 * @param clear {boolean} Whether or not we need to clear the RenderTarget
	 * @return {RenderTarget}
	 */
	FilterManager.prototype.getRenderTarget = function ( clear )
	{
	    var renderTarget = this.texturePool.pop() || new RenderTarget(this.renderer.gl, this.textureSize.width, this.textureSize.height, CONST.SCALE_MODES.LINEAR, this.renderer.resolution * CONST.FILTER_RESOLUTION);
	    renderTarget.frame = this.currentFrame;
	
	    if (clear)
	    {
	        renderTarget.clear(true);
	    }
	
	    return renderTarget;
	};
	
	/*
	 * Returns a RenderTarget to the internal pool
	 * @param renderTarget {RenderTarget} The RenderTarget we want to return to the pool
	 */
	FilterManager.prototype.returnRenderTarget = function (renderTarget)
	{
	    this.texturePool.push( renderTarget );
	};
	
	/*
	 * Applies the filter
	 * @param shader {Shader} The shader to upload
	 * @param inputTarget {RenderTarget}
	 * @param outputTarget {RenderTarget}
	 * @param clear {boolean} Whether or not we want to clear the outputTarget
	 */
	FilterManager.prototype.applyFilter = function (shader, inputTarget, outputTarget, clear)
	{
	    var gl = this.renderer.gl;
	
	    this.renderer.setRenderTarget(outputTarget);
	
	    if (clear)
	    {
	        outputTarget.clear();
	    }
	
	    // set the shader
	    this.renderer.shaderManager.setShader(shader);
	
	    // TODO (cengler) - Can this be cached and not `toArray`ed each frame?
	    shader.uniforms.projectionMatrix.value = this.renderer.currentRenderTarget.projectionMatrix.toArray(true);
	
	    //TODO can this be optimised?
	    shader.syncUniforms();
	/*
	    gl.vertexAttribPointer(shader.attributes.aVertexPosition, 2, gl.FLOAT, false, 0, 0);
	    gl.vertexAttribPointer(shader.attributes.aTextureCoord, 2, gl.FLOAT, false, 0, 2 * 4 * 4);
	    gl.vertexAttribPointer(shader.attributes.aColor, 4, gl.FLOAT, false, 0, 4 * 4 * 4);
	*/
	
	    gl.activeTexture(gl.TEXTURE0);
	    gl.bindTexture(gl.TEXTURE_2D, inputTarget.texture);
	
	    gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	    this.renderer.drawCount++;
	};
	
	/*
	 * Calculates the mapped matrix
	 * @param filterArea {Rectangle} The filter area
	 * @param sprite {Sprite} the target sprite
	 * @param outputMatrix {Matrix} @alvin
	 */
	// TODO playing around here.. this is temporary - (will end up in the shader)
	FilterManager.prototype.calculateMappedMatrix = function (filterArea, sprite, outputMatrix)
	{
	    var worldTransform = sprite.worldTransform.copy(math.Matrix.TEMP_MATRIX),
	    texture = sprite._texture.baseTexture;
	
	    var mappedMatrix = outputMatrix.identity();
	
	    // scale..
	    var ratio = this.textureSize.height / this.textureSize.width;
	
	    mappedMatrix.translate(filterArea.x / this.textureSize.width, filterArea.y / this.textureSize.height );
	
	    mappedMatrix.scale(1 , ratio);
	
	    var translateScaleX = (this.textureSize.width / texture.width);
	    var translateScaleY = (this.textureSize.height / texture.height);
	
	    worldTransform.tx /= texture.width * translateScaleX;
	    worldTransform.ty /= texture.width * translateScaleX;
	
	    worldTransform.invert();
	
	    mappedMatrix.prepend(worldTransform);
	
	    // apply inverse scale..
	    mappedMatrix.scale(1 , 1/ratio);
	
	    mappedMatrix.scale( translateScaleX , translateScaleY );
	
	    mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);
	
	    return mappedMatrix;
	
	    // Keeping the orginal as a reminder to me on how this works!
	    //
	    // var m = new math.Matrix();
	
	    // // scale..
	    // var ratio = this.textureSize.height / this.textureSize.width;
	
	    // m.translate(filterArea.x / this.textureSize.width, filterArea.y / this.textureSize.height);
	
	
	    // m.scale(1 , ratio);
	
	
	    // var transform = wt.clone();
	
	    // var translateScaleX = (this.textureSize.width / 620);
	    // var translateScaleY = (this.textureSize.height / 380);
	
	    // transform.tx /= 620 * translateScaleX;
	    // transform.ty /= 620 * translateScaleX;
	
	    // transform.invert();
	
	    // transform.append(m);
	
	    // // apply inverse scale..
	    // transform.scale(1 , 1/ratio);
	
	    // transform.scale( translateScaleX , translateScaleY );
	
	    // return transform;
	};
	
	/*
	 * Constrains the filter area to the texture size
	 * @param filterArea {Rectangle} The filter area we want to cap
	 */
	FilterManager.prototype.capFilterArea = function (filterArea)
	{
	    if (filterArea.x < 0)
	    {
	        filterArea.width += filterArea.x;
	        filterArea.x = 0;
	    }
	
	    if (filterArea.y < 0)
	    {
	        filterArea.height += filterArea.y;
	        filterArea.y = 0;
	    }
	
	    if ( filterArea.x + filterArea.width > this.textureSize.width )
	    {
	        filterArea.width = this.textureSize.width - filterArea.x;
	    }
	
	    if ( filterArea.y + filterArea.height > this.textureSize.height )
	    {
	        filterArea.height = this.textureSize.height - filterArea.y;
	    }
	};
	
	/*
	 * Resizes all the render targets in the pool
	 * @param width {number} the new width
	 * @param height {number} the new height
	 */
	FilterManager.prototype.resize = function ( width, height )
	{
	    this.textureSize.width = width;
	    this.textureSize.height = height;
	
	    for (var i = 0; i < this.texturePool.length; i++)
	    {
	        this.texturePool[i].resize( width, height );
	    }
	};
	
	/**
	 * Destroys the filter and removes it from the filter stack.
	 *
	 */
	FilterManager.prototype.destroy = function ()
	{
	    this.quad.destroy();
	    
	    WebGLManager.prototype.destroy.call(this);
	    
	    this.filterStack = null;
	    this.offsetY = 0;
	
	    // destroy textures
	    for (var i = 0; i < this.texturePool.length; i++)
	    {
	        this.texturePool[i].destroy();
	    }
	
	    this.texturePool = null;
	};


/***/ },
/* 103 */
/*!**********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/managers/ShaderManager.js ***!
  \**********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var WebGLManager = __webpack_require__(/*! ./WebGLManager */ 23),
	    TextureShader = __webpack_require__(/*! ../shaders/TextureShader */ 39),
	    ComplexPrimitiveShader = __webpack_require__(/*! ../shaders/ComplexPrimitiveShader */ 104),
	    PrimitiveShader = __webpack_require__(/*! ../shaders/PrimitiveShader */ 105),
	    utils = __webpack_require__(/*! ../../../utils */ 7);
	
	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.WebGLManager
	 * @param renderer {PIXI.WebGLRenderer} The renderer this manager works for.
	 */
	function ShaderManager(renderer)
	{
	    WebGLManager.call(this, renderer);
	
	    /**
	     * @member {number}
	     */
	    this.maxAttibs = 10;
	
	    /**
	     * @member {any[]}
	     */
	    this.attribState = [];
	
	    /**
	     * @member {any[]}
	     */
	    this.tempAttribState = [];
	
	    for (var i = 0; i < this.maxAttibs; i++)
	    {
	        this.attribState[i] = false;
	    }
	
	    /**
	     * @member {any[]}
	     */
	    this.stack = [];
	
	    /**
	     * @member {number}
	     * @private
	     */
	    this._currentId = -1;
	
	    /**
	     * @member {PIXI.Shader}
	     * @private
	     */
	    this.currentShader = null;
	
	//    this.initPlugins();
	}
	
	ShaderManager.prototype = Object.create(WebGLManager.prototype);
	ShaderManager.prototype.constructor = ShaderManager;
	utils.pluginTarget.mixin(ShaderManager);
	
	module.exports = ShaderManager;
	
	/**
	 * Called when there is a WebGL context change.
	 *
	 */
	ShaderManager.prototype.onContextChange = function ()
	{
	    this.initPlugins();
	
	    var gl = this.renderer.gl;
	
	    // get the maximum number of attribute correctly as this tends to vary
	    this.maxAttibs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
	
	    this.attribState = [];
	
	    for (var i = 0; i < this.maxAttibs; i++)
	    {
	        this.attribState[i] = false;
	    }
	
	    // TODO - Why are these not plugins? We can't decouple primitives unless they are....
	    this.defaultShader = new TextureShader(this);
	    this.primitiveShader = new PrimitiveShader(this);
	    this.complexPrimitiveShader = new ComplexPrimitiveShader(this);
	};
	
	/**
	 * Takes the attributes given in parameters and uploads them.
	 *
	 * @param attribs {any[]} attribs
	 */
	ShaderManager.prototype.setAttribs = function (attribs)
	{
	    // reset temp state
	    var i;
	
	    for (i = 0; i < this.tempAttribState.length; i++)
	    {
	        this.tempAttribState[i] = false;
	    }
	
	    // set the new attribs
	    for (var a in attribs)
	    {
	        this.tempAttribState[attribs[a]] = true;
	    }
	
	    var gl = this.renderer.gl;
	
	    for (i = 0; i < this.attribState.length; i++)
	    {
	        if (this.attribState[i] !== this.tempAttribState[i])
	        {
	            this.attribState[i] = this.tempAttribState[i];
	
	            if (this.attribState[i])
	            {
	                gl.enableVertexAttribArray(i);
	            }
	            else
	            {
	                gl.disableVertexAttribArray(i);
	            }
	        }
	    }
	};
	
	/**
	 * Sets the current shader.
	 *
	 * @param shader {PIXI.Shader} the shader to upload
	 */
	ShaderManager.prototype.setShader = function (shader)
	{
	    if (this._currentId === shader.uid)
	    {
	        return false;
	    }
	
	    this._currentId = shader.uid;
	
	    this.currentShader = shader;
	
	    this.renderer.gl.useProgram(shader.program);
	    this.setAttribs(shader.attributes);
	
	    return true;
	};
	
	/**
	 * Destroys this object.
	 *
	 */
	ShaderManager.prototype.destroy = function ()
	{
	    this.primitiveShader.destroy();
	    this.complexPrimitiveShader.destroy();
	    WebGLManager.prototype.destroy.call(this);
	
	    this.destroyPlugins();
	
	    this.attribState = null;
	
	    this.tempAttribState = null;
	};


/***/ },
/* 104 */
/*!******************************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/shaders/ComplexPrimitiveShader.js ***!
  \******************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Shader = __webpack_require__(/*! ./Shader */ 38);
	
	/**
	 * This shader is used to draw complex primitive shapes for {@link PIXI.Graphics}.
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 * @param shaderManager {PIXI.ShaderManager} The webgl shader manager this shader works for.
	 */
	function ComplexPrimitiveShader(shaderManager)
	{
	    Shader.call(this,
	        shaderManager,
	        // vertex shader
	        [
	            'attribute vec2 aVertexPosition;',
	
	            'uniform mat3 translationMatrix;',
	            'uniform mat3 projectionMatrix;',
	
	            'uniform vec3 tint;',
	            'uniform float alpha;',
	            'uniform vec3 color;',
	
	            'varying vec4 vColor;',
	
	            'void main(void){',
	            '   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);',
	            '   vColor = vec4(color * alpha * tint, alpha);',//" * vec4(tint * alpha, alpha);',
	            '}'
	        ].join('\n'),
	        // fragment shader
	        [
	            'precision mediump float;',
	
	            'varying vec4 vColor;',
	
	            'void main(void){',
	            '   gl_FragColor = vColor;',
	            '}'
	        ].join('\n'),
	        // custom uniforms
	        {
	            tint:   { type: '3f', value: [0, 0, 0] },
	            alpha:  { type: '1f', value: 0 },
	            color:  { type: '3f', value: [0,0,0] },
	            translationMatrix: { type: 'mat3', value: new Float32Array(9) },
	            projectionMatrix: { type: 'mat3', value: new Float32Array(9) }
	        },
	        // attributes
	        {
	            aVertexPosition:0
	        }
	    );
	}
	
	ComplexPrimitiveShader.prototype = Object.create(Shader.prototype);
	ComplexPrimitiveShader.prototype.constructor = ComplexPrimitiveShader;
	module.exports = ComplexPrimitiveShader;


/***/ },
/* 105 */
/*!***********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/shaders/PrimitiveShader.js ***!
  \***********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Shader = __webpack_require__(/*! ./Shader */ 38);
	
	/**
	 * This shader is used to draw simple primitive shapes for {@link PIXI.Graphics}.
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 * @param shaderManager {ShaderManager} The webgl shader manager this shader works for.
	 */
	function PrimitiveShader(shaderManager)
	{
	    Shader.call(this,
	        shaderManager,
	        // vertex shader
	        [
	            'attribute vec2 aVertexPosition;',
	            'attribute vec4 aColor;',
	
	            'uniform mat3 translationMatrix;',
	            'uniform mat3 projectionMatrix;',
	
	            'uniform float alpha;',
	            'uniform float flipY;',
	            'uniform vec3 tint;',
	
	            'varying vec4 vColor;',
	
	            'void main(void){',
	            '   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);',
	            '   vColor = aColor * vec4(tint * alpha, alpha);',
	            '}'
	        ].join('\n'),
	        // fragment shader
	        [
	            'precision mediump float;',
	
	            'varying vec4 vColor;',
	
	            'void main(void){',
	            '   gl_FragColor = vColor;',
	            '}'
	        ].join('\n'),
	        // custom uniforms
	        {
	            tint:   { type: '3f', value: [0, 0, 0] },
	            alpha:  { type: '1f', value: 0 },
	            translationMatrix: { type: 'mat3', value: new Float32Array(9) },
	            projectionMatrix: { type: 'mat3', value: new Float32Array(9) }
	        },
	        // custom attributes
	        {
	            aVertexPosition:0,
	            aColor:0
	        }
	    );
	}
	
	PrimitiveShader.prototype = Object.create(Shader.prototype);
	PrimitiveShader.prototype.constructor = PrimitiveShader;
	module.exports = PrimitiveShader;


/***/ },
/* 106 */
/*!**********************************************!*\
  !*** ./~/pixi.js/src/core/sprites/Sprite.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	var math = __webpack_require__(/*! ../math */ 9),
	    Texture = __webpack_require__(/*! ../textures/Texture */ 30),
	    Container = __webpack_require__(/*! ../display/Container */ 36),
	    CanvasTinter = __webpack_require__(/*! ../renderers/canvas/utils/CanvasTinter */ 99),
	    utils = __webpack_require__(/*! ../utils */ 7),
	    CONST = __webpack_require__(/*! ../const */ 6),
	    tempPoint = new math.Point(),
	    GroupD8 = math.GroupD8,
	    canvasRenderWorldTransform = new math.Matrix();
	
	/**
	 * The Sprite object is the base for all textured objects that are rendered to the screen
	 *
	 * A sprite can be created directly from an image like this:
	 *
	 * ```js
	 * var sprite = new PIXI.Sprite.fromImage('assets/image.png');
	 * ```
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 * @param texture {PIXI.Texture} The texture for this sprite
	 */
	function Sprite(texture)
	{
	    Container.call(this);
	
	    /**
	     * The anchor sets the origin point of the texture.
	     * The default is 0,0 this means the texture's origin is the top left
	     * Setting the anchor to 0.5,0.5 means the texture's origin is centered
	     * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner
	     *
	     * @member {PIXI.Point}
	     */
	    this.anchor = new math.Point();
	
	    /**
	     * The texture that the sprite is using
	     *
	     * @member {PIXI.Texture}
	     * @private
	     */
	    this._texture = null;
	
	    /**
	     * The width of the sprite (this is initially set by the texture)
	     *
	     * @member {number}
	     * @private
	     */
	    this._width = 0;
	
	    /**
	     * The height of the sprite (this is initially set by the texture)
	     *
	     * @member {number}
	     * @private
	     */
	    this._height = 0;
	
	    /**
	     * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	     *
	     * @member {number}
	     * @default 0xFFFFFF
	     */
	    this.tint = 0xFFFFFF;
	
	    /**
	     * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	     *
	     * @member {number}
	     * @default PIXI.BLEND_MODES.NORMAL
	     * @see PIXI.BLEND_MODES
	     */
	    this.blendMode = CONST.BLEND_MODES.NORMAL;
	
	    /**
	     * The shader that will be used to render the sprite. Set to null to remove a current shader.
	     *
	     * @member {PIXI.AbstractFilter|PIXI.Shader}
	     */
	    this.shader = null;
	
	    /**
	     * An internal cached value of the tint.
	     *
	     * @member {number}
	     * @default 0xFFFFFF
	     */
	    this.cachedTint = 0xFFFFFF;
	
	    // call texture setter
	    this.texture = texture || Texture.EMPTY;
	}
	
	// constructor
	Sprite.prototype = Object.create(Container.prototype);
	Sprite.prototype.constructor = Sprite;
	module.exports = Sprite;
	
	Object.defineProperties(Sprite.prototype, {
	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     * @memberof PIXI.Sprite#
	     */
	    width: {
	        get: function ()
	        {
	            return Math.abs(this.scale.x) * this.texture._frame.width;
	        },
	        set: function (value)
	        {
	            var sign = utils.sign(this.scale.x) || 1;
	            this.scale.x = sign * value / this.texture._frame.width;
	            this._width = value;
	        }
	    },
	
	    /**
	     * The height of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     * @memberof PIXI.Sprite#
	     */
	    height: {
	        get: function ()
	        {
	            return  Math.abs(this.scale.y) * this.texture._frame.height;
	        },
	        set: function (value)
	        {
	            var sign = utils.sign(this.scale.y) || 1;
	            this.scale.y = sign * value / this.texture._frame.height;
	            this._height = value;
	        }
	    },
	
	    /**
	     * The texture that the sprite is using
	     *
	     * @member {PIXI.Texture}
	     * @memberof PIXI.Sprite#
	     */
	    texture: {
	        get: function ()
	        {
	            return  this._texture;
	        },
	        set: function (value)
	        {
	            if (this._texture === value)
	            {
	                return;
	            }
	
	            this._texture = value;
	            this.cachedTint = 0xFFFFFF;
	
	            if (value)
	            {
	                // wait for the texture to load
	                if (value.baseTexture.hasLoaded)
	                {
	                    this._onTextureUpdate();
	                }
	                else
	                {
	                    value.once('update', this._onTextureUpdate, this);
	                }
	            }
	        }
	    }
	});
	
	/**
	 * When the texture is updated, this event will fire to update the scale and frame
	 *
	 * @private
	 */
	Sprite.prototype._onTextureUpdate = function ()
	{
	    // so if _width is 0 then width was not set..
	    if (this._width)
	    {
	        this.scale.x = utils.sign(this.scale.x) * this._width / this.texture.frame.width;
	    }
	
	    if (this._height)
	    {
	        this.scale.y = utils.sign(this.scale.y) * this._height / this.texture.frame.height;
	    }
	};
	
	/**
	*
	* Renders the object using the WebGL renderer
	*
	* @param renderer {PIXI.WebGLRenderer}
	* @private
	*/
	Sprite.prototype._renderWebGL = function (renderer)
	{
	    renderer.setObjectRenderer(renderer.plugins.sprite);
	    renderer.plugins.sprite.render(this);
	};
	
	/**
	 * Returns the bounds of the Sprite as a rectangle. The bounds calculation takes the worldTransform into account.
	 *
	 * @param matrix {PIXI.Matrix} the transformation matrix of the sprite
	 * @return {PIXI.Rectangle} the framing rectangle
	 */
	Sprite.prototype.getBounds = function (matrix)
	{
	    if(!this._currentBounds)
	    {
	
	        var width = this._texture._frame.width;
	        var height = this._texture._frame.height;
	
	        var w0 = width * (1-this.anchor.x);
	        var w1 = width * -this.anchor.x;
	
	        var h0 = height * (1-this.anchor.y);
	        var h1 = height * -this.anchor.y;
	
	        var worldTransform = matrix || this.worldTransform ;
	
	        var a = worldTransform.a;
	        var b = worldTransform.b;
	        var c = worldTransform.c;
	        var d = worldTransform.d;
	        var tx = worldTransform.tx;
	        var ty = worldTransform.ty;
	
	        var minX,
	            maxX,
	            minY,
	            maxY;
	
	        //TODO - I am SURE this can be optimised, but the below is not accurate enough..
	        /*
	        if (b === 0 && c === 0)
	        {
	            // scale may be negative!
	            if (a < 0)
	            {
	                a *= -1;
	            }
	
	            if (d < 0)
	            {
	                d *= -1;
	            }
	
	            // this means there is no rotation going on right? RIGHT?
	            // if thats the case then we can avoid checking the bound values! yay
	            minX = a * w1 + tx;
	            maxX = a * w0 + tx;
	            minY = d * h1 + ty;
	            maxY = d * h0 + ty;
	        }
	        else
	        {
	        */
	
	        var x1 = a * w1 + c * h1 + tx;
	        var y1 = d * h1 + b * w1 + ty;
	
	        var x2 = a * w0 + c * h1 + tx;
	        var y2 = d * h1 + b * w0 + ty;
	
	        var x3 = a * w0 + c * h0 + tx;
	        var y3 = d * h0 + b * w0 + ty;
	
	        var x4 =  a * w1 + c * h0 + tx;
	        var y4 =  d * h0 + b * w1 + ty;
	
	        minX = x1;
	        minX = x2 < minX ? x2 : minX;
	        minX = x3 < minX ? x3 : minX;
	        minX = x4 < minX ? x4 : minX;
	
	        minY = y1;
	        minY = y2 < minY ? y2 : minY;
	        minY = y3 < minY ? y3 : minY;
	        minY = y4 < minY ? y4 : minY;
	
	        maxX = x1;
	        maxX = x2 > maxX ? x2 : maxX;
	        maxX = x3 > maxX ? x3 : maxX;
	        maxX = x4 > maxX ? x4 : maxX;
	
	        maxY = y1;
	        maxY = y2 > maxY ? y2 : maxY;
	        maxY = y3 > maxY ? y3 : maxY;
	        maxY = y4 > maxY ? y4 : maxY;
	
	        //}
	
	        // check for children
	        if(this.children.length)
	        {
	            var childBounds = this.containerGetBounds();
	
	            w0 = childBounds.x;
	            w1 = childBounds.x + childBounds.width;
	            h0 = childBounds.y;
	            h1 = childBounds.y + childBounds.height;
	
	            minX = (minX < w0) ? minX : w0;
	            minY = (minY < h0) ? minY : h0;
	
	            maxX = (maxX > w1) ? maxX : w1;
	            maxY = (maxY > h1) ? maxY : h1;
	        }
	
	        var bounds = this._bounds;
	
	        bounds.x = minX;
	        bounds.width = maxX - minX;
	
	        bounds.y = minY;
	        bounds.height = maxY - minY;
	
	        // store a reference so that if this function gets called again in the render cycle we do not have to recalculate
	        this._currentBounds = bounds;
	    }
	
	    return this._currentBounds;
	};
	
	/**
	 * Gets the local bounds of the sprite object.
	 *
	 */
	Sprite.prototype.getLocalBounds = function ()
	{
	    this._bounds.x = -this._texture._frame.width * this.anchor.x;
	    this._bounds.y = -this._texture._frame.height * this.anchor.y;
	    this._bounds.width = this._texture._frame.width;
	    this._bounds.height = this._texture._frame.height;
	    return this._bounds;
	};
	
	/**
	* Tests if a point is inside this sprite
	*
	* @param point {PIXI.Point} the point to test
	* @return {boolean} the result of the test
	*/
	Sprite.prototype.containsPoint = function( point )
	{
	    this.worldTransform.applyInverse(point,  tempPoint);
	
	    var width = this._texture._frame.width;
	    var height = this._texture._frame.height;
	    var x1 = -width * this.anchor.x;
	    var y1;
	
	    if ( tempPoint.x > x1 && tempPoint.x < x1 + width )
	    {
	        y1 = -height * this.anchor.y;
	
	        if ( tempPoint.y > y1 && tempPoint.y < y1 + height )
	        {
	            return true;
	        }
	    }
	
	    return false;
	};
	
	/**
	* Renders the object using the Canvas renderer
	*
	* @param renderer {PIXI.CanvasRenderer} The renderer
	* @private
	*/
	Sprite.prototype._renderCanvas = function (renderer)
	{
	    if (this.texture.crop.width <= 0 || this.texture.crop.height <= 0)
	    {
	        return;
	    }
	
	    var compositeOperation = renderer.blendModes[this.blendMode];
	    if (compositeOperation !== renderer.context.globalCompositeOperation)
	    {
	        renderer.context.globalCompositeOperation = compositeOperation;
	    }
	
	    //  Ignore null sources
	    if (this.texture.valid)
	    {
	        var texture = this._texture,
	            wt = this.worldTransform,
	            dx,
	            dy,
	            width = texture.crop.width,
	            height = texture.crop.height;
	
	        renderer.context.globalAlpha = this.worldAlpha;
	
	        // If smoothingEnabled is supported and we need to change the smoothing property for this texture
	        var smoothingEnabled = texture.baseTexture.scaleMode === CONST.SCALE_MODES.LINEAR;
	        if (renderer.smoothProperty && renderer.context[renderer.smoothProperty] !== smoothingEnabled)
	        {
	            renderer.context[renderer.smoothProperty] = smoothingEnabled;
	        }
	
	        //inline GroupD8.isSwapWidthHeight
	        if ((texture.rotate & 3) === 2) {
	            width = texture.crop.height;
	            height = texture.crop.width;
	        }
	        if (texture.trim) {
	            dx = texture.crop.width/2 + texture.trim.x - this.anchor.x * texture.trim.width;
	            dy = texture.crop.height/2 + texture.trim.y - this.anchor.y * texture.trim.height;
	        } else {
	            dx = (0.5 - this.anchor.x) * texture._frame.width;
	            dy = (0.5 - this.anchor.y) * texture._frame.height;
	        }
	        if(texture.rotate) {
	            wt.copy(canvasRenderWorldTransform);
	            wt = canvasRenderWorldTransform;
	            GroupD8.matrixAppendRotationInv(wt, texture.rotate, dx, dy);
	            // the anchor has already been applied above, so lets set it to zero
	            dx = 0;
	            dy = 0;
	        }
	        dx -= width/2;
	        dy -= height/2;
	        // Allow for pixel rounding
	        if (renderer.roundPixels)
	        {
	            renderer.context.setTransform(
	                wt.a,
	                wt.b,
	                wt.c,
	                wt.d,
	                (wt.tx * renderer.resolution) | 0,
	                (wt.ty * renderer.resolution) | 0
	            );
	
	            dx = dx | 0;
	            dy = dy | 0;
	        }
	        else
	        {
	
	            renderer.context.setTransform(
	                wt.a,
	                wt.b,
	                wt.c,
	                wt.d,
	                wt.tx * renderer.resolution,
	                wt.ty * renderer.resolution
	            );
	
	
	        }
	
	        var resolution = texture.baseTexture.resolution;
	
	        if (this.tint !== 0xFFFFFF)
	        {
	            if (this.cachedTint !== this.tint)
	            {
	                this.cachedTint = this.tint;
	
	                // TODO clean up caching - how to clean up the caches?
	                this.tintedTexture = CanvasTinter.getTintedTexture(this, this.tint);
	            }
	
	            renderer.context.drawImage(
	                this.tintedTexture,
	                0,
	                0,
	                width * resolution,
	                height * resolution,
	                dx * renderer.resolution,
	                dy * renderer.resolution,
	                width * renderer.resolution,
	                height * renderer.resolution
	            );
	        }
	        else
	        {
	            renderer.context.drawImage(
	                texture.baseTexture.source,
	                texture.crop.x * resolution,
	                texture.crop.y * resolution,
	                width * resolution,
	                height * resolution,
	                dx  * renderer.resolution,
	                dy  * renderer.resolution,
	                width * renderer.resolution,
	                height * renderer.resolution
	            );
	        }
	    }
	};
	
	/**
	 * Destroys this sprite and optionally its texture
	 *
	 * @param [destroyTexture=false] {boolean} Should it destroy the current texture of the sprite as well
	 * @param [destroyBaseTexture=false] {boolean} Should it destroy the base texture of the sprite as well
	 */
	Sprite.prototype.destroy = function (destroyTexture, destroyBaseTexture)
	{
	    Container.prototype.destroy.call(this);
	
	    this.anchor = null;
	
	    if (destroyTexture)
	    {
	        this._texture.destroy(destroyBaseTexture);
	    }
	
	    this._texture = null;
	    this.shader = null;
	};
	
	// some helper functions..
	
	/**
	 * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
	 * The frame ids are created when a Texture packer file has been loaded
	 *
	 * @static
	 * @param frameId {string} The frame Id of the texture in the cache
	 * @param [crossorigin=(auto)] {boolean} if you want to specify the cross-origin parameter
	 * @param [scaleMode=PIXI.SCALE_MODES.DEFAULT] {number} if you want to specify the scale mode, see {@link PIXI.SCALE_MODES} for possible values
	 * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the frameId
	 */
	Sprite.fromFrame = function (frameId)
	{
	    var texture = utils.TextureCache[frameId];
	
	    if (!texture)
	    {
	        throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
	    }
	
	    return new Sprite(texture);
	};
	
	/**
	 * Helper function that creates a sprite that will contain a texture based on an image url
	 * If the image is not in the texture cache it will be loaded
	 *
	 * @static
	 * @param imageId {string} The image url of the texture
	 * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the image id
	 */
	Sprite.fromImage = function (imageId, crossorigin, scaleMode)
	{
	    return new Sprite(Texture.fromImage(imageId, crossorigin, scaleMode));
	};


/***/ },
/* 107 */
/*!***************************************************!*\
  !*** ./~/pixi.js/src/core/textures/TextureUvs.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A standard object to store the Uvs of a texture
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	function TextureUvs()
	{
	    this.x0 = 0;
	    this.y0 = 0;
	
	    this.x1 = 1;
	    this.y1 = 0;
	
	    this.x2 = 1;
	    this.y2 = 1;
	
	    this.x3 = 0;
	    this.y3 = 1;
	}
	
	module.exports = TextureUvs;
	
	var GroupD8 = __webpack_require__(/*! ../math/GroupD8 */ 96);
	
	/**
	 * Sets the texture Uvs based on the given frame information
	 * @param frame {PIXI.Rectangle}
	 * @param baseFrame {PIXI.Rectangle}
	 * @param rotate {number} Rotation of frame, see {@link PIXI.GroupD8}
	 * @private
	 */
	TextureUvs.prototype.set = function (frame, baseFrame, rotate)
	{
	    var tw = baseFrame.width;
	    var th = baseFrame.height;
	
	    if(rotate)
	    {
	        //width and height div 2 div baseFrame size
	        var swapWidthHeight = GroupD8.isSwapWidthHeight(rotate);
	        var w2 = (swapWidthHeight ? frame.height : frame.width) / 2 / tw;
	        var h2 = (swapWidthHeight ? frame.width : frame.height) / 2 / th;
	        //coordinates of center
	        var cX = frame.x / tw + w2;
	        var cY = frame.y / th + h2;
	        rotate = GroupD8.add(rotate, GroupD8.NW); //NW is top-left corner
	        this.x0 = cX + w2 * GroupD8.uX(rotate);
	        this.y0 = cY + h2 * GroupD8.uY(rotate);
	        rotate = GroupD8.add(rotate, 2); //rotate 90 degrees clockwise
	        this.x1 = cX + w2 * GroupD8.uX(rotate);
	        this.y1 = cY + h2 * GroupD8.uY(rotate);
	        rotate = GroupD8.add(rotate, 2);
	        this.x2 = cX + w2 * GroupD8.uX(rotate);
	        this.y2 = cY + h2 * GroupD8.uY(rotate);
	        rotate = GroupD8.add(rotate, 2);
	        this.x3 = cX + w2 * GroupD8.uX(rotate);
	        this.y3 = cY + h2 * GroupD8.uY(rotate);
	    }
	    else
	    {
	
	        this.x0 = frame.x / tw;
	        this.y0 = frame.y / th;
	
	        this.x1 = (frame.x + frame.width) / tw;
	        this.y1 = frame.y / th;
	
	        this.x2 = (frame.x + frame.width) / tw;
	        this.y2 = (frame.y + frame.height) / th;
	
	        this.x3 = frame.x / tw;
	        this.y3 = (frame.y + frame.height) / th;
	    }
	};


/***/ },
/* 108 */
/*!*********************************************************!*\
  !*** ./~/pixi.js/src/core/textures/VideoBaseTexture.js ***!
  \*********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var BaseTexture = __webpack_require__(/*! ./BaseTexture */ 41),
	    utils = __webpack_require__(/*! ../utils */ 7);
	
	/**
	 * A texture of a [playing] Video.
	 *
	 * Video base textures mimic Pixi BaseTexture.from.... method in their creation process.
	 *
	 * This can be used in several ways, such as:
	 *
	 * ```js
	 * var texture = PIXI.VideoBaseTexture.fromUrl('http://mydomain.com/video.mp4');
	 *
	 * var texture = PIXI.VideoBaseTexture.fromUrl({ src: 'http://mydomain.com/video.mp4', mime: 'video/mp4' });
	 *
	 * var texture = PIXI.VideoBaseTexture.fromUrls(['/video.webm', '/video.mp4']);
	 *
	 * var texture = PIXI.VideoBaseTexture.fromUrls([
	 *     { src: '/video.webm', mime: 'video/webm' },
	 *     { src: '/video.mp4', mime: 'video/mp4' }
	 * ]);
	 * ```
	 *
	 * See the ["deus" demo](http://www.goodboydigital.com/pixijs/examples/deus/).
	 *
	 * @class
	 * @extends PIXI.BaseTexture
	 * @memberof PIXI
	 * @param source {HTMLVideoElement}
	 * @param [scaleMode] {number} See {@link PIXI.SCALE_MODES} for possible values
	 */
	function VideoBaseTexture(source, scaleMode)
	{
	    if (!source)
	    {
	        throw new Error('No video source element specified.');
	    }
	
	    // hook in here to check if video is already available.
	    // BaseTexture looks for a source.complete boolean, plus width & height.
	
	    if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height)
	    {
	        source.complete = true;
	    }
	
	    BaseTexture.call(this, source, scaleMode);
	
	    /**
	     * Should the base texture automatically update itself, set to true by default
	     *
	     * @member {boolean}
	     * @default true
	     */
	    this.autoUpdate = false;
	
	    this._onUpdate = this._onUpdate.bind(this);
	    this._onCanPlay = this._onCanPlay.bind(this);
	
	    if (!source.complete)
	    {
	        source.addEventListener('canplay', this._onCanPlay);
	        source.addEventListener('canplaythrough', this._onCanPlay);
	
	        // started playing..
	        source.addEventListener('play', this._onPlayStart.bind(this));
	        source.addEventListener('pause', this._onPlayStop.bind(this));
	    }
	
	    this.__loaded = false;
	}
	
	VideoBaseTexture.prototype = Object.create(BaseTexture.prototype);
	VideoBaseTexture.prototype.constructor = VideoBaseTexture;
	module.exports = VideoBaseTexture;
	
	/**
	 * The internal update loop of the video base texture, only runs when autoUpdate is set to true
	 *
	 * @private
	 */
	VideoBaseTexture.prototype._onUpdate = function ()
	{
	    if (this.autoUpdate)
	    {
	        window.requestAnimationFrame(this._onUpdate);
	        this.update();
	    }
	};
	
	/**
	 * Runs the update loop when the video is ready to play
	 *
	 * @private
	 */
	VideoBaseTexture.prototype._onPlayStart = function ()
	{
	    if (!this.autoUpdate)
	    {
	        window.requestAnimationFrame(this._onUpdate);
	        this.autoUpdate = true;
	    }
	};
	
	/**
	 * Fired when a pause event is triggered, stops the update loop
	 *
	 * @private
	 */
	VideoBaseTexture.prototype._onPlayStop = function ()
	{
	    this.autoUpdate = false;
	};
	
	/**
	 * Fired when the video is loaded and ready to play
	 *
	 * @private
	 */
	VideoBaseTexture.prototype._onCanPlay = function ()
	{
	    this.hasLoaded = true;
	
	    if (this.source)
	    {
	        this.source.removeEventListener('canplay', this._onCanPlay);
	        this.source.removeEventListener('canplaythrough', this._onCanPlay);
	
	        this.width = this.source.videoWidth;
	        this.height = this.source.videoHeight;
	
	        this.source.play();
	
	        // prevent multiple loaded dispatches..
	        if (!this.__loaded)
	        {
	            this.__loaded = true;
	            this.emit('loaded', this);
	        }
	    }
	};
	
	/**
	 * Destroys this texture
	 *
	 */
	VideoBaseTexture.prototype.destroy = function ()
	{
	    if (this.source && this.source._pixiId)
	    {
	        delete utils.BaseTextureCache[ this.source._pixiId ];
	        delete this.source._pixiId;
	    }
	
	    BaseTexture.prototype.destroy.call(this);
	};
	
	/**
	 * Mimic Pixi BaseTexture.from.... method.
	 *
	 * @static
	 * @param video {HTMLVideoElement}
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @return {PIXI.VideoBaseTexture}
	 */
	VideoBaseTexture.fromVideo = function (video, scaleMode)
	{
	    if (!video._pixiId)
	    {
	        video._pixiId = 'video_' + utils.uid();
	    }
	
	    var baseTexture = utils.BaseTextureCache[video._pixiId];
	
	    if (!baseTexture)
	    {
	        baseTexture = new VideoBaseTexture(video, scaleMode);
	        utils.BaseTextureCache[ video._pixiId ] = baseTexture;
	    }
	
	    return baseTexture;
	};
	
	/**
	 * Helper function that creates a new BaseTexture based on the given video element.
	 * This BaseTexture can then be used to create a texture
	 *
	 * @static
	 * @param videoSrc {string|object|string[]|object[]} The URL(s) for the video.
	 * @param [videoSrc.src] {string} One of the source urls for the video
	 * @param [videoSrc.mime] {string} The mimetype of the video (e.g. 'video/mp4'). If not specified
	 *  the url's extension will be used as the second part of the mime type.
	 * @param scaleMode {number} See {@link PIXI.SCALE_MODES} for possible values
	 * @return {PIXI.VideoBaseTexture}
	 */
	VideoBaseTexture.fromUrl = function (videoSrc, scaleMode)
	{
	    var video = document.createElement('video');
	
	    // array of objects or strings
	    if (Array.isArray(videoSrc))
	    {
	        for (var i = 0; i < videoSrc.length; ++i)
	        {
	            video.appendChild(createSource(videoSrc[i].src || videoSrc[i], videoSrc[i].mime));
	        }
	    }
	    // single object or string
	    else
	    {
	        video.appendChild(createSource(videoSrc.src || videoSrc, videoSrc.mime));
	    }
	
	    video.load();
	    video.play();
	
	    return VideoBaseTexture.fromVideo(video, scaleMode);
	};
	
	VideoBaseTexture.fromUrls = VideoBaseTexture.fromUrl;
	
	function createSource(path, type)
	{
	    if (!type)
	    {
	        type = 'video/' + path.substr(path.lastIndexOf('.') + 1);
	    }
	
	    var source = document.createElement('source');
	
	    source.src = path;
	    source.type = type;
	
	    return source;
	}


/***/ },
/* 109 */
/*!****************************************!*\
  !*** ./~/pixi.js/src/filters/index.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @file        Main export of the PIXI filters library
	 * @author      Mat Groves <mat@goodboydigital.com>
	 * @copyright   2013-2015 GoodBoyDigital
	 * @license     {@link https://github.com/pixijs/pixi.js/blob/master/LICENSE|MIT License}
	 */
	
	/**
	 * @namespace PIXI.filters
	 */
	module.exports = {
	    AsciiFilter:        __webpack_require__(/*! ./ascii/AsciiFilter */ 206),
	    BloomFilter:        __webpack_require__(/*! ./bloom/BloomFilter */ 207),
	    BlurFilter:         __webpack_require__(/*! ./blur/BlurFilter */ 209),
	    BlurXFilter:        __webpack_require__(/*! ./blur/BlurXFilter */ 42),
	    BlurYFilter:        __webpack_require__(/*! ./blur/BlurYFilter */ 63),
	    BlurDirFilter:      __webpack_require__(/*! ./blur/BlurDirFilter */ 208),
	    ColorMatrixFilter:  __webpack_require__(/*! ./color/ColorMatrixFilter */ 211),
	    ColorStepFilter:    __webpack_require__(/*! ./color/ColorStepFilter */ 212),
	    ConvolutionFilter:  __webpack_require__(/*! ./convolution/ConvolutionFilter */ 213),
	    CrossHatchFilter:   __webpack_require__(/*! ./crosshatch/CrossHatchFilter */ 214),
	    DisplacementFilter: __webpack_require__(/*! ./displacement/DisplacementFilter */ 215),
	    DotScreenFilter:    __webpack_require__(/*! ./dot/DotScreenFilter */ 216),
	    GrayFilter:         __webpack_require__(/*! ./gray/GrayFilter */ 219),
	    DropShadowFilter:   __webpack_require__(/*! ./dropshadow/DropShadowFilter */ 218),
	    InvertFilter:       __webpack_require__(/*! ./invert/InvertFilter */ 220),
	    NoiseFilter:        __webpack_require__(/*! ./noise/NoiseFilter */ 221),
	    PixelateFilter:     __webpack_require__(/*! ./pixelate/PixelateFilter */ 222),
	    RGBSplitFilter:     __webpack_require__(/*! ./rgb/RGBSplitFilter */ 223),
	    ShockwaveFilter:    __webpack_require__(/*! ./shockwave/ShockwaveFilter */ 225),
	    SepiaFilter:        __webpack_require__(/*! ./sepia/SepiaFilter */ 224),
	    SmartBlurFilter:    __webpack_require__(/*! ./blur/SmartBlurFilter */ 210),
	    TiltShiftFilter:    __webpack_require__(/*! ./tiltshift/TiltShiftFilter */ 226),
	    TiltShiftXFilter:   __webpack_require__(/*! ./tiltshift/TiltShiftXFilter */ 111),
	    TiltShiftYFilter:   __webpack_require__(/*! ./tiltshift/TiltShiftYFilter */ 112),
	    TwistFilter:        __webpack_require__(/*! ./twist/TwistFilter */ 227)
	};


/***/ },
/* 110 */
/*!****************************************************************!*\
  !*** ./~/pixi.js/src/filters/tiltshift/TiltShiftAxisFilter.js ***!
  \****************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * @author Vico @vicocotea
	 * original filter https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js by Evan Wallace : http://madebyevan.com/
	 */
	
	/**
	 * A TiltShiftAxisFilter.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function TiltShiftAxisFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/tiltShift.frag', 'utf8'),
	        // custom uniforms
	        {
	            blur:           { type: '1f', value: 100 },
	            gradientBlur:   { type: '1f', value: 600 },
	            start:          { type: 'v2', value: { x: 0,    y: window.innerHeight / 2 } },
	            end:            { type: 'v2', value: { x: 600,  y: window.innerHeight / 2 } },
	            delta:          { type: 'v2', value: { x: 30,   y: 30 } },
	            texSize:        { type: 'v2', value: { x: window.innerWidth, y: window.innerHeight } }
	        }
	    );
	
	    this.updateDelta();
	}
	
	TiltShiftAxisFilter.prototype = Object.create(core.AbstractFilter.prototype);
	TiltShiftAxisFilter.prototype.constructor = TiltShiftAxisFilter;
	module.exports = TiltShiftAxisFilter;
	
	/**
	 * Updates the filter delta values.
	 * This is overridden in the X and Y filters, does nothing for this class.
	 *
	 */
	TiltShiftAxisFilter.prototype.updateDelta = function ()
	{
	    this.uniforms.delta.value.x = 0;
	    this.uniforms.delta.value.y = 0;
	};
	
	Object.defineProperties(TiltShiftAxisFilter.prototype, {
	    /**
	     * The strength of the blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.TiltShiftAxisFilter#
	     */
	    blur: {
	        get: function ()
	        {
	            return this.uniforms.blur.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.blur.value = value;
	        }
	    },
	
	    /**
	     * The strength of the gradient blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.TiltShiftAxisFilter#
	     */
	    gradientBlur: {
	        get: function ()
	        {
	            return this.uniforms.gradientBlur.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.gradientBlur.value = value;
	        }
	    },
	
	    /**
	     * The X value to start the effect at.
	     *
	     * @member {PIXI.Point}
	     * @memberof PIXI.filters.TiltShiftAxisFilter#
	     */
	    start: {
	        get: function ()
	        {
	            return this.uniforms.start.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.start.value = value;
	            this.updateDelta();
	        }
	    },
	
	    /**
	     * The X value to end the effect at.
	     *
	     * @member {PIXI.Point}
	     * @memberof PIXI.filters.TiltShiftAxisFilter#
	     */
	    end: {
	        get: function ()
	        {
	            return this.uniforms.end.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.end.value = value;
	            this.updateDelta();
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 111 */
/*!*************************************************************!*\
  !*** ./~/pixi.js/src/filters/tiltshift/TiltShiftXFilter.js ***!
  \*************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var TiltShiftAxisFilter = __webpack_require__(/*! ./TiltShiftAxisFilter */ 110);
	
	/**
	 * @author Vico @vicocotea
	 * original filter https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js by Evan Wallace : http://madebyevan.com/
	 */
	
	/**
	 * A TiltShiftXFilter.
	 *
	 * @class
	 * @extends PIXI.TiltShiftAxisFilter
	 * @memberof PIXI.filters
	 */
	function TiltShiftXFilter()
	{
	    TiltShiftAxisFilter.call(this);
	}
	
	TiltShiftXFilter.prototype = Object.create(TiltShiftAxisFilter.prototype);
	TiltShiftXFilter.prototype.constructor = TiltShiftXFilter;
	module.exports = TiltShiftXFilter;
	
	/**
	 * Updates the filter delta values.
	 *
	 */
	TiltShiftXFilter.prototype.updateDelta = function ()
	{
	    var dx = this.uniforms.end.value.x - this.uniforms.start.value.x;
	    var dy = this.uniforms.end.value.y - this.uniforms.start.value.y;
	    var d = Math.sqrt(dx * dx + dy * dy);
	
	    this.uniforms.delta.value.x = dx / d;
	    this.uniforms.delta.value.y = dy / d;
	};


/***/ },
/* 112 */
/*!*************************************************************!*\
  !*** ./~/pixi.js/src/filters/tiltshift/TiltShiftYFilter.js ***!
  \*************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var TiltShiftAxisFilter = __webpack_require__(/*! ./TiltShiftAxisFilter */ 110);
	
	/**
	 * @author Vico @vicocotea
	 * original filter https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js by Evan Wallace : http://madebyevan.com/
	 */
	
	/**
	 * A TiltShiftYFilter.
	 *
	 * @class
	 * @extends PIXI.TiltShiftAxisFilter
	 * @memberof PIXI.filters
	 */
	function TiltShiftYFilter()
	{
	    TiltShiftAxisFilter.call(this);
	}
	
	TiltShiftYFilter.prototype = Object.create(TiltShiftAxisFilter.prototype);
	TiltShiftYFilter.prototype.constructor = TiltShiftYFilter;
	module.exports = TiltShiftYFilter;
	
	/**
	 * Updates the filter delta values.
	 *
	 */
	TiltShiftYFilter.prototype.updateDelta = function ()
	{
	    var dx = this.uniforms.end.value.x - this.uniforms.start.value.x;
	    var dy = this.uniforms.end.value.y - this.uniforms.start.value.y;
	    var d = Math.sqrt(dx * dx + dy * dy);
	
	    this.uniforms.delta.value.x = -dy / d;
	    this.uniforms.delta.value.y = dx / d;
	};


/***/ },
/* 113 */
/*!********************************!*\
  !*** ./~/pixi.js/src/index.js ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// run the polyfills
	__webpack_require__(/*! ./polyfill */ 238);
	
	var core = module.exports = __webpack_require__(/*! ./core */ 1);
	
	// add core plugins.
	core.extras         = __webpack_require__(/*! ./extras */ 62);
	core.filters        = __webpack_require__(/*! ./filters */ 109);
	core.interaction    = __webpack_require__(/*! ./interaction */ 229);
	core.loaders        = __webpack_require__(/*! ./loaders */ 230);
	core.mesh           = __webpack_require__(/*! ./mesh */ 119);
	core.accessibility  = __webpack_require__(/*! ./accessibility */ 175);
	
	// export a premade loader instance
	/**
	 * A premade instance of the loader that can be used to loader resources.
	 *
	 * @name loader
	 * @memberof PIXI
	 * @property {PIXI.loaders.Loader}
	 */
	core.loader = new core.loaders.Loader();
	
	// mixin the deprecation features.
	Object.assign(core, __webpack_require__(/*! ./deprecation */ 199));
	
	// Always export pixi globally.
	global.PIXI = core;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 114 */
/*!******************************************************!*\
  !*** ./~/pixi.js/src/interaction/InteractionData.js ***!
  \******************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1);
	
	/**
	 * Holds all information related to an Interaction event
	 *
	 * @class
	 * @memberof PIXI.interaction
	 */
	function InteractionData()
	{
	    /**
	     * This point stores the global coords of where the touch/mouse event happened
	     *
	     * @member {PIXI.Point}
	     */
	    this.global = new core.Point();
	
	    /**
	     * The target Sprite that was interacted with
	     *
	     * @member {PIXI.Sprite}
	     */
	    this.target = null;
	
	    /**
	     * When passed to an event handler, this will be the original DOM Event that was captured
	     *
	     * @member {Event}
	     */
	    this.originalEvent = null;
	}
	
	InteractionData.prototype.constructor = InteractionData;
	module.exports = InteractionData;
	
	/**
	 * This will return the local coordinates of the specified displayObject for this InteractionData
	 *
	 * @param displayObject {PIXI.DisplayObject} The DisplayObject that you would like the local coords off
	 * @param [point] {PIXI.Point} A Point object in which to store the value, optional (otherwise will create a new point)
	 * @param [globalPos] {PIXI.Point} A Point object containing your custom global coords, optional (otherwise will use the current global coords)
	 * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative to the DisplayObject
	 */
	InteractionData.prototype.getLocalPosition = function (displayObject, point, globalPos)
	{
	    return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
	};


/***/ },
/* 115 */
/*!********************************************************!*\
  !*** ./~/pixi.js/src/interaction/interactiveTarget.js ***!
  \********************************************************/
/***/ function(module, exports) {

	/**
	 * Default property values of interactive objects
	 * used by {@link PIXI.interaction.InteractionManager}.
	 *
	 * @mixin
	 * @memberof PIXI.interaction
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          MyObject.prototype,
	 *          PIXI.interaction.interactiveTarget
	 *      );
	 */
	var interactiveTarget = {
	    /**
	     * @todo Needs docs.
	     */
	    interactive: false,
	    /**
	     * @todo Needs docs.
	     */
	    buttonMode: false,
	    /**
	     * @todo Needs docs.
	     */
	    interactiveChildren: true,
	    /**
	     * @todo Needs docs.
	     */
	    defaultCursor: 'pointer',
	
	    // some internal checks..
	
	    /**
	     * @todo Needs docs.
	     * @private
	     */
	    _over: false,
	    /**
	     * @todo Needs docs.
	     * @private
	     */
	    _touchDown: false
	};
	
	module.exports = interactiveTarget;


/***/ },
/* 116 */
/*!***************************************************!*\
  !*** ./~/pixi.js/src/loaders/bitmapFontParser.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Resource = __webpack_require__(/*! resource-loader */ 53).Resource,
	    core = __webpack_require__(/*! ../core */ 1),
	    extras = __webpack_require__(/*! ../extras */ 62),
	    path = __webpack_require__(/*! path */ 92);
	
	
	function parse(resource, texture) {
	    var data = {};
	    var info = resource.data.getElementsByTagName('info')[0];
	    var common = resource.data.getElementsByTagName('common')[0];
	
	    data.font = info.getAttribute('face');
	    data.size = parseInt(info.getAttribute('size'), 10);
	    data.lineHeight = parseInt(common.getAttribute('lineHeight'), 10);
	    data.chars = {};
	
	    //parse letters
	    var letters = resource.data.getElementsByTagName('char');
	
	    for (var i = 0; i < letters.length; i++)
	    {
	        var charCode = parseInt(letters[i].getAttribute('id'), 10);
	
	        var textureRect = new core.Rectangle(
	            parseInt(letters[i].getAttribute('x'), 10) + texture.frame.x,
	            parseInt(letters[i].getAttribute('y'), 10) + texture.frame.y,
	            parseInt(letters[i].getAttribute('width'), 10),
	            parseInt(letters[i].getAttribute('height'), 10)
	        );
	
	        data.chars[charCode] = {
	            xOffset: parseInt(letters[i].getAttribute('xoffset'), 10),
	            yOffset: parseInt(letters[i].getAttribute('yoffset'), 10),
	            xAdvance: parseInt(letters[i].getAttribute('xadvance'), 10),
	            kerning: {},
	            texture: new core.Texture(texture.baseTexture, textureRect)
	
	        };
	    }
	
	    //parse kernings
	    var kernings = resource.data.getElementsByTagName('kerning');
	    for (i = 0; i < kernings.length; i++)
	    {
	        var first = parseInt(kernings[i].getAttribute('first'), 10);
	        var second = parseInt(kernings[i].getAttribute('second'), 10);
	        var amount = parseInt(kernings[i].getAttribute('amount'), 10);
	
	        if(data.chars[second])
	        {
	            data.chars[second].kerning[first] = amount;
	        }
	    }
	
	    resource.bitmapFont = data;
	
	    // I'm leaving this as a temporary fix so we can test the bitmap fonts in v3
	    // but it's very likely to change
	    extras.BitmapText.fonts[data.font] = data;
	}
	
	
	module.exports = function ()
	{
	    return function (resource, next)
	    {
	        // skip if no data or not xml data
	        if (!resource.data || !resource.isXml)
	        {
	            return next();
	        }
	
	        // skip if not bitmap font data, using some silly duck-typing
	        if (
	            resource.data.getElementsByTagName('page').length === 0 ||
	            resource.data.getElementsByTagName('info').length === 0 ||
	            resource.data.getElementsByTagName('info')[0].getAttribute('face') === null
	            )
	        {
	            return next();
	        }
	
	        var xmlUrl = path.dirname(resource.url);
	
	        if (xmlUrl === '.') {
	            xmlUrl = '';
	        }
	
	        if (this.baseUrl && xmlUrl) {
	            // if baseurl has a trailing slash then add one to xmlUrl so the replace works below
	            if (this.baseUrl.charAt(this.baseUrl.length - 1) === '/') {
	                xmlUrl += '/';
	            }
	
	            // remove baseUrl from xmlUrl
	            xmlUrl = xmlUrl.replace(this.baseUrl, '');
	        }
	
	        // if there is an xmlUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
	        if (xmlUrl && xmlUrl.charAt(xmlUrl.length - 1) !== '/') {
	            xmlUrl += '/';
	        }
	        var textureUrl = xmlUrl + resource.data.getElementsByTagName('page')[0].getAttribute('file');
	        if (core.utils.TextureCache[textureUrl]) {
	            //reuse existing texture
	            parse(resource, core.utils.TextureCache[textureUrl]);
	            next();
	        }
	        else {
	            var loadOptions = {
	                crossOrigin: resource.crossOrigin,
	                loadType: Resource.LOAD_TYPE.IMAGE,
	                metadata: resource.metadata.imageMetadata
	            };
	            // load the texture for the font
	            this.add(resource.name + '_image', textureUrl, loadOptions, function (res) {
	                parse(resource, res.texture);
	                next();
	            });
	        }
	    };
	};


/***/ },
/* 117 */
/*!****************************************************!*\
  !*** ./~/pixi.js/src/loaders/spritesheetParser.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Resource = __webpack_require__(/*! resource-loader */ 53).Resource,
	    path = __webpack_require__(/*! path */ 92),
	    core = __webpack_require__(/*! ../core */ 1),
	    async = __webpack_require__(/*! async */ 85);
	
	var BATCH_SIZE = 1000;
	
	module.exports = function ()
	{
	    return function (resource, next)
	    {
	        var imageResourceName = resource.name + '_image';
	
	        // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
	        if (!resource.data || !resource.isJson || !resource.data.frames || this.resources[imageResourceName])
	        {
	            return next();
	        }
	
	        var loadOptions = {
	            crossOrigin: resource.crossOrigin,
	            loadType: Resource.LOAD_TYPE.IMAGE,
	            metadata: resource.metadata.imageMetadata
	        };
	
	        var route = path.dirname(resource.url.replace(this.baseUrl, ''));
	
	        // load the image for this sheet
	        this.add(imageResourceName, route + '/' + resource.data.meta.image, loadOptions, function (res)
	        {
	            resource.textures = {};
	
	            var frames = resource.data.frames;
	            var frameKeys = Object.keys(frames);
	            var resolution = core.utils.getResolutionOfUrl(resource.url);
	            var batchIndex = 0;
	
	            function processFrames(initialFrameIndex, maxFrames)
	            {
	                var frameIndex = initialFrameIndex;
	
	                while (frameIndex - initialFrameIndex < maxFrames && frameIndex < frameKeys.length)
	                {
	                    var frame = frames[frameKeys[frameIndex]];
	                    var rect = frame.frame;
	
	                    if (rect)
	                    {
	                        var size = null;
	                        var trim = null;
	
	                        if (frame.rotated)
	                        {
	                            size = new core.Rectangle(rect.x, rect.y, rect.h, rect.w);
	                        }
	                        else
	                        {
	                            size = new core.Rectangle(rect.x, rect.y, rect.w, rect.h);
	                        }
	
	                        //  Check to see if the sprite is trimmed
	                        if (frame.trimmed)
	                        {
	                            trim = new core.Rectangle(
	                                frame.spriteSourceSize.x / resolution,
	                                frame.spriteSourceSize.y / resolution,
	                                frame.sourceSize.w / resolution,
	                                frame.sourceSize.h / resolution
	                            );
	                        }
	
	                        // flip the width and height!
	                        if (frame.rotated)
	                        {
	                            var temp = size.width;
	                            size.width = size.height;
	                            size.height = temp;
	                        }
	
	                        size.x /= resolution;
	                        size.y /= resolution;
	                        size.width /= resolution;
	                        size.height /= resolution;
	
	                        resource.textures[frameKeys[frameIndex]] = new core.Texture(res.texture.baseTexture, size, size.clone(), trim, frame.rotated);
	
	                        // lets also add the frame to pixi's global cache for fromFrame and fromImage functions
	                        core.utils.TextureCache[frameKeys[frameIndex]] = resource.textures[frameKeys[frameIndex]];
	                    }
	                    frameIndex++;
	                }
	            }
	
	            function shouldProcessNextBatch()
	            {
	                return batchIndex * BATCH_SIZE < frameKeys.length;
	            }
	
	            function processNextBatch(done)
	            {
	                processFrames(batchIndex * BATCH_SIZE, BATCH_SIZE);
	                batchIndex++;
	                setTimeout(done, 0);
	            }
	
	            if (frameKeys.length <= BATCH_SIZE)
	            {
	                processFrames(0, BATCH_SIZE);
	                next();
	            }
	            else
	            {
	                async.whilst(shouldProcessNextBatch, processNextBatch, next);
	            }
	        });
	    };
	};


/***/ },
/* 118 */
/*!************************************************!*\
  !*** ./~/pixi.js/src/loaders/textureParser.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1);
	
	module.exports = function ()
	{
	    return function (resource, next)
	    {
	        // create a new texture if the data is an Image object
	        if (resource.data && resource.isImage)
	        {
	            var baseTexture = new core.BaseTexture(resource.data, null, core.utils.getResolutionOfUrl(resource.url));
	            baseTexture.imageUrl = resource.url;
	            resource.texture = new core.Texture(baseTexture);
	            // lets also add the frame to pixi's global cache for fromFrame and fromImage fucntions
	            core.utils.BaseTextureCache[resource.url] = baseTexture;
	            core.utils.TextureCache[resource.url] = resource.texture;
	        }
	
	        next();
	    };
	};


/***/ },
/* 119 */
/*!*************************************!*\
  !*** ./~/pixi.js/src/mesh/index.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @file        Main export of the PIXI extras library
	 * @author      Mat Groves <mat@goodboydigital.com>
	 * @copyright   2013-2015 GoodBoyDigital
	 * @license     {@link https://github.com/pixijs/pixi.js/blob/master/LICENSE|MIT License}
	 */
	
	/**
	 * @namespace PIXI.mesh
	 */
	module.exports = {
	    Mesh:           __webpack_require__(/*! ./Mesh */ 43),
	    Plane:           __webpack_require__(/*! ./Plane */ 232),
	    Rope:           __webpack_require__(/*! ./Rope */ 233),
	    MeshRenderer:   __webpack_require__(/*! ./webgl/MeshRenderer */ 234),
	    MeshShader:     __webpack_require__(/*! ./webgl/MeshShader */ 235)
	};


/***/ },
/* 120 */
/*!******************************!*\
  !*** ./~/react-dom/index.js ***!
  \******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(/*! react/lib/ReactDOM */ 133);


/***/ },
/* 121 */
/*!***************************************************!*\
  !*** ./assets/js/src/components/LandingSlide.jsx ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppDispatcher = __webpack_require__(/*! ./../dispatcher/AppDispatcher */ 21);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _AppConstants = __webpack_require__(/*! ./../constants/AppConstants */ 20);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _EmojiRotator = __webpack_require__(/*! ./EmojiRotator.jsx */ 247);
	
	var _EmojiRotator2 = _interopRequireDefault(_EmojiRotator);
	
	var _system = __webpack_require__(/*! ./../helpers/system */ 125);
	
	var _system2 = _interopRequireDefault(_system);
	
	__webpack_require__(/*! ./../../vendor/greensock-js/src/uncompressed/TweenLite.js */ 126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LandingSlide = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'LandingSlide',
	
	  /**
	   * Timeout to show emojis
	   */
	  showTimeout: 0,
	
	  /**
	   * Ball position object
	   */
	  ballPosition: { y: 0 },
	
	  /**
	   * Expected propTypes
	   * @prop {Boolean} active - If this is the current active slide
	   * @prop {Function} clickHandler - A click handler
	   * @prop {Object} cssTransforms3d - Whether the browser
	   * supports css 3d transforms
	   * @prop {Object} descriptionData - The site description data
	   * @prop {Number} height - The height for the slide's style
	   * @prop {Boolean} large - If the user is viewing the large experience
	   * @prop {Boolean} next - If this is the next from the active slide
	   * @prop {Boolean} prev - If this is the previous from the active slide
	   * @prop {Boolean} touch - If browser supports touch events
	   * @prop {Number} yPosition - The top position for the slide's style
	   */
	  propTypes: {
	    active: _react2.default.PropTypes.bool,
	    clickHandler: _react2.default.PropTypes.func,
	    cssTransforms3d: _react2.default.PropTypes.bool,
	    descriptionData: _react2.default.PropTypes.object,
	    height: _react2.default.PropTypes.number,
	    large: _react2.default.PropTypes.bool.isRequired,
	    next: _react2.default.PropTypes.bool,
	    prev: _react2.default.PropTypes.bool,
	    touch: _react2.default.PropTypes.bool,
	    yPosition: _react2.default.PropTypes.number
	  },
	
	  /**
	   * Get initial state object
	   * @returns {Object} initial state
	   */
	  getInitialState: function getInitialState() {
	    return {
	      refreshWindowSize: false
	    };
	  },
	
	
	  /**
	   * Called after component mounts to DOM
	   * @returns {undefined} undefined
	   */
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.setState({ refreshWindowSize: true });
	    }, 20);
	  },
	
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    var description = this._renderDescription();
	    var approximateEmojiWidth = !this.props.large ? 30 : 50;
	    var approximateEmojiHeight = !this.props.large ? 30 : 50;
	    var totalCols = Math.floor(window.innerWidth / approximateEmojiWidth);
	    var totalRows = Math.floor(window.innerHeight / approximateEmojiHeight);
	    var emojiWidth = window.innerWidth / totalCols;
	    var emojiHeight = window.innerHeight / totalRows;
	    var prevClass = this.props.prev ? ' prev' : '';
	    var activeClass = this.props.active ? ' active' : '';
	    var nextClass = this.props.next ? ' next' : '';
	    var className = 'component-landing-slide slide' + prevClass + activeClass + nextClass;
	
	    var titleColAmount = Math.round(totalCols / 3);
	    if ((totalCols - titleColAmount) / 2 % 1 !== 0) {
	      titleColAmount += 1;
	    }
	
	    var titleRowAmount = this.props.large ? Math.round(totalRows / 3) : Math.round(totalRows / 4);
	    if ((totalRows - titleRowAmount) / 2 % 1 !== 0) {
	      titleRowAmount += 1;
	    }
	
	    var titleWidth = emojiWidth * titleColAmount;
	    var titleHeight = emojiHeight * titleRowAmount;
	    var titleLeft = (totalCols - titleColAmount) / 2 * emojiWidth;
	    var titleTop = (totalRows - titleRowAmount) / 2 * emojiHeight;
	    var titleTextHeight = this.props.large ? 70 : 60;
	    var descriptionTextHeight = this.refs.description ? this.refs.description.offsetHeight : 0;
	    var titlePaddingTop = titleHeight / 2 - (titleTextHeight + descriptionTextHeight) / 2 + 5;
	    if (this.props.large) {
	      titlePaddingTop = titleHeight / 2 - (titleTextHeight + descriptionTextHeight - 60) / 2 + 5;
	    }
	
	    var clickHandler = this.props.large && !this.props.touch ? this._onClick : this.props.clickHandler;
	    var touchEndHandler = this.props.touch ? this.props.clickHandler : null;
	    if (this.props.large && this.props.touch) {
	      touchEndHandler = this._onClick;
	    }
	
	    var emojiRotator = this._renderEmojiRotator();
	
	    var style = {
	      height: this.props.height,
	      top: this.props.yPosition
	    };
	
	    var titleStyle = {
	      top: titleTop,
	      left: titleLeft,
	      height: titleHeight,
	      width: titleWidth,
	      paddingTop: titlePaddingTop
	    };
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: style,
	        className: className,
	        onClick: clickHandler,
	        onTouchEnd: touchEndHandler
	      },
	      emojiRotator,
	      _react2.default.createElement(
	        'div',
	        { style: titleStyle, className: 'title-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { ref: 'title', className: 'title' },
	          _react2.default.createElement(
	            'div',
	            { className: 't1' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'EM'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'ball' },
	              '🏀'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'JI'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 't2' },
	            'IS LIFE'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { ref: 'description', className: 'description-wrapper' },
	          description
	        )
	      )
	    );
	  },
	  _renderEmojiRotator: function _renderEmojiRotator() {
	    var emojiRotator = void 0;
	
	    if (!_system2.default.isFirefox()) {
	      emojiRotator = _react2.default.createElement(_EmojiRotator2.default, {
	        large: this.props.large,
	        active: this.props.active,
	        paused: !this.props.active
	      });
	    }
	
	    return emojiRotator;
	  },
	
	
	  /**
	   * Renders the large description
	   * @returns {ReactElement} A ReactElement
	   */
	  _renderDescription: function _renderDescription() {
	    var description = void 0;
	
	    if (this.props.large) {
	      description = _react2.default.createElement(
	        'div',
	        { className: 'description' },
	        _react2.default.createElement(
	          'div',
	          { className: 'text l1' },
	          this.props.descriptionData.text
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text l2' },
	          'ENTER'
	        )
	      );
	    } else {
	      description = _react2.default.createElement(
	        'div',
	        { className: 'description' },
	        _react2.default.createElement(
	          'div',
	          { className: 'text l2' },
	          'ENTER'
	        )
	      );
	    }
	
	    return description;
	  },
	
	
	  /**
	   * Click handler
	   * @returns {undefined} undefined
	   */
	  _onClick: function _onClick() {
	    _AppDispatcher2.default.handleViewAction({
	      actionType: _AppConstants2.default.GO_TO_MAIN_CONTENT
	    });
	
	    _AppDispatcher2.default.handleViewAction({
	      actionType: _AppConstants2.default.SLIDE_CHANGED,
	      slide: 2
	    });
	
	    setTimeout(function () {
	      _AppDispatcher2.default.handleViewAction({
	        actionType: _AppConstants2.default.REMOVE_LARGE_LANDING
	      });
	
	      _AppDispatcher2.default.handleViewAction({
	        actionType: _AppConstants2.default.SECTION_TRANSITION_COMPLETE
	      });
	    }, 600);
	  }
	});
	
	exports.default = LandingSlide;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "LandingSlide.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 122 */
/*!*************************************************!*\
  !*** ./assets/js/src/components/MenuButton.jsx ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppDispatcher = __webpack_require__(/*! ./../dispatcher/AppDispatcher */ 21);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _AppConstants = __webpack_require__(/*! ./../constants/AppConstants */ 20);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuButton = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'MenuButton',
	
	  /**
	   * Start scroll position of the buttonWrapperEl prop
	   */
	  touchStartPos: 0,
	
	  /**
	   * End scroll position of the buttonWrapperEl prop
	   */
	  touchEndPos: 0,
	
	  /**
	   * Expected propTypes
	   * @prop {ReactElement} buttonWrapperEl - The button wrapper element
	   * @prop {Function} clickHandler - The click handler for the button
	   * @prop {Number} currentSlide - The iteration of the current section
	   * @prop {Object} data - A data object
	   * @prop {Number} iteration - The iteration of the button
	   * @prop {Boolean} large - If the user is viewing the large experience
	   * @prop {Boolean} touch - If browser supports touch events
	   */
	  propTypes: {
	    buttonWrapperEl: _react2.default.PropTypes.object,
	    clickHandler: _react2.default.PropTypes.func,
	    currentSlide: _react2.default.PropTypes.number,
	    data: _react2.default.PropTypes.object.isRequired,
	    iteration: _react2.default.PropTypes.number.isRequired,
	    large: _react2.default.PropTypes.bool.isRequired,
	    touch: _react2.default.PropTypes.bool
	  },
	
	  /**
	   * Get initial state object
	   * @returns {Object} initial state
	   */
	  getInitialState: function getInitialState() {
	    return {
	      dragging: false
	    };
	  },
	
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    var data = this.props.data;
	    var touchStartHandler = this.props.touch ? this._onTouchStart : null;
	    var touchEndHandler = this.props.touch ? this._onTouchEnd : null;
	    if (this.props.large && this.props.touch) {
	      touchEndHandler = this._onClick;
	    }
	    var clickHandler = !this.props.touch ? this._onClick : null;
	    var compareNumber = this.props.large ? this.props.currentSlide + 3 : this.props.currentSlide + 1;
	    var title = data.title;
	    var emojis = void 0;
	    var selectedClass = data.sortOrder === compareNumber ? ' active' : '';
	    var className = 'component-menu-button' + selectedClass;
	
	    if (data.type === 'landing') {
	      title = 'Home';
	    }
	
	    if (data.type === 'gif') {
	      emojis = this._renderEmojis();
	    }
	
	    return _react2.default.createElement(
	      'li',
	      {
	        onTouchStart: touchStartHandler,
	        onTouchEnd: touchEndHandler,
	        onClick: clickHandler,
	        className: className
	      },
	      title,
	      ' ',
	      emojis
	    );
	  },
	
	
	  /**
	   * Renders emojis
	   * @returns {Array<ReactElement>} An array of ReactElements
	   */
	  _renderEmojis: function _renderEmojis() {
	    var data = this.props.data;
	    var emojis = [];
	
	    for (var i = 0; i < data.emojis.length; i++) {
	      var key = 'main-menu-button-' + data.id + '-emoji-' + i;
	
	      emojis.push(_react2.default.createElement(
	        'span',
	        { key: key, className: 'emoji' },
	        data.emojis[i].character
	      ));
	    }
	
	    return emojis;
	  },
	
	
	  /**
	   * TouchStart handler
	   * @returns {Object} React element
	   */
	  _onTouchStart: function _onTouchStart() {
	    this.touchStartPos = this.props.buttonWrapperEl.scrollTop;
	  },
	
	
	  /**
	   * TouchEnd handler
	   * @returns {Object} React element
	   */
	  _onTouchEnd: function _onTouchEnd() {
	    this.touchEndPos = this.props.buttonWrapperEl.scrollTop;
	
	    var dif = this.touchStartPos - this.touchEndPos;
	    if (dif < 0) {
	      dif *= -1;
	    }
	
	    if (dif <= 1) {
	      _AppDispatcher2.default.handleViewAction({
	        actionType: _AppConstants2.default.CLOSE_MAIN_MENU
	      });
	
	      _AppDispatcher2.default.handleViewAction({
	        actionType: _AppConstants2.default.GO_TO_SLIDE,
	        slide: this.props.iteration
	      });
	    }
	  },
	
	
	  /**
	   * Click handler
	   * @returns {Object} React element
	   */
	  _onClick: function _onClick() {
	    _AppDispatcher2.default.handleViewAction({
	      actionType: _AppConstants2.default.CLOSE_MAIN_MENU
	    });
	
	    _AppDispatcher2.default.handleViewAction({
	      actionType: _AppConstants2.default.GO_TO_SLIDE,
	      slide: this.props.iteration
	    });
	  }
	});
	
	exports.default = MenuButton;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "MenuButton.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 123 */
/*!********************************************!*\
  !*** ./assets/js/src/components/Share.jsx ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shareButtons = __webpack_require__(/*! ./../ui/share-buttons */ 256);
	
	var _shareButtons2 = _interopRequireDefault(_shareButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Share = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'Share',
	
	  /**
	   * Timeout to show emojis
	   */
	  showTimeout: 0,
	
	  /**
	   * Pre-fill copy for sharing
	   */
	  shareCopy: 'They played. You tweeted. Re-live the %23NBAPlayoffs with B/R\'s "EMOJI IS LIFE"',
	
	  /**
	   * Expected propTypes
	   * @prop {Boolean} touch - If browser supports touch events
	   */
	  propTypes: {
	    touch: _react2.default.PropTypes.bool
	  },
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    var clickHandler = !this.props.touch ? this._openPopup : null;
	    var touchEndHandler = this.props.touch ? this._openPopup : null;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'component-share' },
	      _react2.default.createElement(
	        'div',
	        { className: 'text' },
	        'Share Emoji Is Life with your NBA friends'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'buttons' },
	        _react2.default.createElement(
	          'a',
	          {
	            onClick: this._openPopup,
	            href: 'https://twitter.com/share?text=' + this.shareCopy + '&url=' + encodeURIComponent(window.location.href),
	            title: 'share on twitter',
	            target: '_blank',
	            className: 'button social twitter'
	          },
	          _react2.default.createElement('img', { src: _shareButtons2.default.twitter })
	        ),
	        _react2.default.createElement(
	          'a',
	          _defineProperty({
	            className: 'button',
	            onClick: clickHandler,
	            onTouchEnd: touchEndHandler,
	            href: 'http://www.facebook.com/sharer/sharer.php?s=100&p[url]=' + encodeURI(window.location.href) + '&p[title]=' + encodeURI(this.shareCopy),
	            title: 'share on facebook',
	            target: '_blank'
	          }, 'className', 'button social facebook'),
	          _react2.default.createElement('img', { src: _shareButtons2.default.facebook })
	        )
	      )
	    );
	  },
	
	
	  /**
	   * Opens a popup window
	   * @returns {undefined} undefined
	   */
	  _openPopup: function _openPopup(e) {
	    var target = e.currentTarget;
	    var url = target.getAttribute('href');
	
	    window.open(url, 'Share', 'width=600, height=500');
	
	    e.stopPropagation();
	    e.preventDefault();
	  }
	});
	
	exports.default = Share;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "Share.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 124 */
/*!************************************!*\
  !*** ./assets/js/src/data/data.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var data = [{
	  id: 1,
	  sortOrder: 1,
	  title: 'Landing',
	  type: 'landing'
	}, {
	  id: 2,
	  sortOrder: 2,
	  title: 'What is this?',
	  type: 'description',
	  text: 'We found the most tweeted emojis during the NBA playoffs\' ' + 'biggest moments. Here are our favorites.'
	}, {
	  id: 3,
	  sortOrder: 3,
	  title: 'Don\'t Step to the MVP',
	  type: 'gif',
	  gameTitle: 'HOU V GSW: RD 1',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/rockets_warriors-loveeyes.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/rockets_warriors-loveeyes.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '😍',
	    count: 200
	  }]
	}, {
	  id: 4,
	  sortOrder: 4,
	  title: 'CP3\'s Bad News',
	  type: 'gif',
	  gameTitle: 'POR V LAC: RD 1',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/blazers-clippers-crab-hand.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/blazers-clippers-crab-hand.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '🦀',
	    count: 102
	  }]
	}, {
	  id: 5,
	  sortOrder: 5,
	  title: 'Never Stop Dancing',
	  type: 'gif',
	  gameTitle: 'DAL V OKC: RD 1',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/NeverStopDancing.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/NeverStopDancing.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '😤',
	    count: 383
	  }]
	}, {
	  id: 6,
	  sortOrder: 6,
	  title: 'Locked Down',
	  type: 'gif',
	  gameTitle: 'MEM V SAS: RD 1',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/kawhi-locked.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/kawhi-locked.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '🔒',
	    count: 62
	  }]
	}, {
	  id: 7,
	  sortOrder: 7,
	  title: 'LeBron Quake/Hammer',
	  type: 'gif',
	  gameTitle: 'DET V CLE: RD 1',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/LeBronQuakeHammer.jpg',
	    width: 480
	  },
	  image: {
	    height: 576,
	    url: 'assets/images/LeBronQuakeHammer.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '🔥',
	    count: 212
	  }]
	}, {
	  id: 8,
	  sortOrder: 8,
	  title: 'The Flop',
	  type: 'gif',
	  gameTitle: 'BOS V ATL: RD 1',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/Marcus-Smart-wild-flop.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/Marcus-Smart-wild-flop.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '🍀',
	    count: 293
	  }]
	}, {
	  id: 9,
	  sortOrder: 9,
	  title: 'D-Wade Hushes Hater',
	  type: 'gif',
	  gameTitle: 'CHA V MIA: RD 1',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/purpleface.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/purpleface.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '😈',
	    count: 146
	  }]
	}, {
	  id: 10,
	  sortOrder: 10,
	  title: 'Cheers from the 6ix',
	  type: 'gif',
	  gameTitle: 'IND V TOR: RD 1',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/drake-clap.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/drake-clap.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '👏',
	    count: 120
	  }]
	}, {
	  id: 11,
	  sortOrder: 11,
	  title: 'I\'m Back!',
	  type: 'gif',
	  gameTitle: 'POR V GSW: RD 2',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/imback.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/imback.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '👀',
	    count: 847
	  }]
	}, {
	  id: 12,
	  sortOrder: 12,
	  title: 'The Controversy',
	  type: 'gif',
	  gameTitle: 'OKC V SAS: RD 2',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/controversey.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/controversey.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '😳',
	    count: 3702
	  }]
	}, {
	  id: 13,
	  sortOrder: 13,
	  title: 'Snoozin\'',
	  type: 'gif',
	  gameTitle: 'ATL V CLE: RD 2',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/Snoozin.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/Snoozin.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '👌',
	    count: 1378
	  }]
	}, {
	  id: 14,
	  sortOrder: 14,
	  title: 'The Dragon\'s Tooth',
	  type: 'gif',
	  gameTitle: 'MIA V TOR: RD 2',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/dragictooth.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/dragictooth.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '👊',
	    count: 264
	  }]
	}, {
	  id: 15,
	  sortOrder: 15,
	  title: 'Westbrook\'s Shuffle',
	  type: 'gif',
	  gameTitle: 'OKC V GSW: WCF',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/WestbrookShuffle.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/WestbrookShuffle.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '🐸',
	    count: 524
	  }, {
	    character: '☕',
	    count: 521
	  }]
	}, {
	  id: 16,
	  sortOrder: 16,
	  title: 'Bruised Jewels',
	  type: 'gif',
	  gameTitle: 'OKC V GSW: WCF',
	  date: 'May 7, 2016 8:45PM EST',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/draymondkicksadams.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/draymondkicksadams.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '✨',
	    count: 1409
	  }]
	}, {
	  id: 17,
	  sortOrder: 17,
	  title: 'Cavs\' Friendly Fire',
	  type: 'gif',
	  gameTitle: 'TOR V CLE: ECF ',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/CavsFriendlyFire.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/CavsFriendlyFire.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '💀',
	    count: 449
	  }]
	}, {
	  id: 18,
	  sortOrder: 18,
	  title: 'Curry\'s Dagger',
	  type: 'gif',
	  gameTitle: 'OKC V GSW: WCF',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/currydagger.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/currydagger.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '💯',
	    count: 408
	  }]
	}, {
	  id: 19,
	  sortOrder: 19,
	  title: 'Clipboard Smash',
	  type: 'gif',
	  gameTitle: 'CLE V GSW: FINALS',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/broken-clipboard.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/broken-clipboard.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '😭',
	    count: 3380
	  }, {
	    character: '💪',
	    count: 997
	  }]
	}, {
	  id: 20,
	  sortOrder: 20,
	  title: 'The Block',
	  type: 'gif',
	  gameTitle: 'CLE V GSW: FINALS',
	  date: 'May 7, 2016 8:45PM EST',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/lebronblockiggy.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/lebronblockiggy.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '🙌',
	    count: 368
	  }]
	}, {
	  id: 21,
	  sortOrder: 21,
	  title: 'Champions',
	  type: 'gif',
	  gameTitle: 'CLE V GSW: FINALS',
	  date: 'May 7, 2016 8:45PM EST',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/champion.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/champion.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '🏆',
	    count: 612
	  }]
	}, {
	  id: 22,
	  sortOrder: 22,
	  title: 'Mouthguard',
	  type: 'gif',
	  gameTitle: 'CLE V GSW: FINALS',
	  coverImage: {
	    height: 480,
	    url: 'assets/images/mouthguard.jpg',
	    width: 480
	  },
	  image: {
	    height: 480,
	    url: 'assets/images/mouthguard.gif',
	    width: 480
	  },
	  emojis: [{
	    character: '🐝',
	    count: 422
	  }]
	}, {
	  id: 23,
	  sortOrder: 23,
	  title: 'Credits',
	  type: 'credits',
	  text: 'Produced by<br/>Kate Strassman<br/>& Mike Fey'
	}];
	
	exports.default = data;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "data.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 125 */
/*!*****************************************!*\
  !*** ./assets/js/src/helpers/system.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var systemHelper = {
	  setUserAgent: function setUserAgent(window, userAgent) {
	    if (window.navigator.userAgent !== userAgent) {
	      var userAgentProp = {
	        get: function get() {
	          return userAgent;
	        }
	      };
	
	      try {
	        Object.defineProperty(window.navigator, 'userAgent', userAgentProp);
	      } catch (e) {
	        window.navigator = Object.create(navigator, {
	          userAgent: userAgentProp
	        });
	      }
	    }
	  },
	
	
	  /**
	   * Returns a the current iOS version
	   * @param {Boolean} includeMinor - Whether to include the minor version
	   * @returns {Number} The current iOS version (-1 means no version was found)
	   */
	  iOSVersion: function iOSVersion(includeMinor) {
	    var match = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
	
	    if (!match) {
	      return -1;
	    }
	
	    var version = [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3] || 0, 10)];
	
	    if (!includeMinor) {
	      return version[0];
	    }
	
	    return parseFloat(version.join('.'));
	  },
	
	
	  /**
	   * Returns a the current Android version
	   * @returns {Number} The current Android version (-1 means no version was found)
	   */
	  androidVersion: function androidVersion() {
	    var ua = navigator.userAgent.toLowerCase();
	    var match = ua.match(/android\s([0-9\.]*)/);
	
	    return match ? match[1] : -1;
	  },
	
	
	  /**
	   * Returns true if the browser is Firefox
	   * @returns {Boolean} if the browser is Firefox
	   */
	  isFirefox: function isFirefox() {
	    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	  },
	
	
	  /**
	   * Returns true if the browser is IE or Edge
	   * @returns {Boolean} if the browser is IE or Edge
	   */
	  isIEOrEdge: function isIEOrEdge() {
	    return document.documentMode || /Edge/.test(navigator.userAgent);
	  }
	};
	
	exports.default = systemHelper;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "system.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 126 */
/*!*********************************************************************!*\
  !*** ./assets/js/vendor/greensock-js/src/uncompressed/TweenLite.js ***!
  \*********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	/*!
	 * VERSION: 1.18.2
	 * DATE: 2015-12-22
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * @license Copyright (c) 2008-2016, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 */
	(function (window, moduleName) {
	
		"use strict";
	
		var _globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
		if (_globals.TweenLite) {
			return; //in case the core set of classes is already loaded, don't instantiate twice.
		}
		var _namespace = function _namespace(ns) {
			var a = ns.split("."),
			    p = _globals,
			    i;
			for (i = 0; i < a.length; i++) {
				p[a[i]] = p = p[a[i]] || {};
			}
			return p;
		},
		    gs = _namespace("com.greensock"),
		    _tinyNum = 0.0000000001,
		    _slice = function _slice(a) {
			//don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
			var b = [],
			    l = a.length,
			    i;
			for (i = 0; i !== l; b.push(a[i++])) {}
			return b;
		},
		    _emptyFunc = function _emptyFunc() {},
		    _isArray = function () {
			//works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
			var toString = Object.prototype.toString,
			    array = toString.call([]);
			return function (obj) {
				return obj != null && (obj instanceof Array || (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" && !!obj.push && toString.call(obj) === array);
			};
		}(),
		    a,
		    i,
		    p,
		    _ticker,
		    _tickerActive,
		    _defLookup = {},
	
	
		/**
	  * @constructor
	  * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
	  * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
	  * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
	  * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
	  *
	  * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
	  * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
	  * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
	  * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
	  * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
	  * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
	  * sandbox the banner one like:
	  *
	  * <script>
	  *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
	  * </script>
	  * <script src="js/greensock/v1.7/TweenMax.js"></script>
	  * <script>
	  *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
	  * </script>
	  * <script src="js/greensock/v1.6/TweenMax.js"></script>
	  * <script>
	  *     gs.TweenLite.to(...); //would use v1.7
	  *     TweenLite.to(...); //would use v1.6
	  * </script>
	  *
	  * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
	  * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
	  * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
	  * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
	  */
		Definition = function Definition(ns, dependencies, func, global) {
			this.sc = _defLookup[ns] ? _defLookup[ns].sc : []; //subclasses
			_defLookup[ns] = this;
			this.gsClass = null;
			this.func = func;
			var _classes = [];
			this.check = function (init) {
				var i = dependencies.length,
				    missing = i,
				    cur,
				    a,
				    n,
				    cl,
				    hasModule;
				while (--i > -1) {
					if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
						_classes[i] = cur.gsClass;
						missing--;
					} else if (init) {
						cur.sc.push(this);
					}
				}
				if (missing === 0 && func) {
					a = ("com.greensock." + ns).split(".");
					n = a.pop();
					cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
	
					//exports to multiple environments
					if (global) {
						_globals[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
						hasModule = typeof module !== "undefined" && module.exports;
						if (!hasModule && "function" === "function" && __webpack_require__(/*! !webpack amd options */ 320)) {
							//AMD
							!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
								return cl;
							}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
						} else if (ns === moduleName && hasModule) {
							//node
							module.exports = cl;
						}
					}
					for (i = 0; i < this.sc.length; i++) {
						this.sc[i].check();
					}
				}
			};
			this.check(true);
		},
	
	
		//used to create Definition instances (which basically registers a class that has dependencies).
		_gsDefine = window._gsDefine = function (ns, dependencies, func, global) {
			return new Definition(ns, dependencies, func, global);
		},
	
	
		//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
		_class = gs._class = function (ns, func, global) {
			func = func || function () {};
			_gsDefine(ns, [], function () {
				return func;
			}, global);
			return func;
		};
	
		_gsDefine.globals = _globals;
	
		/*
	  * ----------------------------------------------------------------
	  * Ease
	  * ----------------------------------------------------------------
	  */
		var _baseParams = [0, 0, 1, 1],
		    _blankArray = [],
		    Ease = _class("easing.Ease", function (func, extraParams, type, power) {
			this._func = func;
			this._type = type || 0;
			this._power = power || 0;
			this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
		}, true),
		    _easeMap = Ease.map = {},
		    _easeReg = Ease.register = function (ease, names, types, create) {
			var na = names.split(","),
			    i = na.length,
			    ta = (types || "easeIn,easeOut,easeInOut").split(","),
			    e,
			    name,
			    j,
			    type;
			while (--i > -1) {
				name = na[i];
				e = create ? _class("easing." + name, null, true) : gs.easing[name] || {};
				j = ta.length;
				while (--j > -1) {
					type = ta[j];
					_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
				}
			}
		};
	
		p = Ease.prototype;
		p._calcEnd = false;
		p.getRatio = function (p) {
			if (this._func) {
				this._params[0] = p;
				return this._func.apply(null, this._params);
			}
			var t = this._type,
			    pw = this._power,
			    r = t === 1 ? 1 - p : t === 2 ? p : p < 0.5 ? p * 2 : (1 - p) * 2;
			if (pw === 1) {
				r *= r;
			} else if (pw === 2) {
				r *= r * r;
			} else if (pw === 3) {
				r *= r * r * r;
			} else if (pw === 4) {
				r *= r * r * r * r;
			}
			return t === 1 ? 1 - r : t === 2 ? r : p < 0.5 ? r / 2 : 1 - r / 2;
		};
	
		//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
		a = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"];
		i = a.length;
		while (--i > -1) {
			p = a[i] + ",Power" + i;
			_easeReg(new Ease(null, null, 1, i), p, "easeOut", true);
			_easeReg(new Ease(null, null, 2, i), p, "easeIn" + (i === 0 ? ",easeNone" : ""));
			_easeReg(new Ease(null, null, 3, i), p, "easeInOut");
		}
		_easeMap.linear = gs.easing.Linear.easeIn;
		_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
	
		/*
	  * ----------------------------------------------------------------
	  * EventDispatcher
	  * ----------------------------------------------------------------
	  */
		var EventDispatcher = _class("events.EventDispatcher", function (target) {
			this._listeners = {};
			this._eventTarget = target || this;
		});
		p = EventDispatcher.prototype;
	
		p.addEventListener = function (type, callback, scope, useParam, priority) {
			priority = priority || 0;
			var list = this._listeners[type],
			    index = 0,
			    listener,
			    i;
			if (list == null) {
				this._listeners[type] = list = [];
			}
			i = list.length;
			while (--i > -1) {
				listener = list[i];
				if (listener.c === callback && listener.s === scope) {
					list.splice(i, 1);
				} else if (index === 0 && listener.pr < priority) {
					index = i + 1;
				}
			}
			list.splice(index, 0, { c: callback, s: scope, up: useParam, pr: priority });
			if (this === _ticker && !_tickerActive) {
				_ticker.wake();
			}
		};
	
		p.removeEventListener = function (type, callback) {
			var list = this._listeners[type],
			    i;
			if (list) {
				i = list.length;
				while (--i > -1) {
					if (list[i].c === callback) {
						list.splice(i, 1);
						return;
					}
				}
			}
		};
	
		p.dispatchEvent = function (type) {
			var list = this._listeners[type],
			    i,
			    t,
			    listener;
			if (list) {
				i = list.length;
				t = this._eventTarget;
				while (--i > -1) {
					listener = list[i];
					if (listener) {
						if (listener.up) {
							listener.c.call(listener.s || t, { type: type, target: t });
						} else {
							listener.c.call(listener.s || t);
						}
					}
				}
			}
		};
	
		/*
	  * ----------------------------------------------------------------
	  * Ticker
	  * ----------------------------------------------------------------
	  */
		var _reqAnimFrame = window.requestAnimationFrame,
		    _cancelAnimFrame = window.cancelAnimationFrame,
		    _getTime = Date.now || function () {
			return new Date().getTime();
		},
		    _lastUpdate = _getTime();
	
		//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
		a = ["ms", "moz", "webkit", "o"];
		i = a.length;
		while (--i > -1 && !_reqAnimFrame) {
			_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
			_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
		}
	
		_class("Ticker", function (fps, useRAF) {
			var _self = this,
			    _startTime = _getTime(),
			    _useRAF = useRAF !== false && _reqAnimFrame ? "auto" : false,
			    _lagThreshold = 500,
			    _adjustedLag = 33,
			    _tickWord = "tick",
			    //helps reduce gc burden
			_fps,
			    _req,
			    _id,
			    _gap,
			    _nextTime,
			    _tick = function _tick(manual) {
				var elapsed = _getTime() - _lastUpdate,
				    overlap,
				    dispatch;
				if (elapsed > _lagThreshold) {
					_startTime += elapsed - _adjustedLag;
				}
				_lastUpdate += elapsed;
				_self.time = (_lastUpdate - _startTime) / 1000;
				overlap = _self.time - _nextTime;
				if (!_fps || overlap > 0 || manual === true) {
					_self.frame++;
					_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
					dispatch = true;
				}
				if (manual !== true) {
					//make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
					_id = _req(_tick);
				}
				if (dispatch) {
					_self.dispatchEvent(_tickWord);
				}
			};
	
			EventDispatcher.call(_self);
			_self.time = _self.frame = 0;
			_self.tick = function () {
				_tick(true);
			};
	
			_self.lagSmoothing = function (threshold, adjustedLag) {
				_lagThreshold = threshold || 1 / _tinyNum; //zero should be interpreted as basically unlimited
				_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
			};
	
			_self.sleep = function () {
				if (_id == null) {
					return;
				}
				if (!_useRAF || !_cancelAnimFrame) {
					clearTimeout(_id);
				} else {
					_cancelAnimFrame(_id);
				}
				_req = _emptyFunc;
				_id = null;
				if (_self === _ticker) {
					_tickerActive = false;
				}
			};
	
			_self.wake = function (seamless) {
				if (_id !== null) {
					_self.sleep();
				} else if (seamless) {
					_startTime += -_lastUpdate + (_lastUpdate = _getTime());
				} else if (_self.frame > 10) {
					//don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
					_lastUpdate = _getTime() - _lagThreshold + 5;
				}
				_req = _fps === 0 ? _emptyFunc : !_useRAF || !_reqAnimFrame ? function (f) {
					return setTimeout(f, (_nextTime - _self.time) * 1000 + 1 | 0);
				} : _reqAnimFrame;
				if (_self === _ticker) {
					_tickerActive = true;
				}
				_tick(2);
			};
	
			_self.fps = function (value) {
				if (!arguments.length) {
					return _fps;
				}
				_fps = value;
				_gap = 1 / (_fps || 60);
				_nextTime = this.time + _gap;
				_self.wake();
			};
	
			_self.useRAF = function (value) {
				if (!arguments.length) {
					return _useRAF;
				}
				_self.sleep();
				_useRAF = value;
				_self.fps(_fps);
			};
			_self.fps(fps);
	
			//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
			setTimeout(function () {
				if (_useRAF === "auto" && _self.frame < 5 && document.visibilityState !== "hidden") {
					_self.useRAF(false);
				}
			}, 1500);
		});
	
		p = gs.Ticker.prototype = new gs.events.EventDispatcher();
		p.constructor = gs.Ticker;
	
		/*
	  * ----------------------------------------------------------------
	  * Animation
	  * ----------------------------------------------------------------
	  */
		var Animation = _class("core.Animation", function (duration, vars) {
			this.vars = vars = vars || {};
			this._duration = this._totalDuration = duration || 0;
			this._delay = Number(vars.delay) || 0;
			this._timeScale = 1;
			this._active = vars.immediateRender === true;
			this.data = vars.data;
			this._reversed = vars.reversed === true;
	
			if (!_rootTimeline) {
				return;
			}
			if (!_tickerActive) {
				//some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
				_ticker.wake();
			}
	
			var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
			tl.add(this, tl._time);
	
			if (this.vars.paused) {
				this.paused(true);
			}
		});
	
		_ticker = Animation.ticker = new gs.Ticker();
		p = Animation.prototype;
		p._dirty = p._gc = p._initted = p._paused = false;
		p._totalTime = p._time = 0;
		p._rawPrevTime = -1;
		p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
		p._paused = false;
	
		//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
		var _checkTimeout = function _checkTimeout() {
			if (_tickerActive && _getTime() - _lastUpdate > 2000) {
				_ticker.wake();
			}
			setTimeout(_checkTimeout, 2000);
		};
		_checkTimeout();
	
		p.play = function (from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.reversed(false).paused(false);
		};
	
		p.pause = function (atTime, suppressEvents) {
			if (atTime != null) {
				this.seek(atTime, suppressEvents);
			}
			return this.paused(true);
		};
	
		p.resume = function (from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.paused(false);
		};
	
		p.seek = function (time, suppressEvents) {
			return this.totalTime(Number(time), suppressEvents !== false);
		};
	
		p.restart = function (includeDelay, suppressEvents) {
			return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, suppressEvents !== false, true);
		};
	
		p.reverse = function (from, suppressEvents) {
			if (from != null) {
				this.seek(from || this.totalDuration(), suppressEvents);
			}
			return this.reversed(true).paused(false);
		};
	
		p.render = function (time, suppressEvents, force) {
			//stub - we override this method in subclasses.
		};
	
		p.invalidate = function () {
			this._time = this._totalTime = 0;
			this._initted = this._gc = false;
			this._rawPrevTime = -1;
			if (this._gc || !this.timeline) {
				this._enabled(true);
			}
			return this;
		};
	
		p.isActive = function () {
			var tl = this._timeline,
			    //the 2 root timelines won't have a _timeline; they're always active.
			startTime = this._startTime,
			    rawTime;
			return !tl || !this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime()) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale;
		};
	
		p._enabled = function (enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			this._gc = !enabled;
			this._active = this.isActive();
			if (ignoreTimeline !== true) {
				if (enabled && !this.timeline) {
					this._timeline.add(this, this._startTime - this._delay);
				} else if (!enabled && this.timeline) {
					this._timeline._remove(this, true);
				}
			}
			return false;
		};
	
		p._kill = function (vars, target) {
			return this._enabled(false, false);
		};
	
		p.kill = function (vars, target) {
			this._kill(vars, target);
			return this;
		};
	
		p._uncache = function (includeSelf) {
			var tween = includeSelf ? this : this.timeline;
			while (tween) {
				tween._dirty = true;
				tween = tween.timeline;
			}
			return this;
		};
	
		p._swapSelfInParams = function (params) {
			var i = params.length,
			    copy = params.concat();
			while (--i > -1) {
				if (params[i] === "{self}") {
					copy[i] = this;
				}
			}
			return copy;
		};
	
		p._callback = function (type) {
			var v = this.vars;
			v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
		};
	
		//----Animation getters/setters --------------------------------------------------------
	
		p.eventCallback = function (type, callback, params, scope) {
			if ((type || "").substr(0, 2) === "on") {
				var v = this.vars;
				if (arguments.length === 1) {
					return v[type];
				}
				if (callback == null) {
					delete v[type];
				} else {
					v[type] = callback;
					v[type + "Params"] = _isArray(params) && params.join("").indexOf("{self}") !== -1 ? this._swapSelfInParams(params) : params;
					v[type + "Scope"] = scope;
				}
				if (type === "onUpdate") {
					this._onUpdate = callback;
				}
			}
			return this;
		};
	
		p.delay = function (value) {
			if (!arguments.length) {
				return this._delay;
			}
			if (this._timeline.smoothChildTiming) {
				this.startTime(this._startTime + value - this._delay);
			}
			this._delay = value;
			return this;
		};
	
		p.duration = function (value) {
			if (!arguments.length) {
				this._dirty = false;
				return this._duration;
			}
			this._duration = this._totalDuration = value;
			this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
			if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
				this.totalTime(this._totalTime * (value / this._duration), true);
			}
			return this;
		};
	
		p.totalDuration = function (value) {
			this._dirty = false;
			return !arguments.length ? this._totalDuration : this.duration(value);
		};
	
		p.time = function (value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			return this.totalTime(value > this._duration ? this._duration : value, suppressEvents);
		};
	
		p.totalTime = function (time, suppressEvents, uncapped) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (!arguments.length) {
				return this._totalTime;
			}
			if (this._timeline) {
				if (time < 0 && !uncapped) {
					time += this.totalDuration();
				}
				if (this._timeline.smoothChildTiming) {
					if (this._dirty) {
						this.totalDuration();
					}
					var totalDuration = this._totalDuration,
					    tl = this._timeline;
					if (time > totalDuration && !uncapped) {
						time = totalDuration;
					}
					this._startTime = (this._paused ? this._pauseTime : tl._time) - (!this._reversed ? time : totalDuration - time) / this._timeScale;
					if (!tl._dirty) {
						//for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
						this._uncache(false);
					}
					//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
					if (tl._timeline) {
						while (tl._timeline) {
							if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
								tl.totalTime(tl._totalTime, true);
							}
							tl = tl._timeline;
						}
					}
				}
				if (this._gc) {
					this._enabled(true, false);
				}
				if (this._totalTime !== time || this._duration === 0) {
					if (_lazyTweens.length) {
						_lazyRender();
					}
					this.render(time, suppressEvents, false);
					if (_lazyTweens.length) {
						//in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
						_lazyRender();
					}
				}
			}
			return this;
		};
	
		p.progress = p.totalProgress = function (value, suppressEvents) {
			var duration = this.duration();
			return !arguments.length ? duration ? this._time / duration : this.ratio : this.totalTime(duration * value, suppressEvents);
		};
	
		p.startTime = function (value) {
			if (!arguments.length) {
				return this._startTime;
			}
			if (value !== this._startTime) {
				this._startTime = value;
				if (this.timeline) if (this.timeline._sortChildren) {
					this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			return this;
		};
	
		p.endTime = function (includeRepeats) {
			return this._startTime + (includeRepeats != false ? this.totalDuration() : this.duration()) / this._timeScale;
		};
	
		p.timeScale = function (value) {
			if (!arguments.length) {
				return this._timeScale;
			}
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			if (this._timeline && this._timeline.smoothChildTiming) {
				var pauseTime = this._pauseTime,
				    t = pauseTime || pauseTime === 0 ? pauseTime : this._timeline.totalTime();
				this._startTime = t - (t - this._startTime) * this._timeScale / value;
			}
			this._timeScale = value;
			return this._uncache(false);
		};
	
		p.reversed = function (value) {
			if (!arguments.length) {
				return this._reversed;
			}
			if (value != this._reversed) {
				this._reversed = value;
				this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, true);
			}
			return this;
		};
	
		p.paused = function (value) {
			if (!arguments.length) {
				return this._paused;
			}
			var tl = this._timeline,
			    raw,
			    elapsed;
			if (value != this._paused) if (tl) {
				if (!_tickerActive && !value) {
					_ticker.wake();
				}
				raw = tl.rawTime();
				elapsed = raw - this._pauseTime;
				if (!value && tl.smoothChildTiming) {
					this._startTime += elapsed;
					this._uncache(false);
				}
				this._pauseTime = value ? raw : null;
				this._paused = value;
				this._active = this.isActive();
				if (!value && elapsed !== 0 && this._initted && this.duration()) {
					raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
					this.render(raw, raw === this._totalTime, true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
				}
			}
			if (this._gc && !value) {
				this._enabled(true, false);
			}
			return this;
		};
	
		/*
	  * ----------------------------------------------------------------
	  * SimpleTimeline
	  * ----------------------------------------------------------------
	  */
		var SimpleTimeline = _class("core.SimpleTimeline", function (vars) {
			Animation.call(this, 0, vars);
			this.autoRemoveChildren = this.smoothChildTiming = true;
		});
	
		p = SimpleTimeline.prototype = new Animation();
		p.constructor = SimpleTimeline;
		p.kill()._gc = false;
		p._first = p._last = p._recent = null;
		p._sortChildren = false;
	
		p.add = p.insert = function (child, position, align, stagger) {
			var prevTween, st;
			child._startTime = Number(position || 0) + child._delay;
			if (child._paused) if (this !== child._timeline) {
				//we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
				child._pauseTime = child._startTime + (this.rawTime() - child._startTime) / child._timeScale;
			}
			if (child.timeline) {
				child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
			}
			child.timeline = child._timeline = this;
			if (child._gc) {
				child._enabled(true, true);
			}
			prevTween = this._last;
			if (this._sortChildren) {
				st = child._startTime;
				while (prevTween && prevTween._startTime > st) {
					prevTween = prevTween._prev;
				}
			}
			if (prevTween) {
				child._next = prevTween._next;
				prevTween._next = child;
			} else {
				child._next = this._first;
				this._first = child;
			}
			if (child._next) {
				child._next._prev = child;
			} else {
				this._last = child;
			}
			child._prev = prevTween;
			this._recent = child;
			if (this._timeline) {
				this._uncache(true);
			}
			return this;
		};
	
		p._remove = function (tween, skipDisable) {
			if (tween.timeline === this) {
				if (!skipDisable) {
					tween._enabled(false, true);
				}
	
				if (tween._prev) {
					tween._prev._next = tween._next;
				} else if (this._first === tween) {
					this._first = tween._next;
				}
				if (tween._next) {
					tween._next._prev = tween._prev;
				} else if (this._last === tween) {
					this._last = tween._prev;
				}
				tween._next = tween._prev = tween.timeline = null;
				if (tween === this._recent) {
					this._recent = this._last;
				}
	
				if (this._timeline) {
					this._uncache(true);
				}
			}
			return this;
		};
	
		p.render = function (time, suppressEvents, force) {
			var tween = this._first,
			    next;
			this._totalTime = this._time = this._rawPrevTime = time;
			while (tween) {
				next = tween._next; //record it here because the value could change after rendering...
				if (tween._active || time >= tween._startTime && !tween._paused) {
					if (!tween._reversed) {
						tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
					} else {
						tween.render((!tween._dirty ? tween._totalDuration : tween.totalDuration()) - (time - tween._startTime) * tween._timeScale, suppressEvents, force);
					}
				}
				tween = next;
			}
		};
	
		p.rawTime = function () {
			if (!_tickerActive) {
				_ticker.wake();
			}
			return this._totalTime;
		};
	
		/*
	  * ----------------------------------------------------------------
	  * TweenLite
	  * ----------------------------------------------------------------
	  */
		var TweenLite = _class("TweenLite", function (target, duration, vars) {
			Animation.call(this, duration, vars);
			this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
	
			if (target == null) {
				throw "Cannot tween a null target.";
			}
	
			this.target = target = typeof target !== "string" ? target : TweenLite.selector(target) || target;
	
			var isSelector = target.jquery || target.length && target !== window && target[0] && (target[0] === window || target[0].nodeType && target[0].style && !target.nodeType),
			    overwrite = this.vars.overwrite,
			    i,
			    targ,
			    targets;
	
			this._overwrite = overwrite = overwrite == null ? _overwriteLookup[TweenLite.defaultOverwrite] : typeof overwrite === "number" ? overwrite >> 0 : _overwriteLookup[overwrite];
	
			if ((isSelector || target instanceof Array || target.push && _isArray(target)) && typeof target[0] !== "number") {
				this._targets = targets = _slice(target); //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				this._propLookup = [];
				this._siblings = [];
				for (i = 0; i < targets.length; i++) {
					targ = targets[i];
					if (!targ) {
						targets.splice(i--, 1);
						continue;
					} else if (typeof targ === "string") {
						targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
						if (typeof targ === "string") {
							targets.splice(i + 1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
						}
						continue;
					} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || targ[0].nodeType && targ[0].style && !targ.nodeType)) {
						//in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
						targets.splice(i--, 1);
						this._targets = targets = targets.concat(_slice(targ));
						continue;
					}
					this._siblings[i] = _register(targ, this, false);
					if (overwrite === 1) if (this._siblings[i].length > 1) {
						_applyOverwrite(targ, this, null, 1, this._siblings[i]);
					}
				}
			} else {
				this._propLookup = {};
				this._siblings = _register(target, this, false);
				if (overwrite === 1) if (this._siblings.length > 1) {
					_applyOverwrite(target, this, null, 1, this._siblings);
				}
			}
			if (this.vars.immediateRender || duration === 0 && this._delay === 0 && this.vars.immediateRender !== false) {
				this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
				this.render(-this._delay);
			}
		}, true),
		    _isSelector = function _isSelector(v) {
			return v && v.length && v !== window && v[0] && (v[0] === window || v[0].nodeType && v[0].style && !v.nodeType); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
		},
		    _autoCSS = function _autoCSS(vars, target) {
			var css = {},
			    p;
			for (p in vars) {
				if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || _plugins[p] && _plugins[p]._autoCSS)) {
					//note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
					css[p] = vars[p];
					delete vars[p];
				}
			}
			vars.css = css;
		};
	
		p = TweenLite.prototype = new Animation();
		p.constructor = TweenLite;
		p.kill()._gc = false;
	
		//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
	
		p.ratio = 0;
		p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
		p._notifyPluginsOfEnabled = p._lazy = false;
	
		TweenLite.version = "1.18.2";
		TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
		TweenLite.defaultOverwrite = "auto";
		TweenLite.ticker = _ticker;
		TweenLite.autoSleep = 120;
		TweenLite.lagSmoothing = function (threshold, adjustedLag) {
			_ticker.lagSmoothing(threshold, adjustedLag);
		};
	
		TweenLite.selector = window.$ || window.jQuery || function (e) {
			var selector = window.$ || window.jQuery;
			if (selector) {
				TweenLite.selector = selector;
				return selector(e);
			}
			return typeof document === "undefined" ? e : document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById(e.charAt(0) === "#" ? e.substr(1) : e);
		};
	
		var _lazyTweens = [],
		    _lazyLookup = {},
		    _numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
	
		//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
		_setRatio = function _setRatio(v) {
			var pt = this._firstPT,
			    min = 0.000001,
			    val;
			while (pt) {
				val = !pt.blob ? pt.c * v + pt.s : v ? this.join("") : this.start;
				if (pt.r) {
					val = Math.round(val);
				} else if (val < min) if (val > -min) {
					//prevents issues with converting very small numbers to strings in the browser
					val = 0;
				}
				if (!pt.f) {
					pt.t[pt.p] = val;
				} else if (pt.fp) {
					pt.t[pt.p](pt.fp, val);
				} else {
					pt.t[pt.p](val);
				}
				pt = pt._next;
			}
		},
	
		//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
		_blobDif = function _blobDif(start, end, filter, pt) {
			var a = [start, end],
			    charIndex = 0,
			    s = "",
			    color = 0,
			    startNums,
			    endNums,
			    num,
			    i,
			    l,
			    nonNumbers,
			    currentNum;
			a.start = start;
			if (filter) {
				filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
				start = a[0];
				end = a[1];
			}
			a.length = 0;
			startNums = start.match(_numbersExp) || [];
			endNums = end.match(_numbersExp) || [];
			if (pt) {
				pt._next = null;
				pt.blob = 1;
				a._firstPT = pt; //apply last in the linked list (which means inserting it first)
			}
			l = endNums.length;
			for (i = 0; i < l; i++) {
				currentNum = endNums[i];
				nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex) - charIndex);
				s += nonNumbers || !i ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
				charIndex += nonNumbers.length;
				if (color) {
					//sense rgba() values and round them.
					color = (color + 1) % 5;
				} else if (nonNumbers.substr(-5) === "rgba(") {
					color = 1;
				}
				if (currentNum === startNums[i] || startNums.length <= i) {
					s += currentNum;
				} else {
					if (s) {
						a.push(s);
						s = "";
					}
					num = parseFloat(startNums[i]);
					a.push(num);
					a._firstPT = { _next: a._firstPT, t: a, p: a.length - 1, s: num, c: (currentNum.charAt(1) === "=" ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : parseFloat(currentNum) - num) || 0, f: 0, r: color && color < 4 };
					//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
				}
				charIndex += currentNum.length;
			}
			s += end.substr(charIndex);
			if (s) {
				a.push(s);
			}
			a.setRatio = _setRatio;
			return a;
		},
	
		//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
		_addPropTween = function _addPropTween(target, prop, start, end, overwriteProp, round, funcParam, stringFilter) {
			var s = start === "get" ? target[prop] : start,
			    type = _typeof(target[prop]),
			    isRelative = typeof end === "string" && end.charAt(1) === "=",
			    pt = { t: target, p: prop, s: s, f: type === "function", pg: 0, n: overwriteProp || prop, r: round, pr: 0, c: isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : parseFloat(end) - s || 0 },
			    blob,
			    getterName;
			if (type !== "number") {
				if (type === "function" && start === "get") {
					getterName = prop.indexOf("set") || typeof target["get" + prop.substr(3)] !== "function" ? prop : "get" + prop.substr(3);
					pt.s = s = funcParam ? target[getterName](funcParam) : target[getterName]();
				}
				if (typeof s === "string" && (funcParam || isNaN(s))) {
					//a blob (string that has multiple numbers in it)
					pt.fp = funcParam;
					blob = _blobDif(s, end, stringFilter || TweenLite.defaultStringFilter, pt);
					pt = { t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0 }; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
				} else if (!isRelative) {
						pt.s = parseFloat(s);
						pt.c = parseFloat(end) - pt.s || 0;
					}
			}
			if (pt.c) {
				//only add it to the linked list if there's a change.
				if (pt._next = this._firstPT) {
					pt._next._prev = pt;
				}
				this._firstPT = pt;
				return pt;
			}
		},
		    _internals = TweenLite._internals = { isArray: _isArray, isSelector: _isSelector, lazyTweens: _lazyTweens, blobDif: _blobDif },
		    //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
		_plugins = TweenLite._plugins = {},
		    _tweenLookup = _internals.tweenLookup = {},
		    _tweenLookupNum = 0,
		    _reservedProps = _internals.reservedProps = { ease: 1, delay: 1, overwrite: 1, onComplete: 1, onCompleteParams: 1, onCompleteScope: 1, useFrames: 1, runBackwards: 1, startAt: 1, onUpdate: 1, onUpdateParams: 1, onUpdateScope: 1, onStart: 1, onStartParams: 1, onStartScope: 1, onReverseComplete: 1, onReverseCompleteParams: 1, onReverseCompleteScope: 1, onRepeat: 1, onRepeatParams: 1, onRepeatScope: 1, easeParams: 1, yoyo: 1, immediateRender: 1, repeat: 1, repeatDelay: 1, data: 1, paused: 1, reversed: 1, autoCSS: 1, lazy: 1, onOverwrite: 1, callbackScope: 1, stringFilter: 1 },
		    _overwriteLookup = { none: 0, all: 1, auto: 2, concurrent: 3, allOnStart: 4, preexisting: 5, "true": 1, "false": 0 },
		    _rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
		    _rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
		    _nextGCFrame = 30,
		    _lazyRender = _internals.lazyRender = function () {
			var i = _lazyTweens.length,
			    tween;
			_lazyLookup = {};
			while (--i > -1) {
				tween = _lazyTweens[i];
				if (tween && tween._lazy !== false) {
					tween.render(tween._lazy[0], tween._lazy[1], true);
					tween._lazy = false;
				}
			}
			_lazyTweens.length = 0;
		};
	
		_rootTimeline._startTime = _ticker.time;
		_rootFramesTimeline._startTime = _ticker.frame;
		_rootTimeline._active = _rootFramesTimeline._active = true;
		setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
	
		Animation._updateRoot = TweenLite.render = function () {
			var i, a, p;
			if (_lazyTweens.length) {
				//if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
				_lazyRender();
			}
			_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
			_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
			if (_lazyTweens.length) {
				_lazyRender();
			}
			if (_ticker.frame >= _nextGCFrame) {
				//dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
				_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
				for (p in _tweenLookup) {
					a = _tweenLookup[p].tweens;
					i = a.length;
					while (--i > -1) {
						if (a[i]._gc) {
							a.splice(i, 1);
						}
					}
					if (a.length === 0) {
						delete _tweenLookup[p];
					}
				}
				//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
				p = _rootTimeline._first;
				if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
					while (p && p._paused) {
						p = p._next;
					}
					if (!p) {
						_ticker.sleep();
					}
				}
			}
		};
	
		_ticker.addEventListener("tick", Animation._updateRoot);
	
		var _register = function _register(target, tween, scrub) {
			var id = target._gsTweenID,
			    a,
			    i;
			if (!_tweenLookup[id || (target._gsTweenID = id = "t" + _tweenLookupNum++)]) {
				_tweenLookup[id] = { target: target, tweens: [] };
			}
			if (tween) {
				a = _tweenLookup[id].tweens;
				a[i = a.length] = tween;
				if (scrub) {
					while (--i > -1) {
						if (a[i] === tween) {
							a.splice(i, 1);
						}
					}
				}
			}
			return _tweenLookup[id].tweens;
		},
		    _onOverwrite = function _onOverwrite(overwrittenTween, overwritingTween, target, killedProps) {
			var func = overwrittenTween.vars.onOverwrite,
			    r1,
			    r2;
			if (func) {
				r1 = func(overwrittenTween, overwritingTween, target, killedProps);
			}
			func = TweenLite.onOverwrite;
			if (func) {
				r2 = func(overwrittenTween, overwritingTween, target, killedProps);
			}
			return r1 !== false && r2 !== false;
		},
		    _applyOverwrite = function _applyOverwrite(target, tween, props, mode, siblings) {
			var i, changed, curTween, l;
			if (mode === 1 || mode >= 4) {
				l = siblings.length;
				for (i = 0; i < l; i++) {
					if ((curTween = siblings[i]) !== tween) {
						if (!curTween._gc) {
							if (curTween._kill(null, target, tween)) {
								changed = true;
							}
						}
					} else if (mode === 5) {
						break;
					}
				}
				return changed;
			}
			//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
			var startTime = tween._startTime + _tinyNum,
			    overlaps = [],
			    oCount = 0,
			    zeroDur = tween._duration === 0,
			    globalStart;
			i = siblings.length;
			while (--i > -1) {
				if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
					//ignore
				} else if (curTween._timeline !== tween._timeline) {
						globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
						if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
							overlaps[oCount++] = curTween;
						}
					} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
						overlaps[oCount++] = curTween;
					}
			}
	
			i = oCount;
			while (--i > -1) {
				curTween = overlaps[i];
				if (mode === 2) if (curTween._kill(props, target, tween)) {
					changed = true;
				}
				if (mode !== 2 || !curTween._firstPT && curTween._initted) {
					if (mode !== 2 && !_onOverwrite(curTween, tween)) {
						continue;
					}
					if (curTween._enabled(false, false)) {
						//if all property tweens have been overwritten, kill the tween.
						changed = true;
					}
				}
			}
			return changed;
		},
		    _checkOverlap = function _checkOverlap(tween, reference, zeroDur) {
			var tl = tween._timeline,
			    ts = tl._timeScale,
			    t = tween._startTime;
			while (tl._timeline) {
				t += tl._startTime;
				ts *= tl._timeScale;
				if (tl._paused) {
					return -100;
				}
				tl = tl._timeline;
			}
			t /= ts;
			return t > reference ? t - reference : zeroDur && t === reference || !tween._initted && t - reference < 2 * _tinyNum ? _tinyNum : (t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum ? 0 : t - reference - _tinyNum;
		};
	
		//---- TweenLite instance methods -----------------------------------------------------------------------------
	
		p._init = function () {
			var v = this.vars,
			    op = this._overwrittenProps,
			    dur = this._duration,
			    immediate = !!v.immediateRender,
			    ease = v.ease,
			    i,
			    initPlugins,
			    pt,
			    p,
			    startVars;
			if (v.startAt) {
				if (this._startAt) {
					this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
					this._startAt.kill();
				}
				startVars = {};
				for (p in v.startAt) {
					//copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
					startVars[p] = v.startAt[p];
				}
				startVars.overwrite = false;
				startVars.immediateRender = true;
				startVars.lazy = immediate && v.lazy !== false;
				startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
				this._startAt = TweenLite.to(this.target, 0, startVars);
				if (immediate) {
					if (this._time > 0) {
						this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
					} else if (dur !== 0) {
							return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
						}
				}
			} else if (v.runBackwards && dur !== 0) {
					//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
					if (this._startAt) {
						this._startAt.render(-1, true);
						this._startAt.kill();
						this._startAt = null;
					} else {
						if (this._time !== 0) {
							//in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
							immediate = false;
						}
						pt = {};
						for (p in v) {
							//copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
							if (!_reservedProps[p] || p === "autoCSS") {
								pt[p] = v[p];
							}
						}
						pt.overwrite = 0;
						pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
						pt.lazy = immediate && v.lazy !== false;
						pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
						this._startAt = TweenLite.to(this.target, 0, pt);
						if (!immediate) {
							this._startAt._init(); //ensures that the initial values are recorded
							this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
							if (this.vars.immediateRender) {
								this._startAt = null;
							}
						} else if (this._time === 0) {
							return;
						}
					}
				}
			this._ease = ease = !ease ? TweenLite.defaultEase : ease instanceof Ease ? ease : typeof ease === "function" ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
			if (v.easeParams instanceof Array && ease.config) {
				this._ease = ease.config.apply(ease, v.easeParams);
			}
			this._easeType = this._ease._type;
			this._easePower = this._ease._power;
			this._firstPT = null;
	
			if (this._targets) {
				i = this._targets.length;
				while (--i > -1) {
					if (this._initProps(this._targets[i], this._propLookup[i] = {}, this._siblings[i], op ? op[i] : null)) {
						initPlugins = true;
					}
				}
			} else {
				initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op);
			}
	
			if (initPlugins) {
				TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
			}
			if (op) if (!this._firstPT) if (typeof this.target !== "function") {
				//if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
				this._enabled(false, false);
			}
			if (v.runBackwards) {
				pt = this._firstPT;
				while (pt) {
					pt.s += pt.c;
					pt.c = -pt.c;
					pt = pt._next;
				}
			}
			this._onUpdate = v.onUpdate;
			this._initted = true;
		};
	
		p._initProps = function (target, propLookup, siblings, overwrittenProps) {
			var p, i, initPlugins, plugin, pt, v;
			if (target == null) {
				return false;
			}
	
			if (_lazyLookup[target._gsTweenID]) {
				_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
			}
	
			if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) {
				//it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
				_autoCSS(this.vars, target);
			}
			for (p in this.vars) {
				v = this.vars[p];
				if (_reservedProps[p]) {
					if (v) if (v instanceof Array || v.push && _isArray(v)) if (v.join("").indexOf("{self}") !== -1) {
						this.vars[p] = v = this._swapSelfInParams(v, this);
					}
				} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this)) {
	
					//t - target 		[object]
					//p - property 		[string]
					//s - start			[number]
					//c - change		[number]
					//f - isFunction	[boolean]
					//n - name			[string]
					//pg - isPlugin 	[boolean]
					//pr - priority		[number]
					this._firstPT = pt = { _next: this._firstPT, t: plugin, p: "setRatio", s: 0, c: 1, f: 1, n: p, pg: 1, pr: plugin._priority };
					i = plugin._overwriteProps.length;
					while (--i > -1) {
						propLookup[plugin._overwriteProps[i]] = this._firstPT;
					}
					if (plugin._priority || plugin._onInitAllProps) {
						initPlugins = true;
					}
					if (plugin._onDisable || plugin._onEnable) {
						this._notifyPluginsOfEnabled = true;
					}
					if (pt._next) {
						pt._next._prev = pt;
					}
				} else {
					propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter);
				}
			}
	
			if (overwrittenProps) if (this._kill(overwrittenProps, target)) {
				//another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
				return this._initProps(target, propLookup, siblings, overwrittenProps);
			}
			if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
				this._kill(propLookup, target);
				return this._initProps(target, propLookup, siblings, overwrittenProps);
			}
			if (this._firstPT) if (this.vars.lazy !== false && this._duration || this.vars.lazy && !this._duration) {
				//zero duration tweens don't lazy render by default; everything else does.
				_lazyLookup[target._gsTweenID] = true;
			}
			return initPlugins;
		};
	
		p.render = function (time, suppressEvents, force) {
			var prevTime = this._time,
			    duration = this._duration,
			    prevRawPrevTime = this._rawPrevTime,
			    isComplete,
			    callback,
			    pt,
			    rawPrevTime;
			if (time >= duration - 0.0000001) {
				//to work around occasional floating point math artifacts.
				this._totalTime = this._time = duration;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
				if (!this._reversed) {
					isComplete = true;
					callback = "onComplete";
					force = force || this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (this._initted || !this.vars.lazy || force) {
					//zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (this._startTime === this._timeline._duration) {
						//if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || time <= 0 && time >= -0.0000001 || prevRawPrevTime === _tinyNum && this.data !== "isPause") if (prevRawPrevTime !== time) {
						//note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					this._rawPrevTime = rawPrevTime = !suppressEvents || time || prevRawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}
			} else if (time < 0.0000001) {
					//to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTime !== 0 || duration === 0 && prevRawPrevTime > 0) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) {
							//zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = !suppressEvents || time || prevRawPrevTime === time ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) {
						//if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
	
					if (this._easeType) {
						var r = time / duration,
						    type = this._easeType,
						    pow = this._easePower;
						if (type === 1 || type === 3 && r >= 0.5) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - r / 2;
						}
					} else {
						this.ratio = this._ease.getRatio(time / duration);
					}
				}
	
			if (this._time === prevTime && !force) {
				return;
			} else if (!this._initted) {
				this._init();
				if (!this._initted || this._gc) {
					//immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && this._firstPT && (this.vars.lazy !== false && this._duration || this.vars.lazy && !this._duration)) {
					this._time = this._totalTime = prevTime;
					this._rawPrevTime = prevRawPrevTime;
					_lazyTweens.push(this);
					this._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (this._time && !isComplete) {
					this.ratio = this._ease.getRatio(this._time / duration);
				} else if (isComplete && this._ease._calcEnd) {
					this.ratio = this._ease.getRatio(this._time === 0 ? 0 : 1);
				}
			}
			if (this._lazy !== false) {
				//in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
				this._lazy = false;
			}
			if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
				this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTime === 0) {
				if (this._startAt) {
					if (time >= 0) {
						this._startAt.render(time, suppressEvents, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
					this._callback("onStart");
				}
			}
			pt = this._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * this.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * this.ratio + pt.s;
				}
				pt = pt._next;
			}
	
			if (this._onUpdate) {
				if (time < 0) if (this._startAt && time !== -0.0001) {
					//if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (this._time !== prevTime || isComplete) {
					this._callback("onUpdate");
				}
			}
			if (callback) if (!this._gc || force) {
				//check _gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) {
					//-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
					this._startAt.render(time, suppressEvents, force);
				}
				if (isComplete) {
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
				if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) {
					//the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					this._rawPrevTime = 0;
				}
			}
		};
	
		p._kill = function (vars, target, overwritingTween) {
			if (vars === "all") {
				vars = null;
			}
			if (vars == null) if (target == null || target === this.target) {
				this._lazy = false;
				return this._enabled(false, false);
			}
			target = typeof target !== "string" ? target || this._targets || this.target : TweenLite.selector(target) || target;
			var simultaneousOverwrite = overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline,
			    i,
			    overwrittenProps,
			    p,
			    pt,
			    propLookup,
			    changed,
			    killProps,
			    record,
			    killed;
			if ((_isArray(target) || _isSelector(target)) && typeof target[0] !== "number") {
				i = target.length;
				while (--i > -1) {
					if (this._kill(vars, target[i], overwritingTween)) {
						changed = true;
					}
				}
			} else {
				if (this._targets) {
					i = this._targets.length;
					while (--i > -1) {
						if (target === this._targets[i]) {
							propLookup = this._propLookup[i] || {};
							this._overwrittenProps = this._overwrittenProps || [];
							overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
							break;
						}
					}
				} else if (target !== this.target) {
					return false;
				} else {
					propLookup = this._propLookup;
					overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
				}
	
				if (propLookup) {
					killProps = vars || propLookup;
					record = vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && ((typeof vars === "undefined" ? "undefined" : _typeof(vars)) !== "object" || !vars._tempKill); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
					if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
						for (p in killProps) {
							if (propLookup[p]) {
								if (!killed) {
									killed = [];
								}
								killed.push(p);
							}
						}
						if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) {
							//if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
							return false;
						}
					}
	
					for (p in killProps) {
						if (pt = propLookup[p]) {
							if (simultaneousOverwrite) {
								//if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
								if (pt.f) {
									pt.t[pt.p](pt.s);
								} else {
									pt.t[pt.p] = pt.s;
								}
								changed = true;
							}
							if (pt.pg && pt.t._kill(killProps)) {
								changed = true; //some plugins need to be notified so they can perform cleanup tasks first
							}
							if (!pt.pg || pt.t._overwriteProps.length === 0) {
								if (pt._prev) {
									pt._prev._next = pt._next;
								} else if (pt === this._firstPT) {
									this._firstPT = pt._next;
								}
								if (pt._next) {
									pt._next._prev = pt._prev;
								}
								pt._next = pt._prev = null;
							}
							delete propLookup[p];
						}
						if (record) {
							overwrittenProps[p] = 1;
						}
					}
					if (!this._firstPT && this._initted) {
						//if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
						this._enabled(false, false);
					}
				}
			}
			return changed;
		};
	
		p.invalidate = function () {
			if (this._notifyPluginsOfEnabled) {
				TweenLite._onPluginEvent("_onDisable", this);
			}
			this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
			this._notifyPluginsOfEnabled = this._active = this._lazy = false;
			this._propLookup = this._targets ? {} : [];
			Animation.prototype.invalidate.call(this);
			if (this.vars.immediateRender) {
				this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
				this.render(-this._delay);
			}
			return this;
		};
	
		p._enabled = function (enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (enabled && this._gc) {
				var targets = this._targets,
				    i;
				if (targets) {
					i = targets.length;
					while (--i > -1) {
						this._siblings[i] = _register(targets[i], this, true);
					}
				} else {
					this._siblings = _register(this.target, this, true);
				}
			}
			Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
			if (this._notifyPluginsOfEnabled) if (this._firstPT) {
				return TweenLite._onPluginEvent(enabled ? "_onEnable" : "_onDisable", this);
			}
			return false;
		};
	
		//----TweenLite static methods -----------------------------------------------------
	
		TweenLite.to = function (target, duration, vars) {
			return new TweenLite(target, duration, vars);
		};
	
		TweenLite.from = function (target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = vars.immediateRender != false;
			return new TweenLite(target, duration, vars);
		};
	
		TweenLite.fromTo = function (target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = toVars.immediateRender != false && fromVars.immediateRender != false;
			return new TweenLite(target, duration, toVars);
		};
	
		TweenLite.delayedCall = function (delay, callback, params, scope, useFrames) {
			return new TweenLite(callback, 0, { delay: delay, onComplete: callback, onCompleteParams: params, callbackScope: scope, onReverseComplete: callback, onReverseCompleteParams: params, immediateRender: false, lazy: false, useFrames: useFrames, overwrite: 0 });
		};
	
		TweenLite.set = function (target, vars) {
			return new TweenLite(target, 0, vars);
		};
	
		TweenLite.getTweensOf = function (target, onlyActive) {
			if (target == null) {
				return [];
			}
			target = typeof target !== "string" ? target : TweenLite.selector(target) || target;
			var i, a, j, t;
			if ((_isArray(target) || _isSelector(target)) && typeof target[0] !== "number") {
				i = target.length;
				a = [];
				while (--i > -1) {
					a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
				}
				i = a.length;
				//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
				while (--i > -1) {
					t = a[i];
					j = i;
					while (--j > -1) {
						if (t === a[j]) {
							a.splice(i, 1);
						}
					}
				}
			} else {
				a = _register(target).concat();
				i = a.length;
				while (--i > -1) {
					if (a[i]._gc || onlyActive && !a[i].isActive()) {
						a.splice(i, 1);
					}
				}
			}
			return a;
		};
	
		TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function (target, onlyActive, vars) {
			if ((typeof onlyActive === "undefined" ? "undefined" : _typeof(onlyActive)) === "object") {
				vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
				onlyActive = false;
			}
			var a = TweenLite.getTweensOf(target, onlyActive),
			    i = a.length;
			while (--i > -1) {
				a[i]._kill(vars, target);
			}
		};
	
		/*
	  * ----------------------------------------------------------------
	  * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
	  * ----------------------------------------------------------------
	  */
		var TweenPlugin = _class("plugins.TweenPlugin", function (props, priority) {
			this._overwriteProps = (props || "").split(",");
			this._propName = this._overwriteProps[0];
			this._priority = priority || 0;
			this._super = TweenPlugin.prototype;
		}, true);
	
		p = TweenPlugin.prototype;
		TweenPlugin.version = "1.18.0";
		TweenPlugin.API = 2;
		p._firstPT = null;
		p._addTween = _addPropTween;
		p.setRatio = _setRatio;
	
		p._kill = function (lookup) {
			var a = this._overwriteProps,
			    pt = this._firstPT,
			    i;
			if (lookup[this._propName] != null) {
				this._overwriteProps = [];
			} else {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i]] != null) {
						a.splice(i, 1);
					}
				}
			}
			while (pt) {
				if (lookup[pt.n] != null) {
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
						pt._prev = null;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
					}
				}
				pt = pt._next;
			}
			return false;
		};
	
		p._roundProps = function (lookup, value) {
			var pt = this._firstPT;
			while (pt) {
				if (lookup[this._propName] || pt.n != null && lookup[pt.n.split(this._propName + "_").join("")]) {
					//some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
					pt.r = value;
				}
				pt = pt._next;
			}
		};
	
		TweenLite._onPluginEvent = function (type, tween) {
			var pt = tween._firstPT,
			    changed,
			    pt2,
			    first,
			    last,
			    next;
			if (type === "_onInitAllProps") {
				//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if (pt._prev = pt2 ? pt2._prev : last) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if (pt._next = pt2) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				pt = tween._firstPT = first;
			}
			while (pt) {
				if (pt.pg) if (typeof pt.t[type] === "function") if (pt.t[type]()) {
					changed = true;
				}
				pt = pt._next;
			}
			return changed;
		};
	
		TweenPlugin.activate = function (plugins) {
			var i = plugins.length;
			while (--i > -1) {
				if (plugins[i].API === TweenPlugin.API) {
					_plugins[new plugins[i]()._propName] = plugins[i];
				}
			}
			return true;
		};
	
		//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
		_gsDefine.plugin = function (config) {
			if (!config || !config.propName || !config.init || !config.API) {
				throw "illegal plugin definition.";
			}
			var propName = config.propName,
			    priority = config.priority || 0,
			    overwriteProps = config.overwriteProps,
			    map = { init: "_onInitTween", set: "setRatio", kill: "_kill", round: "_roundProps", initAll: "_onInitAllProps" },
			    Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin", function () {
				TweenPlugin.call(this, propName, priority);
				this._overwriteProps = overwriteProps || [];
			}, config.global === true),
			    p = Plugin.prototype = new TweenPlugin(propName),
			    prop;
			p.constructor = Plugin;
			Plugin.API = config.API;
			for (prop in map) {
				if (typeof config[prop] === "function") {
					p[map[prop]] = config[prop];
				}
			}
			Plugin.version = config.version;
			TweenPlugin.activate([Plugin]);
			return Plugin;
		};
	
		//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
		a = window._gsQueue;
		if (a) {
			for (i = 0; i < a.length; i++) {
				a[i]();
			}
			for (p in _defLookup) {
				if (!_defLookup[p].func) {
					window.console.log("GSAP encountered missing dependency: com.greensock." + p);
				}
			}
		}
	
		_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
	})(typeof module !== "undefined" && module.exports && typeof global !== "undefined" ? global : undefined || window, "TweenLite");
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "TweenLite.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 127 */
/*!************************************!*\
  !*** ./~/react/lib/CSSProperty.js ***!
  \************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 128 */
/*!**********************************************!*\
  !*** ./~/react/lib/DOMChildrenOperations.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(/*! ./Danger */ 262);
	var ReactMultiChildUpdateTypes = __webpack_require__(/*! ./ReactMultiChildUpdateTypes */ 145);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	
	var setInnerHTML = __webpack_require__(/*! ./setInnerHTML */ 52);
	var setTextContent = __webpack_require__(/*! ./setTextContent */ 80);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 129 */
/*!********************************************!*\
  !*** ./~/react/lib/EventPluginRegistry.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 130 */
/*!**************************************!*\
  !*** ./~/react/lib/ReactChildren.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(/*! ./PooledClass */ 22);
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	
	var emptyFunction = __webpack_require__(/*! fbjs/lib/emptyFunction */ 15);
	var traverseAllChildren = __webpack_require__(/*! ./traverseAllChildren */ 82);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 131 */
/*!***********************************!*\
  !*** ./~/react/lib/ReactClass.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(/*! ./ReactComponent */ 132);
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactPropTypeLocations = __webpack_require__(/*! ./ReactPropTypeLocations */ 47);
	var ReactPropTypeLocationNames = __webpack_require__(/*! ./ReactPropTypeLocationNames */ 46);
	var ReactNoopUpdateQueue = __webpack_require__(/*! ./ReactNoopUpdateQueue */ 147);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var emptyObject = __webpack_require__(/*! fbjs/lib/emptyObject */ 28);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var keyMirror = __webpack_require__(/*! fbjs/lib/keyMirror */ 35);
	var keyOf = __webpack_require__(/*! fbjs/lib/keyOf */ 19);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 132 */
/*!***************************************!*\
  !*** ./~/react/lib/ReactComponent.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(/*! ./ReactNoopUpdateQueue */ 147);
	
	var canDefineProperty = __webpack_require__(/*! ./canDefineProperty */ 50);
	var emptyObject = __webpack_require__(/*! fbjs/lib/emptyObject */ 28);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 133 */
/*!*********************************!*\
  !*** ./~/react/lib/ReactDOM.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(/*! ./ReactCurrentOwner */ 17);
	var ReactDOMTextComponent = __webpack_require__(/*! ./ReactDOMTextComponent */ 136);
	var ReactDefaultInjection = __webpack_require__(/*! ./ReactDefaultInjection */ 138);
	var ReactInstanceHandles = __webpack_require__(/*! ./ReactInstanceHandles */ 27);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	var ReactReconciler = __webpack_require__(/*! ./ReactReconciler */ 24);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	var ReactVersion = __webpack_require__(/*! ./ReactVersion */ 72);
	
	var findDOMNode = __webpack_require__(/*! ./findDOMNode */ 73);
	var renderSubtreeIntoContainer = __webpack_require__(/*! ./renderSubtreeIntoContainer */ 311);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 134 */
/*!*********************************************!*\
  !*** ./~/react/lib/ReactDOMFeatureFlags.js ***!
  \*********************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 135 */
/*!***************************************!*\
  !*** ./~/react/lib/ReactDOMSelect.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(/*! ./LinkedValueUtils */ 67);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 136 */
/*!**********************************************!*\
  !*** ./~/react/lib/ReactDOMTextComponent.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(/*! ./DOMChildrenOperations */ 128);
	var DOMPropertyOperations = __webpack_require__(/*! ./DOMPropertyOperations */ 66);
	var ReactComponentBrowserEnvironment = __webpack_require__(/*! ./ReactComponentBrowserEnvironment */ 68);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var escapeTextContentForBrowser = __webpack_require__(/*! ./escapeTextContentForBrowser */ 51);
	var setTextContent = __webpack_require__(/*! ./setTextContent */ 80);
	var validateDOMNesting = __webpack_require__(/*! ./validateDOMNesting */ 83);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 137 */
/*!*****************************************************!*\
  !*** ./~/react/lib/ReactDefaultBatchingStrategy.js ***!
  \*****************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	var Transaction = __webpack_require__(/*! ./Transaction */ 49);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var emptyFunction = __webpack_require__(/*! fbjs/lib/emptyFunction */ 15);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 138 */
/*!**********************************************!*\
  !*** ./~/react/lib/ReactDefaultInjection.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(/*! ./BeforeInputEventPlugin */ 258);
	var ChangeEventPlugin = __webpack_require__(/*! ./ChangeEventPlugin */ 260);
	var ClientReactRootIndex = __webpack_require__(/*! ./ClientReactRootIndex */ 261);
	var DefaultEventPluginOrder = __webpack_require__(/*! ./DefaultEventPluginOrder */ 263);
	var EnterLeaveEventPlugin = __webpack_require__(/*! ./EnterLeaveEventPlugin */ 264);
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	var HTMLDOMPropertyConfig = __webpack_require__(/*! ./HTMLDOMPropertyConfig */ 267);
	var ReactBrowserComponentMixin = __webpack_require__(/*! ./ReactBrowserComponentMixin */ 269);
	var ReactComponentBrowserEnvironment = __webpack_require__(/*! ./ReactComponentBrowserEnvironment */ 68);
	var ReactDefaultBatchingStrategy = __webpack_require__(/*! ./ReactDefaultBatchingStrategy */ 137);
	var ReactDOMComponent = __webpack_require__(/*! ./ReactDOMComponent */ 273);
	var ReactDOMTextComponent = __webpack_require__(/*! ./ReactDOMTextComponent */ 136);
	var ReactEventListener = __webpack_require__(/*! ./ReactEventListener */ 281);
	var ReactInjection = __webpack_require__(/*! ./ReactInjection */ 282);
	var ReactInstanceHandles = __webpack_require__(/*! ./ReactInstanceHandles */ 27);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	var ReactReconcileTransaction = __webpack_require__(/*! ./ReactReconcileTransaction */ 286);
	var SelectEventPlugin = __webpack_require__(/*! ./SelectEventPlugin */ 292);
	var ServerReactRootIndex = __webpack_require__(/*! ./ServerReactRootIndex */ 293);
	var SimpleEventPlugin = __webpack_require__(/*! ./SimpleEventPlugin */ 294);
	var SVGDOMPropertyConfig = __webpack_require__(/*! ./SVGDOMPropertyConfig */ 291);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 139 */
/*!**********************************************!*\
  !*** ./~/react/lib/ReactElementValidator.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactPropTypeLocations = __webpack_require__(/*! ./ReactPropTypeLocations */ 47);
	var ReactPropTypeLocationNames = __webpack_require__(/*! ./ReactPropTypeLocationNames */ 46);
	var ReactCurrentOwner = __webpack_require__(/*! ./ReactCurrentOwner */ 17);
	
	var canDefineProperty = __webpack_require__(/*! ./canDefineProperty */ 50);
	var getIteratorFn = __webpack_require__(/*! ./getIteratorFn */ 77);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ },
/* 140 */
/*!********************************************!*\
  !*** ./~/react/lib/ReactEmptyComponent.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactEmptyComponentRegistry = __webpack_require__(/*! ./ReactEmptyComponentRegistry */ 141);
	var ReactReconciler = __webpack_require__(/*! ./ReactReconciler */ 24);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	function registerNullComponentID() {
	  ReactEmptyComponentRegistry.registerNullComponentID(this._rootNodeID);
	}
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    transaction.getReactMountReady().enqueue(registerNullComponentID, this);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 141 */
/*!****************************************************!*\
  !*** ./~/react/lib/ReactEmptyComponentRegistry.js ***!
  \****************************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ },
/* 142 */
/*!****************************************!*\
  !*** ./~/react/lib/ReactErrorUtils.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 143 */
/*!********************************************!*\
  !*** ./~/react/lib/ReactInputSelection.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(/*! ./ReactDOMSelection */ 277);
	
	var containsNode = __webpack_require__(/*! fbjs/lib/containsNode */ 87);
	var focusNode = __webpack_require__(/*! fbjs/lib/focusNode */ 88);
	var getActiveElement = __webpack_require__(/*! fbjs/lib/getActiveElement */ 89);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 144 */
/*!********************************************!*\
  !*** ./~/react/lib/ReactMarkupChecksum.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(/*! ./adler32 */ 303);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 145 */
/*!***************************************************!*\
  !*** ./~/react/lib/ReactMultiChildUpdateTypes.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(/*! fbjs/lib/keyMirror */ 35);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 146 */
/*!*********************************************!*\
  !*** ./~/react/lib/ReactNativeComponent.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ },
/* 147 */
/*!*********************************************!*\
  !*** ./~/react/lib/ReactNoopUpdateQueue.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 148 */
/*!***************************************!*\
  !*** ./~/react/lib/ReactPropTypes.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactPropTypeLocationNames = __webpack_require__(/*! ./ReactPropTypeLocationNames */ 46);
	
	var emptyFunction = __webpack_require__(/*! fbjs/lib/emptyFunction */ 15);
	var getIteratorFn = __webpack_require__(/*! ./getIteratorFn */ 77);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 149 */
/*!***************************************!*\
  !*** ./~/react/lib/ReactRootIndex.js ***!
  \***************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ },
/* 150 */
/*!****************************************!*\
  !*** ./~/react/lib/ViewportMetrics.js ***!
  \****************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 151 */
/*!***************************************!*\
  !*** ./~/react/lib/accumulateInto.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 152 */
/*!*******************************************!*\
  !*** ./~/react/lib/forEachAccumulated.js ***!
  \*******************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 153 */
/*!***********************************************!*\
  !*** ./~/react/lib/getTextContentAccessor.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 154 */
/*!*******************************************!*\
  !*** ./~/react/lib/isTextInputElement.js ***!
  \*******************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 155 */
/*!**********************************!*\
  !*** ./assets/css/src/main.scss ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../~/css-loader!./../../../~/postcss-loader!./../../../~/sass-loader?outputStyle=expanded!./main.scss */ 157);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../~/style-loader/addStyles.js */ 317)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/sass-loader/index.js?outputStyle=expanded!./main.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/sass-loader/index.js?outputStyle=expanded!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 156 */
/*!**********************!*\
  !*** ./~/url/url.js ***!
  \**********************/
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = __webpack_require__(/*! punycode */ 318);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(/*! querystring */ 242);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ },
/* 157 */
/*!*********************************************************************************************************!*\
  !*** ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./assets/css/src/main.scss ***!
  \*********************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../~/css-loader/lib/css-base.js */ 158)();
	// imports
	
	
	// module
	exports.push([module.id, "*{margin:0;padding:0}.app-container,body,html{background-color:#000;box-sizing:border-box;font-family:cooper_hewittbold,sans-serif;font-size:18px;-webkit-font-smoothing:antialiased;height:100%;line-height:1.3em;overflow:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;position:absolute;text-shadow:rgba(0,0,0,.01) 0 0 1px;-webkit-text-size-adjust:100%;text-transform:uppercase;width:100%}@media (min-width:768px){.app-container,body,html{background-color:#000;height:200vh}}*,:after,:before{box-sizing:inherit}.no-touch .grab-cursor{cursor:url(\"data:image/vnd.microsoft.icon;base64,AAACAAEAICACAAcABQAwAQAAFgAAACgAAAAgAAAAQAAAAAEAAQAAAAAAAAEAAAAAAAAAAAAAAgAAAAAAAAAAAAAA////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8AAAA/AAAAfwAAAP+AAAH/gAAB/8AAA//AAAd/wAAGf+AAAH9gAADbYAAA2yAAAZsAAAGbAAAAGAAAAAAAAA//////////////////////////////////////////////////////////////////////////////////////gH///4B///8Af//+AD///AA///wAH//4AB//8AAf//AAD//5AA///gAP//4AD//8AF///AB///5A////5///8=\"),all-scroll;cursor:-webkit-grab;cursor:-ms-grab;cursor:grab}.no-touch .grab-cursor:active{cursor:url(\"data:image/vnd.microsoft.icon;base64,AAACAAEAICACAAcABQAwAQAAFgAAACgAAAAgAAAAQAAAAAEAAQAAAAAAAAEAAAAAAAAAAAAAAgAAAAAAAAAAAAAA////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8AAAA/AAAAfwAAAP+AAAH/gAAB/8AAAH/AAAB/wAAA/0AAANsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//////////////////////////////////////////////////////////////////////////////////////gH///4B///8Af//+AD///AA///wAH//+AB///wAf//4AH//+AD///yT/////////////////////////////8=\"),all-scroll;cursor:-webkit-grabbing!important;cursor:-ms-grabbing!important;cursor:grabbing!important}li,ul{list-style:none;margin:0;padding:0}input{-webkit-appearance:none}@font-face{font-family:cooper_hewittbold;src:url(\"/assets/fonts/cooperhewitt-bold-webfont.woff2\") format(\"woff2\"),url(\"/assets/fonts/cooperhewitt-bold-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:cooper_hewittbook;src:url(\"/assets/fonts/cooperhewitt-book-webfont.woff2\") format(\"woff2\"),url(\"/assets/fonts/cooperhewitt-book-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}@media (min-width:768px){.component-emoji-is-life .main-content{background-color:#000;background-image:url(\"/assets/images/tile-bg.png\");background-size:250px 76px;display:block;height:100vh;margin:0;position:relative;top:100vh;width:100%}}@media (min-width:768px){.component-emoji-is-life .main-content .main-content-inner{background-color:#000;height:100vh;margin:0 auto;position:relative;width:1000px}}.component-emoji-is-life .large-header{float:left;height:100vh;position:relative;width:100%}.component-emoji-is-life .left-col-large{color:#fff;display:none;float:left;margin:120px 0 0 40px;position:absolute;width:300px}@media (min-width:768px){.component-emoji-is-life .left-col-large{display:block}}.component-emoji-is-life .main-menu-button{background-color:#fff;border-radius:50%;cursor:pointer;font-size:16px;height:37px;padding:9px 0 0 10px;position:fixed;right:20px;top:20px;width:37px}@media (min-width:768px){.component-emoji-is-life .main-menu-button{display:none}}.component-emoji-is-life .br-logo{background-color:#000;display:block;left:20px;position:fixed;top:20px;width:30px}@media (min-width:768px){.component-emoji-is-life .br-logo{left:40px;top:40px;width:45px}}.component-emoji-is-life .br-logo img{display:block;height:auto;width:100%}.component-emoji-is-life .logo{color:#fff;left:60px;position:fixed;top:25px}@media (min-width:768px){.component-emoji-is-life .logo{cursor:pointer;left:105px;top:50px}}@media (min-width:768px){.component-emoji-is-life .logos{display:none}}.component-emoji-is-life .mc-logos{position:absolute}.component-emoji-is-life .mc-logos .br-logo,.component-emoji-is-life .mc-logos .logo{left:0;position:absolute;top:-80px}.component-emoji-is-life .mc-logos .logo{margin:12px 0 0 60px;width:115px}.component-emoji-is-life .large-button-wrapper .sep{border-bottom:2px solid;height:2px;position:absolute;width:200px}.component-emoji-is-life .large-button-wrapper .buttons{height:calc(100vh - 240px);float:left;margin-top:35px;overflow:scroll}.component-emoji-is-life.slide-0 .logo{display:none}@media (min-width:768px){.component-emoji-is-life.slide-0 .logos{display:block}}@media (min-width:768px){.component-emoji-is-life.viewing-main .logos{display:none}}@media (min-width:768px){.component-emoji-is-life.viewing-main .mc-logos .logo{display:block}}@media (min-width:768px){.component-emoji-is-life .section-transition-complete.viewing-main .logos{display:none}}@media (min-width:768px){.component-emoji-is-life .section-transition-complete.viewing-main .mc-logos .br-logo,.component-emoji-is-life .section-transition-complete.viewing-main .mc-logos .logo{display:block}}.component-emoji-is-life.viewing-main .content-inner{-webkit-transform:translate3d(0,-100vh,0);transform:translate3d(0,-100vh,0)}.component-emoji-is-life.section-transition-complete.viewing-main .content-inner{-webkit-transition:none;transition:none;-webkit-transform:translateZ(0);transform:translateZ(0)}.component-emoji-is-life.section-transition-complete.viewing-main .main-content{top:0}.component-emoji-is-life.section-transition-complete.viewing-main.transitioning-to-landing .content-inner{-webkit-transform:translate3d(0,-100vh,0);transform:translate3d(0,-100vh,0)}.component-emoji-is-life.section-transition-complete.viewing-main.transitioning-to-landing .main-content{top:100vh}.component-emoji-is-life .content-inner{-webkit-transition:transform .5s ease-out;transition:transform .5s ease-out;height:100%;position:absolute;width:100%}.component-emoji-is-life .large-credits{color:#999;float:left;font-size:10px;letter-spacing:.2px;line-height:10px;margin-top:40px;width:100%}.component-emoji-is-life .large-share{font-size:14px;line-height:1.2em;margin-top:120px;position:absolute;right:40px;width:120px}.component-emoji-is-life .large-share .component-share{padding:0}.component-emoji-is-life .large-share .component-share .button{float:right;display:block;height:40px;margin:0 0 0 10px;width:40px}.component-emoji-is-life .large-share .credits,.component-emoji-is-life .large-share .text{text-align:right}.component-emoji-is-life .large-share .credits{color:#999;float:right;font-size:10px;line-height:10px;margin-top:40px;width:130px}.nocsstransforms3d .twitter-nba-emoji-web-client.viewing-main .content-inner{-webkit-transition:transform .5s ease-out;transition:transform .5s ease-out;-webkit-transform:translateY(-100vh);transform:translateY(-100vh)}.nocsstransforms3d .twitter-nba-emoji-web-client.section-transition-complete.viewing-main .twitter-nba-emoji-web-client .content-inner,.nocsstransforms3d .twitter-nba-emoji-web-client.viewing-main.transitioning-to-landing .content-inner{-webkit-transform:translate(0);transform:translate(0)}.nocsstransforms3d .twitter-nba-emoji-web-client.section-transition-complete.viewing-main .twitter-nba-emoji-web-client.transitioning-to-landing .content-inner{-webkit-transform:translateY(100vh);transform:translateY(100vh)}.iOS-8 .main-menu-button,.iOS-9 .main-menu-button{padding:7px 0 0 7px}.android .main-menu-button{padding:8px 0 0 8px}.ie-edge .large-button-wrapper .buttons{overflow:hidden}.component-menu{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);-webkit-transition:transform .3s ease-out;transition:transform .3s ease-out;background-color:#000;cursor:pointer;height:100%;left:0;padding:25px 20px 20px;position:absolute;top:0;width:100%}.component-menu.open{-webkit-transform:translateZ(0);transform:translateZ(0)}.component-menu .sep{width:calc(100% - 40px);border-bottom:2px solid #fff;left:20px;position:absolute;top:80px}.component-menu .button-wrapper{height:calc(100% - 100px);overflow:scroll;-webkit-overflow-scrolling:touch;position:absolute;top:100px;width:100%}.component-menu .buttons{float:left;width:100%}.component-menu .close-button{color:#fff;cursor:pointer;position:absolute;right:20px;top:20px}.nocsstransforms3d .component-menu{-webkit-transform:translate(-100%);transform:translate(-100%)}.nocsstransforms3d .component-menu.open{-webkit-transform:translate(0);transform:translate(0)}.component-menu-button{color:#fff;float:left;margin:0 0 10px;width:100%}@media (min-width:768px){.component-menu-button{font-size:14px;line-height:1.4em;margin:0;width:300px}}.component-menu-button.active{opacity:.6}.component-menu-button .emoji{margin:0 5px}.desktop .component-menu-button{-webkit-transition:opacity .2s;transition:opacity .2s;cursor:pointer}.desktop .component-menu-button.active{cursor:default}.desktop .component-menu-button:hover{opacity:.6}.component-slides .component-draggable,.component-slides .slides,.component-slides.slides-wrapper{height:100%;position:absolute;width:100%}.component-slides.slides-wrapper{overflow:hidden}@media (min-width:768px){.component-slides.slides-wrapper{margin-left:300px;width:400px}}@media (min-width:900px){.component-slides.slides-wrapper{margin-left:400px}}.component-slides .slides{-webkit-transition:transform .2s ease-out;transition:transform .2s ease-out}@media (min-width:768px){.component-slides .slides{-webkit-transition:transform .5s ease-out;transition:transform .5s ease-out}}.component-slides.dragging .slides{-webkit-transition:none;transition:none}.component-share{color:#fff;padding:20px;text-align:center}.component-share,.component-share .buttons{float:left;width:100%}@media (min-width:768px){.component-share .buttons{margin-top:20px}}.component-share .button{-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;border:2px solid #fff;border-radius:50%;cursor:pointer;display:inline-block;height:60px;margin:0 10px;width:60px}@media (min-width:768px){.component-share .button{height:40px;width:40px}}.component-share .button:hover{opacity:.7}.component-share .button img{height:auto;margin:14px 8px 0;width:30px}@media (min-width:768px){.component-share .button img{margin:8px;width:20px}}.component-description-slide{-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;background-color:#000;height:100%;opacity:.3;position:absolute;width:100%}.component-description-slide.active{opacity:1}.component-description-slide .text-wrapper{float:left;position:absolute;text-align:center;top:50%;width:100%}.component-description-slide .text-wrapper .text{-webkit-transform:translateY(-50%);transform:translateY(-50%);color:#fff;display:inline-block;max-width:310px;padding:20px;width:100%}.desktop .component-description-slide{cursor:pointer}.desktop .component-description-slide.active{cursor:url(\"data:image/vnd.microsoft.icon;base64,AAACAAEAICACAAcABQAwAQAAFgAAACgAAAAgAAAAQAAAAAEAAQAAAAAAAAEAAAAAAAAAAAAAAgAAAAAAAAAAAAAA////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8AAAA/AAAAfwAAAP+AAAH/gAAB/8AAA//AAAd/wAAGf+AAAH9gAADbYAAA2yAAAZsAAAGbAAAAGAAAAAAAAA//////////////////////////////////////////////////////////////////////////////////////gH///4B///8Af//+AD///AA///wAH//4AB//8AAf//AAD//5AA///gAP//4AD//8AF///AB///5A////5///8=\"),all-scroll;cursor:-webkit-grab;cursor:-ms-grab;cursor:grab;opacity:1}.desktop .component-description-slide.active:active{cursor:url(\"data:image/vnd.microsoft.icon;base64,AAACAAEAICACAAcABQAwAQAAFgAAACgAAAAgAAAAQAAAAAEAAQAAAAAAAAEAAAAAAAAAAAAAAgAAAAAAAAAAAAAA////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8AAAA/AAAAfwAAAP+AAAH/gAAB/8AAAH/AAAB/wAAA/0AAANsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//////////////////////////////////////////////////////////////////////////////////////gH///4B///8Af//+AD///AA///wAH//+AB///wAf//4AH//+AD///yT/////////////////////////////8=\"),all-scroll;cursor:-webkit-grabbing!important;cursor:-ms-grabbing!important;cursor:grabbing!important}.component-gif-slide{-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;height:100%;opacity:.3;position:absolute;width:100%}@media (min-width:768px){.component-gif-slide{width:400px}}.component-gif-slide.active{opacity:1;z-index:800}.component-gif-slide.active .text,.component-gif-slide.gif-loading .loader-wrapper{display:block}.component-gif-slide.gif-loaded .gif{opacity:1}.component-gif-slide .cover-image,.component-gif-slide .gif{height:100%;left:0;overflow:hidden;position:absolute;top:0;width:100%}.component-gif-slide .gif{-webkit-transition:opacity .3s ease-out;transition:opacity .3s ease-out;opacity:0}.component-gif-slide .gradient{background:-webkit-linear-gradient(top,transparent,rgba(0,0,0,.75));background:linear-gradient(180deg,transparent 0,rgba(0,0,0,.75));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000',endColorstr='#a6000000',GradientType=0);bottom:0;height:120px;position:absolute;width:100%}.component-gif-slide .text{bottom:15px;color:#fff;display:none;padding-left:20px;position:absolute}.component-gif-slide .text .emoji-item{display:inline-block;margin:5px 10px 0 0}.component-gif-slide .text .count,.component-gif-slide .text .emoji{display:inline-block;float:left}.component-gif-slide .text .emoji{font-size:16px;padding:9px 0 0}.component-gif-slide .text .count{margin:7px 0 0 10px}.component-gif-slide .text .emojis,.component-gif-slide .text .game-title,.component-gif-slide .text .title{float:left;width:100%}.component-gif-slide .text .title{margin:2px 0}.component-gif-slide .text .emojis,.component-gif-slide .text .game-title{font-size:12px;line-height:12px}.component-gif-slide .text .emojis{margin-top:-12px}.component-gif-slide .loader-wrapper{display:none;height:50px;left:50%;margin:-25px 0 0 -25px;padding:5px;position:absolute;top:50%;width:50px}.component-gif-slide .loader{-webkit-animation:spinner 1.1s infinite linear;animation:spinner 1.1s infinite linear;border-bottom:4px solid hsla(0,0%,100%,.2);border-left:4px solid #fff;border-right:4px solid hsla(0,0%,100%,.2);border-top:4px solid hsla(0,0%,100%,.2);font-size:10px;position:absolute;text-indent:-9999em;-webkit-transform:translateZ(0);transform:translateZ(0)}.component-gif-slide .loader,.component-gif-slide .loader:after{border-radius:50%;height:40px;width:40px}@-webkit-keyframes spinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.desktop .component-gif-slide{cursor:pointer}.desktop .component-gif-slide.active{cursor:url(\"data:image/vnd.microsoft.icon;base64,AAACAAEAICACAAcABQAwAQAAFgAAACgAAAAgAAAAQAAAAAEAAQAAAAAAAAEAAAAAAAAAAAAAAgAAAAAAAAAAAAAA////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8AAAA/AAAAfwAAAP+AAAH/gAAB/8AAA//AAAd/wAAGf+AAAH9gAADbYAAA2yAAAZsAAAGbAAAAGAAAAAAAAA//////////////////////////////////////////////////////////////////////////////////////gH///4B///8Af//+AD///AA///wAH//4AB//8AAf//AAD//5AA///gAP//4AD//8AF///AB///5A////5///8=\"),all-scroll;cursor:-webkit-grab;cursor:-ms-grab;cursor:grab;opacity:1}.desktop .component-gif-slide.active:active{cursor:url(\"data:image/vnd.microsoft.icon;base64,AAACAAEAICACAAcABQAwAQAAFgAAACgAAAAgAAAAQAAAAAEAAQAAAAAAAAEAAAAAAAAAAAAAAgAAAAAAAAAAAAAA////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8AAAA/AAAAfwAAAP+AAAH/gAAB/8AAAH/AAAB/wAAA/0AAANsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//////////////////////////////////////////////////////////////////////////////////////gH///4B///8Af//+AD///AA///wAH//+AB///wAf//4AH//+AD///yT/////////////////////////////8=\"),all-scroll;cursor:-webkit-grabbing!important;cursor:-ms-grabbing!important;cursor:grabbing!important}.component-emoji-rotator{height:100%;left:0;position:absolute;top:0;width:100%}.component-landing-slide{-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;opacity:.3;position:absolute;width:100%}@media (min-width:768px){.component-landing-slide{width:400px}}.component-landing-slide.active{opacity:1}.component-landing-slide .title-wrapper{background-color:#000;position:absolute;text-align:center}@media (min-width:768px){.component-landing-slide .title-wrapper{width:350px}}.component-landing-slide .title-wrapper .title{color:#fff;display:inline-block;font-size:24px}.component-landing-slide .title-wrapper .title .t1,.component-landing-slide .title-wrapper .title .t2{float:left;width:100%}@media (min-width:768px){.component-landing-slide .title-wrapper .title .t1,.component-landing-slide .title-wrapper .title .t2{width:auto}}.component-landing-slide .title-wrapper .title .t1{font-size:34px}.component-landing-slide .title-wrapper .title .t2{font-size:33px;margin-top:10px}@media (min-width:768px){.component-landing-slide .title-wrapper .title .t2{margin-top:0}}.component-landing-slide .title-wrapper .title span{display:inline-block;margin:0 5px;position:relative}@media (min-width:768px){.component-landing-slide .title-wrapper .title span{margin:0 10px}}.component-landing-slide .title-wrapper .title span.ball{-webkit-animation:move-ball 2s infinite linear;animation:move-ball 2s infinite linear;font-size:16px;margin:0 -2px}@media (min-width:768px){.component-landing-slide .title-wrapper .title span.ball{margin:0 -5px;font-size:32px}}.component-landing-slide .title-wrapper .description-wrapper{color:#fff;float:left;font-size:14px;width:100%}@media (min-width:768px){.component-landing-slide .title-wrapper .description-wrapper{padding:20px}}.large-header .component-landing-slide{cursor:pointer}@media (min-width:768px){.large-header .component-landing-slide{width:100%}}.description{display:inline-block;max-width:300px}.description .l1{line-height:1.3em}.description .l1,.description .l2{width:100%}.description .l2{margin-top:20px}.desktop .large-header .component-landing-slide{cursor:pointer}@-webkit-keyframes move-ball{0%{-webkit-transform:translate(0);transform:translate(0)}50%{-webkit-transform:translateY(-15px);transform:translateY(-15px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes move-ball{0%{-webkit-transform:translate(0);transform:translate(0)}50%{-webkit-transform:translateY(-15px);transform:translateY(-15px)}to{-webkit-transform:translate(0);transform:translate(0)}}.firefox .component-landing-slide{background-color:#000;background-image:url(\"/assets/images/tile-bg.png\");background-size:250px 76px}.component-credits-slide{-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;background-color:#000;height:100%;opacity:.3;position:absolute;width:100%}.component-credits-slide.active{opacity:1}.component-credits-slide .text{color:#fff;display:inline-block;max-width:250px;padding:20px;text-align:center;width:100%}.component-credits-slide .credits{color:#999;float:left;font-size:10px;line-height:10px;margin-top:40px;padding:20px;text-align:center;width:100%}.desktop .component-credits-slide{cursor:pointer}.desktop .component-credits-slide.active{cursor:url(\"data:image/vnd.microsoft.icon;base64,AAACAAEAICACAAcABQAwAQAAFgAAACgAAAAgAAAAQAAAAAEAAQAAAAAAAAEAAAAAAAAAAAAAAgAAAAAAAAAAAAAA////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8AAAA/AAAAfwAAAP+AAAH/gAAB/8AAA//AAAd/wAAGf+AAAH9gAADbYAAA2yAAAZsAAAGbAAAAGAAAAAAAAA//////////////////////////////////////////////////////////////////////////////////////gH///4B///8Af//+AD///AA///wAH//4AB//8AAf//AAD//5AA///gAP//4AD//8AF///AB///5A////5///8=\"),all-scroll;cursor:-webkit-grab;cursor:-ms-grab;cursor:grab;opacity:1}.desktop .component-credits-slide.active:active{cursor:url(\"data:image/vnd.microsoft.icon;base64,AAACAAEAICACAAcABQAwAQAAFgAAACgAAAAgAAAAQAAAAAEAAQAAAAAAAAEAAAAAAAAAAAAAAgAAAAAAAAAAAAAA////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8AAAA/AAAAfwAAAP+AAAH/gAAB/8AAAH/AAAB/wAAA/0AAANsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//////////////////////////////////////////////////////////////////////////////////////gH///4B///8Af//+AD///AA///wAH//+AB///wAf//4AH//+AD///yT/////////////////////////////8=\"),all-scroll;cursor:-webkit-grabbing!important;cursor:-ms-grabbing!important;cursor:grabbing!important}", ""]);
	
	// exports


/***/ },
/* 158 */
/*!**************************************!*\
  !*** ./~/css-loader/lib/css-base.js ***!
  \**************************************/
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 159 */
/*!********************************!*\
  !*** ./~/earcut/src/earcut.js ***!
  \********************************/
/***/ function(module, exports) {

	'use strict';
	
	module.exports = earcut;
	
	function earcut(data, holeIndices, dim) {
	
	    dim = dim || 2;
	
	    var hasHoles = holeIndices && holeIndices.length,
	        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
	        outerNode = linkedList(data, 0, outerLen, dim, true),
	        triangles = [];
	
	    if (!outerNode) return triangles;
	
	    var minX, minY, maxX, maxY, x, y, size;
	
	    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
	
	    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	    if (data.length > 80 * dim) {
	        minX = maxX = data[0];
	        minY = maxY = data[1];
	
	        for (var i = dim; i < outerLen; i += dim) {
	            x = data[i];
	            y = data[i + 1];
	            if (x < minX) minX = x;
	            if (y < minY) minY = y;
	            if (x > maxX) maxX = x;
	            if (y > maxY) maxY = y;
	        }
	
	        // minX, minY and size are later used to transform coords into integers for z-order calculation
	        size = Math.max(maxX - minX, maxY - minY);
	    }
	
	    earcutLinked(outerNode, triangles, dim, minX, minY, size);
	
	    return triangles;
	}
	
	// create a circular doubly linked list from polygon points in the specified winding order
	function linkedList(data, start, end, dim, clockwise) {
	    var i, last;
	
	    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
	        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
	    } else {
	        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
	    }
	
	    if (last && equals(last, last.next)) {
	        removeNode(last);
	        last = last.next;
	    }
	
	    return last;
	}
	
	// eliminate colinear or duplicate points
	function filterPoints(start, end) {
	    if (!start) return start;
	    if (!end) end = start;
	
	    var p = start,
	        again;
	    do {
	        again = false;
	
	        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	            removeNode(p);
	            p = end = p.prev;
	            if (p === p.next) return null;
	            again = true;
	
	        } else {
	            p = p.next;
	        }
	    } while (again || p !== end);
	
	    return end;
	}
	
	// main ear slicing loop which triangulates a polygon (given as a linked list)
	function earcutLinked(ear, triangles, dim, minX, minY, size, pass) {
	    if (!ear) return;
	
	    // interlink polygon nodes in z-order
	    if (!pass && size) indexCurve(ear, minX, minY, size);
	
	    var stop = ear,
	        prev, next;
	
	    // iterate through ears, slicing them one by one
	    while (ear.prev !== ear.next) {
	        prev = ear.prev;
	        next = ear.next;
	
	        if (size ? isEarHashed(ear, minX, minY, size) : isEar(ear)) {
	            // cut off the triangle
	            triangles.push(prev.i / dim);
	            triangles.push(ear.i / dim);
	            triangles.push(next.i / dim);
	
	            removeNode(ear);
	
	            // skipping the next vertice leads to less sliver triangles
	            ear = next.next;
	            stop = next.next;
	
	            continue;
	        }
	
	        ear = next;
	
	        // if we looped through the whole remaining polygon and can't find any more ears
	        if (ear === stop) {
	            // try filtering points and slicing again
	            if (!pass) {
	                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, size, 1);
	
	            // if this didn't work, try curing all small self-intersections locally
	            } else if (pass === 1) {
	                ear = cureLocalIntersections(ear, triangles, dim);
	                earcutLinked(ear, triangles, dim, minX, minY, size, 2);
	
	            // as a last resort, try splitting the remaining polygon into two
	            } else if (pass === 2) {
	                splitEarcut(ear, triangles, dim, minX, minY, size);
	            }
	
	            break;
	        }
	    }
	}
	
	// check whether a polygon node forms a valid ear with adjacent nodes
	function isEar(ear) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // now make sure we don't have other points inside the potential ear
	    var p = ear.next.next;
	
	    while (p !== ear.prev) {
	        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.next;
	    }
	
	    return true;
	}
	
	function isEarHashed(ear, minX, minY, size) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // triangle bbox; min & max are calculated like this for speed
	    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
	        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
	        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
	        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);
	
	    // z-order range for the current triangle bbox;
	    var minZ = zOrder(minTX, minTY, minX, minY, size),
	        maxZ = zOrder(maxTX, maxTY, minX, minY, size);
	
	    // first look for points inside the triangle in increasing z-order
	    var p = ear.nextZ;
	
	    while (p && p.z <= maxZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.nextZ;
	    }
	
	    // then look for points in decreasing z-order
	    p = ear.prevZ;
	
	    while (p && p.z >= minZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	    }
	
	    return true;
	}
	
	// go through all polygon nodes and cure small local self-intersections
	function cureLocalIntersections(start, triangles, dim) {
	    var p = start;
	    do {
	        var a = p.prev,
	            b = p.next.next;
	
	        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
	
	            triangles.push(a.i / dim);
	            triangles.push(p.i / dim);
	            triangles.push(b.i / dim);
	
	            // remove two nodes involved
	            removeNode(p);
	            removeNode(p.next);
	
	            p = start = b;
	        }
	        p = p.next;
	    } while (p !== start);
	
	    return p;
	}
	
	// try splitting polygon into two and triangulate them independently
	function splitEarcut(start, triangles, dim, minX, minY, size) {
	    // look for a valid diagonal that divides the polygon into two
	    var a = start;
	    do {
	        var b = a.next.next;
	        while (b !== a.prev) {
	            if (a.i !== b.i && isValidDiagonal(a, b)) {
	                // split the polygon in two by the diagonal
	                var c = splitPolygon(a, b);
	
	                // filter colinear points around the cuts
	                a = filterPoints(a, a.next);
	                c = filterPoints(c, c.next);
	
	                // run earcut on each half
	                earcutLinked(a, triangles, dim, minX, minY, size);
	                earcutLinked(c, triangles, dim, minX, minY, size);
	                return;
	            }
	            b = b.next;
	        }
	        a = a.next;
	    } while (a !== start);
	}
	
	// link every hole into the outer loop, producing a single-ring polygon without holes
	function eliminateHoles(data, holeIndices, outerNode, dim) {
	    var queue = [],
	        i, len, start, end, list;
	
	    for (i = 0, len = holeIndices.length; i < len; i++) {
	        start = holeIndices[i] * dim;
	        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	        list = linkedList(data, start, end, dim, false);
	        if (list === list.next) list.steiner = true;
	        queue.push(getLeftmost(list));
	    }
	
	    queue.sort(compareX);
	
	    // process holes from left to right
	    for (i = 0; i < queue.length; i++) {
	        eliminateHole(queue[i], outerNode);
	        outerNode = filterPoints(outerNode, outerNode.next);
	    }
	
	    return outerNode;
	}
	
	function compareX(a, b) {
	    return a.x - b.x;
	}
	
	// find a bridge between vertices that connects hole with an outer ring and and link it
	function eliminateHole(hole, outerNode) {
	    outerNode = findHoleBridge(hole, outerNode);
	    if (outerNode) {
	        var b = splitPolygon(outerNode, hole);
	        filterPoints(b, b.next);
	    }
	}
	
	// David Eberly's algorithm for finding a bridge between hole and outer polygon
	function findHoleBridge(hole, outerNode) {
	    var p = outerNode,
	        hx = hole.x,
	        hy = hole.y,
	        qx = -Infinity,
	        m;
	
	    // find a segment intersected by a ray from the hole's leftmost point to the left;
	    // segment's endpoint with lesser x will be potential connection point
	    do {
	        if (hy <= p.y && hy >= p.next.y) {
	            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	            if (x <= hx && x > qx) {
	                qx = x;
	                if (x === hx) {
	                    if (hy === p.y) return p;
	                    if (hy === p.next.y) return p.next;
	                }
	                m = p.x < p.next.x ? p : p.next;
	            }
	        }
	        p = p.next;
	    } while (p !== outerNode);
	
	    if (!m) return null;
	
	    if (hx === qx) return m.prev; // hole touches outer segment; pick lower endpoint
	
	    // look for points inside the triangle of hole point, segment intersection and endpoint;
	    // if there are no points found, we have a valid connection;
	    // otherwise choose the point of the minimum angle with the ray as connection point
	
	    var stop = m,
	        mx = m.x,
	        my = m.y,
	        tanMin = Infinity,
	        tan;
	
	    p = m.next;
	
	    while (p !== stop) {
	        if (hx >= p.x && p.x >= mx &&
	                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
	
	            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
	
	            if ((tan < tanMin || (tan === tanMin && p.x > m.x)) && locallyInside(p, hole)) {
	                m = p;
	                tanMin = tan;
	            }
	        }
	
	        p = p.next;
	    }
	
	    return m;
	}
	
	// interlink polygon nodes in z-order
	function indexCurve(start, minX, minY, size) {
	    var p = start;
	    do {
	        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, size);
	        p.prevZ = p.prev;
	        p.nextZ = p.next;
	        p = p.next;
	    } while (p !== start);
	
	    p.prevZ.nextZ = null;
	    p.prevZ = null;
	
	    sortLinked(p);
	}
	
	// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	function sortLinked(list) {
	    var i, p, q, e, tail, numMerges, pSize, qSize,
	        inSize = 1;
	
	    do {
	        p = list;
	        list = null;
	        tail = null;
	        numMerges = 0;
	
	        while (p) {
	            numMerges++;
	            q = p;
	            pSize = 0;
	            for (i = 0; i < inSize; i++) {
	                pSize++;
	                q = q.nextZ;
	                if (!q) break;
	            }
	
	            qSize = inSize;
	
	            while (pSize > 0 || (qSize > 0 && q)) {
	
	                if (pSize === 0) {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                } else if (qSize === 0 || !q) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else if (p.z <= q.z) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                }
	
	                if (tail) tail.nextZ = e;
	                else list = e;
	
	                e.prevZ = tail;
	                tail = e;
	            }
	
	            p = q;
	        }
	
	        tail.nextZ = null;
	        inSize *= 2;
	
	    } while (numMerges > 1);
	
	    return list;
	}
	
	// z-order of a point given coords and size of the data bounding box
	function zOrder(x, y, minX, minY, size) {
	    // coords are transformed into non-negative 15-bit integer range
	    x = 32767 * (x - minX) / size;
	    y = 32767 * (y - minY) / size;
	
	    x = (x | (x << 8)) & 0x00FF00FF;
	    x = (x | (x << 4)) & 0x0F0F0F0F;
	    x = (x | (x << 2)) & 0x33333333;
	    x = (x | (x << 1)) & 0x55555555;
	
	    y = (y | (y << 8)) & 0x00FF00FF;
	    y = (y | (y << 4)) & 0x0F0F0F0F;
	    y = (y | (y << 2)) & 0x33333333;
	    y = (y | (y << 1)) & 0x55555555;
	
	    return x | (y << 1);
	}
	
	// find the leftmost node of a polygon ring
	function getLeftmost(start) {
	    var p = start,
	        leftmost = start;
	    do {
	        if (p.x < leftmost.x) leftmost = p;
	        p = p.next;
	    } while (p !== start);
	
	    return leftmost;
	}
	
	// check if a point lies within a convex triangle
	function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
	           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
	           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	}
	
	// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	function isValidDiagonal(a, b) {
	    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) &&
	           locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b);
	}
	
	// signed area of a triangle
	function area(p, q, r) {
	    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	}
	
	// check if two points are equal
	function equals(p1, p2) {
	    return p1.x === p2.x && p1.y === p2.y;
	}
	
	// check if two segments intersect
	function intersects(p1, q1, p2, q2) {
	    if ((equals(p1, q1) && equals(p2, q2)) ||
	        (equals(p1, q2) && equals(p2, q1))) return true;
	    return area(p1, q1, p2) > 0 !== area(p1, q1, q2) > 0 &&
	           area(p2, q2, p1) > 0 !== area(p2, q2, q1) > 0;
	}
	
	// check if a polygon diagonal intersects any polygon segments
	function intersectsPolygon(a, b) {
	    var p = a;
	    do {
	        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
	                intersects(p, p.next, a, b)) return true;
	        p = p.next;
	    } while (p !== a);
	
	    return false;
	}
	
	// check if a polygon diagonal is locally inside the polygon
	function locallyInside(a, b) {
	    return area(a.prev, a, a.next) < 0 ?
	        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
	        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	}
	
	// check if the middle point of a polygon diagonal is inside the polygon
	function middleInside(a, b) {
	    var p = a,
	        inside = false,
	        px = (a.x + b.x) / 2,
	        py = (a.y + b.y) / 2;
	    do {
	        if (((p.y > py) !== (p.next.y > py)) && (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
	            inside = !inside;
	        p = p.next;
	    } while (p !== a);
	
	    return inside;
	}
	
	// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	function splitPolygon(a, b) {
	    var a2 = new Node(a.i, a.x, a.y),
	        b2 = new Node(b.i, b.x, b.y),
	        an = a.next,
	        bp = b.prev;
	
	    a.next = b;
	    b.prev = a;
	
	    a2.next = an;
	    an.prev = a2;
	
	    b2.next = a2;
	    a2.prev = b2;
	
	    bp.next = b2;
	    b2.prev = bp;
	
	    return b2;
	}
	
	// create a node and optionally link it with previous one (in a circular doubly linked list)
	function insertNode(i, x, y, last) {
	    var p = new Node(i, x, y);
	
	    if (!last) {
	        p.prev = p;
	        p.next = p;
	
	    } else {
	        p.next = last.next;
	        p.prev = last;
	        last.next.prev = p;
	        last.next = p;
	    }
	    return p;
	}
	
	function removeNode(p) {
	    p.next.prev = p.prev;
	    p.prev.next = p.next;
	
	    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
	}
	
	function Node(i, x, y) {
	    // vertice index in coordinates array
	    this.i = i;
	
	    // vertex coordinates
	    this.x = x;
	    this.y = y;
	
	    // previous and next vertice nodes in a polygon ring
	    this.prev = null;
	    this.next = null;
	
	    // z-order curve value
	    this.z = null;
	
	    // previous and next nodes in z-order
	    this.prevZ = null;
	    this.nextZ = null;
	
	    // indicates whether this is a steiner point
	    this.steiner = false;
	}
	
	// return a percentage difference between the polygon area and its triangulation area;
	// used to verify correctness of triangulation
	earcut.deviation = function (data, holeIndices, dim, triangles) {
	    var hasHoles = holeIndices && holeIndices.length;
	    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
	
	    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	    if (hasHoles) {
	        for (var i = 0, len = holeIndices.length; i < len; i++) {
	            var start = holeIndices[i] * dim;
	            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	            polygonArea -= Math.abs(signedArea(data, start, end, dim));
	        }
	    }
	
	    var trianglesArea = 0;
	    for (i = 0; i < triangles.length; i += 3) {
	        var a = triangles[i] * dim;
	        var b = triangles[i + 1] * dim;
	        var c = triangles[i + 2] * dim;
	        trianglesArea += Math.abs(
	            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
	            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	    }
	
	    return polygonArea === 0 && trianglesArea === 0 ? 0 :
	        Math.abs((trianglesArea - polygonArea) / polygonArea);
	};
	
	function signedArea(data, start, end, dim) {
	    var sum = 0;
	    for (var i = start, j = end - dim; i < end; i += dim) {
	        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	        j = i;
	    }
	    return sum;
	}
	
	// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
	earcut.flatten = function (data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;
	
	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	    return result;
	};


/***/ },
/* 160 */
/*!********************************!*\
  !*** ./~/fbjs/lib/camelize.js ***!
  \********************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 161 */
/*!*****************************************!*\
  !*** ./~/fbjs/lib/camelizeStyleName.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(/*! ./camelize */ 160);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 162 */
/*!********************************************!*\
  !*** ./~/fbjs/lib/createArrayFromMixed.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(/*! ./toArray */ 171);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 163 */
/*!*********************************************!*\
  !*** ./~/fbjs/lib/createNodesFromMarkup.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(/*! ./ExecutionEnvironment */ 8);
	
	var createArrayFromMixed = __webpack_require__(/*! ./createArrayFromMixed */ 162);
	var getMarkupWrap = __webpack_require__(/*! ./getMarkupWrap */ 90);
	var invariant = __webpack_require__(/*! ./invariant */ 2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 164 */
/*!**************************************************!*\
  !*** ./~/fbjs/lib/getUnboundedScrollPosition.js ***!
  \**************************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 165 */
/*!*********************************!*\
  !*** ./~/fbjs/lib/hyphenate.js ***!
  \*********************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 166 */
/*!******************************************!*\
  !*** ./~/fbjs/lib/hyphenateStyleName.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(/*! ./hyphenate */ 165);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 167 */
/*!******************************!*\
  !*** ./~/fbjs/lib/isNode.js ***!
  \******************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 168 */
/*!**********************************!*\
  !*** ./~/fbjs/lib/isTextNode.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(/*! ./isNode */ 167);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 169 */
/*!*********************************!*\
  !*** ./~/fbjs/lib/mapObject.js ***!
  \*********************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 170 */
/*!*****************************************!*\
  !*** ./~/fbjs/lib/memoizeStringOnly.js ***!
  \*****************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 171 */
/*!*******************************!*\
  !*** ./~/fbjs/lib/toArray.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(/*! ./invariant */ 2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ },
/* 172 */
/*!******************************************!*\
  !*** ./~/mobile-detect/mobile-detect.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS GENERATED - DO NOT EDIT!
	/*global module:false, define:false*/
	
	(function (define, undefined) {
	define(function () {
	    'use strict';
	
	    var impl = {};
	
	    impl.mobileDetectRules = {
	    "phones": {
	        "iPhone": "\\biPhone\\b|\\biPod\\b",
	        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
	        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m",
	        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
	        "Dell": "Dell.*Streak|Dell.*Aero|Dell.*Venue|DELL.*Venue Pro|Dell Flash|Dell Smoke|Dell Mini 3iX|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
	        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b",
	        "Samsung": "Samsung|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350",
	        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323)",
	        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
	        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
	        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
	        "Palm": "PalmSource|Palm",
	        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
	        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
	        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
	        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
	        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
	        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
	        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
	        "Alcatel": "Alcatel",
	        "Nintendo": "Nintendo 3DS",
	        "Amoi": "Amoi",
	        "INQ": "INQ",
	        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
	    },
	    "tablets": {
	        "iPad": "iPad|iPad.*Mobile",
	        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
	        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561",
	        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI)\\b",
	        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
	        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
	        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K017 |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C",
	        "BlackBerryTablet": "PlayBook|RIM Tablet",
	        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
	        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
	        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
	        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b",
	        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
	        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
	        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
	        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
	        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)",
	        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
	        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
	        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
	        "ArnovaTablet": "AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
	        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
	        "IRUTablet": "M702pro",
	        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
	        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
	        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
	        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
	        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
	        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP612|SOT31",
	        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
	        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
	        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
	        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
	        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
	        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
	        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
	        "FlyTablet": "IQ310|Fly Vision",
	        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris E10)|Maxwell.*Lite|Maxwell.*Plus",
	        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim",
	        "NecTablet": "\\bN-06D|\\bN-08D",
	        "PantechTablet": "Pantech.*P4100",
	        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
	        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
	        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
	        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
	        "NabiTablet": "Android.*\\bNabi",
	        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
	        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
	        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
	        "PlaystationTablet": "Playstation.*(Portable|Vita)",
	        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
	        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
	        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
	        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
	        "GalapadTablet": "Android.*\\bG1\\b",
	        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
	        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
	        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
	        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
	        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
	        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
	        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
	        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
	        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)",
	        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
	        "DPSTablet": "DPS Dream 9|DPS Dual 7",
	        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
	        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
	        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
	        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
	        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
	        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
	        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
	        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
	        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
	        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7",
	        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
	        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
	        "iMobileTablet": "i-mobile i-note",
	        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
	        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
	        "AMPETablet": "Android.* A78 ",
	        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
	        "TecnoTablet": "TECNO P9",
	        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
	        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
	        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
	        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
	        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
	        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
	        "CaptivaTablet": "CAPTIVA PAD",
	        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
	        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
	        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+",
	        "JaytechTablet": "TPC-PA762",
	        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
	        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
	        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
	        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
	        "AocTablet": "MW0811|MW0812|MW0922|MTK8382",
	        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
	        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
	        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
	        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
	        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
	        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
	        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
	        "UbislateTablet": "UbiSlate[\\s]?7C",
	        "PocketBookTablet": "Pocketbook",
	        "Hudl": "Hudl HT7S3|Hudl 2",
	        "TelstraTablet": "T-Hub2",
	        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bJolla\\b|\\bTP750\\b"
	    },
	    "oss": {
	        "AndroidOS": "Android",
	        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
	        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
	        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
	        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
	        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
	        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad",
	        "MeeGoOS": "MeeGo",
	        "MaemoOS": "Maemo",
	        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
	        "webOS": "webOS|hpwOS",
	        "badaOS": "\\bBada\\b",
	        "BREWOS": "BREW"
	    },
	    "uas": {
	        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
	        "Dolfin": "\\bDolfin\\b",
	        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+|Coast\/[0-9.]+",
	        "Skyfire": "Skyfire",
	        "IE": "IEMobile|MSIEMobile",
	        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile",
	        "Bolt": "bolt",
	        "TeaShark": "teashark",
	        "Blazer": "Blazer",
	        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
	        "Tizen": "Tizen",
	        "UCBrowser": "UC.*Browser|UCWEB",
	        "baiduboxapp": "baiduboxapp",
	        "baidubrowser": "baidubrowser",
	        "DiigoBrowser": "DiigoBrowser",
	        "Puffin": "Puffin",
	        "Mercury": "\\bMercury\\b",
	        "ObigoBrowser": "Obigo",
	        "NetFront": "NF-Browser",
	        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger"
	    },
	    "props": {
	        "Mobile": "Mobile\/[VER]",
	        "Build": "Build\/[VER]",
	        "Version": "Version\/[VER]",
	        "VendorID": "VendorID\/[VER]",
	        "iPad": "iPad.*CPU[a-z ]+[VER]",
	        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
	        "iPod": "iPod.*CPU[a-z ]+[VER]",
	        "Kindle": "Kindle\/[VER]",
	        "Chrome": [
	            "Chrome\/[VER]",
	            "CriOS\/[VER]",
	            "CrMo\/[VER]"
	        ],
	        "Coast": [
	            "Coast\/[VER]"
	        ],
	        "Dolfin": "Dolfin\/[VER]",
	        "Firefox": "Firefox\/[VER]",
	        "Fennec": "Fennec\/[VER]",
	        "IE": [
	            "IEMobile\/[VER];",
	            "IEMobile [VER]",
	            "MSIE [VER];",
	            "Trident\/[0-9.]+;.*rv:[VER]"
	        ],
	        "NetFront": "NetFront\/[VER]",
	        "NokiaBrowser": "NokiaBrowser\/[VER]",
	        "Opera": [
	            " OPR\/[VER]",
	            "Opera Mini\/[VER]",
	            "Version\/[VER]"
	        ],
	        "Opera Mini": "Opera Mini\/[VER]",
	        "Opera Mobi": "Version\/[VER]",
	        "UC Browser": "UC Browser[VER]",
	        "MQQBrowser": "MQQBrowser\/[VER]",
	        "MicroMessenger": "MicroMessenger\/[VER]",
	        "baiduboxapp": "baiduboxapp\/[VER]",
	        "baidubrowser": "baidubrowser\/[VER]",
	        "Iron": "Iron\/[VER]",
	        "Safari": [
	            "Version\/[VER]",
	            "Safari\/[VER]"
	        ],
	        "Skyfire": "Skyfire\/[VER]",
	        "Tizen": "Tizen\/[VER]",
	        "Webkit": "webkit[ \/][VER]",
	        "Gecko": "Gecko\/[VER]",
	        "Trident": "Trident\/[VER]",
	        "Presto": "Presto\/[VER]",
	        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
	        "Android": "Android [VER]",
	        "BlackBerry": [
	            "BlackBerry[\\w]+\/[VER]",
	            "BlackBerry.*Version\/[VER]",
	            "Version\/[VER]"
	        ],
	        "BREW": "BREW [VER]",
	        "Java": "Java\/[VER]",
	        "Windows Phone OS": [
	            "Windows Phone OS [VER]",
	            "Windows Phone [VER]"
	        ],
	        "Windows Phone": "Windows Phone [VER]",
	        "Windows CE": "Windows CE\/[VER]",
	        "Windows NT": "Windows NT [VER]",
	        "Symbian": [
	            "SymbianOS\/[VER]",
	            "Symbian\/[VER]"
	        ],
	        "webOS": [
	            "webOS\/[VER]",
	            "hpwOS\/[VER];"
	        ]
	    },
	    "utils": {
	        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
	        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
	        "DesktopMode": "WPDesktop",
	        "TV": "SonyDTV|HbbTV",
	        "WebKit": "(webkit)[ \/]([\\w.]+)",
	        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|PLAYSTATION|Xbox)\\b",
	        "Watch": "SM-V700"
	    }
	};
	
	    // following patterns come from http://detectmobilebrowsers.com/
	    impl.detectMobileBrowsers = {
	        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
	        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        tabletPattern: /android|ipad|playbook|silk/i
	    };
	
	    var hasOwnProp = Object.prototype.hasOwnProperty,
	        isArray;
	
	    impl.FALLBACK_PHONE = 'UnknownPhone';
	    impl.FALLBACK_TABLET = 'UnknownTablet';
	    impl.FALLBACK_MOBILE = 'UnknownMobile';
	
	    isArray = ('isArray' in Array) ?
	        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };
	
	    function equalIC(a, b) {
	        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
	    }
	
	    function containsIC(array, value) {
	        var valueLC, i, len = array.length;
	        if (!len || !value) {
	            return false;
	        }
	        valueLC = value.toLowerCase();
	        for (i = 0; i < len; ++i) {
	            if (valueLC === array[i].toLowerCase()) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function convertPropsToRegExp(object) {
	        for (var key in object) {
	            if (hasOwnProp.call(object, key)) {
	                object[key] = new RegExp(object[key], 'i');
	            }
	        }
	    }
	
	    (function init() {
	        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
	        for (key in mobileDetectRules.props) {
	            if (hasOwnProp.call(mobileDetectRules.props, key)) {
	                values = mobileDetectRules.props[key];
	                if (!isArray(values)) {
	                    values = [values];
	                }
	                len = values.length;
	                for (i = 0; i < len; ++i) {
	                    value = values[i];
	                    verPos = value.indexOf('[VER]');
	                    if (verPos >= 0) {
	                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
	                    }
	                    values[i] = new RegExp(value, 'i');
	                }
	                mobileDetectRules.props[key] = values;
	            }
	        }
	        convertPropsToRegExp(mobileDetectRules.oss);
	        convertPropsToRegExp(mobileDetectRules.phones);
	        convertPropsToRegExp(mobileDetectRules.tablets);
	        convertPropsToRegExp(mobileDetectRules.uas);
	        convertPropsToRegExp(mobileDetectRules.utils);
	
	        // copy some patterns to oss0 which are tested first (see issue#15)
	        mobileDetectRules.oss0 = {
	            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
	            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
	        };
	    }());
	
	    /**
	     * Test userAgent string against a set of rules and find the first matched key.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
	     * @private
	     */
	    impl.findMatch = function(rules, userAgent) {
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    return key;
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Test userAgent string against a set of rules and return an array of matched keys.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
	     * @private
	     */
	    impl.findMatches = function(rules, userAgent) {
	        var result = [];
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    result.push(key);
	                }
	            }
	        }
	        return result;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {String} version or <tt>null</tt> if version not found
	     * @private
	     */
	    impl.getVersionStr = function (propertyName, userAgent) {
	        var props = impl.mobileDetectRules.props, patterns, i, len, match;
	        if (hasOwnProp.call(props, propertyName)) {
	            patterns = props[propertyName];
	            len = patterns.length;
	            for (i = 0; i < len; ++i) {
	                match = patterns[i].exec(userAgent);
	                if (match !== null) {
	                    return match[1];
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {Number} version or <tt>NaN</tt> if version not found
	     * @private
	     */
	    impl.getVersion = function (propertyName, userAgent) {
	        var version = impl.getVersionStr(propertyName, userAgent);
	        return version ? impl.prepareVersionNo(version) : NaN;
	    };
	
	    /**
	     * Prepare the version number.
	     *
	     * @param {String} version
	     * @return {Number} the version number as a floating number
	     * @private
	     */
	    impl.prepareVersionNo = function (version) {
	        var numbers;
	
	        numbers = version.split(/[a-z._ \/\-]/i);
	        if (numbers.length === 1) {
	            version = numbers[0];
	        }
	        if (numbers.length > 1) {
	            version = numbers[0] + '.';
	            numbers.shift();
	            version += numbers.join('');
	        }
	        return Number(version);
	    };
	
	    impl.isMobileFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
	            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
	    };
	
	    impl.isTabletFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
	    };
	
	    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
	        if (cache.mobile !== undefined) {
	            return;
	        }
	        var phone, tablet, phoneSized;
	
	        // first check for stronger tablet rules, then phone (see issue#5)
	        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
	        if (tablet) {
	            cache.mobile = cache.tablet = tablet;
	            cache.phone = null;
	            return; // unambiguously identified as tablet
	        }
	
	        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
	        if (phone) {
	            cache.mobile = cache.phone = phone;
	            cache.tablet = null;
	            return; // unambiguously identified as phone
	        }
	
	        // our rules haven't found a match -> try more general fallback rules
	        if (impl.isMobileFallback(userAgent)) {
	            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
	            if (phoneSized === undefined) {
	                cache.mobile = impl.FALLBACK_MOBILE;
	                cache.tablet = cache.phone = null;
	            } else if (phoneSized) {
	                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
	                cache.tablet = null;
	            } else {
	                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	                cache.phone = null;
	            }
	        } else if (impl.isTabletFallback(userAgent)) {
	            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	            cache.phone = null;
	        } else {
	            // not mobile at all!
	            cache.mobile = cache.tablet = cache.phone = null;
	        }
	    };
	
	    // t is a reference to a MobileDetect instance
	    impl.mobileGrade = function (t) {
	        // impl note:
	        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
	        // When changes are made in Mobile_Detect.php, copy this method and replace:
	        //     $this-> / t.
	        //     self::MOBILE_GRADE_(.) / '$1'
	        //     , self::VERSION_TYPE_FLOAT / (nothing)
	        //     isIOS() / os('iOS')
	        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
	        var $isMobile = t.mobile() !== null;
	
	        if (
	            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
	            t.os('iOS') && t.version('iPad')>=4.3 ||
	            t.os('iOS') && t.version('iPhone')>=3.1 ||
	            t.os('iOS') && t.version('iPod')>=3.1 ||
	
	            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
	            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
	            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
	            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
	            ( t.version('Android')>2.1 && t.is('Webkit') ) ||
	
	            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
	            t.version('Windows Phone OS')>=7.0 ||
	
	            // Blackberry 7 - Tested on BlackBerry Torch 9810
	            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
	            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
	            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
	            t.match('Playbook.*Tablet') ||
	
	            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
	            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
	            // Palm WebOS 3.0  - Tested on HP TouchPad
	            t.match('hp.*TouchPad') ||
	
	            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
	            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||
	
	            // Chrome for Android - Tested on Android 4.0, 4.1 device
	            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||
	
	            // Skyfire 4.1 - Tested on Android 2.3 device
	            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||
	
	            // Opera Mobile 11.5-12: Tested on Android 2.3
	            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||
	
	            // Meego 1.2 - Tested on Nokia 950 and N9
	            t.is('MeeGoOS') ||
	
	            // Tizen (pre-release) - Tested on early hardware
	            t.is('Tizen') ||
	
	            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
	            // @todo: more tests here!
	            t.is('Dolfin') && t.version('Bada')>=2.0 ||
	
	            // UC Browser - Tested on Android 2.3 device
	            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||
	
	            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
	            ( t.match('Kindle Fire') ||
	                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||
	
	            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
	            t.is('AndroidOS') && t.is('NookTablet') ||
	
	            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
	            t.version('Chrome')>=11 && !$isMobile ||
	
	            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
	            t.version('Safari')>=5.0 && !$isMobile ||
	
	            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
	            t.version('Firefox')>=4.0 && !$isMobile ||
	
	            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
	            t.version('MSIE')>=7.0 && !$isMobile ||
	
	            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
	            // @reference: http://my.opera.com/community/openweb/idopera/
	            t.version('Opera')>=10 && !$isMobile
	
	            ){
	            return 'A';
	        }
	
	        if (
	            t.os('iOS') && t.version('iPad')<4.3 ||
	            t.os('iOS') && t.version('iPhone')<3.1 ||
	            t.os('iOS') && t.version('iPod')<3.1 ||
	
	            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
	            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||
	
	            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
	            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
	                (t.version('Android')>=2.3 || t.is('iOS')) ) ||
	
	            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
	            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||
	
	            // @todo: report this (tested on Nokia N71)
	            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
	            ){
	            return 'B';
	        }
	
	        if (
	        // Blackberry 4.x - Tested on the Curve 8330
	            t.version('BlackBerry')<5.0 ||
	            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
	            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2
	
	            ){
	            return 'C';
	        }
	
	        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
	        //will receive the basic, C grade experience.
	        return 'C';
	    };
	
	    impl.detectOS = function (ua) {
	        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
	            impl.findMatch(impl.mobileDetectRules.oss, ua);
	    };
	
	    impl.getDeviceSmallerSide = function () {
	        return window.screen.width < window.screen.height ?
	            window.screen.width :
	            window.screen.height;
	    };
	
	    /**
	     * Constructor for MobileDetect object.
	     * <br>
	     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
	     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
	     *     <strong>Find information how to download and install:</strong>
	     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
	     * </div>
	     *
	     * @example <pre>
	     *     var md = new MobileDetect(window.navigator.userAgent);
	     *     if (md.mobile()) {
	     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
	     *     }
	     * </pre>
	     *
	     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
	     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
	     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
	     *        as phone.
	     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
	     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
	     *        for Android</a>.<br>
	     *        If you provide a value < 0, then this "fuzzy" check is disabled.
	     * @constructor
	     * @global
	     */
	    function MobileDetect(userAgent, maxPhoneWidth) {
	        this.ua = userAgent || '';
	        this._cache = {};
	        //600dp is typical 7" tablet minimum width
	        this.maxPhoneWidth = maxPhoneWidth || 600;
	    }
	
	    MobileDetect.prototype = {
	        constructor: MobileDetect,
	
	        /**
	         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
	         * <br>
	         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
	         * <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
	         * @function MobileDetect#mobile
	         */
	        mobile: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.mobile;
	        },
	
	        /**
	         * Returns the detected phone type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
	         * Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley, Wolfgang,
	         * Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
	         * @function MobileDetect#phone
	         */
	        phone: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.phone;
	        },
	
	        /**
	         * Returns the detected tablet type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPad, NexusTablet, SamsungTablet, Kindle, SurfaceTablet, HPTablet, AsusTablet,
	         * BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet, AcerTablet,
	         * ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet, LenovoTablet,
	         * DellTablet, YarvikTablet, MedionTablet, ArnovaTablet, IntensoTablet, IRUTablet,
	         * MegafonTablet, EbodaTablet, AllViewTablet, ArchosTablet, AinolTablet,
	         * SonyTablet, PhilipsTablet, CubeTablet, CobyTablet, MIDTablet, MSITablet,
	         * SMiTTablet, RockChipTablet, FlyTablet, bqTablet, HuaweiTablet, NecTablet,
	         * PantechTablet, BronchoTablet, VersusTablet, ZyncTablet, PositivoTablet,
	         * NabiTablet, KoboTablet, DanewTablet, TexetTablet, PlaystationTablet,
	         * TrekstorTablet, PyleAudioTablet, AdvanTablet, DanyTechTablet, GalapadTablet,
	         * MicromaxTablet, KarbonnTablet, AllFineTablet, PROSCANTablet, YONESTablet,
	         * ChangJiaTablet, GUTablet, PointOfViewTablet, OvermaxTablet, HCLTablet,
	         * DPSTablet, VistureTablet, CrestaTablet, MediatekTablet, ConcordeTablet,
	         * GoCleverTablet, ModecomTablet, VoninoTablet, ECSTablet, StorexTablet,
	         * VodafoneTablet, EssentielBTablet, RossMoorTablet, iMobileTablet, TolinoTablet,
	         * AudioSonicTablet, AMPETablet, SkkTablet, TecnoTablet, JXDTablet, iJoyTablet,
	         * FX2Tablet, XoroTablet, ViewsonicTablet, OdysTablet, CaptivaTablet,
	         * IconbitTablet, TeclastTablet, OndaTablet, JaytechTablet, BlaupunktTablet,
	         * DigmaTablet, EvolioTablet, LavaTablet, AocTablet, MpmanTablet, CelkonTablet,
	         * WolderTablet, MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
	         * PocketBookTablet, Hudl, TelstraTablet, GenericTablet</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
	         * @function MobileDetect#tablet
	         */
	        tablet: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.tablet;
	        },
	
	        /**
	         * Returns the (first) detected user-agent string or <tt>null</tt>.
	         * <br>
	         * The returned user-agent is one of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, IE, Firefox, Bolt, TeaShark, Blazer, Safari,
	         * Tizen, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {String} the key for the detected user-agent or <tt>null</tt>
	         * @function MobileDetect#userAgent
	         */
	        userAgent: function () {
	            if (this._cache.userAgent === undefined) {
	                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgent;
	        },
	
	        /**
	         * Returns all detected user-agent strings.
	         * <br>
	         * The array is empty or contains one or more of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, IE, Firefox, Bolt, TeaShark, Blazer, Safari,
	         * Tizen, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
	         * @function MobileDetect#userAgents
	         */
	        userAgents: function () {
	            if (this._cache.userAgents === undefined) {
	                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgents;
	        },
	
	        /**
	         * Returns the detected operating system string or <tt>null</tt>.
	         * <br>
	         * The operating system is one of following keys:<br>
	         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
	         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
	         *
	         * @returns {String} the key for the detected operating system.
	         * @function MobileDetect#os
	         */
	        os: function () {
	            if (this._cache.os === undefined) {
	                this._cache.os = impl.detectOS(this.ua);
	            }
	            return this._cache.os;
	        },
	
	        /**
	         * Get the version (as Number) of the given property in the User-Agent.
	         * <br>
	         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, IE, NetFront, NokiaBrowser, Opera, Opera Mini, Opera
	         * Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser, Iron,
	         * Safari, Skyfire, Tizen, Webkit, Gecko, Trident, Presto, iOS, Android,
	         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
	         * NT, Symbian, webOS</tt><br>
	         *
	         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
	         *          Be careful when comparing this value with '==' operator!
	         * @function MobileDetect#version
	         */
	        version: function (key) {
	            return impl.getVersion(key, this.ua);
	        },
	
	        /**
	         * Get the version (as String) of the given property in the User-Agent.
	         * <br>
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, IE, NetFront, NokiaBrowser, Opera, Opera Mini, Opera
	         * Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser, Iron,
	         * Safari, Skyfire, Tizen, Webkit, Gecko, Trident, Presto, iOS, Android,
	         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
	         * NT, Symbian, webOS</tt><br>
	         *
	         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
	         *
	         * @function MobileDetect#versionStr
	         */
	        versionStr: function (key) {
	            return impl.getVersionStr(key, this.ua);
	        },
	
	        /**
	         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
	         *
	         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
	         *        tablet family.<br>
	         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
	         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
	         *        Additionally you have following keys:<br>
	         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
	         *
	         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
	         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
	         * @function MobileDetect#is
	         */
	        is: function (key) {
	            return containsIC(this.userAgents(), key) ||
	                   equalIC(key, this.os()) ||
	                   equalIC(key, this.phone()) ||
	                   equalIC(key, this.tablet()) ||
	                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
	        },
	
	        /**
	         * Do a quick test against navigator::userAgent.
	         *
	         * @param {String|RegExp} pattern the pattern, either as String or RegExp
	         *                        (a string will be converted to a case-insensitive RegExp).
	         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
	         * @function MobileDetect#match
	         */
	        match: function (pattern) {
	            if (!(pattern instanceof RegExp)) {
	                pattern = new RegExp(pattern, 'i');
	            }
	            return pattern.test(this.ua);
	        },
	
	        /**
	         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
	         * <br>
	         * Obviously this method makes sense in browser environments only (not for Node.js)!
	         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
	         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
	         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
	         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
	         *          Will always return <code>undefined</code> server-side.
	         */
	        isPhoneSized: function (maxPhoneWidth) {
	            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
	        },
	
	        /**
	         * Returns the mobile grade ('A', 'B', 'C').
	         *
	         * @returns {String} one of the mobile grades ('A', 'B', 'C').
	         * @function MobileDetect#mobileGrade
	         */
	        mobileGrade: function () {
	            if (this._cache.grade === undefined) {
	                this._cache.grade = impl.mobileGrade(this);
	            }
	            return this._cache.grade;
	        }
	    };
	
	    // environment-dependent
	    if (typeof window !== 'undefined' && window.screen) {
	        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
	            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
	        };
	    } else {
	        MobileDetect.isPhoneSized = function () {};
	    }
	
	    // should not be replaced by a completely new object - just overwrite existing methods
	    MobileDetect._impl = impl;
	
	    return MobileDetect;
	}); // end of call of define()
	})((function (undefined) {
	    if (typeof module !== 'undefined' && module.exports) {
	        return function (factory) { module.exports = factory(); };
	    } else if (true) {
	        return __webpack_require__(/*! !webpack amd define */ 319);
	    } else if (typeof window !== 'undefined') {
	        return function (factory) { window.MobileDetect = factory(); };
	    } else {
	        // please file a bug if you get this error!
	        throw new Error('unknown environment');
	    }
	})());

/***/ },
/* 173 */
/*!**********************************!*\
  !*** ./~/object-assign/index.js ***!
  \**********************************/
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 174 */
/*!*************************************************************!*\
  !*** ./~/pixi.js/src/accessibility/AccessibilityManager.js ***!
  \*************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1);
	
	// add some extra variables to the container..
	Object.assign(
	    core.DisplayObject.prototype,
	    __webpack_require__(/*! ./accessibleTarget */ 93)
	);
	
	
	/**
	 * The Accessibility manager reacreates the ability to tab and and have content read by screen readers. This is very important as it can possibly help people with disabilities access pixi content.
	 * Much like interaction any DisplayObject can be made accessible. This manager will map the events as if the mouse was being used, minimizing the efferot required to implement.
	 *
	 * @class
	 * @memberof PIXI
	 * @param renderer {PIXI.CanvasRenderer|PIXI.WebGLRenderer} A reference to the current renderer
	 */
	function AccessibilityManager(renderer)
	{
		// first we create a div that will sit over the pixi element. This is where the div overlays will go.
	    var div = document.createElement('div');
	    
	    div.style.width = 100 + 'px';
	    div.style.height = 100 + 'px';
	    div.style.position = 'absolute';
	    div.style.top = 0;
	    div.style.left = 0;
	   //
	    div.style.zIndex = 2;
	   	
	   	/**
	   	 * This is the dom element that will sit over the pixi element. This is where the div overlays will go.
	   	 * 
	   	 * @type {HTMLElement}
	   	 * @private
	   	 */
	   	this.div = div;
	
	   	/**
	   	 * A simple pool for storing divs.
	   	 * 
	   	 * @type {Array}
	   	 * @private
	   	 */
	 	this.pool = [];
	
	 	/**
	 	 * This is a tick used to check if an object is no longer being rendered.
	 	 * 
	 	 * @type {Number}
	 	 * @private
	 	 */
	   	this.renderId = 0;
	
	   	/**
	   	 * Setting this to true will visually show the divs
	   	 * 
	   	 * @type {Boolean}
	   	 */
	   	this.debug = false;
	
	  	/**
	     * The renderer this accessibility manager works for.
	     *
	     * @member {PIXI.SystemRenderer}
	     */
	   	this.renderer = renderer;
	
	   	/**
	     * The array of currently active accessible items.
	     *
	     * @member {Array}
	     * @private
	     */
	   	this.children = [];
	   	
	   	/**
	     * pre bind the functions..
	     */
	   	this._onKeyDown = this._onKeyDown.bind(this);
	   	this._onMouseMove = this._onMouseMove.bind(this);
	   	
	   	/**
	     * stores the state of the manager. If there are no accessible objects or the mouse is moving the will be false.
	     *
	     * @member {Array}
	     * @private
	     */
	   	this.isActive = false;
	
	
	   	// let listen for tab.. once pressed we can fire up and show the accessibility layer
	   	window.addEventListener('keydown', this._onKeyDown, false);
	}
	
	
	AccessibilityManager.prototype.constructor = AccessibilityManager;
	module.exports = AccessibilityManager;
	
	/**
	 * Activating will cause the Accessibility layer to be shown. This is called when a user preses the tab key
	 * @private
	 */
	AccessibilityManager.prototype.activate = function()
	{
		if(this.isActive)
		{
			return;
		}
	
		this.isActive = true;
	
		window.document.addEventListener('mousemove', this._onMouseMove, true);
		window.removeEventListener('keydown', this._onKeyDown, false);
	
		this.renderer.on('postrender', this.update, this);
	
		this.renderer.view.parentNode.appendChild(this.div);	
	};
	
	/**
	 * Deactivating will cause the Accessibility layer to be hidden. This is called when a user moves the mouse
	 * @private
	 */
	AccessibilityManager.prototype.deactivate = function()
	{
		if(!this.isActive)
		{
			return;
		}
	
		this.isActive = false;
	
		window.document.removeEventListener('mousemove', this._onMouseMove);
		window.addEventListener('keydown', this._onKeyDown, false);
	
		this.renderer.off('postrender', this.update);
	
		this.div.parentNode.removeChild(this.div);
	
	};
	
	/**
	 * This recursive function will run throught he scene graph and add any new accessible objects to the DOM layer.
	 * @param element {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} the DisplayObject to check.
	 * @private
	 */
	AccessibilityManager.prototype.updateAccessibleObjects = function(displayObject)
	{
		if(!displayObject.visible)
		{
			return;
		}
	
		if(displayObject.accessible && displayObject.interactive)
		{
			if(!displayObject._accessibleActive)
			{
				this.addChild(displayObject);
			}
		   	
		   	displayObject.renderId = this.renderId;
		}
	
	
		if(displayObject.interactiveChildren)
		{
	
			var children = displayObject.children;
	
			for (var i = children.length - 1; i >= 0; i--) {
			
				this.updateAccessibleObjects(children[i]);
			}
		}
	};
	
	
	/**
	 * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects
	 * @private
	 */
	AccessibilityManager.prototype.update = function()
	{
	
		// update children...
		this.updateAccessibleObjects(this.renderer._lastObjectRendered);
	
		var rect = this.renderer.view.getBoundingClientRect();
		var sx = rect.width  / this.renderer.width;
		var sy = rect.height / this.renderer.height;
	
		var div = this.div;
	
		div.style.left = rect.left + 'px';
		div.style.top = rect.top + 'px';
		div.style.width = this.renderer.width + 'px';
		div.style.height = this.renderer.height + 'px';
	
		for (var i = 0; i < this.children.length; i++)
		{
	
			var child = this.children[i];
	
			if(child.renderId !== this.renderId)
			{
				child._accessibleActive = false;
	
	            core.utils.removeItems(this.children, i, 1);
				this.div.removeChild( child._accessibleDiv );
				this.pool.push(child._accessibleDiv);
				child._accessibleDiv = null;
	
				i--;
	
				if(this.children.length === 0)
				{
					this.deactivate();
				}
			}
			else
			{
				// map div to display..
				div = child._accessibleDiv;
				var hitArea = child.hitArea;
				var wt = child.worldTransform;
	
				if(child.hitArea)
				{
					div.style.left = ((wt.tx + (hitArea.x * wt.a)) * sx) + 'px';
					div.style.top =  ((wt.ty + (hitArea.y * wt.d)) * sy) +  'px';
	
					div.style.width = (hitArea.width * wt.a * sx) + 'px';
					div.style.height = (hitArea.height * wt.d * sy) + 'px';
				
				}
				else
				{
					hitArea = child.getBounds();
	
					this.capHitArea(hitArea);
	
					div.style.left = (hitArea.x * sx) + 'px';
					div.style.top =  (hitArea.y * sy) +  'px';
	
					div.style.width = (hitArea.width * sx) + 'px';
					div.style.height = (hitArea.height * sy) + 'px';
				}		
			}
		}
	
		// increment the render id..
		this.renderId++;
	};
	
	AccessibilityManager.prototype.capHitArea = function (hitArea)
	{
	    if (hitArea.x < 0)
	    {
	        hitArea.width += hitArea.x;
	        hitArea.x = 0;
	    }
	
	    if (hitArea.y < 0)
	    {
	        hitArea.height += hitArea.y;
	        hitArea.y = 0;
	    }
	
	    if ( hitArea.x + hitArea.width > this.renderer.width )
	    {
	        hitArea.width = this.renderer.width - hitArea.x;
	    }
	
	    if ( hitArea.y + hitArea.height > this.renderer.height )
	    {
	        hitArea.height = this.renderer.height - hitArea.y;
	    }
	};
	
	
	/**
	 * Adds a DisplayObject to the accessibility manager
	 * @private
	 */
	AccessibilityManager.prototype.addChild = function(displayObject)
	{
	//	this.activate();
		
		var div = this.pool.pop();
	
		if(!div)
		{
			div = document.createElement('button'); 
	
		    div.style.width = 100 + 'px';
		    div.style.height = 100 + 'px';
		    div.style.backgroundColor = this.debug ? 'rgba(255,0,0,0.5)' : 'transparent';
		    div.style.position = 'absolute';
		    div.style.zIndex = 2;
		    div.style.borderStyle = 'none';
	
		    
		    div.addEventListener('click', this._onClick.bind(this));
		    div.addEventListener('focus', this._onFocus.bind(this));
		    div.addEventListener('focusout', this._onFocusOut.bind(this));
		}
		   	
	
	
	
		div.title = displayObject.accessibleTitle || 'displayObject ' + this.tabIndex;
	
		//
		
		displayObject._accessibleActive = true;
		displayObject._accessibleDiv = div;
		div.displayObject = displayObject;
	
	
		this.children.push(displayObject);
		this.div.appendChild( displayObject._accessibleDiv );
		displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
	};
	
	
	/**
	 * Maps the div button press to pixi's InteractionManager (click)
	 * @private
	 */
	AccessibilityManager.prototype._onClick = function(e)
	{
		var interactionManager = this.renderer.plugins.interaction;
		interactionManager.dispatchEvent(e.target.displayObject, 'click', interactionManager.eventData);
	};
	
	/**
	 * Maps the div focus events to pixis InteractionManager (mouseover)
	 * @private
	 */
	AccessibilityManager.prototype._onFocus = function(e)
	{
		var interactionManager = this.renderer.plugins.interaction;
		interactionManager.dispatchEvent(e.target.displayObject, 'mouseover', interactionManager.eventData);
	};
	
	/**
	 * Maps the div focus events to pixis InteractionManager (mouseout)
	 * @private
	 */
	AccessibilityManager.prototype._onFocusOut = function(e)
	{
		var interactionManager = this.renderer.plugins.interaction;
		interactionManager.dispatchEvent(e.target.displayObject, 'mouseout', interactionManager.eventData);
	};
	
	/**
	 * Is called when a key is pressed
	 *
	 * @private
	 */
	AccessibilityManager.prototype._onKeyDown = function(e)
	{
		if(e.keyCode !== 9)
		{
			return;
		}
	
		this.activate();
	};
	
	/**
	 * Is called when the mouse moves across the renderer element
	 *
	 * @private
	 */
	AccessibilityManager.prototype._onMouseMove = function()
	{
		this.deactivate();
	};
	
	
	/**
	 * Destroys the accessibility manager
	 *
	 */
	AccessibilityManager.prototype.destroy = function () 
	{
		this.div = null;
	
		for (var i = 0; i < this.children.length; i++)
		{
			this.children[i].div = null;
		}
	
		
		window.document.removeEventListener('mousemove', this._onMouseMove);
		window.removeEventListener('keydown', this._onKeyDown);
			
		this.pool = null;
		this.children = null;
		this.renderer = null;
	
	};
	
	core.WebGLRenderer.registerPlugin('accessibility', AccessibilityManager);
	core.CanvasRenderer.registerPlugin('accessibility', AccessibilityManager);
	


/***/ },
/* 175 */
/*!**********************************************!*\
  !*** ./~/pixi.js/src/accessibility/index.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @file        Main export of the PIXI accessibility library
	 * @author      Mat Groves <mat@goodboydigital.com>
	 * @copyright   2013-2015 GoodBoyDigital
	 * @license     {@link https://github.com/pixijs/pixi.js/blob/master/LICENSE|MIT License}
	 */
	
	/**
	 * @namespace PIXI.interaction
	 */
	module.exports = {
	    accessibleTarget:     __webpack_require__(/*! ./accessibleTarget */ 93),
	    AccessibilityManager: __webpack_require__(/*! ./AccessibilityManager */ 174)
	};


/***/ },
/* 176 */
/*!*************************************************!*\
  !*** ./~/pixi.js/src/core/graphics/Graphics.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Container = __webpack_require__(/*! ../display/Container */ 36),
	    Texture = __webpack_require__(/*! ../textures/Texture */ 30),
	    CanvasBuffer = __webpack_require__(/*! ../renderers/canvas/utils/CanvasBuffer */ 58),
	    CanvasGraphics = __webpack_require__(/*! ../renderers/canvas/utils/CanvasGraphics */ 59),
	    GraphicsData = __webpack_require__(/*! ./GraphicsData */ 95),
	    math = __webpack_require__(/*! ../math */ 9),
	    CONST = __webpack_require__(/*! ../const */ 6),
	    tempPoint = new math.Point();
	
	/**
	 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
	 * rectangles to the display, and to color and fill them.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	function Graphics()
	{
	    Container.call(this);
	
	    /**
	     * The alpha value used when filling the Graphics object.
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.fillAlpha = 1;
	
	    /**
	     * The width (thickness) of any lines drawn.
	     *
	     * @member {number}
	     * @default 0
	     */
	    this.lineWidth = 0;
	
	    /**
	     * The color of any lines drawn.
	     *
	     * @member {string}
	     * @default 0
	     */
	    this.lineColor = 0;
	
	    /**
	     * Graphics data
	     *
	     * @member {PIXI.GraphicsData[]}
	     * @private
	     */
	    this.graphicsData = [];
	
	    /**
	     * The tint applied to the graphic shape. This is a hex value. Apply a value of 0xFFFFFF to reset the tint.
	     *
	     * @member {number}
	     * @default 0xFFFFFF
	     */
	    this.tint = 0xFFFFFF;
	
	    /**
	     * The previous tint applied to the graphic shape. Used to compare to the current tint and check if theres change.
	     *
	     * @member {number}
	     * @private
	     * @default 0xFFFFFF
	     */
	    this._prevTint = 0xFFFFFF;
	
	    /**
	     * The blend mode to be applied to the graphic shape. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	     *
	     * @member {number}
	     * @default PIXI.BLEND_MODES.NORMAL;
	     * @see PIXI.BLEND_MODES
	     */
	    this.blendMode = CONST.BLEND_MODES.NORMAL;
	
	    /**
	     * Current path
	     *
	     * @member {PIXI.GraphicsData}
	     * @private
	     */
	    this.currentPath = null;
	
	    /**
	     * Array containing some WebGL-related properties used by the WebGL renderer.
	     *
	     * @member {object<number, object>}
	     * @private
	     */
	    // TODO - _webgl should use a prototype object, not a random undocumented object...
	    this._webGL = {};
	
	    /**
	     * Whether this shape is being used as a mask.
	     *
	     * @member {boolean}
	     */
	    this.isMask = false;
	
	    /**
	     * The bounds' padding used for bounds calculation.
	     *
	     * @member {number}
	     */
	    this.boundsPadding = 0;
	
	    /**
	     * A cache of the local bounds to prevent recalculation.
	     *
	     * @member {PIXI.Rectangle}
	     * @private
	     */
	    this._localBounds = new math.Rectangle(0,0,1,1);
	
	    /**
	     * Used to detect if the graphics object has changed. If this is set to true then the graphics
	     * object will be recalculated.
	     *
	     * @member {boolean}
	     * @private
	     */
	    this.dirty = true;
	
	    /**
	     * Used to detect if the WebGL graphics object has changed. If this is set to true then the
	     * graphics object will be recalculated.
	     *
	     * @member {boolean}
	     * @private
	     */
	    this.glDirty = false;
	
	    this.boundsDirty = true;
	
	    /**
	     * Used to detect if the cached sprite object needs to be updated.
	     *
	     * @member {boolean}
	     * @private
	     */
	    this.cachedSpriteDirty = false;
	
	    /**
	     * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
	     * This is useful if your graphics element does not change often, as it will speed up the rendering
	     * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
	     * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
	     * you are constantly redrawing the graphics element.
	     *
	     * @name cacheAsBitmap
	     * @member {boolean}
	     * @memberof PIXI.Graphics#
	     * @default false
	     */
	}
	
	// constructor
	Graphics.prototype = Object.create(Container.prototype);
	Graphics.prototype.constructor = Graphics;
	module.exports = Graphics;
	
	/**
	 * Creates a new Graphics object with the same values as this one.
	 * Note that the only the properties of the object are cloned, not its transform (position,scale,etc)
	 *
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.clone = function ()
	{
	    var clone = new Graphics();
	
	    clone.renderable    = this.renderable;
	    clone.fillAlpha     = this.fillAlpha;
	    clone.lineWidth     = this.lineWidth;
	    clone.lineColor     = this.lineColor;
	    clone.tint          = this.tint;
	    clone.blendMode     = this.blendMode;
	    clone.isMask        = this.isMask;
	    clone.boundsPadding = this.boundsPadding;
	    clone.dirty         = true;
	    clone.glDirty       = true;
	    clone.cachedSpriteDirty = this.cachedSpriteDirty;
	
	    // copy graphics data
	    for (var i = 0; i < this.graphicsData.length; ++i)
	    {
	        clone.graphicsData.push(this.graphicsData[i].clone());
	    }
	
	    clone.currentPath = clone.graphicsData[clone.graphicsData.length - 1];
	
	    clone.updateLocalBounds();
	
	    return clone;
	};
	
	/**
	 * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo() method or the drawCircle() method.
	 *
	 * @param lineWidth {number} width of the line to draw, will update the objects stored style
	 * @param color {number} color of the line to draw, will update the objects stored style
	 * @param alpha {number} alpha of the line to draw, will update the objects stored style
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.lineStyle = function (lineWidth, color, alpha)
	{
	    this.lineWidth = lineWidth || 0;
	    this.lineColor = color || 0;
	    this.lineAlpha = (alpha === undefined) ? 1 : alpha;
	
	    if (this.currentPath)
	    {
	        if (this.currentPath.shape.points.length)
	        {
	            // halfway through a line? start a new one!
	            var shape = new math.Polygon(this.currentPath.shape.points.slice(-2));
	            shape.closed = false;
	            this.drawShape(shape);
	        }
	        else
	        {
	            // otherwise its empty so lets just set the line properties
	            this.currentPath.lineWidth = this.lineWidth;
	            this.currentPath.lineColor = this.lineColor;
	            this.currentPath.lineAlpha = this.lineAlpha;
	        }
	    }
	
	    return this;
	};
	
	/**
	 * Moves the current drawing position to x, y.
	 *
	 * @param x {number} the X coordinate to move to
	 * @param y {number} the Y coordinate to move to
	 * @return {PIXI.Graphics}
	  */
	Graphics.prototype.moveTo = function (x, y)
	{
	    var shape = new math.Polygon([x,y]);
	    shape.closed = false;
	    this.drawShape(shape);
	
	    return this;
	};
	
	/**
	 * Draws a line using the current line style from the current drawing position to (x, y);
	 * The current drawing position is then set to (x, y).
	 *
	 * @param x {number} the X coordinate to draw to
	 * @param y {number} the Y coordinate to draw to
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.lineTo = function (x, y)
	{
	    this.currentPath.shape.points.push(x, y);
	    this.dirty = true;
	
	    return this;
	};
	
	/**
	 * Calculate the points for a quadratic bezier curve and then draws it.
	 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	 *
	 * @param cpX {number} Control point x
	 * @param cpY {number} Control point y
	 * @param toX {number} Destination point x
	 * @param toY {number} Destination point y
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.quadraticCurveTo = function (cpX, cpY, toX, toY)
	{
	    if (this.currentPath)
	    {
	        if (this.currentPath.shape.points.length === 0)
	        {
	            this.currentPath.shape.points = [0, 0];
	        }
	    }
	    else
	    {
	        this.moveTo(0,0);
	    }
	
	    var xa,
	        ya,
	        n = 20,
	        points = this.currentPath.shape.points;
	
	    if (points.length === 0)
	    {
	        this.moveTo(0, 0);
	    }
	
	    var fromX = points[points.length-2];
	    var fromY = points[points.length-1];
	
	    var j = 0;
	    for (var i = 1; i <= n; ++i)
	    {
	        j = i / n;
	
	        xa = fromX + ( (cpX - fromX) * j );
	        ya = fromY + ( (cpY - fromY) * j );
	
	        points.push( xa + ( ((cpX + ( (toX - cpX) * j )) - xa) * j ),
	                     ya + ( ((cpY + ( (toY - cpY) * j )) - ya) * j ) );
	    }
	
	    this.dirty = this.boundsDirty = true;
	
	    return this;
	};
	
	/**
	 * Calculate the points for a bezier curve and then draws it.
	 *
	 * @param cpX {number} Control point x
	 * @param cpY {number} Control point y
	 * @param cpX2 {number} Second Control point x
	 * @param cpY2 {number} Second Control point y
	 * @param toX {number} Destination point x
	 * @param toY {number} Destination point y
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.bezierCurveTo = function (cpX, cpY, cpX2, cpY2, toX, toY)
	{
	    if (this.currentPath)
	    {
	        if (this.currentPath.shape.points.length === 0)
	        {
	            this.currentPath.shape.points = [0, 0];
	        }
	    }
	    else
	    {
	        this.moveTo(0,0);
	    }
	
	    var n = 20,
	        dt,
	        dt2,
	        dt3,
	        t2,
	        t3,
	        points = this.currentPath.shape.points;
	
	    var fromX = points[points.length-2];
	    var fromY = points[points.length-1];
	
	    var j = 0;
	
	    for (var i = 1; i <= n; ++i)
	    {
	        j = i / n;
	
	        dt = (1 - j);
	        dt2 = dt * dt;
	        dt3 = dt2 * dt;
	
	        t2 = j * j;
	        t3 = t2 * j;
	
	        points.push( dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX,
	                     dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
	    }
	
	    this.dirty = this.boundsDirty = true;
	
	    return this;
	};
	
	/**
	 * The arcTo() method creates an arc/curve between two tangents on the canvas.
	 *
	 * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
	 *
	 * @param x1 {number} The x-coordinate of the beginning of the arc
	 * @param y1 {number} The y-coordinate of the beginning of the arc
	 * @param x2 {number} The x-coordinate of the end of the arc
	 * @param y2 {number} The y-coordinate of the end of the arc
	 * @param radius {number} The radius of the arc
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.arcTo = function (x1, y1, x2, y2, radius)
	{
	    if (this.currentPath)
	    {
	        if (this.currentPath.shape.points.length === 0)
	        {
	            this.currentPath.shape.points.push(x1, y1);
	        }
	    }
	    else
	    {
	        this.moveTo(x1, y1);
	    }
	
	    var points = this.currentPath.shape.points,
	        fromX = points[points.length-2],
	        fromY = points[points.length-1],
	        a1 = fromY - y1,
	        b1 = fromX - x1,
	        a2 = y2   - y1,
	        b2 = x2   - x1,
	        mm = Math.abs(a1 * b2 - b1 * a2);
	
	    if (mm < 1.0e-8 || radius === 0)
	    {
	        if (points[points.length-2] !== x1 || points[points.length-1] !== y1)
	        {
	            points.push(x1, y1);
	        }
	    }
	    else
	    {
	        var dd = a1 * a1 + b1 * b1,
	            cc = a2 * a2 + b2 * b2,
	            tt = a1 * a2 + b1 * b2,
	            k1 = radius * Math.sqrt(dd) / mm,
	            k2 = radius * Math.sqrt(cc) / mm,
	            j1 = k1 * tt / dd,
	            j2 = k2 * tt / cc,
	            cx = k1 * b2 + k2 * b1,
	            cy = k1 * a2 + k2 * a1,
	            px = b1 * (k2 + j1),
	            py = a1 * (k2 + j1),
	            qx = b2 * (k1 + j2),
	            qy = a2 * (k1 + j2),
	            startAngle = Math.atan2(py - cy, px - cx),
	            endAngle   = Math.atan2(qy - cy, qx - cx);
	
	        this.arc(cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
	    }
	
	    this.dirty = this.boundsDirty = true;
	
	    return this;
	};
	
	/**
	 * The arc method creates an arc/curve (used to create circles, or parts of circles).
	 *
	 * @param cx {number} The x-coordinate of the center of the circle
	 * @param cy {number} The y-coordinate of the center of the circle
	 * @param radius {number} The radius of the circle
	 * @param startAngle {number} The starting angle, in radians (0 is at the 3 o'clock position of the arc's circle)
	 * @param endAngle {number} The ending angle, in radians
	 * @param anticlockwise {boolean} Optional. Specifies whether the drawing should be counterclockwise or clockwise. False is default, and indicates clockwise, while true indicates counter-clockwise.
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.arc = function(cx, cy, radius, startAngle, endAngle, anticlockwise)
	{
	    anticlockwise = anticlockwise || false;
	
	    if (startAngle === endAngle)
	    {
	        return this;
	    }
	
	    if( !anticlockwise && endAngle <= startAngle )
	    {
	        endAngle += Math.PI * 2;
	    }
	    else if( anticlockwise && startAngle <= endAngle )
	    {
	        startAngle += Math.PI * 2;
	    }
	
	    var sweep = anticlockwise ? (startAngle - endAngle) * -1 : (endAngle - startAngle);
	    var segs =  Math.ceil(Math.abs(sweep) / (Math.PI * 2)) * 40;
	
	    if(sweep === 0)
	    {
	        return this;
	    }
	
	    var startX = cx + Math.cos(startAngle) * radius;
	    var startY = cy + Math.sin(startAngle) * radius;
	
	    if (this.currentPath)
	    {
	        this.currentPath.shape.points.push(startX, startY);
	    }
	    else
	    {
	        this.moveTo(startX, startY);
	    }
	
	    var points = this.currentPath.shape.points;
	
	    var theta = sweep/(segs*2);
	    var theta2 = theta*2;
	
	    var cTheta = Math.cos(theta);
	    var sTheta = Math.sin(theta);
	
	    var segMinus = segs - 1;
	
	    var remainder = ( segMinus % 1 ) / segMinus;
	
	    for(var i=0; i<=segMinus; i++)
	    {
	        var real =  i + remainder * i;
	
	
	        var angle = ((theta) + startAngle + (theta2 * real));
	
	        var c = Math.cos(angle);
	        var s = -Math.sin(angle);
	
	        points.push(( (cTheta *  c) + (sTheta * s) ) * radius + cx,
	                    ( (cTheta * -s) + (sTheta * c) ) * radius + cy);
	    }
	
	    this.dirty = this.boundsDirty = true;
	
	    return this;
	};
	
	/**
	 * Specifies a simple one-color fill that subsequent calls to other Graphics methods
	 * (such as lineTo() or drawCircle()) use when drawing.
	 *
	 * @param color {number} the color of the fill
	 * @param alpha {number} the alpha of the fill
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.beginFill = function (color, alpha)
	{
	    this.filling = true;
	    this.fillColor = color || 0;
	    this.fillAlpha = (alpha === undefined) ? 1 : alpha;
	
	    if (this.currentPath)
	    {
	        if (this.currentPath.shape.points.length <= 2)
	        {
	            this.currentPath.fill = this.filling;
	            this.currentPath.fillColor = this.fillColor;
	            this.currentPath.fillAlpha = this.fillAlpha;
	        }
	    }
	    return this;
	};
	
	/**
	 * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
	 *
	 * @return {Graphics}
	 */
	Graphics.prototype.endFill = function ()
	{
	    this.filling = false;
	    this.fillColor = null;
	    this.fillAlpha = 1;
	
	    return this;
	};
	
	/**
	 *
	 * @param x {number} The X coord of the top-left of the rectangle
	 * @param y {number} The Y coord of the top-left of the rectangle
	 * @param width {number} The width of the rectangle
	 * @param height {number} The height of the rectangle
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.drawRect = function ( x, y, width, height )
	{
	    this.drawShape(new math.Rectangle(x,y, width, height));
	
	    return this;
	};
	
	/**
	 *
	 * @param x {number} The X coord of the top-left of the rectangle
	 * @param y {number} The Y coord of the top-left of the rectangle
	 * @param width {number} The width of the rectangle
	 * @param height {number} The height of the rectangle
	 * @param radius {number} Radius of the rectangle corners
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.drawRoundedRect = function ( x, y, width, height, radius )
	{
	    this.drawShape(new math.RoundedRectangle(x, y, width, height, radius));
	
	    return this;
	};
	
	/**
	 * Draws a circle.
	 *
	 * @param x {number} The X coordinate of the center of the circle
	 * @param y {number} The Y coordinate of the center of the circle
	 * @param radius {number} The radius of the circle
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.drawCircle = function (x, y, radius)
	{
	    this.drawShape(new math.Circle(x,y, radius));
	
	    return this;
	};
	
	/**
	 * Draws an ellipse.
	 *
	 * @param x {number} The X coordinate of the center of the ellipse
	 * @param y {number} The Y coordinate of the center of the ellipse
	 * @param width {number} The half width of the ellipse
	 * @param height {number} The half height of the ellipse
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.drawEllipse = function (x, y, width, height)
	{
	    this.drawShape(new math.Ellipse(x, y, width, height));
	
	    return this;
	};
	
	/**
	 * Draws a polygon using the given path.
	 *
	 * @param path {number[]|PIXI.Point[]} The path data used to construct the polygon.
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.drawPolygon = function (path)
	{
	    // prevents an argument assignment deopt
	    // see section 3.1: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	    var points = path;
	
	    var closed = true;
	
	    if (points instanceof math.Polygon)
	    {
	        closed = points.closed;
	        points = points.points;
	    }
	
	    if (!Array.isArray(points))
	    {
	        // prevents an argument leak deopt
	        // see section 3.2: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	        points = new Array(arguments.length);
	
	        for (var i = 0; i < points.length; ++i)
	        {
	            points[i] = arguments[i];
	        }
	    }
	
	    var shape = new math.Polygon(points);
	    shape.closed = closed;
	
	    this.drawShape(shape);
	
	    return this;
	};
	
	/**
	 * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
	 *
	 * @return {PIXI.Graphics}
	 */
	Graphics.prototype.clear = function ()
	{
	    this.lineWidth = 0;
	    this.filling = false;
	
	    this.dirty = true;
	    this.clearDirty = true;
	    this.graphicsData = [];
	
	    return this;
	};
	
	/**
	 * Useful function that returns a texture of the graphics object that can then be used to create sprites
	 * This can be quite useful if your geometry is complicated and needs to be reused multiple times.
	 *
	 * @param resolution {number} The resolution of the texture being generated
	 * @param scaleMode {number} Should be one of the scaleMode consts
	 * @return {PIXI.Texture} a texture of the graphics object
	 */
	Graphics.prototype.generateTexture = function (renderer, resolution, scaleMode)
	{
	
	    resolution = resolution || 1;
	
	    var bounds = this.getLocalBounds();
	
	    var canvasBuffer = new CanvasBuffer(bounds.width * resolution, bounds.height * resolution);
	
	    var texture = Texture.fromCanvas(canvasBuffer.canvas, scaleMode);
	    texture.baseTexture.resolution = resolution;
	
	    canvasBuffer.context.scale(resolution, resolution);
	
	    canvasBuffer.context.translate(-bounds.x,-bounds.y);
	
	    CanvasGraphics.renderGraphics(this, canvasBuffer.context);
	
	    return texture;
	};
	
	/**
	 * Renders the object using the WebGL renderer
	 *
	 * @param renderer {PIXI.WebGLRenderer}
	 * @private
	 */
	Graphics.prototype._renderWebGL = function (renderer)
	{
	    // if the sprite is not visible or the alpha is 0 then no need to render this element
	
	    // this code may still be needed so leaving for now..
	    //
	    /*
	    if (this._cacheAsBitmap)
	    {
	        if (this.dirty || this.cachedSpriteDirty)
	        {
	            this._generateCachedSprite();
	
	            // we will also need to update the texture on the gpu too!
	            this.updateCachedSpriteTexture();
	
	            this.cachedSpriteDirty = false;
	            this.dirty = false;
	        }
	
	        this._cachedSprite.worldAlpha = this.worldAlpha;
	
	        Sprite.prototype.renderWebGL.call(this._cachedSprite, renderer);
	
	        return;
	    }
	
	    */
	
	    if (this.glDirty)
	    {
	        this.dirty = true;
	        this.glDirty = false;
	    }
	
	    renderer.setObjectRenderer(renderer.plugins.graphics);
	    renderer.plugins.graphics.render(this);
	
	};
	
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @param renderer {PIXI.CanvasRenderer}
	 * @private
	 */
	Graphics.prototype._renderCanvas = function (renderer)
	{
	    if (this.isMask === true)
	    {
	        return;
	    }
	
	    // if the tint has changed, set the graphics object to dirty.
	    if (this._prevTint !== this.tint) {
	        this.dirty = true;
	    }
	
	    // this code may still be needed so leaving for now..
	    //
	    /*
	    if (this._cacheAsBitmap)
	    {
	        if (this.dirty || this.cachedSpriteDirty)
	        {
	            this._generateCachedSprite();
	
	            // we will also need to update the texture
	            this.updateCachedSpriteTexture();
	
	            this.cachedSpriteDirty = false;
	            this.dirty = false;
	        }
	
	        this._cachedSprite.alpha = this.alpha;
	
	        Sprite.prototype._renderCanvas.call(this._cachedSprite, renderer);
	
	        return;
	    }
	    */
	    var context = renderer.context;
	    var transform = this.worldTransform;
	
	    var compositeOperation = renderer.blendModes[this.blendMode];
	    if (compositeOperation !== context.globalCompositeOperation)
	    {
	        context.globalCompositeOperation = compositeOperation;
	    }
	
	    var resolution = renderer.resolution;
	    context.setTransform(
	        transform.a * resolution,
	        transform.b * resolution,
	        transform.c * resolution,
	        transform.d * resolution,
	        transform.tx * resolution,
	        transform.ty * resolution
	    );
	
	    CanvasGraphics.renderGraphics(this, context);
	};
	
	/**
	 * Retrieves the bounds of the graphic shape as a rectangle object
	 *
	 * @param [matrix] {PIXI.Matrix} The world transform matrix to use, defaults to this
	 *  object's worldTransform.
	 * @return {PIXI.Rectangle} the rectangular bounding area
	 */
	Graphics.prototype.getBounds = function (matrix)
	{
	    if(!this._currentBounds)
	    {
	
	        // return an empty object if the item is a mask!
	        if (!this.renderable)
	        {
	            return math.Rectangle.EMPTY;
	        }
	
	        if (this.boundsDirty)
	        {
	            this.updateLocalBounds();
	
	            this.glDirty = true;
	            this.cachedSpriteDirty = true;
	            this.boundsDirty = false;
	        }
	
	        var bounds = this._localBounds;
	
	        var w0 = bounds.x;
	        var w1 = bounds.width + bounds.x;
	
	        var h0 = bounds.y;
	        var h1 = bounds.height + bounds.y;
	
	        var worldTransform = matrix || this.worldTransform;
	
	        var a = worldTransform.a;
	        var b = worldTransform.b;
	        var c = worldTransform.c;
	        var d = worldTransform.d;
	        var tx = worldTransform.tx;
	        var ty = worldTransform.ty;
	
	        var x1 = a * w1 + c * h1 + tx;
	        var y1 = d * h1 + b * w1 + ty;
	
	        var x2 = a * w0 + c * h1 + tx;
	        var y2 = d * h1 + b * w0 + ty;
	
	        var x3 = a * w0 + c * h0 + tx;
	        var y3 = d * h0 + b * w0 + ty;
	
	        var x4 =  a * w1 + c * h0 + tx;
	        var y4 =  d * h0 + b * w1 + ty;
	
	        var maxX = x1;
	        var maxY = y1;
	
	        var minX = x1;
	        var minY = y1;
	
	        minX = x2 < minX ? x2 : minX;
	        minX = x3 < minX ? x3 : minX;
	        minX = x4 < minX ? x4 : minX;
	
	        minY = y2 < minY ? y2 : minY;
	        minY = y3 < minY ? y3 : minY;
	        minY = y4 < minY ? y4 : minY;
	
	        maxX = x2 > maxX ? x2 : maxX;
	        maxX = x3 > maxX ? x3 : maxX;
	        maxX = x4 > maxX ? x4 : maxX;
	
	        maxY = y2 > maxY ? y2 : maxY;
	        maxY = y3 > maxY ? y3 : maxY;
	        maxY = y4 > maxY ? y4 : maxY;
	
	        this._bounds.x = minX;
	        this._bounds.width = maxX - minX;
	
	        this._bounds.y = minY;
	        this._bounds.height = maxY - minY;
	
	        this._currentBounds = this._bounds;
	    }
	
	    return this._currentBounds;
	};
	
	/**
	* Tests if a point is inside this graphics object
	*
	* @param point {PIXI.Point} the point to test
	* @return {boolean} the result of the test
	*/
	Graphics.prototype.containsPoint = function( point )
	{
	    this.worldTransform.applyInverse(point,  tempPoint);
	
	    var graphicsData = this.graphicsData;
	
	    for (var i = 0; i < graphicsData.length; i++)
	    {
	        var data = graphicsData[i];
	
	        if (!data.fill)
	        {
	            continue;
	        }
	
	        // only deal with fills..
	        if (data.shape)
	        {
	            if ( data.shape.contains( tempPoint.x, tempPoint.y ) )
	            {
	                return true;
	            }
	        }
	    }
	
	    return false;
	};
	
	/**
	 * Update the bounds of the object
	 *
	 */
	Graphics.prototype.updateLocalBounds = function ()
	{
	    var minX = Infinity;
	    var maxX = -Infinity;
	
	    var minY = Infinity;
	    var maxY = -Infinity;
	
	    if (this.graphicsData.length)
	    {
	        var shape, points, x, y, w, h;
	
	        for (var i = 0; i < this.graphicsData.length; i++)
	        {
	            var data = this.graphicsData[i];
	            var type = data.type;
	            var lineWidth = data.lineWidth;
	            shape = data.shape;
	
	            if (type === CONST.SHAPES.RECT || type === CONST.SHAPES.RREC)
	            {
	                x = shape.x - lineWidth/2;
	                y = shape.y - lineWidth/2;
	                w = shape.width + lineWidth;
	                h = shape.height + lineWidth;
	
	                minX = x < minX ? x : minX;
	                maxX = x + w > maxX ? x + w : maxX;
	
	                minY = y < minY ? y : minY;
	                maxY = y + h > maxY ? y + h : maxY;
	            }
	            else if (type === CONST.SHAPES.CIRC)
	            {
	                x = shape.x;
	                y = shape.y;
	                w = shape.radius + lineWidth/2;
	                h = shape.radius + lineWidth/2;
	
	                minX = x - w < minX ? x - w : minX;
	                maxX = x + w > maxX ? x + w : maxX;
	
	                minY = y - h < minY ? y - h : minY;
	                maxY = y + h > maxY ? y + h : maxY;
	            }
	            else if (type === CONST.SHAPES.ELIP)
	            {
	                x = shape.x;
	                y = shape.y;
	                w = shape.width + lineWidth/2;
	                h = shape.height + lineWidth/2;
	
	                minX = x - w < minX ? x - w : minX;
	                maxX = x + w > maxX ? x + w : maxX;
	
	                minY = y - h < minY ? y - h : minY;
	                maxY = y + h > maxY ? y + h : maxY;
	            }
	            else
	            {
	                // POLY
	                points = shape.points;
	
	                for (var j = 0; j < points.length; j += 2)
	                {
	                    x = points[j];
	                    y = points[j+1];
	
	                    minX = x-lineWidth < minX ? x-lineWidth : minX;
	                    maxX = x+lineWidth > maxX ? x+lineWidth : maxX;
	
	                    minY = y-lineWidth < minY ? y-lineWidth : minY;
	                    maxY = y+lineWidth > maxY ? y+lineWidth : maxY;
	                }
	            }
	        }
	    }
	    else
	    {
	        minX = 0;
	        maxX = 0;
	        minY = 0;
	        maxY = 0;
	    }
	
	    var padding = this.boundsPadding;
	
	    this._localBounds.x = minX - padding;
	    this._localBounds.width = (maxX - minX) + padding * 2;
	
	    this._localBounds.y = minY - padding;
	    this._localBounds.height = (maxY - minY) + padding * 2;
	};
	
	/**
	 * Generates the cached sprite when the sprite has cacheAsBitmap = true
	 *
	 * @private
	 */
	/*
	Graphics.prototype._generateCachedSprite = function ()
	{
	    var bounds = this.getLocalBounds();
	
	    if (!this._cachedSprite)
	    {
	        var canvasBuffer = new CanvasBuffer(bounds.width, bounds.height);
	        var texture = Texture.fromCanvas(canvasBuffer.canvas);
	
	        this._cachedSprite = new Sprite(texture);
	        this._cachedSprite.buffer = canvasBuffer;
	
	        this._cachedSprite.worldTransform = this.worldTransform;
	    }
	    else
	    {
	        this._cachedSprite.buffer.resize(bounds.width, bounds.height);
	    }
	
	    // leverage the anchor to account for the offset of the element
	    this._cachedSprite.anchor.x = -( bounds.x / bounds.width );
	    this._cachedSprite.anchor.y = -( bounds.y / bounds.height );
	
	    // this._cachedSprite.buffer.context.save();
	    this._cachedSprite.buffer.context.translate(-bounds.x,-bounds.y);
	
	    // make sure we set the alpha of the graphics to 1 for the render..
	    this.worldAlpha = 1;
	
	    // now render the graphic..
	    CanvasGraphics.renderGraphics(this, this._cachedSprite.buffer.context);
	
	    this._cachedSprite.alpha = this.alpha;
	};
	*/
	/**
	 * Updates texture size based on canvas size
	 *
	 * @private
	 */
	/*
	Graphics.prototype.updateCachedSpriteTexture = function ()
	{
	    var cachedSprite = this._cachedSprite;
	    var texture = cachedSprite.texture;
	    var canvas = cachedSprite.buffer.canvas;
	
	    texture.baseTexture.width = canvas.width;
	    texture.baseTexture.height = canvas.height;
	    texture.crop.width = texture.frame.width = canvas.width;
	    texture.crop.height = texture.frame.height = canvas.height;
	
	    cachedSprite._width = canvas.width;
	    cachedSprite._height = canvas.height;
	
	    // update the dirty base textures
	    texture.baseTexture.dirty();
	};*/
	
	/**
	 * Destroys a previous cached sprite.
	 *
	 */
	/*
	Graphics.prototype.destroyCachedSprite = function ()
	{
	    this._cachedSprite.texture.destroy(true);
	
	    // let the gc collect the unused sprite
	    // TODO could be object pooled!
	    this._cachedSprite = null;
	};*/
	
	/**
	 * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
	 *
	 * @param shape {PIXI.Circle|PIXI.Rectangle|PIXI.Ellipse|PIXI.Line|PIXI.Polygon} The shape object to draw.
	 * @return {PIXI.GraphicsData} The generated GraphicsData object.
	 */
	Graphics.prototype.drawShape = function (shape)
	{
	    if (this.currentPath)
	    {
	        // check current path!
	        if (this.currentPath.shape.points.length <= 2)
	        {
	            this.graphicsData.pop();
	        }
	    }
	
	    this.currentPath = null;
	
	    var data = new GraphicsData(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.filling, shape);
	
	    this.graphicsData.push(data);
	
	    if (data.type === CONST.SHAPES.POLY)
	    {
	        data.shape.closed = data.shape.closed || this.filling;
	        this.currentPath = data;
	    }
	
	    this.dirty = this.boundsDirty = true;
	
	    return data;
	};
	
	/**
	 * Destroys the Graphics object.
	 */
	Graphics.prototype.destroy = function () {
	    Container.prototype.destroy.apply(this, arguments);
	
	    // destroy each of the GraphicsData objects
	    for (var i = 0; i < this.graphicsData.length; ++i) {
	        this.graphicsData[i].destroy();
	    }
	
	    // for each webgl data entry, destroy the WebGLGraphicsData
	    for (var id in this._webgl) {
	        for (var j = 0; j < this._webgl[id].data.length; ++j) {
	            this._webgl[id].data[j].destroy();
	        }
	    }
	
	    this.graphicsData = null;
	
	    this.currentPath = null;
	    this._webgl = null;
	    this._localBounds = null;
	};


/***/ },
/* 177 */
/*!***************************************************************!*\
  !*** ./~/pixi.js/src/core/graphics/webgl/GraphicsRenderer.js ***!
  \***************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(/*! ../../utils */ 7),
	    math = __webpack_require__(/*! ../../math */ 9),
	    CONST = __webpack_require__(/*! ../../const */ 6),
	    ObjectRenderer = __webpack_require__(/*! ../../renderers/webgl/utils/ObjectRenderer */ 29),
	    WebGLRenderer = __webpack_require__(/*! ../../renderers/webgl/WebGLRenderer */ 37),
	    WebGLGraphicsData = __webpack_require__(/*! ./WebGLGraphicsData */ 178),
	    earcut = __webpack_require__(/*! earcut */ 159);
	
	/**
	 * Renders the graphics object.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 * @param renderer {PIXI.WebGLRenderer} The renderer this object renderer works for.
	 */
	function GraphicsRenderer(renderer)
	{
	    ObjectRenderer.call(this, renderer);
	
	    this.graphicsDataPool = [];
	
	    this.primitiveShader = null;
	    this.complexPrimitiveShader = null;
	
	    /**
	     * This is the maximum number of points a poly can contain before it is rendered as a complex polygon (using the stencil buffer)
	     * @type {Number}
	     */
	    this.maximumSimplePolySize = 200;
	}
	
	GraphicsRenderer.prototype = Object.create(ObjectRenderer.prototype);
	GraphicsRenderer.prototype.constructor = GraphicsRenderer;
	module.exports = GraphicsRenderer;
	
	WebGLRenderer.registerPlugin('graphics', GraphicsRenderer);
	
	/**
	 * Called when there is a WebGL context change
	 *
	 * @private
	 *
	 */
	GraphicsRenderer.prototype.onContextChange = function()
	{
	
	};
	
	/**
	 * Destroys this renderer.
	 *
	 */
	GraphicsRenderer.prototype.destroy = function () {
	    ObjectRenderer.prototype.destroy.call(this);
	
	    for (var i = 0; i < this.graphicsDataPool.length; ++i) {
	        this.graphicsDataPool[i].destroy();
	    }
	
	    this.graphicsDataPool = null;
	};
	
	/**
	 * Renders a graphics object.
	 *
	 * @param graphics {PIXI.Graphics} The graphics object to render.
	 */
	GraphicsRenderer.prototype.render = function(graphics)
	{
	    var renderer = this.renderer;
	    var gl = renderer.gl;
	
	    var shader = renderer.shaderManager.plugins.primitiveShader,
	        webGLData;
	
	    if (graphics.dirty || !graphics._webGL[gl.id])
	    {
	        this.updateGraphics(graphics);
	    }
	
	    var webGL = graphics._webGL[gl.id];
	
	    // This  could be speeded up for sure!
	
	    renderer.blendModeManager.setBlendMode( graphics.blendMode );
	
	//    var matrix =  graphics.worldTransform.clone();
	//    var matrix =  renderer.currentRenderTarget.projectionMatrix.clone();
	//    matrix.append(graphics.worldTransform);
	
	    for (var i = 0, n = webGL.data.length; i < n; i++)
	    {
	        webGLData = webGL.data[i];
	
	        if (webGL.data[i].mode === 1)
	        {
	
	            renderer.stencilManager.pushStencil(graphics, webGLData);
	
	            gl.uniform1f(renderer.shaderManager.complexPrimitiveShader.uniforms.alpha._location, graphics.worldAlpha * webGLData.alpha);
	
	            // render quad..
	            gl.drawElements(gl.TRIANGLE_FAN, 4, gl.UNSIGNED_SHORT, ( webGLData.indices.length - 4 ) * 2 );
	
	            renderer.stencilManager.popStencil(graphics, webGLData);
	        }
	        else
	        {
	
	            shader = renderer.shaderManager.primitiveShader;
	
	            renderer.shaderManager.setShader( shader );//activatePrimitiveShader();
	
	            gl.uniformMatrix3fv(shader.uniforms.translationMatrix._location, false, graphics.worldTransform.toArray(true));
	
	            gl.uniformMatrix3fv(shader.uniforms.projectionMatrix._location, false, renderer.currentRenderTarget.projectionMatrix.toArray(true));
	
	            gl.uniform3fv(shader.uniforms.tint._location, utils.hex2rgb(graphics.tint));
	
	            gl.uniform1f(shader.uniforms.alpha._location, graphics.worldAlpha);
	
	
	            gl.bindBuffer(gl.ARRAY_BUFFER, webGLData.buffer);
	
	            gl.vertexAttribPointer(shader.attributes.aVertexPosition, 2, gl.FLOAT, false, 4 * 6, 0);
	            gl.vertexAttribPointer(shader.attributes.aColor, 4, gl.FLOAT, false,4 * 6, 2 * 4);
	
	            // set the index buffer!
	            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, webGLData.indexBuffer);
	            gl.drawElements(gl.TRIANGLE_STRIP,  webGLData.indices.length, gl.UNSIGNED_SHORT, 0 );
	        }
	
	        renderer.drawCount++;
	    }
	};
	
	/**
	 * Updates the graphics object
	 *
	 * @private
	 * @param graphics {PIXI.Graphics} The graphics object to update
	 */
	GraphicsRenderer.prototype.updateGraphics = function(graphics)
	{
	    var gl = this.renderer.gl;
	
	     // get the contexts graphics object
	    var webGL = graphics._webGL[gl.id];
	
	    // if the graphics object does not exist in the webGL context time to create it!
	    if (!webGL)
	    {
	        webGL = graphics._webGL[gl.id] = {lastIndex:0, data:[], gl:gl};
	    }
	
	    // flag the graphics as not dirty as we are about to update it...
	    graphics.dirty = false;
	
	    var i;
	
	    // if the user cleared the graphics object we will need to clear every object
	    if (graphics.clearDirty)
	    {
	        graphics.clearDirty = false;
	
	        // loop through and return all the webGLDatas to the object pool so than can be reused later on
	        for (i = 0; i < webGL.data.length; i++)
	        {
	            var graphicsData = webGL.data[i];
	            graphicsData.reset();
	            this.graphicsDataPool.push( graphicsData );
	        }
	
	        // clear the array and reset the index..
	        webGL.data = [];
	        webGL.lastIndex = 0;
	    }
	
	    var webGLData;
	
	    // loop through the graphics datas and construct each one..
	    // if the object is a complex fill then the new stencil buffer technique will be used
	    // other wise graphics objects will be pushed into a batch..
	    for (i = webGL.lastIndex; i < graphics.graphicsData.length; i++)
	    {
	        var data = graphics.graphicsData[i];
	
	        if (data.type === CONST.SHAPES.POLY)
	        {
	            // need to add the points the the graphics object..
	            data.points = data.shape.points.slice();
	            if (data.shape.closed)
	            {
	                // close the poly if the value is true!
	                if (data.points[0] !== data.points[data.points.length-2] || data.points[1] !== data.points[data.points.length-1])
	                {
	                    data.points.push(data.points[0], data.points[1]);
	                }
	            }
	
	            // MAKE SURE WE HAVE THE CORRECT TYPE..
	            if (data.fill)
	            {
	                if (data.points.length >= 6)
	                {
	                    if (data.points.length < this.maximumSimplePolySize * 2)
	                    {
	                        webGLData = this.switchMode(webGL, 0);
	
	                        var canDrawUsingSimple = this.buildPoly(data, webGLData);
	
	                        if (!canDrawUsingSimple)
	                        {
	                            webGLData = this.switchMode(webGL, 1);
	                            this.buildComplexPoly(data, webGLData);
	                        }
	
	                    }
	                    else
	                    {
	                        webGLData = this.switchMode(webGL, 1);
	                        this.buildComplexPoly(data, webGLData);
	                    }
	                }
	            }
	
	            if (data.lineWidth > 0)
	            {
	                webGLData = this.switchMode(webGL, 0);
	                this.buildLine(data, webGLData);
	            }
	        }
	        else
	        {
	            webGLData = this.switchMode(webGL, 0);
	
	            if (data.type === CONST.SHAPES.RECT)
	            {
	                this.buildRectangle(data, webGLData);
	            }
	            else if (data.type === CONST.SHAPES.CIRC || data.type === CONST.SHAPES.ELIP)
	            {
	                this.buildCircle(data, webGLData);
	            }
	            else if (data.type === CONST.SHAPES.RREC)
	            {
	                this.buildRoundedRectangle(data, webGLData);
	            }
	        }
	
	        webGL.lastIndex++;
	    }
	
	    // upload all the dirty data...
	    for (i = 0; i < webGL.data.length; i++)
	    {
	        webGLData = webGL.data[i];
	
	        if (webGLData.dirty)
	        {
	            webGLData.upload();
	        }
	    }
	};
	
	/**
	 *
	 *
	 * @private
	 * @param webGL {WebGLRenderingContext} the current WebGL drawing context
	 * @param type {number} TODO @Alvin
	 */
	GraphicsRenderer.prototype.switchMode = function (webGL, type)
	{
	    var webGLData;
	
	    if (!webGL.data.length)
	    {
	        webGLData = this.graphicsDataPool.pop() || new WebGLGraphicsData(webGL.gl);
	        webGLData.mode = type;
	        webGL.data.push(webGLData);
	    }
	    else
	    {
	        webGLData = webGL.data[webGL.data.length-1];
	
	        if ((webGLData.points.length > 320000) || webGLData.mode !== type || type === 1)
	        {
	            webGLData = this.graphicsDataPool.pop() || new WebGLGraphicsData(webGL.gl);
	            webGLData.mode = type;
	            webGL.data.push(webGLData);
	        }
	    }
	
	    webGLData.dirty = true;
	
	    return webGLData;
	};
	
	/**
	 * Builds a rectangle to draw
	 *
	 * @private
	 * @param graphicsData {PIXI.Graphics} The graphics object containing all the necessary properties
	 * @param webGLData {object} an object containing all the webGL-specific information to create this shape
	 */
	GraphicsRenderer.prototype.buildRectangle = function (graphicsData, webGLData)
	{
	    // --- //
	    // need to convert points to a nice regular data
	    //
	    var rectData = graphicsData.shape;
	    var x = rectData.x;
	    var y = rectData.y;
	    var width = rectData.width;
	    var height = rectData.height;
	
	    if (graphicsData.fill)
	    {
	        var color = utils.hex2rgb(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var vertPos = verts.length/6;
	
	        // start
	        verts.push(x, y);
	        verts.push(r, g, b, alpha);
	
	        verts.push(x + width, y);
	        verts.push(r, g, b, alpha);
	
	        verts.push(x , y + height);
	        verts.push(r, g, b, alpha);
	
	        verts.push(x + width, y + height);
	        verts.push(r, g, b, alpha);
	
	        // insert 2 dead triangles..
	        indices.push(vertPos, vertPos, vertPos+1, vertPos+2, vertPos+3, vertPos+3);
	    }
	
	    if (graphicsData.lineWidth)
	    {
	        var tempPoints = graphicsData.points;
	
	        graphicsData.points = [x, y,
	                  x + width, y,
	                  x + width, y + height,
	                  x, y + height,
	                  x, y];
	
	
	        this.buildLine(graphicsData, webGLData);
	
	        graphicsData.points = tempPoints;
	    }
	};
	
	/**
	 * Builds a rounded rectangle to draw
	 *
	 * @private
	 * @param graphicsData {PIXI.Graphics} The graphics object containing all the necessary properties
	 * @param webGLData {object} an object containing all the webGL-specific information to create this shape
	 */
	GraphicsRenderer.prototype.buildRoundedRectangle = function (graphicsData, webGLData)
	{
	    var rrectData = graphicsData.shape;
	    var x = rrectData.x;
	    var y = rrectData.y;
	    var width = rrectData.width;
	    var height = rrectData.height;
	
	    var radius = rrectData.radius;
	
	    var recPoints = [];
	    recPoints.push(x, y + radius);
	    this.quadraticBezierCurve(x, y + height - radius, x, y + height, x + radius, y + height, recPoints);
	    this.quadraticBezierCurve(x + width - radius, y + height, x + width, y + height, x + width, y + height - radius, recPoints);
	    this.quadraticBezierCurve(x + width, y + radius, x + width, y, x + width - radius, y, recPoints);
	    this.quadraticBezierCurve(x + radius, y, x, y, x, y + radius + 0.0000000001, recPoints);
	
	    // this tiny number deals with the issue that occurs when points overlap and earcut fails to triangulate the item.
	    // TODO - fix this properly, this is not very elegant.. but it works for now.
	
	    if (graphicsData.fill)
	    {
	        var color = utils.hex2rgb(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var vecPos = verts.length/6;
	
	        var triangles = earcut(recPoints, null, 2);
	
	        var i = 0;
	        for (i = 0; i < triangles.length; i+=3)
	        {
	            indices.push(triangles[i] + vecPos);
	            indices.push(triangles[i] + vecPos);
	            indices.push(triangles[i+1] + vecPos);
	            indices.push(triangles[i+2] + vecPos);
	            indices.push(triangles[i+2] + vecPos);
	        }
	
	        for (i = 0; i < recPoints.length; i++)
	        {
	            verts.push(recPoints[i], recPoints[++i], r, g, b, alpha);
	        }
	    }
	
	    if (graphicsData.lineWidth)
	    {
	        var tempPoints = graphicsData.points;
	
	        graphicsData.points = recPoints;
	
	        this.buildLine(graphicsData, webGLData);
	
	        graphicsData.points = tempPoints;
	    }
	};
	
	/**
	 * Calculate the points for a quadratic bezier curve. (helper function..)
	 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	 *
	 * @private
	 * @param fromX {number} Origin point x
	 * @param fromY {number} Origin point x
	 * @param cpX {number} Control point x
	 * @param cpY {number} Control point y
	 * @param toX {number} Destination point x
	 * @param toY {number} Destination point y
	 * @param [out] {number[]} The output array to add points into. If not passed, a new array is created.
	 * @return {number[]} an array of points
	 */
	GraphicsRenderer.prototype.quadraticBezierCurve = function (fromX, fromY, cpX, cpY, toX, toY, out)
	{
	    var xa,
	        ya,
	        xb,
	        yb,
	        x,
	        y,
	        n = 20,
	        points = out || [];
	
	    function getPt(n1 , n2, perc) {
	        var diff = n2 - n1;
	
	        return n1 + ( diff * perc );
	    }
	
	    var j = 0;
	    for (var i = 0; i <= n; i++ ) {
	        j = i / n;
	
	        // The Green Line
	        xa = getPt( fromX , cpX , j );
	        ya = getPt( fromY , cpY , j );
	        xb = getPt( cpX , toX , j );
	        yb = getPt( cpY , toY , j );
	
	        // The Black Dot
	        x = getPt( xa , xb , j );
	        y = getPt( ya , yb , j );
	
	        points.push(x, y);
	    }
	
	    return points;
	};
	
	/**
	 * Builds a circle to draw
	 *
	 * @private
	 * @param graphicsData {PIXI.Graphics} The graphics object to draw
	 * @param webGLData {object} an object containing all the webGL-specific information to create this shape
	 */
	GraphicsRenderer.prototype.buildCircle = function (graphicsData, webGLData)
	{
	    // need to convert points to a nice regular data
	    var circleData = graphicsData.shape;
	    var x = circleData.x;
	    var y = circleData.y;
	    var width;
	    var height;
	
	    // TODO - bit hacky??
	    if (graphicsData.type === CONST.SHAPES.CIRC)
	    {
	        width = circleData.radius;
	        height = circleData.radius;
	    }
	    else
	    {
	        width = circleData.width;
	        height = circleData.height;
	    }
	
	    var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius)) || Math.floor(15 * Math.sqrt(circleData.width + circleData.height));
	    var seg = (Math.PI * 2) / totalSegs ;
	
	    var i = 0;
	
	    if (graphicsData.fill)
	    {
	        var color = utils.hex2rgb(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var vecPos = verts.length/6;
	
	        indices.push(vecPos);
	
	        for (i = 0; i < totalSegs + 1 ; i++)
	        {
	            verts.push(x,y, r, g, b, alpha);
	
	            verts.push(x + Math.sin(seg * i) * width,
	                       y + Math.cos(seg * i) * height,
	                       r, g, b, alpha);
	
	            indices.push(vecPos++, vecPos++);
	        }
	
	        indices.push(vecPos-1);
	    }
	
	    if (graphicsData.lineWidth)
	    {
	        var tempPoints = graphicsData.points;
	
	        graphicsData.points = [];
	
	        for (i = 0; i < totalSegs + 1; i++)
	        {
	            graphicsData.points.push(x + Math.sin(seg * i) * width,
	                                     y + Math.cos(seg * i) * height);
	        }
	
	        this.buildLine(graphicsData, webGLData);
	
	        graphicsData.points = tempPoints;
	    }
	};
	
	/**
	 * Builds a line to draw
	 *
	 * @private
	 * @param graphicsData {PIXI.Graphics} The graphics object containing all the necessary properties
	 * @param webGLData {object} an object containing all the webGL-specific information to create this shape
	 */
	GraphicsRenderer.prototype.buildLine = function (graphicsData, webGLData)
	{
	    // TODO OPTIMISE!
	    var i = 0;
	    var points = graphicsData.points;
	
	    if (points.length === 0)
	    {
	        return;
	    }
	    // if the line width is an odd number add 0.5 to align to a whole pixel
	    // commenting this out fixes #711 and #1620
	    // if (graphicsData.lineWidth%2)
	    // {
	    //     for (i = 0; i < points.length; i++)
	    //     {
	    //         points[i] += 0.5;
	    //     }
	    // }
	
	    // get first and last point.. figure out the middle!
	    var firstPoint = new math.Point(points[0], points[1]);
	    var lastPoint = new math.Point(points[points.length - 2], points[points.length - 1]);
	
	    // if the first point is the last point - gonna have issues :)
	    if (firstPoint.x === lastPoint.x && firstPoint.y === lastPoint.y)
	    {
	        // need to clone as we are going to slightly modify the shape..
	        points = points.slice();
	
	        points.pop();
	        points.pop();
	
	        lastPoint = new math.Point(points[points.length - 2], points[points.length - 1]);
	
	        var midPointX = lastPoint.x + (firstPoint.x - lastPoint.x) *0.5;
	        var midPointY = lastPoint.y + (firstPoint.y - lastPoint.y) *0.5;
	
	        points.unshift(midPointX, midPointY);
	        points.push(midPointX, midPointY);
	    }
	
	    var verts = webGLData.points;
	    var indices = webGLData.indices;
	    var length = points.length / 2;
	    var indexCount = points.length;
	    var indexStart = verts.length/6;
	
	    // DRAW the Line
	    var width = graphicsData.lineWidth / 2;
	
	    // sort color
	    var color = utils.hex2rgb(graphicsData.lineColor);
	    var alpha = graphicsData.lineAlpha;
	    var r = color[0] * alpha;
	    var g = color[1] * alpha;
	    var b = color[2] * alpha;
	
	    var px, py, p1x, p1y, p2x, p2y, p3x, p3y;
	    var perpx, perpy, perp2x, perp2y, perp3x, perp3y;
	    var a1, b1, c1, a2, b2, c2;
	    var denom, pdist, dist;
	
	    p1x = points[0];
	    p1y = points[1];
	
	    p2x = points[2];
	    p2y = points[3];
	
	    perpx = -(p1y - p2y);
	    perpy =  p1x - p2x;
	
	    dist = Math.sqrt(perpx*perpx + perpy*perpy);
	
	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;
	
	    // start
	    verts.push(p1x - perpx , p1y - perpy,
	                r, g, b, alpha);
	
	    verts.push(p1x + perpx , p1y + perpy,
	                r, g, b, alpha);
	
	    for (i = 1; i < length-1; i++)
	    {
	        p1x = points[(i-1)*2];
	        p1y = points[(i-1)*2 + 1];
	
	        p2x = points[(i)*2];
	        p2y = points[(i)*2 + 1];
	
	        p3x = points[(i+1)*2];
	        p3y = points[(i+1)*2 + 1];
	
	        perpx = -(p1y - p2y);
	        perpy = p1x - p2x;
	
	        dist = Math.sqrt(perpx*perpx + perpy*perpy);
	        perpx /= dist;
	        perpy /= dist;
	        perpx *= width;
	        perpy *= width;
	
	        perp2x = -(p2y - p3y);
	        perp2y = p2x - p3x;
	
	        dist = Math.sqrt(perp2x*perp2x + perp2y*perp2y);
	        perp2x /= dist;
	        perp2y /= dist;
	        perp2x *= width;
	        perp2y *= width;
	
	        a1 = (-perpy + p1y) - (-perpy + p2y);
	        b1 = (-perpx + p2x) - (-perpx + p1x);
	        c1 = (-perpx + p1x) * (-perpy + p2y) - (-perpx + p2x) * (-perpy + p1y);
	        a2 = (-perp2y + p3y) - (-perp2y + p2y);
	        b2 = (-perp2x + p2x) - (-perp2x + p3x);
	        c2 = (-perp2x + p3x) * (-perp2y + p2y) - (-perp2x + p2x) * (-perp2y + p3y);
	
	        denom = a1*b2 - a2*b1;
	
	        if (Math.abs(denom) < 0.1 )
	        {
	
	            denom+=10.1;
	            verts.push(p2x - perpx , p2y - perpy,
	                r, g, b, alpha);
	
	            verts.push(p2x + perpx , p2y + perpy,
	                r, g, b, alpha);
	
	            continue;
	        }
	
	        px = (b1*c2 - b2*c1)/denom;
	        py = (a2*c1 - a1*c2)/denom;
	
	
	        pdist = (px -p2x) * (px -p2x) + (py -p2y) * (py -p2y);
	
	
	        if (pdist > 140 * 140)
	        {
	            perp3x = perpx - perp2x;
	            perp3y = perpy - perp2y;
	
	            dist = Math.sqrt(perp3x*perp3x + perp3y*perp3y);
	            perp3x /= dist;
	            perp3y /= dist;
	            perp3x *= width;
	            perp3y *= width;
	
	            verts.push(p2x - perp3x, p2y -perp3y);
	            verts.push(r, g, b, alpha);
	
	            verts.push(p2x + perp3x, p2y +perp3y);
	            verts.push(r, g, b, alpha);
	
	            verts.push(p2x - perp3x, p2y -perp3y);
	            verts.push(r, g, b, alpha);
	
	            indexCount++;
	        }
	        else
	        {
	
	            verts.push(px , py);
	            verts.push(r, g, b, alpha);
	
	            verts.push(p2x - (px-p2x), p2y - (py - p2y));
	            verts.push(r, g, b, alpha);
	        }
	    }
	
	    p1x = points[(length-2)*2];
	    p1y = points[(length-2)*2 + 1];
	
	    p2x = points[(length-1)*2];
	    p2y = points[(length-1)*2 + 1];
	
	    perpx = -(p1y - p2y);
	    perpy = p1x - p2x;
	
	    dist = Math.sqrt(perpx*perpx + perpy*perpy);
	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;
	
	    verts.push(p2x - perpx , p2y - perpy);
	    verts.push(r, g, b, alpha);
	
	    verts.push(p2x + perpx , p2y + perpy);
	    verts.push(r, g, b, alpha);
	
	    indices.push(indexStart);
	
	    for (i = 0; i < indexCount; i++)
	    {
	        indices.push(indexStart++);
	    }
	
	    indices.push(indexStart-1);
	};
	
	/**
	 * Builds a complex polygon to draw
	 *
	 * @private
	 * @param graphicsData {PIXI.Graphics} The graphics object containing all the necessary properties
	 * @param webGLData {object} an object containing all the webGL-specific information to create this shape
	 */
	GraphicsRenderer.prototype.buildComplexPoly = function (graphicsData, webGLData)
	{
	    //TODO - no need to copy this as it gets turned into a FLoat32Array anyways..
	    var points = graphicsData.points.slice();
	
	    if (points.length < 6)
	    {
	        return;
	    }
	
	    // get first and last point.. figure out the middle!
	    var indices = webGLData.indices;
	    webGLData.points = points;
	    webGLData.alpha = graphicsData.fillAlpha;
	    webGLData.color = utils.hex2rgb(graphicsData.fillColor);
	
	    // calclate the bounds..
	    var minX = Infinity;
	    var maxX = -Infinity;
	
	    var minY = Infinity;
	    var maxY = -Infinity;
	
	    var x,y;
	
	    // get size..
	    for (var i = 0; i < points.length; i+=2)
	    {
	        x = points[i];
	        y = points[i+1];
	
	        minX = x < minX ? x : minX;
	        maxX = x > maxX ? x : maxX;
	
	        minY = y < minY ? y : minY;
	        maxY = y > maxY ? y : maxY;
	    }
	
	    // add a quad to the end cos there is no point making another buffer!
	    points.push(minX, minY,
	                maxX, minY,
	                maxX, maxY,
	                minX, maxY);
	
	    // push a quad onto the end..
	
	    //TODO - this aint needed!
	    var length = points.length / 2;
	    for (i = 0; i < length; i++)
	    {
	        indices.push( i );
	    }
	
	};
	
	/**
	 * Builds a polygon to draw
	 *
	 * @private
	 * @param graphicsData {PIXI.WebGLGraphicsData} The graphics object containing all the necessary properties
	 * @param webGLData {object} an object containing all the webGL-specific information to create this shape
	 */
	GraphicsRenderer.prototype.buildPoly = function (graphicsData, webGLData)
	{
	    var points = graphicsData.points;
	
	    if (points.length < 6)
	    {
	        return;
	    }
	
	    // get first and last point.. figure out the middle!
	    var verts = webGLData.points;
	    var indices = webGLData.indices;
	
	    var length = points.length / 2;
	
	    // sort color
	    var color = utils.hex2rgb(graphicsData.fillColor);
	    var alpha = graphicsData.fillAlpha;
	    var r = color[0] * alpha;
	    var g = color[1] * alpha;
	    var b = color[2] * alpha;
	
	    var triangles = earcut(points, null, 2);
	
	    if (!triangles) {
	        return false;
	    }
	
	    var vertPos = verts.length / 6;
	
	    var i = 0;
	
	    for (i = 0; i < triangles.length; i+=3)
	    {
	        indices.push(triangles[i] + vertPos);
	        indices.push(triangles[i] + vertPos);
	        indices.push(triangles[i+1] + vertPos);
	        indices.push(triangles[i+2] +vertPos);
	        indices.push(triangles[i+2] + vertPos);
	    }
	
	    for (i = 0; i < length; i++)
	    {
	        verts.push(points[i * 2], points[i * 2 + 1],
	                   r, g, b, alpha);
	    }
	
	    return true;
	};


/***/ },
/* 178 */
/*!****************************************************************!*\
  !*** ./~/pixi.js/src/core/graphics/webgl/WebGLGraphicsData.js ***!
  \****************************************************************/
/***/ function(module, exports) {

	/**
	 * An object containing WebGL specific properties to be used by the WebGL renderer
	 *
	 * @class
	 * @memberof PIXI
	 * @param gl {WebGLRenderingContext} the current WebGL drawing context
	 * @private
	 */
	function WebGLGraphicsData(gl) {
	
	    /**
	     * The current WebGL drawing context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    //TODO does this need to be split before uploding??
	    /**
	     * An array of color components (r,g,b)
	     * @member {number[]}
	     */
	    this.color = [0,0,0]; // color split!
	
	    /**
	     * An array of points to draw
	     * @member {PIXI.Point[]}
	     */
	    this.points = [];
	
	    /**
	     * The indices of the vertices
	     * @member {number[]}
	     */
	    this.indices = [];
	    /**
	     * The main buffer
	     * @member {WebGLBuffer}
	     */
	    this.buffer = gl.createBuffer();
	
	    /**
	     * The index buffer
	     * @member {WebGLBuffer}
	     */
	    this.indexBuffer = gl.createBuffer();
	
	    /**
	     * todo @alvin
	     * @member {number}
	     */
	    this.mode = 1;
	
	    /**
	     * The alpha of the graphics
	     * @member {number}
	     */
	    this.alpha = 1;
	
	    /**
	     * Whether this graphics is dirty or not
	     * @member {boolean}
	     */
	    this.dirty = true;
	
	    this.glPoints = null;
	    this.glIndices = null;
	}
	
	WebGLGraphicsData.prototype.constructor = WebGLGraphicsData;
	module.exports = WebGLGraphicsData;
	
	/**
	 * Resets the vertices and the indices
	 */
	WebGLGraphicsData.prototype.reset = function () {
	    this.points.length = 0;
	    this.indices.length = 0;
	};
	
	/**
	 * Binds the buffers and uploads the data
	 */
	WebGLGraphicsData.prototype.upload = function () {
	    var gl = this.gl;
	
	//    this.lastIndex = graphics.graphicsData.length;
	    this.glPoints = new Float32Array(this.points);
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
	    gl.bufferData(gl.ARRAY_BUFFER, this.glPoints, gl.STATIC_DRAW);
	
	    this.glIndices = new Uint16Array(this.indices);
	
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.glIndices, gl.STATIC_DRAW);
	
	    this.dirty = false;
	};
	
	WebGLGraphicsData.prototype.destroy = function () {
	    this.color = null;
	    this.points = null;
	    this.indices = null;
	
	    this.gl.deleteBuffer(this.buffer);
	    this.gl.deleteBuffer(this.indexBuffer);
	    
	    this.gl = null;
	
	    this.buffer = null;
	    this.indexBuffer = null;
	
	    this.glPoints = null;
	    this.glIndices = null;
	};


/***/ },
/* 179 */
/*!**************************************************!*\
  !*** ./~/pixi.js/src/core/math/shapes/Circle.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Rectangle = __webpack_require__(/*! ./Rectangle */ 57),
	    CONST = __webpack_require__(/*! ../../const */ 6);
	
	/**
	 * The Circle object can be used to specify a hit area for displayObjects
	 *
	 * @class
	 * @memberof PIXI
	 * @param x {number} The X coordinate of the center of this circle
	 * @param y {number} The Y coordinate of the center of this circle
	 * @param radius {number} The radius of the circle
	 */
	function Circle(x, y, radius)
	{
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.radius = radius || 0;
	
	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     */
	    this.type = CONST.SHAPES.CIRC;
	}
	
	Circle.prototype.constructor = Circle;
	module.exports = Circle;
	
	/**
	 * Creates a clone of this Circle instance
	 *
	 * @return {PIXI.Circle} a copy of the Circle
	 */
	Circle.prototype.clone = function ()
	{
	    return new Circle(this.x, this.y, this.radius);
	};
	
	/**
	 * Checks whether the x and y coordinates given are contained within this circle
	 *
	 * @param x {number} The X coordinate of the point to test
	 * @param y {number} The Y coordinate of the point to test
	 * @return {boolean} Whether the x/y coordinates are within this Circle
	 */
	Circle.prototype.contains = function (x, y)
	{
	    if (this.radius <= 0)
	    {
	        return false;
	    }
	
	    var dx = (this.x - x),
	        dy = (this.y - y),
	        r2 = this.radius * this.radius;
	
	    dx *= dx;
	    dy *= dy;
	
	    return (dx + dy <= r2);
	};
	
	/**
	* Returns the framing rectangle of the circle as a Rectangle object
	*
	* @return {PIXI.Rectangle} the framing rectangle
	*/
	Circle.prototype.getBounds = function ()
	{
	    return new Rectangle(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
	};


/***/ },
/* 180 */
/*!***************************************************!*\
  !*** ./~/pixi.js/src/core/math/shapes/Ellipse.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Rectangle = __webpack_require__(/*! ./Rectangle */ 57),
	    CONST = __webpack_require__(/*! ../../const */ 6);
	
	/**
	 * The Ellipse object can be used to specify a hit area for displayObjects
	 *
	 * @class
	 * @memberof PIXI
	 * @param x {number} The X coordinate of the center of the ellipse
	 * @param y {number} The Y coordinate of the center of the ellipse
	 * @param width {number} The half width of this ellipse
	 * @param height {number} The half height of this ellipse
	 */
	function Ellipse(x, y, width, height)
	{
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.width = width || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.height = height || 0;
	
	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     */
	    this.type = CONST.SHAPES.ELIP;
	}
	
	Ellipse.prototype.constructor = Ellipse;
	module.exports = Ellipse;
	
	/**
	 * Creates a clone of this Ellipse instance
	 *
	 * @return {PIXI.Ellipse} a copy of the ellipse
	 */
	Ellipse.prototype.clone = function ()
	{
	    return new Ellipse(this.x, this.y, this.width, this.height);
	};
	
	/**
	 * Checks whether the x and y coordinates given are contained within this ellipse
	 *
	 * @param x {number} The X coordinate of the point to test
	 * @param y {number} The Y coordinate of the point to test
	 * @return {boolean} Whether the x/y coords are within this ellipse
	 */
	Ellipse.prototype.contains = function (x, y)
	{
	    if (this.width <= 0 || this.height <= 0)
	    {
	        return false;
	    }
	
	    //normalize the coords to an ellipse with center 0,0
	    var normx = ((x - this.x) / this.width),
	        normy = ((y - this.y) / this.height);
	
	    normx *= normx;
	    normy *= normy;
	
	    return (normx + normy <= 1);
	};
	
	/**
	 * Returns the framing rectangle of the ellipse as a Rectangle object
	 *
	 * @return {PIXI.Rectangle} the framing rectangle
	 */
	Ellipse.prototype.getBounds = function ()
	{
	    return new Rectangle(this.x - this.width, this.y - this.height, this.width, this.height);
	};


/***/ },
/* 181 */
/*!***************************************************!*\
  !*** ./~/pixi.js/src/core/math/shapes/Polygon.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Point = __webpack_require__(/*! ../Point */ 56),
	    CONST = __webpack_require__(/*! ../../const */ 6);
	
	/**
	 * @class
	 * @memberof PIXI
	 * @param points {PIXI.Point[]|number[]|...PIXI.Point|...number} This can be an array of Points that form the polygon,
	 *      a flat array of numbers that will be interpreted as [x,y, x,y, ...], or the arguments passed can be
	 *      all the points of the polygon e.g. `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the
	 *      arguments passed can be flat x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are
	 *      Numbers.
	 */
	function Polygon(points_)
	{
	    // prevents an argument assignment deopt
	    // see section 3.1: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	    var points = points_;
	
	    //if points isn't an array, use arguments as the array
	    if (!Array.isArray(points))
	    {
	        // prevents an argument leak deopt
	        // see section 3.2: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	        points = new Array(arguments.length);
	
	        for (var a = 0; a < points.length; ++a) {
	            points[a] = arguments[a];
	        }
	    }
	
	    // if this is an array of points, convert it to a flat array of numbers
	    if (points[0] instanceof Point)
	    {
	        var p = [];
	        for (var i = 0, il = points.length; i < il; i++)
	        {
	            p.push(points[i].x, points[i].y);
	        }
	
	        points = p;
	    }
	
	    this.closed = true;
	
	    /**
	     * An array of the points of this polygon
	     *
	     * @member {number[]}
	     */
	    this.points = points;
	
	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     */
	    this.type = CONST.SHAPES.POLY;
	}
	
	Polygon.prototype.constructor = Polygon;
	module.exports = Polygon;
	
	/**
	 * Creates a clone of this polygon
	 *
	 * @return {PIXI.Polygon} a copy of the polygon
	 */
	Polygon.prototype.clone = function ()
	{
	    return new Polygon(this.points.slice());
	};
	
	/**
	 * Checks whether the x and y coordinates passed to this function are contained within this polygon
	 *
	 * @param x {number} The X coordinate of the point to test
	 * @param y {number} The Y coordinate of the point to test
	 * @return {boolean} Whether the x/y coordinates are within this polygon
	 */
	Polygon.prototype.contains = function (x, y)
	{
	    var inside = false;
	
	    // use some raycasting to test hits
	    // https://github.com/substack/point-in-polygon/blob/master/index.js
	    var length = this.points.length / 2;
	
	    for (var i = 0, j = length - 1; i < length; j = i++)
	    {
	        var xi = this.points[i * 2], yi = this.points[i * 2 + 1],
	            xj = this.points[j * 2], yj = this.points[j * 2 + 1],
	            intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
	
	        if (intersect)
	        {
	            inside = !inside;
	        }
	    }
	
	    return inside;
	};


/***/ },
/* 182 */
/*!************************************************************!*\
  !*** ./~/pixi.js/src/core/math/shapes/RoundedRectangle.js ***!
  \************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var CONST = __webpack_require__(/*! ../../const */ 6);
	
	/**
	 * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its top-left corner point (x, y) and by its width and its height and its radius.
	 *
	 * @class
	 * @memberof PIXI
	 * @param x {number} The X coordinate of the upper-left corner of the rounded rectangle
	 * @param y {number} The Y coordinate of the upper-left corner of the rounded rectangle
	 * @param width {number} The overall width of this rounded rectangle
	 * @param height {number} The overall height of this rounded rectangle
	 * @param radius {number} Controls the radius of the rounded corners
	 */
	function RoundedRectangle(x, y, width, height, radius)
	{
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.width = width || 0;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.height = height || 0;
	
	    /**
	     * @member {number}
	     * @default 20
	     */
	    this.radius = radius || 20;
	
	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     */
	    this.type = CONST.SHAPES.RREC;
	}
	
	RoundedRectangle.prototype.constructor = RoundedRectangle;
	module.exports = RoundedRectangle;
	
	/**
	 * Creates a clone of this Rounded Rectangle
	 *
	 * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
	 */
	RoundedRectangle.prototype.clone = function ()
	{
	    return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
	};
	
	/**
	 * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
	 *
	 * @param x {number} The X coordinate of the point to test
	 * @param y {number} The Y coordinate of the point to test
	 * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
	 */
	RoundedRectangle.prototype.contains = function (x, y)
	{
	    if (this.width <= 0 || this.height <= 0)
	    {
	        return false;
	    }
	
	    if (x >= this.x && x <= this.x + this.width)
	    {
	        if (y >= this.y && y <= this.y + this.height)
	        {
	            return true;
	        }
	    }
	
	    return false;
	};


/***/ },
/* 183 */
/*!***********************************************************!*\
  !*** ./~/pixi.js/src/core/particles/ParticleContainer.js ***!
  \***********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Container = __webpack_require__(/*! ../display/Container */ 36),
	    CONST = __webpack_require__(/*! ../const */ 6);
	
	/**
	 * The ParticleContainer class is a really fast version of the Container built solely for speed,
	 * so use when you need a lot of sprites or particles. The tradeoff of the ParticleContainer is that advanced
	 * functionality will not work. ParticleContainer implements only the basic object transform (position, scale, rotation).
	 * Any other functionality like tinting, masking, etc will not work on sprites in this batch.
	 *
	 * It's extremely easy to use :
	 *
	 * ```js
	 * var container = new ParticleContainer();
	 *
	 * for (var i = 0; i < 100; ++i)
	 * {
	 *     var sprite = new PIXI.Sprite.fromImage("myImage.png");
	 *     container.addChild(sprite);
	 * }
	 * ```
	 *
	 * And here you have a hundred sprites that will be renderer at the speed of light.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 * @param [maxSize=15000] {number} The maximum number of particles that can be renderer by the container.
	 * @param [properties] {object} The properties of children that should be uploaded to the gpu and applied.
	 * @param [properties.scale=false] {boolean} When true, scale be uploaded and applied.
	 * @param [properties.position=true] {boolean} When true, position be uploaded and applied.
	 * @param [properties.rotation=false] {boolean} When true, rotation be uploaded and applied.
	 * @param [properties.uvs=false] {boolean} When true, uvs be uploaded and applied.
	 * @param [properties.alpha=false] {boolean} When true, alpha be uploaded and applied.
	 * @param [batchSize=15000] {number} Number of particles per batch.
	 */
	function ParticleContainer(maxSize, properties, batchSize)
	{
	    Container.call(this);
	
	    batchSize = batchSize || 15000; //CONST.SPRITE_BATCH_SIZE; // 2000 is a nice balance between mobile / desktop
	    maxSize = maxSize || 15000;
	
	    // Making sure the batch size is valid
	    // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	    // so max number of particles is 65536 / 4 = 16384
	    var maxBatchSize = 16384;
	    if (batchSize > maxBatchSize) {
	        batchSize = maxBatchSize;
	    }
	
	    if (batchSize > maxSize) {
	        batchSize = maxSize;
	    }
	
	    /**
	     * Set properties to be dynamic (true) / static (false)
	     *
	     * @member {boolean[]}
	     * @private
	     */
	    this._properties = [false, true, false, false, false];
	
	    /**
	     * @member {number}
	     * @private
	     */
	    this._maxSize = maxSize;
	
	    /**
	     * @member {number}
	     * @private
	     */
	    this._batchSize = batchSize;
	
	    /**
	     * @member {WebGLBuffer}
	     * @private
	     */
	    this._buffers = null;
	
	    /**
	     * @member {number}
	     * @private
	     */
	    this._bufferToUpdate = 0;
	
	    /**
	     * @member {boolean}
	     *
	     */
	    this.interactiveChildren = false;
	
	    /**
	     * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	     *
	     * @member {number}
	     * @default PIXI.BLEND_MODES.NORMAL
	     * @see PIXI.BLEND_MODES
	     */
	    this.blendMode = CONST.BLEND_MODES.NORMAL;
	
	    /**
	     * Used for canvas renderering. If true then the elements will be positioned at the nearest pixel. This provides a nice speed boost.
	     *
	     * @member {boolean}
	     * @default true;
	     */
	    this.roundPixels = true;
	
	    this.setProperties(properties);
	}
	
	ParticleContainer.prototype = Object.create(Container.prototype);
	ParticleContainer.prototype.constructor = ParticleContainer;
	module.exports = ParticleContainer;
	
	/**
	 * Sets the private properties array to dynamic / static based on the passed properties object
	 *
	 * @param properties {object} The properties to be uploaded
	 */
	ParticleContainer.prototype.setProperties = function(properties)
	{
	    if ( properties ) {
	        this._properties[0] = 'scale' in properties ? !!properties.scale : this._properties[0];
	        this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
	        this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
	        this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
	        this._properties[4] = 'alpha' in properties ? !!properties.alpha : this._properties[4];
	    }
	};
	
	/**
	 * Updates the object transform for rendering
	 *
	 * @private
	 */
	ParticleContainer.prototype.updateTransform = function ()
	{
	
	    // TODO don't need to!
	    this.displayObjectUpdateTransform();
	    //  PIXI.Container.prototype.updateTransform.call( this );
	};
	
	/**
	 * Renders the container using the WebGL renderer
	 *
	 * @param renderer {PIXI.WebGLRenderer} The webgl renderer
	 * @private
	 */
	ParticleContainer.prototype.renderWebGL = function (renderer)
	{
	    if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable)
	    {
	        return;
	    }
	
	    renderer.setObjectRenderer( renderer.plugins.particle );
	    renderer.plugins.particle.render( this );
	};
	
	/**
	 * Set the flag that static data should be updated to true
	 *
	 * @private
	 */
	ParticleContainer.prototype.onChildrenChange = function (smallestChildIndex)
	{
	    var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
	    if (bufferIndex < this._bufferToUpdate) {
	        this._bufferToUpdate = bufferIndex;
	    }
	};
	
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @param renderer {PIXI.CanvasRenderer} The canvas renderer
	 * @private
	 */
	ParticleContainer.prototype.renderCanvas = function (renderer)
	{
	    if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable)
	    {
	        return;
	    }
	
	    var context = renderer.context;
	    var transform = this.worldTransform;
	    var isRotated = true;
	
	    var positionX = 0;
	    var positionY = 0;
	
	    var finalWidth = 0;
	    var finalHeight = 0;
	
	    var compositeOperation = renderer.blendModes[this.blendMode];
	    if (compositeOperation !== context.globalCompositeOperation)
	    {
	        context.globalCompositeOperation = compositeOperation;
	    }
	
	    context.globalAlpha = this.worldAlpha;
	
	    this.displayObjectUpdateTransform();
	
	    for (var i = 0; i < this.children.length; ++i)
	    {
	        var child = this.children[i];
	
	        if (!child.visible)
	        {
	            continue;
	        }
	
	        var frame = child.texture.frame;
	
	        context.globalAlpha = this.worldAlpha * child.alpha;
	
	        if (child.rotation % (Math.PI * 2) === 0)
	        {
	            // this is the fastest  way to optimise! - if rotation is 0 then we can avoid any kind of setTransform call
	            if (isRotated)
	            {
	                context.setTransform(
	                    transform.a,
	                    transform.b,
	                    transform.c,
	                    transform.d,
	                    transform.tx,
	                    transform.ty
	                );
	
	                isRotated = false;
	            }
	
	            positionX = ((child.anchor.x) * (-frame.width * child.scale.x) + child.position.x  + 0.5);
	            positionY = ((child.anchor.y) * (-frame.height * child.scale.y) + child.position.y  + 0.5);
	
	            finalWidth = frame.width * child.scale.x;
	            finalHeight = frame.height * child.scale.y;
	
	        }
	        else
	        {
	            if (!isRotated)
	            {
	                isRotated = true;
	            }
	
	            child.displayObjectUpdateTransform();
	
	            var childTransform = child.worldTransform;
	
	            if (renderer.roundPixels)
	            {
	                context.setTransform(
	                    childTransform.a,
	                    childTransform.b,
	                    childTransform.c,
	                    childTransform.d,
	                    childTransform.tx | 0,
	                    childTransform.ty | 0
	                );
	            }
	            else
	            {
	                context.setTransform(
	                    childTransform.a,
	                    childTransform.b,
	                    childTransform.c,
	                    childTransform.d,
	                    childTransform.tx,
	                    childTransform.ty
	                );
	            }
	
	            positionX = ((child.anchor.x) * (-frame.width) + 0.5);
	            positionY = ((child.anchor.y) * (-frame.height) + 0.5);
	
	            finalWidth = frame.width;
	            finalHeight = frame.height;
	        }
	
	        context.drawImage(
	            child.texture.baseTexture.source,
	            frame.x,
	            frame.y,
	            frame.width,
	            frame.height,
	            positionX,
	            positionY,
	            finalWidth,
	            finalHeight
	        );
	    }
	};
	
	/**
	 * Destroys the container
	 *
	 * @param [destroyChildren=false] {boolean} if set to true, all the children will have their destroy method called as well
	 */
	ParticleContainer.prototype.destroy = function () {
	    Container.prototype.destroy.apply(this, arguments);
	
	    if (this._buffers) {
	        for (var i = 0; i < this._buffers.length; ++i) {
	            this._buffers[i].destroy();
	        }
	    }
	
	    this._properties = null;
	    this._buffers = null;
	};


/***/ },
/* 184 */
/*!**************************************************************!*\
  !*** ./~/pixi.js/src/core/particles/webgl/ParticleBuffer.js ***!
  \**************************************************************/
/***/ function(module, exports) {

	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original pixi version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleBuffer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
	 */
	
	/**
	 * The particle buffer manages the static and dynamic buffers for a particle container.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	function ParticleBuffer(gl, properties, dynamicPropertyFlags, size)
	{
	    /**
	     * The current WebGL drawing context.
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    /**
	     * Size of a single vertex.
	     *
	     * @member {number}
	     */
	    this.vertSize = 2;
	
	    /**
	     * Size of a single vertex in bytes.
	     *
	     * @member {number}
	     */
	    this.vertByteSize = this.vertSize * 4;
	
	    /**
	     * The number of particles the buffer can hold
	     *
	     * @member {number}
	     */
	    this.size = size;
	
	    /**
	     * A list of the properties that are dynamic.
	     *
	     * @member {object[]}
	     */
	    this.dynamicProperties = [];
	
	    /**
	     * A list of the properties that are static.
	     *
	     * @member {object[]}
	     */
	    this.staticProperties = [];
	
	    for (var i = 0; i < properties.length; i++)
	    {
	        var property = properties[i];
	
	        if(dynamicPropertyFlags[i])
	        {
	            this.dynamicProperties.push(property);
	        }
	        else
	        {
	            this.staticProperties.push(property);
	        }
	    }
	
	    this.staticStride = 0;
	    this.staticBuffer = null;
	    this.staticData = null;
	
	    this.dynamicStride = 0;
	    this.dynamicBuffer = null;
	    this.dynamicData = null;
	
	    this.initBuffers();
	
	}
	
	ParticleBuffer.prototype.constructor = ParticleBuffer;
	module.exports = ParticleBuffer;
	
	/**
	 * Sets up the renderer context and necessary buffers.
	 *
	 * @private
	 */
	ParticleBuffer.prototype.initBuffers = function ()
	{
	    var gl = this.gl;
	    var i;
	    var property;
	
	    var dynamicOffset = 0;
	    this.dynamicStride = 0;
	
	    for (i = 0; i < this.dynamicProperties.length; i++)
	    {
	        property = this.dynamicProperties[i];
	
	        property.offset = dynamicOffset;
	        dynamicOffset += property.size;
	        this.dynamicStride += property.size;
	    }
	
	    this.dynamicData = new Float32Array( this.size * this.dynamicStride * 4);
	    this.dynamicBuffer = gl.createBuffer();
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.dynamicBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, this.dynamicData, gl.DYNAMIC_DRAW);
	
	
	    // static //
	    var staticOffset = 0;
	    this.staticStride = 0;
	
	    for (i = 0; i < this.staticProperties.length; i++)
	    {
	        property = this.staticProperties[i];
	
	        property.offset = staticOffset;
	        staticOffset += property.size;
	        this.staticStride += property.size;
	    }
	
	    this.staticData = new Float32Array( this.size * this.staticStride * 4);
	    this.staticBuffer = gl.createBuffer();
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.staticBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, this.staticData, gl.DYNAMIC_DRAW);
	};
	
	/**
	 * Uploads the dynamic properties.
	 *
	 */
	ParticleBuffer.prototype.uploadDynamic = function(children, startIndex, amount)
	{
	    var gl = this.gl;
	
	    for (var i = 0; i < this.dynamicProperties.length; i++)
	    {
	        var property = this.dynamicProperties[i];
	        property.uploadFunction(children, startIndex, amount, this.dynamicData, this.dynamicStride, property.offset);
	    }
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.dynamicBuffer);
	    gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.dynamicData);
	};
	
	/**
	 * Uploads the static properties.
	 *
	 */
	ParticleBuffer.prototype.uploadStatic = function(children, startIndex, amount)
	{
	    var gl = this.gl;
	
	    for (var i = 0; i < this.staticProperties.length; i++)
	    {
	        var property = this.staticProperties[i];
	        property.uploadFunction(children, startIndex, amount, this.staticData, this.staticStride, property.offset);
	    }
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.staticBuffer);
	    gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.staticData);
	};
	
	/**
	 * Binds the buffers to the GPU
	 *
	 */
	ParticleBuffer.prototype.bind = function ()
	{
	    var gl = this.gl;
	    var i, property;
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.dynamicBuffer);
	
	    for (i = 0; i < this.dynamicProperties.length; i++)
	    {
	        property = this.dynamicProperties[i];
	        gl.vertexAttribPointer(property.attribute, property.size, gl.FLOAT, false, this.dynamicStride * 4, property.offset * 4);
	    }
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.staticBuffer);
	
	    for (i = 0; i < this.staticProperties.length; i++)
	    {
	        property = this.staticProperties[i];
	        gl.vertexAttribPointer(property.attribute, property.size, gl.FLOAT, false, this.staticStride * 4, property.offset * 4);
	    }
	};
	
	/**
	 * Destroys the ParticleBuffer.
	 *
	 */
	ParticleBuffer.prototype.destroy = function ()
	{
	    this.dynamicProperties = null;
	    this.dynamicData = null;
	    this.gl.deleteBuffer(this.dynamicBuffer);
	
	    this.staticProperties = null;
	    this.staticData = null;
	    this.gl.deleteBuffer(this.staticBuffer);
	};


/***/ },
/* 185 */
/*!****************************************************************!*\
  !*** ./~/pixi.js/src/core/particles/webgl/ParticleRenderer.js ***!
  \****************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var ObjectRenderer = __webpack_require__(/*! ../../renderers/webgl/utils/ObjectRenderer */ 29),
	    WebGLRenderer = __webpack_require__(/*! ../../renderers/webgl/WebGLRenderer */ 37),
	    ParticleShader = __webpack_require__(/*! ./ParticleShader */ 186),
	    ParticleBuffer = __webpack_require__(/*! ./ParticleBuffer */ 184),
	    math            = __webpack_require__(/*! ../../math */ 9);
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original pixi version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
	 */
	
	/**
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 * @param renderer {PIXI.WebGLRenderer} The renderer this sprite batch works for.
	 */
	function ParticleRenderer(renderer)
	{
	    ObjectRenderer.call(this, renderer);
	
	    // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	    // so max number of particles is 65536 / 4 = 16384
	    // and max number of element in the index buffer is 16384 * 6 = 98304
	    // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
	    var numIndices = 98304;
	
	    /**
	     * Holds the indices
	     *
	     * @member {Uint16Array}
	     */
	    this.indices = new Uint16Array(numIndices);
	
	    for (var i=0, j=0; i < numIndices; i += 6, j += 4)
	    {
	        this.indices[i + 0] = j + 0;
	        this.indices[i + 1] = j + 1;
	        this.indices[i + 2] = j + 2;
	        this.indices[i + 3] = j + 0;
	        this.indices[i + 4] = j + 2;
	        this.indices[i + 5] = j + 3;
	    }
	
	    /**
	     * The default shader that is used if a sprite doesn't have a more specific one.
	     *
	     * @member {PIXI.Shader}
	     */
	    this.shader = null;
	
	    this.indexBuffer = null;
	
	    this.properties = null;
	
	    this.tempMatrix = new math.Matrix();
	}
	
	ParticleRenderer.prototype = Object.create(ObjectRenderer.prototype);
	ParticleRenderer.prototype.constructor = ParticleRenderer;
	module.exports = ParticleRenderer;
	
	WebGLRenderer.registerPlugin('particle', ParticleRenderer);
	
	/**
	 * When there is a WebGL context change
	 *
	 * @private
	 */
	ParticleRenderer.prototype.onContextChange = function ()
	{
	    var gl = this.renderer.gl;
	
	    // setup default shader
	    this.shader = new ParticleShader(this.renderer.shaderManager);
	
	    this.indexBuffer = gl.createBuffer();
	
	    // 65535 is max index, so 65535 / 6 = 10922.
	
	    //upload the index data
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices, gl.STATIC_DRAW);
	
	    this.properties = [
	        // verticesData
	        {
	            attribute:this.shader.attributes.aVertexPosition,
	            size:2,
	            uploadFunction:this.uploadVertices,
	            offset:0
	        },
	        // positionData
	        {
	            attribute:this.shader.attributes.aPositionCoord,
	            size:2,
	            uploadFunction:this.uploadPosition,
	            offset:0
	        },
	        // rotationData
	        {
	            attribute:this.shader.attributes.aRotation,
	            size:1,
	            uploadFunction:this.uploadRotation,
	            offset:0
	        },
	        // uvsData
	        {
	            attribute:this.shader.attributes.aTextureCoord,
	            size:2,
	            uploadFunction:this.uploadUvs,
	            offset:0
	        },
	        // alphaData
	        {
	            attribute:this.shader.attributes.aColor,
	            size:1,
	            uploadFunction:this.uploadAlpha,
	            offset:0
	        }
	    ];
	};
	
	/**
	 * Starts a new particle batch.
	 *
	 */
	ParticleRenderer.prototype.start = function ()
	{
	    var gl = this.renderer.gl;
	
	    // bind the main texture
	    gl.activeTexture(gl.TEXTURE0);
	
	    // bind the buffers
	
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	
	    var shader = this.shader;
	
	    this.renderer.shaderManager.setShader(shader);
	};
	
	
	/**
	 * Renders the particle container object.
	 *
	 * @param container {PIXI.ParticleContainer} The container to render using this ParticleRenderer
	 */
	ParticleRenderer.prototype.render = function (container)
	{
	    var children = container.children,
	        totalChildren = children.length,
	        maxSize = container._maxSize,
	        batchSize = container._batchSize;
	
	    if(totalChildren === 0)
	    {
	        return;
	    }
	    else if(totalChildren > maxSize)
	    {
	        totalChildren = maxSize;
	    }
	
	    if(!container._buffers)
	    {
	        container._buffers = this.generateBuffers( container );
	    }
	
	    // if the uvs have not updated then no point rendering just yet!
	    this.renderer.blendModeManager.setBlendMode(container.blendMode);
	
	    var gl = this.renderer.gl;
	
	    var m =  container.worldTransform.copy( this.tempMatrix );
	    m.prepend( this.renderer.currentRenderTarget.projectionMatrix );
	    gl.uniformMatrix3fv(this.shader.uniforms.projectionMatrix._location, false, m.toArray(true));
	    gl.uniform1f(this.shader.uniforms.uAlpha._location, container.worldAlpha);
	
	
	    // make sure the texture is bound..
	    var baseTexture = children[0]._texture.baseTexture;
	
	    if (!baseTexture._glTextures[gl.id])
	    {
	        // if the texture has not updated then lets not upload any static properties
	        if(!this.renderer.updateTexture(baseTexture))
	        {
	            return;
	        }
	
	        if(!container._properties[0] || !container._properties[3])
	        {
	            container._bufferToUpdate = 0;
	        }
	    }
	    else
	    {
	        gl.bindTexture(gl.TEXTURE_2D, baseTexture._glTextures[gl.id]);
	    }
	
	    // now lets upload and render the buffers..
	    for (var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1)
	    {
	        var amount = ( totalChildren - i);
	        if(amount > batchSize)
	        {
	            amount = batchSize;
	        }
	
	        var buffer = container._buffers[j];
	
	        // we always upload the dynamic
	        buffer.uploadDynamic(children, i, amount);
	
	        // we only upload the static content when we have to!
	        if(container._bufferToUpdate === j)
	        {
	            buffer.uploadStatic(children, i, amount);
	            container._bufferToUpdate = j + 1;
	        }
	
	        // bind the buffer
	        buffer.bind( this.shader );
	
	         // now draw those suckas!
	        gl.drawElements(gl.TRIANGLES, amount * 6, gl.UNSIGNED_SHORT, 0);
	        this.renderer.drawCount++;
	    }
	};
	
	/**
	 * Creates one particle buffer for each child in the container we want to render and updates internal properties
	 *
	 * @param container {PIXI.ParticleContainer} The container to render using this ParticleRenderer
	 */
	ParticleRenderer.prototype.generateBuffers = function (container)
	{
	    var gl = this.renderer.gl,
	        buffers = [],
	        size = container._maxSize,
	        batchSize = container._batchSize,
	        dynamicPropertyFlags = container._properties,
	        i;
	
	    for (i = 0; i < size; i += batchSize)
	    {
	        buffers.push(new ParticleBuffer(gl, this.properties, dynamicPropertyFlags, batchSize));
	    }
	
	    return buffers;
	};
	
	/**
	 * Uploads the verticies.
	 *
	 * @param children {PIXI.DisplayObject[]} the array of display objects to render
	 * @param startIndex {number} the index to start from in the children array
	 * @param amount {number} the amount of children that will have their vertices uploaded
	 * @param array {number[]}
	 * @param stride {number}
	 * @param offset {number}
	 */
	ParticleRenderer.prototype.uploadVertices = function (children, startIndex, amount, array, stride, offset)
	{
	    var sprite,
	        texture,
	        trim,
	        sx,
	        sy,
	        w0, w1, h0, h1;
	
	    for (var i = 0; i < amount; i++) {
	
	        sprite = children[startIndex + i];
	        texture = sprite._texture;
	        sx = sprite.scale.x;
	        sy = sprite.scale.y;
	
	        if (texture.trim)
	        {
	            // if the sprite is trimmed then we need to add the extra space before transforming the sprite coords..
	            trim = texture.trim;
	
	            w1 = trim.x - sprite.anchor.x * trim.width;
	            w0 = w1 + texture.crop.width;
	
	            h1 = trim.y - sprite.anchor.y * trim.height;
	            h0 = h1 + texture.crop.height;
	        }
	        else
	        {
	            w0 = (texture._frame.width ) * (1-sprite.anchor.x);
	            w1 = (texture._frame.width ) * -sprite.anchor.x;
	
	            h0 = texture._frame.height * (1-sprite.anchor.y);
	            h1 = texture._frame.height * -sprite.anchor.y;
	        }
	
	        array[offset] = w1 * sx;
	        array[offset + 1] = h1 * sy;
	
	        array[offset + stride] = w0 * sx;
	        array[offset + stride + 1] = h1 * sy;
	
	        array[offset + stride * 2] = w0 * sx;
	        array[offset + stride * 2 + 1] = h0 * sy;
	
	        array[offset + stride * 3] = w1 * sx;
	        array[offset + stride * 3 + 1] = h0 * sy;
	
	        offset += stride * 4;
	    }
	
	};
	
	/**
	 *
	 * @param children {PIXI.DisplayObject[]} the array of display objects to render
	 * @param startIndex {number} the index to start from in the children array
	 * @param amount {number} the amount of children that will have their positions uploaded
	 * @param array {number[]}
	 * @param stride {number}
	 * @param offset {number}
	 */
	ParticleRenderer.prototype.uploadPosition = function (children,startIndex, amount, array, stride, offset)
	{
	    for (var i = 0; i < amount; i++)
	    {
	        var spritePosition = children[startIndex + i].position;
	
	        array[offset] = spritePosition.x;
	        array[offset + 1] = spritePosition.y;
	
	        array[offset + stride] = spritePosition.x;
	        array[offset + stride + 1] = spritePosition.y;
	
	        array[offset + stride * 2] = spritePosition.x;
	        array[offset + stride * 2 + 1] = spritePosition.y;
	
	        array[offset + stride * 3] = spritePosition.x;
	        array[offset + stride * 3 + 1] = spritePosition.y;
	
	        offset += stride * 4;
	    }
	
	};
	
	/**
	 *
	 * @param children {PIXI.DisplayObject[]} the array of display objects to render
	 * @param startIndex {number} the index to start from in the children array
	 * @param amount {number} the amount of children that will have their rotation uploaded
	 * @param array {number[]}
	 * @param stride {number}
	 * @param offset {number}
	 */
	ParticleRenderer.prototype.uploadRotation = function (children,startIndex, amount, array, stride, offset)
	{
	    for (var i = 0; i < amount; i++)
	    {
	        var spriteRotation = children[startIndex + i].rotation;
	
	
	        array[offset] = spriteRotation;
	        array[offset + stride] = spriteRotation;
	        array[offset + stride * 2] = spriteRotation;
	        array[offset + stride * 3] = spriteRotation;
	
	        offset += stride * 4;
	    }
	};
	
	/**
	 *
	 * @param children {PIXI.DisplayObject[]} the array of display objects to render
	 * @param startIndex {number} the index to start from in the children array
	 * @param amount {number} the amount of children that will have their Uvs uploaded
	 * @param array {number[]}
	 * @param stride {number}
	 * @param offset {number}
	 */
	ParticleRenderer.prototype.uploadUvs = function (children,startIndex, amount, array, stride, offset)
	{
	    for (var i = 0; i < amount; i++)
	    {
	        var textureUvs = children[startIndex + i]._texture._uvs;
	
	        if (textureUvs)
	        {
	            array[offset] = textureUvs.x0;
	            array[offset + 1] = textureUvs.y0;
	
	            array[offset + stride] = textureUvs.x1;
	            array[offset + stride + 1] = textureUvs.y1;
	
	            array[offset + stride * 2] = textureUvs.x2;
	            array[offset + stride * 2 + 1] = textureUvs.y2;
	
	            array[offset + stride * 3] = textureUvs.x3;
	            array[offset + stride * 3 + 1] = textureUvs.y3;
	
	            offset += stride * 4;
	        }
	        else
	        {
	            //TODO you know this can be easier!
	            array[offset] = 0;
	            array[offset + 1] = 0;
	
	            array[offset + stride] = 0;
	            array[offset + stride + 1] = 0;
	
	            array[offset + stride * 2] = 0;
	            array[offset + stride * 2 + 1] = 0;
	
	            array[offset + stride * 3] = 0;
	            array[offset + stride * 3 + 1] = 0;
	
	            offset += stride * 4;
	        }
	    }
	};
	
	/**
	 *
	 * @param children {PIXI.DisplayObject[]} the array of display objects to render
	 * @param startIndex {number} the index to start from in the children array
	 * @param amount {number} the amount of children that will have their alpha uploaded
	 * @param array {number[]}
	 * @param stride {number}
	 * @param offset {number}
	 */
	ParticleRenderer.prototype.uploadAlpha = function (children,startIndex, amount, array, stride, offset)
	{
	     for (var i = 0; i < amount; i++)
	     {
	        var spriteAlpha = children[startIndex + i].alpha;
	
	        array[offset] = spriteAlpha;
	        array[offset + stride] = spriteAlpha;
	        array[offset + stride * 2] = spriteAlpha;
	        array[offset + stride * 3] = spriteAlpha;
	
	        offset += stride * 4;
	    }
	};
	
	
	/**
	 * Destroys the ParticleRenderer.
	 *
	 */
	ParticleRenderer.prototype.destroy = function ()
	{
	    if (this.renderer.gl) {
	        this.renderer.gl.deleteBuffer(this.indexBuffer);
	    }
	
	    ObjectRenderer.prototype.destroy.apply(this, arguments);
	
	    this.shader.destroy();
	
	    this.indices = null;
	    this.tempMatrix = null;
	};


/***/ },
/* 186 */
/*!**************************************************************!*\
  !*** ./~/pixi.js/src/core/particles/webgl/ParticleShader.js ***!
  \**************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var TextureShader = __webpack_require__(/*! ../../renderers/webgl/shaders/TextureShader */ 39);
	
	/**
	 * @class
	 * @extends PIXI.TextureShader
	 * @memberof PIXI
	 * @param shaderManager {ShaderManager} The webgl shader manager this shader works for.
	 */
	function ParticleShader(shaderManager)
	{
	    TextureShader.call(this,
	        shaderManager,
	        // vertex shader
	        [
	            'attribute vec2 aVertexPosition;',
	            'attribute vec2 aTextureCoord;',
	            'attribute float aColor;',
	
	            'attribute vec2 aPositionCoord;',
	            'attribute vec2 aScale;',
	            'attribute float aRotation;',
	
	            'uniform mat3 projectionMatrix;',
	
	            'varying vec2 vTextureCoord;',
	            'varying float vColor;',
	
	            'void main(void){',
	            '   vec2 v = aVertexPosition;',
	
	            '   v.x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);',
	            '   v.y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);',
	            '   v = v + aPositionCoord;',
	
	            '   gl_Position = vec4((projectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);',
	
	            '   vTextureCoord = aTextureCoord;',
	            '   vColor = aColor;',
	            '}'
	        ].join('\n'),
	        // hello
	         [
	            'precision lowp float;',
	
	            'varying vec2 vTextureCoord;',
	            'varying float vColor;',
	
	            'uniform sampler2D uSampler;',
	            'uniform float uAlpha;',
	
	            'void main(void){',
	            '  vec4 color = texture2D(uSampler, vTextureCoord) * vColor * uAlpha;',
	            '  if (color.a == 0.0) discard;',
	            '  gl_FragColor = color;',
	            '}'
	        ].join('\n'),
	        // custom uniforms
	        {
	            uAlpha:  { type: '1f', value: 1 }
	        },
	        // custom attributes
	        {
	            aPositionCoord: 0,
	           // aScale:         0,
	            aRotation:      0
	        }
	    );
	
	    // TEMP HACK
	
	}
	
	ParticleShader.prototype = Object.create(TextureShader.prototype);
	ParticleShader.prototype.constructor = ParticleShader;
	
	module.exports = ParticleShader;


/***/ },
/* 187 */
/*!***************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/canvas/CanvasRenderer.js ***!
  \***************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var SystemRenderer = __webpack_require__(/*! ../SystemRenderer */ 98),
	    CanvasMaskManager = __webpack_require__(/*! ./utils/CanvasMaskManager */ 188),
	    utils = __webpack_require__(/*! ../../utils */ 7),
	    math = __webpack_require__(/*! ../../math */ 9),
	    CONST = __webpack_require__(/*! ../../const */ 6);
	
	/**
	 * The CanvasRenderer draws the scene and all its content onto a 2d canvas. This renderer should be used for browsers that do not support webGL.
	 * Don't forget to add the CanvasRenderer.view to your DOM or you will not see anything :)
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.SystemRenderer
	 * @param [width=800] {number} the width of the canvas view
	 * @param [height=600] {number} the height of the canvas view
	 * @param [options] {object} The optional renderer parameters
	 * @param [options.view] {HTMLCanvasElement} the canvas to use as a view, optional
	 * @param [options.transparent=false] {boolean} If the render view is transparent, default false
	 * @param [options.autoResize=false] {boolean} If the render view is automatically resized, default false
	 * @param [options.antialias=false] {boolean} sets antialias (only applicable in chrome at the moment)
	 * @param [options.resolution=1] {number} the resolution of the renderer retina would be 2
	 * @param [options.clearBeforeRender=true] {boolean} This sets if the CanvasRenderer will clear the canvas or
	 *      not before the new render pass.
	 * @param [options.roundPixels=false] {boolean} If true Pixi will Math.floor() x/y values when rendering, stopping pixel interpolation.
	 */
	function CanvasRenderer(width, height, options)
	{
	    options = options || {};
	
	    SystemRenderer.call(this, 'Canvas', width, height, options);
	
	    this.type = CONST.RENDERER_TYPE.CANVAS;
	
	    /**
	     * The canvas 2d context that everything is drawn with.
	     *
	     * @member {CanvasRenderingContext2D}
	     */
	    this.context = this.view.getContext('2d', { alpha: this.transparent });
	
	    /**
	     * Boolean flag controlling canvas refresh.
	     *
	     * @member {boolean}
	     */
	    this.refresh = true;
	
	    /**
	     * Instance of a CanvasMaskManager, handles masking when using the canvas renderer.
	     *
	     * @member {PIXI.CanvasMaskManager}
	     */
	    this.maskManager = new CanvasMaskManager();
	
	    /**
	     * The canvas property used to set the canvas smoothing property.
	     *
	     * @member {string}
	     */
	    this.smoothProperty = 'imageSmoothingEnabled';
	
	    if (!this.context.imageSmoothingEnabled)
	    {
	        if (this.context.webkitImageSmoothingEnabled)
	        {
	            this.smoothProperty = 'webkitImageSmoothingEnabled';
	        }
	        else if (this.context.mozImageSmoothingEnabled)
	        {
	            this.smoothProperty = 'mozImageSmoothingEnabled';
	        }
	        else if (this.context.oImageSmoothingEnabled)
	        {
	            this.smoothProperty = 'oImageSmoothingEnabled';
	        }
	        else if (this.context.msImageSmoothingEnabled)
	        {
	            this.smoothProperty = 'msImageSmoothingEnabled';
	        }
	    }
	
	    this.initPlugins();
	
	    this._mapBlendModes();
	
	    /**
	     * This temporary display object used as the parent of the currently being rendered item
	     *
	     * @member {PIXI.DisplayObject}
	     * @private
	     */
	    this._tempDisplayObjectParent = {
	        worldTransform: new math.Matrix(),
	        worldAlpha: 1
	    };
	
	
	    this.resize(width, height);
	}
	
	// constructor
	CanvasRenderer.prototype = Object.create(SystemRenderer.prototype);
	CanvasRenderer.prototype.constructor = CanvasRenderer;
	module.exports = CanvasRenderer;
	utils.pluginTarget.mixin(CanvasRenderer);
	
	/**
	 * Renders the object to this canvas view
	 *
	 * @param object {PIXI.DisplayObject} the object to be rendered
	 */
	CanvasRenderer.prototype.render = function (object)
	{
	    this.emit('prerender');
	
	    var cacheParent = object.parent;
	
	    this._lastObjectRendered = object;
	
	    object.parent = this._tempDisplayObjectParent;
	
	    // update the scene graph
	    object.updateTransform();
	
	    object.parent = cacheParent;
	
	    this.context.setTransform(1, 0, 0, 1, 0, 0);
	
	    this.context.globalAlpha = 1;
	
	    this.context.globalCompositeOperation = this.blendModes[CONST.BLEND_MODES.NORMAL];
	
	    if (navigator.isCocoonJS && this.view.screencanvas)
	    {
	        this.context.fillStyle = 'black';
	        this.context.clear();
	    }
	
	    if (this.clearBeforeRender)
	    {
	        if (this.transparent)
	        {
	            this.context.clearRect(0, 0, this.width, this.height);
	        }
	        else
	        {
	            this.context.fillStyle = this._backgroundColorString;
	            this.context.fillRect(0, 0, this.width , this.height);
	        }
	    }
	
	    this.renderDisplayObject(object, this.context);
	
	    this.emit('postrender');
	};
	
	/**
	 * Removes everything from the renderer and optionally removes the Canvas DOM element.
	 *
	 * @param [removeView=false] {boolean} Removes the Canvas element from the DOM.
	 */
	CanvasRenderer.prototype.destroy = function (removeView)
	{
	    this.destroyPlugins();
	
	    // call the base destroy
	    SystemRenderer.prototype.destroy.call(this, removeView);
	
	    this.context = null;
	
	    this.refresh = true;
	
	    this.maskManager.destroy();
	    this.maskManager = null;
	
	    this.smoothProperty = null;
	};
	
	/**
	 * Renders a display object
	 *
	 * @param displayObject {PIXI.DisplayObject} The displayObject to render
	 * @private
	 */
	CanvasRenderer.prototype.renderDisplayObject = function (displayObject, context)
	{
	    var tempContext = this.context;
	
	    this.context = context;
	    displayObject.renderCanvas(this);
	    this.context = tempContext;
	};
	
	/**
	 * @extends PIXI.SystemRenderer#resize
	 *
	 * @param {number} w
	 * @param {number} h
	 */
	CanvasRenderer.prototype.resize = function (w, h)
	{
	    SystemRenderer.prototype.resize.call(this, w, h);
	
	    //reset the scale mode.. oddly this seems to be reset when the canvas is resized.
	    //surely a browser bug?? Let pixi fix that for you..
	    if(this.smoothProperty)
	    {
	        this.context[this.smoothProperty] = (CONST.SCALE_MODES.DEFAULT === CONST.SCALE_MODES.LINEAR);
	    }
	
	};
	
	/**
	 * Maps Pixi blend modes to canvas blend modes.
	 *
	 * @private
	 */
	CanvasRenderer.prototype._mapBlendModes = function ()
	{
	    if (!this.blendModes)
	    {
	        this.blendModes = {};
	
	        if (utils.canUseNewCanvasBlendModes())
	        {
	            this.blendModes[CONST.BLEND_MODES.NORMAL]        = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.ADD]           = 'lighter'; //IS THIS OK???
	            this.blendModes[CONST.BLEND_MODES.MULTIPLY]      = 'multiply';
	            this.blendModes[CONST.BLEND_MODES.SCREEN]        = 'screen';
	            this.blendModes[CONST.BLEND_MODES.OVERLAY]       = 'overlay';
	            this.blendModes[CONST.BLEND_MODES.DARKEN]        = 'darken';
	            this.blendModes[CONST.BLEND_MODES.LIGHTEN]       = 'lighten';
	            this.blendModes[CONST.BLEND_MODES.COLOR_DODGE]   = 'color-dodge';
	            this.blendModes[CONST.BLEND_MODES.COLOR_BURN]    = 'color-burn';
	            this.blendModes[CONST.BLEND_MODES.HARD_LIGHT]    = 'hard-light';
	            this.blendModes[CONST.BLEND_MODES.SOFT_LIGHT]    = 'soft-light';
	            this.blendModes[CONST.BLEND_MODES.DIFFERENCE]    = 'difference';
	            this.blendModes[CONST.BLEND_MODES.EXCLUSION]     = 'exclusion';
	            this.blendModes[CONST.BLEND_MODES.HUE]           = 'hue';
	            this.blendModes[CONST.BLEND_MODES.SATURATION]    = 'saturate';
	            this.blendModes[CONST.BLEND_MODES.COLOR]         = 'color';
	            this.blendModes[CONST.BLEND_MODES.LUMINOSITY]    = 'luminosity';
	        }
	        else
	        {
	            // this means that the browser does not support the cool new blend modes in canvas 'cough' ie 'cough'
	            this.blendModes[CONST.BLEND_MODES.NORMAL]        = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.ADD]           = 'lighter'; //IS THIS OK???
	            this.blendModes[CONST.BLEND_MODES.MULTIPLY]      = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.SCREEN]        = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.OVERLAY]       = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.DARKEN]        = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.LIGHTEN]       = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.COLOR_DODGE]   = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.COLOR_BURN]    = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.HARD_LIGHT]    = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.SOFT_LIGHT]    = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.DIFFERENCE]    = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.EXCLUSION]     = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.HUE]           = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.SATURATION]    = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.COLOR]         = 'source-over';
	            this.blendModes[CONST.BLEND_MODES.LUMINOSITY]    = 'source-over';
	        }
	    }
	};


/***/ },
/* 188 */
/*!************************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/canvas/utils/CanvasMaskManager.js ***!
  \************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var CanvasGraphics = __webpack_require__(/*! ./CanvasGraphics */ 59);
	
	/**
	 * A set of functions used to handle masking.
	 *
	 * @class
	 * @memberof PIXI
	 */
	function CanvasMaskManager()
	{}
	
	CanvasMaskManager.prototype.constructor = CanvasMaskManager;
	module.exports = CanvasMaskManager;
	
	/**
	 * This method adds it to the current stack of masks.
	 *
	 * @param maskData {object} the maskData that will be pushed
	 * @param renderer {PIXI.WebGLRenderer|PIXI.CanvasRenderer} The renderer context to use.
	 */
	CanvasMaskManager.prototype.pushMask = function (maskData, renderer)
	{
	
	    renderer.context.save();
	
	    var cacheAlpha = maskData.alpha;
	    var transform = maskData.worldTransform;
	    var resolution = renderer.resolution;
	
	    renderer.context.setTransform(
	        transform.a * resolution,
	        transform.b * resolution,
	        transform.c * resolution,
	        transform.d * resolution,
	        transform.tx * resolution,
	        transform.ty * resolution
	    );
	
	    //TODO suport sprite alpha masks??
	    //lots of effort required. If demand is great enough..
	    if(!maskData.texture)
	    {
	        CanvasGraphics.renderGraphicsMask(maskData, renderer.context);
	        renderer.context.clip();
	    }
	
	    maskData.worldAlpha = cacheAlpha;
	};
	
	/**
	 * Restores the current drawing context to the state it was before the mask was applied.
	 *
	 * @param renderer {PIXI.WebGLRenderer|PIXI.CanvasRenderer} The renderer context to use.
	 */
	CanvasMaskManager.prototype.popMask = function (renderer)
	{
	    renderer.context.restore();
	};
	
	CanvasMaskManager.prototype.destroy = function () {};


/***/ },
/* 189 */
/*!*************************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/managers/BlendModeManager.js ***!
  \*************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var WebGLManager = __webpack_require__(/*! ./WebGLManager */ 23);
	
	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.WebGlManager
	 * @param renderer {PIXI.WebGLRenderer} The renderer this manager works for.
	 */
	function BlendModeManager(renderer)
	{
	    WebGLManager.call(this, renderer);
	
	    /**
	     * @member {number}
	     */
	    this.currentBlendMode = 99999;
	}
	
	BlendModeManager.prototype = Object.create(WebGLManager.prototype);
	BlendModeManager.prototype.constructor = BlendModeManager;
	module.exports = BlendModeManager;
	
	/**
	 * Sets-up the given blendMode from WebGL's point of view.
	 *
	 * @param blendMode {number} the blendMode, should be a Pixi const, such as `PIXI.BLEND_MODES.ADD`. See
	 *  {@link PIXI.BLEND_MODES} for possible values.
	 */
	BlendModeManager.prototype.setBlendMode = function (blendMode)
	{
	    if (this.currentBlendMode === blendMode)
	    {
	        return false;
	    }
	
	    this.currentBlendMode = blendMode;
	
	    var mode = this.renderer.blendModes[this.currentBlendMode];
	    this.renderer.gl.blendFunc(mode[0], mode[1]);
	
	    return true;
	};


/***/ },
/* 190 */
/*!********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/managers/MaskManager.js ***!
  \********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var WebGLManager = __webpack_require__(/*! ./WebGLManager */ 23),
	    AlphaMaskFilter = __webpack_require__(/*! ../filters/SpriteMaskFilter */ 101);
	
	/**
	 * @class
	 * @memberof PIXI
	 * @param renderer {PIXI.WebGLRenderer} The renderer this manager works for.
	 */
	function MaskManager(renderer)
	{
	    WebGLManager.call(this, renderer);
	
	    this.stencilStack = [];
	    this.reverse = true;
	    this.count = 0;
	
	    this.alphaMaskPool = [];
	}
	
	MaskManager.prototype = Object.create(WebGLManager.prototype);
	MaskManager.prototype.constructor = MaskManager;
	module.exports = MaskManager;
	
	/**
	 * Applies the Mask and adds it to the current filter stack.
	 *
	 * @param graphics {PIXI.Graphics}
	 * @param webGLData {any[]}
	 */
	MaskManager.prototype.pushMask = function (target, maskData)
	{
	    if (maskData.texture)
	    {
	        this.pushSpriteMask(target, maskData);
	    }
	    else
	    {
	        this.pushStencilMask(target, maskData);
	    }
	
	};
	
	/**
	 * Removes the last mask from the mask stack and doesn't return it.
	 *
	 * @param target {PIXI.RenderTarget}
	 * @param maskData {any[]}
	 */
	MaskManager.prototype.popMask = function (target, maskData)
	{
	    if (maskData.texture)
	    {
	        this.popSpriteMask(target, maskData);
	    }
	    else
	    {
	        this.popStencilMask(target, maskData);
	    }
	};
	
	/**
	 * Applies the Mask and adds it to the current filter stack.
	 *
	 * @param target {PIXI.RenderTarget}
	 * @param maskData {any[]}
	 */
	MaskManager.prototype.pushSpriteMask = function (target, maskData)
	{
	    var alphaMaskFilter = this.alphaMaskPool.pop();
	
	    if (!alphaMaskFilter)
	    {
	        alphaMaskFilter = [new AlphaMaskFilter(maskData)];
	    }
	
	    alphaMaskFilter[0].maskSprite = maskData;
	    this.renderer.filterManager.pushFilter(target, alphaMaskFilter);
	};
	
	/**
	 * Removes the last filter from the filter stack and doesn't return it.
	 *
	 */
	MaskManager.prototype.popSpriteMask = function ()
	{
	    var filters = this.renderer.filterManager.popFilter();
	
	    this.alphaMaskPool.push(filters);
	};
	
	
	/**
	 * Applies the Mask and adds it to the current filter stack.
	 *
	 * @param target {PIXI.RenderTarget}
	 * @param maskData {any[]}
	 */
	MaskManager.prototype.pushStencilMask = function (target, maskData)
	{
	    this.renderer.stencilManager.pushMask(maskData);
	};
	
	/**
	 * Removes the last filter from the filter stack and doesn't return it.
	 *
	 * @param target {PIXI.RenderTarget}
	 * @param maskData {any[]}
	 */
	MaskManager.prototype.popStencilMask = function (target, maskData)
	{
	    this.renderer.stencilManager.popMask(maskData);
	};
	


/***/ },
/* 191 */
/*!***********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/managers/StencilManager.js ***!
  \***********************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var WebGLManager = __webpack_require__(/*! ./WebGLManager */ 23),
	    utils = __webpack_require__(/*! ../../../utils */ 7);
	
	/**
	 * @class
	 * @memberof PIXI
	 * @param renderer {PIXI.WebGLRenderer} The renderer this manager works for.
	 */
	function WebGLMaskManager(renderer)
	{
	    WebGLManager.call(this, renderer);
	    this.stencilMaskStack = null;
	}
	
	WebGLMaskManager.prototype = Object.create(WebGLManager.prototype);
	WebGLMaskManager.prototype.constructor = WebGLMaskManager;
	module.exports = WebGLMaskManager;
	
	/**
	 * Changes the mask stack that is used by this manager.
	 *
	 * @param stencilMaskStack {PIXI.StencilMaskStack} The mask stack
	 */
	WebGLMaskManager.prototype.setMaskStack = function ( stencilMaskStack )
	{
	    this.stencilMaskStack = stencilMaskStack;
	
	    var gl = this.renderer.gl;
	
	    if (stencilMaskStack.stencilStack.length === 0)
	    {
	        gl.disable(gl.STENCIL_TEST);
	    }
	    else
	    {
	        gl.enable(gl.STENCIL_TEST);
	    }
	};
	
	/**
	 * Applies the Mask and adds it to the current filter stack. @alvin
	 *
	 * @param graphics {PIXI.Graphics}
	 * @param webGLData {any[]}
	 */
	WebGLMaskManager.prototype.pushStencil = function (graphics, webGLData)
	{
	    this.renderer.currentRenderTarget.attachStencilBuffer();
	
	    var gl = this.renderer.gl,
	        sms = this.stencilMaskStack;
	
	    this.bindGraphics(graphics, webGLData);
	
	    if (sms.stencilStack.length === 0)
	    {
	        gl.enable(gl.STENCIL_TEST);
	        gl.clear(gl.STENCIL_BUFFER_BIT);
	        sms.reverse = true;
	        sms.count = 0;
	    }
	
	    sms.stencilStack.push(webGLData);
	
	    var level = sms.count;
	
	    gl.colorMask(false, false, false, false);
	
	    gl.stencilFunc(gl.ALWAYS,0,0xFF);
	    gl.stencilOp(gl.KEEP,gl.KEEP,gl.INVERT);
	
	    // draw the triangle strip!
	
	    if (webGLData.mode === 1)
	    {
	        gl.drawElements(gl.TRIANGLE_FAN,  webGLData.indices.length - 4, gl.UNSIGNED_SHORT, 0 );
	
	        if (sms.reverse)
	        {
	            gl.stencilFunc(gl.EQUAL, 0xFF - level, 0xFF);
	            gl.stencilOp(gl.KEEP,gl.KEEP,gl.DECR);
	        }
	        else
	        {
	            gl.stencilFunc(gl.EQUAL,level, 0xFF);
	            gl.stencilOp(gl.KEEP,gl.KEEP,gl.INCR);
	        }
	
	        // draw a quad to increment..
	        gl.drawElements(gl.TRIANGLE_FAN, 4, gl.UNSIGNED_SHORT, ( webGLData.indices.length - 4 ) * 2 );
	
	        if (sms.reverse)
	        {
	            gl.stencilFunc(gl.EQUAL,0xFF-(level+1), 0xFF);
	        }
	        else
	        {
	            gl.stencilFunc(gl.EQUAL,level+1, 0xFF);
	        }
	
	        sms.reverse = !sms.reverse;
	    }
	    else
	    {
	        if (!sms.reverse)
	        {
	            gl.stencilFunc(gl.EQUAL, 0xFF - level, 0xFF);
	            gl.stencilOp(gl.KEEP,gl.KEEP,gl.DECR);
	        }
	        else
	        {
	            gl.stencilFunc(gl.EQUAL,level, 0xFF);
	            gl.stencilOp(gl.KEEP,gl.KEEP,gl.INCR);
	        }
	
	        gl.drawElements(gl.TRIANGLE_STRIP,  webGLData.indices.length, gl.UNSIGNED_SHORT, 0 );
	
	        if (!sms.reverse)
	        {
	            gl.stencilFunc(gl.EQUAL,0xFF-(level+1), 0xFF);
	        }
	        else
	        {
	            gl.stencilFunc(gl.EQUAL,level+1, 0xFF);
	        }
	    }
	
	    gl.colorMask(true, true, true, true);
	    gl.stencilOp(gl.KEEP,gl.KEEP,gl.KEEP);
	
	    sms.count++;
	};
	
	/**
	 * TODO this does not belong here!
	 *
	 * @param graphics {PIXI.Graphics}
	 * @param webGLData {any[]}
	 */
	WebGLMaskManager.prototype.bindGraphics = function (graphics, webGLData)
	{
	    //if (this._currentGraphics === graphics)return;
	    var gl = this.renderer.gl;
	
	     // bind the graphics object..
	    var shader;// = this.renderer.shaderManager.plugins.primitiveShader;
	
	    if (webGLData.mode === 1)
	    {
	        shader = this.renderer.shaderManager.complexPrimitiveShader;
	
	        this.renderer.shaderManager.setShader(shader);
	
	        gl.uniformMatrix3fv(shader.uniforms.translationMatrix._location, false, graphics.worldTransform.toArray(true));
	
	        gl.uniformMatrix3fv(shader.uniforms.projectionMatrix._location, false, this.renderer.currentRenderTarget.projectionMatrix.toArray(true));
	
	        gl.uniform3fv(shader.uniforms.tint._location, utils.hex2rgb(graphics.tint));
	
	        gl.uniform3fv(shader.uniforms.color._location, webGLData.color);
	
	        gl.uniform1f(shader.uniforms.alpha._location, graphics.worldAlpha);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, webGLData.buffer);
	
	        gl.vertexAttribPointer(shader.attributes.aVertexPosition, 2, gl.FLOAT, false, 4 * 2, 0);
	
	
	        // now do the rest..
	        // set the index buffer!
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, webGLData.indexBuffer);
	    }
	    else
	    {
	        //this.renderer.shaderManager.activatePrimitiveShader();
	        shader = this.renderer.shaderManager.primitiveShader;
	
	        this.renderer.shaderManager.setShader(shader);
	
	        gl.uniformMatrix3fv(shader.uniforms.translationMatrix._location, false, graphics.worldTransform.toArray(true));
	
	        gl.uniformMatrix3fv(shader.uniforms.projectionMatrix._location, false, this.renderer.currentRenderTarget.projectionMatrix.toArray(true));
	
	        gl.uniform3fv(shader.uniforms.tint._location, utils.hex2rgb(graphics.tint));
	
	        gl.uniform1f(shader.uniforms.alpha._location, graphics.worldAlpha);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, webGLData.buffer);
	
	        gl.vertexAttribPointer(shader.attributes.aVertexPosition, 2, gl.FLOAT, false, 4 * 6, 0);
	        gl.vertexAttribPointer(shader.attributes.aColor, 4, gl.FLOAT, false,4 * 6, 2 * 4);
	
	        // set the index buffer!
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, webGLData.indexBuffer);
	    }
	};
	
	/**
	 * TODO @alvin
	 * @param graphics {PIXI.Graphics}
	 * @param webGLData {any[]}
	 */
	WebGLMaskManager.prototype.popStencil = function (graphics, webGLData)
	{
	    var gl = this.renderer.gl,
	        sms = this.stencilMaskStack;
	
	    sms.stencilStack.pop();
	
	    sms.count--;
	
	    if (sms.stencilStack.length === 0)
	    {
	        // the stack is empty!
	        gl.disable(gl.STENCIL_TEST);
	
	    }
	    else
	    {
	
	        var level = sms.count;
	
	        this.bindGraphics(graphics, webGLData);
	
	        gl.colorMask(false, false, false, false);
	
	        if (webGLData.mode === 1)
	        {
	            sms.reverse = !sms.reverse;
	
	            if (sms.reverse)
	            {
	                gl.stencilFunc(gl.EQUAL, 0xFF - (level+1), 0xFF);
	                gl.stencilOp(gl.KEEP,gl.KEEP,gl.INCR);
	            }
	            else
	            {
	                gl.stencilFunc(gl.EQUAL,level+1, 0xFF);
	                gl.stencilOp(gl.KEEP,gl.KEEP,gl.DECR);
	            }
	
	            // draw a quad to increment..
	            gl.drawElements(gl.TRIANGLE_FAN, 4, gl.UNSIGNED_SHORT, ( webGLData.indices.length - 4 ) * 2 );
	
	            gl.stencilFunc(gl.ALWAYS,0,0xFF);
	            gl.stencilOp(gl.KEEP,gl.KEEP,gl.INVERT);
	
	            // draw the triangle strip!
	            gl.drawElements(gl.TRIANGLE_FAN,  webGLData.indices.length - 4, gl.UNSIGNED_SHORT, 0 );
	
	            this.renderer.drawCount += 2;
	
	            if (!sms.reverse)
	            {
	                gl.stencilFunc(gl.EQUAL,0xFF-(level), 0xFF);
	            }
	            else
	            {
	                gl.stencilFunc(gl.EQUAL,level, 0xFF);
	            }
	
	        }
	        else
	        {
	          //  console.log("<<>>")
	            if (!sms.reverse)
	            {
	                gl.stencilFunc(gl.EQUAL, 0xFF - (level+1), 0xFF);
	                gl.stencilOp(gl.KEEP,gl.KEEP,gl.INCR);
	            }
	            else
	            {
	                gl.stencilFunc(gl.EQUAL,level+1, 0xFF);
	                gl.stencilOp(gl.KEEP,gl.KEEP,gl.DECR);
	            }
	
	            gl.drawElements(gl.TRIANGLE_STRIP,  webGLData.indices.length, gl.UNSIGNED_SHORT, 0 );
	
	            this.renderer.drawCount++;
	
	            if (!sms.reverse)
	            {
	                gl.stencilFunc(gl.EQUAL,0xFF-(level), 0xFF);
	            }
	            else
	            {
	                gl.stencilFunc(gl.EQUAL,level, 0xFF);
	            }
	        }
	
	        gl.colorMask(true, true, true, true);
	        gl.stencilOp(gl.KEEP,gl.KEEP,gl.KEEP);
	
	
	    }
	};
	
	/**
	 * Destroys the mask stack.
	 *
	 */
	WebGLMaskManager.prototype.destroy = function ()
	{
	    WebGLManager.prototype.destroy.call(this);
	
	    this.stencilMaskStack.stencilStack = null;
	};
	
	/**
	 * Applies the Mask and adds it to the current filter stack.
	 *
	 * @param maskData {any[]} The mask data structure to use
	 */
	WebGLMaskManager.prototype.pushMask = function (maskData)
	{
	
	
	    this.renderer.setObjectRenderer(this.renderer.plugins.graphics);
	
	    if (maskData.dirty)
	    {
	        this.renderer.plugins.graphics.updateGraphics(maskData, this.renderer.gl);
	    }
	
	    if (!maskData._webGL[this.renderer.gl.id].data.length)
	    {
	        return;
	    }
	
	    this.pushStencil(maskData, maskData._webGL[this.renderer.gl.id].data[0]);
	};
	
	/**
	 * Removes the last filter from the filter stack and doesn't return it.
	 *
	 * @param maskData {any[]}
	 */
	WebGLMaskManager.prototype.popMask = function (maskData)
	{
	    this.renderer.setObjectRenderer(this.renderer.plugins.graphics);
	
	    this.popStencil(maskData, maskData._webGL[this.renderer.gl.id].data[0]);
	};
	


/***/ },
/* 192 */
/*!**********************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/utils/Quad.js ***!
  \**********************************************************/
/***/ function(module, exports) {

	/**
	 * Helper class to create a quad
	 *
	 * @class
	 * @memberof PIXI
	 * @param gl {WebGLRenderingContext} The gl context for this quad to use.
	 */
	function Quad(gl)
	{
	    /*
	     * the current WebGL drawing context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	//    this.textures = new TextureUvs();
	
	    /**
	     * An array of vertices
	     *
	     * @member {Float32Array}
	     */
	    this.vertices = new Float32Array([
	        0,0,
	        200,0,
	        200,200,
	        0,200
	    ]);
	
	    /**
	     * The Uvs of the quad
	     *
	     * @member {Float32Array}
	     */
	    this.uvs = new Float32Array([
	        0,0,
	        1,0,
	        1,1,
	        0,1
	    ]);
	
	//    var white = (0xFFFFFF >> 16) + (0xFFFFFF & 0xff00) + ((0xFFFFFF & 0xff) << 16) + (1 * 255 << 24);
	    //TODO convert this to a 32 unsigned int array
	    /**
	     * The color components of the triangles
	     *
	     * @member {Float32Array}
	     */
	    this.colors = new Float32Array([
	        1,1,1,1,
	        1,1,1,1,
	        1,1,1,1,
	        1,1,1,1
	    ]);
	
	    /*
	     * @member {Uint16Array} An array containing the indices of the vertices
	     */
	    this.indices = new Uint16Array([
	        0, 1, 2, 0, 3, 2
	    ]);
	
	    /*
	     * @member {WebGLBuffer} The vertex buffer
	     */
	    this.vertexBuffer = gl.createBuffer();
	
	    /*
	     * @member {WebGLBuffer} The index buffer
	     */
	    this.indexBuffer = gl.createBuffer();
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, (8 + 8 + 16) * 4, gl.DYNAMIC_DRAW);
	
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices, gl.STATIC_DRAW);
	
	    this.upload();
	}
	
	Quad.prototype.constructor = Quad;
	
	/**
	 * Maps two Rectangle to the quad
	 * @param rect {PIXI.Rectangle} the first rectangle
	 * @param rect2 {PIXI.Rectangle} the second rectangle
	 */
	Quad.prototype.map = function(rect, rect2)
	{
	    var x = 0; //rect2.x / rect.width;
	    var y = 0; //rect2.y / rect.height;
	
	    this.uvs[0] = x;
	    this.uvs[1] = y;
	
	    this.uvs[2] = x + rect2.width / rect.width;
	    this.uvs[3] = y;
	
	    this.uvs[4] = x + rect2.width / rect.width;
	    this.uvs[5] = y + rect2.height / rect.height;
	
	    this.uvs[6] = x;
	    this.uvs[7] = y + rect2.height / rect.height;
	
	    /// -----
	    x = rect2.x;
	    y = rect2.y;
	
	    this.vertices[0] = x;
	    this.vertices[1] = y;
	
	    this.vertices[2] = x + rect2.width;
	    this.vertices[3] = y;
	
	    this.vertices[4] = x + rect2.width;
	    this.vertices[5] = y + rect2.height;
	
	    this.vertices[6] = x;
	    this.vertices[7] = y + rect2.height;
	
	    this.upload();
	};
	
	/**
	 * Binds the buffer and uploads the data
	 */
	Quad.prototype.upload = function()
	{
	    var gl = this.gl;
	
	    // TODO could probably be pushed into one upload!
	    gl.bindBuffer( gl.ARRAY_BUFFER, this.vertexBuffer );
	
	    gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.vertices);
	
	    gl.bufferSubData(gl.ARRAY_BUFFER, 8 * 4, this.uvs);
	
	    gl.bufferSubData(gl.ARRAY_BUFFER, (8 + 8) * 4, this.colors);
	};
	
	Quad.prototype.destroy = function()
	{
	    var gl = this.gl;
	    
	     gl.deleteBuffer(this.vertexBuffer);
	     gl.deleteBuffer(this.indexBuffer);
	};
	
	module.exports = Quad;
	
	


/***/ },
/* 193 */
/*!**********************************************************************!*\
  !*** ./~/pixi.js/src/core/renderers/webgl/utils/StencilMaskStack.js ***!
  \**********************************************************************/
/***/ function(module, exports) {

	/**
	 * Generic Mask Stack data structure
	 * @class
	 * @memberof PIXI
	 */
	function StencilMaskStack()
	{
		/**
	     * The actual stack
	     *
	     * @member {any[]}
	     */
	    this.stencilStack = [];
	
	    /**
	     * TODO @alvin
	     *
	     * @member {boolean}
	     */
	    this.reverse = true;
	
	    /**
	     * Internal count
	     *
	     * @member {number}
	     */
	    this.count = 0;
	}
	
	StencilMaskStack.prototype.constructor = StencilMaskStack;
	module.exports = StencilMaskStack;


/***/ },
/* 194 */
/*!************************************************************!*\
  !*** ./~/pixi.js/src/core/sprites/webgl/SpriteRenderer.js ***!
  \************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var ObjectRenderer = __webpack_require__(/*! ../../renderers/webgl/utils/ObjectRenderer */ 29),
	    WebGLRenderer = __webpack_require__(/*! ../../renderers/webgl/WebGLRenderer */ 37),
	    CONST = __webpack_require__(/*! ../../const */ 6);
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original pixi version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's SpriteRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/SpriteRenderer.java
	 */
	
	/**
	 * Renderer dedicated to drawing and batching sprites.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 * @param renderer {PIXI.WebGLRenderer} The renderer this sprite batch works for.
	 */
	function SpriteRenderer(renderer)
	{
	    ObjectRenderer.call(this, renderer);
	
	    /**
	     * Number of values sent in the vertex buffer.
	     * positionX, positionY, colorR, colorG, colorB = 5
	     *
	     * @member {number}
	     */
	    this.vertSize = 5;
	
	    /**
	     * The size of the vertex information in bytes.
	     *
	     * @member {number}
	     */
	    this.vertByteSize = this.vertSize * 4;
	
	    /**
	     * The number of images in the SpriteBatch before it flushes.
	     *
	     * @member {number}
	     */
	    this.size = CONST.SPRITE_BATCH_SIZE; // 2000 is a nice balance between mobile / desktop
	
	    // the total number of bytes in our batch
	    var numVerts = (this.size * 4) * this.vertByteSize;
	
	    // the total number of indices in our batch, there are 6 points per quad.
	    var numIndices = this.size * 6;
	
	    /**
	     * Holds the vertex data that will be sent to the vertex shader.
	     *
	     * @member {ArrayBuffer}
	     */
	    this.vertices = new ArrayBuffer(numVerts);
	
	    /**
	     * View on the vertices as a Float32Array for positions
	     *
	     * @member {Float32Array}
	     */
	    this.positions = new Float32Array(this.vertices);
	
	    /**
	     * View on the vertices as a Uint32Array for colors
	     *
	     * @member {Uint32Array}
	     */
	    this.colors = new Uint32Array(this.vertices);
	
	    /**
	     * Holds the indices of the geometry (quads) to draw
	     *
	     * @member {Uint16Array}
	     */
	    this.indices = new Uint16Array(numIndices);
	
	    // fill the indices with the quads to draw
	    for (var i=0, j=0; i < numIndices; i += 6, j += 4)
	    {
	        this.indices[i + 0] = j + 0;
	        this.indices[i + 1] = j + 1;
	        this.indices[i + 2] = j + 2;
	        this.indices[i + 3] = j + 0;
	        this.indices[i + 4] = j + 2;
	        this.indices[i + 5] = j + 3;
	    }
	
	    /**
	     * The current size of the batch, each render() call adds to this number.
	     *
	     * @member {number}
	     */
	    this.currentBatchSize = 0;
	
	    /**
	     * The current sprites in the batch.
	     *
	     * @member {PIXI.Sprite[]}
	     */
	    this.sprites = [];
	
	    /**
	     * The default shader that is used if a sprite doesn't have a more specific one.
	     *
	     * @member {PIXI.Shader}
	     */
	    this.shader = null;
	}
	
	SpriteRenderer.prototype = Object.create(ObjectRenderer.prototype);
	SpriteRenderer.prototype.constructor = SpriteRenderer;
	module.exports = SpriteRenderer;
	
	WebGLRenderer.registerPlugin('sprite', SpriteRenderer);
	
	/**
	 * Sets up the renderer context and necessary buffers.
	 *
	 * @private
	 * @param gl {WebGLRenderingContext} the current WebGL drawing context
	 */
	SpriteRenderer.prototype.onContextChange = function ()
	{
	    var gl = this.renderer.gl;
	
	    // setup default shader
	    this.shader = this.renderer.shaderManager.defaultShader;
	
	    // create a couple of buffers
	    this.vertexBuffer = gl.createBuffer();
	    this.indexBuffer = gl.createBuffer();
	
	    //upload the index data
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices, gl.STATIC_DRAW);
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.DYNAMIC_DRAW);
	
	    this.currentBlendMode = 99999;
	};
	
	/**
	 * Renders the sprite object.
	 *
	 * @param sprite {PIXI.Sprite} the sprite to render when using this spritebatch
	 */
	SpriteRenderer.prototype.render = function (sprite)
	{
	    var texture = sprite._texture;
	
	    //TODO set blend modes..
	    // check texture..
	    if (this.currentBatchSize >= this.size)
	    {
	        this.flush();
	    }
	
	    // get the uvs for the texture
	    var uvs = texture._uvs;
	
	    // if the uvs have not updated then no point rendering just yet!
	    if (!uvs)
	    {
	        return;
	    }
	
	    // TODO trim??
	    var aX = sprite.anchor.x;
	    var aY = sprite.anchor.y;
	
	    var w0, w1, h0, h1;
	
	    if (texture.trim && sprite.tileScale === undefined)
	    {
	        // if the sprite is trimmed and is not a tilingsprite then we need to add the extra space before transforming the sprite coords..
	        var trim = texture.trim;
	
	        w1 = trim.x - aX * trim.width;
	        w0 = w1 + texture.crop.width;
	
	        h1 = trim.y - aY * trim.height;
	        h0 = h1 + texture.crop.height;
	
	    }
	    else
	    {
	        w0 = (texture._frame.width ) * (1-aX);
	        w1 = (texture._frame.width ) * -aX;
	
	        h0 = texture._frame.height * (1-aY);
	        h1 = texture._frame.height * -aY;
	    }
	
	    var index = this.currentBatchSize * this.vertByteSize;
	
	    var worldTransform = sprite.worldTransform;
	
	    var a = worldTransform.a;
	    var b = worldTransform.b;
	    var c = worldTransform.c;
	    var d = worldTransform.d;
	    var tx = worldTransform.tx;
	    var ty = worldTransform.ty;
	
	    var colors = this.colors;
	    var positions = this.positions;
	
	    if (this.renderer.roundPixels)
	    {
	        var resolution = this.renderer.resolution;
	
	        // xy
	        positions[index] = (((a * w1 + c * h1 + tx) * resolution) | 0) / resolution;
	        positions[index+1] = (((d * h1 + b * w1 + ty) * resolution) | 0) / resolution;
	
	        // xy
	        positions[index+5] = (((a * w0 + c * h1 + tx) * resolution) | 0) / resolution;
	        positions[index+6] = (((d * h1 + b * w0 + ty) * resolution) | 0) / resolution;
	
	         // xy
	        positions[index+10] = (((a * w0 + c * h0 + tx) * resolution) | 0) / resolution;
	        positions[index+11] = (((d * h0 + b * w0 + ty) * resolution) | 0) / resolution;
	
	        // xy
	        positions[index+15] = (((a * w1 + c * h0 + tx) * resolution) | 0) / resolution;
	        positions[index+16] = (((d * h0 + b * w1 + ty) * resolution) | 0) / resolution;
	    }
	    else
	    {
	
	        // xy
	        positions[index] = a * w1 + c * h1 + tx;
	        positions[index+1] = d * h1 + b * w1 + ty;
	
	        // xy
	        positions[index+5] = a * w0 + c * h1 + tx;
	        positions[index+6] = d * h1 + b * w0 + ty;
	
	         // xy
	        positions[index+10] = a * w0 + c * h0 + tx;
	        positions[index+11] = d * h0 + b * w0 + ty;
	
	        // xy
	        positions[index+15] = a * w1 + c * h0 + tx;
	        positions[index+16] = d * h0 + b * w1 + ty;
	    }
	
	    // uv
	    positions[index+2] = uvs.x0;
	    positions[index+3] = uvs.y0;
	
	    // uv
	    positions[index+7] = uvs.x1;
	    positions[index+8] = uvs.y1;
	
	     // uv
	    positions[index+12] = uvs.x2;
	    positions[index+13] = uvs.y2;
	
	    // uv
	    positions[index+17] = uvs.x3;
	    positions[index+18] = uvs.y3;
	
	    // color and alpha
	    var tint = sprite.tint;
	    colors[index+4] = colors[index+9] = colors[index+14] = colors[index+19] = (tint >> 16) + (tint & 0xff00) + ((tint & 0xff) << 16) + (sprite.worldAlpha * 255 << 24);
	
	    // increment the batchsize
	    this.sprites[this.currentBatchSize++] = sprite;
	};
	
	/**
	 * Renders the content and empties the current batch.
	 *
	 */
	SpriteRenderer.prototype.flush = function ()
	{
	    // If the batch is length 0 then return as there is nothing to draw
	    if (this.currentBatchSize === 0)
	    {
	        return;
	    }
	
	    var gl = this.renderer.gl;
	    var shader;
	
	    // upload the verts to the buffer
	    if (this.currentBatchSize > ( this.size * 0.5 ) )
	    {
	        gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.vertices);
	    }
	    else
	    {
	        var view = this.positions.subarray(0, this.currentBatchSize * this.vertByteSize);
	        gl.bufferSubData(gl.ARRAY_BUFFER, 0, view);
	    }
	
	    var nextTexture, nextBlendMode, nextShader;
	    var batchSize = 0;
	    var start = 0;
	
	    var currentBaseTexture = null;
	    var currentBlendMode = this.renderer.blendModeManager.currentBlendMode;
	    var currentShader = null;
	
	    var blendSwap = false;
	    var shaderSwap = false;
	    var sprite;
	
	    for (var i = 0, j = this.currentBatchSize; i < j; i++)
	    {
	
	        sprite = this.sprites[i];
	
	        nextTexture = sprite._texture.baseTexture;
	        nextBlendMode = sprite.blendMode;
	        nextShader = sprite.shader || this.shader;
	
	        blendSwap = currentBlendMode !== nextBlendMode;
	        shaderSwap = currentShader !== nextShader; // should I use uidS???
	
	        if (currentBaseTexture !== nextTexture || blendSwap || shaderSwap)
	        {
	            this.renderBatch(currentBaseTexture, batchSize, start);
	
	            start = i;
	            batchSize = 0;
	            currentBaseTexture = nextTexture;
	
	            if (blendSwap)
	            {
	                currentBlendMode = nextBlendMode;
	                this.renderer.blendModeManager.setBlendMode( currentBlendMode );
	            }
	
	            if (shaderSwap)
	            {
	                currentShader = nextShader;
	
	
	
	                shader = currentShader.shaders ? currentShader.shaders[gl.id] : currentShader;
	
	                if (!shader)
	                {
	                    shader = currentShader.getShader(this.renderer);
	
	                }
	
	                // set shader function???
	                this.renderer.shaderManager.setShader(shader);
	
	                //TODO - i KNOW this can be optimised! Once v3 is stable il look at this next...
	                shader.uniforms.projectionMatrix.value = this.renderer.currentRenderTarget.projectionMatrix.toArray(true);
	                //Make this a little more dynamic / intelligent!
	                shader.syncUniforms();
	
	                //TODO investigate some kind of texture state managment??
	                // need to make sure this texture is the active one for all the batch swaps..
	                gl.activeTexture(gl.TEXTURE0);
	
	                // both thease only need to be set if they are changing..
	                // set the projection
	                //gl.uniformMatrix3fv(shader.uniforms.projectionMatrix._location, false, this.renderer.currentRenderTarget.projectionMatrix.toArray(true));
	
	
	            }
	        }
	
	        batchSize++;
	    }
	
	    this.renderBatch(currentBaseTexture, batchSize, start);
	
	    // then reset the batch!
	    this.currentBatchSize = 0;
	};
	
	/**
	 * Draws the currently batches sprites.
	 *
	 * @private
	 * @param texture {PIXI.Texture}
	 * @param size {number}
	 * @param startIndex {number}
	 */
	SpriteRenderer.prototype.renderBatch = function (texture, size, startIndex)
	{
	    if (size === 0)
	    {
	        return;
	    }
	
	    var gl = this.renderer.gl;
	
	    if (!texture._glTextures[gl.id])
	    {
	        this.renderer.updateTexture(texture);
	    }
	    else
	    {
	        // bind the current texture
	        gl.bindTexture(gl.TEXTURE_2D, texture._glTextures[gl.id]);
	    }
	
	    // now draw those suckas!
	    gl.drawElements(gl.TRIANGLES, size * 6, gl.UNSIGNED_SHORT, startIndex * 6 * 2);
	
	    // increment the draw count
	    this.renderer.drawCount++;
	};
	
	/**
	 * Starts a new sprite batch.
	 *
	 */
	SpriteRenderer.prototype.start = function ()
	{
	    var gl = this.renderer.gl;
	
	    // bind the main texture
	
	
	    // bind the buffers
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	
	    // this is the same for each shader?
	    var stride =  this.vertByteSize;
	    gl.vertexAttribPointer(this.shader.attributes.aVertexPosition, 2, gl.FLOAT, false, stride, 0);
	    gl.vertexAttribPointer(this.shader.attributes.aTextureCoord, 2, gl.FLOAT, false, stride, 2 * 4);
	
	    // color attributes will be interpreted as unsigned bytes and normalized
	    gl.vertexAttribPointer(this.shader.attributes.aColor, 4, gl.UNSIGNED_BYTE, true, stride, 4 * 4);
	};
	
	/**
	 * Destroys the SpriteBatch.
	 *
	 */
	SpriteRenderer.prototype.destroy = function ()
	{
	    this.renderer.gl.deleteBuffer(this.vertexBuffer);
	    this.renderer.gl.deleteBuffer(this.indexBuffer);
	
	    ObjectRenderer.prototype.destroy.call(this);
	
	    this.shader.destroy();
	
	    this.renderer = null;
	
	    this.vertices = null;
	    this.positions = null;
	    this.colors = null;
	    this.indices = null;
	
	    this.vertexBuffer = null;
	    this.indexBuffer = null;
	
	    this.sprites = null;
	    this.shader = null;
	};


/***/ },
/* 195 */
/*!*****************************************!*\
  !*** ./~/pixi.js/src/core/text/Text.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var Sprite = __webpack_require__(/*! ../sprites/Sprite */ 106),
	    Texture = __webpack_require__(/*! ../textures/Texture */ 30),
	    math = __webpack_require__(/*! ../math */ 9),
	    utils = __webpack_require__(/*! ../utils */ 7),
	    CONST = __webpack_require__(/*! ../const */ 6);
	
	/**
	 * A Text Object will create a line or multiple lines of text. To split a line you can use '\n' in your text string,
	 * or add a wordWrap property set to true and and wordWrapWidth property with a value in the style object.
	 *
	 * A Text can be created directly from a string and a style object
	 *
	 * ```js
	 * var text = new PIXI.Text('This is a pixi text',{font : '24px Arial', fill : 0xff1010, align : 'center'});
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI
	 * @param text {string} The copy that you would like the text to display
	 * @param [style] {object} The style parameters
	 * @param [style.font] {string} default 'bold 20px Arial' The style and size of the font
	 * @param [style.fill='black'] {String|Number} A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'
	 * @param [style.align='left'] {string} Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
	 * @param [style.stroke] {String|Number} A canvas fillstyle that will be used on the text stroke e.g 'blue', '#FCFF00'
	 * @param [style.strokeThickness=0] {number} A number that represents the thickness of the stroke. Default is 0 (no stroke)
	 * @param [style.wordWrap=false] {boolean} Indicates if word wrap should be used
	 * @param [style.wordWrapWidth=100] {number} The width at which text will wrap, it needs wordWrap to be set to true
	 * @param [style.letterSpacing=0] {number} The amount of spacing between letters, default is 0
	 * @param [style.breakWords=false] {boolean} Indicates if lines can be wrapped within words, it needs wordWrap to be set to true
	 * @param [style.lineHeight] {number} The line height, a number that represents the vertical space that a letter uses
	 * @param [style.dropShadow=false] {boolean} Set a drop shadow for the text
	 * @param [style.dropShadowColor='#000000'] {string} A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	 * @param [style.dropShadowAngle=Math.PI/4] {number} Set a angle of the drop shadow
	 * @param [style.dropShadowDistance=5] {number} Set a distance of the drop shadow
	 * @param [style.dropShadowBlur=0] {number} Set a shadow blur radius
	 * @param [style.padding=0] {number} Occasionally some fonts are cropped on top or bottom. Adding some padding will
	 *      prevent this from happening by adding padding to the top and bottom of text height.
	 * @param [style.textBaseline='alphabetic'] {string} The baseline of the text that is rendered.
	 * @param [style.lineJoin='miter'] {string} The lineJoin property sets the type of corner created, it can resolve
	 *      spiked text issues. Default is 'miter' (creates a sharp corner).
	 * @param [style.miterLimit=10] {number} The miter limit to use when using the 'miter' lineJoin mode. This can reduce
	 *      or increase the spikiness of rendered text.
	 */
	function Text(text, style, resolution)
	{
	    /**
	     * The canvas element that everything is drawn to
	     *
	     * @member {HTMLCanvasElement}
	     */
	    this.canvas = document.createElement('canvas');
	
	    /**
	     * The canvas 2d context that everything is drawn with
	     * @member {HTMLCanvasElement}
	     */
	    this.context = this.canvas.getContext('2d');
	
	    /**
	     * The resolution of the canvas.
	     * @member {number}
	     */
	    this.resolution = resolution || CONST.RESOLUTION;
	
	    /**
	     * Private tracker for the current text.
	     *
	     * @member {string}
	     * @private
	     */
	    this._text = null;
	
	    /**
	     * Private tracker for the current style.
	     *
	     * @member {object}
	     * @private
	     */
	    this._style = null;
	
	    var texture = Texture.fromCanvas(this.canvas);
	    texture.trim = new math.Rectangle();
	    Sprite.call(this, texture);
	
	    this.text = text;
	    this.style = style;
	}
	
	// constructor
	Text.prototype = Object.create(Sprite.prototype);
	Text.prototype.constructor = Text;
	module.exports = Text;
	
	Text.fontPropertiesCache = {};
	Text.fontPropertiesCanvas = document.createElement('canvas');
	Text.fontPropertiesContext = Text.fontPropertiesCanvas.getContext('2d');
	
	Object.defineProperties(Text.prototype, {
	    /**
	     * The width of the Text, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     * @memberof PIXI.Text#
	     */
	    width: {
	        get: function ()
	        {
	            if (this.dirty)
	            {
	                this.updateText();
	            }
	
	            return this.scale.x * this._texture._frame.width;
	        },
	        set: function (value)
	        {
	            this.scale.x = value / this._texture._frame.width;
	            this._width = value;
	        }
	    },
	
	    /**
	     * The height of the Text, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     * @memberof PIXI.Text#
	     */
	    height: {
	        get: function ()
	        {
	            if (this.dirty)
	            {
	                this.updateText();
	            }
	
	            return  this.scale.y * this._texture._frame.height;
	        },
	        set: function (value)
	        {
	            this.scale.y = value / this._texture._frame.height;
	            this._height = value;
	        }
	    },
	
	    /**
	     * Set the style of the text
	     *
	     * @param [style] {object} The style parameters
	     * @param [style.font='bold 20pt Arial'] {string} The style and size of the font
	     * @param [style.fill='black'] {string|number} A canvas fillstyle that will be used on the text eg 'red', '#00FF00'
	     * @param [style.align='left'] {string} Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
	     * @param [style.stroke='black'] {string|number} A canvas fillstyle that will be used on the text stroke eg 'blue', '#FCFF00'
	     * @param [style.strokeThickness=0] {number} A number that represents the thickness of the stroke. Default is 0 (no stroke)
	     * @param [style.wordWrap=false] {boolean} Indicates if word wrap should be used
	     * @param [style.wordWrapWidth=100] {number} The width at which text will wrap
	     * @param [style.lineHeight] {number} The line height, a number that represents the vertical space that a letter uses
	     * @param [style.dropShadow=false] {boolean} Set a drop shadow for the text
	     * @param [style.dropShadowColor='#000000'] {string|number} A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	     * @param [style.dropShadowAngle=Math.PI/6] {number} Set a angle of the drop shadow
	     * @param [style.dropShadowDistance=5] {number} Set a distance of the drop shadow
	     * @param [style.dropShadowBlur=0] {number} Set a shadow blur radius
	     * @param [style.padding=0] {number} Occasionally some fonts are cropped on top or bottom. Adding some padding will
	     *      prevent this from happening by adding padding to the top and bottom of text height.
	     * @param [style.textBaseline='alphabetic'] {string} The baseline of the text that is rendered.
	     * @param [style.lineJoin='miter'] {string} The lineJoin property sets the type of corner created, it can resolve
	     *      spiked text issues. Default is 'miter' (creates a sharp corner).
	     * @param [style.miterLimit=10] {number} The miter limit to use when using the 'miter' lineJoin mode. This can reduce
	     *      or increase the spikiness of rendered text.
	     * @memberof PIXI.Text#
	     */
	    style: {
	        get: function ()
	        {
	            return this._style;
	        },
	        set: function (style)
	        {
	            style = style || {};
	
	            if (typeof style.fill === 'number') {
	                style.fill = utils.hex2string(style.fill);
	            }
	
	            if (typeof style.stroke === 'number') {
	                style.stroke = utils.hex2string(style.stroke);
	            }
	
	            if (typeof style.dropShadowColor === 'number') {
	                style.dropShadowColor = utils.hex2string(style.dropShadowColor);
	            }
	
	            style.font = style.font || 'bold 20pt Arial';
	            style.fill = style.fill || 'black';
	            style.align = style.align || 'left';
	            style.stroke = style.stroke || 'black'; //provide a default, see: https://github.com/pixijs/pixi.js/issues/136
	            style.strokeThickness = style.strokeThickness || 0;
	            style.wordWrap = style.wordWrap || false;
	            style.wordWrapWidth = style.wordWrapWidth || 100;
	            style.breakWords = style.breakWords || false;
	            style.letterSpacing = style.letterSpacing || 0;
	
	            style.dropShadow = style.dropShadow || false;
	            style.dropShadowColor = style.dropShadowColor || '#000000';
	            style.dropShadowAngle = style.dropShadowAngle !== undefined ? style.dropShadowAngle : Math.PI / 6;
	            style.dropShadowDistance = style.dropShadowDistance !== undefined ? style.dropShadowDistance : 5;
	            style.dropShadowBlur = style.dropShadowBlur !== undefined ? style.dropShadowBlur : 0; //shadowBlur is '0' by default according to HTML
	
	            style.padding = style.padding || 0;
	
	            style.textBaseline = style.textBaseline || 'alphabetic';
	
	            style.lineJoin = style.lineJoin || 'miter';
	            style.miterLimit = style.miterLimit || 10;
	
	            this._style = style;
	            this.dirty = true;
	        }
	    },
	
	    /**
	     * Set the copy for the text object. To split a line you can use '\n'.
	     *
	     * @param text {string} The copy that you would like the text to display
	     * @memberof PIXI.Text#
	     */
	    text: {
	        get: function()
	        {
	            return this._text;
	        },
	        set: function (text){
	            text = text.toString() || ' ';
	            if (this._text === text)
	            {
	                return;
	            }
	            this._text = text;
	            this.dirty = true;
	        }
	    }
	});
	
	/**
	 * Renders text and updates it when needed
	 *
	 * @private
	 */
	Text.prototype.updateText = function ()
	{
	    var style = this._style;
	    this.context.font = style.font;
	
	    // word wrap
	    // preserve original text
	    var outputText = style.wordWrap ? this.wordWrap(this._text) : this._text;
	
	    // split text into lines
	    var lines = outputText.split(/(?:\r\n|\r|\n)/);
	
	    // calculate text width
	    var lineWidths = new Array(lines.length);
	    var maxLineWidth = 0;
	    var fontProperties = this.determineFontProperties(style.font);
	    for (var i = 0; i < lines.length; i++)
	    {
	        var lineWidth = this.context.measureText(lines[i]).width + ((lines[i].length - 1) * style.letterSpacing);
	        lineWidths[i] = lineWidth;
	        maxLineWidth = Math.max(maxLineWidth, lineWidth);
	    }
	
	    var width = maxLineWidth + style.strokeThickness;
	    if (style.dropShadow)
	    {
	        width += style.dropShadowDistance;
	    }
	
	    this.canvas.width = Math.ceil( ( width + this.context.lineWidth ) * this.resolution );
	
	    // calculate text height
	    var lineHeight = this.style.lineHeight || fontProperties.fontSize + style.strokeThickness;
	
	    var height = lineHeight * lines.length;
	    if (style.dropShadow)
	    {
	        height += style.dropShadowDistance;
	    }
	
	    this.canvas.height = Math.ceil( ( height + this._style.padding * 2 ) * this.resolution );
	
	    this.context.scale( this.resolution, this.resolution);
	
	    if (navigator.isCocoonJS)
	    {
	        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	
	    }
	
	    //this.context.fillStyle="#FF0000";
	    //this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
	
	    this.context.font = style.font;
	    this.context.strokeStyle = style.stroke;
	    this.context.lineWidth = style.strokeThickness;
	    this.context.textBaseline = style.textBaseline;
	    this.context.lineJoin = style.lineJoin;
	    this.context.miterLimit = style.miterLimit;
	
	    var linePositionX;
	    var linePositionY;
	
	    if (style.dropShadow)
	    {
	        if (style.dropShadowBlur > 0) {
	            this.context.shadowColor = style.dropShadowColor;
	            this.context.shadowBlur = style.dropShadowBlur;
	        } else {
	            this.context.fillStyle = style.dropShadowColor;
	        }
	
	        var xShadowOffset = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
	        var yShadowOffset = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;
	
	        for (i = 0; i < lines.length; i++)
	        {
	            linePositionX = style.strokeThickness / 2;
	            linePositionY = (style.strokeThickness / 2 + i * lineHeight) + fontProperties.ascent;
	
	            if (style.align === 'right')
	            {
	                linePositionX += maxLineWidth - lineWidths[i];
	            }
	            else if (style.align === 'center')
	            {
	                linePositionX += (maxLineWidth - lineWidths[i]) / 2;
	            }
	
	            if (style.fill)
	            {
	                this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset, linePositionY + yShadowOffset + style.padding);
	            }
	        }
	    }
	
	    //set canvas text styles
	    this.context.fillStyle = style.fill;
	
	    //draw lines line by line
	    for (i = 0; i < lines.length; i++)
	    {
	        linePositionX = style.strokeThickness / 2;
	        linePositionY = (style.strokeThickness / 2 + i * lineHeight) + fontProperties.ascent;
	
	        if (style.align === 'right')
	        {
	            linePositionX += maxLineWidth - lineWidths[i];
	        }
	        else if (style.align === 'center')
	        {
	            linePositionX += (maxLineWidth - lineWidths[i]) / 2;
	        }
	
	        if (style.stroke && style.strokeThickness)
	        {
	            this.drawLetterSpacing(lines[i], linePositionX, linePositionY + style.padding, true);
	        }
	
	        if (style.fill)
	        {
	            this.drawLetterSpacing(lines[i], linePositionX, linePositionY + style.padding);
	        }
	    }
	
	    this.updateTexture();
	};
	
	/**
	 * Render the text with letter-spacing.
	 *
	 * @private
	 */
	Text.prototype.drawLetterSpacing = function(text, x, y, isStroke)
	{
	    var style = this._style;
	
	    // letterSpacing of 0 means normal
	    var letterSpacing = style.letterSpacing;
	
	    if (letterSpacing === 0)
	    {
	        if (isStroke)
	        {
	            this.context.strokeText(text, x, y);
	        }
	        else
	        {
	            this.context.fillText(text, x, y);
	        }
	        return;
	    }
	
	    var characters = String.prototype.split.call(text, ''),
	        index = 0,
	        current,
	        currentPosition = x;
	
	    while (index < text.length)
	    {
	        current = characters[index++];
	        if (isStroke) 
	        {
	            this.context.strokeText(current, currentPosition, y);
	        }
	        else
	        {
	            this.context.fillText(current, currentPosition, y);
	        }
	        currentPosition += this.context.measureText(current).width + letterSpacing;
	    }
	};
	
	/**
	 * Updates texture size based on canvas size
	 *
	 * @private
	 */
	Text.prototype.updateTexture = function ()
	{
	    var texture = this._texture;
	    var style = this._style;
	
	    texture.baseTexture.hasLoaded = true;
	    texture.baseTexture.resolution = this.resolution;
	
	    texture.baseTexture.width = this.canvas.width / this.resolution;
	    texture.baseTexture.height = this.canvas.height / this.resolution;
	    texture.crop.width = texture._frame.width = this.canvas.width / this.resolution;
	    texture.crop.height = texture._frame.height = this.canvas.height / this.resolution;
	
	    texture.trim.x = 0;
	    texture.trim.y = -style.padding;
	
	    texture.trim.width = texture._frame.width;
	    texture.trim.height = texture._frame.height - style.padding*2;
	
	    this._width = this.canvas.width / this.resolution;
	    this._height = this.canvas.height / this.resolution;
	
	    texture.baseTexture.emit('update',  texture.baseTexture);
	
	    this.dirty = false;
	};
	
	/**
	 * Renders the object using the WebGL renderer
	 *
	 * @param renderer {PIXI.WebGLRenderer}
	 */
	Text.prototype.renderWebGL = function (renderer)
	{
	    if (this.dirty)
	    {
	        //this.resolution = 1//renderer.resolution;
	
	        this.updateText();
	    }
	
	    Sprite.prototype.renderWebGL.call(this, renderer);
	};
	
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @param renderer {PIXI.CanvasRenderer}
	 * @private
	 */
	Text.prototype._renderCanvas = function (renderer)
	{
	    if (this.dirty)
	    {
	     //   this.resolution = 1//renderer.resolution;
	
	        this.updateText();
	    }
	
	    Sprite.prototype._renderCanvas.call(this, renderer);
	};
	
	/**
	 * Calculates the ascent, descent and fontSize of a given fontStyle
	 *
	 * @param fontStyle {object}
	 * @private
	 */
	Text.prototype.determineFontProperties = function (fontStyle)
	{
	    var properties = Text.fontPropertiesCache[fontStyle];
	
	    if (!properties)
	    {
	        properties = {};
	
	        var canvas = Text.fontPropertiesCanvas;
	        var context = Text.fontPropertiesContext;
	
	        context.font = fontStyle;
	
	        var width = Math.ceil(context.measureText('|MÉq').width);
	        var baseline = Math.ceil(context.measureText('M').width);
	        var height = 2 * baseline;
	
	        baseline = baseline * 1.4 | 0;
	
	        canvas.width = width;
	        canvas.height = height;
	
	        context.fillStyle = '#f00';
	        context.fillRect(0, 0, width, height);
	
	        context.font = fontStyle;
	
	        context.textBaseline = 'alphabetic';
	        context.fillStyle = '#000';
	        context.fillText('|MÉq', 0, baseline);
	
	        var imagedata = context.getImageData(0, 0, width, height).data;
	        var pixels = imagedata.length;
	        var line = width * 4;
	
	        var i, j;
	
	        var idx = 0;
	        var stop = false;
	
	        // ascent. scan from top to bottom until we find a non red pixel
	        for (i = 0; i < baseline; i++)
	        {
	            for (j = 0; j < line; j += 4)
	            {
	                if (imagedata[idx + j] !== 255)
	                {
	                    stop = true;
	                    break;
	                }
	            }
	            if (!stop)
	            {
	                idx += line;
	            }
	            else
	            {
	                break;
	            }
	        }
	
	        properties.ascent = baseline - i;
	
	        idx = pixels - line;
	        stop = false;
	
	        // descent. scan from bottom to top until we find a non red pixel
	        for (i = height; i > baseline; i--)
	        {
	            for (j = 0; j < line; j += 4)
	            {
	                if (imagedata[idx + j] !== 255)
	                {
	                    stop = true;
	                    break;
	                }
	            }
	            if (!stop)
	            {
	                idx -= line;
	            }
	            else
	            {
	                break;
	            }
	        }
	
	        properties.descent = i - baseline;
	        properties.fontSize = properties.ascent + properties.descent;
	
	        Text.fontPropertiesCache[fontStyle] = properties;
	    }
	
	    return properties;
	};
	
	/**
	 * Applies newlines to a string to have it optimally fit into the horizontal
	 * bounds set by the Text object's wordWrapWidth property.
	 *
	 * @param text {string}
	 * @private
	 */
	Text.prototype.wordWrap = function (text)
	{
	    // Greedy wrapping algorithm that will wrap words as the line grows longer
	    // than its horizontal bounds.
	    var result = '';
	    var lines = text.split('\n');
	    var wordWrapWidth = this._style.wordWrapWidth;
	    for (var i = 0; i < lines.length; i++)
	    {
	        var spaceLeft = wordWrapWidth;
	        var words = lines[i].split(' ');
	        for (var j = 0; j < words.length; j++)
	        {
	            var wordWidth = this.context.measureText(words[j]).width;
	            if (this._style.breakWords && wordWidth > wordWrapWidth) 
	            {
	                // Word should be split in the middle
	                var characters = words[j].split('');
	                for (var c = 0; c < characters.length; c++) 
	                {
	                  var characterWidth = this.context.measureText(characters[c]).width;
	                  if (characterWidth > spaceLeft) 
	                  {
	                    result += '\n' + characters[c];
	                    spaceLeft = wordWrapWidth - characterWidth;
	                  } 
	                  else 
	                  {
	                    if (c === 0) 
	                    {
	                      result += ' ';
	                    }
	                    result += characters[c];
	                    spaceLeft -= characterWidth;
	                  }
	                }
	            }
	            else 
	            {
	                var wordWidthWithSpace = wordWidth + this.context.measureText(' ').width;
	                if (j === 0 || wordWidthWithSpace > spaceLeft)
	                {
	                    // Skip printing the newline if it's the first word of the line that is
	                    // greater than the word wrap width.
	                    if (j > 0)
	                    {
	                        result += '\n';
	                    }
	                    result += words[j];
	                    spaceLeft = wordWrapWidth - wordWidth;
	                }
	                else
	                {
	                    spaceLeft -= wordWidthWithSpace;
	                    result += ' ' + words[j];
	                }
	            }
	        }
	
	        if (i < lines.length-1)
	        {
	            result += '\n';
	        }
	    }
	    return result;
	};
	
	/**
	 * Returns the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account.
	 *
	 * @param matrix {PIXI.Matrix} the transformation matrix of the Text
	 * @return {PIXI.Rectangle} the framing rectangle
	 */
	Text.prototype.getBounds = function (matrix)
	{
	    if (this.dirty)
	    {
	        this.updateText();
	    }
	
	    return Sprite.prototype.getBounds.call(this, matrix);
	};
	
	/**
	 * Destroys this text object.
	 *
	 * @param [destroyBaseTexture=true] {boolean} whether to destroy the base texture as well
	 */
	Text.prototype.destroy = function (destroyBaseTexture)
	{
	    // make sure to reset the the context and canvas.. dont want this hanging around in memory!
	    this.context = null;
	    this.canvas = null;
	
	    this._style = null;
	
	    this._texture.destroy(destroyBaseTexture === undefined ? true : destroyBaseTexture);
	};


/***/ },
/* 196 */
/*!*********************************************!*\
  !*** ./~/pixi.js/src/core/ticker/Ticker.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var CONST = __webpack_require__(/*! ../const */ 6),
	    EventEmitter = __webpack_require__(/*! eventemitter3 */ 18),
	    // Internal event used by composed emitter
	    TICK = 'tick';
	
	/**
	 * A Ticker class that runs an update loop that other objects listen to.
	 * This class is composed around an EventEmitter object to add listeners
	 * meant for execution on the next requested animation frame.
	 * Animation frames are requested only when necessary,
	 * e.g. When the ticker is started and the emitter has listeners.
	 *
	 * @class
	 * @memberof PIXI.ticker
	 */
	function Ticker()
	{
	    var _this = this;
	
	    /**
	     * Internal tick method bound to ticker instance.
	     * This is because in early 2015, Function.bind
	     * is still 60% slower in high performance scenarios.
	     * Also separating frame requests from update method
	     * so listeners may be called at any time and with
	     * any animation API, just invoke ticker.update(time).
	     *
	     * @private
	     */
	    this._tick = function _tick(time) {
	
	        _this._requestId = null;
	
	        if (_this.started)
	        {
	            // Invoke listeners now
	            _this.update(time);
	            // Listener side effects may have modified ticker state.
	            if (_this.started && _this._requestId === null && _this._emitter.listeners(TICK, true))
	            {
	                _this._requestId = requestAnimationFrame(_this._tick);
	            }
	        }
	    };
	
	    /**
	     * Internal emitter used to fire 'tick' event
	     * @private
	     */
	    this._emitter = new EventEmitter();
	
	    /**
	     * Internal current frame request ID
	     * @private
	     */
	    this._requestId = null;
	
	    /**
	     * Internal value managed by minFPS property setter and getter.
	     * This is the maximum allowed milliseconds between updates.
	     * @private
	     */
	    this._maxElapsedMS = 100;
	
	    /**
	     * Whether or not this ticker should invoke the method
	     * {@link PIXI.ticker.Ticker#start} automatically
	     * when a listener is added.
	     *
	     * @member {boolean}
	     * @default false
	     */
	    this.autoStart = false;
	
	    /**
	     * Scalar time value from last frame to this frame.
	     * This value is capped by setting {@link PIXI.ticker.Ticker#minFPS}
	     * and is scaled with {@link PIXI.ticker.Ticker#speed}.
	     * **Note:** The cap may be exceeded by scaling.
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.deltaTime = 1;
	
	    /**
	     * Time elapsed in milliseconds from last frame to this frame.
	     * Opposed to what the scalar {@link PIXI.ticker.Ticker#deltaTime}
	     * is based, this value is neither capped nor scaled.
	     * If the platform supports DOMHighResTimeStamp,
	     * this value will have a precision of 1 µs.
	     *
	     * @member {DOMHighResTimeStamp|number}
	     * @default 1 / TARGET_FPMS
	     */
	    this.elapsedMS = 1 / CONST.TARGET_FPMS; // default to target frame time
	
	    /**
	     * The last time {@link PIXI.ticker.Ticker#update} was invoked.
	     * This value is also reset internally outside of invoking
	     * update, but only when a new animation frame is requested.
	     * If the platform supports DOMHighResTimeStamp,
	     * this value will have a precision of 1 µs.
	     *
	     * @member {DOMHighResTimeStamp|number}
	     * @default 0
	     */
	    this.lastTime = 0;
	
	    /**
	     * Factor of current {@link PIXI.ticker.Ticker#deltaTime}.
	     * @example
	     * // Scales ticker.deltaTime to what would be
	     * // the equivalent of approximately 120 FPS
	     * ticker.speed = 2;
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.speed = 1;
	
	    /**
	     * Whether or not this ticker has been started.
	     * `true` if {@link PIXI.ticker.Ticker#start} has been called.
	     * `false` if {@link PIXI.ticker.Ticker#stop} has been called.
	     * While `false`, this value may change to `true` in the
	     * event of {@link PIXI.ticker.Ticker#autoStart} being `true`
	     * and a listener is added.
	     *
	     * @member {boolean}
	     * @default false
	     */
	    this.started = false;
	}
	
	Object.defineProperties(Ticker.prototype, {
	    /**
	     * The frames per second at which this ticker is running.
	     * The default is approximately 60 in most modern browsers.
	     * **Note:** This does not factor in the value of
	     * {@link PIXI.ticker.Ticker#speed}, which is specific
	     * to scaling {@link PIXI.ticker.Ticker#deltaTime}.
	     *
	     * @member
	     * @memberof PIXI.ticker.Ticker#
	     * @readonly
	     */
	    FPS: {
	        get: function()
	        {
	            return 1000 / this.elapsedMS;
	        }
	    },
	
	    /**
	     * Manages the maximum amount of milliseconds allowed to
	     * elapse between invoking {@link PIXI.ticker.Ticker#update}.
	     * This value is used to cap {@link PIXI.ticker.Ticker#deltaTime},
	     * but does not effect the measured value of {@link PIXI.ticker.Ticker#FPS}.
	     * When setting this property it is clamped to a value between
	     * `0` and `PIXI.TARGET_FPMS * 1000`.
	     *
	     * @member
	     * @memberof PIXI.ticker.Ticker#
	     * @default 10
	     */
	    minFPS: {
	        get: function()
	        {
	            return 1000 / this._maxElapsedMS;
	        },
	        set: function(fps)
	        {
	            // Clamp: 0 to TARGET_FPMS
	            var minFPMS = Math.min(Math.max(0, fps) / 1000, CONST.TARGET_FPMS);
	            this._maxElapsedMS = 1 / minFPMS;
	        }
	    }
	});
	
	/**
	 * Conditionally requests a new animation frame.
	 * If a frame has not already been requested, and if the internal
	 * emitter has listeners, a new frame is requested.
	 *
	 * @private
	 */
	Ticker.prototype._requestIfNeeded = function _requestIfNeeded()
	{
	    if (this._requestId === null && this._emitter.listeners(TICK, true))
	    {
	        // ensure callbacks get correct delta
	        this.lastTime = performance.now();
	        this._requestId = requestAnimationFrame(this._tick);
	    }
	};
	
	/**
	 * Conditionally cancels a pending animation frame.
	 *
	 * @private
	 */
	Ticker.prototype._cancelIfNeeded = function _cancelIfNeeded()
	{
	    if (this._requestId !== null)
	    {
	        cancelAnimationFrame(this._requestId);
	        this._requestId = null;
	    }
	};
	
	/**
	 * Conditionally requests a new animation frame.
	 * If the ticker has been started it checks if a frame has not already
	 * been requested, and if the internal emitter has listeners. If these
	 * conditions are met, a new frame is requested. If the ticker has not
	 * been started, but autoStart is `true`, then the ticker starts now,
	 * and continues with the previous conditions to request a new frame.
	 *
	 * @private
	 */
	Ticker.prototype._startIfPossible = function _startIfPossible()
	{
	    if (this.started)
	    {
	        this._requestIfNeeded();
	    }
	    else if (this.autoStart)
	    {
	        this.start();
	    }
	};
	
	/**
	 * Calls {@link module:eventemitter3.EventEmitter#on} internally for the
	 * internal 'tick' event. It checks if the emitter has listeners,
	 * and if so it requests a new animation frame at this point.
	 *
	 * @param fn {Function} The listener function to be added for updates
	 * @param [context] {Function} The listener context
	 * @returns {PIXI.ticker.Ticker} this
	 */
	Ticker.prototype.add = function add(fn, context)
	{
	    this._emitter.on(TICK, fn, context);
	
	    this._startIfPossible();
	
	    return this;
	};
	
	/**
	 * Calls {@link module:eventemitter3.EventEmitter#once} internally for the
	 * internal 'tick' event. It checks if the emitter has listeners,
	 * and if so it requests a new animation frame at this point.
	 *
	 * @param fn {Function} The listener function to be added for one update
	 * @param [context] {Function} The listener context
	 * @returns {PIXI.ticker.Ticker} this
	 */
	Ticker.prototype.addOnce = function addOnce(fn, context)
	{
	    this._emitter.once(TICK, fn, context);
	
	    this._startIfPossible();
	
	    return this;
	};
	
	/**
	 * Calls {@link module:eventemitter3.EventEmitter#off} internally for 'tick' event.
	 * It checks if the emitter has listeners for 'tick' event.
	 * If it does, then it cancels the animation frame.
	 *
	 * @param [fn] {Function} The listener function to be removed
	 * @param [context] {Function} The listener context to be removed
	 * @returns {PIXI.ticker.Ticker} this
	 */
	Ticker.prototype.remove = function remove(fn, context)
	{
	    this._emitter.off(TICK, fn, context);
	
	    if (!this._emitter.listeners(TICK, true))
	    {
	        this._cancelIfNeeded();
	    }
	
	    return this;
	};
	
	/**
	 * Starts the ticker. If the ticker has listeners
	 * a new animation frame is requested at this point.
	 */
	Ticker.prototype.start = function start()
	{
	    if (!this.started)
	    {
	        this.started = true;
	        this._requestIfNeeded();
	    }
	};
	
	/**
	 * Stops the ticker. If the ticker has requested
	 * an animation frame it is canceled at this point.
	 */
	Ticker.prototype.stop = function stop()
	{
	    if (this.started)
	    {
	        this.started = false;
	        this._cancelIfNeeded();
	    }
	};
	
	/**
	 * Triggers an update. An update entails setting the
	 * current {@link PIXI.ticker.Ticker#elapsedMS},
	 * the current {@link PIXI.ticker.Ticker#deltaTime},
	 * invoking all listeners with current deltaTime,
	 * and then finally setting {@link PIXI.ticker.Ticker#lastTime}
	 * with the value of currentTime that was provided.
	 * This method will be called automatically by animation
	 * frame callbacks if the ticker instance has been started
	 * and listeners are added.
	 *
	 * @param [currentTime=performance.now()] {DOMHighResTimeStamp|number} the current time of execution
	 */
	Ticker.prototype.update = function update(currentTime)
	{
	    var elapsedMS;
	
	    // Allow calling update directly with default currentTime.
	    currentTime = currentTime || performance.now();
	    // Save uncapped elapsedMS for measurement
	    elapsedMS = this.elapsedMS = currentTime - this.lastTime;
	
	    // cap the milliseconds elapsed used for deltaTime
	    if (elapsedMS > this._maxElapsedMS)
	    {
	        elapsedMS = this._maxElapsedMS;
	    }
	
	    this.deltaTime = elapsedMS * CONST.TARGET_FPMS * this.speed;
	
	    // Invoke listeners added to internal emitter
	    this._emitter.emit(TICK, this.deltaTime);
	
	    this.lastTime = currentTime;
	};
	
	module.exports = Ticker;


/***/ },
/* 197 */
/*!********************************************!*\
  !*** ./~/pixi.js/src/core/ticker/index.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	var Ticker = __webpack_require__(/*! ./Ticker */ 196);
	
	/**
	 * The shared ticker instance used by {@link PIXI.extras.MovieClip}.
	 * and by {@link PIXI.interaction.InteractionManager}.
	 * The property {@link PIXI.ticker.Ticker#autoStart} is set to `true`
	 * for this instance. Please follow the examples for usage, including
	 * how to opt-out of auto-starting the shared ticker.
	 *
	 * @example
	 * var ticker = PIXI.ticker.shared;
	 * // Set this to prevent starting this ticker when listeners are added.
	 * // By default this is true only for the PIXI.ticker.shared instance.
	 * ticker.autoStart = false;
	 * // FYI, call this to ensure the ticker is stopped. It should be stopped
	 * // if you have not attempted to render anything yet.
	 * ticker.stop();
	 * // Call this when you are ready for a running shared ticker.
	 * ticker.start();
	 *
	 * @example
	 * // You may use the shared ticker to render...
	 * var renderer = PIXI.autoDetectRenderer(800, 600);
	 * var stage = new PIXI.Container();
	 * var interactionManager = PIXI.interaction.InteractionManager(renderer);
	 * document.body.appendChild(renderer.view);
	 * ticker.add(function (time) {
	 *     renderer.render(stage);
	 * });
	 *
	 * @example
	 * // Or you can just update it manually.
	 * ticker.autoStart = false;
	 * ticker.stop();
	 * function animate(time) {
	 *     ticker.update(time);
	 *     renderer.render(stage);
	 *     requestAnimationFrame(animate);
	 * }
	 * animate(performance.now());
	 *
	 * @type {PIXI.ticker.Ticker}
	 * @memberof PIXI.ticker
	 */
	var shared = new Ticker();
	shared.autoStart = true;
	
	/**
	 * @namespace PIXI.ticker
	 */
	module.exports = {
	    shared: shared,
	    Ticker: Ticker
	};


/***/ },
/* 198 */
/*!**************************************************!*\
  !*** ./~/pixi.js/src/core/utils/pluginTarget.js ***!
  \**************************************************/
/***/ function(module, exports) {

	/**
	 * Mixins functionality to make an object have "plugins".
	 *
	 * @mixin
	 * @memberof PIXI.utils
	 * @param obj {object} The object to mix into.
	 * @example
	 *      function MyObject() {}
	 *
	 *      pluginTarget.mixin(MyObject);
	 */
	function pluginTarget(obj)
	{
	    obj.__plugins = {};
	
	    /**
	     * Adds a plugin to an object
	     *
	     * @param pluginName {string} The events that should be listed.
	     * @param ctor {Function} The constructor function for the plugin.
	     */
	    obj.registerPlugin = function (pluginName, ctor)
	    {
	        obj.__plugins[pluginName] = ctor;
	    };
	
	    /**
	     * Instantiates all the plugins of this object
	     *
	     */
	    obj.prototype.initPlugins = function ()
	    {
	        this.plugins = this.plugins || {};
	
	        for (var o in obj.__plugins)
	        {
	            this.plugins[o] = new (obj.__plugins[o])(this);
	        }
	    };
	
	    /**
	     * Removes all the plugins of this object
	     *
	     */
	    obj.prototype.destroyPlugins = function ()
	    {
	        for (var o in this.plugins)
	        {
	            this.plugins[o].destroy();
	            this.plugins[o] = null;
	        }
	
	        this.plugins = null;
	    };
	}
	
	
	module.exports = {
	    /**
	     * Mixes in the properties of the pluginTarget into another object
	     *
	     * @param object {object} The obj to mix into
	     */
	    mixin: function mixin(obj)
	    {
	        pluginTarget(obj);
	    }
	};


/***/ },
/* 199 */
/*!**************************************!*\
  !*** ./~/pixi.js/src/deprecation.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	/*global console */
	var core = __webpack_require__(/*! ./core */ 1),
	    mesh = __webpack_require__(/*! ./mesh */ 119),
	    extras = __webpack_require__(/*! ./extras */ 62),
	    filters = __webpack_require__(/*! ./filters */ 109);
	
	/**
	 * @class
	 * @private
	 * @name SpriteBatch
	 * @memberof PIXI
	 * @see PIXI.ParticleContainer
	 * @throws {ReferenceError} SpriteBatch does not exist any more, please use the new ParticleContainer instead.
	 * @deprecated since version 3.0.0
	 */
	core.SpriteBatch = function()
	{
	    throw new ReferenceError('SpriteBatch does not exist any more, please use the new ParticleContainer instead.');
	};
	
	/**
	 * @class
	 * @private
	 * @name AssetLoader
	 * @memberof PIXI
	 * @see PIXI.loaders.Loader
	 * @throws {ReferenceError} The loader system was overhauled in pixi v3, please see the new PIXI.loaders.Loader class.
	 * @deprecated since version 3.0.0
	 */
	core.AssetLoader = function()
	{
	    throw new ReferenceError('The loader system was overhauled in pixi v3, please see the new PIXI.loaders.Loader class.');
	};
	
	Object.defineProperties(core, {
	
	    /**
	     * @class
	     * @private
	     * @name Stage
	     * @memberof PIXI
	     * @see PIXI.Container
	     * @deprecated since version 3.0.0
	     */
	    Stage: {
	        get: function()
	        {
	            console.warn('You do not need to use a PIXI Stage any more, you can simply render any container.');
	            return core.Container;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name DisplayObjectContainer
	     * @memberof PIXI
	     * @see PIXI.Container
	     * @deprecated since version 3.0.0
	     */
	    DisplayObjectContainer: {
	        get: function()
	        {
	            console.warn('DisplayObjectContainer has been shortened to Container, please use Container from now on.');
	            return core.Container;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name Strip
	     * @memberof PIXI
	     * @see PIXI.mesh.Mesh
	     * @deprecated since version 3.0.0
	     */
	    Strip: {
	        get: function()
	        {
	            console.warn('The Strip class has been renamed to Mesh and moved to mesh.Mesh, please use mesh.Mesh from now on.');
	            return mesh.Mesh;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name Rope
	     * @memberof PIXI
	     * @see PIXI.mesh.Rope
	     * @deprecated since version 3.0.0
	     */
	    Rope: {
	        get: function()
	        {
	            console.warn('The Rope class has been moved to mesh.Rope, please use mesh.Rope from now on.');
	            return mesh.Rope;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name MovieClip
	     * @memberof PIXI
	     * @see PIXI.extras.MovieClip
	     * @deprecated since version 3.0.0
	     */
	    MovieClip: {
	        get: function()
	        {
	            console.warn('The MovieClip class has been moved to extras.MovieClip, please use extras.MovieClip from now on.');
	            return extras.MovieClip;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name TilingSprite
	     * @memberof PIXI
	     * @see PIXI.extras.TilingSprite
	     * @deprecated since version 3.0.0
	     */
	    TilingSprite: {
	        get: function()
	        {
	            console.warn('The TilingSprite class has been moved to extras.TilingSprite, please use extras.TilingSprite from now on.');
	            return extras.TilingSprite;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name BitmapText
	     * @memberof PIXI
	     * @see PIXI.extras.BitmapText
	     * @deprecated since version 3.0.0
	     */
	    BitmapText: {
	        get: function()
	        {
	            console.warn('The BitmapText class has been moved to extras.BitmapText, please use extras.BitmapText from now on.');
	            return extras.BitmapText;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name blendModes
	     * @memberof PIXI
	     * @see PIXI.BLEND_MODES
	     * @deprecated since version 3.0.0
	     */
	    blendModes: {
	        get: function()
	        {
	            console.warn('The blendModes has been moved to BLEND_MODES, please use BLEND_MODES from now on.');
	            return core.BLEND_MODES;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name scaleModes
	     * @memberof PIXI
	     * @see PIXI.SCALE_MODES
	     * @deprecated since version 3.0.0
	     */
	    scaleModes: {
	        get: function()
	        {
	            console.warn('The scaleModes has been moved to SCALE_MODES, please use SCALE_MODES from now on.');
	            return core.SCALE_MODES;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name BaseTextureCache
	     * @memberof PIXI
	     * @see PIXI.utils.BaseTextureCache
	     * @deprecated since version 3.0.0
	     */
	    BaseTextureCache: {
	        get: function ()
	        {
	            console.warn('The BaseTextureCache class has been moved to utils.BaseTextureCache, please use utils.BaseTextureCache from now on.');
	            return core.utils.BaseTextureCache;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name TextureCache
	     * @memberof PIXI
	     * @see PIXI.utils.TextureCache
	     * @deprecated since version 3.0.0
	     */
	    TextureCache: {
	        get: function ()
	        {
	            console.warn('The TextureCache class has been moved to utils.TextureCache, please use utils.TextureCache from now on.');
	            return core.utils.TextureCache;
	        }
	    },
	
	    /**
	     * @namespace
	     * @private
	     * @name math
	     * @memberof PIXI
	     * @see PIXI
	     * @deprecated since version 3.0.6
	     */
	    math: {
	        get: function ()
	        {
	            console.warn('The math namespace is deprecated, please access members already accessible on PIXI.');
	            return core;
	        }
	    }
	});
	
	/**
	 * @method
	 * @private
	 * @name PIXI.Sprite#setTexture
	 * @see PIXI.Sprite#texture
	 * @deprecated since version 3.0.0
	 */
	core.Sprite.prototype.setTexture = function(texture)
	{
	    this.texture = texture;
	    console.warn('setTexture is now deprecated, please use the texture property, e.g : sprite.texture = texture;');
	};
	
	/**
	 * @method
	 * @name PIXI.extras.BitmapText#setText
	 * @see PIXI.extras.BitmapText#text
	 * @deprecated since version 3.0.0
	 */
	extras.BitmapText.prototype.setText = function(text)
	{
	    this.text = text;
	    console.warn('setText is now deprecated, please use the text property, e.g : myBitmapText.text = \'my text\';');
	};
	
	/**
	 * @method
	 * @name PIXI.Text#setText
	 * @see PIXI.Text#text
	 * @deprecated since version 3.0.0
	 */
	core.Text.prototype.setText = function(text)
	{
	    this.text = text;
	    console.warn('setText is now deprecated, please use the text property, e.g : myText.text = \'my text\';');
	};
	
	/**
	 * @method
	 * @name PIXI.Text#setStyle
	 * @see PIXI.Text#style
	 * @deprecated since version 3.0.0
	 */
	core.Text.prototype.setStyle = function(style)
	{
	    this.style = style;
	    console.warn('setStyle is now deprecated, please use the style property, e.g : myText.style = style;');
	};
	
	/**
	 * @method
	 * @name PIXI.Texture#setFrame
	 * @see PIXI.Texture#setFrame
	 * @deprecated since version 3.0.0
	 */
	core.Texture.prototype.setFrame = function(frame)
	{
	    this.frame = frame;
	    console.warn('setFrame is now deprecated, please use the frame property, e.g : myTexture.frame = frame;');
	};
	
	Object.defineProperties(filters, {
	
	    /**
	     * @class
	     * @private
	     * @name PIXI.filters.AbstractFilter
	     * @see PIXI.AbstractFilter
	     * @deprecated since version 3.0.6
	     */
	    AbstractFilter: {
	        get: function()
	        {
	            console.warn('filters.AbstractFilter is an undocumented alias, please use AbstractFilter from now on.');
	            return core.AbstractFilter;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name PIXI.filters.FXAAFilter
	     * @see PIXI.FXAAFilter
	     * @deprecated since version 3.0.6
	     */
	    FXAAFilter: {
	        get: function()
	        {
	            console.warn('filters.FXAAFilter is an undocumented alias, please use FXAAFilter from now on.');
	            return core.FXAAFilter;
	        }
	    },
	
	    /**
	     * @class
	     * @private
	     * @name PIXI.filters.SpriteMaskFilter
	     * @see PIXI.SpriteMaskFilter
	     * @deprecated since version 3.0.6
	     */
	    SpriteMaskFilter: {
	        get: function()
	        {
	            console.warn('filters.SpriteMaskFilter is an undocumented alias, please use SpriteMaskFilter from now on.');
	            return core.SpriteMaskFilter;
	        }
	    }
	});
	
	/**
	 * @method
	 * @name PIXI.utils.uuid
	 * @see PIXI.utils.uid
	 * @deprecated since version 3.0.6
	 */
	core.utils.uuid = function ()
	{
	    console.warn('utils.uuid() is deprecated, please use utils.uid() from now on.');
	    return core.utils.uid();
	};


/***/ },
/* 200 */
/*!********************************************!*\
  !*** ./~/pixi.js/src/extras/BitmapText.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1);
	
	/**
	 * A BitmapText object will create a line or multiple lines of text using bitmap font. To
	 * split a line you can use '\n', '\r' or '\r\n' in your string. You can generate the fnt files using:
	 *
	 * A BitmapText can only be created when the font is loaded
	 *
	 * ```js
	 * // in this case the font is in a file called 'desyrel.fnt'
	 * var bitmapText = new PIXI.extras.BitmapText("text using a fancy font!", {font: "35px Desyrel", align: "right"});
	 * ```
	 *
	 *
	 * http://www.angelcode.com/products/bmfont/ for windows or
	 * http://www.bmglyph.com/ for mac.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.extras
	 * @param text {string} The copy that you would like the text to display
	 * @param style {object} The style parameters
	 * @param style.font {string|object} The font descriptor for the object, can be passed as a string of form
	 *      "24px FontName" or "FontName" or as an object with explicit name/size properties.
	 * @param [style.font.name] {string} The bitmap font id
	 * @param [style.font.size] {number} The size of the font in pixels, e.g. 24
	 * @param [style.align='left'] {string} Alignment for multiline text ('left', 'center' or 'right'), does not affect
	 *      single line text
	 * @param [style.tint=0xFFFFFF] {number} The tint color
	 */
	function BitmapText(text, style)
	{
	    core.Container.call(this);
	
	    style = style || {};
	
	    /**
	     * The width of the overall text, different from fontSize,
	     * which is defined in the style object
	     *
	     * @member {number}
	     * @readOnly
	     */
	    this.textWidth = 0;
	
	    /**
	     * The height of the overall text, different from fontSize,
	     * which is defined in the style object
	     *
	     * @member {number}
	     * @readOnly
	     */
	    this.textHeight = 0;
	
	    /**
	     * Private tracker for the letter sprite pool.
	     *
	     * @member {PIXI.Sprite[]}
	     * @private
	     */
	    this._glyphs = [];
	
	    /**
	     * Private tracker for the current style.
	     *
	     * @member {object}
	     * @private
	     */
	    this._font = {
	        tint: style.tint !== undefined ? style.tint : 0xFFFFFF,
	        align: style.align || 'left',
	        name: null,
	        size: 0
	    };
	
	    /**
	     * Private tracker for the current font.
	     *
	     * @member {object}
	     * @private
	     */
	    this.font = style.font; // run font setter
	
	    /**
	     * Private tracker for the current text.
	     *
	     * @member {string}
	     * @private
	     */
	    this._text = text;
	
	    /**
	     * The max width of this bitmap text in pixels. If the text provided is longer than the value provided, line breaks will be automatically inserted in the last whitespace.
	     * Disable by setting value to 0
	     *
	     * @member {number}
	     */
	    this.maxWidth = 0;
	
	    /**
	     * The max line height. This is useful when trying to use the total height of the Text, ie: when trying to vertically align.
	     *
	     * @member {number}
	     */
	    this.maxLineHeight = 0;
	
	    /**
	     * The dirty state of this object.
	     *
	     * @member {boolean}
	     */
	    this.dirty = false;
	
	    this.updateText();
	}
	
	// constructor
	BitmapText.prototype = Object.create(core.Container.prototype);
	BitmapText.prototype.constructor = BitmapText;
	module.exports = BitmapText;
	
	Object.defineProperties(BitmapText.prototype, {
	    /**
	     * The tint of the BitmapText object
	     *
	     * @member {number}
	     * @memberof PIXI.extras.BitmapText#
	     */
	    tint: {
	        get: function ()
	        {
	            return this._font.tint;
	        },
	        set: function (value)
	        {
	            this._font.tint = (typeof value === 'number' && value >= 0) ? value : 0xFFFFFF;
	
	            this.dirty = true;
	        }
	    },
	
	    /**
	     * The alignment of the BitmapText object
	     *
	     * @member {string}
	     * @default 'left'
	     * @memberof PIXI.extras.BitmapText#
	     */
	    align: {
	        get: function ()
	        {
	            return this._font.align;
	        },
	        set: function (value)
	        {
	            this._font.align = value || 'left';
	
	            this.dirty = true;
	        }
	    },
	
	    /**
	     * The font descriptor of the BitmapText object
	     *
	     * @member {Font}
	     * @memberof PIXI.extras.BitmapText#
	     */
	    font: {
	        get: function ()
	        {
	            return this._font;
	        },
	        set: function (value)
	        {
	            if (!value) {
	                return;
	            }
	
	            if (typeof value === 'string') {
	                value = value.split(' ');
	
	                this._font.name = value.length === 1 ? value[0] : value.slice(1).join(' ');
	                this._font.size = value.length >= 2 ? parseInt(value[0], 10) : BitmapText.fonts[this._font.name].size;
	            }
	            else {
	                this._font.name = value.name;
	                this._font.size = typeof value.size === 'number' ? value.size : parseInt(value.size, 10);
	            }
	
	            this.dirty = true;
	        }
	    },
	
	    /**
	     * The text of the BitmapText object
	     *
	     * @member {string}
	     * @memberof PIXI.extras.BitmapText#
	     */
	    text: {
	        get: function ()
	        {
	            return this._text;
	        },
	        set: function (value)
	        {
	            value = value.toString() || ' ';
	            if (this._text === value)
	            {
	                return;
	            }
	            this._text = value;
	            this.dirty = true;
	        }
	    }
	});
	
	/**
	 * Renders text and updates it when needed
	 *
	 * @private
	 */
	BitmapText.prototype.updateText = function ()
	{
	    var data = BitmapText.fonts[this._font.name];
	    var pos = new core.Point();
	    var prevCharCode = null;
	    var chars = [];
	    var lastLineWidth = 0;
	    var maxLineWidth = 0;
	    var lineWidths = [];
	    var line = 0;
	    var scale = this._font.size / data.size;
	    var lastSpace = -1;
	    var maxLineHeight = 0;
	
	    for (var i = 0; i < this.text.length; i++)
	    {
	        var charCode = this.text.charCodeAt(i);
	        lastSpace = /(\s)/.test(this.text.charAt(i)) ? i : lastSpace;
	
	        if (/(?:\r\n|\r|\n)/.test(this.text.charAt(i)))
	        {
	            lineWidths.push(lastLineWidth);
	            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	            line++;
	
	            pos.x = 0;
	            pos.y += data.lineHeight;
	            prevCharCode = null;
	            continue;
	        }
	
	        if (lastSpace !== -1 && this.maxWidth > 0 && pos.x * scale > this.maxWidth)
	        {
	            core.utils.removeItems(chars, lastSpace, i - lastSpace);
	            i = lastSpace;
	            lastSpace = -1;
	
	            lineWidths.push(lastLineWidth);
	            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	            line++;
	
	            pos.x = 0;
	            pos.y += data.lineHeight;
	            prevCharCode = null;
	            continue;
	        }
	
	        var charData = data.chars[charCode];
	
	        if (!charData)
	        {
	            continue;
	        }
	
	        if (prevCharCode && charData.kerning[prevCharCode])
	        {
	            pos.x += charData.kerning[prevCharCode];
	        }
	
	        chars.push({texture:charData.texture, line: line, charCode: charCode, position: new core.Point(pos.x + charData.xOffset, pos.y + charData.yOffset)});
	        lastLineWidth = pos.x + (charData.texture.width + charData.xOffset);
	        pos.x += charData.xAdvance;
	        maxLineHeight = Math.max(maxLineHeight, (charData.yOffset + charData.texture.height));
	        prevCharCode = charCode;
	    }
	
	    lineWidths.push(lastLineWidth);
	    maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	
	    var lineAlignOffsets = [];
	
	    for (i = 0; i <= line; i++)
	    {
	        var alignOffset = 0;
	
	        if (this._font.align === 'right')
	        {
	            alignOffset = maxLineWidth - lineWidths[i];
	        }
	        else if (this._font.align === 'center')
	        {
	            alignOffset = (maxLineWidth - lineWidths[i]) / 2;
	        }
	
	        lineAlignOffsets.push(alignOffset);
	    }
	
	    var lenChars = chars.length;
	    var tint = this.tint;
	
	    for (i = 0; i < lenChars; i++)
	    {
	        var c = this._glyphs[i]; // get the next glyph sprite
	
	        if (c)
	        {
	            c.texture = chars[i].texture;
	        }
	        else
	        {
	            c = new core.Sprite(chars[i].texture);
	            this._glyphs.push(c);
	        }
	
	        c.position.x = (chars[i].position.x + lineAlignOffsets[chars[i].line]) * scale;
	        c.position.y = chars[i].position.y * scale;
	        c.scale.x = c.scale.y = scale;
	        c.tint = tint;
	
	        if (!c.parent)
	        {
	            this.addChild(c);
	        }
	    }
	
	    // remove unnecessary children.
	    for (i = lenChars; i < this._glyphs.length; ++i)
	    {
	        this.removeChild(this._glyphs[i]);
	    }
	
	    this.textWidth = maxLineWidth * scale;
	    this.textHeight = (pos.y + data.lineHeight) * scale;
	    this.maxLineHeight = maxLineHeight * scale;
	};
	
	/**
	 * Updates the transform of this object
	 *
	 * @private
	 */
	BitmapText.prototype.updateTransform = function ()
	{
	    this.validate();
	    this.containerUpdateTransform();
	};
	
	/**
	 * Validates text before calling parent's getLocalBounds
	 *
	 * @return {PIXI.Rectangle} The rectangular bounding area
	 */
	
	BitmapText.prototype.getLocalBounds = function()
	{
	    this.validate();
	    return core.Container.prototype.getLocalBounds.call(this);
	};
	
	/**
	 * Updates text when needed
	 *
	 * @private
	 */
	BitmapText.prototype.validate = function()
	{
	    if (this.dirty)
	    {
	        this.updateText();
	        this.dirty = false;
	    }
	};
	
	BitmapText.fonts = {};


/***/ },
/* 201 */
/*!*******************************************!*\
  !*** ./~/pixi.js/src/extras/MovieClip.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1);
	
	/**
	 * A MovieClip is a simple way to display an animation depicted by a list of textures.
	 *
	 * ```js
	 * var alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
	 * var textureArray = [];
	 *
	 * for (var i=0; i < 4; i++)
	 * {
	 *      var texture = PIXI.Texture.fromImage(alienImages[i]);
	 *      textureArray.push(texture);
	 * };
	 *
	 * var mc = new PIXI.MovieClip(textureArray);
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI.extras
	 * @param textures {PIXI.Texture[]|Object[]} an array of {@link PIXI.Texture} or frame objects that make up the animation
	 * @param textures[].texture {PIXI.Texture} the {@link PIXI.Texture} of the frame
	 * @param textures[].time {number} the duration of the frame in ms
	 */
	function MovieClip(textures)
	{
	    core.Sprite.call(this, textures[0] instanceof core.Texture ? textures[0] : textures[0].texture);
	
	    /**
	     * @private
	     */
	    this._textures = null;
	
	    /**
	     * @private
	     */
	    this._durations = null;
	
	    this.textures = textures;
	
	    /**
	     * The speed that the MovieClip will play at. Higher is faster, lower is slower
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.animationSpeed = 1;
	
	    /**
	     * Whether or not the movie clip repeats after playing.
	     *
	     * @member {boolean}
	     * @default true
	     */
	    this.loop = true;
	
	    /**
	     * Function to call when a MovieClip finishes playing
	     *
	     * @method
	     * @memberof PIXI.extras.MovieClip#
	     */
	    this.onComplete = null;
	
	    /**
	     * Elapsed time since animation has been started, used internally to display current texture
	     *
	     * @member {number}
	     * @private
	     */
	    this._currentTime = 0;
	
	    /**
	     * Indicates if the MovieClip is currently playing
	     *
	     * @member {boolean}
	     * @readonly
	     */
	    this.playing = false;
	}
	
	// constructor
	MovieClip.prototype = Object.create(core.Sprite.prototype);
	MovieClip.prototype.constructor = MovieClip;
	module.exports = MovieClip;
	
	Object.defineProperties(MovieClip.prototype, {
	    /**
	     * totalFrames is the total number of frames in the MovieClip. This is the same as number of textures
	     * assigned to the MovieClip.
	     *
	     * @member {number}
	     * @memberof PIXI.extras.MovieClip#
	     * @default 0
	     * @readonly
	     */
	    totalFrames: {
	        get: function()
	        {
	            return this._textures.length;
	        }
	    },
	
	    /**
	     * The array of textures used for this MovieClip
	     *
	     * @member {PIXI.Texture[]}
	     * @memberof PIXI.extras.MovieClip#
	     *
	     */
	    textures: {
	        get: function ()
	        {
	            return this._textures;
	        },
	        set: function (value)
	        {
	            if(value[0] instanceof core.Texture)
	            {
	                this._textures = value;
	                this._durations = null;
	            }
	            else
	            {
	                this._textures = [];
	                this._durations = [];
	                for(var i = 0; i < value.length; i++)
	                {
	                    this._textures.push(value[i].texture);
	                    this._durations.push(value[i].time);
	                }
	            }
	        }
	    },
	
	    /**
	    * The MovieClips current frame index
	    *
	    * @member {number}
	    * @memberof PIXI.extras.MovieClip#
	    * @readonly
	    */
	    currentFrame: {
	        get: function ()
	        {
	            var currentFrame = Math.floor(this._currentTime) % this._textures.length;
	            if (currentFrame < 0)
	            {
	                currentFrame += this._textures.length;
	            }
	            return currentFrame;
	        }
	    }
	
	});
	
	/**
	 * Stops the MovieClip
	 *
	 */
	MovieClip.prototype.stop = function ()
	{
	    if(!this.playing)
	    {
	        return;
	    }
	
	    this.playing = false;
	    core.ticker.shared.remove(this.update, this);
	};
	
	/**
	 * Plays the MovieClip
	 *
	 */
	MovieClip.prototype.play = function ()
	{
	    if(this.playing)
	    {
	        return;
	    }
	
	    this.playing = true;
	    core.ticker.shared.add(this.update, this);
	};
	
	/**
	 * Stops the MovieClip and goes to a specific frame
	 *
	 * @param frameNumber {number} frame index to stop at
	 */
	MovieClip.prototype.gotoAndStop = function (frameNumber)
	{
	    this.stop();
	
	    this._currentTime = frameNumber;
	
	    this._texture = this._textures[this.currentFrame];
	};
	
	/**
	 * Goes to a specific frame and begins playing the MovieClip
	 *
	 * @param frameNumber {number} frame index to start at
	 */
	MovieClip.prototype.gotoAndPlay = function (frameNumber)
	{
	    this._currentTime = frameNumber;
	
	    this.play();
	};
	
	/*
	 * Updates the object transform for rendering
	 * @private
	 */
	MovieClip.prototype.update = function (deltaTime)
	{
	    var elapsed = this.animationSpeed * deltaTime;
	
	    if (this._durations !== null)
	    {
	        var lag = this._currentTime % 1 * this._durations[this.currentFrame];
	
	        lag += elapsed / 60 * 1000;
	
	        while (lag < 0)
	        {
	            this._currentTime--;
	            lag += this._durations[this.currentFrame];
	        }
	
	        var sign = Math.sign(this.animationSpeed * deltaTime);
	        this._currentTime = Math.floor(this._currentTime);
	
	        while (lag >= this._durations[this.currentFrame])
	        {
	            lag -= this._durations[this.currentFrame] * sign;
	            this._currentTime += sign;
	        }
	
	        this._currentTime += lag / this._durations[this.currentFrame];
	    }
	    else
	    {
	        this._currentTime += elapsed;
	    }
	
	    if (this._currentTime < 0 && !this.loop)
	    {
	        this.gotoAndStop(0);
	
	        if (this.onComplete)
	        {
	            this.onComplete();
	        }
	    }
	    else if (this._currentTime >= this._textures.length && !this.loop)
	    {
	        this.gotoAndStop(this._textures.length - 1);
	
	        if (this.onComplete)
	        {
	            this.onComplete();
	        }
	    }
	    else
	    {
	        this._texture = this._textures[this.currentFrame];
	    }
	
	};
	
	/*
	 * Stops the MovieClip and destroys it
	 *
	 */
	MovieClip.prototype.destroy = function ( )
	{
	    this.stop();
	    core.Sprite.prototype.destroy.call(this);
	};
	
	/**
	 * A short hand way of creating a movieclip from an array of frame ids
	 *
	 * @static
	 * @param frames {string[]} the array of frames ids the movieclip will use as its texture frames
	 */
	MovieClip.fromFrames = function (frames)
	{
	    var textures = [];
	
	    for (var i = 0; i < frames.length; ++i)
	    {
	        textures.push(new core.Texture.fromFrame(frames[i]));
	    }
	
	    return new MovieClip(textures);
	};
	
	/**
	 * A short hand way of creating a movieclip from an array of image ids
	 *
	 * @static
	 * @param images {string[]} the array of image urls the movieclip will use as its texture frames
	 */
	MovieClip.fromImages = function (images)
	{
	    var textures = [];
	
	    for (var i = 0; i < images.length; ++i)
	    {
	        textures.push(new core.Texture.fromImage(images[i]));
	    }
	
	    return new MovieClip(textures);
	};

/***/ },
/* 202 */
/*!**********************************************!*\
  !*** ./~/pixi.js/src/extras/TilingSprite.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1),
	    // a sprite use dfor rendering textures..
	    tempPoint = new core.Point(),
	    CanvasTinter = __webpack_require__(/*! ../core/renderers/canvas/utils/CanvasTinter */ 99);
	
	/**
	 * A tiling sprite is a fast way of rendering a tiling image
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI.extras
	 * @param texture {Texture} the texture of the tiling sprite
	 * @param width {number}  the width of the tiling sprite
	 * @param height {number} the height of the tiling sprite
	 */
	function TilingSprite(texture, width, height)
	{
	    core.Sprite.call(this, texture);
	
	    /**
	     * The scaling of the image that is being tiled
	     *
	     * @member {PIXI.Point}
	     */
	    this.tileScale = new core.Point(1,1);
	
	
	    /**
	     * The offset position of the image that is being tiled
	     *
	     * @member {PIXI.Point}
	     */
	    this.tilePosition = new core.Point(0,0);
	
	    ///// private
	
	    /**
	     * The with of the tiling sprite
	     *
	     * @member {number}
	     * @private
	     */
	    this._width = width || 100;
	
	    /**
	     * The height of the tiling sprite
	     *
	     * @member {number}
	     * @private
	     */
	    this._height = height || 100;
	
	    /**
	     * An internal WebGL UV cache.
	     *
	     * @member {PIXI.TextureUvs}
	     * @private
	     */
	    this._uvs = new core.TextureUvs();
	
	    this._canvasPattern = null;
	
	    //TODO move..
	    this.shader = new core.AbstractFilter(
	
	      [
	        'precision lowp float;',
	        'attribute vec2 aVertexPosition;',
	        'attribute vec2 aTextureCoord;',
	        'attribute vec4 aColor;',
	
	        'uniform mat3 projectionMatrix;',
	
	        'uniform vec4 uFrame;',
	        'uniform vec4 uTransform;',
	
	        'varying vec2 vTextureCoord;',
	        'varying vec4 vColor;',
	
	        'void main(void){',
	        '   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);',
	
	        '   vec2 coord = aTextureCoord;',
	        '   coord -= uTransform.xy;',
	        '   coord /= uTransform.zw;',
	        '   vTextureCoord = coord;',
	
	        '   vColor = vec4(aColor.rgb * aColor.a, aColor.a);',
	        '}'
	      ].join('\n'),
	      [
	        'precision lowp float;',
	
	        'varying vec2 vTextureCoord;',
	        'varying vec4 vColor;',
	
	        'uniform sampler2D uSampler;',
	        'uniform vec4 uFrame;',
	        'uniform vec2 uPixelSize;',
	
	        'void main(void){',
	
	        '   vec2 coord = mod(vTextureCoord, uFrame.zw);',
	        '   coord = clamp(coord, uPixelSize, uFrame.zw - uPixelSize);',
	        '   coord += uFrame.xy;',
	
	        '   gl_FragColor =  texture2D(uSampler, coord) * vColor ;',
	        '}'
	      ].join('\n'),
	
	            // set the uniforms
	            {
	                uFrame: { type: '4fv', value: [0,0,1,1] },
	                uTransform: { type: '4fv', value: [0,0,1,1] },
	                uPixelSize : { type : '2fv', value: [1, 1]}
	            }
	      );
	}
	
	TilingSprite.prototype = Object.create(core.Sprite.prototype);
	TilingSprite.prototype.constructor = TilingSprite;
	module.exports = TilingSprite;
	
	
	Object.defineProperties(TilingSprite.prototype, {
	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     * @memberof PIXI.extras.TilingSprite#
	     */
	    width: {
	        get: function ()
	        {
	            return this._width;
	        },
	        set: function (value)
	        {
	            this._width = value;
	        }
	    },
	
	    /**
	     * The height of the TilingSprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     * @memberof PIXI.extras.TilingSprite#
	     */
	    height: {
	        get: function ()
	        {
	            return this._height;
	        },
	        set: function (value)
	        {
	            this._height = value;
	        }
	    }
	});
	
	TilingSprite.prototype._onTextureUpdate = function ()
	{
	    return;
	};
	
	
	/**
	 * Renders the object using the WebGL renderer
	 *
	 * @param renderer {PIXI.WebGLRenderer}
	 * @private
	 */
	TilingSprite.prototype._renderWebGL = function (renderer)
	{
	    // tweak our texture temporarily..
	    var texture = this._texture;
	
	    if(!texture || !texture._uvs)
	    {
	        return;
	    }
	
	    var tempUvs = texture._uvs,
	        tempWidth = texture._frame.width,
	        tempHeight = texture._frame.height,
	        tw = texture.baseTexture.width,
	        th = texture.baseTexture.height;
	
	    texture._uvs = this._uvs;
	    texture._frame.width = this.width;
	    texture._frame.height = this.height;
	
	    this.shader.uniforms.uPixelSize.value[0] = 1.0/tw;
	    this.shader.uniforms.uPixelSize.value[1] = 1.0/th;
	
	    this.shader.uniforms.uFrame.value[0] = tempUvs.x0;
	    this.shader.uniforms.uFrame.value[1] = tempUvs.y0;
	    this.shader.uniforms.uFrame.value[2] = tempUvs.x1 - tempUvs.x0;
	    this.shader.uniforms.uFrame.value[3] = tempUvs.y2 - tempUvs.y0;
	
	    this.shader.uniforms.uTransform.value[0] = (this.tilePosition.x % (tempWidth * this.tileScale.x)) / this._width;
	    this.shader.uniforms.uTransform.value[1] = (this.tilePosition.y % (tempHeight * this.tileScale.y)) / this._height;
	    this.shader.uniforms.uTransform.value[2] = ( tw / this._width ) * this.tileScale.x;
	    this.shader.uniforms.uTransform.value[3] = ( th / this._height ) * this.tileScale.y;
	
	    renderer.setObjectRenderer(renderer.plugins.sprite);
	    renderer.plugins.sprite.render(this);
	
	    texture._uvs = tempUvs;
	    texture._frame.width = tempWidth;
	    texture._frame.height = tempHeight;
	};
	
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @param renderer {PIXI.CanvasRenderer} a reference to the canvas renderer
	 * @private
	 */
	TilingSprite.prototype._renderCanvas = function (renderer)
	{
	    var texture = this._texture;
	
	    if (!texture.baseTexture.hasLoaded)
	    {
	      return;
	    }
	
	    var context = renderer.context,
	        transform = this.worldTransform,
	        resolution = renderer.resolution,
	        baseTexture = texture.baseTexture,
	        modX = (this.tilePosition.x / this.tileScale.x) % texture._frame.width,
	        modY = (this.tilePosition.y / this.tileScale.y) % texture._frame.height;
	
	    // create a nice shiny pattern!
	    // TODO this needs to be refreshed if texture changes..
	    if(!this._canvasPattern)
	    {
	        // cut an object from a spritesheet..
	        var tempCanvas = new core.CanvasBuffer(texture._frame.width * resolution, texture._frame.height * resolution);
	
	        // Tint the tiling sprite
	        if (this.tint !== 0xFFFFFF)
	        {
	            if (this.cachedTint !== this.tint)
	            {
	                this.cachedTint = this.tint;
	
	                this.tintedTexture = CanvasTinter.getTintedTexture(this, this.tint);
	            }
	            tempCanvas.context.drawImage(this.tintedTexture, 0, 0);
	        }
	        else
	        {
	            tempCanvas.context.drawImage(baseTexture.source, -texture._frame.x * resolution, -texture._frame.y * resolution);
	        }
	        this._canvasPattern = tempCanvas.context.createPattern( tempCanvas.canvas, 'repeat' );
	    }
	
	    // set context state..
	    context.globalAlpha = this.worldAlpha;
	    context.setTransform(transform.a * resolution,
	                       transform.b * resolution,
	                       transform.c * resolution,
	                       transform.d * resolution,
	                       transform.tx * resolution,
	                       transform.ty * resolution);
	
	    // TODO - this should be rolled into the setTransform above..
	    context.scale(this.tileScale.x / resolution, this.tileScale.y / resolution);
	
	    context.translate(modX + (this.anchor.x * -this._width ),
	                      modY + (this.anchor.y * -this._height));
	
	    // check blend mode
	    var compositeOperation = renderer.blendModes[this.blendMode];
	    if (compositeOperation !== renderer.context.globalCompositeOperation)
	    {
	        context.globalCompositeOperation = compositeOperation;
	    }
	
	    // fill the pattern!
	    context.fillStyle = this._canvasPattern;
	    context.fillRect(-modX,
	                     -modY,
	                     this._width * resolution / this.tileScale.x,
	                     this._height * resolution / this.tileScale.y);
	
	
	    //TODO - pretty sure this can be deleted...
	    //context.translate(-this.tilePosition.x + (this.anchor.x * this._width), -this.tilePosition.y + (this.anchor.y * this._height));
	    //context.scale(1 / this.tileScale.x, 1 / this.tileScale.y);
	};
	
	
	/**
	 * Returns the framing rectangle of the sprite as a Rectangle object
	*
	 * @return {PIXI.Rectangle} the framing rectangle
	 */
	TilingSprite.prototype.getBounds = function ()
	{
	    var width = this._width;
	    var height = this._height;
	
	    var w0 = width * (1-this.anchor.x);
	    var w1 = width * -this.anchor.x;
	
	    var h0 = height * (1-this.anchor.y);
	    var h1 = height * -this.anchor.y;
	
	    var worldTransform = this.worldTransform;
	
	    var a = worldTransform.a;
	    var b = worldTransform.b;
	    var c = worldTransform.c;
	    var d = worldTransform.d;
	    var tx = worldTransform.tx;
	    var ty = worldTransform.ty;
	
	    var x1 = a * w1 + c * h1 + tx;
	    var y1 = d * h1 + b * w1 + ty;
	
	    var x2 = a * w0 + c * h1 + tx;
	    var y2 = d * h1 + b * w0 + ty;
	
	    var x3 = a * w0 + c * h0 + tx;
	    var y3 = d * h0 + b * w0 + ty;
	
	    var x4 =  a * w1 + c * h0 + tx;
	    var y4 =  d * h0 + b * w1 + ty;
	
	    var minX,
	        maxX,
	        minY,
	        maxY;
	
	    minX = x1;
	    minX = x2 < minX ? x2 : minX;
	    minX = x3 < minX ? x3 : minX;
	    minX = x4 < minX ? x4 : minX;
	
	    minY = y1;
	    minY = y2 < minY ? y2 : minY;
	    minY = y3 < minY ? y3 : minY;
	    minY = y4 < minY ? y4 : minY;
	
	    maxX = x1;
	    maxX = x2 > maxX ? x2 : maxX;
	    maxX = x3 > maxX ? x3 : maxX;
	    maxX = x4 > maxX ? x4 : maxX;
	
	    maxY = y1;
	    maxY = y2 > maxY ? y2 : maxY;
	    maxY = y3 > maxY ? y3 : maxY;
	    maxY = y4 > maxY ? y4 : maxY;
	
	    var bounds = this._bounds;
	
	    bounds.x = minX;
	    bounds.width = maxX - minX;
	
	    bounds.y = minY;
	    bounds.height = maxY - minY;
	
	    // store a reference so that if this function gets called again in the render cycle we do not have to recalculate
	    this._currentBounds = bounds;
	
	    return bounds;
	};
	
	/**
	 * Checks if a point is inside this tiling sprite
	 * @param point {PIXI.Point} the point to check
	 */
	TilingSprite.prototype.containsPoint = function( point )
	{
	    this.worldTransform.applyInverse(point,  tempPoint);
	
	    var width = this._width;
	    var height = this._height;
	    var x1 = -width * this.anchor.x;
	    var y1;
	
	    if ( tempPoint.x > x1 && tempPoint.x < x1 + width )
	    {
	        y1 = -height * this.anchor.y;
	
	        if ( tempPoint.y > y1 && tempPoint.y < y1 + height )
	        {
	            return true;
	        }
	    }
	
	    return false;
	};
	
	/**
	 * Destroys this tiling sprite
	 *
	 */
	TilingSprite.prototype.destroy = function () {
	    core.Sprite.prototype.destroy.call(this);
	
	    this.tileScale = null;
	    this._tileScaleOffset = null;
	    this.tilePosition = null;
	
	    this._uvs = null;
	};
	
	/**
	 * Helper function that creates a tiling sprite that will use a texture from the TextureCache based on the frameId
	 * The frame ids are created when a Texture packer file has been loaded
	 *
	 * @static
	 * @param frameId {string} The frame Id of the texture in the cache
	 * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the frameId
	 * @param width {number}  the width of the tiling sprite
	 * @param height {number} the height of the tiling sprite
	 */
	TilingSprite.fromFrame = function (frameId,width,height)
	{
	    var texture = core.utils.TextureCache[frameId];
	
	    if (!texture)
	    {
	        throw new Error('The frameId "' + frameId + '" does not exist in the texture cache ' + this);
	    }
	
	    return new TilingSprite(texture,width,height);
	};
	
	/**
	 * Helper function that creates a sprite that will contain a texture based on an image url
	 * If the image is not in the texture cache it will be loaded
	 *
	 * @static
	 * @param imageId {string} The image url of the texture
	 * @param width {number}  the width of the tiling sprite
	 * @param height {number} the height of the tiling sprite
	 * @param [crossorigin=(auto)] {boolean} if you want to specify the cross-origin parameter
	 * @param [scaleMode=PIXI.SCALE_MODES.DEFAULT] {number} if you want to specify the scale mode, see {@link PIXI.SCALE_MODES} for possible values
	 * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the image id
	 */
	TilingSprite.fromImage = function (imageId, width, height, crossorigin, scaleMode)
	{
	    return new TilingSprite(core.Texture.fromImage(imageId, crossorigin, scaleMode),width,height);
	};


/***/ },
/* 203 */
/*!***********************************************!*\
  !*** ./~/pixi.js/src/extras/cacheAsBitmap.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1),
	    DisplayObject = core.DisplayObject,
	    _tempMatrix = new core.Matrix();
	
	DisplayObject.prototype._cacheAsBitmap = false;
	DisplayObject.prototype._originalRenderWebGL = null;
	DisplayObject.prototype._originalRenderCanvas = null;
	
	DisplayObject.prototype._originalUpdateTransform = null;
	DisplayObject.prototype._originalHitTest = null;
	DisplayObject.prototype._originalDestroy = null;
	DisplayObject.prototype._cachedSprite = null;
	
	Object.defineProperties(DisplayObject.prototype, {
	
	    /**
	     * Set this to true if you want this display object to be cached as a bitmap.
	     * This basically takes a snap shot of the display object as it is at that moment. It can provide a performance benefit for complex static displayObjects.
	     * To remove simply set this property to 'false'
	     *
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     */
	    cacheAsBitmap: {
	        get: function ()
	        {
	            return this._cacheAsBitmap;
	        },
	        set: function (value)
	        {
	            if (this._cacheAsBitmap === value)
	            {
	                return;
	            }
	
	            this._cacheAsBitmap = value;
	
	            if (value)
	            {
	                this._originalRenderWebGL = this.renderWebGL;
	                this._originalRenderCanvas = this.renderCanvas;
	
	                this._originalUpdateTransform = this.updateTransform;
	                this._originalGetBounds = this.getBounds;
	
	                this._originalDestroy = this.destroy;
	
	                this._originalContainsPoint = this.containsPoint;
	
	                this.renderWebGL = this._renderCachedWebGL;
	                this.renderCanvas = this._renderCachedCanvas;
	
	                this.destroy = this._cacheAsBitmapDestroy;
	
	            }
	            else
	            {
	                if (this._cachedSprite)
	                {
	                    this._destroyCachedDisplayObject();
	                }
	
	                this.renderWebGL = this._originalRenderWebGL;
	                this.renderCanvas = this._originalRenderCanvas;
	                this.getBounds = this._originalGetBounds;
	
	                this.destroy = this._originalDestroy;
	
	                this.updateTransform = this._originalUpdateTransform;
	                this.containsPoint = this._originalContainsPoint;
	            }
	        }
	    }
	});
	/**
	* Renders a cached version of the sprite with WebGL
	*
	* @param renderer {PIXI.WebGLRenderer} the WebGL renderer
	* @private
	*/
	DisplayObject.prototype._renderCachedWebGL = function (renderer)
	{
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable)
	    {
	        return;
	    }
	
	    this._initCachedDisplayObject( renderer );
	
	    this._cachedSprite.worldAlpha = this.worldAlpha;
	
	    renderer.setObjectRenderer(renderer.plugins.sprite);
	    renderer.plugins.sprite.render( this._cachedSprite );
	};
	
	/**
	* Prepares the WebGL renderer to cache the sprite
	*
	* @param renderer {PIXI.WebGLRenderer} the WebGL renderer
	* @private
	*/
	DisplayObject.prototype._initCachedDisplayObject = function (renderer)
	{
	    if(this._cachedSprite)
	    {
	        return;
	    }
	
	    // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
	    renderer.currentRenderer.flush();
	    //this.filters= [];
	    // next we find the dimensions of the untransformed object
	    // this function also calls updatetransform on all its children as part of the measuring. This means we don't need to update the transform again in this function
	    // TODO pass an object to clone too? saves having to create a new one each time!
	    var bounds = this.getLocalBounds().clone();
	
	    // add some padding!
	    if(this._filters)
	    {
	        var padding = this._filters[0].padding;
	        bounds.x -= padding;
	        bounds.y -= padding;
	
	        bounds.width += padding * 2;
	        bounds.height += padding * 2;
	    }
	
	    // for now we cache the current renderTarget that the webGL renderer is currently using.
	    // this could be more elegent..
	    var cachedRenderTarget = renderer.currentRenderTarget;
	    // We also store the filter stack - I will definitely look to change how this works a little later down the line.
	    var stack = renderer.filterManager.filterStack;
	
	    // this renderTexture will be used to store the cached DisplayObject
	    var renderTexture = new core.RenderTexture(renderer, bounds.width | 0, bounds.height | 0);
	
	    // need to set //
	    var m = _tempMatrix;
	
	    m.tx = -bounds.x;
	    m.ty = -bounds.y;
	
	
	
	    // set all properties to there original so we can render to a texture
	    this.renderWebGL = this._originalRenderWebGL;
	
	    renderTexture.render(this, m, true, true);
	
	    // now restore the state be setting the new properties
	    renderer.setRenderTarget(cachedRenderTarget);
	    renderer.filterManager.filterStack = stack;
	
	    this.renderWebGL     = this._renderCachedWebGL;
	    this.updateTransform = this.displayObjectUpdateTransform;
	    this.getBounds       = this._getCachedBounds;
	
	
	    // create our cached sprite
	    this._cachedSprite = new core.Sprite(renderTexture);
	    this._cachedSprite.worldTransform = this.worldTransform;
	    this._cachedSprite.anchor.x = -( bounds.x / bounds.width );
	    this._cachedSprite.anchor.y = -( bounds.y / bounds.height );
	
	    // restore the transform of the cached sprite to avoid the nasty flicker..
	    this.updateTransform();
	
	    // map the hit test..
	    this.containsPoint = this._cachedSprite.containsPoint.bind(this._cachedSprite);
	};
	
	/**
	* Renders a cached version of the sprite with canvas
	*
	* @param renderer {PIXI.CanvasRenderer} the Canvas renderer
	* @private
	*/
	DisplayObject.prototype._renderCachedCanvas = function (renderer)
	{
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable)
	    {
	        return;
	    }
	
	    this._initCachedDisplayObjectCanvas( renderer );
	
	    this._cachedSprite.worldAlpha = this.worldAlpha;
	
	    this._cachedSprite.renderCanvas(renderer);
	};
	
	//TODO this can be the same as the webGL verison.. will need to do a little tweaking first though..
	/**
	* Prepares the Canvas renderer to cache the sprite
	*
	* @param renderer {PIXI.CanvasRenderer} the Canvas renderer
	* @private
	*/
	DisplayObject.prototype._initCachedDisplayObjectCanvas = function (renderer)
	{
	    if(this._cachedSprite)
	    {
	        return;
	    }
	
	    //get bounds actually transforms the object for us already!
	    var bounds = this.getLocalBounds();
	
	    var cachedRenderTarget = renderer.context;
	
	    var renderTexture = new core.RenderTexture(renderer, bounds.width | 0, bounds.height | 0);
	
	    // need to set //
	    var m = _tempMatrix;
	
	    m.tx = -bounds.x;
	    m.ty = -bounds.y;
	
	    // set all properties to there original so we can render to a texture
	    this.renderCanvas = this._originalRenderCanvas;
	
	    renderTexture.render(this, m, true);
	
	    // now restore the state be setting the new properties
	    renderer.context = cachedRenderTarget;
	
	    this.renderCanvas = this._renderCachedCanvas;
	    this.updateTransform = this.displayObjectUpdateTransform;
	    this.getBounds  = this._getCachedBounds;
	
	
	    // create our cached sprite
	    this._cachedSprite = new core.Sprite(renderTexture);
	    this._cachedSprite.worldTransform = this.worldTransform;
	    this._cachedSprite.anchor.x = -( bounds.x / bounds.width );
	    this._cachedSprite.anchor.y = -( bounds.y / bounds.height );
	
	    this.updateTransform();
	
	    this.containsPoint = this._cachedSprite.containsPoint.bind(this._cachedSprite);
	};
	
	/**
	* Calculates the bounds of the cached sprite
	*
	* @private
	*/
	DisplayObject.prototype._getCachedBounds = function ()
	{
	    this._cachedSprite._currentBounds = null;
	
	    return this._cachedSprite.getBounds();
	};
	
	/**
	* Destroys the cached sprite.
	*
	* @private
	*/
	DisplayObject.prototype._destroyCachedDisplayObject = function ()
	{
	    this._cachedSprite._texture.destroy();
	    this._cachedSprite = null;
	};
	
	DisplayObject.prototype._cacheAsBitmapDestroy = function ()
	{
	    this.cacheAsBitmap = false;
	    this._originalDestroy();
	};


/***/ },
/* 204 */
/*!************************************************!*\
  !*** ./~/pixi.js/src/extras/getChildByName.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1);
	
	/**
	 * The instance name of the object.
	 *
	 * @memberof PIXI.DisplayObject#
	 * @member {string}
	 */
	core.DisplayObject.prototype.name = null;
	
	/**
	* Returns the display object in the container
	*
	* @memberof PIXI.Container#
	* @param name {string} instance name
	* @return {PIXI.DisplayObject}
	*/
	core.Container.prototype.getChildByName = function (name)
	{
	    for (var i = 0; i < this.children.length; i++)
	    {
	        if (this.children[i].name === name)
	        {
	            return this.children[i];
	        }
	    }
	    return null;
	};


/***/ },
/* 205 */
/*!***************************************************!*\
  !*** ./~/pixi.js/src/extras/getGlobalPosition.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1);
	
	/**
	* Returns the global position of the displayObject
	*
	* @memberof PIXI.DisplayObject#
	* @param point {Point} the point to write the global value to. If null a new point will be returned
	* @return {Point}
	*/
	core.DisplayObject.prototype.getGlobalPosition = function (point)
	{
	    point = point || new core.Point();
	
	    if(this.parent)
	    {
	        this.displayObjectUpdateTransform();
	
	        point.x = this.worldTransform.tx;
	        point.y = this.worldTransform.ty;
	    }
	    else
	    {
	        point.x = this.position.x;
	        point.y = this.position.y;
	    }
	
	    return point;
	};


/***/ },
/* 206 */
/*!****************************************************!*\
  !*** ./~/pixi.js/src/filters/ascii/AsciiFilter.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	// TODO (cengler) - The Y is flipped in this shader for some reason.
	
	/**
	 * @author Vico @vicocotea
	 * original shader : https://www.shadertoy.com/view/lssGDj by @movAX13h
	 */
	
	/**
	 * An ASCII filter.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function AsciiFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/ascii.frag', 'utf8'),
	        // custom uniforms
	        {
	            dimensions: { type: '4fv', value: new Float32Array([0, 0, 0, 0]) },
	            pixelSize:  { type: '1f', value: 8 }
	        }
	    );
	}
	
	AsciiFilter.prototype = Object.create(core.AbstractFilter.prototype);
	AsciiFilter.prototype.constructor = AsciiFilter;
	module.exports = AsciiFilter;
	
	Object.defineProperties(AsciiFilter.prototype, {
	    /**
	     * The pixel size used by the filter.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.AsciiFilter#
	     */
	    size: {
	        get: function ()
	        {
	            return this.uniforms.pixelSize.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.pixelSize.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 207 */
/*!****************************************************!*\
  !*** ./~/pixi.js/src/filters/bloom/BloomFilter.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../../core */ 1),
	    BlurXFilter = __webpack_require__(/*! ../blur/BlurXFilter */ 42),
	    BlurYFilter = __webpack_require__(/*! ../blur/BlurYFilter */ 63);
	
	/**
	 * The BloomFilter applies a Gaussian blur to an object.
	 * The strength of the blur can be set for x- and y-axis separately.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function BloomFilter()
	{
	    core.AbstractFilter.call(this);
	
	    this.blurXFilter = new BlurXFilter();
	    this.blurYFilter = new BlurYFilter();
	
	    this.defaultFilter = new core.AbstractFilter();
	}
	
	BloomFilter.prototype = Object.create(core.AbstractFilter.prototype);
	BloomFilter.prototype.constructor = BloomFilter;
	module.exports = BloomFilter;
	
	BloomFilter.prototype.applyFilter = function (renderer, input, output)
	{
	    var renderTarget = renderer.filterManager.getRenderTarget(true);
	
	    //TODO - copyTexSubImage2D could be used here?
	    this.defaultFilter.applyFilter(renderer, input, output);
	
	    this.blurXFilter.applyFilter(renderer, input, renderTarget);
	
	    renderer.blendModeManager.setBlendMode(core.BLEND_MODES.SCREEN);
	
	    this.blurYFilter.applyFilter(renderer, renderTarget, output);
	
	    renderer.blendModeManager.setBlendMode(core.BLEND_MODES.NORMAL);
	
	    renderer.filterManager.returnRenderTarget(renderTarget);
	};
	
	Object.defineProperties(BloomFilter.prototype, {
	    /**
	     * Sets the strength of both the blurX and blurY properties simultaneously
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.BloomFilter#
	     * @default 2
	     */
	    blur: {
	        get: function ()
	        {
	            return this.blurXFilter.blur;
	        },
	        set: function (value)
	        {
	            this.blurXFilter.blur = this.blurYFilter.blur = value;
	        }
	    },
	
	    /**
	     * Sets the strength of the blurX property
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.BloomFilter#
	     * @default 2
	     */
	    blurX: {
	        get: function ()
	        {
	            return this.blurXFilter.blur;
	        },
	        set: function (value)
	        {
	            this.blurXFilter.blur = value;
	        }
	    },
	
	    /**
	     * Sets the strength of the blurY property
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.BloomFilter#
	     * @default 2
	     */
	    blurY: {
	        get: function ()
	        {
	            return this.blurYFilter.blur;
	        },
	        set: function (value)
	        {
	            this.blurYFilter.blur = value;
	        }
	    }
	});


/***/ },
/* 208 */
/*!*****************************************************!*\
  !*** ./~/pixi.js/src/filters/blur/BlurDirFilter.js ***!
  \*****************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * The BlurDirFilter applies a Gaussian blur toward a direction to an object.
	 *
	 * @class
	 * @param {number} dirX
	 * @param {number} dirY
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function BlurDirFilter(dirX, dirY)
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        fs.readFileSync(__dirname + '/blurDir.vert', 'utf8'),
	        // fragment shader
	        fs.readFileSync(__dirname + '/blurDir.frag', 'utf8'),
	        // set the uniforms
	        {
	            strength: { type: '1f', value: 1 },
	            dirX: { type: '1f', value: dirX || 0 },
	            dirY: { type: '1f', value: dirY || 0 }
	        }
	    );
	
	    this.defaultFilter = new core.AbstractFilter();
	
	    /**
	     * Sets the number of passes for blur. More passes means higher quaility bluring.
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.passes = 1;
	
	    /**
	     * Sets the X direction of the blur
	     *
	     * @member {number}
	     * @default 0
	     */
	    this.dirX = dirX || 0;
	
	    /**
	     * Sets the Y direction of the blur
	     *
	     * @member {number}
	     * @default 0
	     */
	    this.dirY = dirY || 0;
	
	    this.strength = 4;
	}
	
	BlurDirFilter.prototype = Object.create(core.AbstractFilter.prototype);
	BlurDirFilter.prototype.constructor = BlurDirFilter;
	module.exports = BlurDirFilter;
	
	BlurDirFilter.prototype.applyFilter = function (renderer, input, output, clear) {
	
	    var shader = this.getShader(renderer);
	
	    this.uniforms.strength.value = this.strength / 4 / this.passes * (input.frame.width / input.size.width);
	
	    if (this.passes === 1) {
	        renderer.filterManager.applyFilter(shader, input, output, clear);
	    } else {
	        var renderTarget = renderer.filterManager.getRenderTarget(true);
	
	        renderer.filterManager.applyFilter(shader, input, renderTarget, clear);
	
	        for(var i = 0; i < this.passes-2; i++)
	        {
	            //this.uniforms.strength.value = this.strength / 4 / (this.passes+(i*2)) * (input.frame.width / input.size.width);
	            renderer.filterManager.applyFilter(shader, renderTarget, renderTarget, clear);
	        }
	
	        renderer.filterManager.applyFilter(shader, renderTarget, output, clear);
	
	        renderer.filterManager.returnRenderTarget(renderTarget);
	    }
	};
	
	
	Object.defineProperties(BlurDirFilter.prototype, {
	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.BlurDirFilter#
	     * @default 2
	     */
	    blur: {
	        get: function ()
	        {
	            return this.strength;
	        },
	        set: function (value)
	        {
	            this.padding = value * 0.5;
	            this.strength = value;
	        }
	    },
	    /**
	     * Sets the X direction of the blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.BlurYFilter#
	     * @default 0
	     */
	    dirX: {
	        get: function ()
	        {
	            return this.dirX;
	        },
	        set: function (value)
	        {
	            this.uniforms.dirX.value = value;
	        }
	    },
	    /**
	     * Sets the Y direction of the blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.BlurDirFilter#
	     * @default 0
	     */
	    dirY: {
	        get: function ()
	        {
	            return this.dirY;
	        },
	        set: function (value)
	        {
	            this.uniforms.dirY.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 209 */
/*!**************************************************!*\
  !*** ./~/pixi.js/src/filters/blur/BlurFilter.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../../core */ 1),
	    BlurXFilter = __webpack_require__(/*! ./BlurXFilter */ 42),
	    BlurYFilter = __webpack_require__(/*! ./BlurYFilter */ 63);
	
	/**
	 * The BlurFilter applies a Gaussian blur to an object.
	 * The strength of the blur can be set for x- and y-axis separately.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function BlurFilter()
	{
	    core.AbstractFilter.call(this);
	
	    this.blurXFilter = new BlurXFilter();
	    this.blurYFilter = new BlurYFilter();
	}
	
	BlurFilter.prototype = Object.create(core.AbstractFilter.prototype);
	BlurFilter.prototype.constructor = BlurFilter;
	module.exports = BlurFilter;
	
	BlurFilter.prototype.applyFilter = function (renderer, input, output)
	{
	    var renderTarget = renderer.filterManager.getRenderTarget(true);
	
	    this.blurXFilter.applyFilter(renderer, input, renderTarget);
	    this.blurYFilter.applyFilter(renderer, renderTarget, output);
	
	    renderer.filterManager.returnRenderTarget(renderTarget);
	};
	
	Object.defineProperties(BlurFilter.prototype, {
	    /**
	     * Sets the strength of both the blurX and blurY properties simultaneously
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.BlurFilter#
	     * @default 2
	     */
	    blur: {
	        get: function ()
	        {
	            return this.blurXFilter.blur;
	        },
	        set: function (value)
	        {
	            this.padding = Math.abs(value) * 0.5;
	            this.blurXFilter.blur = this.blurYFilter.blur = value;
	        }
	    },
	
	    /**
	     * Sets the number of passes for blur. More passes means higher quaility bluring.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.BlurYFilter#
	     * @default 1
	     */
	    passes: {
	        get: function ()
	        {
	            return  this.blurXFilter.passes;
	        },
	        set: function (value)
	        {
	            this.blurXFilter.passes = this.blurYFilter.passes = value;
	        }
	    },
	
	    /**
	     * Sets the strength of the blurX property
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.BlurFilter#
	     * @default 2
	     */
	    blurX: {
	        get: function ()
	        {
	            return this.blurXFilter.blur;
	        },
	        set: function (value)
	        {
	            this.blurXFilter.blur = value;
	        }
	    },
	
	    /**
	     * Sets the strength of the blurY property
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.BlurFilter#
	     * @default 2
	     */
	    blurY: {
	        get: function ()
	        {
	            return this.blurYFilter.blur;
	        },
	        set: function (value)
	        {
	            this.blurYFilter.blur = value;
	        }
	    }
	});


/***/ },
/* 210 */
/*!*******************************************************!*\
  !*** ./~/pixi.js/src/filters/blur/SmartBlurFilter.js ***!
  \*******************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * A Smart Blur Filter.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function SmartBlurFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/smartBlur.frag', 'utf8'),
	        // uniforms
	        {
	          delta: { type: 'v2', value: { x: 0.1, y: 0.0 } }
	        }
	    );
	}
	
	SmartBlurFilter.prototype = Object.create(core.AbstractFilter.prototype);
	SmartBlurFilter.prototype.constructor = SmartBlurFilter;
	module.exports = SmartBlurFilter;
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 211 */
/*!**********************************************************!*\
  !*** ./~/pixi.js/src/filters/color/ColorMatrixFilter.js ***!
  \**********************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
	 * color and alpha values of every pixel on your displayObject to produce a result
	 * with a new set of RGBA color and alpha values. It's pretty powerful!
	 *
	 * ```js
	 *  var colorMatrix = new PIXI.ColorMatrixFilter();
	 *  container.filters = [colorMatrix];
	 *  colorMatrix.contrast(2);
	 * ```
	 * @author Clément Chenebault <clement@goodboydigital.com>
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function ColorMatrixFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/colorMatrix.frag', 'utf8'),
	        // custom uniforms
	        {
	            m: {
	                type: '1fv', value: [
	                    1, 0, 0, 0, 0,
	                    0, 1, 0, 0, 0,
	                    0, 0, 1, 0, 0,
	                    0, 0, 0, 1, 0
	                ]
	            }
	        }
	    );
	}
	
	ColorMatrixFilter.prototype = Object.create(core.AbstractFilter.prototype);
	ColorMatrixFilter.prototype.constructor = ColorMatrixFilter;
	module.exports = ColorMatrixFilter;
	
	
	/**
	 * Transforms current matrix and set the new one
	 *
	 * @param matrix {number[]} (mat 5x4)
	 * @param multiply {boolean} if true, current matrix and matrix are multiplied. If false, just set the current matrix with @param matrix
	 */
	ColorMatrixFilter.prototype._loadMatrix = function (matrix, multiply)
	{
	    multiply = !!multiply;
	
	    var newMatrix = matrix;
	
	    if (multiply) {
	        this._multiply(newMatrix, this.uniforms.m.value, matrix);
	        newMatrix = this._colorMatrix(newMatrix);
	    }
	
	    // set the new matrix
	    this.uniforms.m.value = newMatrix;
	};
	
	/**
	 * Multiplies two mat5's
	 *
	 * @param out {number[]} (mat 5x4) the receiving matrix
	 * @param a {number[]} (mat 5x4) the first operand
	 * @param b {number[]} (mat 5x4) the second operand
	 * @returns out {number[]} (mat 5x4)
	 */
	ColorMatrixFilter.prototype._multiply = function (out, a, b)
	{
	
	    // Red Channel
	    out[0] = (a[0] * b[0]) + (a[1] * b[5]) + (a[2] * b[10]) + (a[3] * b[15]);
	    out[1] = (a[0] * b[1]) + (a[1] * b[6]) + (a[2] * b[11]) + (a[3] * b[16]);
	    out[2] = (a[0] * b[2]) + (a[1] * b[7]) + (a[2] * b[12]) + (a[3] * b[17]);
	    out[3] = (a[0] * b[3]) + (a[1] * b[8]) + (a[2] * b[13]) + (a[3] * b[18]);
	    out[4] = (a[0] * b[4]) + (a[1] * b[9]) + (a[2] * b[14]) + (a[3] * b[19]);
	
	    // Green Channel
	    out[5] = (a[5] * b[0]) + (a[6] * b[5]) + (a[7] * b[10]) + (a[8] * b[15]);
	    out[6] = (a[5] * b[1]) + (a[6] * b[6]) + (a[7] * b[11]) + (a[8] * b[16]);
	    out[7] = (a[5] * b[2]) + (a[6] * b[7]) + (a[7] * b[12]) + (a[8] * b[17]);
	    out[8] = (a[5] * b[3]) + (a[6] * b[8]) + (a[7] * b[13]) + (a[8] * b[18]);
	    out[9] = (a[5] * b[4]) + (a[6] * b[9]) + (a[7] * b[14]) + (a[8] * b[19]);
	
	    // Blue Channel
	    out[10] = (a[10] * b[0]) + (a[11] * b[5]) + (a[12] * b[10]) + (a[13] * b[15]);
	    out[11] = (a[10] * b[1]) + (a[11] * b[6]) + (a[12] * b[11]) + (a[13] * b[16]);
	    out[12] = (a[10] * b[2]) + (a[11] * b[7]) + (a[12] * b[12]) + (a[13] * b[17]);
	    out[13] = (a[10] * b[3]) + (a[11] * b[8]) + (a[12] * b[13]) + (a[13] * b[18]);
	    out[14] = (a[10] * b[4]) + (a[11] * b[9]) + (a[12] * b[14]) + (a[13] * b[19]);
	
	    // Alpha Channel
	    out[15] = (a[15] * b[0]) + (a[16] * b[5]) + (a[17] * b[10]) + (a[18] * b[15]);
	    out[16] = (a[15] * b[1]) + (a[16] * b[6]) + (a[17] * b[11]) + (a[18] * b[16]);
	    out[17] = (a[15] * b[2]) + (a[16] * b[7]) + (a[17] * b[12]) + (a[18] * b[17]);
	    out[18] = (a[15] * b[3]) + (a[16] * b[8]) + (a[17] * b[13]) + (a[18] * b[18]);
	    out[19] = (a[15] * b[4]) + (a[16] * b[9]) + (a[17] * b[14]) + (a[18] * b[19]);
	
	    return out;
	};
	
	/**
	 * Create a Float32 Array and normalize the offset component to 0-1
	 *
	 * @param matrix {number[]} (mat 5x4)
	 * @return m {number[]} (mat 5x4) with all values between 0-1
	 */
	ColorMatrixFilter.prototype._colorMatrix = function (matrix)
	{
	    // Create a Float32 Array and normalize the offset component to 0-1
	    var m = new Float32Array(matrix);
	    m[4] /= 255;
	    m[9] /= 255;
	    m[14] /= 255;
	    m[19] /= 255;
	
	    return m;
	};
	
	/**
	 * Adjusts brightness
	 *
	 * @param b {number} value of the brigthness (0 is black)
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.brightness = function (b, multiply)
	{
	    var matrix = [
	        b, 0, 0, 0, 0,
	        0, b, 0, 0, 0,
	        0, 0, b, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Set the matrices in grey scales
	 *
	 * @param scale {number} value of the grey (0 is black)
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.greyscale = function (scale, multiply)
	{
	    var matrix = [
	        scale, scale, scale, 0, 0,
	        scale, scale, scale, 0, 0,
	        scale, scale, scale, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	//Americanized alias
	ColorMatrixFilter.prototype.grayscale = ColorMatrixFilter.prototype.greyscale;
	
	/**
	 * Set the black and white matrice
	 * Multiply the current matrix
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.blackAndWhite = function (multiply)
	{
	    var matrix = [
	        0.3, 0.6, 0.1, 0, 0,
	        0.3, 0.6, 0.1, 0, 0,
	        0.3, 0.6, 0.1, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Set the hue property of the color
	 *
	 * @param rotation {number} in degrees
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.hue = function (rotation, multiply)
	{
	    rotation = (rotation || 0) / 180 * Math.PI;
	    var cos = Math.cos(rotation),
	        sin = Math.sin(rotation);
	
	    // luminanceRed, luminanceGreen, luminanceBlue
	    var lumR = 0.213, // or 0.3086
	        lumG = 0.715, // or 0.6094
	        lumB = 0.072; // or 0.0820
	
	    var matrix = [
	        lumR + cos * (1 - lumR) + sin * (-lumR), lumG + cos * (-lumG) + sin * (-lumG), lumB + cos * (-lumB) + sin * (1 - lumB), 0, 0,
	        lumR + cos * (-lumR) + sin * (0.143), lumG + cos * (1 - lumG) + sin * (0.140), lumB + cos * (-lumB) + sin * (-0.283), 0, 0,
	        lumR + cos * (-lumR) + sin * (-(1 - lumR)), lumG + cos * (-lumG) + sin * (lumG), lumB + cos * (1 - lumB) + sin * (lumB), 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	
	/**
	 * Set the contrast matrix, increase the separation between dark and bright
	 * Increase contrast : shadows darker and highlights brighter
	 * Decrease contrast : bring the shadows up and the highlights down
	 *
	 * @param amount {number} value of the contrast
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.contrast = function (amount, multiply)
	{
	    var v = (amount || 0) + 1;
	    var o = -128 * (v - 1);
	
	    var matrix = [
	        v, 0, 0, 0, o,
	        0, v, 0, 0, o,
	        0, 0, v, 0, o,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Set the saturation matrix, increase the separation between colors
	 * Increase saturation : increase contrast, brightness, and sharpness
	 *
	 * @param amount {number}
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.saturate = function (amount, multiply)
	{
	    var x = (amount || 0) * 2 / 3 + 1;
	    var y = ((x - 1) * -0.5);
	
	    var matrix = [
	        x, y, y, 0, 0,
	        y, x, y, 0, 0,
	        y, y, x, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Desaturate image (remove color)
	 *
	 * Call the saturate function
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.desaturate = function (multiply) // jshint unused:false
	{
	    this.saturate(-1);
	};
	
	/**
	 * Negative image (inverse of classic rgb matrix)
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.negative = function (multiply)
	{
	    var matrix = [
	        0, 1, 1, 0, 0,
	        1, 0, 1, 0, 0,
	        1, 1, 0, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Sepia image
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.sepia = function (multiply)
	{
	    var matrix = [
	        0.393, 0.7689999, 0.18899999, 0, 0,
	        0.349, 0.6859999, 0.16799999, 0, 0,
	        0.272, 0.5339999, 0.13099999, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.technicolor = function (multiply)
	{
	    var matrix = [
	        1.9125277891456083, -0.8545344976951645, -0.09155508482755585, 0, 11.793603434377337,
	        -0.3087833385928097, 1.7658908555458428, -0.10601743074722245, 0, -70.35205161461398,
	        -0.231103377548616, -0.7501899197440212, 1.847597816108189, 0, 30.950940869491138,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Polaroid filter
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.polaroid = function (multiply)
	{
	    var matrix = [
	        1.438, -0.062, -0.062, 0, 0,
	        -0.122, 1.378, -0.122, 0, 0,
	        -0.016, -0.016, 1.483, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Filter who transforms : Red -> Blue and Blue -> Red
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.toBGR = function (multiply)
	{
	    var matrix = [
	        0, 0, 1, 0, 0,
	        0, 1, 0, 0, 0,
	        1, 0, 0, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.kodachrome = function (multiply)
	{
	    var matrix = [
	        1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
	        -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
	        -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/**
	 * Brown delicious browni filter (thanks Dominic Szablewski)
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.browni = function (multiply)
	{
	    var matrix = [
	        0.5997023498159715, 0.34553243048391263, -0.2708298674538042, 0, 47.43192855600873,
	        -0.037703249837783157, 0.8609577587992641, 0.15059552388459913, 0, -36.96841498319127,
	        0.24113635128153335, -0.07441037908422492, 0.44972182064877153, 0, -7.562075277591283,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/*
	 * Vintage filter (thanks Dominic Szablewski)
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.vintage = function (multiply)
	{
	    var matrix = [
	        0.6279345635605994, 0.3202183420819367, -0.03965408211312453, 0, 9.651285835294123,
	        0.02578397704808868, 0.6441188644374771, 0.03259127616149294, 0, 7.462829176470591,
	        0.0466055556782719, -0.0851232987247891, 0.5241648018700465, 0, 5.159190588235296,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/*
	 * We don't know exactly what it does, kind of gradient map, but funny to play with!
	 *
	 * @param desaturation {number}
	 * @param toned {number}
	 * @param lightColor {string} (example : "0xFFE580")
	 * @param darkColor {string}  (example : "0xFFE580")
	 *
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.colorTone = function (desaturation, toned, lightColor, darkColor, multiply)
	{
	    desaturation = desaturation || 0.2;
	    toned = toned || 0.15;
	    lightColor = lightColor || 0xFFE580;
	    darkColor = darkColor || 0x338000;
	
	    var lR = ((lightColor >> 16) & 0xFF) / 255;
	    var lG = ((lightColor >> 8) & 0xFF) / 255;
	    var lB = (lightColor & 0xFF) / 255;
	
	    var dR = ((darkColor >> 16) & 0xFF) / 255;
	    var dG = ((darkColor >> 8) & 0xFF) / 255;
	    var dB = (darkColor & 0xFF) / 255;
	
	    var matrix = [
	        0.3, 0.59, 0.11, 0, 0,
	        lR, lG, lB, desaturation, 0,
	        dR, dG, dB, toned, 0,
	        lR - dR, lG - dG, lB - dB, 0, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/*
	 * Night effect
	 *
	 * @param intensity {number}
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.night = function (intensity, multiply)
	{
	    intensity = intensity || 0.1;
	    var matrix = [
	        intensity * ( -2.0), -intensity, 0, 0, 0,
	        -intensity, 0, intensity, 0, 0,
	        0, intensity, intensity * 2.0, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	
	/*
	 * Predator effect
	 *
	 * Erase the current matrix by setting a new indepent one
	 *
	 * @param amount {number} how much the predator feels his future victim
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.predator = function (amount, multiply)
	{
	    var matrix = [
	        11.224130630493164 * amount, -4.794486999511719 * amount, -2.8746118545532227 * amount, 0 * amount, 0.40342438220977783 * amount,
	        -3.6330697536468506 * amount, 9.193157196044922 * amount, -2.951810836791992 * amount, 0 * amount, -1.316135048866272 * amount,
	        -3.2184197902679443 * amount, -4.2375030517578125 * amount, 7.476448059082031 * amount, 0 * amount, 0.8044459223747253 * amount,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/*
	 * LSD effect
	 *
	 * Multiply the current matrix
	 *
	 * @param amount {number} How crazy is your effect
	 * @param multiply {boolean} refer to ._loadMatrix() method
	 */
	ColorMatrixFilter.prototype.lsd = function (multiply)
	{
	    var matrix = [
	        2, -0.4, 0.5, 0, 0,
	        -0.5, 2, -0.4, 0, 0,
	        -0.4, -0.5, 3, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, multiply);
	};
	
	/*
	 * Erase the current matrix by setting the default one
	 *
	 */
	ColorMatrixFilter.prototype.reset = function ()
	{
	    var matrix = [
	        1, 0, 0, 0, 0,
	        0, 1, 0, 0, 0,
	        0, 0, 1, 0, 0,
	        0, 0, 0, 1, 0
	    ];
	
	    this._loadMatrix(matrix, false);
	};
	
	
	Object.defineProperties(ColorMatrixFilter.prototype, {
	    /**
	     * Sets the matrix of the color matrix filter
	     *
	     * @member {number[]}
	     * @memberof PIXI.filters.ColorMatrixFilter#
	     * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
	     */
	    matrix: {
	        get: function ()
	        {
	            return this.uniforms.m.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.m.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 212 */
/*!********************************************************!*\
  !*** ./~/pixi.js/src/filters/color/ColorStepFilter.js ***!
  \********************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * This lowers the color depth of your image by the given amount, producing an image with a smaller palette.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function ColorStepFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/colorStep.frag', 'utf8'),
	        // custom uniforms
	        {
	            step: { type: '1f', value: 5 }
	        }
	    );
	}
	
	ColorStepFilter.prototype = Object.create(core.AbstractFilter.prototype);
	ColorStepFilter.prototype.constructor = ColorStepFilter;
	module.exports = ColorStepFilter;
	
	Object.defineProperties(ColorStepFilter.prototype, {
	    /**
	     * The number of steps to reduce the palette by.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.ColorStepFilter#
	     */
	    step: {
	        get: function ()
	        {
	            return this.uniforms.step.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.step.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 213 */
/*!****************************************************************!*\
  !*** ./~/pixi.js/src/filters/convolution/ConvolutionFilter.js ***!
  \****************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * The ConvolutionFilter class applies a matrix convolution filter effect.
	 * A convolution combines pixels in the input image with neighboring pixels to produce a new image.
	 * A wide variety of image effects can be achieved through convolutions, including blurring, edge
	 * detection, sharpening, embossing, and beveling. The matrix should be specified as a 9 point Array.
	 * See http://docs.gimp.org/en/plug-in-convmatrix.html for more info.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 * @param matrix {number[]} An array of values used for matrix transformation. Specified as a 9 point Array.
	 * @param width {number} Width of the object you are transforming
	 * @param height {number} Height of the object you are transforming
	 */
	function ConvolutionFilter(matrix, width, height)
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/convolution.frag', 'utf8'),
	        // custom uniforms
	        {
	            matrix:     { type: '1fv', value: new Float32Array(matrix) },
	            texelSize:  { type: 'v2', value: { x: 1 / width, y: 1 / height } }
	        }
	    );
	}
	
	ConvolutionFilter.prototype = Object.create(core.AbstractFilter.prototype);
	ConvolutionFilter.prototype.constructor = ConvolutionFilter;
	module.exports = ConvolutionFilter;
	
	Object.defineProperties(ConvolutionFilter.prototype, {
	    /**
	     * An array of values used for matrix transformation. Specified as a 9 point Array.
	     *
	     * @member {number[]}
	     * @memberof PIXI.filters.ConvolutionFilter#
	     */
	    matrix: {
	        get: function ()
	        {
	            return this.uniforms.matrix.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.matrix.value = new Float32Array(value);
	        }
	    },
	
	    /**
	     * Width of the object you are transforming
	     *
	     * @member {number}
	     * @memberof PIXI.filters.ConvolutionFilter#
	     */
	    width: {
	        get: function ()
	        {
	            return 1/this.uniforms.texelSize.value.x;
	        },
	        set: function (value)
	        {
	            this.uniforms.texelSize.value.x = 1/value;
	        }
	    },
	
	    /**
	     * Height of the object you are transforming
	     *
	     * @member {number}
	     * @memberof PIXI.filters.ConvolutionFilter#
	     */
	    height: {
	        get: function ()
	        {
	            return 1/this.uniforms.texelSize.value.y;
	        },
	        set: function (value)
	        {
	            this.uniforms.texelSize.value.y = 1/value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 214 */
/*!**************************************************************!*\
  !*** ./~/pixi.js/src/filters/crosshatch/CrossHatchFilter.js ***!
  \**************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * A Cross Hatch effect filter.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function CrossHatchFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/crosshatch.frag', 'utf8')
	    );
	}
	
	CrossHatchFilter.prototype = Object.create(core.AbstractFilter.prototype);
	CrossHatchFilter.prototype.constructor = CrossHatchFilter;
	module.exports = CrossHatchFilter;
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 215 */
/*!******************************************************************!*\
  !*** ./~/pixi.js/src/filters/displacement/DisplacementFilter.js ***!
  \******************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * The DisplacementFilter class uses the pixel values from the specified texture (called the displacement map) to perform a displacement of an object.
	 * You can use this filter to apply all manor of crazy warping effects
	 * Currently the r property of the texture is used to offset the x and the g property of the texture is used to offset the y.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 * @param sprite {PIXI.Sprite} the sprite used for the displacement map. (make sure its added to the scene!)
	 */
	function DisplacementFilter(sprite, scale)
	{
	    var maskMatrix = new core.Matrix();
	    sprite.renderable = false;
	
	    core.AbstractFilter.call(this,
	        // vertex shader
	        fs.readFileSync(__dirname + '/displacement.vert', 'utf8'),
	        // fragment shader
	        fs.readFileSync(__dirname + '/displacement.frag', 'utf8'),
	        // uniforms
	        {
	            mapSampler:     { type: 'sampler2D', value: sprite.texture },
	            otherMatrix:    { type: 'mat3', value: maskMatrix.toArray(true) },
	            scale:          { type: 'v2', value: { x: 1, y: 1 } }
	        }
	    );
	
	    this.maskSprite = sprite;
	    this.maskMatrix = maskMatrix;
	
	    if (scale === null || scale === undefined)
	    {
	        scale = 20;
	    }
	
	    this.scale = new core.Point(scale, scale);
	}
	
	DisplacementFilter.prototype = Object.create(core.AbstractFilter.prototype);
	DisplacementFilter.prototype.constructor = DisplacementFilter;
	module.exports = DisplacementFilter;
	
	DisplacementFilter.prototype.applyFilter = function (renderer, input, output)
	{
	    var filterManager = renderer.filterManager;
	
	    filterManager.calculateMappedMatrix(input.frame, this.maskSprite, this.maskMatrix);
	
	    this.uniforms.otherMatrix.value = this.maskMatrix.toArray(true);
	    this.uniforms.scale.value.x = this.scale.x * (1/input.frame.width);
	    this.uniforms.scale.value.y = this.scale.y * (1/input.frame.height);
	
	    var shader = this.getShader(renderer);
	     // draw the filter...
	    filterManager.applyFilter(shader, input, output);
	};
	
	
	Object.defineProperties(DisplacementFilter.prototype, {
	    /**
	     * The texture used for the displacement map. Must be power of 2 sized texture.
	     *
	     * @member {PIXI.Texture}
	     * @memberof PIXI.filters.DisplacementFilter#
	     */
	    map: {
	        get: function ()
	        {
	            return this.uniforms.mapSampler.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.mapSampler.value = value;
	
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 216 */
/*!******************************************************!*\
  !*** ./~/pixi.js/src/filters/dot/DotScreenFilter.js ***!
  \******************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * @author Mat Groves http://matgroves.com/ @Doormat23
	 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/fun/dotscreen.js
	 */
	
	/**
	 * This filter applies a dotscreen effect making display objects appear to be made out of
	 * black and white halftone dots like an old printer.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function DotScreenFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/dotScreen.frag', 'utf8'),
	        // custom uniforms
	        {
	            scale:      { type: '1f', value: 1 },
	            angle:      { type: '1f', value: 5 },
	            dimensions: { type: '4fv', value: [0, 0, 0, 0] }
	        }
	    );
	}
	
	DotScreenFilter.prototype = Object.create(core.AbstractFilter.prototype);
	DotScreenFilter.prototype.constructor = DotScreenFilter;
	module.exports = DotScreenFilter;
	
	Object.defineProperties(DotScreenFilter.prototype, {
	    /**
	     * The scale of the effect.
	     * @member {number}
	     * @memberof PIXI.filters.DotScreenFilter#
	     */
	    scale: {
	        get: function ()
	        {
	            return this.uniforms.scale.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.scale.value = value;
	        }
	    },
	
	    /**
	     * The radius of the effect.
	     * @member {number}
	     * @memberof PIXI.filters.DotScreenFilter#
	     */
	    angle: {
	        get: function ()
	        {
	            return this.uniforms.angle.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.angle.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 217 */
/*!*************************************************************!*\
  !*** ./~/pixi.js/src/filters/dropshadow/BlurYTintFilter.js ***!
  \*************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * The BlurYTintFilter applies a vertical Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function BlurYTintFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        fs.readFileSync(__dirname + '/blurYTint.vert', 'utf8'),
	        // fragment shader
	        fs.readFileSync(__dirname + '/blurYTint.frag', 'utf8'),
	        // set the uniforms
	        {
	            blur: { type: '1f', value: 1 / 512 },
	            color: { type: 'c', value: [0,0,0]},
	            alpha: { type: '1f', value: 0.7 },
	            offset: { type: '2f', value:[5, 5]},
	            strength: { type: '1f', value:1}
	        }
	    );
	
	    this.passes = 1;
	    this.strength = 4;
	}
	
	BlurYTintFilter.prototype = Object.create(core.AbstractFilter.prototype);
	BlurYTintFilter.prototype.constructor = BlurYTintFilter;
	module.exports = BlurYTintFilter;
	
	BlurYTintFilter.prototype.applyFilter = function (renderer, input, output, clear)
	{
	    var shader = this.getShader(renderer);
	
	    this.uniforms.strength.value = this.strength / 4 / this.passes * (input.frame.height / input.size.height);
	
	    if(this.passes === 1)
	    {
	        renderer.filterManager.applyFilter(shader, input, output, clear);
	    }
	    else
	    {
	        var renderTarget = renderer.filterManager.getRenderTarget(true);
	        var flip = input;
	        var flop = renderTarget;
	
	        for(var i = 0; i < this.passes-1; i++)
	        {
	            renderer.filterManager.applyFilter(shader, flip, flop, clear);
	
	           var temp = flop;
	           flop = flip;
	           flip = temp;
	        }
	
	        renderer.filterManager.applyFilter(shader, flip, output, clear);
	
	        renderer.filterManager.returnRenderTarget(renderTarget);
	    }
	};
	
	
	Object.defineProperties(BlurYTintFilter.prototype, {
	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.BlurYTintFilter#
	     * @default 2
	     */
	    blur: {
	        get: function ()
	        {
	            return  this.strength;
	        },
	        set: function (value)
	        {
	            this.padding = value * 0.5;
	            this.strength = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 218 */
/*!**************************************************************!*\
  !*** ./~/pixi.js/src/filters/dropshadow/DropShadowFilter.js ***!
  \**************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../../core */ 1),
	    BlurXFilter = __webpack_require__(/*! ../blur/BlurXFilter */ 42),
	    BlurYTintFilter = __webpack_require__(/*! ./BlurYTintFilter */ 217);
	
	/**
	 * The DropShadowFilter applies a Gaussian blur to an object.
	 * The strength of the blur can be set for x- and y-axis separately.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function DropShadowFilter()
	{
	    core.AbstractFilter.call(this);
	
	    this.blurXFilter = new BlurXFilter();
	    this.blurYTintFilter = new BlurYTintFilter();
	
	    this.defaultFilter = new core.AbstractFilter();
	
	    this.padding = 30;
	
	    this._dirtyPosition = true;
	    this._angle = 45 * Math.PI / 180;
	    this._distance = 10;
	    this.alpha = 0.75;
	    this.hideObject = false;
	    this.blendMode = core.BLEND_MODES.MULTIPLY;
	}
	
	DropShadowFilter.prototype = Object.create(core.AbstractFilter.prototype);
	DropShadowFilter.prototype.constructor = DropShadowFilter;
	module.exports = DropShadowFilter;
	
	DropShadowFilter.prototype.applyFilter = function (renderer, input, output)
	{
	    var renderTarget = renderer.filterManager.getRenderTarget(true);
	
	    //TODO - copyTexSubImage2D could be used here?
	    if(this._dirtyPosition)
	    {
	        this._dirtyPosition = false;
	
	        this.blurYTintFilter.uniforms.offset.value[0] = Math.sin(this._angle) * this._distance;
	        this.blurYTintFilter.uniforms.offset.value[1] = Math.cos(this._angle) * this._distance;
	    }
	
	    this.blurXFilter.applyFilter(renderer, input, renderTarget);
	
	    renderer.blendModeManager.setBlendMode(this.blendMode);
	
	    this.blurYTintFilter.applyFilter(renderer, renderTarget, output);
	
	    renderer.blendModeManager.setBlendMode(core.BLEND_MODES.NORMAL);
	
	    if(!this.hideObject)
	    {
	
	        this.defaultFilter.applyFilter(renderer, input, output);
	    }
	
	
	    renderer.filterManager.returnRenderTarget(renderTarget);
	};
	
	Object.defineProperties(DropShadowFilter.prototype, {
	    /**
	     * Sets the strength of both the blurX and blurY properties simultaneously
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.DropShadowFilter#
	     * @default 2
	     */
	    blur: {
	        get: function ()
	        {
	            return this.blurXFilter.blur;
	        },
	        set: function (value)
	        {
	            this.blurXFilter.blur = this.blurYTintFilter.blur = value;
	        }
	    },
	
	    /**
	     * Sets the strength of the blurX property
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.DropShadowFilter#
	     * @default 2
	     */
	    blurX: {
	        get: function ()
	        {
	            return this.blurXFilter.blur;
	        },
	        set: function (value)
	        {
	            this.blurXFilter.blur = value;
	        }
	    },
	
	    /**
	     * Sets the strength of the blurY property
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.DropShadowFilter#
	     * @default 2
	     */
	    blurY: {
	        get: function ()
	        {
	            return this.blurYTintFilter.blur;
	        },
	        set: function (value)
	        {
	            this.blurYTintFilter.blur = value;
	        }
	    },
	
	    /**
	     * Sets the color of the shadow
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.DropShadowFilter#
	     */
	    color: {
	        get: function ()
	        {
	            return  core.utils.rgb2hex( this.blurYTintFilter.uniforms.color.value );
	        },
	        set: function (value)
	        {
	            this.blurYTintFilter.uniforms.color.value = core.utils.hex2rgb(value);
	        }
	    },
	
	    /**
	     * Sets the alpha of the shadow
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.DropShadowFilter#
	     */
	    alpha: {
	        get: function ()
	        {
	            return  this.blurYTintFilter.uniforms.alpha.value;
	        },
	        set: function (value)
	        {
	            this.blurYTintFilter.uniforms.alpha.value = value;
	        }
	    },
	
	    /**
	     * Sets the distance of the shadow
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.DropShadowFilter#
	     */
	    distance: {
	        get: function ()
	        {
	            return  this._distance;
	        },
	        set: function (value)
	        {
	            this._dirtyPosition = true;
	            this._distance = value;
	        }
	    },
	
	    /**
	     * Sets the angle of the shadow
	     *
	     * @member {number}
	     * @memberOf PIXI.filters.DropShadowFilter#
	     */
	    angle: {
	        get: function ()
	        {
	            return  this._angle;
	        },
	        set: function (value)
	        {
	            this._dirtyPosition = true;
	            this._angle = value;
	        }
	    }
	});


/***/ },
/* 219 */
/*!**************************************************!*\
  !*** ./~/pixi.js/src/filters/gray/GrayFilter.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * This greyscales the palette of your Display Objects.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function GrayFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/gray.frag', 'utf8'),
	        // set the uniforms
	        {
	            gray: { type: '1f', value: 1 }
	        }
	    );
	}
	
	GrayFilter.prototype = Object.create(core.AbstractFilter.prototype);
	GrayFilter.prototype.constructor = GrayFilter;
	module.exports = GrayFilter;
	
	Object.defineProperties(GrayFilter.prototype, {
	    /**
	     * The strength of the gray. 1 will make the object black and white, 0 will make the object its normal color.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.GrayFilter#
	     */
	    gray: {
	        get: function ()
	        {
	            return this.uniforms.gray.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.gray.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 220 */
/*!******************************************************!*\
  !*** ./~/pixi.js/src/filters/invert/InvertFilter.js ***!
  \******************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * This inverts your Display Objects colors.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function InvertFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/invert.frag', 'utf8'),
	        // custom uniforms
	        {
	            invert: { type: '1f', value: 1 }
	        }
	    );
	}
	
	InvertFilter.prototype = Object.create(core.AbstractFilter.prototype);
	InvertFilter.prototype.constructor = InvertFilter;
	module.exports = InvertFilter;
	
	Object.defineProperties(InvertFilter.prototype, {
	    /**
	     * The strength of the invert. `1` will fully invert the colors, and
	     * `0` will make the object its normal color.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.InvertFilter#
	     */
	    invert: {
	        get: function ()
	        {
	            return this.uniforms.invert.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.invert.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 221 */
/*!****************************************************!*\
  !*** ./~/pixi.js/src/filters/noise/NoiseFilter.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * @author Vico @vicocotea
	 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
	 */
	
	/**
	 * A Noise effect filter.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function NoiseFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/noise.frag', 'utf8'),
	        // custom uniforms
	        {
	            noise: { type: '1f', value: 0.5 }
	        }
	    );
	}
	
	NoiseFilter.prototype = Object.create(core.AbstractFilter.prototype);
	NoiseFilter.prototype.constructor = NoiseFilter;
	module.exports = NoiseFilter;
	
	Object.defineProperties(NoiseFilter.prototype, {
	    /**
	     * The amount of noise to apply.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.NoiseFilter#
	     * @default 0.5
	     */
	    noise: {
	        get: function ()
	        {
	            return this.uniforms.noise.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.noise.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 222 */
/*!**********************************************************!*\
  !*** ./~/pixi.js/src/filters/pixelate/PixelateFilter.js ***!
  \**********************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * This filter applies a pixelate effect making display objects appear 'blocky'.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function PixelateFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/pixelate.frag', 'utf8'),
	        // custom uniforms
	        {
	            dimensions: { type: '4fv',  value: new Float32Array([0, 0, 0, 0]) },
	            pixelSize:  { type: 'v2',   value: { x: 10, y: 10 } }
	        }
	    );
	}
	
	PixelateFilter.prototype = Object.create(core.AbstractFilter.prototype);
	PixelateFilter.prototype.constructor = PixelateFilter;
	module.exports = PixelateFilter;
	
	Object.defineProperties(PixelateFilter.prototype, {
	    /**
	     * This a point that describes the size of the blocks.
	     * x is the width of the block and y is the height.
	     *
	     * @member {PIXI.Point}
	     * @memberof PIXI.filters.PixelateFilter#
	     */
	    size: {
	        get: function ()
	        {
	            return this.uniforms.pixelSize.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.pixelSize.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 223 */
/*!*****************************************************!*\
  !*** ./~/pixi.js/src/filters/rgb/RGBSplitFilter.js ***!
  \*****************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * An RGB Split Filter.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function RGBSplitFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/rgbSplit.frag', 'utf8'),
	        // custom uniforms
	        {
	            red:        { type: 'v2', value: { x: 20, y: 20 } },
	            green:      { type: 'v2', value: { x: -20, y: 20 } },
	            blue:       { type: 'v2', value: { x: 20, y: -20 } },
	            dimensions: { type: '4fv', value: [0, 0, 0, 0] }
	        }
	    );
	}
	
	RGBSplitFilter.prototype = Object.create(core.AbstractFilter.prototype);
	RGBSplitFilter.prototype.constructor = RGBSplitFilter;
	module.exports = RGBSplitFilter;
	
	Object.defineProperties(RGBSplitFilter.prototype, {
	    /**
	     * Red channel offset.
	     *
	     * @member {PIXI.Point}
	     * @memberof PIXI.filters.RGBSplitFilter#
	     */
	    red: {
	        get: function ()
	        {
	            return this.uniforms.red.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.red.value = value;
	        }
	    },
	
	    /**
	     * Green channel offset.
	     *
	     * @member {PIXI.Point}
	     * @memberof PIXI.filters.RGBSplitFilter#
	     */
	    green: {
	        get: function ()
	        {
	            return this.uniforms.green.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.green.value = value;
	        }
	    },
	
	    /**
	     * Blue offset.
	     *
	     * @member {PIXI.Point}
	     * @memberof PIXI.filters.RGBSplitFilter#
	     */
	    blue: {
	        get: function ()
	        {
	            return this.uniforms.blue.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.blue.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 224 */
/*!****************************************************!*\
  !*** ./~/pixi.js/src/filters/sepia/SepiaFilter.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * This applies a sepia effect to your Display Objects.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function SepiaFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/sepia.frag', 'utf8'),
	        // custom uniforms
	        {
	            sepia: { type: '1f', value: 1 }
	        }
	    );
	}
	
	SepiaFilter.prototype = Object.create(core.AbstractFilter.prototype);
	SepiaFilter.prototype.constructor = SepiaFilter;
	module.exports = SepiaFilter;
	
	Object.defineProperties(SepiaFilter.prototype, {
	    /**
	     * The strength of the sepia. `1` will apply the full sepia effect, and
	     * `0` will make the object its normal color.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.SepiaFilter#
	     */
	    sepia: {
	        get: function ()
	        {
	            return this.uniforms.sepia.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.sepia.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 225 */
/*!************************************************************!*\
  !*** ./~/pixi.js/src/filters/shockwave/ShockwaveFilter.js ***!
  \************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * The ColorMatrixFilter class lets you apply a 4x4 matrix transformation on the RGBA
	 * color and alpha values of every pixel on your displayObject to produce a result
	 * with a new set of RGBA color and alpha values. It's pretty powerful!
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function ShockwaveFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/shockwave.frag', 'utf8'),
	        // custom uniforms
	        {
	            center: { type: 'v2', value: { x: 0.5, y: 0.5 } },
	            params: { type: 'v3', value: { x: 10, y: 0.8, z: 0.1 } },
	            time: { type: '1f', value: 0 }
	        }
	    );
	}
	
	ShockwaveFilter.prototype = Object.create(core.AbstractFilter.prototype);
	ShockwaveFilter.prototype.constructor = ShockwaveFilter;
	module.exports = ShockwaveFilter;
	
	Object.defineProperties(ShockwaveFilter.prototype, {
	    /**
	     * Sets the center of the shockwave in normalized screen coords. That is
	     * (0,0) is the top-left and (1,1) is the bottom right.
	     *
	     * @member {object<string, number>}
	     * @memberof PIXI.filters.ShockwaveFilter#
	     */
	    center: {
	        get: function ()
	        {
	            return this.uniforms.center.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.center.value = value;
	        }
	    },
	    /**
	     * Sets the params of the shockwave. These modify the look and behavior of
	     * the shockwave as it ripples out.
	     *
	     * @member {object<string, number>}
	     * @memberof PIXI.filters.ShockwaveFilter#
	     */
	    params: {
	        get: function ()
	        {
	            return this.uniforms.params.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.params.value = value;
	        }
	    },
	    /**
	     * Sets the elapsed time of the shockwave. This controls the speed at which
	     * the shockwave ripples out.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.ShockwaveFilter#
	     */
	    time: {
	        get: function ()
	        {
	            return this.uniforms.time.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.time.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 226 */
/*!************************************************************!*\
  !*** ./~/pixi.js/src/filters/tiltshift/TiltShiftFilter.js ***!
  \************************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../../core */ 1),
	    TiltShiftXFilter = __webpack_require__(/*! ./TiltShiftXFilter */ 111),
	    TiltShiftYFilter = __webpack_require__(/*! ./TiltShiftYFilter */ 112);
	
	/**
	 * @author Vico @vicocotea
	 * original filter https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js by Evan Wallace : http://madebyevan.com/
	 */
	
	/**
	 * A TiltShift Filter. Manages the pass of both a TiltShiftXFilter and TiltShiftYFilter.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function TiltShiftFilter()
	{
	    core.AbstractFilter.call(this);
	
	    this.tiltShiftXFilter = new TiltShiftXFilter();
	    this.tiltShiftYFilter = new TiltShiftYFilter();
	}
	
	TiltShiftFilter.prototype = Object.create(core.AbstractFilter.prototype);
	TiltShiftFilter.prototype.constructor = TiltShiftFilter;
	module.exports = TiltShiftFilter;
	
	TiltShiftFilter.prototype.applyFilter = function (renderer, input, output)
	{
	    var renderTarget = renderer.filterManager.getRenderTarget(true);
	
	    this.tiltShiftXFilter.applyFilter(renderer, input, renderTarget);
	
	    this.tiltShiftYFilter.applyFilter(renderer, renderTarget, output);
	
	    renderer.filterManager.returnRenderTarget(renderTarget);
	};
	
	Object.defineProperties(TiltShiftFilter.prototype, {
	    /**
	     * The strength of the blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.TiltShiftFilter#
	     */
	    blur: {
	        get: function ()
	        {
	            return this.tiltShiftXFilter.blur;
	        },
	        set: function (value)
	        {
	            this.tiltShiftXFilter.blur = this.tiltShiftYFilter.blur = value;
	        }
	    },
	
	    /**
	     * The strength of the gradient blur.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.TiltShiftFilter#
	     */
	    gradientBlur: {
	        get: function ()
	        {
	            return this.tiltShiftXFilter.gradientBlur;
	        },
	        set: function (value)
	        {
	            this.tiltShiftXFilter.gradientBlur = this.tiltShiftYFilter.gradientBlur = value;
	        }
	    },
	
	    /**
	     * The Y value to start the effect at.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.TiltShiftFilter#
	     */
	    start: {
	        get: function ()
	        {
	            return this.tiltShiftXFilter.start;
	        },
	        set: function (value)
	        {
	            this.tiltShiftXFilter.start = this.tiltShiftYFilter.start = value;
	        }
	    },
	
	    /**
	     * The Y value to end the effect at.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.TiltShiftFilter#
	     */
	    end: {
	        get: function ()
	        {
	            return this.tiltShiftXFilter.end;
	        },
	        set: function (value)
	        {
	            this.tiltShiftXFilter.end = this.tiltShiftYFilter.end = value;
	        }
	    }
	});


/***/ },
/* 227 */
/*!****************************************************!*\
  !*** ./~/pixi.js/src/filters/twist/TwistFilter.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {var core = __webpack_require__(/*! ../../core */ 1);
	// @see https://github.com/substack/brfs/issues/25
	var fs = __webpack_require__(/*! fs */ 5);
	
	/**
	 * This filter applies a twist effect making display objects appear twisted in the given direction.
	 *
	 * @class
	 * @extends PIXI.AbstractFilter
	 * @memberof PIXI.filters
	 */
	function TwistFilter()
	{
	    core.AbstractFilter.call(this,
	        // vertex shader
	        null,
	        // fragment shader
	        fs.readFileSync(__dirname + '/twist.frag', 'utf8'),
	        // custom uniforms
	        {
	            radius:     { type: '1f', value: 0.5 },
	            angle:      { type: '1f', value: 5 },
	            offset:     { type: 'v2', value: { x: 0.5, y: 0.5 } }
	        }
	    );
	}
	
	TwistFilter.prototype = Object.create(core.AbstractFilter.prototype);
	TwistFilter.prototype.constructor = TwistFilter;
	module.exports = TwistFilter;
	
	Object.defineProperties(TwistFilter.prototype, {
	    /**
	     * This point describes the the offset of the twist.
	     *
	     * @member {PIXI.Point}
	     * @memberof PIXI.filters.TwistFilter#
	     */
	    offset: {
	        get: function ()
	        {
	            return this.uniforms.offset.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.offset.value = value;
	        }
	    },
	
	    /**
	     * This radius of the twist.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.TwistFilter#
	     */
	    radius: {
	        get: function ()
	        {
	            return this.uniforms.radius.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.radius.value = value;
	        }
	    },
	
	    /**
	     * This angle of the twist.
	     *
	     * @member {number}
	     * @memberof PIXI.filters.TwistFilter#
	     */
	    angle: {
	        get: function ()
	        {
	            return this.uniforms.angle.value;
	        },
	        set: function (value)
	        {
	            this.uniforms.angle.value = value;
	        }
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 228 */
/*!*********************************************************!*\
  !*** ./~/pixi.js/src/interaction/InteractionManager.js ***!
  \*********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../core */ 1),
	    InteractionData = __webpack_require__(/*! ./InteractionData */ 114);
	
	// Mix interactiveTarget into core.DisplayObject.prototype
	Object.assign(
	    core.DisplayObject.prototype,
	    __webpack_require__(/*! ./interactiveTarget */ 115)
	);
	
	/**
	 * The interaction manager deals with mouse and touch events. Any DisplayObject can be interactive
	 * if its interactive parameter is set to true
	 * This manager also supports multitouch.
	 *
	 * @class
	 * @memberof PIXI.interaction
	 * @param renderer {PIXI.CanvasRenderer|PIXI.WebGLRenderer} A reference to the current renderer
	 * @param [options] {object}
	 * @param [options.autoPreventDefault=true] {boolean} Should the manager automatically prevent default browser actions.
	 * @param [options.interactionFrequency=10] {number} Frequency increases the interaction events will be checked.
	 */
	function InteractionManager(renderer, options)
	{
	    options = options || {};
	
	    /**
	     * The renderer this interaction manager works for.
	     *
	     * @member {PIXI.SystemRenderer}
	     */
	    this.renderer = renderer;
	
	    /**
	     * Should default browser actions automatically be prevented.
	     *
	     * @member {boolean}
	     * @default true
	     */
	    this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;
	
	    /**
	     * As this frequency increases the interaction events will be checked more often.
	     *
	     * @member {number}
	     * @default 10
	     */
	    this.interactionFrequency = options.interactionFrequency || 10;
	
	    /**
	     * The mouse data
	     *
	     * @member {PIXI.interaction.InteractionData}
	     */
	    this.mouse = new InteractionData();
	
	    /**
	     * An event data object to handle all the event tracking/dispatching
	     *
	     * @member {object}
	     */
	    this.eventData = {
	        stopped: false,
	        target: null,
	        type: null,
	        data: this.mouse,
	        stopPropagation:function(){
	            this.stopped = true;
	        }
	    };
	
	    /**
	     * Tiny little interactiveData pool !
	     *
	     * @member {PIXI.interaction.InteractionData[]}
	     */
	    this.interactiveDataPool = [];
	
	    /**
	     * The DOM element to bind to.
	     *
	     * @member {HTMLElement}
	     * @private
	     */
	    this.interactionDOMElement = null;
	
	    /**
	     * This property determins if mousemove and touchmove events are fired only when the cursror is over the object
	     * Setting to true will make things work more in line with how the DOM verison works.
	     * Setting to false can make things easier for things like dragging
	     * It is currently set to false as this is how pixi used to work. This will be set to true in future versions of pixi.
	     * @member {boolean}
	     * @private
	     */
	    this.moveWhenInside = false;
	    
	    /**
	     * Have events been attached to the dom element?
	     *
	     * @member {boolean}
	     * @private
	     */
	    this.eventsAdded = false;
	
	    //this will make it so that you don't have to call bind all the time
	
	    /**
	     * @member {Function}
	     */
	    this.onMouseUp = this.onMouseUp.bind(this);
	    this.processMouseUp = this.processMouseUp.bind( this );
	
	
	    /**
	     * @member {Function}
	     */
	    this.onMouseDown = this.onMouseDown.bind(this);
	    this.processMouseDown = this.processMouseDown.bind( this );
	
	    /**
	     * @member {Function}
	     */
	    this.onMouseMove = this.onMouseMove.bind( this );
	    this.processMouseMove = this.processMouseMove.bind( this );
	
	    /**
	     * @member {Function}
	     */
	    this.onMouseOut = this.onMouseOut.bind(this);
	    this.processMouseOverOut = this.processMouseOverOut.bind( this );
	
	
	    /**
	     * @member {Function}
	     */
	    this.onTouchStart = this.onTouchStart.bind(this);
	    this.processTouchStart = this.processTouchStart.bind(this);
	
	    /**
	     * @member {Function}
	     */
	    this.onTouchEnd = this.onTouchEnd.bind(this);
	    this.processTouchEnd = this.processTouchEnd.bind(this);
	
	    /**
	     * @member {Function}
	     */
	    this.onTouchMove = this.onTouchMove.bind(this);
	    this.processTouchMove = this.processTouchMove.bind(this);
	
	    /**
	     * @member {number}
	     */
	    this.last = 0;
	
	    /**
	     * The css style of the cursor that is being used
	     * @member {string}
	     */
	    this.currentCursorStyle = 'inherit';
	
	    /**
	     * Internal cached var
	     * @member {PIXI.Point}
	     * @private
	     */
	    this._tempPoint = new core.Point();
	    
	
	    /**
	     * The current resolution
	     * @member {number}
	     */
	    this.resolution = 1;
	
	    this.setTargetElement(this.renderer.view, this.renderer.resolution);
	}
	
	InteractionManager.prototype.constructor = InteractionManager;
	module.exports = InteractionManager;
	
	/**
	 * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
	 * other DOM elements on top of the renderers Canvas element. With this you'll be bale to deletegate
	 * another DOM element to receive those events.
	 *
	 * @param element {HTMLElement} the DOM element which will receive mouse and touch events.
	 * @param [resolution=1] {number} THe resolution of the new element (relative to the canvas).
	 * @private
	 */
	InteractionManager.prototype.setTargetElement = function (element, resolution)
	{
	    this.removeEvents();
	
	    this.interactionDOMElement = element;
	
	    this.resolution = resolution || 1;
	
	    this.addEvents();
	};
	
	/**
	 * Registers all the DOM events
	 *
	 * @private
	 */
	InteractionManager.prototype.addEvents = function ()
	{
	    if (!this.interactionDOMElement)
	    {
	        return;
	    }
	
	    core.ticker.shared.add(this.update, this);
	
	    if (window.navigator.msPointerEnabled)
	    {
	        this.interactionDOMElement.style['-ms-content-zooming'] = 'none';
	        this.interactionDOMElement.style['-ms-touch-action'] = 'none';
	    }
	
	    window.document.addEventListener('mousemove',    this.onMouseMove, true);
	    this.interactionDOMElement.addEventListener('mousedown',    this.onMouseDown, true);
	    this.interactionDOMElement.addEventListener('mouseout',     this.onMouseOut, true);
	
	    this.interactionDOMElement.addEventListener('touchstart',   this.onTouchStart, true);
	    this.interactionDOMElement.addEventListener('touchend',     this.onTouchEnd, true);
	    this.interactionDOMElement.addEventListener('touchmove',    this.onTouchMove, true);
	
	    window.addEventListener('mouseup',  this.onMouseUp, true);
	
	    this.eventsAdded = true;
	};
	
	/**
	 * Removes all the DOM events that were previously registered
	 *
	 * @private
	 */
	InteractionManager.prototype.removeEvents = function ()
	{
	    if (!this.interactionDOMElement)
	    {
	        return;
	    }
	
	    core.ticker.shared.remove(this.update);
	
	    if (window.navigator.msPointerEnabled)
	    {
	        this.interactionDOMElement.style['-ms-content-zooming'] = '';
	        this.interactionDOMElement.style['-ms-touch-action'] = '';
	    }
	
	    window.document.removeEventListener('mousemove', this.onMouseMove, true);
	    this.interactionDOMElement.removeEventListener('mousedown', this.onMouseDown, true);
	    this.interactionDOMElement.removeEventListener('mouseout',  this.onMouseOut, true);
	
	    this.interactionDOMElement.removeEventListener('touchstart', this.onTouchStart, true);
	    this.interactionDOMElement.removeEventListener('touchend',  this.onTouchEnd, true);
	    this.interactionDOMElement.removeEventListener('touchmove', this.onTouchMove, true);
	
	    this.interactionDOMElement = null;
	
	    window.removeEventListener('mouseup',  this.onMouseUp, true);
	
	    this.eventsAdded = false;
	};
	
	/**
	 * Updates the state of interactive objects.
	 * Invoked by a throttled ticker update from
	 * {@link PIXI.ticker.shared}.
	 *
	 * @param deltaTime {number}
	 */
	InteractionManager.prototype.update = function (deltaTime)
	{
	    this._deltaTime += deltaTime;
	
	    if (this._deltaTime < this.interactionFrequency)
	    {
	        return;
	    }
	
	    this._deltaTime = 0;
	
	    if (!this.interactionDOMElement)
	    {
	        return;
	    }
	
	    // if the user move the mouse this check has already been dfone using the mouse move!
	    if(this.didMove)
	    {
	        this.didMove = false;
	        return;
	    }
	
	    this.cursor = 'inherit';
	
	    this.processInteractive(this.mouse.global, this.renderer._lastObjectRendered, this.processMouseOverOut, true );
	
	    if (this.currentCursorStyle !== this.cursor)
	    {
	        this.currentCursorStyle = this.cursor;
	        this.interactionDOMElement.style.cursor = this.cursor;
	    }
	
	    //TODO
	};
	
	/**
	 * Dispatches an event on the display object that was interacted with
	 *
	 * @param displayObject {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} the display object in question
	 * @param eventString {string} the name of the event (e.g, mousedown)
	 * @param eventData {object} the event data object
	 * @private
	 */
	InteractionManager.prototype.dispatchEvent = function ( displayObject, eventString, eventData )
	{
	    if(!eventData.stopped)
	    {
	        eventData.target = displayObject;
	        eventData.type = eventString;
	
	        displayObject.emit( eventString, eventData );
	
	        if( displayObject[eventString] )
	        {
	            displayObject[eventString]( eventData );
	        }
	    }
	};
	
	/**
	 * Maps x and y coords from a DOM object and maps them correctly to the pixi view. The resulting value is stored in the point.
	 * This takes into account the fact that the DOM element could be scaled and positioned anywhere on the screen.
	 *
	 * @param  {PIXI.Point} point the point that the result will be stored in
	 * @param  {number} x     the x coord of the position to map
	 * @param  {number} y     the y coord of the position to map
	 */
	InteractionManager.prototype.mapPositionToPoint = function ( point, x, y )
	{
	    var rect = this.interactionDOMElement.getBoundingClientRect();
	    point.x = ( ( x - rect.left ) * (this.interactionDOMElement.width  / rect.width  ) ) / this.resolution;
	    point.y = ( ( y - rect.top  ) * (this.interactionDOMElement.height / rect.height ) ) / this.resolution;
	};
	
	/**
	 * This function is provides a neat way of crawling through the scene graph and running a specified function on all interactive objects it finds.
	 * It will also take care of hit testing the interactive objects and passes the hit across in the function.
	 *
	 * @param  {PIXI.Point} point the point that is tested for collision
	 * @param  {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject the displayObject that will be hit test (recurcsivly crawls its children)
	 * @param  {Function} func the function that will be called on each interactive object. The displayObject and hit will be passed to the function
	 * @param  {boolean} hitTest this indicates if the objects inside should be hit test against the point
	 * @return {boolean} returns true if the displayObject hit the point
	 */
	InteractionManager.prototype.processInteractive = function (point, displayObject, func, hitTest, interactive)
	{
	    if(!displayObject || !displayObject.visible)
	    {
	        return false;
	    }
	
	    // Took a little while to rework this function correctly! But now it is done and nice and optimised. ^_^
	    // 
	    // This function will now loop through all objects and then only hit test the objects it HAS to, not all of them. MUCH faster..
	    // An object will be hit test if the following is true:
	    // 
	    // 1: It is interactive.
	    // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
	    // 
	    // As another little optimisation once an interactive object has been hit we can carry on through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
	    // A final optimisation is that an object is not hit test directly if a child has already been hit.
	    
	    var hit = false,
	        interactiveParent = interactive = displayObject.interactive || interactive;
	
	    // if the displayobject has a hitArea, then it does not need to hitTest children.
	    if(displayObject.hitArea)
	    {
	        interactiveParent = false;
	    }
	
	    // ** FREE TIP **! If an object is not interacttive or has no buttons in it (such as a game scene!) set interactiveChildren to false for that displayObject.
	    // This will allow pixi to completly ignore and bypass checking the displayObjects children.
	    if(displayObject.interactiveChildren)
	    {       
	        var children = displayObject.children;
	        
	        for (var i = children.length-1; i >= 0; i--)
	        {
	            var child = children[i];
	
	            // time to get recursive.. if this function will return if somthing is hit..
	            if(this.processInteractive(point, child, func, hitTest, interactiveParent))
	            {
	                // its a good idea to check if a child has lost its parent.
	                // this means it has been removed whilst looping so its best
	                if(!child.parent)
	                {
	                    continue;
	                }
	
	                hit = true;
	
	                // we no longer need to hit test any more objects in this container as we we now know the parent has been hit
	                interactiveParent = false;
	                
	                // If the child is interactive , that means that the object hit was actually interactive and not just the child of an interactive object. 
	                // This means we no longer need to hit test anything else. We still need to run through all objects, but we don't need to perform any hit tests.
	                //if(child.interactive)
	                //{
	                hitTest = false;
	                //}
	
	                // we can break now as we have hit an object.
	                //break;
	            }
	        }
	    }
	
	    // no point running this if the item is not interactive or does not have an interactive parent.
	    if(interactive)
	    {
	        // if we are hit testing (as in we have no hit any objects yet)
	        // We also don't need to worry about hit testing if once of the displayObjects children has already been hit!
	        if(hitTest && !hit)
	        {  
	            if(displayObject.hitArea)
	            {
	                displayObject.worldTransform.applyInverse(point,  this._tempPoint);
	                hit = displayObject.hitArea.contains( this._tempPoint.x, this._tempPoint.y );
	            }
	            else if(displayObject.containsPoint)
	            {
	                hit = displayObject.containsPoint(point);
	            }
	        }
	
	        if(displayObject.interactive)
	        {
	            func(displayObject, hit); 
	        }
	    }
	
	    return hit;
	  
	};
	
	
	/**
	 * Is called when the mouse button is pressed down on the renderer element
	 *
	 * @param event {Event} The DOM event of a mouse button being pressed down
	 * @private
	 */
	InteractionManager.prototype.onMouseDown = function (event)
	{
	    this.mouse.originalEvent = event;
	    this.eventData.data = this.mouse;
	    this.eventData.stopped = false;
	
	    // Update internal mouse reference
	    this.mapPositionToPoint( this.mouse.global, event.clientX, event.clientY);
	
	    if (this.autoPreventDefault)
	    {
	        this.mouse.originalEvent.preventDefault();
	    }
	
	    this.processInteractive(this.mouse.global, this.renderer._lastObjectRendered, this.processMouseDown, true );
	};
	
	/**
	 * Processes the result of the mouse down check and dispatches the event if need be
	 *
	 * @param displayObject {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} The display object that was tested
	 * @param hit {boolean} the result of the hit test on the dispay object
	 * @private
	 */
	InteractionManager.prototype.processMouseDown = function ( displayObject, hit )
	{
	    var e = this.mouse.originalEvent;
	    
	    var isRightButton = e.button === 2 || e.which === 3;
	
	    if(hit)
	    {
	        displayObject[ isRightButton ? '_isRightDown' : '_isLeftDown' ] = true;
	        this.dispatchEvent( displayObject, isRightButton ? 'rightdown' : 'mousedown', this.eventData );
	    }
	};
	
	
	
	/**
	 * Is called when the mouse button is released on the renderer element
	 *
	 * @param event {Event} The DOM event of a mouse button being released
	 * @private
	 */
	InteractionManager.prototype.onMouseUp = function (event)
	{
	    this.mouse.originalEvent = event;
	    this.eventData.data = this.mouse;
	    this.eventData.stopped = false;
	
	    // Update internal mouse reference
	    this.mapPositionToPoint( this.mouse.global, event.clientX, event.clientY);
	
	    this.processInteractive(this.mouse.global, this.renderer._lastObjectRendered, this.processMouseUp, true );
	};
	
	/**
	 * Processes the result of the mouse up check and dispatches the event if need be
	 *
	 * @param displayObject {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} The display object that was tested
	 * @param hit {boolean} the result of the hit test on the display object
	 * @private
	 */
	InteractionManager.prototype.processMouseUp = function ( displayObject, hit )
	{
	    var e = this.mouse.originalEvent;
	
	    var isRightButton = e.button === 2 || e.which === 3;
	    var isDown =  isRightButton ? '_isRightDown' : '_isLeftDown';
	
	    if(hit)
	    {
	        this.dispatchEvent( displayObject, isRightButton ? 'rightup' : 'mouseup', this.eventData );
	
	        if( displayObject[ isDown ] )
	        {
	            displayObject[ isDown ] = false;
	            this.dispatchEvent( displayObject, isRightButton ? 'rightclick' : 'click', this.eventData );
	        }
	    }
	    else
	    {
	        if( displayObject[ isDown ] )
	        {
	            displayObject[ isDown ] = false;
	            this.dispatchEvent( displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', this.eventData );
	        }
	    }
	};
	
	
	/**
	 * Is called when the mouse moves across the renderer element
	 *
	 * @param event {Event} The DOM event of the mouse moving
	 * @private
	 */
	InteractionManager.prototype.onMouseMove = function (event)
	{
	    this.mouse.originalEvent = event;
	    this.eventData.data = this.mouse;
	    this.eventData.stopped = false;
	
	    this.mapPositionToPoint( this.mouse.global, event.clientX, event.clientY);
	
	    this.didMove = true;
	
	    this.cursor = 'inherit';
	
	    this.processInteractive(this.mouse.global, this.renderer._lastObjectRendered, this.processMouseMove, true );
	
	    if (this.currentCursorStyle !== this.cursor)
	    {
	        this.currentCursorStyle = this.cursor;
	        this.interactionDOMElement.style.cursor = this.cursor;
	    }
	
	    //TODO BUG for parents ineractive object (border order issue)
	};
	
	/**
	 * Processes the result of the mouse move check and dispatches the event if need be
	 *
	 * @param displayObject {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} The display object that was tested
	 * @param hit {boolean} the result of the hit test on the display object
	 * @private
	 */
	InteractionManager.prototype.processMouseMove = function ( displayObject, hit )
	{
	    this.processMouseOverOut(displayObject, hit);
	    
	    // only display on mouse over
	    if(!this.moveWhenInside || hit)
	    {
	        this.dispatchEvent( displayObject, 'mousemove', this.eventData);
	    }
	};
	
	
	/**
	 * Is called when the mouse is moved out of the renderer element
	 *
	 * @param event {Event} The DOM event of a mouse being moved out
	 * @private
	 */
	InteractionManager.prototype.onMouseOut = function (event)
	{
	    this.mouse.originalEvent = event;
	    this.eventData.stopped = false;
	
	    // Update internal mouse reference
	    this.mapPositionToPoint( this.mouse.global, event.clientX, event.clientY);
	
	    this.interactionDOMElement.style.cursor = 'inherit';
	
	    // TODO optimize by not check EVERY TIME! maybe half as often? //
	    this.mapPositionToPoint( this.mouse.global, event.clientX, event.clientY );
	
	    this.processInteractive( this.mouse.global, this.renderer._lastObjectRendered, this.processMouseOverOut, false );
	};
	
	/**
	 * Processes the result of the mouse over/out check and dispatches the event if need be
	 *
	 * @param displayObject {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} The display object that was tested
	 * @param hit {boolean} the result of the hit test on the display object
	 * @private
	 */
	InteractionManager.prototype.processMouseOverOut = function ( displayObject, hit )
	{
	    if(hit)
	    {
	        if(!displayObject._over)
	        {
	            displayObject._over = true;
	            this.dispatchEvent( displayObject, 'mouseover', this.eventData );
	        }
	
	        if (displayObject.buttonMode)
	        {
	            this.cursor = displayObject.defaultCursor;
	        }
	    }
	    else
	    {
	        if(displayObject._over)
	        {
	            displayObject._over = false;
	            this.dispatchEvent( displayObject, 'mouseout', this.eventData);
	        }
	    }
	};
	
	
	/**
	 * Is called when a touch is started on the renderer element
	 *
	 * @param event {Event} The DOM event of a touch starting on the renderer view
	 * @private
	 */
	InteractionManager.prototype.onTouchStart = function (event)
	{
	    if (this.autoPreventDefault)
	    {
	        event.preventDefault();
	    }
	
	    var changedTouches = event.changedTouches;
	    var cLength = changedTouches.length;
	
	    for (var i=0; i < cLength; i++)
	    {
	        var touchEvent = changedTouches[i];
	        //TODO POOL
	        var touchData = this.getTouchData( touchEvent );
	
	        touchData.originalEvent = event;
	
	        this.eventData.data = touchData;
	        this.eventData.stopped = false;
	
	        this.processInteractive( touchData.global, this.renderer._lastObjectRendered, this.processTouchStart, true );
	
	        this.returnTouchData( touchData );
	    }
	};
	
	/**
	 * Processes the result of a touch check and dispatches the event if need be
	 *
	 * @param displayObject {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} The display object that was tested
	 * @param hit {boolean} the result of the hit test on the display object
	 * @private
	 */
	InteractionManager.prototype.processTouchStart = function ( displayObject, hit )
	{
	    if(hit)
	    {
	        displayObject._touchDown = true;
	        this.dispatchEvent( displayObject, 'touchstart', this.eventData );
	    }
	};
	
	
	/**
	 * Is called when a touch ends on the renderer element
	 *
	 * @param event {Event} The DOM event of a touch ending on the renderer view
	 */
	InteractionManager.prototype.onTouchEnd = function (event)
	{
	    if (this.autoPreventDefault)
	    {
	        event.preventDefault();
	    }
	
	    var changedTouches = event.changedTouches;
	    var cLength = changedTouches.length;
	
	    for (var i=0; i < cLength; i++)
	    {
	        var touchEvent = changedTouches[i];
	
	        var touchData = this.getTouchData( touchEvent );
	
	        touchData.originalEvent = event;
	
	        //TODO this should be passed along.. no set
	        this.eventData.data = touchData;
	        this.eventData.stopped = false;
	
	
	        this.processInteractive( touchData.global, this.renderer._lastObjectRendered, this.processTouchEnd, true );
	
	        this.returnTouchData( touchData );
	    }
	};
	
	/**
	 * Processes the result of the end of a touch and dispatches the event if need be
	 *
	 * @param displayObject {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} The display object that was tested
	 * @param hit {boolean} the result of the hit test on the display object
	 * @private
	 */
	InteractionManager.prototype.processTouchEnd = function ( displayObject, hit )
	{
	    if(hit)
	    {
	        this.dispatchEvent( displayObject, 'touchend', this.eventData );
	
	        if( displayObject._touchDown )
	        {
	            displayObject._touchDown = false;
	            this.dispatchEvent( displayObject, 'tap', this.eventData );
	        }
	    }
	    else
	    {
	        if( displayObject._touchDown )
	        {
	            displayObject._touchDown = false;
	            this.dispatchEvent( displayObject, 'touchendoutside', this.eventData );
	        }
	    }
	};
	
	/**
	 * Is called when a touch is moved across the renderer element
	 *
	 * @param event {Event} The DOM event of a touch moving across the renderer view
	 * @private
	 */
	InteractionManager.prototype.onTouchMove = function (event)
	{
	    if (this.autoPreventDefault)
	    {
	        event.preventDefault();
	    }
	
	    var changedTouches = event.changedTouches;
	    var cLength = changedTouches.length;
	
	    for (var i=0; i < cLength; i++)
	    {
	        var touchEvent = changedTouches[i];
	
	        var touchData = this.getTouchData( touchEvent );
	
	        touchData.originalEvent = event;
	
	        this.eventData.data = touchData;
	        this.eventData.stopped = false;
	
	        this.processInteractive( touchData.global, this.renderer._lastObjectRendered, this.processTouchMove, this.moveWhenInside );
	
	        this.returnTouchData( touchData );
	    }
	};
	
	/**
	 * Processes the result of a touch move check and dispatches the event if need be
	 *
	 * @param displayObject {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} The display object that was tested
	 * @param hit {boolean} the result of the hit test on the display object
	 * @private
	 */
	InteractionManager.prototype.processTouchMove = function ( displayObject, hit )
	{
	    if(!this.moveWhenInside || hit)
	    {
	        this.dispatchEvent( displayObject, 'touchmove', this.eventData);
	    }
	};
	
	/**
	 * Grabs an interaction data object from the internal pool
	 *
	 * @param touchEvent {EventData} The touch event we need to pair with an interactionData object
	 *
	 * @private
	 */
	InteractionManager.prototype.getTouchData = function (touchEvent)
	{
	    var touchData = this.interactiveDataPool.pop();
	
	    if(!touchData)
	    {
	        touchData = new InteractionData();
	    }
	
	    touchData.identifier = touchEvent.identifier;
	    this.mapPositionToPoint( touchData.global, touchEvent.clientX, touchEvent.clientY );
	
	    if(navigator.isCocoonJS)
	    {
	        touchData.global.x = touchData.global.x / this.resolution;
	        touchData.global.y = touchData.global.y / this.resolution;
	    }
	
	    touchEvent.globalX = touchData.global.x;
	    touchEvent.globalY = touchData.global.y;
	
	    return touchData;
	};
	
	/**
	 * Returns an interaction data object to the internal pool
	 *
	 * @param touchData {PIXI.interaction.InteractionData} The touch data object we want to return to the pool
	 *
	 * @private
	 */
	InteractionManager.prototype.returnTouchData = function ( touchData )
	{
	    this.interactiveDataPool.push( touchData );
	};
	
	/**
	 * Destroys the interaction manager
	 *
	 */
	InteractionManager.prototype.destroy = function () {
	    this.removeEvents();
	
	    this.renderer = null;
	
	    this.mouse = null;
	
	    this.eventData = null;
	
	    this.interactiveDataPool = null;
	
	    this.interactionDOMElement = null;
	
	    this.onMouseUp = null;
	    this.processMouseUp = null;
	
	
	    this.onMouseDown = null;
	    this.processMouseDown = null;
	
	    this.onMouseMove = null;
	    this.processMouseMove = null;
	
	    this.onMouseOut = null;
	    this.processMouseOverOut = null;
	
	
	    this.onTouchStart = null;
	    this.processTouchStart = null;
	
	    this.onTouchEnd = null;
	    this.processTouchEnd = null;
	
	    this.onTouchMove = null;
	    this.processTouchMove = null;
	
	    this._tempPoint = null;
	};
	
	core.WebGLRenderer.registerPlugin('interaction', InteractionManager);
	core.CanvasRenderer.registerPlugin('interaction', InteractionManager);


/***/ },
/* 229 */
/*!********************************************!*\
  !*** ./~/pixi.js/src/interaction/index.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @file        Main export of the PIXI interactions library
	 * @author      Mat Groves <mat@goodboydigital.com>
	 * @copyright   2013-2015 GoodBoyDigital
	 * @license     {@link https://github.com/pixijs/pixi.js/blob/master/LICENSE|MIT License}
	 */
	
	/**
	 * @namespace PIXI.interaction
	 */
	module.exports = {
	    InteractionData:    __webpack_require__(/*! ./InteractionData */ 114),
	    InteractionManager: __webpack_require__(/*! ./InteractionManager */ 228),
	    interactiveTarget:  __webpack_require__(/*! ./interactiveTarget */ 115)
	};


/***/ },
/* 230 */
/*!****************************************!*\
  !*** ./~/pixi.js/src/loaders/index.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @file        Main export of the PIXI loaders library
	 * @author      Mat Groves <mat@goodboydigital.com>
	 * @copyright   2013-2015 GoodBoyDigital
	 * @license     {@link https://github.com/pixijs/pixi.js/blob/master/LICENSE|MIT License}
	 */
	
	/**
	 * @namespace PIXI.loaders
	 */
	module.exports = {
	    Loader:             __webpack_require__(/*! ./loader */ 231),
	
	    // parsers
	    bitmapFontParser:   __webpack_require__(/*! ./bitmapFontParser */ 116),
	    spritesheetParser:  __webpack_require__(/*! ./spritesheetParser */ 117),
	    textureParser:      __webpack_require__(/*! ./textureParser */ 118),
	    Resource:           __webpack_require__(/*! resource-loader */ 53).Resource
	};


/***/ },
/* 231 */
/*!*****************************************!*\
  !*** ./~/pixi.js/src/loaders/loader.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var ResourceLoader = __webpack_require__(/*! resource-loader */ 53),
	    textureParser = __webpack_require__(/*! ./textureParser */ 118),
	    spritesheetParser = __webpack_require__(/*! ./spritesheetParser */ 117),
	    bitmapFontParser = __webpack_require__(/*! ./bitmapFontParser */ 116);
	
	/**
	 *
	 * The new loader, extends Resource Loader by Chad Engler : https://github.com/englercj/resource-loader
	 *
	 * ```js
	 * var loader = PIXI.loader; // pixi exposes a premade instance for you to use.
	 * //or
	 * var loader = new PIXI.loaders.Loader(); // you can also create your own if you want
	 *
	 * loader.add('bunny',"data/bunny.png");
	 *
	 * loader.once('complete',onAssetsLoaded);
	 *
	 * loader.load();
	 * ```
	 *
	 * @class
	 * @extends PIXI.ResourceLoader
	 * @memberof PIXI.loaders
	 * @param [baseUrl=''] {string} The base url for all resources loaded by this loader.
	 * @param [concurrency=10] {number} The number of resources to load concurrently.
	 */
	function Loader(baseUrl, concurrency)
	{
	    ResourceLoader.call(this, baseUrl, concurrency);
	
	    for (var i = 0; i < Loader._pixiMiddleware.length; ++i) {
	        this.use(Loader._pixiMiddleware[i]());
	    }
	}
	
	Loader.prototype = Object.create(ResourceLoader.prototype);
	Loader.prototype.constructor = Loader;
	
	module.exports = Loader;
	
	Loader._pixiMiddleware = [
	    // parse any blob into more usable objects (e.g. Image)
	    ResourceLoader.middleware.parsing.blob,
	    // parse any Image objects into textures
	    textureParser,
	    // parse any spritesheet data into multiple textures
	    spritesheetParser,
	    // parse any spritesheet data into multiple textures
	    bitmapFontParser
	];
	
	Loader.addPixiMiddleware = function (fn) {
	    Loader._pixiMiddleware.push(fn);
	};
	
	// Add custom extentions
	var Resource = ResourceLoader.Resource;
	
	Resource.setExtensionXhrType('fnt', Resource.XHR_RESPONSE_TYPE.DOCUMENT);


/***/ },
/* 232 */
/*!*************************************!*\
  !*** ./~/pixi.js/src/mesh/Plane.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var Mesh = __webpack_require__(/*! ./Mesh */ 43);
	
	/**
	 * The Plane allows you to draw a texture across several points and them manipulate these points
	 *
	 *```js
	 * for (var i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * var Plane = new PIXI.Plane(PIXI.Texture.fromImage("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.mesh.Mesh
	 * @memberof PIXI.mesh
	 * @param {PIXI.Texture} texture - The texture to use on the Plane.
	 * @param {int} segmentsX - The number ox x segments
	 * @param {int} segmentsY - The number of y segments
	 *
	 */
	function Plane(texture, segmentsX, segmentsY)
	{
	    Mesh.call(this, texture);
	
	    /**
	     * Tracker for if the Plane is ready to be drawn. Needed because Mesh ctor can
	     * call _onTextureUpdated which could call refresh too early.
	     *
	     * @member {boolean}
	     * @private
	     */
	    this._ready = true;
	
	    this.segmentsX =  segmentsX || 10;
	    this.segmentsY = segmentsY || 10;
	
	    this.drawMode = Mesh.DRAW_MODES.TRIANGLES;
	    this.refresh();
	
	}
	
	
	// constructor
	Plane.prototype = Object.create( Mesh.prototype );
	Plane.prototype.constructor = Plane;
	module.exports = Plane;
	
	/**
	 * Refreshes
	 *
	 */
	Plane.prototype.refresh = function()
	{
	    var total = this.segmentsX * this.segmentsY;
	    var verts = [];
	    var colors = [];
	    var uvs = [];
	    var indices = [];
	    var texture = this.texture;
	
	  //  texture.width = 800 texture.width || 800;
	 //   texture.height = 800//texture.height || 800;
	
	    var segmentsXSub = this.segmentsX - 1;
	    var segmentsYSub = this.segmentsY - 1;
	    var i = 0;
	
	    var sizeX = texture.width / segmentsXSub;
	    var sizeY = texture.height / segmentsYSub;
	
	    for (i = 0; i < total; i++) {
	
	        var x = (i % this.segmentsX);
	        var y = ( (i / this.segmentsX ) | 0 );
	
	
	        verts.push((x * sizeX),
	                   (y * sizeY));
	
	        // this works for rectangular textures. 
	        uvs.push(texture._uvs.x0 + (texture._uvs.x1 - texture._uvs.x0) * (x / (this.segmentsX-1)), texture._uvs.y0 + (texture._uvs.y3-texture._uvs.y0) * (y/ (this.segmentsY-1)));
	      }
	
	    //  cons
	
	    var totalSub = segmentsXSub * segmentsYSub;
	
	    for (i = 0; i < totalSub; i++) {
	
	        var xpos = i % segmentsXSub;
	        var ypos = (i / segmentsXSub ) | 0;
	
	
	        var  value = (ypos * this.segmentsX) + xpos;
	        var  value2 = (ypos * this.segmentsX) + xpos + 1;
	        var  value3 = ((ypos+1) * this.segmentsX) + xpos;
	        var  value4 = ((ypos+1) * this.segmentsX) + xpos + 1;
	
	        indices.push(value, value2, value3);
	        indices.push(value2, value4, value3);
	    }
	
	
	    //console.log(indices)
	    this.vertices = new Float32Array(verts);
	    this.uvs = new Float32Array(uvs);
	    this.colors = new Float32Array(colors);
	    this.indices = new Uint16Array(indices);
	};
	
	/**
	 * Clear texture UVs when new texture is set
	 *
	 * @private
	 */
	Plane.prototype._onTextureUpdate = function ()
	{
	    Mesh.prototype._onTextureUpdate.call(this);
	
	    // wait for the Plane ctor to finish before calling refresh
	    if (this._ready) {
	        this.refresh();
	    }
	};


/***/ },
/* 233 */
/*!************************************!*\
  !*** ./~/pixi.js/src/mesh/Rope.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	var Mesh = __webpack_require__(/*! ./Mesh */ 43);
	var core = __webpack_require__(/*! ../core */ 1);
	
	/**
	 * The rope allows you to draw a texture across several points and them manipulate these points
	 *
	 *```js
	 * for (var i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * var rope = new PIXI.Rope(PIXI.Texture.fromImage("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.mesh.Mesh
	 * @memberof PIXI.mesh
	 * @param {PIXI.Texture} texture - The texture to use on the rope.
	 * @param {PIXI.Point[]} points - An array of {@link PIXI.Point} objects to construct this rope.
	 *
	 */
	function Rope(texture, points)
	{
	    Mesh.call(this, texture);
	
	    /*
	     * @member {PIXI.Point[]} An array of points that determine the rope
	     */
	    this.points = points;
	
	    /*
	     * @member {Float32Array} An array of vertices used to construct this rope.
	     */
	    this.vertices = new Float32Array(points.length * 4);
	
	    /*
	     * @member {Float32Array} The WebGL Uvs of the rope.
	     */
	    this.uvs = new Float32Array(points.length * 4);
	
	    /*
	     * @member {Float32Array} An array containing the color components
	     */
	    this.colors = new Float32Array(points.length * 2);
	
	    /*
	     * @member {Uint16Array} An array containing the indices of the vertices
	     */
	    this.indices = new Uint16Array(points.length * 2);
	
	    /**
	     * Tracker for if the rope is ready to be drawn. Needed because Mesh ctor can
	     * call _onTextureUpdated which could call refresh too early.
	     *
	     * @member {boolean}
	     * @private
	     */
	     this._ready = true;
	
	     this.refresh();
	}
	
	
	// constructor
	Rope.prototype = Object.create(Mesh.prototype);
	Rope.prototype.constructor = Rope;
	module.exports = Rope;
	
	/**
	 * Refreshes
	 *
	 */
	Rope.prototype.refresh = function ()
	{
	    var points = this.points;
	
	    // if too little points, or texture hasn't got UVs set yet just move on.
	    if (points.length < 1 || !this._texture._uvs)
	    {
	        return;
	    }
	
	    var uvs = this.uvs;
	
	    var indices = this.indices;
	    var colors = this.colors;
	
	    var textureUvs = this._texture._uvs;
	    var offset = new core.Point(textureUvs.x0, textureUvs.y0);
	    var factor = new core.Point(textureUvs.x2 - textureUvs.x0, textureUvs.y2 - textureUvs.y0);
	
	    uvs[0] = 0 + offset.x;
	    uvs[1] = 0 + offset.y;
	    uvs[2] = 0 + offset.x;
	    uvs[3] = 1 * factor.y + offset.y;
	
	    colors[0] = 1;
	    colors[1] = 1;
	
	    indices[0] = 0;
	    indices[1] = 1;
	
	    var total = points.length,
	        point, index, amount;
	
	    for (var i = 1; i < total; i++)
	    {
	        point = points[i];
	        index = i * 4;
	        // time to do some smart drawing!
	        amount = i / (total-1);
	
	        uvs[index] = amount * factor.x + offset.x;
	        uvs[index+1] = 0 + offset.y;
	
	        uvs[index+2] = amount * factor.x + offset.x;
	        uvs[index+3] = 1 * factor.y + offset.y;
	
	        index = i * 2;
	        colors[index] = 1;
	        colors[index+1] = 1;
	
	        index = i * 2;
	        indices[index] = index;
	        indices[index + 1] = index + 1;
	    }
	
	    this.dirty = true;
	};
	
	/**
	 * Clear texture UVs when new texture is set
	 *
	 * @private
	 */
	Rope.prototype._onTextureUpdate = function ()
	{
	    Mesh.prototype._onTextureUpdate.call(this);
	
	    // wait for the Rope ctor to finish before calling refresh
	    if (this._ready) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates the object transform for rendering
	 *
	 * @private
	 */
	Rope.prototype.updateTransform = function ()
	{
	    var points = this.points;
	
	    if (points.length < 1)
	    {
	        return;
	    }
	
	    var lastPoint = points[0];
	    var nextPoint;
	    var perpX = 0;
	    var perpY = 0;
	
	    // this.count -= 0.2;
	
	    var vertices = this.vertices;
	    var total = points.length,
	        point, index, ratio, perpLength, num;
	
	    for (var i = 0; i < total; i++)
	    {
	        point = points[i];
	        index = i * 4;
	
	        if (i < points.length-1)
	        {
	            nextPoint = points[i+1];
	        }
	        else
	        {
	            nextPoint = point;
	        }
	
	        perpY = -(nextPoint.x - lastPoint.x);
	        perpX = nextPoint.y - lastPoint.y;
	
	        ratio = (1 - (i / (total-1))) * 10;
	
	        if (ratio > 1)
	        {
	            ratio = 1;
	        }
	
	        perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
	        num = this._texture.height / 2; //(20 + Math.abs(Math.sin((i + this.count) * 0.3) * 50) )* ratio;
	        perpX /= perpLength;
	        perpY /= perpLength;
	
	        perpX *= num;
	        perpY *= num;
	
	        vertices[index] = point.x + perpX;
	        vertices[index+1] = point.y + perpY;
	        vertices[index+2] = point.x - perpX;
	        vertices[index+3] = point.y - perpY;
	
	        lastPoint = point;
	    }
	
	    this.containerUpdateTransform();
	};


/***/ },
/* 234 */
/*!**************************************************!*\
  !*** ./~/pixi.js/src/mesh/webgl/MeshRenderer.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../../core */ 1),
	    Mesh = __webpack_require__(/*! ../Mesh */ 43);
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original pixi version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's MeshRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/MeshRenderer.java
	 */
	
	/**
	 *
	 * @class
	 * @private
	 * @memberof PIXI.mesh
	 * @extends PIXI.ObjectRenderer
	 * @param renderer {PIXI.WebGLRenderer} The renderer this sprite batch works for.
	 */
	function MeshRenderer(renderer)
	{
	    core.ObjectRenderer.call(this, renderer);
	
	
	    /**
	     * Holds the indices
	     *
	     * @member {Uint16Array}
	     */
	    
	    this.indices = new Uint16Array(15000);
	
	    //TODO this could be a single buffer shared amongst all renderers as we reuse this set up in most renderers
	    for (var i=0, j=0; i < 15000; i += 6, j += 4)
	    {
	        this.indices[i + 0] = j + 0;
	        this.indices[i + 1] = j + 1;
	        this.indices[i + 2] = j + 2;
	        this.indices[i + 3] = j + 0;
	        this.indices[i + 4] = j + 2;
	        this.indices[i + 5] = j + 3;
	    }
	
	    this.currentShader = null;
	}
	
	MeshRenderer.prototype = Object.create(core.ObjectRenderer.prototype);
	MeshRenderer.prototype.constructor = MeshRenderer;
	module.exports = MeshRenderer;
	
	core.WebGLRenderer.registerPlugin('mesh', MeshRenderer);
	
	/**
	 * Sets up the renderer context and necessary buffers.
	 *
	 * @private
	 * @param gl {WebGLRenderingContext} the current WebGL drawing context
	 */
	MeshRenderer.prototype.onContextChange = function ()
	{
	
	};
	
	/**
	 * Renders the sprite object.
	 *
	 * @param mesh {PIXI.mesh.Mesh} the mesh to render
	 */
	MeshRenderer.prototype.render = function (mesh)
	{
	    if(!mesh._vertexBuffer)
	    {
	        this._initWebGL(mesh);
	    }
	
	    var renderer = this.renderer,
	        gl = renderer.gl,
	        texture = mesh._texture.baseTexture,
	        shader = mesh.shader;// || renderer.shaderManager.plugins.meshShader;
	
	    var drawMode = mesh.drawMode === Mesh.DRAW_MODES.TRIANGLE_MESH ? gl.TRIANGLE_STRIP : gl.TRIANGLES;
	
	    renderer.blendModeManager.setBlendMode(mesh.blendMode);
	
	    //TODO cache custom state..
	    if (!shader)
	    {
	        shader = renderer.shaderManager.plugins.meshShader;
	    }
	    else
	    {
	        shader = shader.shaders[gl.id] || shader.getShader(renderer);// : shader;
	    }
	
	    this.renderer.shaderManager.setShader(shader);
	
	    shader.uniforms.translationMatrix.value = mesh.worldTransform.toArray(true);
	    shader.uniforms.projectionMatrix.value = renderer.currentRenderTarget.projectionMatrix.toArray(true);
	    shader.uniforms.alpha.value = mesh.worldAlpha;
	
	    shader.syncUniforms();
	
	    if (!mesh.dirty)
	    {
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, mesh._vertexBuffer);
	        gl.bufferSubData(gl.ARRAY_BUFFER, 0, mesh.vertices);
	        gl.vertexAttribPointer(shader.attributes.aVertexPosition, 2, gl.FLOAT, false, 0, 0);
	
	        // update the uvs
	        gl.bindBuffer(gl.ARRAY_BUFFER, mesh._uvBuffer);
	        gl.vertexAttribPointer(shader.attributes.aTextureCoord, 2, gl.FLOAT, false, 0, 0);
	
	
	        gl.activeTexture(gl.TEXTURE0);
	
	       if (!texture._glTextures[gl.id])
	        {
	            this.renderer.updateTexture(texture);
	        }
	        else
	        {
	            // bind the current texture
	            gl.bindTexture(gl.TEXTURE_2D, texture._glTextures[gl.id]);
	        }
	
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, mesh._indexBuffer);
	        gl.bufferSubData(gl.ELEMENT_ARRAY_BUFFER, 0, mesh.indices);
	    }
	    else
	    {
	
	        mesh.dirty = false;
	        gl.bindBuffer(gl.ARRAY_BUFFER, mesh._vertexBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, mesh.vertices, gl.STATIC_DRAW);
	        gl.vertexAttribPointer(shader.attributes.aVertexPosition, 2, gl.FLOAT, false, 0, 0);
	
	        // update the uvs
	        gl.bindBuffer(gl.ARRAY_BUFFER, mesh._uvBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, mesh.uvs, gl.STATIC_DRAW);
	        gl.vertexAttribPointer(shader.attributes.aTextureCoord, 2, gl.FLOAT, false, 0, 0);
	
	         gl.activeTexture(gl.TEXTURE0);
	
	        if (!texture._glTextures[gl.id])
	        {
	            this.renderer.updateTexture(texture);
	        }
	        else
	        {
	            // bind the current texture
	            gl.bindTexture(gl.TEXTURE_2D, texture._glTextures[gl.id]);
	        }
	
	        // dont need to upload!
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, mesh._indexBuffer);
	        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, mesh.indices, gl.STATIC_DRAW);
	
	    }
	
	    gl.drawElements(drawMode, mesh.indices.length, gl.UNSIGNED_SHORT, 0);
	
	};
	
	/**
	 * Prepares all the buffers to render this mesh
	 * @param mesh {PIXI.mesh.Mesh} the mesh to render
	 */
	MeshRenderer.prototype._initWebGL = function (mesh)
	{
	    // build the strip!
	    var gl = this.renderer.gl;
	
	    mesh._vertexBuffer = gl.createBuffer();
	    mesh._indexBuffer = gl.createBuffer();
	    mesh._uvBuffer = gl.createBuffer();
	
	
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, mesh._vertexBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, mesh.vertices, gl.DYNAMIC_DRAW);
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, mesh._uvBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER,  mesh.uvs, gl.STATIC_DRAW);
	
	    if(mesh.colors){
	        mesh._colorBuffer = gl.createBuffer();
	        gl.bindBuffer(gl.ARRAY_BUFFER, mesh._colorBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, mesh.colors, gl.STATIC_DRAW);
	    }
	
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, mesh._indexBuffer);
	    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, mesh.indices, gl.STATIC_DRAW);
	};
	
	
	/**
	 * Empties the current batch.
	 *
	 */
	MeshRenderer.prototype.flush = function ()
	{
	
	};
	
	/**
	 * Starts a new mesh renderer.
	 *
	 */
	MeshRenderer.prototype.start = function ()
	{
	    
	
	    this.currentShader = null;
	};
	
	/**
	 * Destroys the Mesh renderer
	 *
	 */
	MeshRenderer.prototype.destroy = function ()
	{
	    core.ObjectRenderer.prototype.destroy.call(this);
	};


/***/ },
/* 235 */
/*!************************************************!*\
  !*** ./~/pixi.js/src/mesh/webgl/MeshShader.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(/*! ../../core */ 1);
	
	/**
	 * @class
	 * @extends PIXI.Shader
	 * @memberof PIXI.mesh
	 * @param shaderManager {PIXI.ShaderManager} The WebGL shader manager this shader works for.
	 */
	function MeshShader(shaderManager)
	{
	    core.Shader.call(this,
	        shaderManager,
	        // vertex shader
	        [
	            'precision lowp float;',
	            'attribute vec2 aVertexPosition;',
	            'attribute vec2 aTextureCoord;',
	
	            'uniform mat3 translationMatrix;',
	            'uniform mat3 projectionMatrix;',
	
	            'varying vec2 vTextureCoord;',
	
	            'void main(void){',
	            '   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);',
	            '   vTextureCoord = aTextureCoord;',
	            '}'
	        ].join('\n'),
	        [
	            'precision lowp float;',
	
	            'varying vec2 vTextureCoord;',
	            'uniform float alpha;',
	
	            'uniform sampler2D uSampler;',
	
	            'void main(void){',
	            '   gl_FragColor = texture2D(uSampler, vTextureCoord) * alpha ;',
	            '}'
	        ].join('\n'),
	        // custom uniforms
	        {
	            alpha:  { type: '1f', value: 0 },
	            translationMatrix: { type: 'mat3', value: new Float32Array(9) },
	            projectionMatrix: { type: 'mat3', value: new Float32Array(9) }
	        },
	        // custom attributes
	        {
	            aVertexPosition:0,
	            aTextureCoord:0
	        }
	    );
	}
	
	MeshShader.prototype = Object.create(core.Shader.prototype);
	MeshShader.prototype.constructor = MeshShader;
	module.exports = MeshShader;
	
	core.ShaderManager.registerPlugin('meshShader', MeshShader);


/***/ },
/* 236 */
/*!*********************************************!*\
  !*** ./~/pixi.js/src/polyfill/Math.sign.js ***!
  \*********************************************/
/***/ function(module, exports) {

	// References:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
	
	if (!Math.sign)
	{
	    Math.sign = function (x) {
	        x = +x;
	        if (x === 0 || isNaN(x))
	        {
	            return x;
	        }
	        return x > 0 ? 1 : -1;
	    };
	}


/***/ },
/* 237 */
/*!*************************************************!*\
  !*** ./~/pixi.js/src/polyfill/Object.assign.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	// References:
	// https://github.com/sindresorhus/object-assign
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	
	if (!Object.assign)
	{
	    Object.assign = __webpack_require__(/*! object-assign */ 173);
	}


/***/ },
/* 238 */
/*!*****************************************!*\
  !*** ./~/pixi.js/src/polyfill/index.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(/*! ./Object.assign */ 237);
	__webpack_require__(/*! ./requestAnimationFrame */ 239);
	__webpack_require__(/*! ./Math.sign */ 236);


/***/ },
/* 239 */
/*!*********************************************************!*\
  !*** ./~/pixi.js/src/polyfill/requestAnimationFrame.js ***!
  \*********************************************************/
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// References:
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// https://gist.github.com/1579671
	// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
	// https://gist.github.com/timhall/4078614
	// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
	
	// Expected to be used with Browserfiy
	// Browserify automatically detects the use of `global` and passes the
	// correct reference of `global`, `self`, and finally `window`
	
	// Date.now
	if (!(Date.now && Date.prototype.getTime)) {
	    Date.now = function now() {
	        return new Date().getTime();
	    };
	}
	
	// performance.now
	if (!(global.performance && global.performance.now)) {
	    var startTime = Date.now();
	    if (!global.performance) {
	        global.performance = {};
	    }
	    global.performance.now = function () {
	        return Date.now() - startTime;
	    };
	}
	
	// requestAnimationFrame
	var lastTime = Date.now();
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	
	for(var x = 0; x < vendors.length && !global.requestAnimationFrame; ++x) {
	    global.requestAnimationFrame = global[vendors[x] + 'RequestAnimationFrame'];
	    global.cancelAnimationFrame = global[vendors[x] + 'CancelAnimationFrame'] ||
	        global[vendors[x] + 'CancelRequestAnimationFrame'];
	}
	
	if (!global.requestAnimationFrame) {
	    global.requestAnimationFrame = function (callback) {
	        if (typeof callback !== 'function') {
	            throw new TypeError(callback + 'is not a function');
	        }
	
	        var currentTime = Date.now(),
	            delay = 16 + lastTime - currentTime;
	
	        if (delay < 0) {
	            delay = 0;
	        }
	
	        lastTime = currentTime;
	
	        return setTimeout(function () {
	            lastTime = Date.now();
	            callback(performance.now());
	        }, delay);
	    };
	}
	
	if (!global.cancelAnimationFrame) {
	    global.cancelAnimationFrame = function(id) {
	        clearTimeout(id);
	    };
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 240 */
/*!*********************************!*\
  !*** ./~/querystring/decode.js ***!
  \*********************************/
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 241 */
/*!*********************************!*\
  !*** ./~/querystring/encode.js ***!
  \*********************************/
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 242 */
/*!********************************!*\
  !*** ./~/querystring/index.js ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(/*! ./decode */ 240);
	exports.encode = exports.stringify = __webpack_require__(/*! ./encode */ 241);


/***/ },
/* 243 */
/*!***************************************************!*\
  !*** ./assets/js/src/components/CreditsSlide.jsx ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Share = __webpack_require__(/*! ./Share.jsx */ 123);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreditsSlide = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'CreditsSlide',
	
	  /**
	   * Timeout to show emojis
	   */
	  showTimeout: 0,
	
	  /**
	   * Expected propTypes
	   * @prop {Boolean} active - If this is the current active slide
	   * @prop {Object} cssTransforms3d - Whether the browser
	   * supports css 3d transforms
	   * @prop {Object} data - A data object
	   * @prop {Number} height - The height for the slide's style
	   * @prop {Boolean} next - If this is the next from the active slide
	   * @prop {Boolean} prev - If this is the previous from the active slide
	   * @prop {Boolean} touch - If browser supports touch events
	   * @prop {Number} yPosition - The top position for the slide's style
	   */
	  propTypes: {
	    active: _react2.default.PropTypes.bool,
	    cssTransforms3d: _react2.default.PropTypes.bool,
	    data: _react2.default.PropTypes.object.isRequired,
	    height: _react2.default.PropTypes.number,
	    next: _react2.default.PropTypes.bool,
	    prev: _react2.default.PropTypes.bool,
	    touch: _react2.default.PropTypes.bool,
	    yPosition: _react2.default.PropTypes.number
	  },
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    // const clickHandler = this.p
	    var data = this.props.data;
	    var prevClass = this.props.prev ? ' prev' : '';
	    var activeClass = this.props.active ? ' active' : '';
	    var nextClass = this.props.next ? ' next' : '';
	    var className = 'component-credits-slide slide ' + prevClass + activeClass + nextClass;
	    var style = {
	      height: this.props.height,
	      top: this.props.yPosition
	    };
	    var creditsText = data.text.split('<br/>').join(' ');
	
	    return _react2.default.createElement(
	      'div',
	      { style: style, className: className },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-wrapper' },
	        _react2.default.createElement(_Share2.default, { touch: this.props.touch }),
	        _react2.default.createElement('div', { className: 'credits', dangerouslySetInnerHTML: { __html: creditsText } })
	      )
	    );
	  }
	});
	
	exports.default = CreditsSlide;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "CreditsSlide.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 244 */
/*!*******************************************************!*\
  !*** ./assets/js/src/components/DescriptionSlide.jsx ***!
  \*******************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DescriptionSlide = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'DescriptionSlide',
	
	  /**
	   * Timeout to show emojis
	   */
	  showTimeout: 0,
	
	  /**
	   * Expected propTypes
	   * @prop {Boolean} active - If this is the current active slide
	   * @prop {Object} cssTransforms3d - Whether the browser
	   * supports css 3d transforms
	   * @prop {Object} data - A data object
	   * @prop {Number} height - The height for the slide's style
	   * @prop {Boolean} next - If this is the next from the active slide
	   * @prop {Boolean} prev - If this is the previous from the active slide
	   * @prop {Boolean} touch - If browser supports touch events
	   * @prop {Number} yPosition - The top position for the slide's style
	   */
	  propTypes: {
	    active: _react2.default.PropTypes.bool,
	    cssTransforms3d: _react2.default.PropTypes.bool,
	    data: _react2.default.PropTypes.object.isRequired,
	    height: _react2.default.PropTypes.number,
	    next: _react2.default.PropTypes.bool,
	    prev: _react2.default.PropTypes.bool,
	    touch: _react2.default.PropTypes.bool,
	    yPosition: _react2.default.PropTypes.number
	  },
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    // const clickHandler = this.p
	    var data = this.props.data;
	    var prevClass = this.props.prev ? ' prev' : '';
	    var activeClass = this.props.active ? ' active' : '';
	    var nextClass = this.props.next ? ' next' : '';
	    var className = 'component-description-slide slide ' + prevClass + activeClass + nextClass;
	    var style = {
	      height: this.props.height,
	      top: this.props.yPosition
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: style, className: className },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'text' },
	          data.text
	        )
	      )
	    );
	  }
	});
	
	exports.default = DescriptionSlide;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "DescriptionSlide.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 245 */
/*!************************************************!*\
  !*** ./assets/js/src/components/Draggable.jsx ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Draggable component
	 * @class
	 */
	var Draggable = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'Draggable',
	
	  /**
	   * Expected propTypes
	   * @prop {String} additionalClass - A string of additional classnames to add
	   * to the element
	   * @prop {Object} bounds - An array of coordinates the user cannot drag the
	   * component outside of
	   * @prop {Object} children - Child React elements
	   * @prop {String} contentPosition - The css positioning for for the element
	   * ('absolute' or 'fixed', defaults to 'absolute')
	   * @prop {Function} dragCallback - The function to call while the user is
	   * dragging
	   * @prop {Function} dragStartCallback - The function to call when the user
	   * starts dragging
	   * @prop {Function} dragStopCallback - The function to call when the user
	   * stops dragging
	   * @prop {Function} dragLeaveCallback - A function to call when the user is
	   * dragging and the mouse/touch leaves the draggable component
	   * @prop {Object} initialPosition - An object with initial x and y values for the
	   * content
	   * @prop {String} lock - An axis to lock element to when dragging, either
	   * 'x' or 'y'
	   * @prop {Boolean} preventDefaultEvents - Whether to prevent default
	   * mouse/touch events
	   * @prop {String} touchScrollLock - If set to true, prevents the content from
	   * being dragged if the user is scrolling in the opposite direction on a touchend
	   * device
	   * @prop {Boolean} translate3d - Whether to use css3 transform3d for
	   * positioning
	   */
	  propTypes: {
	    additionalClass: _react2.default.PropTypes.string,
	    bounds: _react2.default.PropTypes.object,
	    children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object]).isRequired,
	    contentPosition: _react2.default.PropTypes.string,
	    dragCallback: _react2.default.PropTypes.func,
	    dragLeaveCallback: _react2.default.PropTypes.func,
	    dragStartCallback: _react2.default.PropTypes.func,
	    dragStopCallback: _react2.default.PropTypes.func,
	    initialPosition: _react2.default.PropTypes.object,
	    lock: _react2.default.PropTypes.string,
	    preventDefaultEvents: _react2.default.PropTypes.bool,
	    touchScrollLock: _react2.default.PropTypes.bool,
	    translate3d: _react2.default.PropTypes.bool
	  },
	
	  /**
	   * Get initial state object
	   * @returns {Object} initial object
	   */
	  getInitialState: function getInitialState() {
	    var elPos = this.props.contentPosition || 'absolute';
	
	    return {
	      pos: this.props.initialPosition || { x: 0, y: 0 },
	      dragging: false,
	      rel: null,
	      enabled: true,
	      elementStyle: {
	        position: elPos
	      },
	      checkTimerStarted: false,
	      scrollLocked: false,
	      dragLocked: false
	    };
	  },
	
	
	  /**
	   * Called after component mounts to DOM
	   * @returns {undefined} undefined
	   */
	  componentDidMount: function componentDidMount() {
	    this._allowDragThreshold = 40;
	    this._mouseDownWhileDisabled = false;
	
	    if (this.props.lock && this.props.touchScrollLock) {
	      this.doSwipe = false;
	    } else {
	      this.doSwipe = true;
	    }
	
	    this._cssProperties = {
	      supported: false,
	      prefix: ''
	    };
	
	    if (typeof document.body.style.borderRadius !== 'undefined') {
	      this._cssProperties.supported = true;
	      this._cssProperties.prefix = '';
	      this._cssProperties.objectPrefix = '';
	    }
	
	    if (typeof document.body.style.MozBorderRadius !== 'undefined') {
	      this._cssProperties.supported = true;
	      this._cssProperties.prefix = '-moz-';
	      this._cssProperties.objectPrefix = 'moz';
	    }
	
	    if (typeof document.body.style.webkitBorderRadius !== 'undefined') {
	      this._cssProperties.supported = true;
	      this._cssProperties.prefix = '-webkit-';
	      this._cssProperties.objectPrefix = 'Webkit';
	    }
	
	    document.addEventListener('mousemove', this._onMouseMove);
	    document.addEventListener('touchmove', this._onMouseMove);
	
	    document.addEventListener('mouseup', this._onMouseUp);
	    document.addEventListener('touchend', this._onMouseUp);
	  },
	
	
	  /**
	   * Called before component is removed from the DOM
	   * @returns {undefined} undefined
	   */
	  componentWillUnmount: function componentWillUnmount() {
	    document.removeEventListener('mousemove', this._onMouseMove);
	    document.removeEventListener('touchmove', this._onMouseMove);
	
	    document.removeEventListener('mouseup', this._onMouseUp);
	    document.removeEventListener('touchend', this._onMouseUp);
	  },
	
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    var _this = this;
	    var className = 'component-draggable';
	    if (this.props.additionalClass) {
	      className = 'component-draggable ' + this.props.additionalClass;
	    }
	
	    var renderedChildren = _react2.default.Children.map(this.props.children, function (child) {
	      var newStyle = {};
	      var childStyle = {};
	      if (child.props && child.props.style) {
	        childStyle = child.props.style;
	      }
	      var elementStyle = {};
	      if (_this.state && _this.state.elementStyle) {
	        elementStyle = _this.state.elementStyle;
	      }
	
	      if (_this.state.dragging && _this.state.enabled) {
	        newStyle = Object.assign(childStyle, elementStyle);
	      } else {
	        newStyle = Object.assign(elementStyle, childStyle);
	      }
	
	      return _react2.default.cloneElement(child, {
	        style: newStyle,
	        ref: 'draggableChild'
	      });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onTouchStart: this._onMouseDown,
	        onTouchLeave: this._onMouseOut,
	        onMouseDown: this._onMouseDown,
	        onMouseOut: this._onMouseOut
	      },
	      renderedChildren
	    );
	  },
	
	
	  /**
	   * Enables or disables the element's draggability
	   * @param {Boolean} enabled Whether the draggable object should be enabled
	    * @returns {undefined} undefined
	   */
	  setEnabled: function setEnabled(enabled) {
	    this.setState({
	      enabled: enabled
	    });
	  },
	
	
	  /**
	   * Sets the element's style
	   * @param {Object} style An object key/value style attributes
	    * @returns {undefined} undefined
	   */
	  setStyle: function setStyle(style) {
	    var oldStyle = Object.assign({}, this.state.elementStyle);
	    var newStyle = Object.assign(oldStyle, style);
	
	    this.setState({
	      elementStyle: newStyle
	    });
	  },
	
	
	  /**
	   * Positions the draggable element
	   * @param {Object} pos - An object with x and y position values
	   * @param {Function} callback - An optional callback
	   * @returns {undefined} undefined
	   */
	  setPosition: function setPosition(pos, callback) {
	    var _this = this;
	
	    this.setState({
	      pos: pos
	    }, function () {
	      _this.positionContent();
	
	      if (callback) {
	        callback(_this.state.pos);
	      }
	    });
	  },
	
	
	  /**
	   * Gets the draggable element position
	   * @returns {Object} pos - An object with x and y position values
	   */
	  getPosition: function getPosition() {
	    return this.state.pos;
	  },
	
	
	  /**
	   * Positions the draggable element
	   * @returns {undefined} undefined
	   */
	  positionContent: function positionContent() {
	    var positionTransformString = 'translate(' + this.state.pos.x + 'px,' + this.state.pos.y + 'px)';
	    if (this.props.translate3d) {
	      positionTransformString = 'translate3d(' + this.state.pos.x + 'px ,' + this.state.pos.y + 'px, 0px)';
	    }
	
	    if (this.props.lock === 'x') {
	      positionTransformString = 'translate(' + this.state.pos.x + 'px, 0px)';
	      if (this.props.translate3d) {
	        positionTransformString = 'translate3d(' + this.state.pos.x + 'px, 0px, 0px)';
	      }
	    }
	
	    if (this.props.lock === 'y') {
	      positionTransformString = 'translate(0px, ' + this.state.pos.y + 'px)';
	      if (this.props.translate3d) {
	        positionTransformString = 'translate3d(0px, ' + this.state.pos.y + 'px, 0px)';
	      }
	    }
	
	    var transformStyle = {
	      msTransform: positionTransformString,
	      WebkitTransform: positionTransformString,
	      MozTransform: positionTransformString,
	      transform: positionTransformString
	    };
	
	    var oldStyle = Object.assign({}, this.state.elementStyle);
	    var newStyle = Object.assign(oldStyle, transformStyle);
	
	    this.setState({
	      elementStyle: newStyle
	    });
	  },
	
	
	  /**
	   * Called when the user's mouse is pressed
	   * @param {Event} e A mousedown event
	   * @returns {undefined} undefined
	   */
	  _onMouseDown: function _onMouseDown(e) {
	    this.mouseDownOnElement = true;
	
	    if (this.state.enabled) {
	      var transformValues = this._parseTransformValues(this.refs.draggableChild);
	      var xVal = Number(transformValues[0]);
	      var yVal = Number(transformValues[1]);
	      var pageX = e.clientX;
	      var pageY = e.clientY;
	
	      this._mouseDownWhileDisabled = false;
	
	      if (this.props.translate3d) {
	        xVal = Number(transformValues[1]);
	      }
	
	      if (this.props.translate3d) {
	        yVal = Number(transformValues[2]);
	      }
	
	      if (isNaN(xVal)) {
	        xVal = 0;
	      }
	
	      if (isNaN(yVal)) {
	        yVal = 0;
	      }
	
	      if (e.type !== 'mousedown') {
	        pageX = e.changedTouches[0].clientX;
	        pageY = e.changedTouches[0].clientY;
	      }
	
	      this.setState({
	        scrollLocked: false,
	        checkTimerStarted: true,
	        dragging: true,
	        rel: {
	          inputX: pageX,
	          inputY: pageY,
	          contentX: xVal,
	          contentY: yVal
	        }
	      });
	
	      if (this.props.dragStartCallback) {
	        this.props.dragStartCallback({
	          x: xVal,
	          y: yVal
	        }, e);
	      }
	    } else {
	      this._mouseDownWhileDisabled = true;
	    }
	
	    if (this.props.preventDefaultEvents) {
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  },
	
	
	  /**
	   * Called when the user's mouse is moved
	   * @param {Event} e A mousemove event
	   * @returns {undefined} undefined
	   */
	  _onMouseMove: function _onMouseMove(e) {
	    if (this.mouseDownOnElement) {
	      var transformValues = this._parseTransformValues(this.refs.draggableChild);
	      var xVal = Number(transformValues[0]);
	      var yVal = Number(transformValues[1]);
	      var pageX = e.clientX;
	      var pageY = e.clientY;
	      var difX = 0;
	      var difY = 0;
	
	      if (this.props.translate3d) {
	        xVal = Number(transformValues[1]);
	      }
	
	      if (this.props.translate3d) {
	        yVal = Number(transformValues[2]);
	      }
	
	      if (isNaN(xVal)) {
	        xVal = 0;
	      }
	
	      if (isNaN(yVal)) {
	        yVal = 0;
	      }
	
	      if (!this.state.dragging) {
	        return;
	      }
	
	      if (e.type !== 'mousemove') {
	        pageX = e.changedTouches[0].clientX;
	        pageY = e.changedTouches[0].clientY;
	      }
	
	      // If the dragging is locked to the 'x' or 'y' axis,
	      // and the user is dragging (or scrolling on mobile) the opposite axis,
	      // stop any dragging. This is so the content doesn't move when a user is
	      // scrolling on a mobile device.
	      if (this.props.touchScrollLock && (this.props.lock === 'x' || this.props.lock === 'y')) {
	        difY = pageY - this.state.rel.inputY;
	        difX = pageX - this.state.rel.inputX;
	
	        if (difY < 0) {
	          difY *= -1;
	        }
	
	        if (difX < 0) {
	          difX *= -1;
	        }
	
	        if (this.props.lock === 'x') {
	          // if the content is locked to dragging horizontally
	          if (difX > difY) {
	            // if the user is intending to swipe horizontally
	            if (difX > 10 && !this.state.scrollLocked) {
	              this.doSwipe = true;
	              this.setState({ dragLocked: true });
	            }
	          } else {
	            // if the user is intending to swipe vertically
	            if (!this.state.dragLocked) {
	              this.setState({ scrollLocked: true });
	            }
	          }
	        } else {
	          // if the content is locked to dragging vertically
	          if (difY > difX) {
	            // if the user is intending to swipe vertically
	            if (difY > 10 && !this.state.scrollLocked) {
	              this.doSwipe = true;
	              this.setState({ dragLocked: true });
	            }
	          } else {
	            // if the user is intending to swipe horizontally
	            if (!this.state.dragLocked) {
	              this.setState({ scrollLocked: true });
	            }
	          }
	        }
	      }
	
	      if (this.doSwipe && !this.state.scrollLocked) {
	        var newPos = {
	          x: this.state.rel.contentX + (pageX - this.state.rel.inputX),
	          y: this.state.rel.contentY + (pageY - this.state.rel.inputY)
	        };
	
	        if (this.props.bounds) {
	          // if the bounds were supplied, don't let the content move outside
	          // of them
	          var bounds = this.props.bounds;
	
	          if (newPos.x < bounds.x1) {
	            newPos.x = bounds.x1;
	          }
	
	          if (newPos.y < bounds.y1) {
	            newPos.y = bounds.y1;
	          }
	
	          if (newPos.x > bounds.x2) {
	            newPos.x = bounds.x2;
	          }
	
	          if (newPos.y > bounds.y2) {
	            newPos.y = bounds.y3;
	          }
	        }
	
	        if (this.props.dragCallback) {
	          this.props.dragCallback(newPos, e);
	        }
	
	        this.setState({
	          pos: newPos
	        }, this.positionContent);
	      }
	    }
	
	    if (this.props.preventDefaultEvents) {
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  },
	
	
	  /**
	   * Called when the user's mouse is released
	   * @param {Event} e A mouseup event
	   * @returns {undefined} undefined
	   */
	  _onMouseUp: function _onMouseUp(e) {
	    if (this.mouseDownOnElement && this.state.enabled && !this._mouseDownWhileDisabled) {
	      var transformValues = this._parseTransformValues(this.refs.draggableChild);
	      var xVal = Number(transformValues[0]);
	      var yVal = Number(transformValues[1]);
	
	      if (this.props.translate3d) {
	        xVal = Number(transformValues[1]);
	      }
	
	      if (this.props.translate3d) {
	        yVal = Number(transformValues[2]);
	      }
	
	      if (isNaN(xVal)) {
	        xVal = 0;
	      }
	
	      if (isNaN(yVal)) {
	        yVal = 0;
	      }
	
	      if (this.props.dragStopCallback && !this.state.scrollLocked) {
	        this.props.dragStopCallback({
	          x: xVal,
	          y: yVal
	        }, e);
	      }
	
	      this.setState({
	        dragging: false,
	        scrollLocked: false,
	        dragLocked: false
	      });
	    }
	
	    if (this.props.preventDefaultEvents) {
	      e.stopPropagation();
	      e.preventDefault();
	    }
	
	    this.mouseDownOnElement = false;
	  },
	
	
	  /**
	   * Called when the user is dragging but releases the mouse
	   * outside of the draggable component
	   * @returns {undefined} undefined
	   */
	  _onMouseOut: function _onMouseOut() {
	    if (this.state.dragging && this.props.dragLeaveCallback) {
	      this.setState({
	        dragging: false,
	        scrollLocked: false,
	        dragLocked: false
	      });
	
	      this.props.dragLeaveCallback();
	    }
	  },
	
	
	  /**
	   * Parses a CSS string containing a transform property
	   * @param {HTMLElement} element The element to get the CSS values from
	   * @returns {Array} An array of the transform values
	   */
	  _parseTransformValues: function _parseTransformValues(element) {
	    var transformString = 'transform';
	    if (this._cssProperties.objectPrefix !== '') {
	      transformString = 'Transform';
	    }
	    var matrix = element.style[this._cssProperties.objectPrefix + transformString];
	    var values = matrix.match(/-?[0-9\.]+/g);
	
	    if (!values) {
	      values = [0, 0, 0];
	    }
	
	    return values;
	  }
	});
	
	exports.default = Draggable;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "Draggable.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 246 */
/*!**************************************************!*\
  !*** ./assets/js/src/components/EmojiIsLife.jsx ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(/*! ./../../../css/src/main.scss */ 155);
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _data = __webpack_require__(/*! ./../data/data */ 124);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _MainMenuStore = __webpack_require__(/*! ./../stores/MainMenuStore */ 64);
	
	var _MainMenuStore2 = _interopRequireDefault(_MainMenuStore);
	
	var _EmojiIsLifeStore = __webpack_require__(/*! ./../stores/EmojiIsLifeStore */ 254);
	
	var _EmojiIsLifeStore2 = _interopRequireDefault(_EmojiIsLifeStore);
	
	var _AppDispatcher = __webpack_require__(/*! ./../dispatcher/AppDispatcher */ 21);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _AppConstants = __webpack_require__(/*! ./../constants/AppConstants */ 20);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _Slides = __webpack_require__(/*! ./Slides.jsx */ 250);
	
	var _Slides2 = _interopRequireDefault(_Slides);
	
	var _MenuButton = __webpack_require__(/*! ./MenuButton.jsx */ 122);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _LandingSlide = __webpack_require__(/*! ./LandingSlide.jsx */ 121);
	
	var _LandingSlide2 = _interopRequireDefault(_LandingSlide);
	
	var _Menu = __webpack_require__(/*! ./Menu.jsx */ 249);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Share = __webpack_require__(/*! ./Share.jsx */ 123);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmojiIsLife = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'EmojiIsLife',
	
	  /**
	   * The iteration of the current content
	   */
	  contentIteration: 0,
	
	  /**
	   * Used to track how many times the user has swiped
	   */
	  animateIteration: 0,
	
	  /**
	   * Starting drag position of the content
	   */
	  startDragPos: 0,
	
	  /**
	   * Ending drag position of the content
	   */
	  endDragPos: 0,
	
	  /**
	   * The amount of pixels the user needs to drag to trigger a transition
	   */
	  dragThreshold: 10,
	
	  /**
	   * The number of slides above and below the current slide
	   */
	  surroundingSlideAmount: 2,
	
	  /**
	   * Timeout to reset the content positions
	   */
	  resetPositionTimeout: 0,
	
	  /**
	   * If the user is scrolling
	   */
	  scrolling: false,
	
	  /**
	   * Timeout to reset whether the user is scrolling
	   */
	  resetScrollTimeout: 0,
	
	  /**
	   * Expected propTypes
	   * @prop {Object} data - A data object
	   * @prop {Number} minDesktopWidth - The minimum width to render the desktop
	   * layout
	   * @prop {Boolean} touch - If browser supports touch events
	   */
	  propTypes: {
	    data: _react2.default.PropTypes.array.isRequired,
	    minDesktopWidth: _react2.default.PropTypes.number.isRequired,
	    touch: _react2.default.PropTypes.bool
	  },
	
	  /**
	   * Get initial state object
	   * @returns {Object} initial state
	   */
	  getInitialState: function getInitialState() {
	    return {
	      currentSlideData: [],
	      menuOpen: false,
	      large: false,
	      currentSlide: 0,
	      showLargeLanding: true,
	      windowSize: {
	        width: 0,
	        height: 0
	      }
	    };
	  },
	
	
	  /**
	   * Called after component mounts to DOM
	   * @returns {undefined} undefined
	   */
	  componentDidMount: function componentDidMount() {
	    _MainMenuStore2.default.addChangeListener(this._onMenuChange);
	    _EmojiIsLifeStore2.default.addChangeListener(this._onAppChange);
	    window.addEventListener('resize', this._onResize);
	    window.addEventListener('mousewheel', this._mouseWheelHandler, false);
	    window.addEventListener('DOMMouseScroll', this._mouseWheelHandler, false);
	
	    this.draggableElement = this.refs.draggable;
	    this._onResize();
	  },
	
	
	  /**
	   * Called before component is removed from the DOM
	   * @returns {undefined} undefined
	   */
	  componentWillUnmount: function componentWillUnmount() {
	    _MainMenuStore2.default.removeChangeListener(this._onMenuChange);
	    _EmojiIsLifeStore2.default.removeChangeListener(this._onAppChange);
	    window.removeEventListener('resize', this._onResize);
	  },
	
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    var largeHeader = this._renderLargeHeader();
	    var largeMenu = this._renderLargeMenu();
	    var largeMainContentLogos = this._renderLargeMainContentLogos();
	    var largeShare = this._renderLargeShare();
	    var largeCredits = this._renderLargeCredits();
	    var largeContentClass = this.state.viewingMainContent ? ' viewing-main' : '';
	    var largeSectionTransitionCompleteClass = this.state.sectionTransitionComplete ? ' section-transition-complete' : '';
	    var transitioningToLandingClass = this.state.sectionTransitionComplete && this.state.showLargeLanding && this.state.viewingMainContent ? ' transitioning-to-landing' : '';
	    var currentSlideClass = ' slide-' + this.state.currentSlide;
	    var className = 'component-emoji-is-life' + largeContentClass + currentSlideClass + transitioningToLandingClass + largeSectionTransitionCompleteClass;
	    var menuIcon = this.state.menuOpen ? '🚫' : '🍔';
	    var menuTouchEndHandler = this.props.touch ? this._toggleMainMenu : null;
	    var menuClickHandler = !this.props.touch ? this._toggleMainMenu : null;
	    var smallLogoTouchEndHandler = this.props.touch ? this._onSmallLogoClick : null;
	    var smallLogoClickHandler = !this.props.touch ? this._onSmallLogoClick : null;
	
	    return _react2.default.createElement(
	      'div',
	      { className: className },
	      _react2.default.createElement(
	        'div',
	        { className: 'content-inner' },
	        largeHeader,
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'main-content-inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'left-col-large' },
	              largeMainContentLogos,
	              largeMenu,
	              largeCredits
	            ),
	            _react2.default.createElement(_Slides2.default, {
	              data: _data2.default,
	              large: this.state.large,
	              touch: this.props.touch
	            }),
	            largeShare
	          )
	        )
	      ),
	      _react2.default.createElement(_Menu2.default, {
	        currentSlide: this.state.currentSlide,
	        data: _data2.default,
	        touch: this.props.touch,
	        large: this.state.large
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'main-menu-button',
	          onTouchEnd: menuTouchEndHandler,
	          onClick: menuClickHandler
	        },
	        menuIcon
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'logos' },
	        _react2.default.createElement(
	          'a',
	          { className: 'br-logo', href: 'http://bleacherreport.com', target: '_blank' },
	          _react2.default.createElement('img', { src: 'assets/images/br-logo-white.png' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'logo',
	            onClick: smallLogoClickHandler,
	            onTouchEnd: smallLogoTouchEndHandler
	          },
	          _react2.default.createElement(
	            'span',
	            null,
	            'EMOJI IS LIFE'
	          )
	        )
	      )
	    );
	  },
	
	
	  /**
	   * Mousewheel handler
	   * @param {Object} e - The mousewheel event
	   * @returns undefined
	   */
	  _mouseWheelHandler: function _mouseWheelHandler(e) {
	    var _this = this;
	
	    if (!this.scrolling && this.state.large) {
	      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
	
	      this.scrolling = true;
	
	      if (delta < 0) {
	        _AppDispatcher2.default.handleViewAction({
	          actionType: _AppConstants2.default.ADVANCE_SLIDE
	        });
	      } else {
	        _AppDispatcher2.default.handleViewAction({
	          actionType: _AppConstants2.default.REVERSE_SLIDE
	        });
	      }
	
	      this.resetScrollTimeout = setTimeout(function () {
	        _this.scrolling = false;
	      }, 1000);
	    }
	  },
	
	
	  /**
	   * Renders the large header
	   * @returns {ReactElement} A ReactElement
	   */
	  _renderLargeHeader: function _renderLargeHeader() {
	    var largeHeader = void 0;
	
	    if (this.state.large && this.state.showLargeLanding) {
	      largeHeader = _react2.default.createElement(
	        'div',
	        { className: 'large-header' },
	        _react2.default.createElement(_LandingSlide2.default, {
	          active: !this.state.viewingMainContent,
	          descriptionData: _data2.default[1],
	          height: window.innerHeight,
	          large: this.state.large,
	          windowSize: this.state.windowSize,
	          touch: this.props.touch,
	          yPosition: 0
	        })
	      );
	    }
	
	    return largeHeader;
	  },
	
	
	  /**
	   * Renders the large menu
	   * @returns {ReactElement} A ReactElement
	   */
	  _renderLargeMenu: function _renderLargeMenu() {
	    var menuButtons = this._renderLargeMenuButtons();
	    var largeMenu = void 0;
	
	    if (this.state.large) {
	      largeMenu = _react2.default.createElement(
	        'div',
	        { className: 'large-button-wrapper' },
	        _react2.default.createElement('div', { className: 'sep' }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'buttons' },
	          menuButtons
	        )
	      );
	    }
	
	    return largeMenu;
	  },
	
	
	  /**
	   * Renders the large menu buttons
	   * @returns {ReactElement} A ReactElement
	   */
	  _renderLargeMenuButtons: function _renderLargeMenuButtons() {
	    var buttons = [];
	
	    for (var i = 2; i < _data2.default.length; i++) {
	      var newIteration = i - 2;
	      var key = 'menu-button-' + i;
	
	      if (_data2.default[i].type !== 'credits') {
	        buttons.push(_react2.default.createElement(_MenuButton2.default, {
	          buttonWrapperEl: this.refs.buttonWrapper,
	          currentSlide: this.state.currentSlide,
	          iteration: newIteration,
	          data: _data2.default[i],
	          key: key,
	          large: this.state.large,
	          touch: this.props.touch
	        }));
	      }
	    }
	
	    return buttons;
	  },
	
	
	  /**
	   * Renders the logos for the main content when on a larger screen
	   * @returns {ReactElement} A ReactElement
	   */
	  _renderLargeMainContentLogos: function _renderLargeMainContentLogos() {
	    var logos = void 0;
	
	    if (this.state.large) {
	      logos = _react2.default.createElement(
	        'div',
	        { className: 'mc-logos' },
	        _react2.default.createElement(
	          'a',
	          { className: 'br-logo', href: 'http://bleacherreport.com', target: '_blank' },
	          _react2.default.createElement('img', { src: 'assets/images/br-logo-white.png' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'logo', onClick: this._onLogoClick },
	          _react2.default.createElement(
	            'span',
	            null,
	            'EMOJI IS LIFE'
	          )
	        )
	      );
	    }
	
	    return logos;
	  },
	
	
	  /**
	   * Renders the large share buttons
	   * @returns {ReactElement} A ReactElement
	   */
	  _renderLargeShare: function _renderLargeShare() {
	    var share = void 0;
	
	    if (this.state.large) {
	      share = _react2.default.createElement(
	        'div',
	        { className: 'large-share' },
	        _react2.default.createElement(_Share2.default, null)
	      );
	    }
	
	    return share;
	  },
	
	
	  /**
	   * Renders the large credits
	   * @returns {ReactElement} A ReactElement
	   */
	  _renderLargeCredits: function _renderLargeCredits() {
	    var credits = void 0;
	
	    if (this.state.large) {
	      var creditData = void 0;
	
	      for (var i = 0; i < _data2.default.length; i++) {
	        if (_data2.default[i].type === 'credits') {
	          creditData = _data2.default[i];
	        }
	      }
	
	      var creditText = creditData.text.split('<br/>').join(' ');
	
	      credits = _react2.default.createElement(
	        'div',
	        { className: 'large-credits' },
	        creditText
	      );
	    }
	
	    return credits;
	  },
	
	
	  /**
	   * Toggles the main menu showing
	   * @returns {undefined} undefined
	   */
	  _toggleMainMenu: function _toggleMainMenu() {
	    if (!this.state.menuOpen) {
	      _AppDispatcher2.default.handleViewAction({
	        actionType: _AppConstants2.default.OPEN_MAIN_MENU
	      });
	    } else {
	      _AppDispatcher2.default.handleViewAction({
	        actionType: _AppConstants2.default.CLOSE_MAIN_MENU
	      });
	    }
	  },
	
	
	  /**
	   * Called when a CHANGE event is emitted from the EmojiIsLifeStore
	   * @returns {undefined} undefined
	   */
	  _onAppChange: function _onAppChange() {
	    var _this2 = this;
	
	    if (this.state.large && this.state.showLargeLanding && !_EmojiIsLifeStore2.default.getState().showLargeLanding) {
	      setTimeout(function () {
	        _this2.setState({ currentSlide: 0 });
	      }, 10);
	    }
	
	    this.setState(_EmojiIsLifeStore2.default.getState());
	  },
	
	
	  /**
	   * Called when a CHANGE event is emitted from the MainMenuStore
	   * @returns {undefined} undefined
	   */
	  _onMenuChange: function _onMenuChange() {
	    this.setState(_MainMenuStore2.default.getState());
	  },
	
	
	  /**
	   * Click handler for the logo
	   * @returns {undefined} undefined
	   */
	  _onLogoClick: function _onLogoClick() {
	    if (this.state.large) {
	      _AppDispatcher2.default.handleViewAction({
	        actionType: _AppConstants2.default.SHOW_LARGE_LANDING
	      });
	
	      setTimeout(function () {
	        _AppDispatcher2.default.handleViewAction({
	          actionType: _AppConstants2.default.GO_TO_LANDING_CONTENT
	        });
	
	        _AppDispatcher2.default.handleViewAction({
	          actionType: _AppConstants2.default.SECTION_TRANSITION_IN_PROGRESS
	        });
	      }, 50);
	
	      setTimeout(function () {
	        _AppDispatcher2.default.handleViewAction({
	          actionType: _AppConstants2.default.SLIDE_CHANGED,
	          slide: 0
	        });
	      }, 600);
	    }
	  },
	
	
	  /**
	   * Click handler for the logo in the small view
	   * @returns {undefined} undefined
	   */
	  _onSmallLogoClick: function _onSmallLogoClick() {
	    _AppDispatcher2.default.handleViewAction({
	      actionType: _AppConstants2.default.GO_TO_SLIDE,
	      slide: 0
	    });
	
	    _AppDispatcher2.default.handleViewAction({
	      actionType: _AppConstants2.default.CLOSE_MAIN_MENU
	    });
	  },
	
	
	  /**
	   * Resize handler
	   * @returns {undefined} undefined
	   */
	  _onResize: function _onResize() {
	    if (window.innerWidth >= this.props.minDesktopWidth) {
	      if (!this.state.large) {
	        this.setState({ large: true });
	      }
	    } else {
	      if (this.state.large) {
	        this.setState({ large: false });
	
	        _AppDispatcher2.default.handleViewAction({
	          actionType: _AppConstants2.default.GO_TO_SLIDE,
	          slide: 0
	        });
	      }
	    }
	
	    var windowSize = {
	      width: window.innerWidth,
	      height: window.innerHeight
	    };
	
	    this.setState({ windowSize: windowSize });
	  }
	});
	
	exports.default = EmojiIsLife;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "EmojiIsLife.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 247 */
/*!***************************************************!*\
  !*** ./assets/js/src/components/EmojiRotator.jsx ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _src = __webpack_require__(/*! pixi.js/src */ 113);
	
	var _src2 = _interopRequireDefault(_src);
	
	var _render = __webpack_require__(/*! ./../helpers/render */ 252);
	
	var _render2 = _interopRequireDefault(_render);
	
	__webpack_require__(/*! ./../../vendor/greensock-js/src/uncompressed/TweenLite.js */ 126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmojiRotator = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'EmojiRotator',
	
	  /**
	   * Emojis to rotate
	   */
	  emojis: ['🔥', '🏀', '👀', '🙌', '💯', '😂', '👏', '🏆'],
	
	  /**
	   * Holds the emoji objects
	   */
	  emojiObjects: [],
	
	  /**
	   * Interval to change emojis
	   */
	  changeInterval: 0,
	
	  /**
	   * Timeout to re-lay everything out
	   */
	  resetTimeout: 0,
	
	  /**
	   * Expected propTypes
	   * @prop {Boolean} active - If the animation should be performed
	   * @prop {Object} cssTransforms3d - Whether the browser
	   * supports css 3d transforms
	   * @prop {Boolean} large - If the user is viewing the large experience
	   * @prop {Boolean} active - If the animation is paused
	   * @prop {Number} startDelay - The delay before starting the animation
	   */
	  propTypes: {
	    active: _react2.default.PropTypes.bool,
	    cssTransforms3d: _react2.default.PropTypes.bool,
	    large: _react2.default.PropTypes.bool.isRequired,
	    paused: _react2.default.PropTypes.bool,
	    startDelay: _react2.default.PropTypes.number
	  },
	
	  /**
	   * Get initial state object
	   * @returns {Object} initial state
	   */
	  getInitialState: function getInitialState() {
	    return {
	      currentEmoji: this.emojis[0],
	      transitionOut: false
	    };
	  },
	
	
	  /**
	   * Sets everything up
	   * @returns {undefined} undefined
	   */
	  componentDidMount: function componentDidMount() {
	    var _this2 = this;
	
	    var appContainer = this.refs.rotatorContainer;
	    window.addEventListener('resize', this._onResize);
	
	    _render2.default.init(appContainer);
	
	    this.resetTimeout = setTimeout(function () {
	      _this2._setup();
	    }, 20);
	  },
	
	
	  /**
	   * Called before component is removed from the DOM
	   * @returns {undefined} undefined
	   */
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.resetTimeout);
	
	    this._removeContent();
	    _render2.default.destroy();
	
	    window.removeEventListener('resize', this._onResize);
	  },
	
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    var className = 'component-emoji-rotator';
	
	    return _react2.default.createElement('div', { ref: 'rotatorContainer', className: className });
	  },
	
	
	  /**
	   * Animates an emoji in
	   * @returns {undefined} undefined
	   */
	  _setup: function _setup() {
	    this._addEmojis();
	    this._changeEmojis();
	
	    this.changeInterval = setInterval(this._changeEmojis, 3000);
	  },
	
	
	  /**
	   * Resize handler
	   * @returns {undefined} undefined
	   */
	  _onResize: function _onResize() {
	    var _this3 = this;
	
	    this._removeContent();
	
	    this.resetTimeout = setTimeout(function () {
	      _this3._setup();
	    }, 200);
	  },
	
	
	  /**
	   * Changes the emojis
	   * @returns {undefined} undefined
	   */
	  _addEmojis: function _addEmojis() {
	    var approximateEmojiWidth = !this.props.large ? 30 : 50;
	    var approximateEmojiHeight = !this.props.large ? 30 : 50;
	    var fontSize = !this.props.large ? 24 : 42;
	    var colCount = 0;
	    var rowCount = 0;
	    var totalCols = Math.floor(window.innerWidth / approximateEmojiWidth);
	    var totalRows = Math.floor(window.innerHeight / approximateEmojiHeight);
	    var emojiWidth = window.innerWidth / totalCols;
	    var emojiHeight = window.innerHeight / totalRows;
	    var totalCount = totalCols * totalRows;
	
	    this.emojiObjects = [];
	
	    for (var i = 0; i < totalCount; i++) {
	      var emojiContainer = new _src2.default.Container();
	      _render2.default.stage.addChild(emojiContainer);
	      emojiContainer.x = colCount * emojiWidth + emojiWidth * 0.5;
	      emojiContainer.y = rowCount * emojiHeight + emojiHeight * 0.5;
	      emojiContainer._emojiIteration = 0;
	
	      var emojiText = new _src2.default.Text(this.emojis[0], {
	        font: fontSize + 'px Helvetica',
	        fill: 0xFFFFFF,
	        align: 'center'
	      });
	      emojiText.resolution = 2;
	      emojiText.x = -(emojiWidth * 0.4);
	      emojiText.y = -(emojiHeight * 0.4);
	
	      emojiContainer.addChild(emojiText);
	      emojiContainer._emojiText = emojiText;
	
	      colCount++;
	      if (colCount === totalCols) {
	        colCount = 0;
	        rowCount++;
	      }
	
	      this.emojiObjects.push(emojiContainer);
	    }
	  },
	
	
	  /**
	   * Animates an emoji out
	   * @returns {undefined} undefined
	   */
	  _changeEmojis: function _changeEmojis() {
	    var _this4 = this;
	
	    var _this = this;
	
	    if (!this.props.paused) {
	      var _loop = function _loop(i) {
	        // const timeout = Math.random() * 5000;
	        var timeout = i * 10;
	
	        setTimeout(function () {
	          if (!_this.props.paused) {
	            _this._animateEmojiOut(_this4.emojiObjects[i]);
	          }
	        }, timeout);
	
	        setTimeout(function () {
	          if (!_this.props.paused) {
	            _this._animateEmojiIn(_this4.emojiObjects[i]);
	          }
	        }, timeout + 100);
	      };
	
	      for (var i = 0; i < this.emojiObjects.length; i++) {
	        _loop(i);
	      }
	    } else {
	      clearInterval(this.changeInterval);
	    }
	  },
	
	
	  /**
	   * Animates an emoji out
	   * @returns {undefined} undefined
	   */
	  _animateEmojiOut: function _animateEmojiOut(object) {
	    if (object) {
	      var newIteration = object._emojiIteration + 1;
	      if (newIteration > this.emojis.length - 1) {
	        newIteration = 0;
	      }
	
	      object._emojiIteration = newIteration;
	
	      this.tween = window.TweenLite.to(object.scale, 0.1, {
	        x: 0,
	        y: 0,
	        ease: window.Linear.easeNone
	      });
	    }
	  },
	
	
	  /**
	   * Animates an emoji in
	   * @returns {undefined} undefined
	   */
	  _animateEmojiIn: function _animateEmojiIn(object) {
	    if (object) {
	      object._emojiText.text = this.emojis[object._emojiIteration];
	
	      this.tween = window.TweenLite.to(object.scale, 0.1, {
	        x: 1,
	        y: 1,
	        ease: window.Linear.easeNone
	      });
	    }
	  },
	
	
	  /**
	   * Removes all emojis and stops all animations
	   * @returns {undefined} undefined
	   */
	  _removeContent: function _removeContent() {
	    clearInterval(this.changeInterval);
	    clearTimeout(this.resetTimeout);
	
	    if (this.tween) {
	      this.tween.kill();
	      this.tween = null;
	    }
	
	    for (var i = 0; i < this.emojiObjects.length; i++) {
	      window.TweenLite.killTweensOf(this.emojiObjects[i]);
	      _render2.default.stage.removeChild(this.emojiObjects[i]);
	    }
	
	    this.emojiObjects = [];
	  }
	});
	
	exports.default = EmojiRotator;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "EmojiRotator.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 248 */
/*!***********************************************!*\
  !*** ./assets/js/src/components/GifSlide.jsx ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(/*! ./../helpers/style */ 253);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GifSlide = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'GifSlide',
	
	  /**
	   * Used by React as the component name
	   */
	  countInterval: 0,
	
	  /**
	   * Timeout to hide cover image
	   */
	  hideCoverImageTimeout: 0,
	
	  /**
	   * Timeout to render gif element
	   */
	  loadGifTimeout: 0,
	
	  /**
	   * Expected propTypes
	   * @prop {Boolean} active - If this is the current active slide
	   * @prop {Object} cssTransforms3d - Whether the browser
	   * supports css 3d transforms
	   * @prop {Object} data - A data object
	   * @prop {Number} height - The height for the slide's style
	   * @prop {Boolean} large - If the user is viewing the large experience
	   * @prop {Boolean} next - If this is the next from the active slide
	   * @prop {Boolean} prev - If this is the previous from the active slide
	   * @prop {Number} yPosition - The top position for the slide's style
	   */
	  propTypes: {
	    active: _react2.default.PropTypes.bool,
	    cssTransforms3d: _react2.default.PropTypes.bool,
	    data: _react2.default.PropTypes.object.isRequired,
	    height: _react2.default.PropTypes.number,
	    touch: _react2.default.PropTypes.bool,
	    large: _react2.default.PropTypes.bool.isRequired,
	    next: _react2.default.PropTypes.bool,
	    prev: _react2.default.PropTypes.bool,
	    yPosition: _react2.default.PropTypes.number
	  },
	
	  /**
	   * Get initial state object
	   * @returns {Object} initial state
	   */
	  getInitialState: function getInitialState() {
	    return {
	      emojiCountInt: 0,
	      gifLoaded: false,
	      gifLoading: false,
	      hideCoverImage: false,
	      emojiCountStarted: false,
	      emojiCounts: this._getEmptyCountArray(),
	      gifElement: null
	    };
	  },
	
	
	  /**
	   * Called after component updates
	   * @returns {undefined} undefined
	   */
	  componentDidUpdate: function componentDidUpdate() {
	    var _this2 = this;
	
	    // if this slide is active and the count up hasn't started, start it
	    if (this.props.active && !this.state.emojiCountStarted) {
	      this.setState({ emojiCountStarted: true }, function () {
	        _this2._countUpEmojiCount();
	      });
	    }
	
	    // if this slide is not active and the count has started, stop it
	    if (!this.props.active && this.state.emojiCountStarted) {
	      clearInterval(this.countInterval);
	      this.setState({
	        emojiCounts: this._getEmptyCountArray(),
	        emojiCountStarted: false
	      });
	    }
	
	    // if this slide is active and the gif isn't loaded, load it
	    if (this.props.active && !this.state.gifLoaded) {
	      if (!this.state.gifLoading) {
	        this.setState({ gifLoading: true });
	
	        this.loadGifTimeout = setTimeout(function () {
	          if (_this2.isMounted()) {
	            _this2.setState({ gifElement: _this2._renderGif() });
	          }
	        }, 300);
	      }
	    }
	
	    // if this slide is active and the gif is loaded, show it
	    if (this.props.active && this.state.gifLoaded && !this.state.hideCoverImage) {
	      this.loadGifTimeout = setTimeout(function () {
	        if (_this2.isMounted()) {
	          _this2.setState({ gifElement: _this2._renderGif() });
	        }
	      }, 300);
	    }
	
	    // if this slide is not active and the cover image isn't showing, show it
	    if (!this.props.active && this.state.hideCoverImage) {
	      clearTimeout(this.hideCoverImageTimeout);
	      this.setState({
	        gifElement: null,
	        hideCoverImage: false
	      });
	    }
	
	    // if this slide is not active and the gif is loading, hide the loader
	    if (!this.props.active && this.state.gifLoading) {
	      clearTimeout(this.loadGifTimeout);
	      this.setState({
	        gifElement: null,
	        gifLoading: false
	      });
	    }
	  },
	
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    var data = this.props.data;
	    var coverImage = this._renderCoverImage();
	    var gif = this.state.gifElement;
	    var emojis = this._renderEmojis();
	    var prevClass = this.props.prev ? ' prev' : '';
	    var activeClass = this.props.active ? ' active' : '';
	    var nextClass = this.props.next ? ' next' : '';
	    var gifLoadingClass = this.state.gifLoading ? ' gif-loading' : '';
	    var gifLoadedClass = this.state.gifLoaded ? ' gif-loaded' : '';
	    var className = 'component-gif-slide slide' + prevClass + activeClass + nextClass + gifLoadedClass + gifLoadingClass;
	    var style = {
	      height: this.props.height,
	      top: this.props.yPosition
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: style, className: className },
	      _react2.default.createElement(
	        'div',
	        { className: 'cover-image' },
	        coverImage
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'gif' },
	        gif
	      ),
	      _react2.default.createElement('div', { className: 'gradient' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'text' },
	        _react2.default.createElement(
	          'div',
	          { className: 'game-title' },
	          data.gameTitle
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          data.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'emojis' },
	          emojis
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'loader-wrapper' },
	        _react2.default.createElement('div', { className: 'loader' })
	      )
	    );
	  },
	
	
	  /**
	   * Renders the cover image
	   * @returns {ReactElement} an image tag
	   */
	  _renderCoverImage: function _renderCoverImage() {
	    var data = this.props.data;
	    var coverImage = void 0;
	    var containerWidth = this.props.large ? 400 : window.innerWidth;
	
	    if (!this.state.hideCoverImage) {
	      var imageStyle = _style2.default.getSizeToCover(data.coverImage.width, data.coverImage.height, containerWidth, containerWidth);
	
	      coverImage = _react2.default.createElement('img', { style: imageStyle, src: data.coverImage.url });
	    }
	
	    return coverImage;
	  },
	
	
	  /**
	   * Renders the gif
	   * @returns {ReactElement} an image tag
	   */
	  _renderGif: function _renderGif() {
	    var data = this.props.data;
	    var containerWidth = this.props.large ? 400 : window.innerWidth;
	    var gif = void 0;
	
	    if (this.props.active) {
	      var imageStyle = _style2.default.getSizeToCover(data.image.width, data.image.height, containerWidth, containerWidth);
	
	      var onGifLoad = this.state.gifLoaded ? null : this._onGifLoad;
	
	      gif = _react2.default.createElement('img', {
	        style: imageStyle,
	        src: data.image.url,
	        onLoad: onGifLoad
	      });
	
	      if (this.state.gifLoaded) {
	        this._onGifLoad();
	      }
	    }
	
	    return gif;
	  },
	
	
	  /**
	   * Callback for when gif is loaded
	   * @returns {undefined} undefined
	   */
	  _onGifLoad: function _onGifLoad() {
	    var _this3 = this;
	
	    if (this.props.active) {
	      if (!this.state.gifLoaded) {
	        this.setState({ gifLoaded: true, gifLoading: false });
	      }
	
	      this.hideCoverImageTimeout = setTimeout(function () {
	        if (_this3.isMounted()) {
	          _this3.setState({ hideCoverImage: true });
	        }
	      }, 400);
	    }
	  },
	
	
	  /**
	   * Renders emojis
	   * @returns {Array<ReactElement>} An array of ReactElements
	   */
	  _renderEmojis: function _renderEmojis() {
	    var data = this.props.data;
	    var emojis = [];
	
	    for (var i = 0; i < data.emojis.length; i++) {
	      var key = 'gif-slide-' + data.id + '-emoji-' + i;
	
	      emojis.push(_react2.default.createElement(
	        'div',
	        { key: key, className: 'emoji-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'emoji' },
	          data.emojis[i].character
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'count' },
	          this.state.emojiCounts[i].currentCount,
	          ' TWEETS'
	        )
	      ));
	    }
	
	    return emojis;
	  },
	
	
	  /**
	   * Counts up the Emoji usage count
	   * @returns {undefined} undefined
	   */
	  _countUpEmojiCount: function _countUpEmojiCount() {
	    var _this4 = this;
	
	    var _this = this;
	    var data = this.props.data;
	    var highestEmojiCount = this._getHighestEmojiCount();
	    var stopInterval = false;
	
	    this.countInterval = setInterval(function () {
	      if (_this.isMounted()) {
	        var countArray = _this4.state.emojiCounts;
	
	        for (var i = 0; i < _this4.state.emojiCounts.length; i++) {
	          var curCount = _this4.state.emojiCounts[i].currentCount;
	          var newCount = curCount + 2;
	          if (newCount > _this4.state.emojiCounts[i].totalCount) {
	            newCount = _this4.state.emojiCounts[i].totalCount;
	          }
	
	          if (newCount <= _this4.state.emojiCounts[i].totalCount) {
	            countArray[i] = {
	              currentCount: newCount,
	              totalCount: data.emojis[i].count
	            };
	          }
	
	          if (newCount >= highestEmojiCount) {
	            stopInterval = true;
	          }
	        }
	
	        if (!stopInterval) {
	          _this4.setState({ emojiCounts: countArray });
	        } else {
	          clearInterval(_this.countInterval);
	        }
	      } else {
	        clearInterval(_this.countInterval);
	      }
	    }, 10);
	  },
	
	
	  /**
	   * Gets the count for the most used emoji
	   * @returns {Number} The count for the most used emoji
	   */
	  _getHighestEmojiCount: function _getHighestEmojiCount() {
	    var highestCount = 0;
	    var data = this.props.data;
	
	    for (var i = 0; i < data.emojis.length; i++) {
	      if (data.emojis[i].count > highestCount) {
	        highestCount = data.emojis[i].count;
	      }
	    }
	
	    return highestCount;
	  },
	
	
	  /**
	   * Gets an empty count array
	   * @returns {Array<Object>} An array of objects
	   */
	  _getEmptyCountArray: function _getEmptyCountArray() {
	    var data = this.props.data;
	    var countArray = [];
	
	    for (var i = 0; i < data.emojis.length; i++) {
	      countArray.push({
	        currentCount: 0,
	        totalCount: data.emojis[i].count
	      });
	    }
	
	    return countArray;
	  }
	});
	
	exports.default = GifSlide;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "GifSlide.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 249 */
/*!*******************************************!*\
  !*** ./assets/js/src/components/Menu.jsx ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppDispatcher = __webpack_require__(/*! ./../dispatcher/AppDispatcher */ 21);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _AppConstants = __webpack_require__(/*! ./../constants/AppConstants */ 20);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _MainMenuStore = __webpack_require__(/*! ./../stores/MainMenuStore */ 64);
	
	var _MainMenuStore2 = _interopRequireDefault(_MainMenuStore);
	
	var _MenuButton = __webpack_require__(/*! ./MenuButton.jsx */ 122);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'Menu',
	
	  /**
	   * Expected propTypes
	   * @prop {Number} currentSlide - The iteration of the current section
	   * @prop {Object} data - A data object
	   * @prop {Boolean} large - If the user is viewing the large experience
	   * @prop {Boolean} touch - If browser supports touch events
	   */
	  propTypes: {
	    currentSlide: _react2.default.PropTypes.number,
	    data: _react2.default.PropTypes.array.isRequired,
	    large: _react2.default.PropTypes.bool.isRequired,
	    touch: _react2.default.PropTypes.bool
	  },
	
	  /**
	   * Called after component mounts to DOM
	   * @returns {undefined} undefined
	   */
	  componentDidMount: function componentDidMount() {
	    _MainMenuStore2.default.addChangeListener(this._onChange);
	  },
	
	
	  /**
	   * Called before component is removed from the DOM
	   * @returns {undefined} undefined
	   */
	  componentWillUnmount: function componentWillUnmount() {
	    _MainMenuStore2.default.removeChangeListener(this._onChange);
	  },
	
	
	  /**
	   * Get initial state object
	   * @returns {Object} initial state
	   */
	  getInitialState: function getInitialState() {
	    return {
	      dragging: false
	    };
	  },
	
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    var draggingClass = this.state.dragging ? ' dragging' : '';
	    var openClass = this.state.menuOpen ? ' open' : '';
	    var className = 'component-menu' + draggingClass + openClass;
	    var menuButtons = this._renderMenuButtons();
	
	    return _react2.default.createElement(
	      'div',
	      { className: className },
	      _react2.default.createElement('div', { className: 'sep' }),
	      _react2.default.createElement(
	        'div',
	        { ref: 'buttonWrapper', className: 'button-wrapper' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'buttons' },
	          menuButtons
	        )
	      )
	    );
	  },
	
	
	  /**
	   * Renders buttons
	   * @returns {Array<ReactElements>} An array of React elements
	   */
	  _renderMenuButtons: function _renderMenuButtons() {
	    var buttons = [];
	    var data = this.props.data;
	
	    for (var i = 0; i < data.length; i++) {
	      var key = 'menu-button-' + i;
	
	      if (data[i].type !== 'credits' && data[i].type !== 'landing' && data[i].type !== 'description') {
	        buttons.push(_react2.default.createElement(_MenuButton2.default, {
	          buttonWrapperEl: this.refs.buttonWrapper,
	          iteration: i,
	          currentSlide: this.props.currentSlide,
	          data: data[i],
	          key: key,
	          large: this.props.large
	        }));
	      }
	    }
	
	    return buttons;
	  },
	
	
	  /**
	   * Closes the menu
	   * @returns {undefined} undefined
	   */
	  _closeMenu: function _closeMenu() {
	    _AppDispatcher2.default.handleViewAction({
	      actionType: _AppConstants2.default.CLOSE_MAIN_MENU
	    });
	  },
	
	
	  /**
	   * Called when a CHANGE event is emitted from the MainMenuStore
	   * @returns {undefined} undefined
	   */
	  _onChange: function _onChange() {
	    this.setState(_MainMenuStore2.default.getState());
	  }
	});
	
	exports.default = Menu;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "Menu.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 250 */
/*!*********************************************!*\
  !*** ./assets/js/src/components/Slides.jsx ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(/*! ./../../../css/src/main.scss */ 155);
	
	var _react = __webpack_require__(/*! react */ 12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(/*! react-dom */ 120);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Draggable = __webpack_require__(/*! ./Draggable.jsx */ 245);
	
	var _Draggable2 = _interopRequireDefault(_Draggable);
	
	var _MainMenuStore = __webpack_require__(/*! ./../stores/MainMenuStore */ 64);
	
	var _MainMenuStore2 = _interopRequireDefault(_MainMenuStore);
	
	var _SlidesStore = __webpack_require__(/*! ./../stores/SlidesStore */ 255);
	
	var _SlidesStore2 = _interopRequireDefault(_SlidesStore);
	
	var _AppDispatcher = __webpack_require__(/*! ./../dispatcher/AppDispatcher */ 21);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _AppConstants = __webpack_require__(/*! ./../constants/AppConstants */ 20);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _LandingSlide = __webpack_require__(/*! ./LandingSlide.jsx */ 121);
	
	var _LandingSlide2 = _interopRequireDefault(_LandingSlide);
	
	var _DescriptionSlide = __webpack_require__(/*! ./DescriptionSlide.jsx */ 244);
	
	var _DescriptionSlide2 = _interopRequireDefault(_DescriptionSlide);
	
	var _GifSlide = __webpack_require__(/*! ./GifSlide.jsx */ 248);
	
	var _GifSlide2 = _interopRequireDefault(_GifSlide);
	
	var _CreditsSlide = __webpack_require__(/*! ./CreditsSlide.jsx */ 243);
	
	var _CreditsSlide2 = _interopRequireDefault(_CreditsSlide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slides = _react2.default.createClass({
	  /**
	   * Used by React as the component name
	   */
	  displayName: 'Slides',
	
	  /**
	   * The iteration of the current content
	   */
	  contentIteration: 0,
	
	  /**
	   * Used to track how many times the user has swiped
	   */
	  animateIteration: 0,
	
	  /**
	   * Starting drag position of the content
	   */
	  startDragPos: 0,
	
	  /**
	   * Ending drag position of the content
	   */
	  endDragPos: 0,
	
	  /**
	   * The amount of pixels the user needs to drag to trigger a transition
	   */
	  dragThreshold: 10,
	
	  /**
	   * The number of slides above and below the current slide
	   */
	  surroundingSlideAmount: 2,
	
	  /**
	   * Timeout to reset the content positions
	   */
	  resetPositionTimeout: 0,
	
	  /**
	   * Expected propTypes
	   * @prop {Object} data - A data object
	   * @prop {Boolean} large - If the user is viewing the large experience
	   * @prop {Number} minDesktopWidth - The minimum width to render the desktop
	   * layout
	   * @prop {Boolean} touch - If browser supports touch events
	   */
	  propTypes: {
	    data: _react2.default.PropTypes.array.isRequired,
	    large: _react2.default.PropTypes.bool.isRequired,
	    touch: _react2.default.PropTypes.bool
	  },
	
	  /**
	   * Get initial state object
	   * @returns {Object} initial state
	   */
	  getInitialState: function getInitialState() {
	    return {
	      currentSlideData: [],
	      dragging: false
	    };
	  },
	
	
	  /**
	   * Called after component mounts to DOM
	   * @returns {undefined} undefined
	   */
	  componentDidMount: function componentDidMount() {
	    var _this2 = this;
	
	    _MainMenuStore2.default.addChangeListener(this._onMenuChange);
	    _SlidesStore2.default.addChangeListener(this._onSlidesChange);
	    window.addEventListener('resize', this._onResize);
	
	    this.draggableElement = this.refs.draggable;
	    this.node = _reactDom2.default.findDOMNode(this);
	
	    setTimeout(function () {
	      _this2._setCurrentSlideData();
	    }, 10);
	  },
	
	
	  /**
	   * Called before component is removed from the DOM
	   * @returns {undefined} undefined
	   */
	  componentWillUnmount: function componentWillUnmount() {
	    _MainMenuStore2.default.removeChangeListener(this._onMenuChange);
	    _SlidesStore2.default.removeChangeListener(this._onSlidesChange);
	    window.removeEventListener('resize', this._onResize);
	  },
	
	
	  /**
	   * Renders component
	   * @returns {Object} React element
	   */
	  render: function render() {
	    var draggingClass = this.state.dragging ? ' dragging' : '';
	    var className = 'component-slides slides-wrapper' + draggingClass;
	    var currentSlides = this._renderCurrentSlides();
	    var preventDefaultEvents = true;
	    if (this.state.menuOpen || this.contentIteration === this.props.data.length - 1) {
	      preventDefaultEvents = false;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: className },
	      _react2.default.createElement(
	        _Draggable2.default,
	        {
	          preventDefaultEvents: preventDefaultEvents,
	          ref: 'draggable',
	          lock: 'y',
	          dragStartCallback: this._dragStartCallback,
	          dragStopCallback: this._dragStopCallback
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'slides' },
	          currentSlides
	        )
	      )
	    );
	  },
	
	
	  /**
	   * Called when the user starts dragging the slides
	   * @param {Object} draggablePosition - the current x and y position of the
	   * draggable element
	   * @returns {undefined} undefined
	   */
	  _dragStartCallback: function _dragStartCallback(draggablePosition) {
	    clearTimeout(this.resetPositionTimeout);
	
	    this.startDragPos = draggablePosition.y;
	    this.setState({ dragging: true });
	  },
	
	
	  /**
	   * Called when the user stops dragging the slides
	   * @param {Object} draggablePosition - the current x and y position of the
	   * draggable element
	   * @param {Object} event - A mouse event object
	   * @returns {undefined} undefined
	   */
	  _dragStopCallback: function _dragStopCallback(draggablePosition, event) {
	    var _this3 = this;
	
	    var slideClicked = void 0;
	    var data = this.props.data;
	    this.endDragPos = draggablePosition.y;
	
	    var dif = this.startDragPos - this.endDragPos;
	    if (dif < 0) {
	      dif = dif * -1;
	    }
	
	    if (dif > this.dragThreshold) {
	      if (this.endDragPos > this.startDragPos) {
	        // dragged down
	        if (this.contentIteration - 1 >= 0) {
	          this.contentIteration--;
	          this.animateIteration--;
	        }
	      } else {
	        // dragged up
	        if (this.contentIteration + 1 < data.length) {
	          this.contentIteration++;
	          this.animateIteration++;
	        }
	      }
	    } else {
	      slideClicked = this._checkForSlideClick(event);
	      if (slideClicked === 'prev') {
	        this.contentIteration--;
	        this.animateIteration--;
	      }
	
	      if (slideClicked === 'active' && this.contentIteration + 1 < this.props.data.length - 3) {
	        this.contentIteration++;
	        this.animateIteration++;
	      }
	    }
	
	    this.setState({ dragging: false }, function () {
	      _this3._setCurrentSlideData();
	      _this3._animateContent();
	    });
	
	    this.resetPositionTimeout = setTimeout(function () {
	      _this3._resetSlidePositions();
	    }, 600);
	  },
	
	
	  /*
	   * Checks to see if a slide was clicked
	   * @param {Object} event - A mouseup or touchend event, depending on browser
	   * support
	   */
	  _checkForSlideClick: function _checkForSlideClick(event) {
	    var slideClicked = void 0;
	    var slideElements = this.node.getElementsByClassName('slide');
	
	    for (var i = 0; i < slideElements.length; i++) {
	      var elementBounds = slideElements[i].getBoundingClientRect();
	      var clickBounds = {
	        x: event.clientX,
	        y: event.clientY
	      };
	
	      if (event.changedTouches) {
	        clickBounds = {
	          x: event.changedTouches[0].clientX,
	          y: event.changedTouches[0].clientY
	        };
	      }
	
	      if (clickBounds.x > elementBounds.left && clickBounds.x < elementBounds.right && clickBounds.y > elementBounds.top && clickBounds.y < elementBounds.bottom) {
	        if (slideElements[i].className.indexOf('next') > -1 || slideElements[i].className.indexOf('active') > -1) {
	          slideClicked = 'active';
	        }
	
	        if (slideElements[i].className.indexOf('prev') > -1) {
	          slideClicked = 'prev';
	          break;
	        }
	      }
	    }
	
	    return slideClicked;
	  },
	
	
	  /**
	   * Animates the content
	   * @returns {undefined} undefined
	   */
	  _animateContent: function _animateContent() {
	    var newPos = 0;
	
	    _AppDispatcher2.default.handleViewAction({
	      actionType: _AppConstants2.default.SLIDE_CHANGED,
	      slide: this.contentIteration
	    });
	
	    if (!this.props.large) {
	      if (this.animateIteration > 0) {
	        var slideTop = -(window.innerHeight + (this.animateIteration - 1) * window.innerWidth);
	        newPos = slideTop + (window.innerHeight - window.innerWidth) / 2;
	      }
	    } else {
	      newPos = -(this.animateIteration * 550);
	    }
	
	    this.draggableElement.setPosition({
	      x: 0,
	      y: newPos
	    });
	  },
	
	
	  /**
	   * Jumps to a slide
	   * @param {Number} slideIteration - The iteration of the slide to jump to
	   * @returns {undefined} undefined
	   */
	  _jumpToSlide: function _jumpToSlide(slideIteration) {
	    var dif = void 0;
	    var changeSlideFunction = void 0;
	
	    clearTimeout(this.resetPositionTimeout);
	
	    if (slideIteration < this.contentIteration) {
	      dif = this.contentIteration - slideIteration;
	      changeSlideFunction = this._reverseSlide;
	    } else {
	      dif = slideIteration - this.contentIteration;
	      changeSlideFunction = this._advanceSlide;
	    }
	
	    for (var i = 0; i < dif; i++) {
	      setTimeout(function () {
	        changeSlideFunction();
	      }, i * 10);
	    }
	  },
	
	
	  /**
	   * Advances the slide
	   * @returns {undefined} undefined
	   */
	  _advanceSlide: function _advanceSlide() {
	    var _this4 = this;
	
	    this.contentIteration++;
	    this.animateIteration++;
	
	    this._setCurrentSlideData();
	    this._animateContent();
	
	    this.resetPositionTimeout = setTimeout(function () {
	      _this4._resetSlidePositions();
	    }, 600);
	  },
	
	
	  /**
	   * Reverses the slide
	   * @returns {undefined} undefined
	   */
	  _reverseSlide: function _reverseSlide() {
	    var _this5 = this;
	
	    this.contentIteration--;
	    this.animateIteration--;
	
	    this._setCurrentSlideData();
	    this._animateContent();
	
	    this.resetPositionTimeout = setTimeout(function () {
	      _this5._resetSlidePositions();
	    }, 600);
	  },
	
	
	  /**
	   * Gets the current slide data
	   * @returns {undefined} undefined
	   */
	  _setCurrentSlideData: function _setCurrentSlideData() {
	    var data = this.props.data;
	    var slideData = data;
	    if (this.props.large) {
	      slideData = data.slice(2, data.length);
	    }
	    var currentSlideData = [];
	    var startValue = this.contentIteration - this.surroundingSlideAmount;
	    var endValue = this.contentIteration + (this.surroundingSlideAmount + 1);
	
	    if (startValue < 0) {
	      startValue = 0;
	    }
	
	    if (endValue > slideData.length) {
	      endValue = slideData.length;
	    }
	
	    for (var i = startValue; i < endValue; i++) {
	      currentSlideData.push(slideData[i]);
	    }
	
	    this.setState({ currentSlideData: currentSlideData });
	  },
	
	
	  /**
	   * Renders the current array of slides
	   * @returns {Array<ReactElement>} an array of React elements
	   */
	  _renderCurrentSlides: function _renderCurrentSlides() {
	    var data = this.props.data;
	    var slideData = this.state.currentSlideData;
	    var currentSlides = [];
	
	    for (var i = 0; i < slideData.length; i++) {
	      var key = 'slide-' + slideData[i].id;
	      var landingHeight = window.innerHeight;
	      var prev = false;
	      var active = false;
	      var next = false;
	      var yPosition = 0;
	      var height = window.innerWidth;
	
	      if (!this.props.large) {
	        if (slideData[i].sortOrder > 1) {
	          yPosition = window.innerHeight + (slideData[i].sortOrder - 2) * window.innerWidth;
	        }
	      } else {
	        height = 400;
	        yPosition = 120 + 550 * (slideData[i].sortOrder - 3);
	      }
	
	      if (this.animateIteration === 0 && i === 0) {
	        active = true;
	      } else {
	        var activeIteration = void 0;
	        var lengthDif = data.length - slideData[0].sortOrder;
	
	        if (lengthDif > this.surroundingSlideAmount + 1) {
	          activeIteration = slideData.length - this.surroundingSlideAmount - 1;
	        } else {
	          activeIteration = this.surroundingSlideAmount;
	        }
	
	        if (i === activeIteration - 1) {
	          prev = true;
	        }
	
	        if (i === activeIteration) {
	          active = true;
	        }
	
	        if (i === activeIteration + 1) {
	          next = true;
	        }
	      }
	
	      if (slideData[i].type === 'landing' && !this.props.large) {
	        currentSlides.push(_react2.default.createElement(_LandingSlide2.default, {
	          prev: prev,
	          active: active,
	          next: next,
	          descriptionData: this.props.data[1],
	          height: landingHeight,
	          large: this.props.large,
	          yPosition: yPosition,
	          key: key
	        }));
	      } else if (slideData[i].type === 'description' && !this.props.large) {
	        currentSlides.push(_react2.default.createElement(_DescriptionSlide2.default, {
	          prev: prev,
	          active: active,
	          next: next,
	          data: slideData[i],
	          height: height,
	          yPosition: yPosition,
	          key: key
	        }));
	      } else if (slideData[i].type === 'gif') {
	        currentSlides.push(_react2.default.createElement(_GifSlide2.default, {
	          prev: prev,
	          active: active,
	          next: next,
	          data: slideData[i],
	          height: height,
	          large: this.props.large,
	          yPosition: yPosition,
	          key: key
	        }));
	      } else if (slideData[i].type === 'credits') {
	        if (!this.props.large) {
	          currentSlides.push(_react2.default.createElement(_CreditsSlide2.default, {
	            prev: prev,
	            active: active,
	            next: next,
	            data: slideData[i],
	            height: height,
	            large: this.props.large,
	            yPosition: yPosition,
	            key: key
	          }));
	        }
	      }
	    }
	
	    return currentSlides;
	  },
	
	
	  /**
	   * Resets the slide positions
	   * @returns {undefined} undefined
	   */
	  _resetSlidePositions: function _resetSlidePositions() {
	    /* const _this = this;
	     this.animateIteration = 0;
	     this.setState({ dragging: true }, () => {
	      _this._animateContent();
	    });
	     this.draggableElement.setPosition({
	      x: 0,
	      y: 0,
	    }); */
	  },
	
	
	  /**
	   * Toggles the main menu showing
	   * @returns {undefined} undefined
	   */
	  _toggleMainMenu: function _toggleMainMenu() {
	    if (!this.state.menuOpen) {
	      _AppDispatcher2.default.handleViewAction({
	        actionType: _AppConstants2.default.OPEN_MAIN_MENU
	      });
	    } else {
	      _AppDispatcher2.default.handleViewAction({
	        actionType: _AppConstants2.default.CLOSE_MAIN_MENU
	      });
	    }
	  },
	
	
	  /**
	   * Called when a CHANGE event is emitted from the MainMenuStore
	   * @returns {undefined} undefined
	   */
	  _onMenuChange: function _onMenuChange() {
	    this.setState(_MainMenuStore2.default.getState());
	  },
	
	
	  /**
	   * Called when a CHANGE event is emitted from the SlidesStore
	   * @returns {undefined} undefined
	   */
	  _onSlidesChange: function _onSlidesChange() {
	    var _this = this;
	    var data = this.props.data;
	
	    this.setState(_SlidesStore2.default.getState(), function () {
	      if (!_this.state.advanceSlide && !_this.state.reverseSlide && _this.contentIteration !== _this.state.goToSlide) {
	        _this._jumpToSlide(_this.state.goToSlide);
	      }
	
	      if (_this.state.advanceSlide && _this.contentIteration + 1 < data.length - 3) {
	        _this._advanceSlide();
	      }
	
	      if (_this.state.reverseSlide && _this.contentIteration - 1 > 0) {
	        _this._reverseSlide();
	      }
	    });
	  }
	});
	
	exports.default = Slides;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "Slides.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 251 */
/*!************************************************!*\
  !*** ./assets/js/src/dispatcher/Dispatcher.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _callbacks = [];
	var Dispatcher = function dispatcher() {};
	var _promises = [];
	
	/**
	 * Dispatcher
	 * @class
	 */
	Dispatcher.prototype = Object.assign({}, Dispatcher.prototype, {
	  /**
	   * Register a Store's callback so that it may be invoked by an action.
	   * @param {function} callback The callback to be registered.
	   * @return {number} The index of the callback within the _callbacks array.
	   */
	
	  register: function register(callback) {
	    _callbacks.push(callback);
	    return _callbacks.length - 1; // index
	  },
	
	
	  /**
	   * dispatch
	   * @param  {object} payload The data from the action.
	   * @return {undefined} undefined
	   */
	  dispatch: function dispatch(payload) {
	    // First create array of promises for callbacks to reference.
	    var resolves = [];
	    var rejects = [];
	
	    _promises = _callbacks.map(function mapPromises(_, i) {
	      return new Promise(function (resolve, reject) {
	        resolves[i] = resolve;
	        rejects[i] = reject;
	      });
	    });
	
	    // Dispatch to callbacks and resolve/reject promises.
	    _callbacks.forEach(function resolveCallbackPromises(callback, i) {
	      // Callback can return an obj, to resolve, or a promise, to chain.
	      // See waitFor() for why this might be useful.
	      Promise.resolve(callback(payload)).then(function () {
	        resolves[i](payload);
	      }, function () {
	        rejects[i](new Error('Dispatcher callback unsuccessful'));
	      });
	    });
	
	    _promises = [];
	  }
	});
	
	exports.default = Dispatcher;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "Dispatcher.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 252 */
/*!*****************************************!*\
  !*** ./assets/js/src/helpers/render.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _src = __webpack_require__(/*! pixi.js/src */ 113);
	
	var _src2 = _interopRequireDefault(_src);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderHelper = {
	  /**
	   * Sets up the PIXI.js scene
	   * @param {HTMLElement} container - The container to render the game into
	   * @returns {undefined} undefined
	   */
	
	  init: function init(container) {
	    this.stage = new _src2.default.Container(0x66FF99);
	    this.renderer = _src2.default.autoDetectRenderer(window.innerWidth, window.innerHeight, { resolution: 2 });
	    this.renderer.view.style.position = 'absolute';
	    this.renderer.view.style.display = 'block';
	    this.renderer.autoResize = true;
	    this.renderer.resize(container.offsetWidth, container.offsetHeight);
	    this.initialized = true;
	    this.container = container;
	    this.container.appendChild(this.renderer.view);
	    this.resize = this.resize.bind(this);
	    this.animate = this.animate.bind(this);
	
	    window.addEventListener('resize', this.resize);
	    window.requestAnimationFrame(this.animate);
	  },
	
	
	  /**
	   * Renders the PIXI.js scene
	   * @returns {undefined} undefined
	   */
	  animate: function animate() {
	    if (this.initialized) {
	      window.requestAnimationFrame(this.animate);
	      this.renderer.render(this.stage);
	    }
	  },
	
	
	  /**
	   * unpauses rendering
	   * @returns {undefined} undefined
	   */
	  destroy: function destroy() {
	    this.container.removeChild(this.renderer.view);
	    this.stage.destroy();
	    this.renderer.destroy();
	    this.initialized = false;
	    window.removeEventListener('resize', this.resize);
	  },
	
	
	  /**
	   * Called when the window is resized
	   * @returns {undefined} undefined
	   */
	  resize: function resize() {
	    this.renderer.resize(window.innerWidth, window.innerHeight);
	  }
	};
	
	exports.default = renderHelper;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "render.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 253 */
/*!****************************************!*\
  !*** ./assets/js/src/helpers/style.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var styleHelper = {
	  /**
	   * Returns a css object with translate values
	   * @param {Number} x - The x translate position
	   * @param {Number} y- The y translate position
	   * @param {Number} z - The z translate position
	   * @param {Boolean} css3dsupported - If css 3d
	   * transforms should be used
	   * @returns {Object} A style object
	   */
	
	  getTranslateStyle: function getTranslateStyle(x, y, z, css3dsupported) {
	    var xPos = x || 0;
	    var yPos = y || 0;
	    var zPos = z || 0;
	    var positionTransformString = 'translate(' + xPos + 'px,' + yPos + 'px)';
	
	    if (css3dsupported) {
	      positionTransformString = 'translate3d(' + xPos + 'px ,' + yPos + 'px, ' + zPos + 'px)';
	    }
	
	    return this.getTransformStyle(positionTransformString);
	  },
	
	
	  /**
	   * Returns a css object with translate values
	   * @param {Number} degree - The rotation degree
	   * transforms should be used
	   * @returns {Object} A style object
	   */
	  getRotateStyle: function getRotateStyle(degree) {
	    var positionTransformString = 'rotate(' + degree + 'deg)';
	
	    return this.getTransformStyle(positionTransformString);
	  },
	
	
	  /**
	   * Returns a css object with translate and rotate values
	   * @param {Number} x - The x translate position
	   * @param {Number} y- The y translate position
	   * @param {Number} z - The z translate position
	   * @param {Number} degree - The rotation degree
	   * transforms should be used
	   * @param {Boolean} css3dsupported - If css 3d
	   * transforms should be used
	   * @returns {Object} A style object
	   */
	  getTranslateAndRotateStyle: function getTranslateAndRotateStyle(x, y, z, degree, css3dsupported) {
	    var xPos = x || 0;
	    var yPos = y || 0;
	    var zPos = z || 0;
	
	    var fullTransformString = '';
	    var rotationTransformString = 'rotate(' + degree + 'deg)';
	    var positionTransformString = 'translate(' + xPos + 'px,' + yPos + 'px)';
	
	    if (css3dsupported) {
	      positionTransformString = 'translate3d(' + xPos + 'px ,' + yPos + 'px, ' + zPos + 'px)';
	    }
	
	    fullTransformString = rotationTransformString + ' ' + positionTransformString;
	
	    return this.getTransformStyle(fullTransformString);
	  },
	
	
	  /**
	   * Returns a css object with transform values
	   * @param {String} styleString - A string of css transform values
	   * @returns {Object} A style object
	   */
	  getTransformStyle: function getTransformStyle(styleString) {
	    return {
	      msTransform: styleString,
	      WebkitTransform: styleString,
	      MozTransform: styleString,
	      transform: styleString
	    };
	  },
	
	
	  /**
	   * Returns a css object with transsition duration values
	   * @param {String} transitionDuration - The transitionDuration style
	   * @returns {Object} A style object
	   */
	  getTransitionDurationStyle: function getTransitionDurationStyle(transitionDuration) {
	    return {
	      msTransitionDuration: transitionDuration,
	      WebkitTransitionDuration: transitionDuration,
	      MozTransitionDuration: transitionDuration,
	      transitionDuration: transitionDuration
	    };
	  },
	
	
	  /**
	   * Returns a size object to fit an element to a container element
	   * (simulates css background-size: cover)
	   * @param {Number} objectWidth - The width of the element to size
	   * @param {Number} objectHeight - The height of the element to size
	   * @param {Number} containerWidth - The width of the container
	   * @param {Number} containerHeight - The height of the container
	   * @returns {Object} A size object
	   */
	  getSizeToCover: function getSizeToCover(objectWidth, objectHeight, containerWidth, containerHeight) {
	    var horizontalScale = containerWidth / objectWidth;
	    var verticalScale = containerHeight / objectHeight;
	    var scale = horizontalScale > verticalScale ? horizontalScale : verticalScale;
	    var width = scale * objectWidth;
	    var height = scale * objectHeight;
	    var marginLeft = containerWidth / 2 - width / 2;
	    var marginTop = containerHeight / 2 - height / 2;
	
	    return {
	      width: width,
	      height: height,
	      marginLeft: marginLeft,
	      marginTop: marginTop
	    };
	  }
	};
	
	exports.default = styleHelper;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "style.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 254 */
/*!**************************************************!*\
  !*** ./assets/js/src/stores/EmojiIsLifeStore.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var _events = __webpack_require__(/*! events */ 55);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _AppDispatcher = __webpack_require__(/*! ./../dispatcher/AppDispatcher */ 21);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _AppConstants = __webpack_require__(/*! ./../constants/AppConstants */ 20);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHANGE_EVENT = 'change';
	var _viewingMainContent = 0;
	var _currentSlide = 0;
	var _showLargeLanding = true;
	var _sectionTransitionComplete = false;
	
	var EmojiIsLifeStore = Object.assign({}, _events2.default.EventEmitter.prototype, {
	  /**
	   * Returns the current breakpoint
	   * @returns {String} the current breakpoint
	   */
	
	  getState: function getState() {
	    return {
	      viewingMainContent: _viewingMainContent,
	      currentSlide: _currentSlide,
	      showLargeLanding: _showLargeLanding,
	      sectionTransitionComplete: _sectionTransitionComplete
	    };
	  },
	
	
	  /**
	   * Emits change event
	   * @returns {undefined} undefined
	   */
	  emitChange: function emitChange() {
	    this.emit(CHANGE_EVENT);
	  },
	
	
	  /**
	   * Ads a listener function to the store
	   * @param {Function} callback A function to add as a callback
	   * @returns {undefined} undefined
	   */
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	
	
	  /**
	   * Removes a listener function from the store
	   * @param {Function} callback A function to remove from the callbacks
	   * @returns {undefined} undefined
	   */
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	
	
	  /**
	   * Listens for events and takes action accordingly
	   * @returns {Boolean} true
	   */
	  dispatcherIndex: _AppDispatcher2.default.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.actionType) {
	
	      case _AppConstants2.default.GO_TO_LANDING_CONTENT:
	        _viewingMainContent = false;
	
	        EmojiIsLifeStore.emitChange();
	        break;
	
	      case _AppConstants2.default.GO_TO_MAIN_CONTENT:
	        _viewingMainContent = true;
	
	        EmojiIsLifeStore.emitChange();
	        break;
	
	      case _AppConstants2.default.SLIDE_CHANGED:
	        _currentSlide = action.slide;
	
	        EmojiIsLifeStore.emitChange();
	        break;
	
	      case _AppConstants2.default.REMOVE_LARGE_LANDING:
	        _showLargeLanding = false;
	
	        EmojiIsLifeStore.emitChange();
	        break;
	
	      case _AppConstants2.default.SHOW_LARGE_LANDING:
	        _showLargeLanding = true;
	
	        EmojiIsLifeStore.emitChange();
	        break;
	
	      case _AppConstants2.default.SECTION_TRANSITION_COMPLETE:
	        _sectionTransitionComplete = true;
	
	        EmojiIsLifeStore.emitChange();
	        break;
	
	      case _AppConstants2.default.SECTION_TRANSITION_IN_PROGRESS:
	        _sectionTransitionComplete = false;
	
	        EmojiIsLifeStore.emitChange();
	        break;
	
	      default:
	        break;
	    }
	
	    return true;
	  })
	});
	
	module.exports = EmojiIsLifeStore;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "EmojiIsLifeStore.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 255 */
/*!*********************************************!*\
  !*** ./assets/js/src/stores/SlidesStore.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	var _events = __webpack_require__(/*! events */ 55);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _AppDispatcher = __webpack_require__(/*! ./../dispatcher/AppDispatcher */ 21);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _AppConstants = __webpack_require__(/*! ./../constants/AppConstants */ 20);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHANGE_EVENT = 'change';
	var _advanceSlide = false;
	var _reverseSlide = false;
	var _goToSlide = 0;
	
	var SlidesStore = Object.assign({}, _events2.default.EventEmitter.prototype, {
	  /**
	   * Returns the current breakpoint
	   * @returns {String} the current breakpoint
	   */
	
	  getState: function getState() {
	    return {
	      goToSlide: _goToSlide,
	      advanceSlide: _advanceSlide,
	      reverseSlide: _reverseSlide
	    };
	  },
	
	
	  /**
	   * Emits change event
	   * @returns {undefined} undefined
	   */
	  emitChange: function emitChange() {
	    this.emit(CHANGE_EVENT);
	  },
	
	
	  /**
	   * Ads a listener function to the store
	   * @param {Function} callback A function to add as a callback
	   * @returns {undefined} undefined
	   */
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	
	
	  /**
	   * Removes a listener function from the store
	   * @param {Function} callback A function to remove from the callbacks
	   * @returns {undefined} undefined
	   */
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	
	
	  /**
	   * Listens for events and takes action accordingly
	   * @returns {Boolean} true
	   */
	  dispatcherIndex: _AppDispatcher2.default.register(function (payload) {
	    var action = payload.action;
	
	    switch (action.actionType) {
	
	      case _AppConstants2.default.GO_TO_SLIDE:
	        _goToSlide = action.slide;
	
	        SlidesStore.emitChange();
	        break;
	
	      case _AppConstants2.default.ADVANCE_SLIDE:
	        _advanceSlide = true;
	
	        SlidesStore.emitChange();
	
	        _advanceSlide = false;
	        break;
	
	      case _AppConstants2.default.REVERSE_SLIDE:
	        _reverseSlide = true;
	
	        SlidesStore.emitChange();
	
	        _reverseSlide = false;
	        break;
	
	      default:
	        break;
	    }
	
	    return true;
	  })
	});
	
	module.exports = SlidesStore;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "SlidesStore.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 256 */
/*!*******************************************!*\
  !*** ./assets/js/src/ui/share-buttons.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shareButtons = {
	  facebook: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjM1MTE4RjgyQTk0MTFFNkI2NkU4QjNFNEZENjhDOEUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjM1MTE4RjkyQTk0MTFFNkI2NkU4QjNFNEZENjhDOEUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyMzUxMThGNjJBOTQxMUU2QjY2RThCM0U0RkQ2OEM4RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyMzUxMThGNzJBOTQxMUU2QjY2RThCM0U0RkQ2OEM4RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pp67Uh4AAAHxSURBVHja7Js9SwMxGMdzffEFURQH0UlUEFH8CoKTg5u7mzoJgoObmx9AXQQXv4eLi+gmCI5OgoMUpNKqSL34j/cUymFpY7n0Lv0/8KO0DUfu1yRPkuYCrbViKJWjAoqgCIqgiNZRSFFdimAUTIAR0NfwXSiv36AGSuDRJxHmhlfBGlgCM2BMpMRbq27gAmz5ImIT7IPlNssHSXbpbojoB8dgp4NrhD4MlkcdSvAia6yAPaZPpXZBvtdFTEmL6PkJ1SIYpwilJmMpsJMYzHL6HLIsfwMeZCZZiEm4zLKIAYuy1zLbrPjYNYoWZe9dSnAtwqb1ffo8WNqICHwWkepwKaJmUVb7LOKjm6vLbqRPs8w+lSl1vRWYnaV5i2tsgIUm65K8zDEO0y7CVHRdZpL/jWmhWZSz0DVM/64m3JKfmDWieKaIKF4pIooXiogyUIkiIhFvWRBh1gnDCYr4SiJ9FhKq6AmYVdEmSh3zfq7Na1yBc/mh4n/sVJIYI5Q5MeOIbd1+nDms1y8uxwibhVTR9cDjUkSgUhzcj6AIiqAIiqAIiqAIiqAIiqAIiqAIiqAIiqAIiqAIiuhxETa72M5P8Ls8edv4TNZfcsznoVD1WcQtOJAb1dIaczER5qDpO7hzLSLgQ/IcLCmCIiiidfwIMAAn/Bifuv8fDgAAAABJRU5ErkJggg==',
	  twitter: 'data:image/png;base64,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'
	};
	
	exports.default = shareButtons;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/mikefey/projects/emoji-is-life/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "share-buttons.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 257 */
/*!***************************************!*\
  !*** ./~/react/lib/AutoFocusUtils.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	
	var findDOMNode = __webpack_require__(/*! ./findDOMNode */ 73);
	var focusNode = __webpack_require__(/*! fbjs/lib/focusNode */ 88);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 258 */
/*!***********************************************!*\
  !*** ./~/react/lib/BeforeInputEventPlugin.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(/*! ./EventConstants */ 16);
	var EventPropagators = __webpack_require__(/*! ./EventPropagators */ 32);
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	var FallbackCompositionState = __webpack_require__(/*! ./FallbackCompositionState */ 266);
	var SyntheticCompositionEvent = __webpack_require__(/*! ./SyntheticCompositionEvent */ 296);
	var SyntheticInputEvent = __webpack_require__(/*! ./SyntheticInputEvent */ 299);
	
	var keyOf = __webpack_require__(/*! fbjs/lib/keyOf */ 19);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 259 */
/*!**********************************************!*\
  !*** ./~/react/lib/CSSPropertyOperations.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(/*! ./CSSProperty */ 127);
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	
	var camelizeStyleName = __webpack_require__(/*! fbjs/lib/camelizeStyleName */ 161);
	var dangerousStyleValue = __webpack_require__(/*! ./dangerousStyleValue */ 304);
	var hyphenateStyleName = __webpack_require__(/*! fbjs/lib/hyphenateStyleName */ 166);
	var memoizeStringOnly = __webpack_require__(/*! fbjs/lib/memoizeStringOnly */ 170);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 260 */
/*!******************************************!*\
  !*** ./~/react/lib/ChangeEventPlugin.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(/*! ./EventConstants */ 16);
	var EventPluginHub = __webpack_require__(/*! ./EventPluginHub */ 31);
	var EventPropagators = __webpack_require__(/*! ./EventPropagators */ 32);
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	var SyntheticEvent = __webpack_require__(/*! ./SyntheticEvent */ 25);
	
	var getEventTarget = __webpack_require__(/*! ./getEventTarget */ 76);
	var isEventSupported = __webpack_require__(/*! ./isEventSupported */ 79);
	var isTextInputElement = __webpack_require__(/*! ./isTextInputElement */ 154);
	var keyOf = __webpack_require__(/*! fbjs/lib/keyOf */ 19);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 261 */
/*!*********************************************!*\
  !*** ./~/react/lib/ClientReactRootIndex.js ***!
  \*********************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ },
/* 262 */
/*!*******************************!*\
  !*** ./~/react/lib/Danger.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	
	var createNodesFromMarkup = __webpack_require__(/*! fbjs/lib/createNodesFromMarkup */ 163);
	var emptyFunction = __webpack_require__(/*! fbjs/lib/emptyFunction */ 15);
	var getMarkupWrap = __webpack_require__(/*! fbjs/lib/getMarkupWrap */ 90);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 263 */
/*!************************************************!*\
  !*** ./~/react/lib/DefaultEventPluginOrder.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(/*! fbjs/lib/keyOf */ 19);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 264 */
/*!**********************************************!*\
  !*** ./~/react/lib/EnterLeaveEventPlugin.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(/*! ./EventConstants */ 16);
	var EventPropagators = __webpack_require__(/*! ./EventPropagators */ 32);
	var SyntheticMouseEvent = __webpack_require__(/*! ./SyntheticMouseEvent */ 48);
	
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	var keyOf = __webpack_require__(/*! fbjs/lib/keyOf */ 19);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 265 */
/*!*****************************************!*\
  !*** ./~/react/lib/EventPluginUtils.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(/*! ./EventConstants */ 16);
	var ReactErrorUtils = __webpack_require__(/*! ./ReactErrorUtils */ 142);
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 266 */
/*!*************************************************!*\
  !*** ./~/react/lib/FallbackCompositionState.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(/*! ./PooledClass */ 22);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var getTextContentAccessor = __webpack_require__(/*! ./getTextContentAccessor */ 153);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 267 */
/*!**********************************************!*\
  !*** ./~/react/lib/HTMLDOMPropertyConfig.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(/*! ./DOMProperty */ 26);
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 268 */
/*!******************************!*\
  !*** ./~/react/lib/React.js ***!
  \******************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(/*! ./ReactDOM */ 133);
	var ReactDOMServer = __webpack_require__(/*! ./ReactDOMServer */ 278);
	var ReactIsomorphic = __webpack_require__(/*! ./ReactIsomorphic */ 283);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var deprecated = __webpack_require__(/*! ./deprecated */ 305);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ },
/* 269 */
/*!***************************************************!*\
  !*** ./~/react/lib/ReactBrowserComponentMixin.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(/*! ./ReactInstanceMap */ 33);
	
	var findDOMNode = __webpack_require__(/*! ./findDOMNode */ 73);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ },
/* 270 */
/*!*********************************************!*\
  !*** ./~/react/lib/ReactChildReconciler.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(/*! ./ReactReconciler */ 24);
	
	var instantiateReactComponent = __webpack_require__(/*! ./instantiateReactComponent */ 78);
	var shouldUpdateReactComponent = __webpack_require__(/*! ./shouldUpdateReactComponent */ 81);
	var traverseAllChildren = __webpack_require__(/*! ./traverseAllChildren */ 82);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 271 */
/*!************************************************!*\
  !*** ./~/react/lib/ReactCompositeComponent.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(/*! ./ReactComponentEnvironment */ 69);
	var ReactCurrentOwner = __webpack_require__(/*! ./ReactCurrentOwner */ 17);
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactInstanceMap = __webpack_require__(/*! ./ReactInstanceMap */ 33);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	var ReactPropTypeLocations = __webpack_require__(/*! ./ReactPropTypeLocations */ 47);
	var ReactPropTypeLocationNames = __webpack_require__(/*! ./ReactPropTypeLocationNames */ 46);
	var ReactReconciler = __webpack_require__(/*! ./ReactReconciler */ 24);
	var ReactUpdateQueue = __webpack_require__(/*! ./ReactUpdateQueue */ 71);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var emptyObject = __webpack_require__(/*! fbjs/lib/emptyObject */ 28);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var shouldUpdateReactComponent = __webpack_require__(/*! ./shouldUpdateReactComponent */ 81);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 272 */
/*!***************************************!*\
  !*** ./~/react/lib/ReactDOMButton.js ***!
  \***************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 273 */
/*!******************************************!*\
  !*** ./~/react/lib/ReactDOMComponent.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(/*! ./AutoFocusUtils */ 257);
	var CSSPropertyOperations = __webpack_require__(/*! ./CSSPropertyOperations */ 259);
	var DOMProperty = __webpack_require__(/*! ./DOMProperty */ 26);
	var DOMPropertyOperations = __webpack_require__(/*! ./DOMPropertyOperations */ 66);
	var EventConstants = __webpack_require__(/*! ./EventConstants */ 16);
	var ReactBrowserEventEmitter = __webpack_require__(/*! ./ReactBrowserEventEmitter */ 45);
	var ReactComponentBrowserEnvironment = __webpack_require__(/*! ./ReactComponentBrowserEnvironment */ 68);
	var ReactDOMButton = __webpack_require__(/*! ./ReactDOMButton */ 272);
	var ReactDOMInput = __webpack_require__(/*! ./ReactDOMInput */ 275);
	var ReactDOMOption = __webpack_require__(/*! ./ReactDOMOption */ 276);
	var ReactDOMSelect = __webpack_require__(/*! ./ReactDOMSelect */ 135);
	var ReactDOMTextarea = __webpack_require__(/*! ./ReactDOMTextarea */ 279);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	var ReactMultiChild = __webpack_require__(/*! ./ReactMultiChild */ 284);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	var ReactUpdateQueue = __webpack_require__(/*! ./ReactUpdateQueue */ 71);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var canDefineProperty = __webpack_require__(/*! ./canDefineProperty */ 50);
	var escapeTextContentForBrowser = __webpack_require__(/*! ./escapeTextContentForBrowser */ 51);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var isEventSupported = __webpack_require__(/*! ./isEventSupported */ 79);
	var keyOf = __webpack_require__(/*! fbjs/lib/keyOf */ 19);
	var setInnerHTML = __webpack_require__(/*! ./setInnerHTML */ 52);
	var setTextContent = __webpack_require__(/*! ./setTextContent */ 80);
	var shallowEqual = __webpack_require__(/*! fbjs/lib/shallowEqual */ 91);
	var validateDOMNesting = __webpack_require__(/*! ./validateDOMNesting */ 83);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 274 */
/*!******************************************!*\
  !*** ./~/react/lib/ReactDOMFactories.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactElementValidator = __webpack_require__(/*! ./ReactElementValidator */ 139);
	
	var mapObject = __webpack_require__(/*! fbjs/lib/mapObject */ 169);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 275 */
/*!**************************************!*\
  !*** ./~/react/lib/ReactDOMInput.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(/*! ./ReactDOMIDOperations */ 70);
	var LinkedValueUtils = __webpack_require__(/*! ./LinkedValueUtils */ 67);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 276 */
/*!***************************************!*\
  !*** ./~/react/lib/ReactDOMOption.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(/*! ./ReactChildren */ 130);
	var ReactDOMSelect = __webpack_require__(/*! ./ReactDOMSelect */ 135);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 277 */
/*!******************************************!*\
  !*** ./~/react/lib/ReactDOMSelection.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	
	var getNodeForCharacterOffset = __webpack_require__(/*! ./getNodeForCharacterOffset */ 308);
	var getTextContentAccessor = __webpack_require__(/*! ./getTextContentAccessor */ 153);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 278 */
/*!***************************************!*\
  !*** ./~/react/lib/ReactDOMServer.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(/*! ./ReactDefaultInjection */ 138);
	var ReactServerRendering = __webpack_require__(/*! ./ReactServerRendering */ 289);
	var ReactVersion = __webpack_require__(/*! ./ReactVersion */ 72);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 279 */
/*!*****************************************!*\
  !*** ./~/react/lib/ReactDOMTextarea.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(/*! ./LinkedValueUtils */ 67);
	var ReactDOMIDOperations = __webpack_require__(/*! ./ReactDOMIDOperations */ 70);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 280 */
/*!***********************************************!*\
  !*** ./~/react/lib/ReactEventEmitterMixin.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(/*! ./EventPluginHub */ 31);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 281 */
/*!*******************************************!*\
  !*** ./~/react/lib/ReactEventListener.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(/*! fbjs/lib/EventListener */ 86);
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	var PooledClass = __webpack_require__(/*! ./PooledClass */ 22);
	var ReactInstanceHandles = __webpack_require__(/*! ./ReactInstanceHandles */ 27);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var getEventTarget = __webpack_require__(/*! ./getEventTarget */ 76);
	var getUnboundedScrollPosition = __webpack_require__(/*! fbjs/lib/getUnboundedScrollPosition */ 164);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 282 */
/*!***************************************!*\
  !*** ./~/react/lib/ReactInjection.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(/*! ./DOMProperty */ 26);
	var EventPluginHub = __webpack_require__(/*! ./EventPluginHub */ 31);
	var ReactComponentEnvironment = __webpack_require__(/*! ./ReactComponentEnvironment */ 69);
	var ReactClass = __webpack_require__(/*! ./ReactClass */ 131);
	var ReactEmptyComponent = __webpack_require__(/*! ./ReactEmptyComponent */ 140);
	var ReactBrowserEventEmitter = __webpack_require__(/*! ./ReactBrowserEventEmitter */ 45);
	var ReactNativeComponent = __webpack_require__(/*! ./ReactNativeComponent */ 146);
	var ReactPerf = __webpack_require__(/*! ./ReactPerf */ 13);
	var ReactRootIndex = __webpack_require__(/*! ./ReactRootIndex */ 149);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 283 */
/*!****************************************!*\
  !*** ./~/react/lib/ReactIsomorphic.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(/*! ./ReactChildren */ 130);
	var ReactComponent = __webpack_require__(/*! ./ReactComponent */ 132);
	var ReactClass = __webpack_require__(/*! ./ReactClass */ 131);
	var ReactDOMFactories = __webpack_require__(/*! ./ReactDOMFactories */ 274);
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactElementValidator = __webpack_require__(/*! ./ReactElementValidator */ 139);
	var ReactPropTypes = __webpack_require__(/*! ./ReactPropTypes */ 148);
	var ReactVersion = __webpack_require__(/*! ./ReactVersion */ 72);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var onlyChild = __webpack_require__(/*! ./onlyChild */ 309);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ },
/* 284 */
/*!****************************************!*\
  !*** ./~/react/lib/ReactMultiChild.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(/*! ./ReactComponentEnvironment */ 69);
	var ReactMultiChildUpdateTypes = __webpack_require__(/*! ./ReactMultiChildUpdateTypes */ 145);
	
	var ReactCurrentOwner = __webpack_require__(/*! ./ReactCurrentOwner */ 17);
	var ReactReconciler = __webpack_require__(/*! ./ReactReconciler */ 24);
	var ReactChildReconciler = __webpack_require__(/*! ./ReactChildReconciler */ 270);
	
	var flattenChildren = __webpack_require__(/*! ./flattenChildren */ 306);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 285 */
/*!***********************************!*\
  !*** ./~/react/lib/ReactOwner.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 286 */
/*!**************************************************!*\
  !*** ./~/react/lib/ReactReconcileTransaction.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(/*! ./CallbackQueue */ 65);
	var PooledClass = __webpack_require__(/*! ./PooledClass */ 22);
	var ReactBrowserEventEmitter = __webpack_require__(/*! ./ReactBrowserEventEmitter */ 45);
	var ReactDOMFeatureFlags = __webpack_require__(/*! ./ReactDOMFeatureFlags */ 134);
	var ReactInputSelection = __webpack_require__(/*! ./ReactInputSelection */ 143);
	var Transaction = __webpack_require__(/*! ./Transaction */ 49);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 287 */
/*!*********************************!*\
  !*** ./~/react/lib/ReactRef.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(/*! ./ReactOwner */ 285);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 288 */
/*!****************************************************!*\
  !*** ./~/react/lib/ReactServerBatchingStrategy.js ***!
  \****************************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 289 */
/*!*********************************************!*\
  !*** ./~/react/lib/ReactServerRendering.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(/*! ./ReactDefaultBatchingStrategy */ 137);
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	var ReactInstanceHandles = __webpack_require__(/*! ./ReactInstanceHandles */ 27);
	var ReactMarkupChecksum = __webpack_require__(/*! ./ReactMarkupChecksum */ 144);
	var ReactServerBatchingStrategy = __webpack_require__(/*! ./ReactServerBatchingStrategy */ 288);
	var ReactServerRenderingTransaction = __webpack_require__(/*! ./ReactServerRenderingTransaction */ 290);
	var ReactUpdates = __webpack_require__(/*! ./ReactUpdates */ 14);
	
	var emptyObject = __webpack_require__(/*! fbjs/lib/emptyObject */ 28);
	var instantiateReactComponent = __webpack_require__(/*! ./instantiateReactComponent */ 78);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 290 */
/*!********************************************************!*\
  !*** ./~/react/lib/ReactServerRenderingTransaction.js ***!
  \********************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(/*! ./PooledClass */ 22);
	var CallbackQueue = __webpack_require__(/*! ./CallbackQueue */ 65);
	var Transaction = __webpack_require__(/*! ./Transaction */ 49);
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var emptyFunction = __webpack_require__(/*! fbjs/lib/emptyFunction */ 15);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 291 */
/*!*********************************************!*\
  !*** ./~/react/lib/SVGDOMPropertyConfig.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(/*! ./DOMProperty */ 26);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 292 */
/*!******************************************!*\
  !*** ./~/react/lib/SelectEventPlugin.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(/*! ./EventConstants */ 16);
	var EventPropagators = __webpack_require__(/*! ./EventPropagators */ 32);
	var ExecutionEnvironment = __webpack_require__(/*! fbjs/lib/ExecutionEnvironment */ 8);
	var ReactInputSelection = __webpack_require__(/*! ./ReactInputSelection */ 143);
	var SyntheticEvent = __webpack_require__(/*! ./SyntheticEvent */ 25);
	
	var getActiveElement = __webpack_require__(/*! fbjs/lib/getActiveElement */ 89);
	var isTextInputElement = __webpack_require__(/*! ./isTextInputElement */ 154);
	var keyOf = __webpack_require__(/*! fbjs/lib/keyOf */ 19);
	var shallowEqual = __webpack_require__(/*! fbjs/lib/shallowEqual */ 91);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 293 */
/*!*********************************************!*\
  !*** ./~/react/lib/ServerReactRootIndex.js ***!
  \*********************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ },
/* 294 */
/*!******************************************!*\
  !*** ./~/react/lib/SimpleEventPlugin.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(/*! ./EventConstants */ 16);
	var EventListener = __webpack_require__(/*! fbjs/lib/EventListener */ 86);
	var EventPropagators = __webpack_require__(/*! ./EventPropagators */ 32);
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	var SyntheticClipboardEvent = __webpack_require__(/*! ./SyntheticClipboardEvent */ 295);
	var SyntheticEvent = __webpack_require__(/*! ./SyntheticEvent */ 25);
	var SyntheticFocusEvent = __webpack_require__(/*! ./SyntheticFocusEvent */ 298);
	var SyntheticKeyboardEvent = __webpack_require__(/*! ./SyntheticKeyboardEvent */ 300);
	var SyntheticMouseEvent = __webpack_require__(/*! ./SyntheticMouseEvent */ 48);
	var SyntheticDragEvent = __webpack_require__(/*! ./SyntheticDragEvent */ 297);
	var SyntheticTouchEvent = __webpack_require__(/*! ./SyntheticTouchEvent */ 301);
	var SyntheticUIEvent = __webpack_require__(/*! ./SyntheticUIEvent */ 34);
	var SyntheticWheelEvent = __webpack_require__(/*! ./SyntheticWheelEvent */ 302);
	
	var emptyFunction = __webpack_require__(/*! fbjs/lib/emptyFunction */ 15);
	var getEventCharCode = __webpack_require__(/*! ./getEventCharCode */ 74);
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	var keyOf = __webpack_require__(/*! fbjs/lib/keyOf */ 19);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 295 */
/*!************************************************!*\
  !*** ./~/react/lib/SyntheticClipboardEvent.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(/*! ./SyntheticEvent */ 25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 296 */
/*!**************************************************!*\
  !*** ./~/react/lib/SyntheticCompositionEvent.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(/*! ./SyntheticEvent */ 25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 297 */
/*!*******************************************!*\
  !*** ./~/react/lib/SyntheticDragEvent.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(/*! ./SyntheticMouseEvent */ 48);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 298 */
/*!********************************************!*\
  !*** ./~/react/lib/SyntheticFocusEvent.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(/*! ./SyntheticUIEvent */ 34);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 299 */
/*!********************************************!*\
  !*** ./~/react/lib/SyntheticInputEvent.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(/*! ./SyntheticEvent */ 25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 300 */
/*!***********************************************!*\
  !*** ./~/react/lib/SyntheticKeyboardEvent.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(/*! ./SyntheticUIEvent */ 34);
	
	var getEventCharCode = __webpack_require__(/*! ./getEventCharCode */ 74);
	var getEventKey = __webpack_require__(/*! ./getEventKey */ 307);
	var getEventModifierState = __webpack_require__(/*! ./getEventModifierState */ 75);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 301 */
/*!********************************************!*\
  !*** ./~/react/lib/SyntheticTouchEvent.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(/*! ./SyntheticUIEvent */ 34);
	
	var getEventModifierState = __webpack_require__(/*! ./getEventModifierState */ 75);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 302 */
/*!********************************************!*\
  !*** ./~/react/lib/SyntheticWheelEvent.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(/*! ./SyntheticMouseEvent */ 48);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 303 */
/*!********************************!*\
  !*** ./~/react/lib/adler32.js ***!
  \********************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 304 */
/*!********************************************!*\
  !*** ./~/react/lib/dangerousStyleValue.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(/*! ./CSSProperty */ 127);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 305 */
/*!***********************************!*\
  !*** ./~/react/lib/deprecated.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(/*! ./Object.assign */ 4);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ },
/* 306 */
/*!****************************************!*\
  !*** ./~/react/lib/flattenChildren.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(/*! ./traverseAllChildren */ 82);
	var warning = __webpack_require__(/*! fbjs/lib/warning */ 3);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 307 */
/*!************************************!*\
  !*** ./~/react/lib/getEventKey.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(/*! ./getEventCharCode */ 74);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 308 */
/*!**************************************************!*\
  !*** ./~/react/lib/getNodeForCharacterOffset.js ***!
  \**************************************************/
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 309 */
/*!**********************************!*\
  !*** ./~/react/lib/onlyChild.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(/*! ./ReactElement */ 11);
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 310 */
/*!******************************************************!*\
  !*** ./~/react/lib/quoteAttributeValueForBrowser.js ***!
  \******************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(/*! ./escapeTextContentForBrowser */ 51);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 311 */
/*!***************************************************!*\
  !*** ./~/react/lib/renderSubtreeIntoContainer.js ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(/*! ./ReactMount */ 10);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 312 */
/*!************************************************!*\
  !*** ./~/resource-loader/~/async/lib/async.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/*!
	 * async
	 * https://github.com/caolan/async
	 *
	 * Copyright 2010-2014 Caolan McMahon
	 * Released under the MIT license
	 */
	/*jshint onevar: false, indent:4 */
	/*global setImmediate: false, setTimeout: false, console: false */
	(function () {
	
	    var async = {};
	
	    // global on the server, window in the browser
	    var root, previous_async;
	
	    root = this;
	    if (root != null) {
	      previous_async = root.async;
	    }
	
	    async.noConflict = function () {
	        root.async = previous_async;
	        return async;
	    };
	
	    function only_once(fn) {
	        var called = false;
	        return function() {
	            if (called) throw new Error("Callback was already called.");
	            called = true;
	            fn.apply(root, arguments);
	        }
	    }
	
	    //// cross-browser compatiblity functions ////
	
	    var _toString = Object.prototype.toString;
	
	    var _isArray = Array.isArray || function (obj) {
	        return _toString.call(obj) === '[object Array]';
	    };
	
	    var _each = function (arr, iterator) {
	        for (var i = 0; i < arr.length; i += 1) {
	            iterator(arr[i], i, arr);
	        }
	    };
	
	    var _map = function (arr, iterator) {
	        if (arr.map) {
	            return arr.map(iterator);
	        }
	        var results = [];
	        _each(arr, function (x, i, a) {
	            results.push(iterator(x, i, a));
	        });
	        return results;
	    };
	
	    var _reduce = function (arr, iterator, memo) {
	        if (arr.reduce) {
	            return arr.reduce(iterator, memo);
	        }
	        _each(arr, function (x, i, a) {
	            memo = iterator(memo, x, i, a);
	        });
	        return memo;
	    };
	
	    var _keys = function (obj) {
	        if (Object.keys) {
	            return Object.keys(obj);
	        }
	        var keys = [];
	        for (var k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                keys.push(k);
	            }
	        }
	        return keys;
	    };
	
	    //// exported async module functions ////
	
	    //// nextTick implementation with browser-compatible fallback ////
	    if (typeof process === 'undefined' || !(process.nextTick)) {
	        if (typeof setImmediate === 'function') {
	            async.nextTick = function (fn) {
	                // not a direct alias for IE10 compatibility
	                setImmediate(fn);
	            };
	            async.setImmediate = async.nextTick;
	        }
	        else {
	            async.nextTick = function (fn) {
	                setTimeout(fn, 0);
	            };
	            async.setImmediate = async.nextTick;
	        }
	    }
	    else {
	        async.nextTick = process.nextTick;
	        if (typeof setImmediate !== 'undefined') {
	            async.setImmediate = function (fn) {
	              // not a direct alias for IE10 compatibility
	              setImmediate(fn);
	            };
	        }
	        else {
	            async.setImmediate = async.nextTick;
	        }
	    }
	
	    async.each = function (arr, iterator, callback) {
	        callback = callback || function () {};
	        if (!arr.length) {
	            return callback();
	        }
	        var completed = 0;
	        _each(arr, function (x) {
	            iterator(x, only_once(done) );
	        });
	        function done(err) {
	          if (err) {
	              callback(err);
	              callback = function () {};
	          }
	          else {
	              completed += 1;
	              if (completed >= arr.length) {
	                  callback();
	              }
	          }
	        }
	    };
	    async.forEach = async.each;
	
	    async.eachSeries = function (arr, iterator, callback) {
	        callback = callback || function () {};
	        if (!arr.length) {
	            return callback();
	        }
	        var completed = 0;
	        var iterate = function () {
	            iterator(arr[completed], function (err) {
	                if (err) {
	                    callback(err);
	                    callback = function () {};
	                }
	                else {
	                    completed += 1;
	                    if (completed >= arr.length) {
	                        callback();
	                    }
	                    else {
	                        iterate();
	                    }
	                }
	            });
	        };
	        iterate();
	    };
	    async.forEachSeries = async.eachSeries;
	
	    async.eachLimit = function (arr, limit, iterator, callback) {
	        var fn = _eachLimit(limit);
	        fn.apply(null, [arr, iterator, callback]);
	    };
	    async.forEachLimit = async.eachLimit;
	
	    var _eachLimit = function (limit) {
	
	        return function (arr, iterator, callback) {
	            callback = callback || function () {};
	            if (!arr.length || limit <= 0) {
	                return callback();
	            }
	            var completed = 0;
	            var started = 0;
	            var running = 0;
	
	            (function replenish () {
	                if (completed >= arr.length) {
	                    return callback();
	                }
	
	                while (running < limit && started < arr.length) {
	                    started += 1;
	                    running += 1;
	                    iterator(arr[started - 1], function (err) {
	                        if (err) {
	                            callback(err);
	                            callback = function () {};
	                        }
	                        else {
	                            completed += 1;
	                            running -= 1;
	                            if (completed >= arr.length) {
	                                callback();
	                            }
	                            else {
	                                replenish();
	                            }
	                        }
	                    });
	                }
	            })();
	        };
	    };
	
	
	    var doParallel = function (fn) {
	        return function () {
	            var args = Array.prototype.slice.call(arguments);
	            return fn.apply(null, [async.each].concat(args));
	        };
	    };
	    var doParallelLimit = function(limit, fn) {
	        return function () {
	            var args = Array.prototype.slice.call(arguments);
	            return fn.apply(null, [_eachLimit(limit)].concat(args));
	        };
	    };
	    var doSeries = function (fn) {
	        return function () {
	            var args = Array.prototype.slice.call(arguments);
	            return fn.apply(null, [async.eachSeries].concat(args));
	        };
	    };
	
	
	    var _asyncMap = function (eachfn, arr, iterator, callback) {
	        arr = _map(arr, function (x, i) {
	            return {index: i, value: x};
	        });
	        if (!callback) {
	            eachfn(arr, function (x, callback) {
	                iterator(x.value, function (err) {
	                    callback(err);
	                });
	            });
	        } else {
	            var results = [];
	            eachfn(arr, function (x, callback) {
	                iterator(x.value, function (err, v) {
	                    results[x.index] = v;
	                    callback(err);
	                });
	            }, function (err) {
	                callback(err, results);
	            });
	        }
	    };
	    async.map = doParallel(_asyncMap);
	    async.mapSeries = doSeries(_asyncMap);
	    async.mapLimit = function (arr, limit, iterator, callback) {
	        return _mapLimit(limit)(arr, iterator, callback);
	    };
	
	    var _mapLimit = function(limit) {
	        return doParallelLimit(limit, _asyncMap);
	    };
	
	    // reduce only has a series version, as doing reduce in parallel won't
	    // work in many situations.
	    async.reduce = function (arr, memo, iterator, callback) {
	        async.eachSeries(arr, function (x, callback) {
	            iterator(memo, x, function (err, v) {
	                memo = v;
	                callback(err);
	            });
	        }, function (err) {
	            callback(err, memo);
	        });
	    };
	    // inject alias
	    async.inject = async.reduce;
	    // foldl alias
	    async.foldl = async.reduce;
	
	    async.reduceRight = function (arr, memo, iterator, callback) {
	        var reversed = _map(arr, function (x) {
	            return x;
	        }).reverse();
	        async.reduce(reversed, memo, iterator, callback);
	    };
	    // foldr alias
	    async.foldr = async.reduceRight;
	
	    var _filter = function (eachfn, arr, iterator, callback) {
	        var results = [];
	        arr = _map(arr, function (x, i) {
	            return {index: i, value: x};
	        });
	        eachfn(arr, function (x, callback) {
	            iterator(x.value, function (v) {
	                if (v) {
	                    results.push(x);
	                }
	                callback();
	            });
	        }, function (err) {
	            callback(_map(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), function (x) {
	                return x.value;
	            }));
	        });
	    };
	    async.filter = doParallel(_filter);
	    async.filterSeries = doSeries(_filter);
	    // select alias
	    async.select = async.filter;
	    async.selectSeries = async.filterSeries;
	
	    var _reject = function (eachfn, arr, iterator, callback) {
	        var results = [];
	        arr = _map(arr, function (x, i) {
	            return {index: i, value: x};
	        });
	        eachfn(arr, function (x, callback) {
	            iterator(x.value, function (v) {
	                if (!v) {
	                    results.push(x);
	                }
	                callback();
	            });
	        }, function (err) {
	            callback(_map(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), function (x) {
	                return x.value;
	            }));
	        });
	    };
	    async.reject = doParallel(_reject);
	    async.rejectSeries = doSeries(_reject);
	
	    var _detect = function (eachfn, arr, iterator, main_callback) {
	        eachfn(arr, function (x, callback) {
	            iterator(x, function (result) {
	                if (result) {
	                    main_callback(x);
	                    main_callback = function () {};
	                }
	                else {
	                    callback();
	                }
	            });
	        }, function (err) {
	            main_callback();
	        });
	    };
	    async.detect = doParallel(_detect);
	    async.detectSeries = doSeries(_detect);
	
	    async.some = function (arr, iterator, main_callback) {
	        async.each(arr, function (x, callback) {
	            iterator(x, function (v) {
	                if (v) {
	                    main_callback(true);
	                    main_callback = function () {};
	                }
	                callback();
	            });
	        }, function (err) {
	            main_callback(false);
	        });
	    };
	    // any alias
	    async.any = async.some;
	
	    async.every = function (arr, iterator, main_callback) {
	        async.each(arr, function (x, callback) {
	            iterator(x, function (v) {
	                if (!v) {
	                    main_callback(false);
	                    main_callback = function () {};
	                }
	                callback();
	            });
	        }, function (err) {
	            main_callback(true);
	        });
	    };
	    // all alias
	    async.all = async.every;
	
	    async.sortBy = function (arr, iterator, callback) {
	        async.map(arr, function (x, callback) {
	            iterator(x, function (err, criteria) {
	                if (err) {
	                    callback(err);
	                }
	                else {
	                    callback(null, {value: x, criteria: criteria});
	                }
	            });
	        }, function (err, results) {
	            if (err) {
	                return callback(err);
	            }
	            else {
	                var fn = function (left, right) {
	                    var a = left.criteria, b = right.criteria;
	                    return a < b ? -1 : a > b ? 1 : 0;
	                };
	                callback(null, _map(results.sort(fn), function (x) {
	                    return x.value;
	                }));
	            }
	        });
	    };
	
	    async.auto = function (tasks, callback) {
	        callback = callback || function () {};
	        var keys = _keys(tasks);
	        var remainingTasks = keys.length
	        if (!remainingTasks) {
	            return callback();
	        }
	
	        var results = {};
	
	        var listeners = [];
	        var addListener = function (fn) {
	            listeners.unshift(fn);
	        };
	        var removeListener = function (fn) {
	            for (var i = 0; i < listeners.length; i += 1) {
	                if (listeners[i] === fn) {
	                    listeners.splice(i, 1);
	                    return;
	                }
	            }
	        };
	        var taskComplete = function () {
	            remainingTasks--
	            _each(listeners.slice(0), function (fn) {
	                fn();
	            });
	        };
	
	        addListener(function () {
	            if (!remainingTasks) {
	                var theCallback = callback;
	                // prevent final callback from calling itself if it errors
	                callback = function () {};
	
	                theCallback(null, results);
	            }
	        });
	
	        _each(keys, function (k) {
	            var task = _isArray(tasks[k]) ? tasks[k]: [tasks[k]];
	            var taskCallback = function (err) {
	                var args = Array.prototype.slice.call(arguments, 1);
	                if (args.length <= 1) {
	                    args = args[0];
	                }
	                if (err) {
	                    var safeResults = {};
	                    _each(_keys(results), function(rkey) {
	                        safeResults[rkey] = results[rkey];
	                    });
	                    safeResults[k] = args;
	                    callback(err, safeResults);
	                    // stop subsequent errors hitting callback multiple times
	                    callback = function () {};
	                }
	                else {
	                    results[k] = args;
	                    async.setImmediate(taskComplete);
	                }
	            };
	            var requires = task.slice(0, Math.abs(task.length - 1)) || [];
	            var ready = function () {
	                return _reduce(requires, function (a, x) {
	                    return (a && results.hasOwnProperty(x));
	                }, true) && !results.hasOwnProperty(k);
	            };
	            if (ready()) {
	                task[task.length - 1](taskCallback, results);
	            }
	            else {
	                var listener = function () {
	                    if (ready()) {
	                        removeListener(listener);
	                        task[task.length - 1](taskCallback, results);
	                    }
	                };
	                addListener(listener);
	            }
	        });
	    };
	
	    async.retry = function(times, task, callback) {
	        var DEFAULT_TIMES = 5;
	        var attempts = [];
	        // Use defaults if times not passed
	        if (typeof times === 'function') {
	            callback = task;
	            task = times;
	            times = DEFAULT_TIMES;
	        }
	        // Make sure times is a number
	        times = parseInt(times, 10) || DEFAULT_TIMES;
	        var wrappedTask = function(wrappedCallback, wrappedResults) {
	            var retryAttempt = function(task, finalAttempt) {
	                return function(seriesCallback) {
	                    task(function(err, result){
	                        seriesCallback(!err || finalAttempt, {err: err, result: result});
	                    }, wrappedResults);
	                };
	            };
	            while (times) {
	                attempts.push(retryAttempt(task, !(times-=1)));
	            }
	            async.series(attempts, function(done, data){
	                data = data[data.length - 1];
	                (wrappedCallback || callback)(data.err, data.result);
	            });
	        }
	        // If a callback is passed, run this as a controll flow
	        return callback ? wrappedTask() : wrappedTask
	    };
	
	    async.waterfall = function (tasks, callback) {
	        callback = callback || function () {};
	        if (!_isArray(tasks)) {
	          var err = new Error('First argument to waterfall must be an array of functions');
	          return callback(err);
	        }
	        if (!tasks.length) {
	            return callback();
	        }
	        var wrapIterator = function (iterator) {
	            return function (err) {
	                if (err) {
	                    callback.apply(null, arguments);
	                    callback = function () {};
	                }
	                else {
	                    var args = Array.prototype.slice.call(arguments, 1);
	                    var next = iterator.next();
	                    if (next) {
	                        args.push(wrapIterator(next));
	                    }
	                    else {
	                        args.push(callback);
	                    }
	                    async.setImmediate(function () {
	                        iterator.apply(null, args);
	                    });
	                }
	            };
	        };
	        wrapIterator(async.iterator(tasks))();
	    };
	
	    var _parallel = function(eachfn, tasks, callback) {
	        callback = callback || function () {};
	        if (_isArray(tasks)) {
	            eachfn.map(tasks, function (fn, callback) {
	                if (fn) {
	                    fn(function (err) {
	                        var args = Array.prototype.slice.call(arguments, 1);
	                        if (args.length <= 1) {
	                            args = args[0];
	                        }
	                        callback.call(null, err, args);
	                    });
	                }
	            }, callback);
	        }
	        else {
	            var results = {};
	            eachfn.each(_keys(tasks), function (k, callback) {
	                tasks[k](function (err) {
	                    var args = Array.prototype.slice.call(arguments, 1);
	                    if (args.length <= 1) {
	                        args = args[0];
	                    }
	                    results[k] = args;
	                    callback(err);
	                });
	            }, function (err) {
	                callback(err, results);
	            });
	        }
	    };
	
	    async.parallel = function (tasks, callback) {
	        _parallel({ map: async.map, each: async.each }, tasks, callback);
	    };
	
	    async.parallelLimit = function(tasks, limit, callback) {
	        _parallel({ map: _mapLimit(limit), each: _eachLimit(limit) }, tasks, callback);
	    };
	
	    async.series = function (tasks, callback) {
	        callback = callback || function () {};
	        if (_isArray(tasks)) {
	            async.mapSeries(tasks, function (fn, callback) {
	                if (fn) {
	                    fn(function (err) {
	                        var args = Array.prototype.slice.call(arguments, 1);
	                        if (args.length <= 1) {
	                            args = args[0];
	                        }
	                        callback.call(null, err, args);
	                    });
	                }
	            }, callback);
	        }
	        else {
	            var results = {};
	            async.eachSeries(_keys(tasks), function (k, callback) {
	                tasks[k](function (err) {
	                    var args = Array.prototype.slice.call(arguments, 1);
	                    if (args.length <= 1) {
	                        args = args[0];
	                    }
	                    results[k] = args;
	                    callback(err);
	                });
	            }, function (err) {
	                callback(err, results);
	            });
	        }
	    };
	
	    async.iterator = function (tasks) {
	        var makeCallback = function (index) {
	            var fn = function () {
	                if (tasks.length) {
	                    tasks[index].apply(null, arguments);
	                }
	                return fn.next();
	            };
	            fn.next = function () {
	                return (index < tasks.length - 1) ? makeCallback(index + 1): null;
	            };
	            return fn;
	        };
	        return makeCallback(0);
	    };
	
	    async.apply = function (fn) {
	        var args = Array.prototype.slice.call(arguments, 1);
	        return function () {
	            return fn.apply(
	                null, args.concat(Array.prototype.slice.call(arguments))
	            );
	        };
	    };
	
	    var _concat = function (eachfn, arr, fn, callback) {
	        var r = [];
	        eachfn(arr, function (x, cb) {
	            fn(x, function (err, y) {
	                r = r.concat(y || []);
	                cb(err);
	            });
	        }, function (err) {
	            callback(err, r);
	        });
	    };
	    async.concat = doParallel(_concat);
	    async.concatSeries = doSeries(_concat);
	
	    async.whilst = function (test, iterator, callback) {
	        if (test()) {
	            iterator(function (err) {
	                if (err) {
	                    return callback(err);
	                }
	                async.whilst(test, iterator, callback);
	            });
	        }
	        else {
	            callback();
	        }
	    };
	
	    async.doWhilst = function (iterator, test, callback) {
	        iterator(function (err) {
	            if (err) {
	                return callback(err);
	            }
	            var args = Array.prototype.slice.call(arguments, 1);
	            if (test.apply(null, args)) {
	                async.doWhilst(iterator, test, callback);
	            }
	            else {
	                callback();
	            }
	        });
	    };
	
	    async.until = function (test, iterator, callback) {
	        if (!test()) {
	            iterator(function (err) {
	                if (err) {
	                    return callback(err);
	                }
	                async.until(test, iterator, callback);
	            });
	        }
	        else {
	            callback();
	        }
	    };
	
	    async.doUntil = function (iterator, test, callback) {
	        iterator(function (err) {
	            if (err) {
	                return callback(err);
	            }
	            var args = Array.prototype.slice.call(arguments, 1);
	            if (!test.apply(null, args)) {
	                async.doUntil(iterator, test, callback);
	            }
	            else {
	                callback();
	            }
	        });
	    };
	
	    async.queue = function (worker, concurrency) {
	        if (concurrency === undefined) {
	            concurrency = 1;
	        }
	        function _insert(q, data, pos, callback) {
	          if (!q.started){
	            q.started = true;
	          }
	          if (!_isArray(data)) {
	              data = [data];
	          }
	          if(data.length == 0) {
	             // call drain immediately if there are no tasks
	             return async.setImmediate(function() {
	                 if (q.drain) {
	                     q.drain();
	                 }
	             });
	          }
	          _each(data, function(task) {
	              var item = {
	                  data: task,
	                  callback: typeof callback === 'function' ? callback : null
	              };
	
	              if (pos) {
	                q.tasks.unshift(item);
	              } else {
	                q.tasks.push(item);
	              }
	
	              if (q.saturated && q.tasks.length === q.concurrency) {
	                  q.saturated();
	              }
	              async.setImmediate(q.process);
	          });
	        }
	
	        var workers = 0;
	        var q = {
	            tasks: [],
	            concurrency: concurrency,
	            saturated: null,
	            empty: null,
	            drain: null,
	            started: false,
	            paused: false,
	            push: function (data, callback) {
	              _insert(q, data, false, callback);
	            },
	            kill: function () {
	              q.drain = null;
	              q.tasks = [];
	            },
	            unshift: function (data, callback) {
	              _insert(q, data, true, callback);
	            },
	            process: function () {
	                if (!q.paused && workers < q.concurrency && q.tasks.length) {
	                    var task = q.tasks.shift();
	                    if (q.empty && q.tasks.length === 0) {
	                        q.empty();
	                    }
	                    workers += 1;
	                    var next = function () {
	                        workers -= 1;
	                        if (task.callback) {
	                            task.callback.apply(task, arguments);
	                        }
	                        if (q.drain && q.tasks.length + workers === 0) {
	                            q.drain();
	                        }
	                        q.process();
	                    };
	                    var cb = only_once(next);
	                    worker(task.data, cb);
	                }
	            },
	            length: function () {
	                return q.tasks.length;
	            },
	            running: function () {
	                return workers;
	            },
	            idle: function() {
	                return q.tasks.length + workers === 0;
	            },
	            pause: function () {
	                if (q.paused === true) { return; }
	                q.paused = true;
	            },
	            resume: function () {
	                if (q.paused === false) { return; }
	                q.paused = false;
	                // Need to call q.process once per concurrent
	                // worker to preserve full concurrency after pause
	                for (var w = 1; w <= q.concurrency; w++) {
	                    async.setImmediate(q.process);
	                }
	            }
	        };
	        return q;
	    };
	
	    async.priorityQueue = function (worker, concurrency) {
	
	        function _compareTasks(a, b){
	          return a.priority - b.priority;
	        };
	
	        function _binarySearch(sequence, item, compare) {
	          var beg = -1,
	              end = sequence.length - 1;
	          while (beg < end) {
	            var mid = beg + ((end - beg + 1) >>> 1);
	            if (compare(item, sequence[mid]) >= 0) {
	              beg = mid;
	            } else {
	              end = mid - 1;
	            }
	          }
	          return beg;
	        }
	
	        function _insert(q, data, priority, callback) {
	          if (!q.started){
	            q.started = true;
	          }
	          if (!_isArray(data)) {
	              data = [data];
	          }
	          if(data.length == 0) {
	             // call drain immediately if there are no tasks
	             return async.setImmediate(function() {
	                 if (q.drain) {
	                     q.drain();
	                 }
	             });
	          }
	          _each(data, function(task) {
	              var item = {
	                  data: task,
	                  priority: priority,
	                  callback: typeof callback === 'function' ? callback : null
	              };
	
	              q.tasks.splice(_binarySearch(q.tasks, item, _compareTasks) + 1, 0, item);
	
	              if (q.saturated && q.tasks.length === q.concurrency) {
	                  q.saturated();
	              }
	              async.setImmediate(q.process);
	          });
	        }
	
	        // Start with a normal queue
	        var q = async.queue(worker, concurrency);
	
	        // Override push to accept second parameter representing priority
	        q.push = function (data, priority, callback) {
	          _insert(q, data, priority, callback);
	        };
	
	        // Remove unshift function
	        delete q.unshift;
	
	        return q;
	    };
	
	    async.cargo = function (worker, payload) {
	        var working     = false,
	            tasks       = [];
	
	        var cargo = {
	            tasks: tasks,
	            payload: payload,
	            saturated: null,
	            empty: null,
	            drain: null,
	            drained: true,
	            push: function (data, callback) {
	                if (!_isArray(data)) {
	                    data = [data];
	                }
	                _each(data, function(task) {
	                    tasks.push({
	                        data: task,
	                        callback: typeof callback === 'function' ? callback : null
	                    });
	                    cargo.drained = false;
	                    if (cargo.saturated && tasks.length === payload) {
	                        cargo.saturated();
	                    }
	                });
	                async.setImmediate(cargo.process);
	            },
	            process: function process() {
	                if (working) return;
	                if (tasks.length === 0) {
	                    if(cargo.drain && !cargo.drained) cargo.drain();
	                    cargo.drained = true;
	                    return;
	                }
	
	                var ts = typeof payload === 'number'
	                            ? tasks.splice(0, payload)
	                            : tasks.splice(0, tasks.length);
	
	                var ds = _map(ts, function (task) {
	                    return task.data;
	                });
	
	                if(cargo.empty) cargo.empty();
	                working = true;
	                worker(ds, function () {
	                    working = false;
	
	                    var args = arguments;
	                    _each(ts, function (data) {
	                        if (data.callback) {
	                            data.callback.apply(null, args);
	                        }
	                    });
	
	                    process();
	                });
	            },
	            length: function () {
	                return tasks.length;
	            },
	            running: function () {
	                return working;
	            }
	        };
	        return cargo;
	    };
	
	    var _console_fn = function (name) {
	        return function (fn) {
	            var args = Array.prototype.slice.call(arguments, 1);
	            fn.apply(null, args.concat([function (err) {
	                var args = Array.prototype.slice.call(arguments, 1);
	                if (typeof console !== 'undefined') {
	                    if (err) {
	                        if (console.error) {
	                            console.error(err);
	                        }
	                    }
	                    else if (console[name]) {
	                        _each(args, function (x) {
	                            console[name](x);
	                        });
	                    }
	                }
	            }]));
	        };
	    };
	    async.log = _console_fn('log');
	    async.dir = _console_fn('dir');
	    /*async.info = _console_fn('info');
	    async.warn = _console_fn('warn');
	    async.error = _console_fn('error');*/
	
	    async.memoize = function (fn, hasher) {
	        var memo = {};
	        var queues = {};
	        hasher = hasher || function (x) {
	            return x;
	        };
	        var memoized = function () {
	            var args = Array.prototype.slice.call(arguments);
	            var callback = args.pop();
	            var key = hasher.apply(null, args);
	            if (key in memo) {
	                async.nextTick(function () {
	                    callback.apply(null, memo[key]);
	                });
	            }
	            else if (key in queues) {
	                queues[key].push(callback);
	            }
	            else {
	                queues[key] = [callback];
	                fn.apply(null, args.concat([function () {
	                    memo[key] = arguments;
	                    var q = queues[key];
	                    delete queues[key];
	                    for (var i = 0, l = q.length; i < l; i++) {
	                      q[i].apply(null, arguments);
	                    }
	                }]));
	            }
	        };
	        memoized.memo = memo;
	        memoized.unmemoized = fn;
	        return memoized;
	    };
	
	    async.unmemoize = function (fn) {
	      return function () {
	        return (fn.unmemoized || fn).apply(null, arguments);
	      };
	    };
	
	    async.times = function (count, iterator, callback) {
	        var counter = [];
	        for (var i = 0; i < count; i++) {
	            counter.push(i);
	        }
	        return async.map(counter, iterator, callback);
	    };
	
	    async.timesSeries = function (count, iterator, callback) {
	        var counter = [];
	        for (var i = 0; i < count; i++) {
	            counter.push(i);
	        }
	        return async.mapSeries(counter, iterator, callback);
	    };
	
	    async.seq = function (/* functions... */) {
	        var fns = arguments;
	        return function () {
	            var that = this;
	            var args = Array.prototype.slice.call(arguments);
	            var callback = args.pop();
	            async.reduce(fns, args, function (newargs, fn, cb) {
	                fn.apply(that, newargs.concat([function () {
	                    var err = arguments[0];
	                    var nextargs = Array.prototype.slice.call(arguments, 1);
	                    cb(err, nextargs);
	                }]))
	            },
	            function (err, results) {
	                callback.apply(that, [err].concat(results));
	            });
	        };
	    };
	
	    async.compose = function (/* functions... */) {
	      return async.seq.apply(null, Array.prototype.reverse.call(arguments));
	    };
	
	    var _applyEach = function (eachfn, fns /*args...*/) {
	        var go = function () {
	            var that = this;
	            var args = Array.prototype.slice.call(arguments);
	            var callback = args.pop();
	            return eachfn(fns, function (fn, cb) {
	                fn.apply(that, args.concat([cb]));
	            },
	            callback);
	        };
	        if (arguments.length > 2) {
	            var args = Array.prototype.slice.call(arguments, 2);
	            return go.apply(this, args);
	        }
	        else {
	            return go;
	        }
	    };
	    async.applyEach = doParallel(_applyEach);
	    async.applyEachSeries = doSeries(_applyEach);
	
	    async.forever = function (fn, callback) {
	        function next(err) {
	            if (err) {
	                if (callback) {
	                    return callback(err);
	                }
	                throw err;
	            }
	            fn(next);
	        }
	        next();
	    };
	
	    // Node.js
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = async;
	    }
	    // AMD / RequireJS
	    else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return async;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    // included directly via <script> tag
	    else {
	        root.async = async;
	    }
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./~/process/browser.js */ 44), __webpack_require__(/*! ./~/timers-browserify/main.js */ 54).setImmediate))

/***/ },
/* 313 */
/*!*****************************************!*\
  !*** ./~/resource-loader/src/Loader.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var async       = __webpack_require__(/*! async */ 312),
	    urlParser   = __webpack_require__(/*! url */ 156),
	    Resource    = __webpack_require__(/*! ./Resource */ 84),
	    EventEmitter = __webpack_require__(/*! eventemitter3 */ 18);
	
	/**
	 * Manages the state and loading of multiple resources to load.
	 *
	 * @class
	 * @param [baseUrl=''] {string} The base url for all resources loaded by this loader.
	 * @param [concurrency=10] {number} The number of resources to load concurrently.
	 */
	function Loader(baseUrl, concurrency) {
	    EventEmitter.call(this);
	
	    concurrency = concurrency || 10;
	
	    /**
	     * The base url for all resources loaded by this loader.
	     *
	     * @member {string}
	     */
	    this.baseUrl = baseUrl || '';
	
	    /**
	     * The progress percent of the loader going through the queue.
	     *
	     * @member {number}
	     */
	    this.progress = 0;
	
	    /**
	     * Loading state of the loader, true if it is currently loading resources.
	     *
	     * @member {boolean}
	     */
	    this.loading = false;
	
	    /**
	     * The percentage of total progress that a single resource represents.
	     *
	     * @member {number}
	     */
	    this._progressChunk = 0;
	
	    /**
	     * The middleware to run before loading each resource.
	     *
	     * @member {function[]}
	     */
	    this._beforeMiddleware = [];
	
	    /**
	     * The middleware to run after loading each resource.
	     *
	     * @member {function[]}
	     */
	    this._afterMiddleware = [];
	
	    /**
	     * The `_loadResource` function bound with this object context.
	     *
	     * @private
	     * @member {function}
	     */
	    this._boundLoadResource = this._loadResource.bind(this);
	
	    /**
	     * The `_onLoad` function bound with this object context.
	     *
	     * @private
	     * @member {function}
	     */
	    this._boundOnLoad = this._onLoad.bind(this);
	
	    /**
	     * The resource buffer that fills until `load` is called to start loading resources.
	     *
	     * @private
	     * @member {Resource[]}
	     */
	    this._buffer = [];
	
	    /**
	     * Used to track load completion.
	     *
	     * @private
	     * @member {number}
	     */
	    this._numToLoad = 0;
	
	    /**
	     * The resources waiting to be loaded.
	     *
	     * @private
	     * @member {Resource[]}
	     */
	    this._queue = async.queue(this._boundLoadResource, concurrency);
	
	    /**
	     * All the resources for this loader keyed by name.
	     *
	     * @member {object<string, Resource>}
	     */
	    this.resources = {};
	
	    /**
	     * Emitted once per loaded or errored resource.
	     *
	     * @event progress
	     * @memberof Loader#
	     */
	
	    /**
	     * Emitted once per errored resource.
	     *
	     * @event error
	     * @memberof Loader#
	     */
	
	    /**
	     * Emitted once per loaded resource.
	     *
	     * @event load
	     * @memberof Loader#
	     */
	
	    /**
	     * Emitted when the loader begins to process the queue.
	     *
	     * @event start
	     * @memberof Loader#
	     */
	
	    /**
	     * Emitted when the queued resources all load.
	     *
	     * @event complete
	     * @memberof Loader#
	     */
	}
	
	Loader.prototype = Object.create(EventEmitter.prototype);
	Loader.prototype.constructor = Loader;
	module.exports = Loader;
	
	/**
	 * Adds a resource (or multiple resources) to the loader queue.
	 *
	 * This function can take a wide variety of different parameters. The only thing that is always
	 * required the url to load. All the following will work:
	 *
	 * ```js
	 * loader
	 *     // normal param syntax
	 *     .add('key', 'http://...', function () {})
	 *     .add('http://...', function () {})
	 *     .add('http://...')
	 *
	 *     // object syntax
	 *     .add({
	 *         name: 'key2',
	 *         url: 'http://...'
	 *     }, function () {})
	 *     .add({
	 *         url: 'http://...'
	 *     }, function () {})
	 *     .add({
	 *         name: 'key3',
	 *         url: 'http://...'
	 *         onComplete: function () {}
	 *     })
	 *     .add({
	 *         url: 'https://...',
	 *         onComplete: function () {},
	 *         crossOrigin: true
	 *     })
	 *
	 *     // you can also pass an array of objects or urls or both
	 *     .add([
	 *         { name: 'key4', url: 'http://...', onComplete: function () {} },
	 *         { url: 'http://...', onComplete: function () {} },
	 *         'http://...'
	 *     ]);
	 * ```
	 *
	 * @alias enqueue
	 * @param [name] {string} The name of the resource to load, if not passed the url is used.
	 * @param url {string} The url for this resource, relative to the baseUrl of this loader.
	 * @param [options] {object} The options for the load.
	 * @param [options.crossOrigin] {boolean} Is this request cross-origin? Default is to determine automatically.
	 * @param [options.loadType=Resource.LOAD_TYPE.XHR] {Resource.XHR_LOAD_TYPE} How should this resource be loaded?
	 * @param [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] {Resource.XHR_RESPONSE_TYPE} How should the data being
	 *      loaded be interpreted when using XHR?
	 * @param [callback] {function} Function to call when this specific resource completes loading.
	 * @return {Loader}
	 */
	Loader.prototype.add = Loader.prototype.enqueue = function (name, url, options, cb) {
	    // special case of an array of objects or urls
	    if (Array.isArray(name)) {
	        for (var i = 0; i < name.length; ++i) {
	            this.add(name[i]);
	        }
	
	        return this;
	    }
	
	    // if an object is passed instead of params
	    if (typeof name === 'object') {
	        cb = url || name.callback || name.onComplete;
	        options = name;
	        url = name.url;
	        name = name.name || name.key || name.url;
	    }
	
	    // case where no name is passed shift all args over by one.
	    if (typeof url !== 'string') {
	        cb = options;
	        options = url;
	        url = name;
	    }
	
	    // now that we shifted make sure we have a proper url.
	    if (typeof url !== 'string') {
	        throw new Error('No url passed to add resource to loader.');
	    }
	
	    // options are optional so people might pass a function and no options
	    if (typeof options === 'function') {
	        cb = options;
	        options = null;
	    }
	
	    // check if resource already exists.
	    if (this.resources[name]) {
	        throw new Error('Resource with name "' + name + '" already exists.');
	    }
	
	    // add base url if this isn't an absolute url
	    url = this._handleBaseUrl(url);
	
	    // create the store the resource
	    this.resources[name] = new Resource(name, url, options);
	
	    if (typeof cb === 'function') {
	        this.resources[name].once('afterMiddleware', cb);
	    }
	
	    this._numToLoad++;
	
	    // if already loading add it to the worker queue
	    if (this._queue.started) {
	        this._queue.push(this.resources[name]);
	        this._progressChunk = (100 - this.progress) / (this._queue.length() + this._queue.running());
	    }
	    // otherwise buffer it to be added to the queue later
	    else {
	        this._buffer.push(this.resources[name]);
	        this._progressChunk = 100 / this._buffer.length;
	    }
	
	    return this;
	};
	
	Loader.prototype._handleBaseUrl = function (url) {
	    var parsedUrl = urlParser.parse(url);
	
	    // absolute url, just use it as is.
	    if (parsedUrl.protocol || !parsedUrl.pathname || parsedUrl.pathname.indexOf('//') === 0) {
	        return url;
	    }
	
	    // if baseUrl doesn't end in slash and url doesn't start with slash, then add a slash inbetween
	    if (
	        this.baseUrl.length &&
	        this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 &&
	        url.charAt(0) !== '/'
	    ) {
	        return this.baseUrl + '/' + url;
	    }
	    else {
	        return this.baseUrl + url;
	    }
	};
	
	
	/**
	 * Sets up a middleware function that will run *before* the
	 * resource is loaded.
	 *
	 * @alias pre
	 * @param middleware {function} The middleware function to register.
	 * @return {Loader}
	 */
	Loader.prototype.before = Loader.prototype.pre = function (fn) {
	    this._beforeMiddleware.push(fn);
	
	    return this;
	};
	
	/**
	 * Sets up a middleware function that will run *after* the
	 * resource is loaded.
	 *
	 * @alias use
	 * @param middleware {function} The middleware function to register.
	 * @return {Loader}
	 */
	Loader.prototype.after = Loader.prototype.use = function (fn) {
	    this._afterMiddleware.push(fn);
	
	    return this;
	};
	
	/**
	 * Resets the queue of the loader to prepare for a new load.
	 *
	 * @return {Loader}
	 */
	Loader.prototype.reset = function () {
	    // this.baseUrl = baseUrl || '';
	
	    this.progress = 0;
	
	    this.loading = false;
	
	    this._progressChunk = 0;
	
	    // this._beforeMiddleware.length = 0;
	    // this._afterMiddleware.length = 0;
	
	    this._buffer.length = 0;
	
	    this._numToLoad = 0;
	
	    this._queue.kill();
	    this._queue.started = false;
	
	    this.resources = {};
	};
	
	/**
	 * Starts loading the queued resources.
	 *
	 * @fires start
	 * @param [callback] {function} Optional callback that will be bound to the `complete` event.
	 * @return {Loader}
	 */
	Loader.prototype.load = function (cb) {
	    // register complete callback if they pass one
	    if (typeof cb === 'function') {
	        this.once('complete', cb);
	    }
	
	    // if the queue has already started we are done here
	    if (this._queue.started) {
	        return this;
	    }
	
	    // notify of start
	    this.emit('start', this);
	
	    // start the internal queue
	    for (var i = 0; i < this._buffer.length; ++i) {
	        this._queue.push(this._buffer[i]);
	    }
	
	    // empty the buffer
	    this._buffer.length = 0;
	
	    return this;
	};
	
	/**
	 * Loads a single resource.
	 *
	 * @fires progress
	 * @private
	 */
	Loader.prototype._loadResource = function (resource, dequeue) {
	    var self = this;
	
	    resource._dequeue = dequeue;
	
	    this._runMiddleware(resource, this._beforeMiddleware, function () {
	        // resource.on('progress', self.emit.bind(self, 'progress'));
	
	        resource.load(self._boundOnLoad);
	    });
	};
	
	/**
	 * Called once each resource has loaded.
	 *
	 * @fires complete
	 * @private
	 */
	Loader.prototype._onComplete = function () {
	    this.emit('complete', this, this.resources);
	};
	
	/**
	 * Called each time a resources is loaded.
	 *
	 * @fires progress
	 * @fires error
	 * @fires load
	 * @private
	 */
	Loader.prototype._onLoad = function (resource) {
	    this.progress += this._progressChunk;
	
	    this.emit('progress', this, resource);
	
	    // run middleware, this *must* happen before dequeue so sub-assets get added properly
	    this._runMiddleware(resource, this._afterMiddleware, function () {
	        resource.emit('afterMiddleware', resource);
	
	        this._numToLoad--;
	
	        if (resource.error) {
	            this.emit('error', resource.error, this, resource);
	        }
	        else {
	            this.emit('load', this, resource);
	        }
	
	        // do completion check
	        if (this._numToLoad === 0) {
	            this.progress = 100;
	            this._onComplete();
	        }
	    });
	    
	
	
	    // remove this resource from the async queue
	    resource._dequeue();
	};
	
	/**
	 * Run middleware functions on a resource.
	 *
	 * @private
	 */
	Loader.prototype._runMiddleware = function (resource, fns, cb) {
	    var self = this;
	
	    async.eachSeries(fns, function (fn, next) {
	        fn.call(self, resource, next);
	    }, cb.bind(this, resource));
	};
	
	Loader.LOAD_TYPE = Resource.LOAD_TYPE;
	Loader.XHR_READY_STATE = Resource.XHR_READY_STATE;
	Loader.XHR_RESPONSE_TYPE = Resource.XHR_RESPONSE_TYPE;


/***/ },
/* 314 */
/*!**************************************!*\
  !*** ./~/resource-loader/src/b64.js ***!
  \**************************************/
/***/ function(module, exports) {

	module.exports = {
	
	    // private property
	    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
	
	    encodeBinary: function (input) {
	        var output = "";
	        var bytebuffer;
	        var encodedCharIndexes = new Array(4);
	        var inx = 0;
	        var jnx = 0;
	        var paddingBytes = 0;
	
	        while (inx < input.length) {
	            // Fill byte buffer array
	            bytebuffer = new Array(3);
	            for (jnx = 0; jnx < bytebuffer.length; jnx++) {
	                if (inx < input.length) {
	                    // throw away high-order byte, as documented at:
	                    // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
	                    bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
	                }
	                else {
	                    bytebuffer[jnx] = 0;
	                }
	            }
	
	            // Get each encoded character, 6 bits at a time
	            // index 1: first 6 bits
	            encodedCharIndexes[0] = bytebuffer[0] >> 2;
	            // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)
	            encodedCharIndexes[1] = ((bytebuffer[0] & 0x3) << 4) | (bytebuffer[1] >> 4);
	            // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)
	            encodedCharIndexes[2] = ((bytebuffer[1] & 0x0f) << 2) | (bytebuffer[2] >> 6);
	            // index 3: forth 6 bits (6 least significant bits from input byte 3)
	            encodedCharIndexes[3] = bytebuffer[2] & 0x3f;
	
	            // Determine whether padding happened, and adjust accordingly
	            paddingBytes = inx - (input.length - 1);
	            switch (paddingBytes) {
	                case 2:
	                    // Set last 2 characters to padding char
	                    encodedCharIndexes[3] = 64;
	                    encodedCharIndexes[2] = 64;
	                    break;
	
	                case 1:
	                    // Set last character to padding char
	                    encodedCharIndexes[3] = 64;
	                    break;
	
	                default:
	                    break; // No padding - proceed
	            }
	
	            // Now we will grab each appropriate character out of our keystring
	            // based on our index array and append it to the output string
	            for (jnx = 0; jnx < encodedCharIndexes.length; jnx++) {
	                output += this._keyStr.charAt(encodedCharIndexes[jnx]);
	            }
	        }
	        return output;
	    }
	};


/***/ },
/* 315 */
/*!*************************************************************!*\
  !*** ./~/resource-loader/src/middlewares/caching/memory.js ***!
  \*************************************************************/
/***/ function(module, exports) {

	// a simple in-memory cache for resources
	var cache = {};
	
	module.exports = function () {
	    return function (resource, next) {
	        // if cached, then set data and complete the resource
	        if (cache[resource.url]) {
	            resource.data = cache[resource.url];
	            resource.complete();
	        }
	        // if not cached, wait for complete and store it in the cache.
	        else {
	            resource.once('complete', function () {
	               cache[this.url] = this.data;
	            });
	        }
	        
	        next();
	    };
	};


/***/ },
/* 316 */
/*!***********************************************************!*\
  !*** ./~/resource-loader/src/middlewares/parsing/blob.js ***!
  \***********************************************************/
/***/ function(module, exports, __webpack_require__) {

	var Resource = __webpack_require__(/*! ../../Resource */ 84),
	    b64 = __webpack_require__(/*! ../../b64 */ 314);
	
	var Url = window.URL || window.webkitURL;
	
	// a middleware for transforming XHR loaded Blobs into more useful objects
	
	module.exports = function () {
	    return function (resource, next) {
	        if (!resource.data) {
	            return next();
	        }
	
	        // if this was an XHR load of a blob
	        if (resource.xhr && resource.xhrType === Resource.XHR_RESPONSE_TYPE.BLOB) {
	            // if there is no blob support we probably got a binary string back
	            if (!window.Blob || typeof resource.data === 'string') {
	                var type = resource.xhr.getResponseHeader('content-type');
	
	                // this is an image, convert the binary string into a data url
	                if (type && type.indexOf('image') === 0) {
	                    resource.data = new Image();
	                    resource.data.src = 'data:' + type + ';base64,' + b64.encodeBinary(resource.xhr.responseText);
	
	                    resource.isImage = true;
	
	                    // wait until the image loads and then callback
	                    resource.data.onload = function () {
	                        resource.data.onload = null;
	
	                        next();
	                    };
	                }
	            }
	            // if content type says this is an image, then we should transform the blob into an Image object
	            else if (resource.data.type.indexOf('image') === 0) {
	                var src = Url.createObjectURL(resource.data);
	
	                resource.blob = resource.data;
	                resource.data = new Image();
	                resource.data.src = src;
	
	                resource.isImage = true;
	
	                // cleanup the no longer used blob after the image loads
	                resource.data.onload = function () {
	                    Url.revokeObjectURL(src);
	                    resource.data.onload = null;
	
	                    next();
	                };
	            }
	        }
	        else {
	            next();
	        }
	    };
	};


/***/ },
/* 317 */
/*!*************************************!*\
  !*** ./~/style-loader/addStyles.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 318 */
/*!**************************************!*\
  !*** ./~/url/~/punycode/punycode.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../../webpack/buildin/module.js */ 321)(module), (function() { return this; }())))

/***/ },
/* 319 */
/*!***************************************!*\
  !*** (webpack)/buildin/amd-define.js ***!
  \***************************************/
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 320 */
/*!****************************************!*\
  !*** (webpack)/buildin/amd-options.js ***!
  \****************************************/
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 321 */
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** app.build.js
 **/